var bf = Object.defineProperty;
var wf = (e, n, t) => n in e ? bf(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var xe = (e, n, t) => wf(e, typeof n != "symbol" ? n + "" : n, t);
import { defineComponent as ke, computed as T, openBlock as w, createElementBlock as M, normalizeStyle as Fe, normalizeClass as q, createCommentVNode as R, toDisplayString as re, ref as ee, shallowRef as Et, onMounted as et, watch as Le, onUnmounted as Xt, h as xt, nextTick as Ge, createBlock as ue, unref as v, useSlots as Ht, inject as yn, resolveDynamicComponent as mt, mergeProps as lt, withCtx as ce, renderSlot as H, provide as ea, createTextVNode as He, createElementVNode as E, withModifiers as Ve, createVNode as ie, readonly as li, getCurrentScope as Du, onScopeDispose as El, toValue as Qe, getCurrentInstance as ri, hasInjectionContext as Ou, watchEffect as jt, toRaw as _u, Teleport as Pn, Transition as ht, useId as $a, withDirectives as an, vModelCheckbox as kf, reactive as ka, shallowReadonly as Ia, useTemplateRef as Xe, createSlots as dt, renderList as Ie, normalizeProps as Mt, guardReactiveProps as Nt, mergeDefaults as Eu, toRef as yl, Fragment as Te, onBeforeUpdate as xf, vShow as Bn, withKeys as Vt, useModel as En, useAttrs as Il, mergeModels as Yt, TransitionGroup as _r, vModelText as Iu, onUpdated as Sf, onBeforeUnmount as Fs, onDeactivated as Au, onActivated as Pu, isVNode as fs, triggerRef as Er, isRef as Ru, markRaw as Yi, resolveComponent as Fu, isMemoSame as Tf, defineAsyncComponent as $f } from "vue";
import { RouterLink as Mf, useRouter as Vu, onBeforeRouteLeave as Cf, useRoute as ii } from "vue-router";
import { defineStore as Df } from "pinia";
const Of = ["alt", "src"], _f = {
  key: 1,
  class: "select-none"
}, Ef = /* @__PURE__ */ ke({
  __name: "VAvatar",
  props: {
    name: { default: "" },
    avatar: { default: void 0 },
    size: { default: "md" },
    customSize: { default: void 0 },
    shape: { default: "circle" },
    online: { type: Boolean, default: !1 },
    alt: { default: "User avatar" },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = T(() => n.modern ? `user-avatar--${n.size}` : {
      xs: "w-6 h-6 text-xs",
      sm: "w-8 h-8 text-sm",
      md: "w-10 h-10 text-base",
      lg: "w-12 h-12 text-lg",
      xl: "w-16 h-16 text-xl"
    }[n.size]), a = T(
      () => n.shape === "square" ? "rounded-md" : "rounded-full"
    ), s = T(() => n.customSize ? {
      width: `${n.customSize}px`,
      height: `${n.customSize}px`,
      fontSize: `${n.customSize * 0.4}px`
    } : {}), l = T(() => {
      if (!n.name) return "?";
      const c = n.name.trim().split(/\s+/);
      return c.length >= 2 ? `${c[0][0]}${c[1][0]}`.toUpperCase() : n.name.substring(0, 2).toUpperCase();
    }), r = T(() => {
      if (!n.name) return "bg-base-200 text-secondaryText";
      let c = 0;
      for (let p = 0; p < n.name.length; p++)
        c = n.name.charCodeAt(p) + ((c << 5) - c);
      const f = [
        "bg-blue-500 text-white",
        "bg-purple-500 text-white",
        "bg-pink-500 text-white",
        "bg-green-500 text-white",
        "bg-orange-500 text-white",
        "bg-primary text-white",
        "bg-indigo-500 text-white",
        "bg-cyan-500 text-white"
      ];
      return f[Math.abs(c) % f.length];
    }), i = T(() => {
      if (!n.name) return null;
      let c = 0;
      for (let f = 0; f < n.name.length; f++)
        c = n.name.charCodeAt(f) + ((c << 5) - c);
      return Math.abs(c) % 8;
    }), o = T(
      () => i.value === null ? "bg-base-200 text-secondaryText" : `user-avatar--tone-${i.value}`
    ), u = T(() => !!n.avatar);
    return (c, f) => (w(), M("div", {
      class: q([[t.value, a.value, !u.value && (n.modern ? o.value : r.value), { "user-avatar--modern": n.modern }], "user-avatar relative inline-flex items-center justify-center overflow-hidden flex-shrink-0 font-medium transition-all duration-200"]),
      style: Fe(s.value)
    }, [
      u.value ? (w(), M("img", {
        key: 0,
        alt: e.alt,
        src: e.avatar,
        class: "w-full h-full object-cover",
        onError: f[0] || (f[0] = (p) => p.target.style.display = "none")
      }, null, 40, Of)) : R("", !0),
      u.value ? R("", !0) : (w(), M("span", _f, re(l.value), 1)),
      e.online ? (w(), M("span", {
        key: 2,
        class: q([n.modern ? "user-avatar__status" : {
          "w-1.5 h-1.5": e.size === "xs",
          "w-2 h-2": e.size === "sm",
          "w-2.5 h-2.5": e.size === "md",
          "w-3 h-3": e.size === "lg",
          "w-4 h-4": e.size === "xl"
        }, "absolute bottom-0 right-0 block rounded-full bg-success ring-2 ring-base-100 transition-all"]),
        "aria-label": "Online"
      }, null, 2)) : R("", !0)
    ], 6));
  }
}), ze = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, s] of n)
    t[a] = s;
  return t;
}, Hi = /* @__PURE__ */ ze(Ef, [["__scopeId", "data-v-cfe90801"]]), Lu = Symbol("buttonGroup"), Nu = /^[a-z0-9]+(-[a-z0-9]+)*$/, Al = (e, n, t, a = "") => {
  const s = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (s.length < 2 || s.length > 3)
      return null;
    a = s.shift().slice(1);
  }
  if (s.length > 3 || !s.length)
    return null;
  if (s.length > 1) {
    const i = s.pop(), o = s.pop(), u = {
      // Allow provider without '@': "provider:prefix:name"
      provider: s.length > 0 ? s[0] : a,
      prefix: o,
      name: i
    };
    return n && !fl(u) ? null : u;
  }
  const l = s[0], r = l.split("-");
  if (r.length > 1) {
    const i = {
      provider: a,
      prefix: r.shift(),
      name: r.join("-")
    };
    return n && !fl(i) ? null : i;
  }
  if (t && a === "") {
    const i = {
      provider: a,
      prefix: "",
      name: l
    };
    return n && !fl(i, t) ? null : i;
  }
  return null;
}, fl = (e, n) => e ? !!// Check prefix: cannot be empty, unless allowSimpleName is enabled
// Check name: cannot be empty
((n && e.prefix === "" || e.prefix) && e.name) : !1, zu = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), bl = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), Pl = Object.freeze({
  ...zu,
  ...bl
}), Ir = Object.freeze({
  ...Pl,
  body: "",
  hidden: !1
});
function If(e, n) {
  const t = {};
  !e.hFlip != !n.hFlip && (t.hFlip = !0), !e.vFlip != !n.vFlip && (t.vFlip = !0);
  const a = ((e.rotate || 0) + (n.rotate || 0)) % 4;
  return a && (t.rotate = a), t;
}
function Ui(e, n) {
  const t = If(e, n);
  for (const a in Ir)
    a in bl ? a in e && !(a in t) && (t[a] = bl[a]) : a in n ? t[a] = n[a] : a in e && (t[a] = e[a]);
  return t;
}
function Af(e, n) {
  const t = e.icons, a = e.aliases || /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
  function l(r) {
    if (t[r])
      return s[r] = [];
    if (!(r in s)) {
      s[r] = null;
      const i = a[r] && a[r].parent, o = i && l(i);
      o && (s[r] = [i].concat(o));
    }
    return s[r];
  }
  return Object.keys(t).concat(Object.keys(a)).forEach(l), s;
}
function Pf(e, n, t) {
  const a = e.icons, s = e.aliases || /* @__PURE__ */ Object.create(null);
  let l = {};
  function r(i) {
    l = Ui(
      a[i] || s[i],
      l
    );
  }
  return r(n), t.forEach(r), Ui(e, l);
}
function Bu(e, n) {
  const t = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return t;
  e.not_found instanceof Array && e.not_found.forEach((s) => {
    n(s, null), t.push(s);
  });
  const a = Af(e);
  for (const s in a) {
    const l = a[s];
    l && (n(s, Pf(e, s, l)), t.push(s));
  }
  return t;
}
const Rf = {
  provider: "",
  aliases: {},
  not_found: {},
  ...zu
};
function sr(e, n) {
  for (const t in n)
    if (t in e && typeof e[t] != typeof n[t])
      return !1;
  return !0;
}
function Wu(e) {
  if (typeof e != "object" || e === null)
    return null;
  const n = e;
  if (typeof n.prefix != "string" || !e.icons || typeof e.icons != "object" || !sr(e, Rf))
    return null;
  const t = n.icons;
  for (const s in t) {
    const l = t[s];
    if (
      // Name cannot be empty
      !s || // Must have body
      typeof l.body != "string" || // Check other props
      !sr(
        l,
        Ir
      )
    )
      return null;
  }
  const a = n.aliases || /* @__PURE__ */ Object.create(null);
  for (const s in a) {
    const l = a[s], r = l.parent;
    if (
      // Name cannot be empty
      !s || // Parent must be set and point to existing icon
      typeof r != "string" || !t[r] && !a[r] || // Check other props
      !sr(
        l,
        Ir
      )
    )
      return null;
  }
  return n;
}
const qi = /* @__PURE__ */ Object.create(null);
function Ff(e, n) {
  return {
    provider: e,
    prefix: n,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function Za(e, n) {
  const t = qi[e] || (qi[e] = /* @__PURE__ */ Object.create(null));
  return t[n] || (t[n] = Ff(e, n));
}
function Yu(e, n) {
  return Wu(n) ? Bu(n, (t, a) => {
    a ? e.icons[t] = a : e.missing.add(t);
  }) : [];
}
function Vf(e, n, t) {
  try {
    if (typeof t.body == "string")
      return e.icons[n] = { ...t }, !0;
  } catch {
  }
  return !1;
}
let Es = !1;
function Hu(e) {
  return typeof e == "boolean" && (Es = e), Es;
}
function Lf(e) {
  const n = typeof e == "string" ? Al(e, !0, Es) : e;
  if (n) {
    const t = Za(n.provider, n.prefix), a = n.name;
    return t.icons[a] || (t.missing.has(a) ? null : void 0);
  }
}
function Nf(e, n) {
  const t = Al(e, !0, Es);
  if (!t)
    return !1;
  const a = Za(t.provider, t.prefix);
  return n ? Vf(a, t.name, n) : (a.missing.add(t.name), !0);
}
function zf(e, n) {
  if (typeof e != "object")
    return !1;
  if (typeof n != "string" && (n = e.provider || ""), Es && !n && !e.prefix) {
    let s = !1;
    return Wu(e) && (e.prefix = "", Bu(e, (l, r) => {
      Nf(l, r) && (s = !0);
    })), s;
  }
  const t = e.prefix;
  if (!fl({
    prefix: t,
    name: "a"
  }))
    return !1;
  const a = Za(n, t);
  return !!Yu(a, e);
}
const Uu = Object.freeze({
  width: null,
  height: null
}), qu = Object.freeze({
  // Dimensions
  ...Uu,
  // Transformations
  ...bl
}), Bf = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Wf = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function ji(e, n, t) {
  if (n === 1)
    return e;
  if (t = t || 100, typeof e == "number")
    return Math.ceil(e * n * t) / t;
  if (typeof e != "string")
    return e;
  const a = e.split(Bf);
  if (a === null || !a.length)
    return e;
  const s = [];
  let l = a.shift(), r = Wf.test(l);
  for (; ; ) {
    if (r) {
      const i = parseFloat(l);
      isNaN(i) ? s.push(l) : s.push(Math.ceil(i * n * t) / t);
    } else
      s.push(l);
    if (l = a.shift(), l === void 0)
      return s.join("");
    r = !r;
  }
}
function Yf(e, n = "defs") {
  let t = "";
  const a = e.indexOf("<" + n);
  for (; a >= 0; ) {
    const s = e.indexOf(">", a), l = e.indexOf("</" + n);
    if (s === -1 || l === -1)
      break;
    const r = e.indexOf(">", l);
    if (r === -1)
      break;
    t += e.slice(s + 1, l).trim(), e = e.slice(0, a).trim() + e.slice(r + 1);
  }
  return {
    defs: t,
    content: e
  };
}
function Hf(e, n) {
  return e ? "<defs>" + e + "</defs>" + n : n;
}
function Uf(e, n, t) {
  const a = Yf(e);
  return Hf(a.defs, n + a.content + t);
}
const qf = (e) => e === "unset" || e === "undefined" || e === "none";
function jf(e, n) {
  const t = {
    ...Pl,
    ...e
  }, a = {
    ...qu,
    ...n
  }, s = {
    left: t.left,
    top: t.top,
    width: t.width,
    height: t.height
  };
  let l = t.body;
  [t, a].forEach((m) => {
    const k = [], y = m.hFlip, h = m.vFlip;
    let g = m.rotate;
    y ? h ? g += 2 : (k.push(
      "translate(" + (s.width + s.left).toString() + " " + (0 - s.top).toString() + ")"
    ), k.push("scale(-1 1)"), s.top = s.left = 0) : h && (k.push(
      "translate(" + (0 - s.left).toString() + " " + (s.height + s.top).toString() + ")"
    ), k.push("scale(1 -1)"), s.top = s.left = 0);
    let x;
    switch (g < 0 && (g -= Math.floor(g / 4) * 4), g = g % 4, g) {
      case 1:
        x = s.height / 2 + s.top, k.unshift(
          "rotate(90 " + x.toString() + " " + x.toString() + ")"
        );
        break;
      case 2:
        k.unshift(
          "rotate(180 " + (s.width / 2 + s.left).toString() + " " + (s.height / 2 + s.top).toString() + ")"
        );
        break;
      case 3:
        x = s.width / 2 + s.left, k.unshift(
          "rotate(-90 " + x.toString() + " " + x.toString() + ")"
        );
        break;
    }
    g % 2 === 1 && (s.left !== s.top && (x = s.left, s.left = s.top, s.top = x), s.width !== s.height && (x = s.width, s.width = s.height, s.height = x)), k.length && (l = Uf(
      l,
      '<g transform="' + k.join(" ") + '">',
      "</g>"
    ));
  });
  const r = a.width, i = a.height, o = s.width, u = s.height;
  let c, f;
  r === null ? (f = i === null ? "1em" : i === "auto" ? u : i, c = ji(f, o / u)) : (c = r === "auto" ? o : r, f = i === null ? ji(c, u / o) : i === "auto" ? u : i);
  const p = {}, d = (m, k) => {
    qf(k) || (p[m] = k.toString());
  };
  d("width", c), d("height", f);
  const b = [s.left, s.top, o, u];
  return p.viewBox = b.join(" "), {
    attributes: p,
    viewBox: b,
    body: l
  };
}
const Gf = /\sid="(\S+)"/g, Kf = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let Zf = 0;
function Xf(e, n = Kf) {
  const t = [];
  let a;
  for (; a = Gf.exec(e); )
    t.push(a[1]);
  if (!t.length)
    return e;
  const s = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return t.forEach((l) => {
    const r = typeof n == "function" ? n(l) : n + (Zf++).toString(), i = l.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + i + ')([")]|\\.[a-z])', "g"),
      "$1" + r + s + "$3"
    );
  }), e = e.replace(new RegExp(s, "g"), ""), e;
}
const Ar = /* @__PURE__ */ Object.create(null);
function Jf(e, n) {
  Ar[e] = n;
}
function Pr(e) {
  return Ar[e] || Ar[""];
}
function oi(e) {
  let n;
  if (typeof e.resources == "string")
    n = [e.resources];
  else if (n = e.resources, !(n instanceof Array) || !n.length)
    return null;
  return {
    // API hosts
    resources: n,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const ui = /* @__PURE__ */ Object.create(null), hs = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], hl = [];
for (; hs.length > 0; )
  hs.length === 1 || Math.random() > 0.5 ? hl.push(hs.shift()) : hl.push(hs.pop());
ui[""] = oi({
  resources: ["https://api.iconify.design"].concat(hl)
});
function Qf(e, n) {
  const t = oi(n);
  return t === null ? !1 : (ui[e] = t, !0);
}
function ci(e) {
  return ui[e];
}
const eh = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Gi = eh();
function th(e, n) {
  const t = ci(e);
  if (!t)
    return 0;
  let a;
  if (!t.maxURL)
    a = 0;
  else {
    let s = 0;
    t.resources.forEach((r) => {
      s = Math.max(s, r.length);
    });
    const l = n + ".json?icons=";
    a = t.maxURL - s - t.path.length - l.length;
  }
  return a;
}
function nh(e) {
  return e === 404;
}
const ah = (e, n, t) => {
  const a = [], s = th(e, n), l = "icons";
  let r = {
    type: l,
    provider: e,
    prefix: n,
    icons: []
  }, i = 0;
  return t.forEach((o, u) => {
    i += o.length + 1, i >= s && u > 0 && (a.push(r), r = {
      type: l,
      provider: e,
      prefix: n,
      icons: []
    }, i = o.length), r.icons.push(o);
  }), a.push(r), a;
};
function sh(e) {
  if (typeof e == "string") {
    const n = ci(e);
    if (n)
      return n.path;
  }
  return "/";
}
const lh = (e, n, t) => {
  if (!Gi) {
    t("abort", 424);
    return;
  }
  let a = sh(n.provider);
  switch (n.type) {
    case "icons": {
      const l = n.prefix, i = n.icons.join(","), o = new URLSearchParams({
        icons: i
      });
      a += l + ".json?" + o.toString();
      break;
    }
    case "custom": {
      const l = n.uri;
      a += l.slice(0, 1) === "/" ? l.slice(1) : l;
      break;
    }
    default:
      t("abort", 400);
      return;
  }
  let s = 503;
  Gi(e + a).then((l) => {
    const r = l.status;
    if (r !== 200) {
      setTimeout(() => {
        t(nh(r) ? "abort" : "next", r);
      });
      return;
    }
    return s = 501, l.json();
  }).then((l) => {
    if (typeof l != "object" || l === null) {
      setTimeout(() => {
        l === 404 ? t("abort", l) : t("next", s);
      });
      return;
    }
    setTimeout(() => {
      t("success", l);
    });
  }).catch(() => {
    t("next", s);
  });
}, rh = {
  prepare: ah,
  send: lh
};
function ih(e) {
  const n = {
    loaded: [],
    missing: [],
    pending: []
  }, t = /* @__PURE__ */ Object.create(null);
  e.sort((s, l) => s.provider !== l.provider ? s.provider.localeCompare(l.provider) : s.prefix !== l.prefix ? s.prefix.localeCompare(l.prefix) : s.name.localeCompare(l.name));
  let a = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((s) => {
    if (a.name === s.name && a.prefix === s.prefix && a.provider === s.provider)
      return;
    a = s;
    const l = s.provider, r = s.prefix, i = s.name, o = t[l] || (t[l] = /* @__PURE__ */ Object.create(null)), u = o[r] || (o[r] = Za(l, r));
    let c;
    i in u.icons ? c = n.loaded : r === "" || u.missing.has(i) ? c = n.missing : c = n.pending;
    const f = {
      provider: l,
      prefix: r,
      name: i
    };
    c.push(f);
  }), n;
}
function ju(e, n) {
  e.forEach((t) => {
    const a = t.loaderCallbacks;
    a && (t.loaderCallbacks = a.filter((s) => s.id !== n));
  });
}
function oh(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const n = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!n.length)
      return;
    let t = !1;
    const a = e.provider, s = e.prefix;
    n.forEach((l) => {
      const r = l.icons, i = r.pending.length;
      r.pending = r.pending.filter((o) => {
        if (o.prefix !== s)
          return !0;
        const u = o.name;
        if (e.icons[u])
          r.loaded.push({
            provider: a,
            prefix: s,
            name: u
          });
        else if (e.missing.has(u))
          r.missing.push({
            provider: a,
            prefix: s,
            name: u
          });
        else
          return t = !0, !0;
        return !1;
      }), r.pending.length !== i && (t || ju([e], l.id), l.callback(
        r.loaded.slice(0),
        r.missing.slice(0),
        r.pending.slice(0),
        l.abort
      ));
    });
  }));
}
let uh = 0;
function ch(e, n, t) {
  const a = uh++, s = ju.bind(null, t, a);
  if (!n.pending.length)
    return s;
  const l = {
    id: a,
    icons: n,
    callback: e,
    abort: s
  };
  return t.forEach((r) => {
    (r.loaderCallbacks || (r.loaderCallbacks = [])).push(l);
  }), s;
}
function dh(e, n = !0, t = !1) {
  const a = [];
  return e.forEach((s) => {
    const l = typeof s == "string" ? Al(s, n, t) : s;
    l && a.push(l);
  }), a;
}
var fh = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function hh(e, n, t, a) {
  const s = e.resources.length, l = e.random ? Math.floor(Math.random() * s) : e.index;
  let r;
  if (e.random) {
    let C = e.resources.slice(0);
    for (r = []; C.length > 1; ) {
      const _ = Math.floor(Math.random() * C.length);
      r.push(C[_]), C = C.slice(0, _).concat(C.slice(_ + 1));
    }
    r = r.concat(C);
  } else
    r = e.resources.slice(l).concat(e.resources.slice(0, l));
  const i = Date.now();
  let o = "pending", u = 0, c, f = null, p = [], d = [];
  typeof a == "function" && d.push(a);
  function b() {
    f && (clearTimeout(f), f = null);
  }
  function m() {
    o === "pending" && (o = "aborted"), b(), p.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), p = [];
  }
  function k(C, _) {
    _ && (d = []), typeof C == "function" && d.push(C);
  }
  function y() {
    return {
      startTime: i,
      payload: n,
      status: o,
      queriesSent: u,
      queriesPending: p.length,
      subscribe: k,
      abort: m
    };
  }
  function h() {
    o = "failed", d.forEach((C) => {
      C(void 0, c);
    });
  }
  function g() {
    p.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), p = [];
  }
  function x(C, _, O) {
    const I = _ !== "success";
    switch (p = p.filter((D) => D !== C), o) {
      case "pending":
        break;
      case "failed":
        if (I || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (_ === "abort") {
      c = O, h();
      return;
    }
    if (I) {
      c = O, p.length || (r.length ? S() : h());
      return;
    }
    if (b(), g(), !e.random) {
      const D = e.resources.indexOf(C.resource);
      D !== -1 && D !== e.index && (e.index = D);
    }
    o = "completed", d.forEach((D) => {
      D(O);
    });
  }
  function S() {
    if (o !== "pending")
      return;
    b();
    const C = r.shift();
    if (C === void 0) {
      if (p.length) {
        f = setTimeout(() => {
          b(), o === "pending" && (g(), h());
        }, e.timeout);
        return;
      }
      h();
      return;
    }
    const _ = {
      status: "pending",
      resource: C,
      callback: (O, I) => {
        x(_, O, I);
      }
    };
    p.push(_), u++, f = setTimeout(S, e.rotate), t(C, n, _.callback);
  }
  return setTimeout(S), y;
}
function Gu(e) {
  const n = {
    ...fh,
    ...e
  };
  let t = [];
  function a() {
    t = t.filter((i) => i().status === "pending");
  }
  function s(i, o, u) {
    const c = hh(
      n,
      i,
      o,
      (f, p) => {
        a(), u && u(f, p);
      }
    );
    return t.push(c), c;
  }
  function l(i) {
    return t.find((o) => i(o)) || null;
  }
  return {
    query: s,
    find: l,
    setIndex: (i) => {
      n.index = i;
    },
    getIndex: () => n.index,
    cleanup: a
  };
}
function Ki() {
}
const lr = /* @__PURE__ */ Object.create(null);
function mh(e) {
  if (!lr[e]) {
    const n = ci(e);
    if (!n)
      return;
    const t = Gu(n), a = {
      config: n,
      redundancy: t
    };
    lr[e] = a;
  }
  return lr[e];
}
function vh(e, n, t) {
  let a, s;
  if (typeof e == "string") {
    const l = Pr(e);
    if (!l)
      return t(void 0, 424), Ki;
    s = l.send;
    const r = mh(e);
    r && (a = r.redundancy);
  } else {
    const l = oi(e);
    if (l) {
      a = Gu(l);
      const r = e.resources ? e.resources[0] : "", i = Pr(r);
      i && (s = i.send);
    }
  }
  return !a || !s ? (t(void 0, 424), Ki) : a.query(n, s, t)().abort;
}
function Zi() {
}
function ph(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, oh(e);
  }));
}
function gh(e) {
  const n = [], t = [];
  return e.forEach((a) => {
    (a.match(Nu) ? n : t).push(a);
  }), {
    valid: n,
    invalid: t
  };
}
function ms(e, n, t) {
  function a() {
    const s = e.pendingIcons;
    n.forEach((l) => {
      s && s.delete(l), e.icons[l] || e.missing.add(l);
    });
  }
  if (t && typeof t == "object")
    try {
      if (!Yu(e, t).length) {
        a();
        return;
      }
    } catch (s) {
      console.error(s);
    }
  a(), ph(e);
}
function Xi(e, n) {
  e instanceof Promise ? e.then((t) => {
    n(t);
  }).catch(() => {
    n(null);
  }) : n(e);
}
function yh(e, n) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(n).sort() : e.iconsToLoad = n, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: t, prefix: a } = e, s = e.iconsToLoad;
    if (delete e.iconsToLoad, !s || !s.length)
      return;
    const l = e.loadIcon;
    if (e.loadIcons && (s.length > 1 || !l)) {
      Xi(
        e.loadIcons(s, a, t),
        (c) => {
          ms(e, s, c);
        }
      );
      return;
    }
    if (l) {
      s.forEach((c) => {
        const f = l(c, a, t);
        Xi(f, (p) => {
          const d = p ? {
            prefix: a,
            icons: {
              [c]: p
            }
          } : null;
          ms(e, [c], d);
        });
      });
      return;
    }
    const { valid: r, invalid: i } = gh(s);
    if (i.length && ms(e, i, null), !r.length)
      return;
    const o = a.match(Nu) ? Pr(t) : null;
    if (!o) {
      ms(e, r, null);
      return;
    }
    o.prepare(t, a, r).forEach((c) => {
      vh(t, c, (f) => {
        ms(e, c.icons, f);
      });
    });
  }));
}
const bh = (e, n) => {
  const t = dh(e, !0, Hu()), a = ih(t);
  if (!a.pending.length) {
    let o = !0;
    return n && setTimeout(() => {
      o && n(
        a.loaded,
        a.missing,
        a.pending,
        Zi
      );
    }), () => {
      o = !1;
    };
  }
  const s = /* @__PURE__ */ Object.create(null), l = [];
  let r, i;
  return a.pending.forEach((o) => {
    const { provider: u, prefix: c } = o;
    if (c === i && u === r)
      return;
    r = u, i = c, l.push(Za(u, c));
    const f = s[u] || (s[u] = /* @__PURE__ */ Object.create(null));
    f[c] || (f[c] = []);
  }), a.pending.forEach((o) => {
    const { provider: u, prefix: c, name: f } = o, p = Za(u, c), d = p.pendingIcons || (p.pendingIcons = /* @__PURE__ */ new Set());
    d.has(f) || (d.add(f), s[u][c].push(f));
  }), l.forEach((o) => {
    const u = s[o.provider][o.prefix];
    u.length && yh(o, u);
  }), n ? ch(n, a, l) : Zi;
};
function wh(e, n) {
  const t = {
    ...e
  };
  for (const a in n) {
    const s = n[a], l = typeof s;
    a in Uu ? (s === null || s && (l === "string" || l === "number")) && (t[a] = s) : l === typeof t[a] && (t[a] = a === "rotate" ? s % 4 : s);
  }
  return t;
}
const kh = /[\s,]+/;
function xh(e, n) {
  n.split(kh).forEach((t) => {
    switch (t.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function Sh(e, n = 0) {
  const t = e.replace(/^-?[0-9.]*/, "");
  function a(s) {
    for (; s < 0; )
      s += 4;
    return s % 4;
  }
  if (t === "") {
    const s = parseInt(e);
    return isNaN(s) ? 0 : a(s);
  } else if (t !== e) {
    let s = 0;
    switch (t) {
      case "%":
        s = 25;
        break;
      case "deg":
        s = 90;
    }
    if (s) {
      let l = parseFloat(e.slice(0, e.length - t.length));
      return isNaN(l) ? 0 : (l = l / s, l % 1 === 0 ? a(l) : 0);
    }
  }
  return n;
}
function Th(e, n) {
  let t = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const a in n)
    t += " " + a + '="' + n[a] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + t + ">" + e + "</svg>";
}
function $h(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Mh(e) {
  return "data:image/svg+xml," + $h(e);
}
function Ch(e) {
  return 'url("' + Mh(e) + '")';
}
const Ji = {
  ...qu,
  inline: !1
}, Dh = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, Oh = {
  display: "inline-block"
}, Rr = {
  backgroundColor: "currentColor"
}, Ku = {
  backgroundColor: "transparent"
}, Qi = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, eo = {
  webkitMask: Rr,
  mask: Rr,
  background: Ku
};
for (const e in eo) {
  const n = eo[e];
  for (const t in Qi)
    n[e + t] = Qi[t];
}
const ml = {};
["horizontal", "vertical"].forEach((e) => {
  const n = e.slice(0, 1) + "Flip";
  ml[e + "-flip"] = n, ml[e.slice(0, 1) + "-flip"] = n, ml[e + "Flip"] = n;
});
function to(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const no = (e, n) => {
  const t = wh(Ji, n), a = { ...Dh }, s = n.mode || "svg", l = {}, r = n.style, i = typeof r == "object" && !(r instanceof Array) ? r : {};
  for (let m in n) {
    const k = n[m];
    if (k !== void 0)
      switch (m) {
        // Properties to ignore
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
        case "ssr":
          break;
        // Boolean attributes
        case "inline":
        case "hFlip":
        case "vFlip":
          t[m] = k === !0 || k === "true" || k === 1;
          break;
        // Flip as string: 'horizontal,vertical'
        case "flip":
          typeof k == "string" && xh(t, k);
          break;
        // Color: override style
        case "color":
          l.color = k;
          break;
        // Rotation as string
        case "rotate":
          typeof k == "string" ? t[m] = Sh(k) : typeof k == "number" && (t[m] = k);
          break;
        // Remove aria-hidden
        case "ariaHidden":
        case "aria-hidden":
          k !== !0 && k !== "true" && delete a["aria-hidden"];
          break;
        default: {
          const y = ml[m];
          y ? (k === !0 || k === "true" || k === 1) && (t[y] = !0) : Ji[m] === void 0 && (a[m] = k);
        }
      }
  }
  const o = jf(e, t), u = o.attributes;
  if (t.inline && (l.verticalAlign = "-0.125em"), s === "svg") {
    a.style = {
      ...l,
      ...i
    }, Object.assign(a, u);
    let m = 0, k = n.id;
    return typeof k == "string" && (k = k.replace(/-/g, "_")), a.innerHTML = Xf(o.body, k ? () => k + "ID" + m++ : "iconifyVue"), xt("svg", a);
  }
  const { body: c, width: f, height: p } = e, d = s === "mask" || (s === "bg" ? !1 : c.indexOf("currentColor") !== -1), b = Th(c, {
    ...u,
    width: f + "",
    height: p + ""
  });
  return a.style = {
    ...l,
    "--svg": Ch(b),
    width: to(u.width),
    height: to(u.height),
    ...Oh,
    ...d ? Rr : Ku,
    ...i
  }, xt("span", a);
};
Hu(!0);
Jf("", rh);
if (typeof document < "u" && typeof window < "u") {
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const n = e.IconifyPreload, t = "Invalid IconifyPreload syntax.";
    typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((a) => {
      try {
        // Check if item is an object and not null/array
        (typeof a != "object" || a === null || a instanceof Array || // Check for 'icons' and 'prefix'
        typeof a.icons != "object" || typeof a.prefix != "string" || // Add icon set
        !zf(a)) && console.error(t);
      } catch {
        console.error(t);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const n = e.IconifyProviders;
    if (typeof n == "object" && n !== null)
      for (let t in n) {
        const a = "IconifyProviders[" + t + "] is invalid.";
        try {
          const s = n[t];
          if (typeof s != "object" || !s || s.resources === void 0)
            continue;
          Qf(t, s) || console.error(a);
        } catch {
          console.error(a);
        }
      }
  }
}
const _h = {
  ...Pl,
  body: ""
}, Eh = ke((e, { emit: n }) => {
  const t = ee(null);
  function a() {
    var u, c;
    t.value && ((c = (u = t.value).abort) == null || c.call(u), t.value = null);
  }
  const s = ee(!!e.ssr), l = ee(""), r = Et(null);
  function i() {
    const u = e.icon;
    if (typeof u == "object" && u !== null && typeof u.body == "string")
      return l.value = "", {
        data: u
      };
    let c;
    if (typeof u != "string" || (c = Al(u, !1, !0)) === null)
      return null;
    let f = Lf(c);
    if (!f) {
      const b = t.value;
      return (!b || b.name !== u) && (f === null ? t.value = {
        name: u
      } : t.value = {
        name: u,
        abort: bh([c], o)
      }), null;
    }
    a(), l.value !== u && (l.value = u, Ge(() => {
      n("load", u);
    }));
    const p = e.customise;
    if (p) {
      f = Object.assign({}, f);
      const b = p(f.body, c.name, c.prefix, c.provider);
      typeof b == "string" && (f.body = b);
    }
    const d = ["iconify"];
    return c.prefix !== "" && d.push("iconify--" + c.prefix), c.provider !== "" && d.push("iconify--" + c.provider), { data: f, classes: d };
  }
  function o() {
    var c;
    const u = i();
    u ? u.data !== ((c = r.value) == null ? void 0 : c.data) && (r.value = u) : r.value = null;
  }
  return s.value ? o() : et(() => {
    s.value = !0, o();
  }), Le(() => e.icon, o), Xt(a), () => {
    const u = r.value;
    if (!u)
      return no(_h, e);
    let c = e;
    return u.classes && (c = {
      ...e,
      class: u.classes.join(" ")
    }), no({
      ...Pl,
      ...u.data
    }, c);
  };
}, {
  props: [
    // Icon and render mode
    "icon",
    "mode",
    "ssr",
    // Layout and style
    "width",
    "height",
    "style",
    "color",
    "inline",
    // Transformations
    "rotate",
    "hFlip",
    "horizontalFlip",
    "vFlip",
    "verticalFlip",
    "flip",
    // Misc
    "id",
    "ariaHidden",
    "customise",
    "title"
  ],
  emits: ["load"]
}), Ih = /* @__PURE__ */ ke({
  __name: "VIcon",
  props: {
    icon: {},
    size: { default: 24 },
    color: { default: "currentColor" },
    class: { default: "" },
    loading: { type: Boolean }
  },
  setup(e) {
    const n = T(() => e.color.startsWith("text-")), t = T(() => e.loading ? "lucide:loader-2" : e.icon), a = T(() => typeof e.size == "number" ? `${e.size}px` : e.size), s = T(() => n.value ? e.color : ""), l = T(() => n.value ? void 0 : { color: e.color });
    return (r, i) => (w(), ue(v(Eh), {
      class: q([[{ "v-icon--spin": e.loading }, s.value, e.class], "v-icon"]),
      height: a.value,
      icon: t.value,
      style: Fe(l.value),
      width: a.value,
      "aria-hidden": "true",
      focusable: "false"
    }, null, 8, ["class", "height", "icon", "style", "width"]));
  }
}), be = /* @__PURE__ */ ze(Ih, [["__scopeId", "data-v-68f452e3"]]), Ah = {
  key: 0,
  class: "v-button__icon"
}, Ph = {
  key: 1,
  class: "v-button__content"
}, Rh = { key: 0 }, Fh = {
  key: 2,
  class: "v-button__icon"
}, Vh = /* @__PURE__ */ ke({
  __name: "VButton",
  props: {
    text: { default: "" },
    type: { default: "button" },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    icon: { default: void 0 },
    variant: { default: "default" },
    to: { default: void 0 },
    replace: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 },
    size: { default: void 0 }
  },
  setup(e) {
    const n = Ht(), t = yn(Lu, !1), a = e, s = T(() => !a.text && !!a.icon && !n.default), l = T(() => {
      switch (a.variant) {
        case "primary":
          return "v-button--primary";
        case "positive":
          return "v-button--positive";
        case "negative":
          return "v-button--negative";
        case "warning":
          return "v-button--warning";
        case "link":
          return "v-button--link";
        case "secondary":
          return "v-button--secondary";
        case "neutral":
          return "v-button--neutral";
        case "info":
          return "v-button--info";
        default:
          return "v-button--primary";
      }
    }), r = T(() => a.modern ? 15 : 24), i = T(() => !!a.to), o = T(() => a.modern ? a.disabled : a.disabled || a.loading), u = T(() => a.modern && a.loading && !a.disabled);
    return (c, f) => (w(), ue(mt(i.value ? v(Mf) : "button"), lt(
      {
        class: [
          "v-button",
          l.value,
          a.size ? `v-button--${a.size}` : "",
          {
            "v-button--modern": a.modern,
            "v-button--grouped": v(t),
            "v-button--icon-only": s.value,
            "v-button--disabled cursor-not-allowed": o.value,
            "v-button--loading": u.value
          }
        ]
      },
      i.value ? {
        to: a.disabled || a.loading ? void 0 : a.to,
        replace: a.replace,
        ...c.$attrs
      } : { type: a.type, disabled: a.disabled || a.loading, ...c.$attrs }
    ), {
      default: ce(() => [
        c.$slots.iconLeft || a.loading || a.icon ? (w(), M("span", Ah, [
          a.loading ? (w(), ue(be, {
            key: 0,
            loading: a.loading,
            size: r.value,
            icon: "lucide:loader-2"
          }, null, 8, ["loading", "size"])) : H(c.$slots, "iconLeft", { key: 1 }, () => [
            a.icon ? (w(), ue(be, {
              key: 0,
              icon: a.icon,
              size: r.value
            }, null, 8, ["icon", "size"])) : R("", !0)
          ], !0)
        ])) : R("", !0),
        s.value ? R("", !0) : (w(), M("span", Ph, [
          a.text ? (w(), M("span", Rh, re(a.text), 1)) : R("", !0),
          H(c.$slots, "default", {}, void 0, !0)
        ])),
        c.$slots.iconRight ? (w(), M("span", Fh, [
          H(c.$slots, "iconRight", {}, void 0, !0)
        ])) : R("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), _t = /* @__PURE__ */ ze(Vh, [["__scopeId", "data-v-49c3847c"]]), Lh = {
  class: "v-button-group",
  role: "group"
}, Nh = /* @__PURE__ */ ke({
  __name: "VButtonGroup",
  setup(e) {
    return ea(Lu, !0), (n, t) => (w(), M("div", Lh, [
      H(n.$slots, "default", {}, void 0, !0)
    ]));
  }
}), aD = /* @__PURE__ */ ze(Nh, [["__scopeId", "data-v-b6af72a2"]]), zh = { key: 1 }, Bh = /* @__PURE__ */ ke({
  __name: "VTag",
  props: {
    label: { default: "" },
    variant: { default: "soft" },
    color: { default: "primary" },
    size: { default: "sm" },
    icon: { default: void 0 },
    iconPosition: { default: "left" },
    rounded: { type: Boolean, default: !1 },
    class: { default: "" },
    customColor: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = T(() => ({
      xs: 12,
      sm: 14,
      md: 16,
      lg: 18
    })[n.size]), a = T(() => `vtag--${n.size}`), s = T(
      () => n.customColor ? { "--_tag-color": `var(${n.customColor})` } : void 0
    ), l = T(
      () => n.customColor ? `vtag--custom-${n.variant}` : `vtag--${n.variant}-${n.color}`
    ), r = T(() => n.rounded ? "vtag--rounded" : "vtag--square");
    return (i, o) => (w(), M("span", {
      style: Fe(s.value),
      class: q([[a.value, l.value, r.value, n.class, { "vtag--modern": n.modern }], "vtag"])
    }, [
      e.icon && e.iconPosition === "left" ? (w(), ue(be, {
        key: 0,
        icon: e.icon,
        size: t.value
      }, null, 8, ["icon", "size"])) : R("", !0),
      e.label || i.$slots.default ? (w(), M("span", zh, [
        H(i.$slots, "default", {}, () => [
          He(re(e.label), 1)
        ], !0)
      ])) : R("", !0),
      H(i.$slots, "icon-right", {}, () => [
        e.icon && e.iconPosition === "right" ? (w(), ue(be, {
          key: 0,
          icon: e.icon,
          size: t.value
        }, null, 8, ["icon", "size"])) : R("", !0)
      ], !0)
    ], 6));
  }
}), Zu = /* @__PURE__ */ ze(Bh, [["__scopeId", "data-v-2c5fd8f6"]]), Wh = { class: "vchip__content" }, Yh = {
  key: 1,
  class: "vchip__label"
}, Hh = ["disabled"], Uh = /* @__PURE__ */ ke({
  __name: "VChip",
  props: {
    label: { default: "" },
    variant: { default: "soft" },
    color: { default: "default" },
    selectedColor: { default: "primary" },
    size: { default: "md" },
    icon: { default: void 0 },
    closable: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    badge: { default: void 0 },
    badgeColor: { default: "primary" },
    class: { default: "" },
    value: { type: [String, Number, Boolean, Object, null], default: void 0 },
    modelValue: { default: void 0 },
    multiple: { type: Boolean, default: !1 },
    valueComparator: { type: Function, default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["click", "close", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (p, d) => {
      if (t.valueComparator)
        return t.valueComparator(p, d);
      if (p === d) return !0;
      if (p == null || d == null) return !1;
      if (typeof p == "object" && typeof d == "object")
        try {
          return JSON.stringify(p) === JSON.stringify(d);
        } catch {
          return !1;
        }
      return p === d;
    }, l = T(() => t.modelValue !== void 0 && t.value !== void 0 ? t.multiple ? Array.isArray(t.modelValue) && t.modelValue.some((p) => s(p, t.value)) : s(t.modelValue, t.value) : t.active), r = T(() => (t.modern ? { sm: 13, md: 15, lg: 16 } : { sm: 14, md: 16, lg: 18 })[t.size]), i = T(() => `vchip--${t.size}`), o = T(() => {
      if (t.color === "default" && l.value)
        return `vchip--${t.variant}-${t.selectedColor}-selected`;
      const p = `vchip--${t.variant}-${t.color}`;
      return l.value ? `${p}-selected` : p;
    }), u = T(() => t.disabled ? "vchip--disabled" : "vchip--interactive"), c = (p) => {
      if (!t.disabled) {
        if (t.value !== void 0 && t.modelValue !== void 0)
          if (t.multiple) {
            const d = Array.isArray(t.modelValue) ? t.modelValue : [];
            if (d.findIndex((m) => s(m, t.value)) > -1) {
              const m = d.filter((k) => !s(k, t.value));
              a("update:modelValue", m);
            } else
              a("update:modelValue", [...d, t.value]);
          } else
            s(t.modelValue, t.value) ? a("update:modelValue", null) : a("update:modelValue", t.value);
        a("click", p);
      }
    }, f = (p) => {
      t.disabled || a("close", p);
    };
    return (p, d) => (w(), M("span", {
      class: q([[i.value, o.value, u.value, t.class, { "vchip--modern": t.modern }], "vchip"]),
      onClick: c
    }, [
      E("span", Wh, [
        e.icon ? (w(), ue(be, {
          key: 0,
          icon: e.icon,
          size: r.value,
          class: "vchip__icon"
        }, null, 8, ["icon", "size"])) : R("", !0),
        e.label || p.$slots.default ? (w(), M("span", Yh, [
          H(p.$slots, "default", {}, () => [
            He(re(e.label), 1)
          ], !0)
        ])) : R("", !0),
        H(p.$slots, "badge", {}, () => [
          e.badge ? (w(), ue(Zu, {
            key: 0,
            color: e.badgeColor,
            label: e.badge,
            size: "sm",
            variant: "outline"
          }, null, 8, ["color", "label"])) : R("", !0)
        ], !0)
      ]),
      e.closable ? (w(), M("button", {
        key: 0,
        disabled: e.disabled,
        class: "vchip__close",
        type: "button",
        onClick: Ve(f, ["stop"])
      }, [
        ie(be, {
          size: r.value - 2,
          icon: "lucide:x"
        }, null, 8, ["size"])
      ], 8, Hh)) : R("", !0)
    ], 2));
  }
}), sD = /* @__PURE__ */ ze(Uh, [["__scopeId", "data-v-68700419"]]);
function Xu(e) {
  return Du() ? (El(e), !0) : !1;
}
const rr = /* @__PURE__ */ new WeakMap(), qh = (...e) => {
  var n;
  const t = e[0], a = (n = ri()) == null ? void 0 : n.proxy;
  if (a == null && !Ou())
    throw new Error("injectLocal must be called in setup");
  return a && rr.has(a) && t in rr.get(a) ? rr.get(a)[t] : yn(...e);
}, di = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const jh = Object.prototype.toString, Gh = (e) => jh.call(e) === "[object Object]", ao = () => {
};
function Kh(e, n) {
  function t(...a) {
    return new Promise((s, l) => {
      Promise.resolve(e(() => n.apply(this, a), { fn: n, thisArg: this, args: a })).then(s).catch(l);
    });
  }
  return t;
}
function Zh(e, n = {}) {
  let t, a, s = ao;
  const l = (o) => {
    clearTimeout(o), s(), s = ao;
  };
  let r;
  return (o) => {
    const u = Qe(e), c = Qe(n.maxWait);
    return t && l(t), u <= 0 || c !== void 0 && c <= 0 ? (a && (l(a), a = null), Promise.resolve(o())) : new Promise((f, p) => {
      s = n.rejectOnCancel ? p : f, r = o, c && !a && (a = setTimeout(() => {
        t && l(t), a = null, f(r());
      }, c)), t = setTimeout(() => {
        a && l(a), a = null, f(o());
      }, u);
    });
  };
}
function Xh(e) {
  let n;
  function t() {
    return n || (n = e()), n;
  }
  return t.reset = async () => {
    const a = n;
    n = void 0, a && await a;
  }, t;
}
function so(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Jh(e) {
  return ri();
}
function ir(e) {
  return Array.isArray(e) ? e : [e];
}
function Qh(e, n = 200, t = {}) {
  return Kh(
    Zh(n, t),
    e
  );
}
function em(e, n = !0, t) {
  Jh() ? et(e, t) : n ? e() : Ge(e);
}
function Fr(e, n, t = {}) {
  const {
    immediate: a = !0,
    immediateCallback: s = !1
  } = t, l = Et(!1);
  let r = null;
  function i() {
    r && (clearTimeout(r), r = null);
  }
  function o() {
    l.value = !1, i();
  }
  function u(...c) {
    s && e(), i(), l.value = !0, r = setTimeout(() => {
      l.value = !1, r = null, e(...c);
    }, Qe(n));
  }
  return a && (l.value = !0, di && u()), Xu(o), {
    isPending: li(l),
    start: u,
    stop: o
  };
}
function tm(e, n, t) {
  return Le(
    e,
    n,
    {
      ...t,
      immediate: !0
    }
  );
}
const fi = di ? window : void 0, Ju = di ? window.navigator : void 0;
function nm(e) {
  var n;
  const t = Qe(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
function Is(...e) {
  const n = [], t = () => {
    n.forEach((i) => i()), n.length = 0;
  }, a = (i, o, u, c) => (i.addEventListener(o, u, c), () => i.removeEventListener(o, u, c)), s = T(() => {
    const i = ir(Qe(e[0])).filter((o) => o != null);
    return i.every((o) => typeof o != "string") ? i : void 0;
  }), l = tm(
    () => {
      var i, o;
      return [
        (o = (i = s.value) == null ? void 0 : i.map((u) => nm(u))) != null ? o : [fi].filter((u) => u != null),
        ir(Qe(s.value ? e[1] : e[0])),
        ir(v(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Qe(s.value ? e[3] : e[2])
      ];
    },
    ([i, o, u, c]) => {
      if (t(), !(i != null && i.length) || !(o != null && o.length) || !(u != null && u.length))
        return;
      const f = Gh(c) ? { ...c } : c;
      n.push(
        ...i.flatMap(
          (p) => o.flatMap(
            (d) => u.map((b) => a(p, d, b, f))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    l(), t();
  };
  return Xu(t), r;
}
function am() {
  const e = Et(!1), n = ri();
  return n && et(() => {
    e.value = !0;
  }, n), e;
}
function hi(e) {
  const n = am();
  return T(() => (n.value, !!e()));
}
const sm = Symbol("vueuse-ssr-width");
function lm() {
  const e = Ou() ? qh(sm, null) : null;
  return typeof e == "number" ? e : void 0;
}
function rm(e, n = {}) {
  const { window: t = fi, ssrWidth: a = lm() } = n, s = hi(() => t && "matchMedia" in t && typeof t.matchMedia == "function"), l = Et(typeof a == "number"), r = Et(), i = Et(!1), o = (u) => {
    i.value = u.matches;
  };
  return jt(() => {
    if (l.value) {
      l.value = !s.value;
      const u = Qe(e).split(",");
      i.value = u.some((c) => {
        const f = c.includes("not all"), p = c.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), d = c.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let b = !!(p || d);
        return p && b && (b = a >= so(p[1])), d && b && (b = a <= so(d[1])), f ? !b : b;
      });
      return;
    }
    s.value && (r.value = t.matchMedia(Qe(e)), i.value = r.value.matches);
  }), Is(r, "change", o, { passive: !0 }), T(() => i.value);
}
function lo(e, n = {}) {
  const {
    controls: t = !1,
    navigator: a = Ju
  } = n, s = hi(() => a && "permissions" in a), l = Et(), r = typeof e == "string" ? { name: e } : e, i = Et(), o = () => {
    var c, f;
    i.value = (f = (c = l.value) == null ? void 0 : c.state) != null ? f : "prompt";
  };
  Is(l, "change", o, { passive: !0 });
  const u = Xh(async () => {
    if (s.value) {
      if (!l.value)
        try {
          l.value = await a.permissions.query(r);
        } catch {
          l.value = void 0;
        } finally {
          o();
        }
      if (t)
        return _u(l.value);
    }
  });
  return u(), t ? {
    state: i,
    isSupported: s,
    query: u
  } : i;
}
function mi(e = {}) {
  const {
    navigator: n = Ju,
    read: t = !1,
    source: a,
    copiedDuring: s = 1500,
    legacy: l = !1
  } = e, r = hi(() => n && "clipboard" in n), i = lo("clipboard-read"), o = lo("clipboard-write"), u = T(() => r.value || l), c = Et(""), f = Et(!1), p = Fr(() => f.value = !1, s, { immediate: !1 });
  async function d() {
    let h = !(r.value && y(i.value));
    if (!h)
      try {
        c.value = await n.clipboard.readText();
      } catch {
        h = !0;
      }
    h && (c.value = k());
  }
  u.value && t && Is(["copy", "cut"], d, { passive: !0 });
  async function b(h = Qe(a)) {
    if (u.value && h != null) {
      let g = !(r.value && y(o.value));
      if (!g)
        try {
          await n.clipboard.writeText(h);
        } catch {
          g = !0;
        }
      g && m(h), c.value = h, f.value = !0, p.start();
    }
  }
  function m(h) {
    const g = document.createElement("textarea");
    g.value = h ?? "", g.style.position = "absolute", g.style.opacity = "0", document.body.appendChild(g), g.select(), document.execCommand("copy"), g.remove();
  }
  function k() {
    var h, g, x;
    return (x = (g = (h = document == null ? void 0 : document.getSelection) == null ? void 0 : h.call(document)) == null ? void 0 : g.toString()) != null ? x : "";
  }
  function y(h) {
    return h === "granted" || h === "prompt";
  }
  return {
    isSupported: u,
    text: c,
    copied: f,
    copy: b
  };
}
function im(e = {}) {
  const {
    window: n = fi,
    initialWidth: t = Number.POSITIVE_INFINITY,
    initialHeight: a = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: l = !0,
    type: r = "inner"
  } = e, i = Et(t), o = Et(a), u = () => {
    if (n)
      if (r === "outer")
        i.value = n.outerWidth, o.value = n.outerHeight;
      else if (r === "visual" && n.visualViewport) {
        const { width: f, height: p, scale: d } = n.visualViewport;
        i.value = Math.round(f * d), o.value = Math.round(p * d);
      } else l ? (i.value = n.innerWidth, o.value = n.innerHeight) : (i.value = n.document.documentElement.clientWidth, o.value = n.document.documentElement.clientHeight);
  };
  u(), em(u);
  const c = { passive: !0 };
  if (Is("resize", u, c), n && r === "visual" && n.visualViewport && Is(n.visualViewport, "resize", u, c), s) {
    const f = rm("(orientation: portrait)");
    Le(f, () => u());
  }
  return { width: i, height: o };
}
const om = ["innerHTML"], um = { key: 1 }, Nn = 12, Gn = 8, cm = 200, dm = /* @__PURE__ */ ke({
  __name: "VTooltip",
  props: {
    text: {},
    allowHtml: { type: Boolean, default: !1 },
    placement: { default: "right" },
    delay: { default: 300 },
    disabled: { type: Boolean, default: !1 },
    tooltipClass: { default: "" },
    wrapperClass: { default: "" },
    maxWidth: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = ee(!1), a = ee(null), s = ee(null), l = ee(null), r = ee({ top: 0, left: 0 }), i = ee(n.placement), o = ee(null), u = (m, k, y, h, g, x) => {
      const S = m.top, C = g - m.bottom, _ = m.left, O = h - m.right, I = S >= y + Gn + Nn, D = C >= y + Gn + Nn, B = _ >= k + Gn + Nn, Y = O >= k + Gn + Nn;
      if (x === "top" && I) return "top";
      if (x === "bottom" && D) return "bottom";
      if (x === "left" && B) return "left";
      if (x === "right" && Y) return "right";
      const ne = [
        { placement: "right", fits: Y, space: O },
        { placement: "left", fits: B, space: _ },
        { placement: "bottom", fits: D, space: C },
        { placement: "top", fits: I, space: S }
      ], W = ne.find((ae) => ae.fits);
      return W ? W.placement : (ne.sort((ae, G) => G.space - ae.space), ne[0].placement);
    }, c = async () => {
      if (!s.value) return;
      const m = s.value.getBoundingClientRect(), k = window.innerWidth, y = window.innerHeight;
      if (o.value = null, r.value = { top: -9999, left: -9999 }, i.value = n.placement, await Ge(), !l.value) return;
      const h = l.value.getBoundingClientRect(), g = n.modern ? h.width : Math.max(h.width, cm), x = h.height, S = u(
        m,
        g,
        x,
        k,
        y,
        n.placement
      );
      let C, _;
      switch (S) {
        case "top":
          C = m.top - Gn - x, _ = m.left + m.width / 2 - g / 2;
          break;
        case "bottom":
          C = m.bottom + Gn, _ = m.left + m.width / 2 - g / 2;
          break;
        case "left":
          C = m.top + m.height / 2 - x / 2, _ = m.left - Gn - g;
          break;
        case "right":
        default:
          C = m.top + m.height / 2 - x / 2, _ = m.right + Gn;
          break;
      }
      const O = k - g - Nn;
      _ = Math.max(Nn, Math.min(_, O));
      const I = y - x - Nn;
      C = Math.max(Nn, Math.min(C, I));
      const D = k - Nn * 2;
      g > D && (o.value = `${D}px`), r.value = { top: C, left: _ }, S && (i.value = S);
    }, f = () => {
      n.disabled || !n.text || (a.value = setTimeout(async () => {
        t.value = !0, await Ge(), c();
      }, n.delay));
    }, p = () => {
      a.value && (clearTimeout(a.value), a.value = null), t.value = !1, i.value = n.placement;
    }, d = T(() => ({
      top: `${r.value.top}px`,
      left: `${r.value.left}px`,
      maxWidth: o.value ?? n.maxWidth ?? (n.modern ? "20rem" : "800px")
    })), b = T(
      () => n.modern ? "v-tooltip__body--modern bg-base-100/100 text-mainText rounded-lg shadow-lg break-words w-fit card" : "bg-base-100/100 text-mainText text-sm font-medium px-3 py-1.5 rounded-lg shadow-lg break-words w-fit min-w-[200px] card"
    );
    return (m, k) => (w(), M("div", {
      ref_key: "triggerRef",
      ref: s,
      class: q(["relative inline-block cursor-pointer", e.wrapperClass]),
      onBlur: p,
      onFocus: f,
      onMouseenter: f,
      onMouseleave: p
    }, [
      H(m.$slots, "default", {}, void 0, !0),
      (w(), ue(Pn, { to: "body" }, [
        ie(ht, {
          "enter-active-class": "transition-opacity duration-200 ease-out",
          "enter-from-class": "opacity-0",
          "enter-to-class": "opacity-100",
          "leave-active-class": "transition-opacity duration-150 ease-in",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: ce(() => [
            t.value && e.text ? (w(), M("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: l,
              style: Fe(d.value),
              class: "fixed z-[10001] pointer-events-none"
            }, [
              E("div", {
                class: q([b.value, e.tooltipClass])
              }, [
                n.allowHtml ? (w(), M("span", {
                  key: 0,
                  innerHTML: e.text
                }, null, 8, om)) : (w(), M("span", um, re(e.text), 1))
              ], 2)
            ], 4)) : R("", !0)
          ]),
          _: 1
        })
      ]))
    ], 34));
  }
}), xa = /* @__PURE__ */ ze(dm, [["__scopeId", "data-v-11931e94"]]), fm = ["aria-label"], hm = /* @__PURE__ */ ke({
  __name: "VCopyButton",
  props: {
    value: {},
    label: { default: "value" },
    size: { default: 16 }
  },
  setup(e) {
    const { copy: n, copied: t, isSupported: a } = mi({ source: () => e.value, copiedDuring: 1500 });
    return (s, l) => v(a) ? (w(), ue(xa, {
      key: 0,
      text: v(t) ? "Copied!" : `Copy ${e.label}`,
      placement: "top"
    }, {
      default: ce(() => [
        E("button", {
          "aria-label": `Copy ${e.label}`,
          class: "v-copy-button flex-shrink-0 flex items-center justify-center p-1 rounded-md text-secondaryText hover:text-mainText hover:bg-base-200",
          type: "button",
          onClick: l[0] || (l[0] = Ve((r) => v(n)(), ["stop"]))
        }, [
          ie(be, {
            class: q(v(t) ? "text-success" : ""),
            icon: v(t) ? "lucide:check" : "lucide:copy",
            size: e.size
          }, null, 8, ["class", "icon", "size"])
        ], 8, fm)
      ]),
      _: 1
    }, 8, ["text"])) : R("", !0);
  }
}), lD = /* @__PURE__ */ ze(hm, [["__scopeId", "data-v-1863029c"]]);
class Ma extends Error {
}
class mm extends Ma {
  constructor(n) {
    super(`Invalid DateTime: ${n.toMessage()}`);
  }
}
class vm extends Ma {
  constructor(n) {
    super(`Invalid Interval: ${n.toMessage()}`);
  }
}
class pm extends Ma {
  constructor(n) {
    super(`Invalid Duration: ${n.toMessage()}`);
  }
}
class Ba extends Ma {
}
class Qu extends Ma {
  constructor(n) {
    super(`Invalid unit ${n}`);
  }
}
class Pt extends Ma {
}
class Kn extends Ma {
  constructor() {
    super("Zone is an abstract class");
  }
}
const Oe = "numeric", bn = "short", Kt = "long", wl = {
  year: Oe,
  month: Oe,
  day: Oe
}, ec = {
  year: Oe,
  month: bn,
  day: Oe
}, gm = {
  year: Oe,
  month: bn,
  day: Oe,
  weekday: bn
}, tc = {
  year: Oe,
  month: Kt,
  day: Oe
}, nc = {
  year: Oe,
  month: Kt,
  day: Oe,
  weekday: Kt
}, ac = {
  hour: Oe,
  minute: Oe
}, sc = {
  hour: Oe,
  minute: Oe,
  second: Oe
}, lc = {
  hour: Oe,
  minute: Oe,
  second: Oe,
  timeZoneName: bn
}, rc = {
  hour: Oe,
  minute: Oe,
  second: Oe,
  timeZoneName: Kt
}, ic = {
  hour: Oe,
  minute: Oe,
  hourCycle: "h23"
}, oc = {
  hour: Oe,
  minute: Oe,
  second: Oe,
  hourCycle: "h23"
}, uc = {
  hour: Oe,
  minute: Oe,
  second: Oe,
  hourCycle: "h23",
  timeZoneName: bn
}, cc = {
  hour: Oe,
  minute: Oe,
  second: Oe,
  hourCycle: "h23",
  timeZoneName: Kt
}, dc = {
  year: Oe,
  month: Oe,
  day: Oe,
  hour: Oe,
  minute: Oe
}, fc = {
  year: Oe,
  month: Oe,
  day: Oe,
  hour: Oe,
  minute: Oe,
  second: Oe
}, hc = {
  year: Oe,
  month: bn,
  day: Oe,
  hour: Oe,
  minute: Oe
}, mc = {
  year: Oe,
  month: bn,
  day: Oe,
  hour: Oe,
  minute: Oe,
  second: Oe
}, ym = {
  year: Oe,
  month: bn,
  day: Oe,
  weekday: bn,
  hour: Oe,
  minute: Oe
}, vc = {
  year: Oe,
  month: Kt,
  day: Oe,
  hour: Oe,
  minute: Oe,
  timeZoneName: bn
}, pc = {
  year: Oe,
  month: Kt,
  day: Oe,
  hour: Oe,
  minute: Oe,
  second: Oe,
  timeZoneName: bn
}, gc = {
  year: Oe,
  month: Kt,
  day: Oe,
  weekday: Kt,
  hour: Oe,
  minute: Oe,
  timeZoneName: Kt
}, yc = {
  year: Oe,
  month: Kt,
  day: Oe,
  weekday: Kt,
  hour: Oe,
  minute: Oe,
  second: Oe,
  timeZoneName: Kt
};
class Vs {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new Kn();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new Kn();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new Kn();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, t) {
    throw new Kn();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    throw new Kn();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    throw new Kn();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    throw new Kn();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new Kn();
  }
}
let or = null;
class Rl extends Vs {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return or === null && (or = new Rl()), or;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(n, { format: t, locale: a }) {
    return Oc(n, t, a);
  }
  /** @override **/
  formatOffset(n, t) {
    return Ms(this.offset(n), t);
  }
  /** @override **/
  offset(n) {
    return -new Date(n).getTimezoneOffset();
  }
  /** @override **/
  equals(n) {
    return n.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const Vr = /* @__PURE__ */ new Map();
function bm(e) {
  let n = Vr.get(e);
  return n === void 0 && (n = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), Vr.set(e, n)), n;
}
const wm = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function km(e, n) {
  const t = e.format(n).replace(/\u200E/g, ""), a = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(t), [, s, l, r, i, o, u, c] = a;
  return [r, s, l, i, o, u, c];
}
function xm(e, n) {
  const t = e.formatToParts(n), a = [];
  for (let s = 0; s < t.length; s++) {
    const { type: l, value: r } = t[s], i = wm[l];
    l === "era" ? a[i] = r : Be(i) || (a[i] = parseInt(r, 10));
  }
  return a;
}
const ur = /* @__PURE__ */ new Map();
class Yn extends Vs {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(n) {
    let t = ur.get(n);
    return t === void 0 && ur.set(n, t = new Yn(n)), t;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ur.clear(), Vr.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(n) {
    return this.isValidZone(n);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(n) {
    if (!n)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: n }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(n) {
    super(), this.zoneName = n, this.valid = Yn.isValidZone(n);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, { format: t, locale: a }) {
    return Oc(n, t, a, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    return Ms(this.offset(n), t);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    if (!this.valid) return NaN;
    const t = new Date(n);
    if (isNaN(t)) return NaN;
    const a = bm(this.name);
    let [s, l, r, i, o, u, c] = a.formatToParts ? xm(a, t) : km(a, t);
    i === "BC" && (s = -Math.abs(s) + 1);
    const p = Vl({
      year: s,
      month: l,
      day: r,
      hour: o === 24 ? 0 : o,
      minute: u,
      second: c,
      millisecond: 0
    });
    let d = +t;
    const b = d % 1e3;
    return d -= b >= 0 ? b : 1e3 + b, (p - d) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "iana" && n.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let ro = {};
function Sm(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = ro[t];
  return a || (a = new Intl.ListFormat(e, n), ro[t] = a), a;
}
const Lr = /* @__PURE__ */ new Map();
function Nr(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = Lr.get(t);
  return a === void 0 && (a = new Intl.DateTimeFormat(e, n), Lr.set(t, a)), a;
}
const zr = /* @__PURE__ */ new Map();
function Tm(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = zr.get(t);
  return a === void 0 && (a = new Intl.NumberFormat(e, n), zr.set(t, a)), a;
}
const Br = /* @__PURE__ */ new Map();
function $m(e, n = {}) {
  const { base: t, ...a } = n, s = JSON.stringify([e, a]);
  let l = Br.get(s);
  return l === void 0 && (l = new Intl.RelativeTimeFormat(e, n), Br.set(s, l)), l;
}
let xs = null;
function Mm() {
  return xs || (xs = new Intl.DateTimeFormat().resolvedOptions().locale, xs);
}
const Wr = /* @__PURE__ */ new Map();
function bc(e) {
  let n = Wr.get(e);
  return n === void 0 && (n = new Intl.DateTimeFormat(e).resolvedOptions(), Wr.set(e, n)), n;
}
const Yr = /* @__PURE__ */ new Map();
function Cm(e) {
  let n = Yr.get(e);
  if (!n) {
    const t = new Intl.Locale(e);
    n = "getWeekInfo" in t ? t.getWeekInfo() : t.weekInfo, "minimalDays" in n || (n = { ...wc, ...n }), Yr.set(e, n);
  }
  return n;
}
function Dm(e) {
  const n = e.indexOf("-x-");
  n !== -1 && (e = e.substring(0, n));
  const t = e.indexOf("-u-");
  if (t === -1)
    return [e];
  {
    let a, s;
    try {
      a = Nr(e).resolvedOptions(), s = e;
    } catch {
      const o = e.substring(0, t);
      a = Nr(o).resolvedOptions(), s = o;
    }
    const { numberingSystem: l, calendar: r } = a;
    return [s, l, r];
  }
}
function Om(e, n, t) {
  return (t || n) && (e.includes("-u-") || (e += "-u"), t && (e += `-ca-${t}`), n && (e += `-nu-${n}`)), e;
}
function _m(e) {
  const n = [];
  for (let t = 1; t <= 12; t++) {
    const a = Ee.utc(2009, t, 1);
    n.push(e(a));
  }
  return n;
}
function Em(e) {
  const n = [];
  for (let t = 1; t <= 7; t++) {
    const a = Ee.utc(2016, 11, 13 + t);
    n.push(e(a));
  }
  return n;
}
function tl(e, n, t, a) {
  const s = e.listingMode();
  return s === "error" ? null : s === "en" ? t(n) : a(n);
}
function Im(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || bc(e.locale).numberingSystem === "latn";
}
class Am {
  constructor(n, t, a) {
    this.padTo = a.padTo || 0, this.floor = a.floor || !1;
    const { padTo: s, floor: l, ...r } = a;
    if (!t || Object.keys(r).length > 0) {
      const i = { useGrouping: !1, ...a };
      a.padTo > 0 && (i.minimumIntegerDigits = a.padTo), this.inf = Tm(n, i);
    }
  }
  format(n) {
    if (this.inf) {
      const t = this.floor ? Math.floor(n) : n;
      return this.inf.format(t);
    } else {
      const t = this.floor ? Math.floor(n) : bi(n, 3);
      return $t(t, this.padTo);
    }
  }
}
class Pm {
  constructor(n, t, a) {
    this.opts = a, this.originalZone = void 0;
    let s;
    if (this.opts.timeZone)
      this.dt = n;
    else if (n.zone.type === "fixed") {
      const r = -1 * (n.offset / 60), i = r >= 0 ? `Etc/GMT+${r}` : `Etc/GMT${r}`;
      n.offset !== 0 && Yn.create(i).valid ? (s = i, this.dt = n) : (s = "UTC", this.dt = n.offset === 0 ? n : n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    } else n.zone.type === "system" ? this.dt = n : n.zone.type === "iana" ? (this.dt = n, s = n.zone.name) : (s = "UTC", this.dt = n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    const l = { ...this.opts };
    l.timeZone = l.timeZone || s, this.dtf = Nr(t, l);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: n }) => n).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const n = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? n.map((t) => {
      if (t.type === "timeZoneName") {
        const a = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...t,
          value: a
        };
      } else
        return t;
    }) : n;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class Rm {
  constructor(n, t, a) {
    this.opts = { style: "long", ...a }, !t && Cc() && (this.rtf = $m(n, a));
  }
  format(n, t) {
    return this.rtf ? this.rtf.format(n, t) : av(t, n, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(n, t) {
    return this.rtf ? this.rtf.formatToParts(n, t) : [];
  }
}
const wc = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class st {
  static fromOpts(n) {
    return st.create(
      n.locale,
      n.numberingSystem,
      n.outputCalendar,
      n.weekSettings,
      n.defaultToEN
    );
  }
  static create(n, t, a, s, l = !1) {
    const r = n || gt.defaultLocale, i = r || (l ? "en-US" : Mm()), o = t || gt.defaultNumberingSystem, u = a || gt.defaultOutputCalendar, c = Ur(s) || gt.defaultWeekSettings;
    return new st(i, o, u, c, r);
  }
  static resetCache() {
    xs = null, Lr.clear(), zr.clear(), Br.clear(), Wr.clear(), Yr.clear();
  }
  static fromObject({ locale: n, numberingSystem: t, outputCalendar: a, weekSettings: s } = {}) {
    return st.create(n, t, a, s);
  }
  constructor(n, t, a, s, l) {
    const [r, i, o] = Dm(n);
    this.locale = r, this.numberingSystem = t || i || null, this.outputCalendar = a || o || null, this.weekSettings = s, this.intl = Om(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = l, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = Im(this)), this.fastNumbersCached;
  }
  listingMode() {
    const n = this.isEnglish(), t = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return n && t ? "en" : "intl";
  }
  clone(n) {
    return !n || Object.getOwnPropertyNames(n).length === 0 ? this : st.create(
      n.locale || this.specifiedLocale,
      n.numberingSystem || this.numberingSystem,
      n.outputCalendar || this.outputCalendar,
      Ur(n.weekSettings) || this.weekSettings,
      n.defaultToEN || !1
    );
  }
  redefaultToEN(n = {}) {
    return this.clone({ ...n, defaultToEN: !0 });
  }
  redefaultToSystem(n = {}) {
    return this.clone({ ...n, defaultToEN: !1 });
  }
  months(n, t = !1) {
    return tl(this, n, Ic, () => {
      const a = this.intl === "ja" || this.intl.startsWith("ja-");
      t &= !a;
      const s = t ? { month: n, day: "numeric" } : { month: n }, l = t ? "format" : "standalone";
      if (!this.monthsCache[l][n]) {
        const r = a ? (i) => this.dtFormatter(i, s).format() : (i) => this.extract(i, s, "month");
        this.monthsCache[l][n] = _m(r);
      }
      return this.monthsCache[l][n];
    });
  }
  weekdays(n, t = !1) {
    return tl(this, n, Rc, () => {
      const a = t ? { weekday: n, year: "numeric", month: "long", day: "numeric" } : { weekday: n }, s = t ? "format" : "standalone";
      return this.weekdaysCache[s][n] || (this.weekdaysCache[s][n] = Em(
        (l) => this.extract(l, a, "weekday")
      )), this.weekdaysCache[s][n];
    });
  }
  meridiems() {
    return tl(
      this,
      void 0,
      () => Fc,
      () => {
        if (!this.meridiemCache) {
          const n = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [Ee.utc(2016, 11, 13, 9), Ee.utc(2016, 11, 13, 19)].map(
            (t) => this.extract(t, n, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(n) {
    return tl(this, n, Vc, () => {
      const t = { era: n };
      return this.eraCache[n] || (this.eraCache[n] = [Ee.utc(-40, 1, 1), Ee.utc(2017, 1, 1)].map(
        (a) => this.extract(a, t, "era")
      )), this.eraCache[n];
    });
  }
  extract(n, t, a) {
    const s = this.dtFormatter(n, t), l = s.formatToParts(), r = l.find((i) => i.type.toLowerCase() === a);
    return r ? r.value : null;
  }
  numberFormatter(n = {}) {
    return new Am(this.intl, n.forceSimple || this.fastNumbers, n);
  }
  dtFormatter(n, t = {}) {
    return new Pm(n, this.intl, t);
  }
  relFormatter(n = {}) {
    return new Rm(this.intl, this.isEnglish(), n);
  }
  listFormatter(n = {}) {
    return Sm(this.intl, n);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || bc(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : Dc() ? Cm(this.locale) : wc;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(n) {
    return this.locale === n.locale && this.numberingSystem === n.numberingSystem && this.outputCalendar === n.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let cr = null;
class zt extends Vs {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return cr === null && (cr = new zt(0)), cr;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(n) {
    return n === 0 ? zt.utcInstance : new zt(n);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(n) {
    if (n) {
      const t = n.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (t)
        return new zt(Ll(t[1], t[2]));
    }
    return null;
  }
  constructor(n) {
    super(), this.fixed = n;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Ms(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Ms(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    return Ms(this.fixed, t);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "fixed" && n.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class Fm extends Vs {
  constructor(n) {
    super(), this.zoneName = n;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Qn(e, n) {
  if (Be(e) || e === null)
    return n;
  if (e instanceof Vs)
    return e;
  if (Wm(e)) {
    const t = e.toLowerCase();
    return t === "default" ? n : t === "local" || t === "system" ? Rl.instance : t === "utc" || t === "gmt" ? zt.utcInstance : zt.parseSpecifier(t) || Yn.create(e);
  } else return na(e) ? zt.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new Fm(e);
}
const vi = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, io = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, Vm = vi.hanidec.replace(/[\[|\]]/g, "").split("");
function Lm(e) {
  let n = parseInt(e, 10);
  if (isNaN(n)) {
    n = "";
    for (let t = 0; t < e.length; t++) {
      const a = e.charCodeAt(t);
      if (e[t].search(vi.hanidec) !== -1)
        n += Vm.indexOf(e[t]);
      else
        for (const s in io) {
          const [l, r] = io[s];
          a >= l && a <= r && (n += a - l);
        }
    }
    return parseInt(n, 10);
  } else
    return n;
}
const Hr = /* @__PURE__ */ new Map();
function Nm() {
  Hr.clear();
}
function cn({ numberingSystem: e }, n = "") {
  const t = e || "latn";
  let a = Hr.get(t);
  a === void 0 && (a = /* @__PURE__ */ new Map(), Hr.set(t, a));
  let s = a.get(n);
  return s === void 0 && (s = new RegExp(`${vi[t]}${n}`), a.set(n, s)), s;
}
let oo = () => Date.now(), uo = "system", co = null, fo = null, ho = null, mo = 60, vo, po = null;
class gt {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return oo;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    oo = n;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(n) {
    uo = n;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Qn(uo, Rl.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return co;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(n) {
    co = n;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return fo;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(n) {
    fo = n;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return ho;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(n) {
    ho = n;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return po;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(n) {
    po = Ur(n);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return mo;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(n) {
    mo = n % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return vo;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(n) {
    vo = n;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    st.resetCache(), Yn.resetCache(), Ee.resetCache(), Nm();
  }
}
class vn {
  constructor(n, t) {
    this.reason = n, this.explanation = t;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const kc = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], xc = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function sn(e, n) {
  return new vn(
    "unit out of range",
    `you specified ${n} (of type ${typeof n}) as a ${e}, which is invalid`
  );
}
function pi(e, n, t) {
  const a = new Date(Date.UTC(e, n - 1, t));
  e < 100 && e >= 0 && a.setUTCFullYear(a.getUTCFullYear() - 1900);
  const s = a.getUTCDay();
  return s === 0 ? 7 : s;
}
function Sc(e, n, t) {
  return t + (Ls(e) ? xc : kc)[n - 1];
}
function Tc(e, n) {
  const t = Ls(e) ? xc : kc, a = t.findIndex((l) => l < n), s = n - t[a];
  return { month: a + 1, day: s };
}
function gi(e, n) {
  return (e - n + 7) % 7 + 1;
}
function kl(e, n = 4, t = 1) {
  const { year: a, month: s, day: l } = e, r = Sc(a, s, l), i = gi(pi(a, s, l), t);
  let o = Math.floor((r - i + 14 - n) / 7), u;
  return o < 1 ? (u = a - 1, o = As(u, n, t)) : o > As(a, n, t) ? (u = a + 1, o = 1) : u = a, { weekYear: u, weekNumber: o, weekday: i, ...Nl(e) };
}
function go(e, n = 4, t = 1) {
  const { weekYear: a, weekNumber: s, weekday: l } = e, r = gi(pi(a, 1, n), t), i = Ua(a);
  let o = s * 7 + l - r - 7 + n, u;
  o < 1 ? (u = a - 1, o += Ua(u)) : o > i ? (u = a + 1, o -= Ua(a)) : u = a;
  const { month: c, day: f } = Tc(u, o);
  return { year: u, month: c, day: f, ...Nl(e) };
}
function dr(e) {
  const { year: n, month: t, day: a } = e, s = Sc(n, t, a);
  return { year: n, ordinal: s, ...Nl(e) };
}
function yo(e) {
  const { year: n, ordinal: t } = e, { month: a, day: s } = Tc(n, t);
  return { year: n, month: a, day: s, ...Nl(e) };
}
function bo(e, n) {
  if (!Be(e.localWeekday) || !Be(e.localWeekNumber) || !Be(e.localWeekYear)) {
    if (!Be(e.weekday) || !Be(e.weekNumber) || !Be(e.weekYear))
      throw new Ba(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Be(e.localWeekday) || (e.weekday = e.localWeekday), Be(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), Be(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: n.getMinDaysInFirstWeek(),
      startOfWeek: n.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function zm(e, n = 4, t = 1) {
  const a = Fl(e.weekYear), s = ln(
    e.weekNumber,
    1,
    As(e.weekYear, n, t)
  ), l = ln(e.weekday, 1, 7);
  return a ? s ? l ? !1 : sn("weekday", e.weekday) : sn("week", e.weekNumber) : sn("weekYear", e.weekYear);
}
function Bm(e) {
  const n = Fl(e.year), t = ln(e.ordinal, 1, Ua(e.year));
  return n ? t ? !1 : sn("ordinal", e.ordinal) : sn("year", e.year);
}
function $c(e) {
  const n = Fl(e.year), t = ln(e.month, 1, 12), a = ln(e.day, 1, xl(e.year, e.month));
  return n ? t ? a ? !1 : sn("day", e.day) : sn("month", e.month) : sn("year", e.year);
}
function Mc(e) {
  const { hour: n, minute: t, second: a, millisecond: s } = e, l = ln(n, 0, 23) || n === 24 && t === 0 && a === 0 && s === 0, r = ln(t, 0, 59), i = ln(a, 0, 59), o = ln(s, 0, 999);
  return l ? r ? i ? o ? !1 : sn("millisecond", s) : sn("second", a) : sn("minute", t) : sn("hour", n);
}
function Be(e) {
  return typeof e > "u";
}
function na(e) {
  return typeof e == "number";
}
function Fl(e) {
  return typeof e == "number" && e % 1 === 0;
}
function Wm(e) {
  return typeof e == "string";
}
function Ym(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function Cc() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function Dc() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function Hm(e) {
  return Array.isArray(e) ? e : [e];
}
function wo(e, n, t) {
  if (e.length !== 0)
    return e.reduce((a, s) => {
      const l = [n(s), s];
      return a && t(a[0], l[0]) === a[0] ? a : l;
    }, null)[1];
}
function Um(e, n) {
  return n.reduce((t, a) => (t[a] = e[a], t), {});
}
function Xa(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function Ur(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new Pt("Week settings must be an object");
  if (!ln(e.firstDay, 1, 7) || !ln(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((n) => !ln(n, 1, 7)))
    throw new Pt("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function ln(e, n, t) {
  return Fl(e) && e >= n && e <= t;
}
function qm(e, n) {
  return e - n * Math.floor(e / n);
}
function $t(e, n = 2) {
  const t = e < 0;
  let a;
  return t ? a = "-" + ("" + -e).padStart(n, "0") : a = ("" + e).padStart(n, "0"), a;
}
function Jn(e) {
  if (!(Be(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function ca(e) {
  if (!(Be(e) || e === null || e === ""))
    return parseFloat(e);
}
function yi(e) {
  if (!(Be(e) || e === null || e === "")) {
    const n = parseFloat("0." + e) * 1e3;
    return Math.floor(n);
  }
}
function bi(e, n, t = "round") {
  const a = 10 ** n;
  switch (t) {
    case "expand":
      return e > 0 ? Math.ceil(e * a) / a : Math.floor(e * a) / a;
    case "trunc":
      return Math.trunc(e * a) / a;
    case "round":
      return Math.round(e * a) / a;
    case "floor":
      return Math.floor(e * a) / a;
    case "ceil":
      return Math.ceil(e * a) / a;
    default:
      throw new RangeError(`Value rounding ${t} is out of range`);
  }
}
function Ls(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Ua(e) {
  return Ls(e) ? 366 : 365;
}
function xl(e, n) {
  const t = qm(n - 1, 12) + 1, a = e + (n - t) / 12;
  return t === 2 ? Ls(a) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][t - 1];
}
function Vl(e) {
  let n = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (n = new Date(n), n.setUTCFullYear(e.year, e.month - 1, e.day)), +n;
}
function ko(e, n, t) {
  return -gi(pi(e, 1, n), t) + n - 1;
}
function As(e, n = 4, t = 1) {
  const a = ko(e, n, t), s = ko(e + 1, n, t);
  return (Ua(e) - a + s) / 7;
}
function qr(e) {
  return e > 99 ? e : e > gt.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function Oc(e, n, t, a = null) {
  const s = new Date(e), l = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  a && (l.timeZone = a);
  const r = { timeZoneName: n, ...l }, i = new Intl.DateTimeFormat(t, r).formatToParts(s).find((o) => o.type.toLowerCase() === "timezonename");
  return i ? i.value : null;
}
function Ll(e, n) {
  let t = parseInt(e, 10);
  Number.isNaN(t) && (t = 0);
  const a = parseInt(n, 10) || 0, s = t < 0 || Object.is(t, -0) ? -a : a;
  return t * 60 + s;
}
function _c(e) {
  const n = Number(e);
  if (typeof e == "boolean" || e === "" || !Number.isFinite(n))
    throw new Pt(`Invalid unit value ${e}`);
  return n;
}
function Sl(e, n) {
  const t = {};
  for (const a in e)
    if (Xa(e, a)) {
      const s = e[a];
      if (s == null) continue;
      t[n(a)] = _c(s);
    }
  return t;
}
function Ms(e, n) {
  const t = Math.trunc(Math.abs(e / 60)), a = Math.trunc(Math.abs(e % 60)), s = e >= 0 ? "+" : "-";
  switch (n) {
    case "short":
      return `${s}${$t(t, 2)}:${$t(a, 2)}`;
    case "narrow":
      return `${s}${t}${a > 0 ? `:${a}` : ""}`;
    case "techie":
      return `${s}${$t(t, 2)}${$t(a, 2)}`;
    default:
      throw new RangeError(`Value format ${n} is out of range for property format`);
  }
}
function Nl(e) {
  return Um(e, ["hour", "minute", "second", "millisecond"]);
}
const jm = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Ec = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], Gm = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Ic(e) {
  switch (e) {
    case "narrow":
      return [...Gm];
    case "short":
      return [...Ec];
    case "long":
      return [...jm];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const Ac = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], Pc = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], Km = ["M", "T", "W", "T", "F", "S", "S"];
function Rc(e) {
  switch (e) {
    case "narrow":
      return [...Km];
    case "short":
      return [...Pc];
    case "long":
      return [...Ac];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Fc = ["AM", "PM"], Zm = ["Before Christ", "Anno Domini"], Xm = ["BC", "AD"], Jm = ["B", "A"];
function Vc(e) {
  switch (e) {
    case "narrow":
      return [...Jm];
    case "short":
      return [...Xm];
    case "long":
      return [...Zm];
    default:
      return null;
  }
}
function Qm(e) {
  return Fc[e.hour < 12 ? 0 : 1];
}
function ev(e, n) {
  return Rc(n)[e.weekday - 1];
}
function tv(e, n) {
  return Ic(n)[e.month - 1];
}
function nv(e, n) {
  return Vc(n)[e.year < 0 ? 0 : 1];
}
function av(e, n, t = "always", a = !1) {
  const s = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, l = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (t === "auto" && l) {
    const f = e === "days";
    switch (n) {
      case 1:
        return f ? "tomorrow" : `next ${s[e][0]}`;
      case -1:
        return f ? "yesterday" : `last ${s[e][0]}`;
      case 0:
        return f ? "today" : `this ${s[e][0]}`;
    }
  }
  const r = Object.is(n, -0) || n < 0, i = Math.abs(n), o = i === 1, u = s[e], c = a ? o ? u[1] : u[2] || u[1] : o ? s[e][0] : e;
  return r ? `${i} ${c} ago` : `in ${i} ${c}`;
}
function xo(e, n) {
  let t = "";
  for (const a of e)
    a.literal ? t += a.val : t += n(a.val);
  return t;
}
const sv = {
  D: wl,
  DD: ec,
  DDD: tc,
  DDDD: nc,
  t: ac,
  tt: sc,
  ttt: lc,
  tttt: rc,
  T: ic,
  TT: oc,
  TTT: uc,
  TTTT: cc,
  f: dc,
  ff: hc,
  fff: vc,
  ffff: gc,
  F: fc,
  FF: mc,
  FFF: pc,
  FFFF: yc
};
class Rt {
  static create(n, t = {}) {
    return new Rt(n, t);
  }
  static parseFormat(n) {
    let t = null, a = "", s = !1;
    const l = [];
    for (let r = 0; r < n.length; r++) {
      const i = n.charAt(r);
      i === "'" ? ((a.length > 0 || s) && l.push({
        literal: s || /^\s+$/.test(a),
        val: a === "" ? "'" : a
      }), t = null, a = "", s = !s) : s || i === t ? a += i : (a.length > 0 && l.push({ literal: /^\s+$/.test(a), val: a }), a = i, t = i);
    }
    return a.length > 0 && l.push({ literal: s || /^\s+$/.test(a), val: a }), l;
  }
  static macroTokenToFormatOpts(n) {
    return sv[n];
  }
  constructor(n, t) {
    this.opts = t, this.loc = n, this.systemLoc = null;
  }
  formatWithSystemDefault(n, t) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(n, { ...this.opts, ...t }).format();
  }
  dtFormatter(n, t = {}) {
    return this.loc.dtFormatter(n, { ...this.opts, ...t });
  }
  formatDateTime(n, t) {
    return this.dtFormatter(n, t).format();
  }
  formatDateTimeParts(n, t) {
    return this.dtFormatter(n, t).formatToParts();
  }
  formatInterval(n, t) {
    return this.dtFormatter(n.start, t).dtf.formatRange(n.start.toJSDate(), n.end.toJSDate());
  }
  resolvedOptions(n, t) {
    return this.dtFormatter(n, t).resolvedOptions();
  }
  num(n, t = 0, a = void 0) {
    if (this.opts.forceSimple)
      return $t(n, t);
    const s = { ...this.opts };
    return t > 0 && (s.padTo = t), a && (s.signDisplay = a), this.loc.numberFormatter(s).format(n);
  }
  formatDateTimeFromString(n, t) {
    const a = this.loc.listingMode() === "en", s = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", l = (d, b) => this.loc.extract(n, d, b), r = (d) => n.isOffsetFixed && n.offset === 0 && d.allowZ ? "Z" : n.isValid ? n.zone.formatOffset(n.ts, d.format) : "", i = () => a ? Qm(n) : l({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), o = (d, b) => a ? tv(n, d) : l(b ? { month: d } : { month: d, day: "numeric" }, "month"), u = (d, b) => a ? ev(n, d) : l(
      b ? { weekday: d } : { weekday: d, month: "long", day: "numeric" },
      "weekday"
    ), c = (d) => {
      const b = Rt.macroTokenToFormatOpts(d);
      return b ? this.formatWithSystemDefault(n, b) : d;
    }, f = (d) => a ? nv(n, d) : l({ era: d }, "era"), p = (d) => {
      switch (d) {
        // ms
        case "S":
          return this.num(n.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(n.millisecond, 3);
        // seconds
        case "s":
          return this.num(n.second);
        case "ss":
          return this.num(n.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(n.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(n.millisecond / 100));
        // minutes
        case "m":
          return this.num(n.minute);
        case "mm":
          return this.num(n.minute, 2);
        // hours
        case "h":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12);
        case "hh":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12, 2);
        case "H":
          return this.num(n.hour);
        case "HH":
          return this.num(n.hour, 2);
        // offset
        case "Z":
          return r({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return r({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return r({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return n.zone.offsetName(n.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return n.zone.offsetName(n.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return n.zoneName;
        // meridiems
        case "a":
          return i();
        // dates
        case "d":
          return s ? l({ day: "numeric" }, "day") : this.num(n.day);
        case "dd":
          return s ? l({ day: "2-digit" }, "day") : this.num(n.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(n.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(n.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        // months - standalone
        case "L":
          return s ? l({ month: "numeric", day: "numeric" }, "month") : this.num(n.month);
        case "LL":
          return s ? l({ month: "2-digit", day: "numeric" }, "month") : this.num(n.month, 2);
        case "LLL":
          return o("short", !0);
        case "LLLL":
          return o("long", !0);
        case "LLLLL":
          return o("narrow", !0);
        // months - format
        case "M":
          return s ? l({ month: "numeric" }, "month") : this.num(n.month);
        case "MM":
          return s ? l({ month: "2-digit" }, "month") : this.num(n.month, 2);
        case "MMM":
          return o("short", !1);
        case "MMMM":
          return o("long", !1);
        case "MMMMM":
          return o("narrow", !1);
        // years
        case "y":
          return s ? l({ year: "numeric" }, "year") : this.num(n.year);
        case "yy":
          return s ? l({ year: "2-digit" }, "year") : this.num(n.year.toString().slice(-2), 2);
        case "yyyy":
          return s ? l({ year: "numeric" }, "year") : this.num(n.year, 4);
        case "yyyyyy":
          return s ? l({ year: "numeric" }, "year") : this.num(n.year, 6);
        // eras
        case "G":
          return f("short");
        case "GG":
          return f("long");
        case "GGGGG":
          return f("narrow");
        case "kk":
          return this.num(n.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(n.weekYear, 4);
        case "W":
          return this.num(n.weekNumber);
        case "WW":
          return this.num(n.weekNumber, 2);
        case "n":
          return this.num(n.localWeekNumber);
        case "nn":
          return this.num(n.localWeekNumber, 2);
        case "ii":
          return this.num(n.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(n.localWeekYear, 4);
        case "o":
          return this.num(n.ordinal);
        case "ooo":
          return this.num(n.ordinal, 3);
        case "q":
          return this.num(n.quarter);
        case "qq":
          return this.num(n.quarter, 2);
        case "X":
          return this.num(Math.floor(n.ts / 1e3));
        case "x":
          return this.num(n.ts);
        default:
          return c(d);
      }
    };
    return xo(Rt.parseFormat(t), p);
  }
  formatDurationFromString(n, t) {
    const a = this.opts.signMode === "negativeLargestOnly" ? -1 : 1, s = (c) => {
      switch (c[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, l = (c, f) => (p) => {
      const d = s(p);
      if (d) {
        const b = f.isNegativeDuration && d !== f.largestUnit ? a : 1;
        let m;
        return this.opts.signMode === "negativeLargestOnly" && d !== f.largestUnit ? m = "never" : this.opts.signMode === "all" ? m = "always" : m = "auto", this.num(c.get(d) * b, p.length, m);
      } else
        return p;
    }, r = Rt.parseFormat(t), i = r.reduce(
      (c, { literal: f, val: p }) => f ? c : c.concat(p),
      []
    ), o = n.shiftTo(...i.map(s).filter((c) => c)), u = {
      isNegativeDuration: o < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(o.values)[0]
    };
    return xo(r, l(o, u));
  }
}
const Lc = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function as(...e) {
  const n = e.reduce((t, a) => t + a.source, "");
  return RegExp(`^${n}$`);
}
function ss(...e) {
  return (n) => e.reduce(
    ([t, a, s], l) => {
      const [r, i, o] = l(n, s);
      return [{ ...t, ...r }, i || a, o];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function ls(e, ...n) {
  if (e == null)
    return [null, null];
  for (const [t, a] of n) {
    const s = t.exec(e);
    if (s)
      return a(s);
  }
  return [null, null];
}
function Nc(...e) {
  return (n, t) => {
    const a = {};
    let s;
    for (s = 0; s < e.length; s++)
      a[e[s]] = Jn(n[t + s]);
    return [a, null, t + s];
  };
}
const zc = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/, lv = `(?:${zc.source}?(?:\\[(${Lc.source})\\])?)?`, wi = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Bc = RegExp(`${wi.source}${lv}`), ki = RegExp(`(?:[Tt]${Bc.source})?`), rv = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, iv = /(\d{4})-?W(\d\d)(?:-?(\d))?/, ov = /(\d{4})-?(\d{3})/, uv = Nc("weekYear", "weekNumber", "weekDay"), cv = Nc("year", "ordinal"), dv = /(\d{4})-(\d\d)-(\d\d)/, Wc = RegExp(
  `${wi.source} ?(?:${zc.source}|(${Lc.source}))?`
), fv = RegExp(`(?: ${Wc.source})?`);
function qa(e, n, t) {
  const a = e[n];
  return Be(a) ? t : Jn(a);
}
function hv(e, n) {
  return [{
    year: qa(e, n),
    month: qa(e, n + 1, 1),
    day: qa(e, n + 2, 1)
  }, null, n + 3];
}
function rs(e, n) {
  return [{
    hours: qa(e, n, 0),
    minutes: qa(e, n + 1, 0),
    seconds: qa(e, n + 2, 0),
    milliseconds: yi(e[n + 3])
  }, null, n + 4];
}
function Ns(e, n) {
  const t = !e[n] && !e[n + 1], a = Ll(e[n + 1], e[n + 2]), s = t ? null : zt.instance(a);
  return [{}, s, n + 3];
}
function zs(e, n) {
  const t = e[n] ? Yn.create(e[n]) : null;
  return [{}, t, n + 1];
}
const mv = RegExp(`^T?${wi.source}$`), vv = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function pv(e) {
  const [n, t, a, s, l, r, i, o, u] = e, c = n[0] === "-", f = o && o[0] === "-", p = (d, b = !1) => d !== void 0 && (b || d && c) ? -d : d;
  return [
    {
      years: p(ca(t)),
      months: p(ca(a)),
      weeks: p(ca(s)),
      days: p(ca(l)),
      hours: p(ca(r)),
      minutes: p(ca(i)),
      seconds: p(ca(o), o === "-0"),
      milliseconds: p(yi(u), f)
    }
  ];
}
const gv = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function xi(e, n, t, a, s, l, r) {
  const i = {
    year: n.length === 2 ? qr(Jn(n)) : Jn(n),
    month: Ec.indexOf(t) + 1,
    day: Jn(a),
    hour: Jn(s),
    minute: Jn(l)
  };
  return r && (i.second = Jn(r)), e && (i.weekday = e.length > 3 ? Ac.indexOf(e) + 1 : Pc.indexOf(e) + 1), i;
}
const yv = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function bv(e) {
  const [
    ,
    n,
    t,
    a,
    s,
    l,
    r,
    i,
    o,
    u,
    c,
    f
  ] = e, p = xi(n, s, a, t, l, r, i);
  let d;
  return o ? d = gv[o] : u ? d = 0 : d = Ll(c, f), [p, new zt(d)];
}
function wv(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const kv = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, xv = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, Sv = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function So(e) {
  const [, n, t, a, s, l, r, i] = e;
  return [xi(n, s, a, t, l, r, i), zt.utcInstance];
}
function Tv(e) {
  const [, n, t, a, s, l, r, i] = e;
  return [xi(n, i, t, a, s, l, r), zt.utcInstance];
}
const $v = as(rv, ki), Mv = as(iv, ki), Cv = as(ov, ki), Dv = as(Bc), Yc = ss(
  hv,
  rs,
  Ns,
  zs
), Ov = ss(
  uv,
  rs,
  Ns,
  zs
), _v = ss(
  cv,
  rs,
  Ns,
  zs
), Ev = ss(
  rs,
  Ns,
  zs
);
function Iv(e) {
  return ls(
    e,
    [$v, Yc],
    [Mv, Ov],
    [Cv, _v],
    [Dv, Ev]
  );
}
function Av(e) {
  return ls(wv(e), [yv, bv]);
}
function Pv(e) {
  return ls(
    e,
    [kv, So],
    [xv, So],
    [Sv, Tv]
  );
}
function Rv(e) {
  return ls(e, [vv, pv]);
}
const Fv = ss(rs);
function Vv(e) {
  return ls(e, [mv, Fv]);
}
const Lv = as(dv, fv), Nv = as(Wc), zv = ss(
  rs,
  Ns,
  zs
);
function Bv(e) {
  return ls(
    e,
    [Lv, Yc],
    [Nv, zv]
  );
}
const To = "Invalid Duration", Hc = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, Wv = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...Hc
}, Qt = 146097 / 400, Aa = 146097 / 4800, Yv = {
  years: {
    quarters: 4,
    months: 12,
    weeks: Qt / 7,
    days: Qt,
    hours: Qt * 24,
    minutes: Qt * 24 * 60,
    seconds: Qt * 24 * 60 * 60,
    milliseconds: Qt * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: Qt / 28,
    days: Qt / 4,
    hours: Qt * 24 / 4,
    minutes: Qt * 24 * 60 / 4,
    seconds: Qt * 24 * 60 * 60 / 4,
    milliseconds: Qt * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Aa / 7,
    days: Aa,
    hours: Aa * 24,
    minutes: Aa * 24 * 60,
    seconds: Aa * 24 * 60 * 60,
    milliseconds: Aa * 24 * 60 * 60 * 1e3
  },
  ...Hc
}, pa = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Hv = pa.slice(0).reverse();
function zn(e, n, t = !1) {
  const a = {
    values: t ? n.values : { ...e.values, ...n.values || {} },
    loc: e.loc.clone(n.loc),
    conversionAccuracy: n.conversionAccuracy || e.conversionAccuracy,
    matrix: n.matrix || e.matrix
  };
  return new Je(a);
}
function Uc(e, n) {
  let t = n.milliseconds ?? 0;
  for (const a of Hv.slice(1))
    n[a] && (t += n[a] * e[a].milliseconds);
  return t;
}
function $o(e, n) {
  const t = Uc(e, n) < 0 ? -1 : 1;
  pa.reduceRight((a, s) => {
    if (Be(n[s]))
      return a;
    if (a) {
      const l = n[a] * t, r = e[s][a], i = Math.floor(l / r);
      n[s] += i * t, n[a] -= i * r * t;
    }
    return s;
  }, null), pa.reduce((a, s) => {
    if (Be(n[s]))
      return a;
    if (a) {
      const l = n[a] % 1;
      n[a] -= l, n[s] += l * e[a][s];
    }
    return s;
  }, null);
}
function Mo(e) {
  const n = {};
  for (const [t, a] of Object.entries(e))
    a !== 0 && (n[t] = a);
  return n;
}
class Je {
  /**
   * @private
   */
  constructor(n) {
    const t = n.conversionAccuracy === "longterm" || !1;
    let a = t ? Yv : Wv;
    n.matrix && (a = n.matrix), this.values = n.values, this.loc = n.loc || st.create(), this.conversionAccuracy = t ? "longterm" : "casual", this.invalid = n.invalid || null, this.matrix = a, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(n, t) {
    return Je.fromObject({ milliseconds: n }, t);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(n, t = {}) {
    if (n == null || typeof n != "object")
      throw new Pt(
        `Duration.fromObject: argument expected to be an object, got ${n === null ? "null" : typeof n}`
      );
    return new Je({
      values: Sl(n, Je.normalizeUnit),
      loc: st.fromObject(t),
      conversionAccuracy: t.conversionAccuracy,
      matrix: t.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(n) {
    if (na(n))
      return Je.fromMillis(n);
    if (Je.isDuration(n))
      return n;
    if (typeof n == "object")
      return Je.fromObject(n);
    throw new Pt(
      `Unknown duration argument ${n} of type ${typeof n}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(n, t) {
    const [a] = Rv(n);
    return a ? Je.fromObject(a, t) : Je.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(n, t) {
    const [a] = Vv(n);
    return a ? Je.fromObject(a, t) : Je.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Pt("need to specify a reason the Duration is invalid");
    const a = n instanceof vn ? n : new vn(n, t);
    if (gt.throwOnInvalid)
      throw new pm(a);
    return new Je({ invalid: a });
  }
  /**
   * @private
   */
  static normalizeUnit(n) {
    const t = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[n && n.toLowerCase()];
    if (!t) throw new Qu(n);
    return t;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(n) {
    return n && n.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(n, t = {}) {
    const a = {
      ...t,
      floor: t.round !== !1 && t.floor !== !1
    };
    return this.isValid ? Rt.create(this.loc, a).formatDurationFromString(this, n) : To;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(n = {}) {
    if (!this.isValid) return To;
    const t = n.showZeros !== !1, a = pa.map((s) => {
      const l = this.values[s];
      return Be(l) || l === 0 && !t ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...n, unit: s.slice(0, -1) }).format(l);
    }).filter((s) => s);
    return this.loc.listFormatter({ type: "conjunction", style: n.listStyle || "narrow", ...n }).format(a);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let n = "P";
    return this.years !== 0 && (n += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (n += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (n += this.weeks + "W"), this.days !== 0 && (n += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (n += "T"), this.hours !== 0 && (n += this.hours + "H"), this.minutes !== 0 && (n += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (n += bi(this.seconds + this.milliseconds / 1e3, 3) + "S"), n === "P" && (n += "T0S"), n;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(n = {}) {
    if (!this.isValid) return null;
    const t = this.toMillis();
    return t < 0 || t >= 864e5 ? null : (n = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...n,
      includeOffset: !1
    }, Ee.fromMillis(t, { zone: "UTC" }).toISOTime(n));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? Uc(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n), a = {};
    for (const s of pa)
      (Xa(t.values, s) || Xa(this.values, s)) && (a[s] = t.get(s) + this.get(s));
    return zn(this, { values: a }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n);
    return this.plus(t.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(n) {
    if (!this.isValid) return this;
    const t = {};
    for (const a of Object.keys(this.values))
      t[a] = _c(n(this.values[a], a));
    return zn(this, { values: t }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(n) {
    return this[Je.normalizeUnit(n)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(n) {
    if (!this.isValid) return this;
    const t = { ...this.values, ...Sl(n, Je.normalizeUnit) };
    return zn(this, { values: t });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: n, numberingSystem: t, conversionAccuracy: a, matrix: s } = {}) {
    const r = { loc: this.loc.clone({ locale: n, numberingSystem: t }), matrix: s, conversionAccuracy: a };
    return zn(this, r);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(n) {
    return this.isValid ? this.shiftTo(n).get(n) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const n = this.toObject();
    return $o(this.matrix, n), zn(this, { values: n }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const n = Mo(this.normalize().shiftToAll().toObject());
    return zn(this, { values: n }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...n) {
    if (!this.isValid) return this;
    if (n.length === 0)
      return this;
    n = n.map((r) => Je.normalizeUnit(r));
    const t = {}, a = {}, s = this.toObject();
    let l;
    for (const r of pa)
      if (n.indexOf(r) >= 0) {
        l = r;
        let i = 0;
        for (const u in a)
          i += this.matrix[u][r] * a[u], a[u] = 0;
        na(s[r]) && (i += s[r]);
        const o = Math.trunc(i);
        t[r] = o, a[r] = (i * 1e3 - o * 1e3) / 1e3;
      } else na(s[r]) && (a[r] = s[r]);
    for (const r in a)
      a[r] !== 0 && (t[l] += r === l ? a[r] : a[r] / this.matrix[l][r]);
    return $o(this.matrix, t), zn(this, { values: t }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const n = {};
    for (const t of Object.keys(this.values))
      n[t] = this.values[t] === 0 ? 0 : -this.values[t];
    return zn(this, { values: n }, !0);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const n = Mo(this.values);
    return zn(this, { values: n }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(n) {
    if (!this.isValid || !n.isValid || !this.loc.equals(n.loc))
      return !1;
    function t(a, s) {
      return a === void 0 || a === 0 ? s === void 0 || s === 0 : a === s;
    }
    for (const a of pa)
      if (!t(this.values[a], n.values[a]))
        return !1;
    return !0;
  }
}
const Pa = "Invalid Interval";
function Uv(e, n) {
  return !e || !e.isValid ? pt.invalid("missing or invalid start") : !n || !n.isValid ? pt.invalid("missing or invalid end") : n < e ? pt.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${n.toISO()}`
  ) : null;
}
class pt {
  /**
   * @private
   */
  constructor(n) {
    this.s = n.start, this.e = n.end, this.invalid = n.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Pt("need to specify a reason the Interval is invalid");
    const a = n instanceof vn ? n : new vn(n, t);
    if (gt.throwOnInvalid)
      throw new vm(a);
    return new pt({ invalid: a });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(n, t) {
    const a = vs(n), s = vs(t), l = Uv(a, s);
    return l ?? new pt({
      start: a,
      end: s
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(n, t) {
    const a = Je.fromDurationLike(t), s = vs(n);
    return pt.fromDateTimes(s, s.plus(a));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(n, t) {
    const a = Je.fromDurationLike(t), s = vs(n);
    return pt.fromDateTimes(s.minus(a), s);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(n, t) {
    const [a, s] = (n || "").split("/", 2);
    if (a && s) {
      let l, r;
      try {
        l = Ee.fromISO(a, t), r = l.isValid;
      } catch {
        r = !1;
      }
      let i, o;
      try {
        i = Ee.fromISO(s, t), o = i.isValid;
      } catch {
        o = !1;
      }
      if (r && o)
        return pt.fromDateTimes(l, i);
      if (r) {
        const u = Je.fromISO(s, t);
        if (u.isValid)
          return pt.after(l, u);
      } else if (o) {
        const u = Je.fromISO(a, t);
        if (u.isValid)
          return pt.before(i, u);
      }
    }
    return pt.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(n) {
    return n && n.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(n = "milliseconds") {
    return this.isValid ? this.toDuration(n).get(n) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(n = "milliseconds", t) {
    if (!this.isValid) return NaN;
    const a = this.start.startOf(n, t);
    let s;
    return t != null && t.useLocaleWeeks ? s = this.end.reconfigure({ locale: a.locale }) : s = this.end, s = s.startOf(n, t), Math.floor(s.diff(a, n).get(n)) + (s.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(n) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, n) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(n) {
    return this.isValid ? this.s > n : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(n) {
    return this.isValid ? this.e <= n : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(n) {
    return this.isValid ? this.s <= n && this.e > n : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: n, end: t } = {}) {
    return this.isValid ? pt.fromDateTimes(n || this.s, t || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...n) {
    if (!this.isValid) return [];
    const t = n.map(vs).filter((r) => this.contains(r)).sort((r, i) => r.toMillis() - i.toMillis()), a = [];
    let { s } = this, l = 0;
    for (; s < this.e; ) {
      const r = t[l] || this.e, i = +r > +this.e ? this.e : r;
      a.push(pt.fromDateTimes(s, i)), s = i, l += 1;
    }
    return a;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(n) {
    const t = Je.fromDurationLike(n);
    if (!this.isValid || !t.isValid || t.as("milliseconds") === 0)
      return [];
    let { s: a } = this, s = 1, l;
    const r = [];
    for (; a < this.e; ) {
      const i = this.start.plus(t.mapUnits((o) => o * s));
      l = +i > +this.e ? this.e : i, r.push(pt.fromDateTimes(a, l)), a = l, s += 1;
    }
    return r;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(n) {
    return this.isValid ? this.splitBy(this.length() / n).slice(0, n) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(n) {
    return this.e > n.s && this.s < n.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(n) {
    return this.isValid ? +this.e == +n.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(n) {
    return this.isValid ? +n.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(n) {
    return this.isValid ? this.s <= n.s && this.e >= n.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(n) {
    return !this.isValid || !n.isValid ? !1 : this.s.equals(n.s) && this.e.equals(n.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(n) {
    if (!this.isValid) return this;
    const t = this.s > n.s ? this.s : n.s, a = this.e < n.e ? this.e : n.e;
    return t >= a ? null : pt.fromDateTimes(t, a);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(n) {
    if (!this.isValid) return this;
    const t = this.s < n.s ? this.s : n.s, a = this.e > n.e ? this.e : n.e;
    return pt.fromDateTimes(t, a);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(n) {
    const [t, a] = n.sort((s, l) => s.s - l.s).reduce(
      ([s, l], r) => l ? l.overlaps(r) || l.abutsStart(r) ? [s, l.union(r)] : [s.concat([l]), r] : [s, r],
      [[], null]
    );
    return a && t.push(a), t;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(n) {
    let t = null, a = 0;
    const s = [], l = n.map((o) => [
      { time: o.s, type: "s" },
      { time: o.e, type: "e" }
    ]), r = Array.prototype.concat(...l), i = r.sort((o, u) => o.time - u.time);
    for (const o of i)
      a += o.type === "s" ? 1 : -1, a === 1 ? t = o.time : (t && +t != +o.time && s.push(pt.fromDateTimes(t, o.time)), t = null);
    return pt.merge(s);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...n) {
    return pt.xor([this].concat(n)).map((t) => this.intersection(t)).filter((t) => t && !t.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Pa;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(n = wl, t = {}) {
    return this.isValid ? Rt.create(this.s.loc.clone(t), n).formatInterval(this) : Pa;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(n) {
    return this.isValid ? `${this.s.toISO(n)}/${this.e.toISO(n)}` : Pa;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Pa;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(n) {
    return this.isValid ? `${this.s.toISOTime(n)}/${this.e.toISOTime(n)}` : Pa;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(n, { separator: t = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(n)}${t}${this.e.toFormat(n)}` : Pa;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(n, t) {
    return this.isValid ? this.e.diff(this.s, n, t) : Je.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(n) {
    return pt.fromDateTimes(n(this.s), n(this.e));
  }
}
class nl {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(n = gt.defaultZone) {
    const t = Ee.now().setZone(n).set({ month: 12 });
    return !n.isUniversal && t.offset !== t.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(n) {
    return Yn.isValidZone(n);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(n) {
    return Qn(n, gt.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null, outputCalendar: l = "gregory" } = {}) {
    return (s || st.create(t, a, l)).months(n);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null, outputCalendar: l = "gregory" } = {}) {
    return (s || st.create(t, a, l)).months(n, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null } = {}) {
    return (s || st.create(t, a, null)).weekdays(n);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null } = {}) {
    return (s || st.create(t, a, null)).weekdays(n, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: n = null } = {}) {
    return st.create(n).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(n = "short", { locale: t = null } = {}) {
    return st.create(t, null, "gregory").eras(n);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: Cc(), localeWeek: Dc() };
  }
}
function Co(e, n) {
  const t = (s) => s.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), a = t(n) - t(e);
  return Math.floor(Je.fromMillis(a).as("days"));
}
function qv(e, n, t) {
  const a = [
    ["years", (o, u) => u.year - o.year],
    ["quarters", (o, u) => u.quarter - o.quarter + (u.year - o.year) * 4],
    ["months", (o, u) => u.month - o.month + (u.year - o.year) * 12],
    [
      "weeks",
      (o, u) => {
        const c = Co(o, u);
        return (c - c % 7) / 7;
      }
    ],
    ["days", Co]
  ], s = {}, l = e;
  let r, i;
  for (const [o, u] of a)
    t.indexOf(o) >= 0 && (r = o, s[o] = u(e, n), i = l.plus(s), i > n ? (s[o]--, e = l.plus(s), e > n && (i = e, s[o]--, e = l.plus(s))) : e = i);
  return [e, s, i, r];
}
function jv(e, n, t, a) {
  let [s, l, r, i] = qv(e, n, t);
  const o = n - s, u = t.filter(
    (f) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(f) >= 0
  );
  u.length === 0 && (r < n && (r = s.plus({ [i]: 1 })), r !== s && (l[i] = (l[i] || 0) + o / (r - s)));
  const c = Je.fromObject(l, a);
  return u.length > 0 ? Je.fromMillis(o, a).shiftTo(...u).plus(c) : c;
}
const Gv = "missing Intl.DateTimeFormat.formatToParts support";
function nt(e, n = (t) => t) {
  return { regex: e, deser: ([t]) => n(Lm(t)) };
}
const Kv = " ", qc = `[ ${Kv}]`, jc = new RegExp(qc, "g");
function Zv(e) {
  return e.replace(/\./g, "\\.?").replace(jc, qc);
}
function Do(e) {
  return e.replace(/\./g, "").replace(jc, " ").toLowerCase();
}
function dn(e, n) {
  return e === null ? null : {
    regex: RegExp(e.map(Zv).join("|")),
    deser: ([t]) => e.findIndex((a) => Do(t) === Do(a)) + n
  };
}
function Oo(e, n) {
  return { regex: e, deser: ([, t, a]) => Ll(t, a), groups: n };
}
function al(e) {
  return { regex: e, deser: ([n]) => n };
}
function Xv(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Jv(e, n) {
  const t = cn(n), a = cn(n, "{2}"), s = cn(n, "{3}"), l = cn(n, "{4}"), r = cn(n, "{6}"), i = cn(n, "{1,2}"), o = cn(n, "{1,3}"), u = cn(n, "{1,6}"), c = cn(n, "{1,9}"), f = cn(n, "{2,4}"), p = cn(n, "{4,6}"), d = (k) => ({ regex: RegExp(Xv(k.val)), deser: ([y]) => y, literal: !0 }), m = ((k) => {
    if (e.literal)
      return d(k);
    switch (k.val) {
      // era
      case "G":
        return dn(n.eras("short"), 0);
      case "GG":
        return dn(n.eras("long"), 0);
      // years
      case "y":
        return nt(u);
      case "yy":
        return nt(f, qr);
      case "yyyy":
        return nt(l);
      case "yyyyy":
        return nt(p);
      case "yyyyyy":
        return nt(r);
      // months
      case "M":
        return nt(i);
      case "MM":
        return nt(a);
      case "MMM":
        return dn(n.months("short", !0), 1);
      case "MMMM":
        return dn(n.months("long", !0), 1);
      case "L":
        return nt(i);
      case "LL":
        return nt(a);
      case "LLL":
        return dn(n.months("short", !1), 1);
      case "LLLL":
        return dn(n.months("long", !1), 1);
      // dates
      case "d":
        return nt(i);
      case "dd":
        return nt(a);
      // ordinals
      case "o":
        return nt(o);
      case "ooo":
        return nt(s);
      // time
      case "HH":
        return nt(a);
      case "H":
        return nt(i);
      case "hh":
        return nt(a);
      case "h":
        return nt(i);
      case "mm":
        return nt(a);
      case "m":
        return nt(i);
      case "q":
        return nt(i);
      case "qq":
        return nt(a);
      case "s":
        return nt(i);
      case "ss":
        return nt(a);
      case "S":
        return nt(o);
      case "SSS":
        return nt(s);
      case "u":
        return al(c);
      case "uu":
        return al(i);
      case "uuu":
        return nt(t);
      // meridiem
      case "a":
        return dn(n.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return nt(l);
      case "kk":
        return nt(f, qr);
      // weekNumber (W)
      case "W":
        return nt(i);
      case "WW":
        return nt(a);
      // weekdays
      case "E":
      case "c":
        return nt(t);
      case "EEE":
        return dn(n.weekdays("short", !1), 1);
      case "EEEE":
        return dn(n.weekdays("long", !1), 1);
      case "ccc":
        return dn(n.weekdays("short", !0), 1);
      case "cccc":
        return dn(n.weekdays("long", !0), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return Oo(new RegExp(`([+-]${i.source})(?::(${a.source}))?`), 2);
      case "ZZZ":
        return Oo(new RegExp(`([+-]${i.source})(${a.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return al(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return al(/[^\S\n\r]/);
      default:
        return d(k);
    }
  })(e) || {
    invalidReason: Gv
  };
  return m.token = e, m;
}
const Qv = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function ep(e, n, t) {
  const { type: a, value: s } = e;
  if (a === "literal") {
    const o = /^\s+$/.test(s);
    return {
      literal: !o,
      val: o ? " " : s
    };
  }
  const l = n[a];
  let r = a;
  a === "hour" && (n.hour12 != null ? r = n.hour12 ? "hour12" : "hour24" : n.hourCycle != null ? n.hourCycle === "h11" || n.hourCycle === "h12" ? r = "hour12" : r = "hour24" : r = t.hour12 ? "hour12" : "hour24");
  let i = Qv[r];
  if (typeof i == "object" && (i = i[l]), i)
    return {
      literal: !1,
      val: i
    };
}
function tp(e) {
  return [`^${e.map((t) => t.regex).reduce((t, a) => `${t}(${a.source})`, "")}$`, e];
}
function np(e, n, t) {
  const a = e.match(n);
  if (a) {
    const s = {};
    let l = 1;
    for (const r in t)
      if (Xa(t, r)) {
        const i = t[r], o = i.groups ? i.groups + 1 : 1;
        !i.literal && i.token && (s[i.token.val[0]] = i.deser(a.slice(l, l + o))), l += o;
      }
    return [a, s];
  } else
    return [a, {}];
}
function ap(e) {
  const n = (l) => {
    switch (l) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let t = null, a;
  return Be(e.z) || (t = Yn.create(e.z)), Be(e.Z) || (t || (t = new zt(e.Z)), a = e.Z), Be(e.q) || (e.M = (e.q - 1) * 3 + 1), Be(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), Be(e.u) || (e.S = yi(e.u)), [Object.keys(e).reduce((l, r) => {
    const i = n(r);
    return i && (l[i] = e[r]), l;
  }, {}), t, a];
}
let fr = null;
function sp() {
  return fr || (fr = Ee.fromMillis(1555555555555)), fr;
}
function lp(e, n) {
  if (e.literal)
    return e;
  const t = Rt.macroTokenToFormatOpts(e.val), a = Xc(t, n);
  return a == null || a.includes(void 0) ? e : a;
}
function Gc(e, n) {
  return Array.prototype.concat(...e.map((t) => lp(t, n)));
}
class Kc {
  constructor(n, t) {
    if (this.locale = n, this.format = t, this.tokens = Gc(Rt.parseFormat(t), n), this.units = this.tokens.map((a) => Jv(a, n)), this.disqualifyingUnit = this.units.find((a) => a.invalidReason), !this.disqualifyingUnit) {
      const [a, s] = tp(this.units);
      this.regex = RegExp(a, "i"), this.handlers = s;
    }
  }
  explainFromTokens(n) {
    if (this.isValid) {
      const [t, a] = np(n, this.regex, this.handlers), [s, l, r] = a ? ap(a) : [null, null, void 0];
      if (Xa(a, "a") && Xa(a, "H"))
        throw new Ba(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: n,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: t,
        matches: a,
        result: s,
        zone: l,
        specificOffset: r
      };
    } else
      return { input: n, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function Zc(e, n, t) {
  return new Kc(e, t).explainFromTokens(n);
}
function rp(e, n, t) {
  const { result: a, zone: s, specificOffset: l, invalidReason: r } = Zc(e, n, t);
  return [a, s, l, r];
}
function Xc(e, n) {
  if (!e)
    return null;
  const a = Rt.create(n, e).dtFormatter(sp()), s = a.formatToParts(), l = a.resolvedOptions();
  return s.map((r) => ep(r, e, l));
}
const hr = "Invalid DateTime", _o = 864e13;
function Ss(e) {
  return new vn("unsupported zone", `the zone "${e.name}" is not supported`);
}
function mr(e) {
  return e.weekData === null && (e.weekData = kl(e.c)), e.weekData;
}
function vr(e) {
  return e.localWeekData === null && (e.localWeekData = kl(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function da(e, n) {
  const t = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new Ee({ ...t, ...n, old: t });
}
function Jc(e, n, t) {
  let a = e - n * 60 * 1e3;
  const s = t.offset(a);
  if (n === s)
    return [a, n];
  a -= (s - n) * 60 * 1e3;
  const l = t.offset(a);
  return s === l ? [a, s] : [e - Math.min(s, l) * 60 * 1e3, Math.max(s, l)];
}
function sl(e, n) {
  e += n * 60 * 1e3;
  const t = new Date(e);
  return {
    year: t.getUTCFullYear(),
    month: t.getUTCMonth() + 1,
    day: t.getUTCDate(),
    hour: t.getUTCHours(),
    minute: t.getUTCMinutes(),
    second: t.getUTCSeconds(),
    millisecond: t.getUTCMilliseconds()
  };
}
function vl(e, n, t) {
  return Jc(Vl(e), n, t);
}
function Eo(e, n) {
  const t = e.o, a = e.c.year + Math.trunc(n.years), s = e.c.month + Math.trunc(n.months) + Math.trunc(n.quarters) * 3, l = {
    ...e.c,
    year: a,
    month: s,
    day: Math.min(e.c.day, xl(a, s)) + Math.trunc(n.days) + Math.trunc(n.weeks) * 7
  }, r = Je.fromObject({
    years: n.years - Math.trunc(n.years),
    quarters: n.quarters - Math.trunc(n.quarters),
    months: n.months - Math.trunc(n.months),
    weeks: n.weeks - Math.trunc(n.weeks),
    days: n.days - Math.trunc(n.days),
    hours: n.hours,
    minutes: n.minutes,
    seconds: n.seconds,
    milliseconds: n.milliseconds
  }).as("milliseconds"), i = Vl(l);
  let [o, u] = Jc(i, t, e.zone);
  return r !== 0 && (o += r, u = e.zone.offset(o)), { ts: o, o: u };
}
function Ra(e, n, t, a, s, l) {
  const { setZone: r, zone: i } = t;
  if (e && Object.keys(e).length !== 0 || n) {
    const o = n || i, u = Ee.fromObject(e, {
      ...t,
      zone: o,
      specificOffset: l
    });
    return r ? u : u.setZone(i);
  } else
    return Ee.invalid(
      new vn("unparsable", `the input "${s}" can't be parsed as ${a}`)
    );
}
function ll(e, n, t = !0) {
  return e.isValid ? Rt.create(st.create("en-US"), {
    allowZ: t,
    forceSimple: !0
  }).formatDateTimeFromString(e, n) : null;
}
function pr(e, n, t) {
  const a = e.c.year > 9999 || e.c.year < 0;
  let s = "";
  if (a && e.c.year >= 0 && (s += "+"), s += $t(e.c.year, a ? 6 : 4), t === "year") return s;
  if (n) {
    if (s += "-", s += $t(e.c.month), t === "month") return s;
    s += "-";
  } else if (s += $t(e.c.month), t === "month") return s;
  return s += $t(e.c.day), s;
}
function Io(e, n, t, a, s, l, r) {
  let i = !t || e.c.millisecond !== 0 || e.c.second !== 0, o = "";
  switch (r) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      if (o += $t(e.c.hour), r === "hour") break;
      if (n) {
        if (o += ":", o += $t(e.c.minute), r === "minute") break;
        i && (o += ":", o += $t(e.c.second));
      } else {
        if (o += $t(e.c.minute), r === "minute") break;
        i && (o += $t(e.c.second));
      }
      if (r === "second") break;
      i && (!a || e.c.millisecond !== 0) && (o += ".", o += $t(e.c.millisecond, 3));
  }
  return s && (e.isOffsetFixed && e.offset === 0 && !l ? o += "Z" : e.o < 0 ? (o += "-", o += $t(Math.trunc(-e.o / 60)), o += ":", o += $t(Math.trunc(-e.o % 60))) : (o += "+", o += $t(Math.trunc(e.o / 60)), o += ":", o += $t(Math.trunc(e.o % 60)))), l && (o += "[" + e.zone.ianaName + "]"), o;
}
const Qc = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ip = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, op = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, pl = ["year", "month", "day", "hour", "minute", "second", "millisecond"], up = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], cp = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function gl(e) {
  const n = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!n) throw new Qu(e);
  return n;
}
function Ao(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return gl(e);
  }
}
function dp(e) {
  if (Ts === void 0 && (Ts = gt.now()), e.type !== "iana")
    return e.offset(Ts);
  const n = e.name;
  let t = jr.get(n);
  return t === void 0 && (t = e.offset(Ts), jr.set(n, t)), t;
}
function Po(e, n) {
  const t = Qn(n.zone, gt.defaultZone);
  if (!t.isValid)
    return Ee.invalid(Ss(t));
  const a = st.fromObject(n);
  let s, l;
  if (Be(e.year))
    s = gt.now();
  else {
    for (const o of pl)
      Be(e[o]) && (e[o] = Qc[o]);
    const r = $c(e) || Mc(e);
    if (r)
      return Ee.invalid(r);
    const i = dp(t);
    [s, l] = vl(e, i, t);
  }
  return new Ee({ ts: s, zone: t, loc: a, o: l });
}
function Ro(e, n, t) {
  const a = Be(t.round) ? !0 : t.round, s = Be(t.rounding) ? "trunc" : t.rounding, l = (i, o) => (i = bi(i, a || t.calendary ? 0 : 2, t.calendary ? "round" : s), n.loc.clone(t).relFormatter(t).format(i, o)), r = (i) => t.calendary ? n.hasSame(e, i) ? 0 : n.startOf(i).diff(e.startOf(i), i).get(i) : n.diff(e, i).get(i);
  if (t.unit)
    return l(r(t.unit), t.unit);
  for (const i of t.units) {
    const o = r(i);
    if (Math.abs(o) >= 1)
      return l(o, i);
  }
  return l(e > n ? -0 : 0, t.units[t.units.length - 1]);
}
function Fo(e) {
  let n = {}, t;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (n = e[e.length - 1], t = Array.from(e).slice(0, e.length - 1)) : t = Array.from(e), [n, t];
}
let Ts;
const jr = /* @__PURE__ */ new Map();
class Ee {
  /**
   * @access private
   */
  constructor(n) {
    const t = n.zone || gt.defaultZone;
    let a = n.invalid || (Number.isNaN(n.ts) ? new vn("invalid input") : null) || (t.isValid ? null : Ss(t));
    this.ts = Be(n.ts) ? gt.now() : n.ts;
    let s = null, l = null;
    if (!a)
      if (n.old && n.old.ts === this.ts && n.old.zone.equals(t))
        [s, l] = [n.old.c, n.old.o];
      else {
        const i = na(n.o) && !n.old ? n.o : t.offset(this.ts);
        s = sl(this.ts, i), a = Number.isNaN(s.year) ? new vn("invalid input") : null, s = a ? null : s, l = a ? null : i;
      }
    this._zone = t, this.loc = n.loc || st.create(), this.invalid = a, this.weekData = null, this.localWeekData = null, this.c = s, this.o = l, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new Ee({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [n, t] = Fo(arguments), [a, s, l, r, i, o, u] = t;
    return Po({ year: a, month: s, day: l, hour: r, minute: i, second: o, millisecond: u }, n);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [n, t] = Fo(arguments), [a, s, l, r, i, o, u] = t;
    return n.zone = zt.utcInstance, Po({ year: a, month: s, day: l, hour: r, minute: i, second: o, millisecond: u }, n);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(n, t = {}) {
    const a = Ym(n) ? n.valueOf() : NaN;
    if (Number.isNaN(a))
      return Ee.invalid("invalid input");
    const s = Qn(t.zone, gt.defaultZone);
    return s.isValid ? new Ee({
      ts: a,
      zone: s,
      loc: st.fromObject(t)
    }) : Ee.invalid(Ss(s));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(n, t = {}) {
    if (na(n))
      return n < -_o || n > _o ? Ee.invalid("Timestamp out of range") : new Ee({
        ts: n,
        zone: Qn(t.zone, gt.defaultZone),
        loc: st.fromObject(t)
      });
    throw new Pt(
      `fromMillis requires a numerical input, but received a ${typeof n} with value ${n}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(n, t = {}) {
    if (na(n))
      return new Ee({
        ts: n * 1e3,
        zone: Qn(t.zone, gt.defaultZone),
        loc: st.fromObject(t)
      });
    throw new Pt("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(n, t = {}) {
    n = n || {};
    const a = Qn(t.zone, gt.defaultZone);
    if (!a.isValid)
      return Ee.invalid(Ss(a));
    const s = st.fromObject(t), l = Sl(n, Ao), { minDaysInFirstWeek: r, startOfWeek: i } = bo(l, s), o = gt.now(), u = Be(t.specificOffset) ? a.offset(o) : t.specificOffset, c = !Be(l.ordinal), f = !Be(l.year), p = !Be(l.month) || !Be(l.day), d = f || p, b = l.weekYear || l.weekNumber;
    if ((d || c) && b)
      throw new Ba(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (p && c)
      throw new Ba("Can't mix ordinal dates with month/day");
    const m = b || l.weekday && !d;
    let k, y, h = sl(o, u);
    m ? (k = up, y = ip, h = kl(h, r, i)) : c ? (k = cp, y = op, h = dr(h)) : (k = pl, y = Qc);
    let g = !1;
    for (const D of k) {
      const B = l[D];
      Be(B) ? g ? l[D] = y[D] : l[D] = h[D] : g = !0;
    }
    const x = m ? zm(l, r, i) : c ? Bm(l) : $c(l), S = x || Mc(l);
    if (S)
      return Ee.invalid(S);
    const C = m ? go(l, r, i) : c ? yo(l) : l, [_, O] = vl(C, u, a), I = new Ee({
      ts: _,
      zone: a,
      o: O,
      loc: s
    });
    return l.weekday && d && n.weekday !== I.weekday ? Ee.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${l.weekday} and a date of ${I.toISO()}`
    ) : I.isValid ? I : Ee.invalid(I.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(n, t = {}) {
    const [a, s] = Iv(n);
    return Ra(a, s, t, "ISO 8601", n);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(n, t = {}) {
    const [a, s] = Av(n);
    return Ra(a, s, t, "RFC 2822", n);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(n, t = {}) {
    const [a, s] = Pv(n);
    return Ra(a, s, t, "HTTP", t);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(n, t, a = {}) {
    if (Be(n) || Be(t))
      throw new Pt("fromFormat requires an input string and a format");
    const { locale: s = null, numberingSystem: l = null } = a, r = st.fromOpts({
      locale: s,
      numberingSystem: l,
      defaultToEN: !0
    }), [i, o, u, c] = rp(r, n, t);
    return c ? Ee.invalid(c) : Ra(i, o, a, `format ${t}`, n, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(n, t, a = {}) {
    return Ee.fromFormat(n, t, a);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(n, t = {}) {
    const [a, s] = Bv(n);
    return Ra(a, s, t, "SQL", n);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Pt("need to specify a reason the DateTime is invalid");
    const a = n instanceof vn ? n : new vn(n, t);
    if (gt.throwOnInvalid)
      throw new mm(a);
    return new Ee({ invalid: a });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(n) {
    return n && n.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(n, t = {}) {
    const a = Xc(n, st.fromObject(t));
    return a ? a.map((s) => s ? s.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(n, t = {}) {
    return Gc(Rt.parseFormat(n), st.fromObject(t)).map((s) => s.val).join("");
  }
  static resetCache() {
    Ts = void 0, jr.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(n) {
    return this[n];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? mr(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? mr(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? mr(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? vr(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? vr(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? vr(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? dr(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? nl.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? nl.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? nl.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? nl.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const n = 864e5, t = 6e4, a = Vl(this.c), s = this.zone.offset(a - n), l = this.zone.offset(a + n), r = this.zone.offset(a - s * t), i = this.zone.offset(a - l * t);
    if (r === i)
      return [this];
    const o = a - r * t, u = a - i * t, c = sl(o, r), f = sl(u, i);
    return c.hour === f.hour && c.minute === f.minute && c.second === f.second && c.millisecond === f.millisecond ? [da(this, { ts: o }), da(this, { ts: u })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Ls(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return xl(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Ua(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? As(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? As(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(n = {}) {
    const { locale: t, numberingSystem: a, calendar: s } = Rt.create(
      this.loc.clone(n),
      n
    ).resolvedOptions(this);
    return { locale: t, numberingSystem: a, outputCalendar: s };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(n = 0, t = {}) {
    return this.setZone(zt.instance(n), t);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(gt.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(n, { keepLocalTime: t = !1, keepCalendarTime: a = !1 } = {}) {
    if (n = Qn(n, gt.defaultZone), n.equals(this.zone))
      return this;
    if (n.isValid) {
      let s = this.ts;
      if (t || a) {
        const l = n.offset(this.ts), r = this.toObject();
        [s] = vl(r, l, n);
      }
      return da(this, { ts: s, zone: n });
    } else
      return Ee.invalid(Ss(n));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: n, numberingSystem: t, outputCalendar: a } = {}) {
    const s = this.loc.clone({ locale: n, numberingSystem: t, outputCalendar: a });
    return da(this, { loc: s });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(n) {
    return this.reconfigure({ locale: n });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(n) {
    if (!this.isValid) return this;
    const t = Sl(n, Ao), { minDaysInFirstWeek: a, startOfWeek: s } = bo(t, this.loc), l = !Be(t.weekYear) || !Be(t.weekNumber) || !Be(t.weekday), r = !Be(t.ordinal), i = !Be(t.year), o = !Be(t.month) || !Be(t.day), u = i || o, c = t.weekYear || t.weekNumber;
    if ((u || r) && c)
      throw new Ba(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (o && r)
      throw new Ba("Can't mix ordinal dates with month/day");
    let f;
    l ? f = go(
      { ...kl(this.c, a, s), ...t },
      a,
      s
    ) : Be(t.ordinal) ? (f = { ...this.toObject(), ...t }, Be(t.day) && (f.day = Math.min(xl(f.year, f.month), f.day))) : f = yo({ ...dr(this.c), ...t });
    const [p, d] = vl(f, this.o, this.zone);
    return da(this, { ts: p, o: d });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n);
    return da(this, Eo(this, t));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n).negate();
    return da(this, Eo(this, t));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(n, { useLocaleWeeks: t = !1 } = {}) {
    if (!this.isValid) return this;
    const a = {}, s = Je.normalizeUnit(n);
    switch (s) {
      case "years":
        a.month = 1;
      // falls through
      case "quarters":
      case "months":
        a.day = 1;
      // falls through
      case "weeks":
      case "days":
        a.hour = 0;
      // falls through
      case "hours":
        a.minute = 0;
      // falls through
      case "minutes":
        a.second = 0;
      // falls through
      case "seconds":
        a.millisecond = 0;
        break;
    }
    if (s === "weeks")
      if (t) {
        const l = this.loc.getStartOfWeek(), { weekday: r } = this;
        r < l && (a.weekNumber = this.weekNumber - 1), a.weekday = l;
      } else
        a.weekday = 1;
    if (s === "quarters") {
      const l = Math.ceil(this.month / 3);
      a.month = (l - 1) * 3 + 1;
    }
    return this.set(a);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(n, t) {
    return this.isValid ? this.plus({ [n]: 1 }).startOf(n, t).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(n, t = {}) {
    return this.isValid ? Rt.create(this.loc.redefaultToEN(t)).formatDateTimeFromString(this, n) : hr;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(n = wl, t = {}) {
    return this.isValid ? Rt.create(this.loc.clone(t), n).formatDateTime(this) : hr;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(n = {}) {
    return this.isValid ? Rt.create(this.loc.clone(n), n).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format: n = "extended",
    suppressSeconds: t = !1,
    suppressMilliseconds: a = !1,
    includeOffset: s = !0,
    extendedZone: l = !1,
    precision: r = "milliseconds"
  } = {}) {
    if (!this.isValid)
      return null;
    r = gl(r);
    const i = n === "extended";
    let o = pr(this, i, r);
    return pl.indexOf(r) >= 3 && (o += "T"), o += Io(
      this,
      i,
      t,
      a,
      s,
      l,
      r
    ), o;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format: n = "extended", precision: t = "day" } = {}) {
    return this.isValid ? pr(this, n === "extended", gl(t)) : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return ll(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: n = !1,
    suppressSeconds: t = !1,
    includeOffset: a = !0,
    includePrefix: s = !1,
    extendedZone: l = !1,
    format: r = "extended",
    precision: i = "milliseconds"
  } = {}) {
    return this.isValid ? (i = gl(i), (s && pl.indexOf(i) >= 3 ? "T" : "") + Io(
      this,
      r === "extended",
      t,
      n,
      a,
      l,
      i
    )) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return ll(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return ll(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    return this.isValid ? pr(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: n = !0, includeZone: t = !1, includeOffsetSpace: a = !0 } = {}) {
    let s = "HH:mm:ss.SSS";
    return (t || n) && (a && (s += " "), t ? s += "z" : n && (s += "ZZ")), ll(this, s, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(n = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(n)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : hr;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(n = {}) {
    if (!this.isValid) return {};
    const t = { ...this.c };
    return n.includeConfig && (t.outputCalendar = this.outputCalendar, t.numberingSystem = this.loc.numberingSystem, t.locale = this.loc.locale), t;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(n, t = "milliseconds", a = {}) {
    if (!this.isValid || !n.isValid)
      return Je.invalid("created by diffing an invalid DateTime");
    const s = { locale: this.locale, numberingSystem: this.numberingSystem, ...a }, l = Hm(t).map(Je.normalizeUnit), r = n.valueOf() > this.valueOf(), i = r ? this : n, o = r ? n : this, u = jv(i, o, l, s);
    return r ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(n = "milliseconds", t = {}) {
    return this.diff(Ee.now(), n, t);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(n) {
    return this.isValid ? pt.fromDateTimes(this, n) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(n, t, a) {
    if (!this.isValid) return !1;
    const s = n.valueOf(), l = this.setZone(n.zone, { keepLocalTime: !0 });
    return l.startOf(t, a) <= s && s <= l.endOf(t, a);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(n) {
    return this.isValid && n.isValid && this.valueOf() === n.valueOf() && this.zone.equals(n.zone) && this.loc.equals(n.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(n = {}) {
    if (!this.isValid) return null;
    const t = n.base || Ee.fromObject({}, { zone: this.zone }), a = n.padding ? this < t ? -n.padding : n.padding : 0;
    let s = ["years", "months", "days", "hours", "minutes", "seconds"], l = n.unit;
    return Array.isArray(n.unit) && (s = n.unit, l = void 0), Ro(t, this.plus(a), {
      ...n,
      numeric: "always",
      units: s,
      unit: l
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(n = {}) {
    return this.isValid ? Ro(n.base || Ee.fromObject({}, { zone: this.zone }), this, {
      ...n,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...n) {
    if (!n.every(Ee.isDateTime))
      throw new Pt("min requires all arguments be DateTimes");
    return wo(n, (t) => t.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...n) {
    if (!n.every(Ee.isDateTime))
      throw new Pt("max requires all arguments be DateTimes");
    return wo(n, (t) => t.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(n, t, a = {}) {
    const { locale: s = null, numberingSystem: l = null } = a, r = st.fromOpts({
      locale: s,
      numberingSystem: l,
      defaultToEN: !0
    });
    return Zc(r, n, t);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(n, t, a = {}) {
    return Ee.fromFormatExplain(n, t, a);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(n, t = {}) {
    const { locale: a = null, numberingSystem: s = null } = t, l = st.fromOpts({
      locale: a,
      numberingSystem: s,
      defaultToEN: !0
    });
    return new Kc(l, n);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(n, t, a = {}) {
    if (Be(n) || Be(t))
      throw new Pt(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: s = null, numberingSystem: l = null } = a, r = st.fromOpts({
      locale: s,
      numberingSystem: l,
      defaultToEN: !0
    });
    if (!r.equals(t.locale))
      throw new Pt(
        `fromFormatParser called with a locale of ${r}, but the format parser was created for ${t.locale}`
      );
    const { result: i, zone: o, specificOffset: u, invalidReason: c } = t.explainFromTokens(n);
    return c ? Ee.invalid(c) : Ra(
      i,
      o,
      a,
      `format ${t.format}`,
      n,
      u
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return wl;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return ec;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return gm;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return tc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return nc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return ac;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return sc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return lc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return rc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return ic;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return oc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return uc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return cc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return dc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return fc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return hc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return mc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return ym;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return vc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return pc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return gc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return yc;
  }
}
function vs(e) {
  if (Ee.isDateTime(e))
    return e;
  if (e && e.valueOf && na(e.valueOf()))
    return Ee.fromJSDate(e);
  if (e && typeof e == "object")
    return Ee.fromObject(e);
  throw new Pt(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
const fp = ["datetime", "title"], hp = {
  key: 1,
  class: "text-secondaryText"
}, mp = /* @__PURE__ */ ke({
  __name: "VDate",
  props: {
    value: { default: null },
    format: { default: "MM/dd/yyyy, h:mm a" },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = T(() => {
      if (!e.value) return null;
      const s = Ee.fromISO(e.value).toLocal();
      return s.isValid ? s : null;
    }), t = T(() => {
      var s;
      return ((s = n.value) == null ? void 0 : s.toFormat(e.format)) ?? "—";
    }), a = T(() => {
      if (!e.value) return;
      const s = Ee.fromISO(e.value, { zone: "utc" });
      return s.isValid ? `${s.toFormat("yyyy-MM-dd HH:mm:ss")} UTC` : e.value;
    });
    return (s, l) => e.value ? (w(), M("time", {
      key: 0,
      datetime: e.value,
      title: a.value,
      class: q({ "v-date--modern": e.modern })
    }, re(t.value), 11, fp)) : (w(), M("span", hp, "—"));
  }
}), rD = /* @__PURE__ */ ze(mp, [["__scopeId", "data-v-dd18eb20"]]), vp = ["id", "disabled", "value"], pp = ["for"], gp = /* @__PURE__ */ ke({
  __name: "VCheckbox",
  props: {
    modelValue: { type: [Boolean, Array] },
    id: {},
    label: {},
    value: { type: [String, Number, Boolean] },
    disabled: { type: Boolean },
    indeterminate: { type: Boolean },
    modern: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = $a(), l = T(() => t.id || s), r = T({
      get() {
        return t.modelValue;
      },
      set(o) {
        o !== void 0 && a("update:modelValue", o);
      }
    }), i = ee(null);
    return jt(() => {
      i.value && (i.value.indeterminate = !!t.indeterminate);
    }), (o, u) => (w(), M("div", {
      class: q(["v-checkbox", { "v-checkbox--modern": t.modern }])
    }, [
      an(E("input", lt({
        id: l.value,
        ref_key: "inputRef",
        ref: i,
        "onUpdate:modelValue": u[0] || (u[0] = (c) => r.value = c),
        disabled: t.disabled,
        value: e.value,
        class: "v-checkbox__input",
        type: "checkbox"
      }, o.$attrs), null, 16, vp), [
        [kf, r.value]
      ]),
      e.label || o.$slots.label ? (w(), M("label", {
        key: 0,
        class: q([
          "v-checkbox__label",
          { "v-checkbox__label--disabled": t.disabled }
        ]),
        for: t.disabled ? void 0 : l.value
      }, [
        H(o.$slots, "label", {}, () => [
          He(re(e.label), 1)
        ], !0)
      ], 10, pp)) : R("", !0)
    ], 2));
  }
}), ed = /* @__PURE__ */ ze(gp, [["__scopeId", "data-v-e0e44db6"]]), yp = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const bp = Object.prototype.toString, wp = (e) => bp.call(e) === "[object Object]", rl = () => {
};
function gr(e) {
  return Array.isArray(e) ? e : [e];
}
function kp(e, n, t) {
  return Le(e, n, {
    ...t,
    immediate: !0
  });
}
const td = yp ? window : void 0;
function Gt(e) {
  var n;
  const t = Qe(e);
  return (n = t == null ? void 0 : t.$el) !== null && n !== void 0 ? n : t;
}
function ja(...e) {
  const n = (a, s, l, r) => (a.addEventListener(s, l, r), () => a.removeEventListener(s, l, r)), t = T(() => {
    const a = gr(Qe(e[0])).filter((s) => s != null);
    return a.every((s) => typeof s != "string") ? a : void 0;
  });
  return kp(() => {
    var a, s;
    return [
      (a = (s = t.value) === null || s === void 0 ? void 0 : s.map((l) => Gt(l))) !== null && a !== void 0 ? a : [td].filter((l) => l != null),
      gr(Qe(t.value ? e[1] : e[0])),
      gr(v(t.value ? e[2] : e[1])),
      Qe(t.value ? e[3] : e[2])
    ];
  }, ([a, s, l, r], i, o) => {
    if (!(a != null && a.length) || !(s != null && s.length) || !(l != null && l.length)) return;
    const u = wp(r) ? { ...r } : r, c = a.flatMap((f) => s.flatMap((p) => l.map((d) => n(f, p, d, u))));
    o(() => {
      c.forEach((f) => f());
    });
  }, { flush: "post" });
}
function xp(e, n, t = {}) {
  const { window: a = td, ignore: s = [], capture: l = !0, detectIframe: r = !1, controls: i = !1 } = t;
  if (!a) return i ? {
    stop: rl,
    cancel: rl,
    trigger: rl
  } : rl;
  let o = !0;
  const u = (k) => Qe(s).some((y) => {
    if (typeof y == "string") return Array.from(a.document.querySelectorAll(y)).some((h) => h === k.target || k.composedPath().includes(h));
    {
      const h = Gt(y);
      return h && (k.target === h || k.composedPath().includes(h));
    }
  });
  function c(k) {
    const y = Qe(k);
    return y && y.$.subTree.shapeFlag === 16;
  }
  function f(k, y) {
    const h = Qe(k), g = h.$.subTree && h.$.subTree.children;
    return g == null || !Array.isArray(g) ? !1 : g.some((x) => x.el === y.target || y.composedPath().includes(x.el));
  }
  const p = (k) => {
    const y = Gt(e);
    if (k.target != null && !(!(y instanceof Element) && c(e) && f(e, k)) && !(!y || y === k.target || k.composedPath().includes(y))) {
      if ("detail" in k && k.detail === 0 && (o = !u(k)), !o) {
        o = !0;
        return;
      }
      n(k);
    }
  };
  let d = !1;
  const b = [
    ja(a, "click", (k) => {
      d || (d = !0, setTimeout(() => {
        d = !1;
      }, 0), p(k));
    }, {
      passive: !0,
      capture: l
    }),
    ja(a, "pointerdown", (k) => {
      const y = Gt(e);
      o = !u(k) && !!(y && !k.composedPath().includes(y));
    }, { passive: !0 }),
    r && ja(a, "blur", (k) => {
      setTimeout(() => {
        var y;
        const h = Gt(e);
        ((y = a.document.activeElement) === null || y === void 0 ? void 0 : y.tagName) === "IFRAME" && !(h != null && h.contains(a.document.activeElement)) && n(k);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), m = () => b.forEach((k) => k());
  return i ? {
    stop: m,
    cancel: () => {
      o = !1;
    },
    trigger: (k) => {
      o = !0, p(k), o = !1;
    }
  } : m;
}
function Sp(e, n = {}) {
  const { threshold: t = 50, onSwipe: a, onSwipeEnd: s, onSwipeStart: l, passive: r = !0 } = n, i = ka({
    x: 0,
    y: 0
  }), o = ka({
    x: 0,
    y: 0
  }), u = T(() => i.x - o.x), c = T(() => i.y - o.y), { max: f, abs: p } = Math, d = T(() => f(p(u.value), p(c.value)) >= t), b = Et(!1), m = T(() => d.value ? p(u.value) > p(c.value) ? u.value > 0 ? "left" : "right" : c.value > 0 ? "up" : "down" : "none"), k = (_) => [_.touches[0].clientX, _.touches[0].clientY], y = (_, O) => {
    i.x = _, i.y = O;
  }, h = (_, O) => {
    o.x = _, o.y = O;
  }, g = {
    passive: r,
    capture: !r
  }, x = (_) => {
    b.value && (s == null || s(_, m.value)), b.value = !1;
  }, S = [
    ja(e, "touchstart", (_) => {
      if (_.touches.length !== 1) return;
      const [O, I] = k(_);
      y(O, I), h(O, I), l == null || l(_);
    }, g),
    ja(e, "touchmove", (_) => {
      if (_.touches.length !== 1) return;
      const [O, I] = k(_);
      h(O, I), g.capture && !g.passive && Math.abs(u.value) > Math.abs(c.value) && _.preventDefault(), !b.value && d.value && (b.value = !0), b.value && (a == null || a(_));
    }, g),
    ja(e, ["touchend", "touchcancel"], x, g)
  ];
  return {
    isSwiping: b,
    direction: m,
    coordsStart: i,
    coordsEnd: o,
    lengthX: u,
    lengthY: c,
    stop: () => S.forEach((_) => _())
  };
}
const Ja = Math.min, ba = Math.max, Tl = Math.round, il = Math.floor, On = (e) => ({
  x: e,
  y: e
}), Tp = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, $p = {
  start: "end",
  end: "start"
};
function Gr(e, n, t) {
  return ba(e, Ja(n, t));
}
function Bs(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Sa(e) {
  return e.split("-")[0];
}
function Ws(e) {
  return e.split("-")[1];
}
function nd(e) {
  return e === "x" ? "y" : "x";
}
function Si(e) {
  return e === "y" ? "height" : "width";
}
const Mp = /* @__PURE__ */ new Set(["top", "bottom"]);
function ta(e) {
  return Mp.has(Sa(e)) ? "y" : "x";
}
function Ti(e) {
  return nd(ta(e));
}
function Cp(e, n, t) {
  t === void 0 && (t = !1);
  const a = Ws(e), s = Ti(e), l = Si(s);
  let r = s === "x" ? a === (t ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return n.reference[l] > n.floating[l] && (r = $l(r)), [r, $l(r)];
}
function Dp(e) {
  const n = $l(e);
  return [Kr(e), n, Kr(n)];
}
function Kr(e) {
  return e.replace(/start|end/g, (n) => $p[n]);
}
const Vo = ["left", "right"], Lo = ["right", "left"], Op = ["top", "bottom"], _p = ["bottom", "top"];
function Ep(e, n, t) {
  switch (e) {
    case "top":
    case "bottom":
      return t ? n ? Lo : Vo : n ? Vo : Lo;
    case "left":
    case "right":
      return n ? Op : _p;
    default:
      return [];
  }
}
function Ip(e, n, t, a) {
  const s = Ws(e);
  let l = Ep(Sa(e), t === "start", a);
  return s && (l = l.map((r) => r + "-" + s), n && (l = l.concat(l.map(Kr)))), l;
}
function $l(e) {
  return e.replace(/left|right|bottom|top/g, (n) => Tp[n]);
}
function Ap(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ad(e) {
  return typeof e != "number" ? Ap(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ml(e) {
  const {
    x: n,
    y: t,
    width: a,
    height: s
  } = e;
  return {
    width: a,
    height: s,
    top: t,
    left: n,
    right: n + a,
    bottom: t + s,
    x: n,
    y: t
  };
}
function No(e, n, t) {
  let {
    reference: a,
    floating: s
  } = e;
  const l = ta(n), r = Ti(n), i = Si(r), o = Sa(n), u = l === "y", c = a.x + a.width / 2 - s.width / 2, f = a.y + a.height / 2 - s.height / 2, p = a[i] / 2 - s[i] / 2;
  let d;
  switch (o) {
    case "top":
      d = {
        x: c,
        y: a.y - s.height
      };
      break;
    case "bottom":
      d = {
        x: c,
        y: a.y + a.height
      };
      break;
    case "right":
      d = {
        x: a.x + a.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: a.x - s.width,
        y: f
      };
      break;
    default:
      d = {
        x: a.x,
        y: a.y
      };
  }
  switch (Ws(n)) {
    case "start":
      d[r] -= p * (t && u ? -1 : 1);
      break;
    case "end":
      d[r] += p * (t && u ? -1 : 1);
      break;
  }
  return d;
}
async function Pp(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    x: a,
    y: s,
    platform: l,
    rects: r,
    elements: i,
    strategy: o
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: d = 0
  } = Bs(n, e), b = ad(d), k = i[p ? f === "floating" ? "reference" : "floating" : f], y = Ml(await l.getClippingRect({
    element: (t = await (l.isElement == null ? void 0 : l.isElement(k))) == null || t ? k : k.contextElement || await (l.getDocumentElement == null ? void 0 : l.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: o
  })), h = f === "floating" ? {
    x: a,
    y: s,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, g = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(i.floating)), x = await (l.isElement == null ? void 0 : l.isElement(g)) ? await (l.getScale == null ? void 0 : l.getScale(g)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Ml(l.convertOffsetParentRelativeRectToViewportRelativeRect ? await l.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: h,
    offsetParent: g,
    strategy: o
  }) : h);
  return {
    top: (y.top - S.top + b.top) / x.y,
    bottom: (S.bottom - y.bottom + b.bottom) / x.y,
    left: (y.left - S.left + b.left) / x.x,
    right: (S.right - y.right + b.right) / x.x
  };
}
const Rp = async (e, n, t) => {
  const {
    placement: a = "bottom",
    strategy: s = "absolute",
    middleware: l = [],
    platform: r
  } = t, i = l.filter(Boolean), o = await (r.isRTL == null ? void 0 : r.isRTL(n));
  let u = await r.getElementRects({
    reference: e,
    floating: n,
    strategy: s
  }), {
    x: c,
    y: f
  } = No(u, a, o), p = a, d = {}, b = 0;
  for (let k = 0; k < i.length; k++) {
    var m;
    const {
      name: y,
      fn: h
    } = i[k], {
      x: g,
      y: x,
      data: S,
      reset: C
    } = await h({
      x: c,
      y: f,
      initialPlacement: a,
      placement: p,
      strategy: s,
      middlewareData: d,
      rects: u,
      platform: {
        ...r,
        detectOverflow: (m = r.detectOverflow) != null ? m : Pp
      },
      elements: {
        reference: e,
        floating: n
      }
    });
    c = g ?? c, f = x ?? f, d = {
      ...d,
      [y]: {
        ...d[y],
        ...S
      }
    }, C && b <= 50 && (b++, typeof C == "object" && (C.placement && (p = C.placement), C.rects && (u = C.rects === !0 ? await r.getElementRects({
      reference: e,
      floating: n,
      strategy: s
    }) : C.rects), {
      x: c,
      y: f
    } = No(u, p, o)), k = -1);
  }
  return {
    x: c,
    y: f,
    placement: p,
    strategy: s,
    middlewareData: d
  };
}, Fp = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: t,
      y: a,
      placement: s,
      rects: l,
      platform: r,
      elements: i,
      middlewareData: o
    } = n, {
      element: u,
      padding: c = 0
    } = Bs(e, n) || {};
    if (u == null)
      return {};
    const f = ad(c), p = {
      x: t,
      y: a
    }, d = Ti(s), b = Si(d), m = await r.getDimensions(u), k = d === "y", y = k ? "top" : "left", h = k ? "bottom" : "right", g = k ? "clientHeight" : "clientWidth", x = l.reference[b] + l.reference[d] - p[d] - l.floating[b], S = p[d] - l.reference[d], C = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(u));
    let _ = C ? C[g] : 0;
    (!_ || !await (r.isElement == null ? void 0 : r.isElement(C))) && (_ = i.floating[g] || l.floating[b]);
    const O = x / 2 - S / 2, I = _ / 2 - m[b] / 2 - 1, D = Ja(f[y], I), B = Ja(f[h], I), Y = D, ne = _ - m[b] - B, W = _ / 2 - m[b] / 2 + O, ae = Gr(Y, W, ne), G = !o.arrow && Ws(s) != null && W !== ae && l.reference[b] / 2 - (W < Y ? D : B) - m[b] / 2 < 0, j = G ? W < Y ? W - Y : W - ne : 0;
    return {
      [d]: p[d] + j,
      data: {
        [d]: ae,
        centerOffset: W - ae - j,
        ...G && {
          alignmentOffset: j
        }
      },
      reset: G
    };
  }
}), Vp = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var t, a;
      const {
        placement: s,
        middlewareData: l,
        rects: r,
        initialPlacement: i,
        platform: o,
        elements: u
      } = n, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: m = !0,
        ...k
      } = Bs(e, n);
      if ((t = l.arrow) != null && t.alignmentOffset)
        return {};
      const y = Sa(s), h = ta(i), g = Sa(i) === i, x = await (o.isRTL == null ? void 0 : o.isRTL(u.floating)), S = p || (g || !m ? [$l(i)] : Dp(i)), C = b !== "none";
      !p && C && S.push(...Ip(i, m, b, x));
      const _ = [i, ...S], O = await o.detectOverflow(n, k), I = [];
      let D = ((a = l.flip) == null ? void 0 : a.overflows) || [];
      if (c && I.push(O[y]), f) {
        const W = Cp(s, r, x);
        I.push(O[W[0]], O[W[1]]);
      }
      if (D = [...D, {
        placement: s,
        overflows: I
      }], !I.every((W) => W <= 0)) {
        var B, Y;
        const W = (((B = l.flip) == null ? void 0 : B.index) || 0) + 1, ae = _[W];
        if (ae && (!(f === "alignment" ? h !== ta(ae) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        D.every((se) => ta(se.placement) === h ? se.overflows[0] > 0 : !0)))
          return {
            data: {
              index: W,
              overflows: D
            },
            reset: {
              placement: ae
            }
          };
        let G = (Y = D.filter((j) => j.overflows[0] <= 0).sort((j, se) => j.overflows[1] - se.overflows[1])[0]) == null ? void 0 : Y.placement;
        if (!G)
          switch (d) {
            case "bestFit": {
              var ne;
              const j = (ne = D.filter((se) => {
                if (C) {
                  const U = ta(se.placement);
                  return U === h || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  U === "y";
                }
                return !0;
              }).map((se) => [se.placement, se.overflows.filter((U) => U > 0).reduce((U, N) => U + N, 0)]).sort((se, U) => se[1] - U[1])[0]) == null ? void 0 : ne[0];
              j && (G = j);
              break;
            }
            case "initialPlacement":
              G = i;
              break;
          }
        if (s !== G)
          return {
            reset: {
              placement: G
            }
          };
      }
      return {};
    }
  };
}, Lp = /* @__PURE__ */ new Set(["left", "top"]);
async function Np(e, n) {
  const {
    placement: t,
    platform: a,
    elements: s
  } = e, l = await (a.isRTL == null ? void 0 : a.isRTL(s.floating)), r = Sa(t), i = Ws(t), o = ta(t) === "y", u = Lp.has(r) ? -1 : 1, c = l && o ? -1 : 1, f = Bs(n, e);
  let {
    mainAxis: p,
    crossAxis: d,
    alignmentAxis: b
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return i && typeof b == "number" && (d = i === "end" ? b * -1 : b), o ? {
    x: d * c,
    y: p * u
  } : {
    x: p * u,
    y: d * c
  };
}
const zp = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var t, a;
      const {
        x: s,
        y: l,
        placement: r,
        middlewareData: i
      } = n, o = await Np(n, e);
      return r === ((t = i.offset) == null ? void 0 : t.placement) && (a = i.arrow) != null && a.alignmentOffset ? {} : {
        x: s + o.x,
        y: l + o.y,
        data: {
          ...o,
          placement: r
        }
      };
    }
  };
}, Bp = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: t,
        y: a,
        placement: s,
        platform: l
      } = n, {
        mainAxis: r = !0,
        crossAxis: i = !1,
        limiter: o = {
          fn: (y) => {
            let {
              x: h,
              y: g
            } = y;
            return {
              x: h,
              y: g
            };
          }
        },
        ...u
      } = Bs(e, n), c = {
        x: t,
        y: a
      }, f = await l.detectOverflow(n, u), p = ta(Sa(s)), d = nd(p);
      let b = c[d], m = c[p];
      if (r) {
        const y = d === "y" ? "top" : "left", h = d === "y" ? "bottom" : "right", g = b + f[y], x = b - f[h];
        b = Gr(g, b, x);
      }
      if (i) {
        const y = p === "y" ? "top" : "left", h = p === "y" ? "bottom" : "right", g = m + f[y], x = m - f[h];
        m = Gr(g, m, x);
      }
      const k = o.fn({
        ...n,
        [d]: b,
        [p]: m
      });
      return {
        ...k,
        data: {
          x: k.x - t,
          y: k.y - a,
          enabled: {
            [d]: r,
            [p]: i
          }
        }
      };
    }
  };
};
function zl() {
  return typeof window < "u";
}
function Ca(e) {
  return $i(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Zt(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function Rn(e) {
  var n;
  return (n = ($i(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function $i(e) {
  return zl() ? e instanceof Node || e instanceof Zt(e).Node : !1;
}
function wn(e) {
  return zl() ? e instanceof Element || e instanceof Zt(e).Element : !1;
}
function In(e) {
  return zl() ? e instanceof HTMLElement || e instanceof Zt(e).HTMLElement : !1;
}
function zo(e) {
  return !zl() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Zt(e).ShadowRoot;
}
const Wp = /* @__PURE__ */ new Set(["inline", "contents"]);
function Ys(e) {
  const {
    overflow: n,
    overflowX: t,
    overflowY: a,
    display: s
  } = kn(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + a + t) && !Wp.has(s);
}
const Yp = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Hp(e) {
  return Yp.has(Ca(e));
}
const Up = [":popover-open", ":modal"];
function Bl(e) {
  return Up.some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
const qp = ["transform", "translate", "scale", "rotate", "perspective"], jp = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Gp = ["paint", "layout", "strict", "content"];
function Mi(e) {
  const n = Ci(), t = wn(e) ? kn(e) : e;
  return qp.some((a) => t[a] ? t[a] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !n && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !n && (t.filter ? t.filter !== "none" : !1) || jp.some((a) => (t.willChange || "").includes(a)) || Gp.some((a) => (t.contain || "").includes(a));
}
function Kp(e) {
  let n = sa(e);
  for (; In(n) && !Qa(n); ) {
    if (Mi(n))
      return n;
    if (Bl(n))
      return null;
    n = sa(n);
  }
  return null;
}
function Ci() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Zp = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Qa(e) {
  return Zp.has(Ca(e));
}
function kn(e) {
  return Zt(e).getComputedStyle(e);
}
function Wl(e) {
  return wn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function sa(e) {
  if (Ca(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    zo(e) && e.host || // Fallback.
    Rn(e)
  );
  return zo(n) ? n.host : n;
}
function sd(e) {
  const n = sa(e);
  return Qa(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : In(n) && Ys(n) ? n : sd(n);
}
function Ps(e, n, t) {
  var a;
  n === void 0 && (n = []), t === void 0 && (t = !0);
  const s = sd(e), l = s === ((a = e.ownerDocument) == null ? void 0 : a.body), r = Zt(s);
  if (l) {
    const i = Zr(r);
    return n.concat(r, r.visualViewport || [], Ys(s) ? s : [], i && t ? Ps(i) : []);
  }
  return n.concat(s, Ps(s, [], t));
}
function Zr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ld(e) {
  const n = kn(e);
  let t = parseFloat(n.width) || 0, a = parseFloat(n.height) || 0;
  const s = In(e), l = s ? e.offsetWidth : t, r = s ? e.offsetHeight : a, i = Tl(t) !== l || Tl(a) !== r;
  return i && (t = l, a = r), {
    width: t,
    height: a,
    $: i
  };
}
function Di(e) {
  return wn(e) ? e : e.contextElement;
}
function Ga(e) {
  const n = Di(e);
  if (!In(n))
    return On(1);
  const t = n.getBoundingClientRect(), {
    width: a,
    height: s,
    $: l
  } = ld(n);
  let r = (l ? Tl(t.width) : t.width) / a, i = (l ? Tl(t.height) : t.height) / s;
  return (!r || !Number.isFinite(r)) && (r = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: r,
    y: i
  };
}
const Xp = /* @__PURE__ */ On(0);
function rd(e) {
  const n = Zt(e);
  return !Ci() || !n.visualViewport ? Xp : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function Jp(e, n, t) {
  return n === void 0 && (n = !1), !t || n && t !== Zt(e) ? !1 : n;
}
function Ta(e, n, t, a) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const s = e.getBoundingClientRect(), l = Di(e);
  let r = On(1);
  n && (a ? wn(a) && (r = Ga(a)) : r = Ga(e));
  const i = Jp(l, t, a) ? rd(l) : On(0);
  let o = (s.left + i.x) / r.x, u = (s.top + i.y) / r.y, c = s.width / r.x, f = s.height / r.y;
  if (l) {
    const p = Zt(l), d = a && wn(a) ? Zt(a) : a;
    let b = p, m = Zr(b);
    for (; m && a && d !== b; ) {
      const k = Ga(m), y = m.getBoundingClientRect(), h = kn(m), g = y.left + (m.clientLeft + parseFloat(h.paddingLeft)) * k.x, x = y.top + (m.clientTop + parseFloat(h.paddingTop)) * k.y;
      o *= k.x, u *= k.y, c *= k.x, f *= k.y, o += g, u += x, b = Zt(m), m = Zr(b);
    }
  }
  return Ml({
    width: c,
    height: f,
    x: o,
    y: u
  });
}
function Yl(e, n) {
  const t = Wl(e).scrollLeft;
  return n ? n.left + t : Ta(Rn(e)).left + t;
}
function id(e, n) {
  const t = e.getBoundingClientRect(), a = t.left + n.scrollLeft - Yl(e, t), s = t.top + n.scrollTop;
  return {
    x: a,
    y: s
  };
}
function Qp(e) {
  let {
    elements: n,
    rect: t,
    offsetParent: a,
    strategy: s
  } = e;
  const l = s === "fixed", r = Rn(a), i = n ? Bl(n.floating) : !1;
  if (a === r || i && l)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = On(1);
  const c = On(0), f = In(a);
  if ((f || !f && !l) && ((Ca(a) !== "body" || Ys(r)) && (o = Wl(a)), In(a))) {
    const d = Ta(a);
    u = Ga(a), c.x = d.x + a.clientLeft, c.y = d.y + a.clientTop;
  }
  const p = r && !f && !l ? id(r, o) : On(0);
  return {
    width: t.width * u.x,
    height: t.height * u.y,
    x: t.x * u.x - o.scrollLeft * u.x + c.x + p.x,
    y: t.y * u.y - o.scrollTop * u.y + c.y + p.y
  };
}
function eg(e) {
  return Array.from(e.getClientRects());
}
function tg(e) {
  const n = Rn(e), t = Wl(e), a = e.ownerDocument.body, s = ba(n.scrollWidth, n.clientWidth, a.scrollWidth, a.clientWidth), l = ba(n.scrollHeight, n.clientHeight, a.scrollHeight, a.clientHeight);
  let r = -t.scrollLeft + Yl(e);
  const i = -t.scrollTop;
  return kn(a).direction === "rtl" && (r += ba(n.clientWidth, a.clientWidth) - s), {
    width: s,
    height: l,
    x: r,
    y: i
  };
}
const Bo = 25;
function ng(e, n) {
  const t = Zt(e), a = Rn(e), s = t.visualViewport;
  let l = a.clientWidth, r = a.clientHeight, i = 0, o = 0;
  if (s) {
    l = s.width, r = s.height;
    const c = Ci();
    (!c || c && n === "fixed") && (i = s.offsetLeft, o = s.offsetTop);
  }
  const u = Yl(a);
  if (u <= 0) {
    const c = a.ownerDocument, f = c.body, p = getComputedStyle(f), d = c.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, b = Math.abs(a.clientWidth - f.clientWidth - d);
    b <= Bo && (l -= b);
  } else u <= Bo && (l += u);
  return {
    width: l,
    height: r,
    x: i,
    y: o
  };
}
const ag = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function sg(e, n) {
  const t = Ta(e, !0, n === "fixed"), a = t.top + e.clientTop, s = t.left + e.clientLeft, l = In(e) ? Ga(e) : On(1), r = e.clientWidth * l.x, i = e.clientHeight * l.y, o = s * l.x, u = a * l.y;
  return {
    width: r,
    height: i,
    x: o,
    y: u
  };
}
function Wo(e, n, t) {
  let a;
  if (n === "viewport")
    a = ng(e, t);
  else if (n === "document")
    a = tg(Rn(e));
  else if (wn(n))
    a = sg(n, t);
  else {
    const s = rd(e);
    a = {
      x: n.x - s.x,
      y: n.y - s.y,
      width: n.width,
      height: n.height
    };
  }
  return Ml(a);
}
function od(e, n) {
  const t = sa(e);
  return t === n || !wn(t) || Qa(t) ? !1 : kn(t).position === "fixed" || od(t, n);
}
function lg(e, n) {
  const t = n.get(e);
  if (t)
    return t;
  let a = Ps(e, [], !1).filter((i) => wn(i) && Ca(i) !== "body"), s = null;
  const l = kn(e).position === "fixed";
  let r = l ? sa(e) : e;
  for (; wn(r) && !Qa(r); ) {
    const i = kn(r), o = Mi(r);
    !o && i.position === "fixed" && (s = null), (l ? !o && !s : !o && i.position === "static" && !!s && ag.has(s.position) || Ys(r) && !o && od(e, r)) ? a = a.filter((c) => c !== r) : s = i, r = sa(r);
  }
  return n.set(e, a), a;
}
function rg(e) {
  let {
    element: n,
    boundary: t,
    rootBoundary: a,
    strategy: s
  } = e;
  const r = [...t === "clippingAncestors" ? Bl(n) ? [] : lg(n, this._c) : [].concat(t), a], i = r[0], o = r.reduce((u, c) => {
    const f = Wo(n, c, s);
    return u.top = ba(f.top, u.top), u.right = Ja(f.right, u.right), u.bottom = Ja(f.bottom, u.bottom), u.left = ba(f.left, u.left), u;
  }, Wo(n, i, s));
  return {
    width: o.right - o.left,
    height: o.bottom - o.top,
    x: o.left,
    y: o.top
  };
}
function ig(e) {
  const {
    width: n,
    height: t
  } = ld(e);
  return {
    width: n,
    height: t
  };
}
function og(e, n, t) {
  const a = In(n), s = Rn(n), l = t === "fixed", r = Ta(e, !0, l, n);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const o = On(0);
  function u() {
    o.x = Yl(s);
  }
  if (a || !a && !l)
    if ((Ca(n) !== "body" || Ys(s)) && (i = Wl(n)), a) {
      const d = Ta(n, !0, l, n);
      o.x = d.x + n.clientLeft, o.y = d.y + n.clientTop;
    } else s && u();
  l && !a && s && u();
  const c = s && !a && !l ? id(s, i) : On(0), f = r.left + i.scrollLeft - o.x - c.x, p = r.top + i.scrollTop - o.y - c.y;
  return {
    x: f,
    y: p,
    width: r.width,
    height: r.height
  };
}
function yr(e) {
  return kn(e).position === "static";
}
function Yo(e, n) {
  if (!In(e) || kn(e).position === "fixed")
    return null;
  if (n)
    return n(e);
  let t = e.offsetParent;
  return Rn(e) === t && (t = t.ownerDocument.body), t;
}
function ud(e, n) {
  const t = Zt(e);
  if (Bl(e))
    return t;
  if (!In(e)) {
    let s = sa(e);
    for (; s && !Qa(s); ) {
      if (wn(s) && !yr(s))
        return s;
      s = sa(s);
    }
    return t;
  }
  let a = Yo(e, n);
  for (; a && Hp(a) && yr(a); )
    a = Yo(a, n);
  return a && Qa(a) && yr(a) && !Mi(a) ? t : a || Kp(e) || t;
}
const ug = async function(e) {
  const n = this.getOffsetParent || ud, t = this.getDimensions, a = await t(e.floating);
  return {
    reference: og(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function cg(e) {
  return kn(e).direction === "rtl";
}
const dg = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Qp,
  getDocumentElement: Rn,
  getClippingRect: rg,
  getOffsetParent: ud,
  getElementRects: ug,
  getClientRects: eg,
  getDimensions: ig,
  getScale: Ga,
  isElement: wn,
  isRTL: cg
};
function cd(e, n) {
  return e.x === n.x && e.y === n.y && e.width === n.width && e.height === n.height;
}
function fg(e, n) {
  let t = null, a;
  const s = Rn(e);
  function l() {
    var i;
    clearTimeout(a), (i = t) == null || i.disconnect(), t = null;
  }
  function r(i, o) {
    i === void 0 && (i = !1), o === void 0 && (o = 1), l();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: f,
      width: p,
      height: d
    } = u;
    if (i || n(), !p || !d)
      return;
    const b = il(f), m = il(s.clientWidth - (c + p)), k = il(s.clientHeight - (f + d)), y = il(c), g = {
      rootMargin: -b + "px " + -m + "px " + -k + "px " + -y + "px",
      threshold: ba(0, Ja(1, o)) || 1
    };
    let x = !0;
    function S(C) {
      const _ = C[0].intersectionRatio;
      if (_ !== o) {
        if (!x)
          return r();
        _ ? r(!1, _) : a = setTimeout(() => {
          r(!1, 1e-7);
        }, 1e3);
      }
      _ === 1 && !cd(u, e.getBoundingClientRect()) && r(), x = !1;
    }
    try {
      t = new IntersectionObserver(S, {
        ...g,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(S, g);
    }
    t.observe(e);
  }
  return r(!0), l;
}
function hg(e, n, t, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: l = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: o = !1
  } = a, u = Di(e), c = s || l ? [...u ? Ps(u) : [], ...Ps(n)] : [];
  c.forEach((y) => {
    s && y.addEventListener("scroll", t, {
      passive: !0
    }), l && y.addEventListener("resize", t);
  });
  const f = u && i ? fg(u, t) : null;
  let p = -1, d = null;
  r && (d = new ResizeObserver((y) => {
    let [h] = y;
    h && h.target === u && d && (d.unobserve(n), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var g;
      (g = d) == null || g.observe(n);
    })), t();
  }), u && !o && d.observe(u), d.observe(n));
  let b, m = o ? Ta(e) : null;
  o && k();
  function k() {
    const y = Ta(e);
    m && !cd(m, y) && t(), m = y, b = requestAnimationFrame(k);
  }
  return t(), () => {
    var y;
    c.forEach((h) => {
      s && h.removeEventListener("scroll", t), l && h.removeEventListener("resize", t);
    }), f == null || f(), (y = d) == null || y.disconnect(), d = null, o && cancelAnimationFrame(b);
  };
}
const mg = zp, vg = Bp, pg = Vp, gg = Fp, yg = (e, n, t) => {
  const a = /* @__PURE__ */ new Map(), s = {
    platform: dg,
    ...t
  }, l = {
    ...s.platform,
    _c: a
  };
  return Rp(e, n, {
    ...s,
    platform: l
  });
};
function bg(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Xr(e) {
  if (bg(e)) {
    const n = e.$el;
    return $i(n) && Ca(n) === "#comment" ? null : n;
  }
  return e;
}
function za(e) {
  return typeof e == "function" ? e() : v(e);
}
function wg(e) {
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const t = Xr(za(e.element));
      return t == null ? {} : gg({
        element: t,
        padding: e.padding
      }).fn(n);
    }
  };
}
function dd(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ho(e, n) {
  const t = dd(e);
  return Math.round(n * t) / t;
}
function kg(e, n, t) {
  t === void 0 && (t = {});
  const a = t.whileElementsMounted, s = T(() => {
    var _;
    return (_ = za(t.open)) != null ? _ : !0;
  }), l = T(() => za(t.middleware)), r = T(() => {
    var _;
    return (_ = za(t.placement)) != null ? _ : "bottom";
  }), i = T(() => {
    var _;
    return (_ = za(t.strategy)) != null ? _ : "absolute";
  }), o = T(() => {
    var _;
    return (_ = za(t.transform)) != null ? _ : !0;
  }), u = T(() => Xr(e.value)), c = T(() => Xr(n.value)), f = ee(0), p = ee(0), d = ee(i.value), b = ee(r.value), m = Et({}), k = ee(!1), y = T(() => {
    const _ = {
      position: d.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return _;
    const O = Ho(c.value, f.value), I = Ho(c.value, p.value);
    return o.value ? {
      ..._,
      transform: "translate(" + O + "px, " + I + "px)",
      ...dd(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: d.value,
      left: O + "px",
      top: I + "px"
    };
  });
  let h;
  function g() {
    if (u.value == null || c.value == null)
      return;
    const _ = s.value;
    yg(u.value, c.value, {
      middleware: l.value,
      placement: r.value,
      strategy: i.value
    }).then((O) => {
      f.value = O.x, p.value = O.y, d.value = O.strategy, b.value = O.placement, m.value = O.middlewareData, k.value = _ !== !1;
    });
  }
  function x() {
    typeof h == "function" && (h(), h = void 0);
  }
  function S() {
    if (x(), a === void 0) {
      g();
      return;
    }
    if (u.value != null && c.value != null) {
      h = a(u.value, c.value, g);
      return;
    }
  }
  function C() {
    s.value || (k.value = !1);
  }
  return Le([l, r, i, s], g, {
    flush: "sync"
  }), Le([u, c], S, {
    flush: "sync"
  }), Le(s, C, {
    flush: "sync"
  }), Du() && El(x), {
    x: Ia(f),
    y: Ia(p),
    strategy: Ia(d),
    placement: Ia(b),
    middlewareData: Ia(m),
    isPositioned: Ia(k),
    floatingStyles: y,
    update: g
  };
}
const fd = 6048e5, xg = 864e5, Sg = 6e4, Tg = 36e5, $g = 1e3, Uo = Symbol.for("constructDateFrom");
function ot(e, n) {
  return typeof e == "function" ? e(n) : e && typeof e == "object" && Uo in e ? e[Uo](n) : e instanceof Date ? new e.constructor(n) : new Date(n);
}
function Ne(e, n) {
  return ot(n || e, e);
}
function nn(e, n, t) {
  const a = Ne(e, t == null ? void 0 : t.in);
  return isNaN(n) ? ot((t == null ? void 0 : t.in) || e, NaN) : (n && a.setDate(a.getDate() + n), a);
}
function pn(e, n, t) {
  const a = Ne(e, t == null ? void 0 : t.in);
  if (isNaN(n)) return ot(e, NaN);
  if (!n)
    return a;
  const s = a.getDate(), l = ot(e, a.getTime());
  l.setMonth(a.getMonth() + n + 1, 0);
  const r = l.getDate();
  return s >= r ? l : (a.setFullYear(
    l.getFullYear(),
    l.getMonth(),
    s
  ), a);
}
function hd(e, n, t) {
  const {
    years: a = 0,
    months: s = 0,
    weeks: l = 0,
    days: r = 0,
    hours: i = 0,
    minutes: o = 0,
    seconds: u = 0
  } = n, c = Ne(e, t == null ? void 0 : t.in), f = s || a ? pn(c, s + a * 12) : c, p = r || l ? nn(f, r + l * 7) : f, d = o + i * 60, m = (u + d * 60) * 1e3;
  return ot(e, +p + m);
}
let Mg = {};
function Da() {
  return Mg;
}
function rn(e, n) {
  var i, o, u, c;
  const t = Da(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = Ne(e, n == null ? void 0 : n.in), l = s.getDay(), r = (l < a ? 7 : 0) + l - a;
  return s.setDate(s.getDate() - r), s.setHours(0, 0, 0, 0), s;
}
function es(e, n) {
  return rn(e, { ...n, weekStartsOn: 1 });
}
function md(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = ot(t, 0);
  s.setFullYear(a + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const l = es(s), r = ot(t, 0);
  r.setFullYear(a, 0, 4), r.setHours(0, 0, 0, 0);
  const i = es(r);
  return t.getTime() >= l.getTime() ? a + 1 : t.getTime() >= i.getTime() ? a : a - 1;
}
function Cl(e) {
  const n = Ne(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function Hs(e, ...n) {
  const t = ot.bind(
    null,
    n.find((a) => typeof a == "object")
  );
  return n.map(t);
}
function qo(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in);
  return t.setHours(0, 0, 0, 0), t;
}
function vd(e, n, t) {
  const [a, s] = Hs(
    t == null ? void 0 : t.in,
    e,
    n
  ), l = qo(a), r = qo(s), i = +l - Cl(l), o = +r - Cl(r);
  return Math.round((i - o) / xg);
}
function Cg(e, n) {
  const t = md(e, n), a = ot(e, 0);
  return a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0), es(a);
}
function Dg(e, n, t) {
  return pn(e, n * 3, t);
}
function Oi(e, n, t) {
  return pn(e, n * 12, t);
}
function jo(e, n) {
  const t = +Ne(e) - +Ne(n);
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function pd(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Cs(e) {
  return !(!pd(e) && typeof e != "number" || isNaN(+Ne(e)));
}
function Go(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function Og(e, n, t) {
  const [a, s] = Hs(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return a.getFullYear() - s.getFullYear();
}
function _g(e) {
  return (n) => {
    const a = (e ? Math[e] : Math.trunc)(n);
    return a === 0 ? 0 : a;
  };
}
function Eg(e, n, t) {
  const [a, s] = Hs(
    t == null ? void 0 : t.in,
    e,
    n
  ), l = jo(a, s), r = Math.abs(Og(a, s));
  a.setFullYear(1584), s.setFullYear(1584);
  const i = jo(a, s) === -l, o = l * (r - +i);
  return o === 0 ? 0 : o;
}
function gd(e, n) {
  const [t, a] = Hs(e, n.start, n.end);
  return { start: t, end: a };
}
function _i(e, n) {
  const { start: t, end: a } = gd(n == null ? void 0 : n.in, e);
  let s = +t > +a;
  const l = s ? +t : +a, r = s ? a : t;
  r.setHours(0, 0, 0, 0);
  let i = 1;
  const o = [];
  for (; +r <= l; )
    o.push(ot(t, r)), r.setDate(r.getDate() + i), r.setHours(0, 0, 0, 0);
  return s ? o.reverse() : o;
}
function ga(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in), a = t.getMonth(), s = a - a % 3;
  return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
}
function Ig(e, n) {
  const { start: t, end: a } = gd(n == null ? void 0 : n.in, e);
  let s = +t > +a;
  const l = s ? +ga(t) : +ga(a);
  let r = ga(s ? a : t), i = 1;
  const o = [];
  for (; +r <= l; )
    o.push(ot(t, r)), r = Dg(r, i);
  return s ? o.reverse() : o;
}
function Ag(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function yd(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in), a = t.getFullYear();
  return t.setFullYear(a + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Ka(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Ei(e, n) {
  var i, o, u, c;
  const t = Da(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = Ne(e, n == null ? void 0 : n.in), l = s.getDay(), r = (l < a ? -7 : 0) + 6 - (l - a);
  return s.setDate(s.getDate() + r), s.setHours(23, 59, 59, 999), s;
}
function Ko(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in), a = t.getMonth(), s = a - a % 3 + 3;
  return t.setMonth(s, 0), t.setHours(23, 59, 59, 999), t;
}
const Pg = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Rg = (e, n, t) => {
  let a;
  const s = Pg[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
};
function br(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const Fg = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Vg = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Lg = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ng = {
  date: br({
    formats: Fg,
    defaultWidth: "full"
  }),
  time: br({
    formats: Vg,
    defaultWidth: "full"
  }),
  dateTime: br({
    formats: Lg,
    defaultWidth: "full"
  })
}, zg = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Bg = (e, n, t, a) => zg[e];
function ps(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (a === "formatting" && e.formattingValues) {
      const r = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : r;
      s = e.formattingValues[i] || e.formattingValues[r];
    } else {
      const r = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[i] || e.values[r];
    }
    const l = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[l];
  };
}
const Wg = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Yg = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Hg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Ug = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, qg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, jg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Gg = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Kg = {
  ordinalNumber: Gg,
  era: ps({
    values: Wg,
    defaultWidth: "wide"
  }),
  quarter: ps({
    values: Yg,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ps({
    values: Hg,
    defaultWidth: "wide"
  }),
  day: ps({
    values: Ug,
    defaultWidth: "wide"
  }),
  dayPeriod: ps({
    values: qg,
    defaultWidth: "wide",
    formattingValues: jg,
    defaultFormattingWidth: "wide"
  })
};
function gs(e) {
  return (n, t = {}) => {
    const a = t.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], l = n.match(s);
    if (!l)
      return null;
    const r = l[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(i) ? Xg(i, (f) => f.test(r)) : (
      // [TODO] -- I challenge you to fix the type
      Zg(i, (f) => f.test(r))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(r.length);
    return { value: u, rest: c };
  };
}
function Zg(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function Xg(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function Jg(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const s = a[0], l = n.match(e.parsePattern);
    if (!l) return null;
    let r = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    r = t.valueCallback ? t.valueCallback(r) : r;
    const i = n.slice(s.length);
    return { value: r, rest: i };
  };
}
const Qg = /^(\d+)(th|st|nd|rd)?/i, ey = /\d+/i, ty = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, ny = {
  any: [/^b/i, /^(a|c)/i]
}, ay = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, sy = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ly = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, ry = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, iy = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, oy = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, uy = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, cy = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, dy = {
  ordinalNumber: Jg({
    matchPattern: Qg,
    parsePattern: ey,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: gs({
    matchPatterns: ty,
    defaultMatchWidth: "wide",
    parsePatterns: ny,
    defaultParseWidth: "any"
  }),
  quarter: gs({
    matchPatterns: ay,
    defaultMatchWidth: "wide",
    parsePatterns: sy,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: gs({
    matchPatterns: ly,
    defaultMatchWidth: "wide",
    parsePatterns: ry,
    defaultParseWidth: "any"
  }),
  day: gs({
    matchPatterns: iy,
    defaultMatchWidth: "wide",
    parsePatterns: oy,
    defaultParseWidth: "any"
  }),
  dayPeriod: gs({
    matchPatterns: uy,
    defaultMatchWidth: "any",
    parsePatterns: cy,
    defaultParseWidth: "any"
  })
}, bd = {
  code: "en-US",
  formatDistance: Rg,
  formatLong: Ng,
  formatRelative: Bg,
  localize: Kg,
  match: dy,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function fy(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in);
  return vd(t, Ka(t)) + 1;
}
function Ii(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in), a = +es(t) - +Cg(t);
  return Math.round(a / fd) + 1;
}
function Ai(e, n) {
  var c, f, p, d;
  const t = Ne(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = Da(), l = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((d = (p = s.locale) == null ? void 0 : p.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, r = ot((n == null ? void 0 : n.in) || e, 0);
  r.setFullYear(a + 1, 0, l), r.setHours(0, 0, 0, 0);
  const i = rn(r, n), o = ot((n == null ? void 0 : n.in) || e, 0);
  o.setFullYear(a, 0, l), o.setHours(0, 0, 0, 0);
  const u = rn(o, n);
  return +t >= +i ? a + 1 : +t >= +u ? a : a - 1;
}
function hy(e, n) {
  var i, o, u, c;
  const t = Da(), a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, s = Ai(e, n), l = ot((n == null ? void 0 : n.in) || e, 0);
  return l.setFullYear(s, 0, a), l.setHours(0, 0, 0, 0), rn(l, n);
}
function Pi(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in), a = +rn(t, n) - +hy(t, n);
  return Math.round(a / fd) + 1;
}
function it(e, n) {
  const t = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(n, "0");
  return t + a;
}
const Zn = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), a = t > 0 ? t : 1 - t;
    return it(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : it(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return it(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return it(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return it(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return it(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return it(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, a = e.getMilliseconds(), s = Math.trunc(
      a * Math.pow(10, t - 3)
    );
    return it(s, n.length);
  }
}, Fa = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Zo = {
  // Era
  G: function(e, n, t) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(a, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(a, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const a = e.getFullYear(), s = a > 0 ? a : 1 - a;
      return t.ordinalNumber(s, { unit: "year" });
    }
    return Zn.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, a) {
    const s = Ai(e, a), l = s > 0 ? s : 1 - s;
    if (n === "YY") {
      const r = l % 100;
      return it(r, 2);
    }
    return n === "Yo" ? t.ordinalNumber(l, { unit: "year" }) : it(l, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = md(e);
    return it(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return it(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(a);
      // 01, 02, 03, 04
      case "QQ":
        return it(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(a);
      // 01, 02, 03, 04
      case "qq":
        return it(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return Zn.M(e, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(a, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(a + 1);
      // 01, 02, ..., 12
      case "LL":
        return it(a + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(a, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, a) {
    const s = Pi(e, a);
    return n === "wo" ? t.ordinalNumber(s, { unit: "week" }) : it(s, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const a = Ii(e);
    return n === "Io" ? t.ordinalNumber(a, { unit: "week" }) : it(a, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Zn.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const a = fy(e);
    return n === "Do" ? t.ordinalNumber(a, { unit: "dayOfYear" }) : it(a, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const a = e.getDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, a) {
    const s = e.getDay(), l = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(l);
      // Padded numerical value
      case "ee":
        return it(l, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(l, { unit: "day" });
      case "eee":
        return t.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, a) {
    const s = e.getDay(), l = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(l);
      // Padded numerical value
      case "cc":
        return it(l, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(l, { unit: "day" });
      case "ccc":
        return t.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const a = e.getDay(), s = a === 0 ? 7 : a;
    switch (n) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return it(s, n.length);
      // 2nd
      case "io":
        return t.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const a = e.getHours();
    let s;
    switch (a === 12 ? s = Fa.noon : a === 0 ? s = Fa.midnight : s = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const a = e.getHours();
    let s;
    switch (a >= 17 ? s = Fa.evening : a >= 12 ? s = Fa.afternoon : a >= 4 ? s = Fa.morning : s = Fa.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), t.ordinalNumber(a, { unit: "hour" });
    }
    return Zn.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Zn.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const a = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(a, { unit: "hour" }) : it(a, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let a = e.getHours();
    return a === 0 && (a = 24), n === "ko" ? t.ordinalNumber(a, { unit: "hour" }) : it(a, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Zn.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Zn.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Zn.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return Jo(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ma(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ma(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return Jo(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ma(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ma(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Xo(a, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ma(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Xo(a, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ma(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const a = Math.trunc(+e / 1e3);
    return it(a, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    return it(+e, n.length);
  }
};
function Xo(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), s = Math.trunc(a / 60), l = a % 60;
  return l === 0 ? t + String(s) : t + String(s) + n + it(l, 2);
}
function Jo(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + it(Math.abs(e) / 60, 2) : ma(e, n);
}
function ma(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), s = it(Math.trunc(a / 60), 2), l = it(a % 60, 2);
  return t + s + n + l;
}
const Qo = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, wd = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, my = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], a = t[1], s = t[2];
  if (!s)
    return Qo(e, n);
  let l;
  switch (a) {
    case "P":
      l = n.dateTime({ width: "short" });
      break;
    case "PP":
      l = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      l = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      l = n.dateTime({ width: "full" });
      break;
  }
  return l.replace("{{date}}", Qo(a, n)).replace("{{time}}", wd(s, n));
}, Jr = {
  p: wd,
  P: my
}, vy = /^D+$/, py = /^Y+$/, gy = ["D", "DD", "YY", "YYYY"];
function kd(e) {
  return vy.test(e);
}
function xd(e) {
  return py.test(e);
}
function Qr(e, n, t) {
  const a = yy(e, n, t);
  if (console.warn(a), gy.includes(e)) throw new RangeError(a);
}
function yy(e, n, t) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${a} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const by = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, wy = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ky = /^'([^]*?)'?$/, xy = /''/g, Sy = /[a-zA-Z]/;
function tn(e, n, t) {
  var c, f, p, d, b, m, k, y;
  const a = Da(), s = (t == null ? void 0 : t.locale) ?? a.locale ?? bd, l = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((d = (p = a.locale) == null ? void 0 : p.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, r = (t == null ? void 0 : t.weekStartsOn) ?? ((m = (b = t == null ? void 0 : t.locale) == null ? void 0 : b.options) == null ? void 0 : m.weekStartsOn) ?? a.weekStartsOn ?? ((y = (k = a.locale) == null ? void 0 : k.options) == null ? void 0 : y.weekStartsOn) ?? 0, i = Ne(e, t == null ? void 0 : t.in);
  if (!Cs(i))
    throw new RangeError("Invalid time value");
  let o = n.match(wy).map((h) => {
    const g = h[0];
    if (g === "p" || g === "P") {
      const x = Jr[g];
      return x(h, s.formatLong);
    }
    return h;
  }).join("").match(by).map((h) => {
    if (h === "''")
      return { isToken: !1, value: "'" };
    const g = h[0];
    if (g === "'")
      return { isToken: !1, value: Ty(h) };
    if (Zo[g])
      return { isToken: !0, value: h };
    if (g.match(Sy))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + g + "`"
      );
    return { isToken: !1, value: h };
  });
  s.localize.preprocessor && (o = s.localize.preprocessor(i, o));
  const u = {
    firstWeekContainsDate: l,
    weekStartsOn: r,
    locale: s
  };
  return o.map((h) => {
    if (!h.isToken) return h.value;
    const g = h.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && xd(g) || !(t != null && t.useAdditionalDayOfYearTokens) && kd(g)) && Qr(g, n, String(e));
    const x = Zo[g[0]];
    return x(i, g, s.localize, u);
  }).join("");
}
function Ty(e) {
  const n = e.match(ky);
  return n ? n[1].replace(xy, "'") : e;
}
function $y(e, n) {
  return Ne(e, n == null ? void 0 : n.in).getDay();
}
function My(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = t.getMonth(), l = ot(t, 0);
  return l.setFullYear(a, s + 1, 0), l.setHours(0, 0, 0, 0), l.getDate();
}
function Cy() {
  return Object.assign({}, Da());
}
function An(e, n) {
  return Ne(e, n == null ? void 0 : n.in).getHours();
}
function Dy(e, n) {
  const t = Ne(e, n == null ? void 0 : n.in).getDay();
  return t === 0 ? 7 : t;
}
function Hn(e, n) {
  return Ne(e, n == null ? void 0 : n.in).getMinutes();
}
function Ze(e, n) {
  return Ne(e, n == null ? void 0 : n.in).getMonth();
}
function la(e) {
  return Ne(e).getSeconds();
}
function We(e, n) {
  return Ne(e, n == null ? void 0 : n.in).getFullYear();
}
function Cn(e, n) {
  return +Ne(e) > +Ne(n);
}
function Wn(e, n) {
  return +Ne(e) < +Ne(n);
}
function Wa(e, n) {
  return +Ne(e) == +Ne(n);
}
function Oy(e, n) {
  const t = _y(n) ? new n(0) : ot(n, 0);
  return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
function _y(e) {
  var n;
  return typeof e == "function" && ((n = e.prototype) == null ? void 0 : n.constructor) === e;
}
const Ey = 10;
class Sd {
  constructor() {
    xe(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class Iy extends Sd {
  constructor(n, t, a, s, l) {
    super(), this.value = n, this.validateValue = t, this.setValue = a, this.priority = s, l && (this.subPriority = l);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, a) {
    return this.setValue(n, t, this.value, a);
  }
}
class Ay extends Sd {
  constructor(t, a) {
    super();
    xe(this, "priority", Ey);
    xe(this, "subPriority", -1);
    this.context = t || ((s) => ot(a, s));
  }
  set(t, a) {
    return a.timestampIsSet ? t : ot(t, Oy(t, this.context));
  }
}
class at {
  run(n, t, a, s) {
    const l = this.parse(n, t, a, s);
    return l ? {
      setter: new Iy(
        l.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: l.rest
    } : null;
  }
  validate(n, t, a) {
    return !0;
  }
}
class Py extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 140);
    xe(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(t, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(t, { width: "wide" }) || s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
    }
  }
  set(t, a, s) {
    return a.era = s, t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const St = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, $n = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Tt(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function vt(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function Mn(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const a = t[1] === "+" ? 1 : -1, s = t[2] ? parseInt(t[2], 10) : 0, l = t[3] ? parseInt(t[3], 10) : 0, r = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: a * (s * Tg + l * Sg + r * $g),
    rest: n.slice(t[0].length)
  };
}
function Td(e) {
  return vt(St.anyDigitsSigned, e);
}
function yt(e, n) {
  switch (e) {
    case 1:
      return vt(St.singleDigit, n);
    case 2:
      return vt(St.twoDigits, n);
    case 3:
      return vt(St.threeDigits, n);
    case 4:
      return vt(St.fourDigits, n);
    default:
      return vt(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function Dl(e, n) {
  switch (e) {
    case 1:
      return vt(St.singleDigitSigned, n);
    case 2:
      return vt(St.twoDigitsSigned, n);
    case 3:
      return vt(St.threeDigitsSigned, n);
    case 4:
      return vt(St.fourDigitsSigned, n);
    default:
      return vt(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function Ri(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function $d(e, n) {
  const t = n > 0, a = t ? n : 1 - n;
  let s;
  if (a <= 50)
    s = e || 100;
  else {
    const l = a + 50, r = Math.trunc(l / 100) * 100, i = e >= l % 100;
    s = e + r - (i ? 100 : 0);
  }
  return t ? s : 1 - s;
}
function Md(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class Ry extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, s) {
    const l = (r) => ({
      year: r,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return Tt(yt(4, t), l);
      case "yo":
        return Tt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return Tt(yt(a.length, t), l);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, s) {
    const l = t.getFullYear();
    if (s.isTwoDigitYear) {
      const i = $d(
        s.year,
        l
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const r = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Fy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const l = (r) => ({
      year: r,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return Tt(yt(4, t), l);
      case "Yo":
        return Tt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return Tt(yt(a.length, t), l);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, s, l) {
    const r = Ai(t, l);
    if (s.isTwoDigitYear) {
      const o = $d(
        s.year,
        r
      );
      return t.setFullYear(
        o,
        0,
        l.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), rn(t, l);
    }
    const i = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(i, 0, l.firstWeekContainsDate), t.setHours(0, 0, 0, 0), rn(t, l);
  }
}
class Vy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a) {
    return Dl(a === "R" ? 4 : a.length, t);
  }
  set(t, a, s) {
    const l = ot(t, 0);
    return l.setFullYear(s, 0, 4), l.setHours(0, 0, 0, 0), es(l);
  }
}
class Ly extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a) {
    return Dl(a === "u" ? 4 : a.length, t);
  }
  set(t, a, s) {
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Ny extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 120);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return yt(a.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class zy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 120);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return yt(a.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class By extends at {
  constructor() {
    super(...arguments);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    xe(this, "priority", 110);
  }
  parse(t, a, s) {
    const l = (r) => r - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "M":
        return Tt(
          vt(St.month, t),
          l
        );
      // 01, 02, ..., 12
      case "MM":
        return Tt(yt(2, t), l);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return Tt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(t, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(t, { width: "wide", context: "formatting" }) || s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Wy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 110);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const l = (r) => r - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "L":
        return Tt(
          vt(St.month, t),
          l
        );
      // 01, 02, ..., 12
      case "LL":
        return Tt(yt(2, t), l);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return Tt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(t, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(t, { width: "wide", context: "standalone" }) || s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Yy(e, n, t) {
  const a = Ne(e, t == null ? void 0 : t.in), s = Pi(a, t) - n;
  return a.setDate(a.getDate() - s * 7), Ne(a, t == null ? void 0 : t.in);
}
class Hy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 100);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "w":
        return vt(St.week, t);
      case "wo":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, s, l) {
    return rn(Yy(t, s, l), l);
  }
}
function Uy(e, n, t) {
  const a = Ne(e, t == null ? void 0 : t.in), s = Ii(a, t) - n;
  return a.setDate(a.getDate() - s * 7), a;
}
class qy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 100);
    xe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "I":
        return vt(St.week, t);
      case "Io":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, s) {
    return es(Uy(t, s));
  }
}
const jy = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Gy = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Ky extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "subPriority", 1);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "d":
        return vt(St.date, t);
      case "do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    const s = t.getFullYear(), l = Md(s), r = t.getMonth();
    return l ? a >= 1 && a <= Gy[r] : a >= 1 && a <= jy[r];
  }
  set(t, a, s) {
    return t.setDate(s), t.setHours(0, 0, 0, 0), t;
  }
}
class Zy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "subpriority", 1);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "D":
      case "DD":
        return vt(St.dayOfYear, t);
      case "Do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    const s = t.getFullYear();
    return Md(s) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(t, a, s) {
    return t.setMonth(0, s), t.setHours(0, 0, 0, 0), t;
  }
}
function Fi(e, n, t) {
  var f, p, d, b;
  const a = Da(), s = (t == null ? void 0 : t.weekStartsOn) ?? ((p = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : p.weekStartsOn) ?? a.weekStartsOn ?? ((b = (d = a.locale) == null ? void 0 : d.options) == null ? void 0 : b.weekStartsOn) ?? 0, l = Ne(e, t == null ? void 0 : t.in), r = l.getDay(), o = (n % 7 + 7) % 7, u = 7 - s, c = n < 0 || n > 6 ? n - (r + u) % 7 : (o + u) % 7 - (r + u) % 7;
  return nn(l, c, t);
}
class Xy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, l) {
    return t = Fi(t, s, l), t.setHours(0, 0, 0, 0), t;
  }
}
class Jy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s, l) {
    const r = (i) => {
      const o = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + o;
    };
    switch (a) {
      // 3
      case "e":
      case "ee":
        return Tt(yt(a.length, t), r);
      // 3rd
      case "eo":
        return Tt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "eee":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, l) {
    return t = Fi(t, s, l), t.setHours(0, 0, 0, 0), t;
  }
}
class Qy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, a, s, l) {
    const r = (i) => {
      const o = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + o;
    };
    switch (a) {
      // 3
      case "c":
      case "cc":
        return Tt(yt(a.length, t), r);
      // 3rd
      case "co":
        return Tt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "ccc":
        return s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(t, { width: "wide", context: "standalone" }) || s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, l) {
    return t = Fi(t, s, l), t.setHours(0, 0, 0, 0), t;
  }
}
function eb(e, n, t) {
  const a = Ne(e, t == null ? void 0 : t.in), s = Dy(a, t), l = n - s;
  return nn(a, l, t);
}
class tb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const l = (r) => r === 0 ? 7 : r;
    switch (a) {
      // 2
      case "i":
      case "ii":
        return yt(a.length, t);
      // 2nd
      case "io":
        return s.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return Tt(
          s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // T
      case "iiiii":
        return Tt(
          s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // Tu
      case "iiiiii":
        return Tt(
          s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // Tuesday
      case "iiii":
      default:
        return Tt(
          s.day(t, {
            width: "wide",
            context: "formatting"
          }) || s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 7;
  }
  set(t, a, s) {
    return t = eb(t, s), t.setHours(0, 0, 0, 0), t;
  }
}
class nb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 80);
    xe(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Ri(s), 0, 0, 0), t;
  }
}
class ab extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 80);
    xe(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Ri(s), 0, 0, 0), t;
  }
}
class sb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 80);
    xe(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Ri(s), 0, 0, 0), t;
  }
}
class lb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "h":
        return vt(St.hour12h, t);
      case "ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 12;
  }
  set(t, a, s) {
    const l = t.getHours() >= 12;
    return l && s < 12 ? t.setHours(s + 12, 0, 0, 0) : !l && s === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class rb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "H":
        return vt(St.hour23h, t);
      case "Ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 23;
  }
  set(t, a, s) {
    return t.setHours(s, 0, 0, 0), t;
  }
}
class ib extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "K":
        return vt(St.hour11h, t);
      case "Ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.getHours() >= 12 && s < 12 ? t.setHours(s + 12, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class ob extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "k":
        return vt(St.hour24h, t);
      case "ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 24;
  }
  set(t, a, s) {
    const l = s <= 24 ? s % 24 : s;
    return t.setHours(l, 0, 0, 0), t;
  }
}
class ub extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 60);
    xe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "m":
        return vt(St.minute, t);
      case "mo":
        return s.ordinalNumber(t, { unit: "minute" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, s) {
    return t.setMinutes(s, 0, 0), t;
  }
}
class cb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 50);
    xe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "s":
        return vt(St.second, t);
      case "so":
        return s.ordinalNumber(t, { unit: "second" });
      default:
        return yt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, s) {
    return t.setSeconds(s, 0), t;
  }
}
class db extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 30);
    xe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a) {
    const s = (l) => Math.trunc(l * Math.pow(10, -a.length + 3));
    return Tt(yt(a.length, t), s);
  }
  set(t, a, s) {
    return t.setMilliseconds(s), t;
  }
}
class fb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 10);
    xe(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, a) {
    switch (a) {
      case "X":
        return Mn(
          $n.basicOptionalMinutes,
          t
        );
      case "XX":
        return Mn($n.basic, t);
      case "XXXX":
        return Mn(
          $n.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Mn(
          $n.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Mn($n.extended, t);
    }
  }
  set(t, a, s) {
    return a.timestampIsSet ? t : ot(
      t,
      t.getTime() - Cl(t) - s
    );
  }
}
class hb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 10);
    xe(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, a) {
    switch (a) {
      case "x":
        return Mn(
          $n.basicOptionalMinutes,
          t
        );
      case "xx":
        return Mn($n.basic, t);
      case "xxxx":
        return Mn(
          $n.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Mn(
          $n.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Mn($n.extended, t);
    }
  }
  set(t, a, s) {
    return a.timestampIsSet ? t : ot(
      t,
      t.getTime() - Cl(t) - s
    );
  }
}
class mb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 40);
    xe(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Td(t);
  }
  set(t, a, s) {
    return [ot(t, s * 1e3), { timestampIsSet: !0 }];
  }
}
class vb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 20);
    xe(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Td(t);
  }
  set(t, a, s) {
    return [ot(t, s), { timestampIsSet: !0 }];
  }
}
const pb = {
  G: new Py(),
  y: new Ry(),
  Y: new Fy(),
  R: new Vy(),
  u: new Ly(),
  Q: new Ny(),
  q: new zy(),
  M: new By(),
  L: new Wy(),
  w: new Hy(),
  I: new qy(),
  d: new Ky(),
  D: new Zy(),
  E: new Xy(),
  e: new Jy(),
  c: new Qy(),
  i: new tb(),
  a: new nb(),
  b: new ab(),
  B: new sb(),
  h: new lb(),
  H: new rb(),
  K: new ib(),
  k: new ob(),
  m: new ub(),
  s: new cb(),
  S: new db(),
  X: new fb(),
  x: new hb(),
  t: new mb(),
  T: new vb()
}, gb = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, yb = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, bb = /^'([^]*?)'?$/, wb = /''/g, kb = /\S/, xb = /[a-zA-Z]/;
function ei(e, n, t, a) {
  var k, y, h, g, x, S, C, _;
  const s = () => ot((a == null ? void 0 : a.in) || t, NaN), l = Cy(), r = (a == null ? void 0 : a.locale) ?? l.locale ?? bd, i = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((y = (k = a == null ? void 0 : a.locale) == null ? void 0 : k.options) == null ? void 0 : y.firstWeekContainsDate) ?? l.firstWeekContainsDate ?? ((g = (h = l.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, o = (a == null ? void 0 : a.weekStartsOn) ?? ((S = (x = a == null ? void 0 : a.locale) == null ? void 0 : x.options) == null ? void 0 : S.weekStartsOn) ?? l.weekStartsOn ?? ((_ = (C = l.locale) == null ? void 0 : C.options) == null ? void 0 : _.weekStartsOn) ?? 0;
  if (!n)
    return e ? s() : Ne(t, a == null ? void 0 : a.in);
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: r
  }, c = [new Ay(a == null ? void 0 : a.in, t)], f = n.match(yb).map((O) => {
    const I = O[0];
    if (I in Jr) {
      const D = Jr[I];
      return D(O, r.formatLong);
    }
    return O;
  }).join("").match(gb), p = [];
  for (let O of f) {
    !(a != null && a.useAdditionalWeekYearTokens) && xd(O) && Qr(O, n, e), !(a != null && a.useAdditionalDayOfYearTokens) && kd(O) && Qr(O, n, e);
    const I = O[0], D = pb[I];
    if (D) {
      const { incompatibleTokens: B } = D;
      if (Array.isArray(B)) {
        const ne = p.find(
          (W) => B.includes(W.token) || W.token === I
        );
        if (ne)
          throw new RangeError(
            `The format string mustn't contain \`${ne.fullToken}\` and \`${O}\` at the same time`
          );
      } else if (D.incompatibleTokens === "*" && p.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${O}\` and any other token at the same time`
        );
      p.push({ token: I, fullToken: O });
      const Y = D.run(
        e,
        O,
        r.match,
        u
      );
      if (!Y)
        return s();
      c.push(Y.setter), e = Y.rest;
    } else {
      if (I.match(xb))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + I + "`"
        );
      if (O === "''" ? O = "'" : I === "'" && (O = Sb(O)), e.indexOf(O) === 0)
        e = e.slice(O.length);
      else
        return s();
    }
  }
  if (e.length > 0 && kb.test(e))
    return s();
  const d = c.map((O) => O.priority).sort((O, I) => I - O).filter((O, I, D) => D.indexOf(O) === I).map(
    (O) => c.filter((I) => I.priority === O).sort((I, D) => D.subPriority - I.subPriority)
  ).map((O) => O[0]);
  let b = Ne(t, a == null ? void 0 : a.in);
  if (isNaN(+b)) return s();
  const m = {};
  for (const O of d) {
    if (!O.validate(b, u))
      return s();
    const I = O.set(b, m, u);
    Array.isArray(I) ? (b = I[0], Object.assign(m, I[1])) : b = I;
  }
  return b;
}
function Sb(e) {
  return e.match(bb)[1].replace(wb, "'");
}
function eu(e, n, t) {
  const [a, s] = Hs(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return +ga(a) == +ga(s);
}
function Cd(e, n, t) {
  return nn(e, -n, t);
}
function Tb(e, n) {
  const t = (n == null ? void 0 : n.nearestTo) ?? 1;
  if (t < 1 || t > 30) return ot(e, NaN);
  const a = Ne(e, n == null ? void 0 : n.in), s = a.getSeconds() / 60, l = a.getMilliseconds() / 1e3 / 60, r = a.getMinutes() + s + l, i = (n == null ? void 0 : n.roundingMethod) ?? "round", u = _g(i)(r / t) * t;
  return a.setMinutes(u, 0, 0), a;
}
function Dd(e, n, t) {
  const a = Ne(e, t == null ? void 0 : t.in), s = a.getFullYear(), l = a.getDate(), r = ot(e, 0);
  r.setFullYear(s, n, 15), r.setHours(0, 0, 0, 0);
  const i = My(r);
  return a.setMonth(n, Math.min(l, i)), a;
}
function je(e, n, t) {
  let a = Ne(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? ot(e, NaN) : (n.year != null && a.setFullYear(n.year), n.month != null && (a = Dd(a, n.month)), n.date != null && a.setDate(n.date), n.hours != null && a.setHours(n.hours), n.minutes != null && a.setMinutes(n.minutes), n.seconds != null && a.setSeconds(n.seconds), n.milliseconds != null && a.setMilliseconds(n.milliseconds), a);
}
function $b(e, n, t) {
  const a = Ne(e, t == null ? void 0 : t.in);
  return a.setMilliseconds(n), a;
}
function Mb(e, n, t) {
  const a = Ne(e, t == null ? void 0 : t.in);
  return a.setSeconds(n), a;
}
function mn(e, n, t) {
  const a = Ne(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? ot(e, NaN) : (a.setFullYear(n), a);
}
function ts(e, n, t) {
  return pn(e, -n, t);
}
function Cb(e, n, t) {
  const {
    years: a = 0,
    months: s = 0,
    weeks: l = 0,
    days: r = 0,
    hours: i = 0,
    minutes: o = 0,
    seconds: u = 0
  } = n, c = ts(e, s + a * 12, t), f = Cd(c, r + l * 7, t), p = o + i * 60, b = (u + p * 60) * 1e3;
  return ot(e, +f - b);
}
function Od(e, n, t) {
  return Oi(e, -n, t);
}
function Db(e, n, t = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: t
  }).format(n).split(/\s/g).slice(2).join(" ");
}
const wr = {}, $s = {};
function ya(e, n) {
  try {
    const a = (wr[e] || (wr[e] = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format))(n).split("GMT")[1];
    return a in $s ? $s[a] : tu(a, a.split(":"));
  } catch {
    if (e in $s) return $s[e];
    const t = e == null ? void 0 : e.match(Ob);
    return t ? tu(e, t.slice(1)) : NaN;
  }
}
const Ob = /([+-]\d\d):?(\d\d)?/;
function tu(e, n) {
  const t = +(n[0] || 0), a = +(n[1] || 0), s = +(n[2] || 0) / 60;
  return $s[e] = t * 60 + a > 0 ? t * 60 + a + s : t * 60 - a - s;
}
class Dn extends Date {
  //#region static
  constructor(...n) {
    super(), n.length > 1 && typeof n[n.length - 1] == "string" && (this.timeZone = n.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(ya(this.timeZone, this)) ? this.setTime(NaN) : n.length ? typeof n[0] == "number" && (n.length === 1 || n.length === 2 && typeof n[1] != "number") ? this.setTime(n[0]) : typeof n[0] == "string" ? this.setTime(+new Date(n[0])) : n[0] instanceof Date ? this.setTime(+n[0]) : (this.setTime(+new Date(...n)), _d(this), ti(this)) : this.setTime(Date.now());
  }
  static tz(n, ...t) {
    return t.length ? new Dn(...t, n) : new Dn(Date.now(), n);
  }
  //#endregion
  //#region time zone
  withTimeZone(n) {
    return new Dn(+this, n);
  }
  getTimezoneOffset() {
    const n = -ya(this.timeZone, this);
    return n > 0 ? Math.floor(n) : Math.ceil(n);
  }
  //#endregion
  //#region time
  setTime(n) {
    return Date.prototype.setTime.apply(this, arguments), ti(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](n) {
    return new Dn(+new Date(n), this.timeZone);
  }
  //#endregion
}
const nu = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!nu.test(e)) return;
  const n = e.replace(nu, "$1UTC");
  Dn.prototype[n] && (e.startsWith("get") ? Dn.prototype[e] = function() {
    return this.internal[n]();
  } : (Dn.prototype[e] = function() {
    return Date.prototype[n].apply(this.internal, arguments), _b(this), +this;
  }, Dn.prototype[n] = function() {
    return Date.prototype[n].apply(this, arguments), ti(this), +this;
  }));
});
function ti(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-ya(e.timeZone, e) * 60));
}
function _b(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), _d(e);
}
function _d(e) {
  const n = ya(e.timeZone, e), t = n > 0 ? Math.floor(n) : Math.ceil(n), a = /* @__PURE__ */ new Date(+e);
  a.setUTCHours(a.getUTCHours() - 1);
  const s = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), l = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), r = s - l, i = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  r && i && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + r);
  const o = s - t;
  o && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + o);
  const u = /* @__PURE__ */ new Date(+e);
  u.setUTCSeconds(0);
  const c = s > 0 ? u.getSeconds() : (u.getSeconds() - 60) % 60, f = Math.round(-(ya(e.timeZone, e) * 60)) % 60;
  (f || c) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + f), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + f + c));
  const p = ya(e.timeZone, e), d = p > 0 ? Math.floor(p) : Math.ceil(p), m = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - d, k = d !== t, y = m - o;
  if (k && y) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + y);
    const h = ya(e.timeZone, e), g = h > 0 ? Math.floor(h) : Math.ceil(h), x = d - g;
    x && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + x), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + x));
  }
}
class Ya extends Dn {
  //#region static
  static tz(n, ...t) {
    return t.length ? new Ya(...t, n) : new Ya(Date.now(), n);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [n, t, a] = this.tzComponents(), s = `${n}${t}:${a}`;
    return this.internal.toISOString().slice(0, -1) + s;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [n, t, a, s] = this.internal.toUTCString().split(" ");
    return `${n == null ? void 0 : n.slice(0, -1)} ${a} ${t} ${s}`;
  }
  toTimeString() {
    const n = this.internal.toUTCString().split(" ")[4], [t, a, s] = this.tzComponents();
    return `${n} GMT${t}${a}${s} (${Db(this.timeZone, this)})`;
  }
  toLocaleString(n, t) {
    return Date.prototype.toLocaleString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(n, t) {
    return Date.prototype.toLocaleDateString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(n, t) {
    return Date.prototype.toLocaleTimeString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const n = this.getTimezoneOffset(), t = n > 0 ? "-" : "+", a = String(Math.floor(Math.abs(n) / 60)).padStart(2, "0"), s = String(Math.abs(n) % 60).padStart(2, "0");
    return [t, a, s];
  }
  //#endregion
  withTimeZone(n) {
    return new Ya(+this, n);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](n) {
    return new Ya(+new Date(n), this.timeZone);
  }
  //#endregion
}
function Us() {
  return xt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      xt("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      xt("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      xt("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      xt("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
function Eb() {
  return xt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      xt("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      xt("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
function Ed() {
  return xt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      xt("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function Id() {
  return xt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      xt("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
function Ad() {
  return xt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      xt("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      xt("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
function Pd() {
  return xt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      xt("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function Rd() {
  return xt(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      xt("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
const Fd = Symbol("ContextKey"), Ib = (e, n) => {
  const { setTimeModelValue: t } = Dt(), a = $0(e), s = ee(null), l = ka({
    menuFocused: !1,
    shiftKeyInMenu: !1,
    isInputFocused: !1,
    isTextInputDate: !1,
    arrowNavigationLevel: 0
  }), r = a.getDate(/* @__PURE__ */ new Date()), i = ee(""), o = ee([{ month: Ze(r), year: We(r) }]), u = ka({ hours: 0, minutes: 0, seconds: 0 });
  t(u, null, r, a.range.value.enabled);
  const c = T({
    get: () => s.value,
    set: (m) => {
      s.value = m;
    }
  }), f = T(
    () => (m) => o.value[m] ? o.value[m].month : 0
  ), p = T(
    () => (m) => o.value[m] ? o.value[m].year : 0
  ), d = (m, k) => {
    l[m] = k;
  }, b = () => {
    t(u, c.value, r, a.range.value.enabled);
  };
  ea(Fd, {
    rootProps: e,
    defaults: a,
    modelValue: c,
    state: li(l),
    rootEmit: n,
    calendars: o,
    month: f,
    year: p,
    time: u,
    today: r,
    inputValue: i,
    setState: d,
    updateTime: b,
    getDate: a.getDate
  });
}, Ke = () => {
  const e = yn(Fd);
  if (!e)
    throw new Error("Can't use context");
  return e;
};
var fn = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(fn || {}), wa = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(wa || {}), Lt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Lt || {});
const Ab = ["timestamp", "date", "iso"];
var hn = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(hn || {}), ct = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(ct || {}), Ha = /* @__PURE__ */ ((e) => (e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))(Ha || {}), Vd = /* @__PURE__ */ ((e) => (e[e.Sunday = 0] = "Sunday", e[e.Monday = 1] = "Monday", e[e.Tuesday = 2] = "Tuesday", e[e.Wednesday = 3] = "Wednesday", e[e.Thursday = 4] = "Thursday", e[e.Friday = 5] = "Friday", e[e.Saturday = 6] = "Saturday", e))(Vd || {});
const Pb = () => {
  const { rootProps: e, state: n } = Ke(), t = T(() => n.arrowNavigationLevel), a = ee(-1), s = ee(-1);
  Le(t, (h, g) => {
    y(h === 0 && g > 0);
  });
  const l = ee([]), r = ee(/* @__PURE__ */ new Map()), i = () => {
    const h = Array.from(
      document.querySelectorAll(`[data-dp-action-element="${t.value}"]`)
    ), g = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ new Map();
    for (const S of h) {
      const C = S.getBoundingClientRect(), _ = C.top, O = C.left;
      g.has(_) || g.set(_, []), g.get(_).push(S), x.set(S, { row: _, col: O });
    }
    l.value = Array.from(g.entries()).sort((S, C) => S[0] - C[0]).map(([S, C]) => o(C, x)), r.value = x;
  }, o = (h, g) => h.sort((x, S) => {
    const C = g.get(x), _ = g.get(S);
    return C.col - _.col;
  }), u = (h, g) => {
    t.value === 0 && (a.value = h, s.value = g);
  }, c = (h) => {
    if (![ct.arrowUp, ct.arrowDown, ct.arrowLeft, ct.arrowRight].includes(h.key))
      return;
    i(), h.preventDefault();
    const g = document.activeElement;
    if (!(g != null && g.hasAttribute("data-dp-action-element")))
      return;
    let x = -1, S = -1;
    for (let C = 0; C < l.value.length; C++) {
      const _ = l.value[C].indexOf(g);
      if (_ !== -1) {
        x = C, S = _;
        break;
      }
    }
    if (x !== -1)
      switch (h.key) {
        case ct.arrowLeft:
          return f(x, S);
        case ct.arrowRight:
          return p(x, S);
        case ct.arrowUp:
          return d(x, S);
        case ct.arrowDown:
          return b(x, S);
        default:
          return;
      }
  }, f = (h, g) => {
    if (g > 0) {
      const x = l.value[h][g - 1];
      u(h, g - 1), x && x.focus();
    }
  }, p = (h, g) => {
    if (g < l.value[h].length - 1) {
      const x = l.value[h][g + 1];
      u(h, g + 1), x && x.focus();
    }
  }, d = (h, g) => {
    if (h > 0) {
      const x = l.value[h - 1], S = Math.min(g, x.length - 1), C = x[S];
      u(h - 1, S), C && C.focus();
    }
  }, b = (h, g) => {
    if (h < l.value.length - 1) {
      const x = l.value[h + 1], S = Math.min(g, x.length - 1), C = x[S];
      u(h + 1, S), C && C.focus();
    }
  }, m = () => {
    Ge().then(() => {
      var g;
      i();
      const h = (g = l.value[a.value]) == null ? void 0 : g[s.value];
      h && k(h);
    });
  }, k = (h) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        h.focus({ preventScroll: !0 });
      });
    });
  }, y = (h) => {
    if (h)
      return m();
    const g = document.querySelector(`[data-dp-element-active="${t.value}"]`);
    if (g && !h)
      k(g);
    else {
      const x = document.querySelector(`[data-dp-action-element="${t.value}"]`);
      x && k(x);
    }
  };
  et(() => {
    e.arrowNavigation && (y(!1), document.addEventListener("keydown", c));
  }), Xt(() => {
    e.arrowNavigation && document.removeEventListener("keydown", c);
  });
}, Rb = () => {
  const { checkPartialRangeValue: e, checkRangeEnabled: n, isValidDate: t } = on(), { convertType: a, errorMapper: s } = Dt(), {
    getDate: l,
    rootEmit: r,
    state: i,
    rootProps: o,
    inputValue: u,
    defaults: { textInput: c, range: f, multiDates: p, timeConfig: d, formats: b },
    modelValue: m,
    updateTime: k
  } = Ke(), { setTime: y, getWeekFromDate: h } = Ft(), { formatSelectedDate: g, formatForTextInput: x } = ra();
  Le(
    m,
    (V, Z) => {
      r("internal-model-change", m.value), JSON.stringify(Z ?? {}) !== JSON.stringify(V ?? {}) && k();
    },
    { deep: !0 }
  ), Le(f, (V, Z) => {
    V.enabled !== Z.enabled && (m.value = null);
  }), Le(
    () => b.value.input,
    () => {
      de();
    }
  );
  const S = (V) => V ? o.modelType ? ge(V) : {
    hours: An(V),
    minutes: Hn(V),
    seconds: d.value.enableSeconds ? la(V) : 0
  } : null, C = (V) => o.modelType ? ge(V) : { month: Ze(V), year: We(V) }, _ = (V) => Array.isArray(V) ? p.value.enabled ? V.map((Z) => O(Z, mn(l(), Z))) : n(
    () => [
      mn(l(), V[0]),
      V[1] ? mn(l(), V[1]) : e(f.value.partialRange)
    ],
    f.value.enabled
  ) : mn(l(), +V), O = (V, Z) => (typeof V == "string" || typeof V == "number") && o.modelType ? he(V) : Z, I = (V) => Array.isArray(V) ? [
    O(V[0], y(V[0])),
    O(V[1], y(V[1]))
  ] : O(V, y(V)), D = (V) => {
    const Z = je(l(), { date: 1 });
    return Array.isArray(V) ? p.value.enabled ? V.map(
      (me) => O(me, je(Z, { month: +me.month, year: +me.year }))
    ) : n(
      () => [
        O(V[0], je(Z, { month: +V[0].month, year: +V[0].year })),
        O(
          V[1],
          V[1] ? je(Z, { month: +V[1].month, year: +V[1].year }) : e(f.value.partialRange)
        )
      ],
      f.value.enabled
    ) : O(V, je(Z, { month: +V.month, year: +V.year }));
  }, B = (V) => {
    if (Array.isArray(V))
      return V.map((Z) => he(Z));
    throw new Error(s.dateArr("multi-dates"));
  }, Y = (V) => {
    if (Array.isArray(V) && f.value.enabled) {
      const Z = V[0], me = V[1];
      return [
        l(Array.isArray(Z) ? Z[0] : null),
        Array.isArray(me) && me.length ? l(me[0]) : null
      ];
    }
    return l(V[0]);
  }, ne = (V) => o.modelAuto ? Array.isArray(V) ? [he(V[0]), he(V[1])] : o.autoApply ? [he(V)] : [he(V), null] : Array.isArray(V) ? n(
    () => V[1] ? [
      he(V[0]),
      V[1] ? he(V[1]) : e(f.value.partialRange)
    ] : [he(V[0])],
    f.value.enabled
  ) : he(V), W = () => {
    Array.isArray(m.value) && f.value.enabled && m.value.length === 1 && m.value.push(e(f.value.partialRange));
  }, ae = () => {
    const V = m.value;
    return [
      ge(V[0]),
      V[1] ? ge(V[1]) : e(f.value.partialRange)
    ];
  }, G = () => Array.isArray(m.value) ? m.value[1] ? ae() : ge(a(m.value[0])) : [], j = () => (m.value || []).map((V) => ge(V)), se = (V = !1) => (V || W(), o.modelAuto ? G() : p.value.enabled ? j() : Array.isArray(m.value) ? n(() => ae(), f.value.enabled) : ge(a(m.value))), U = (V) => !V || Array.isArray(V) && !V.length ? null : o.timePicker ? I(a(V)) : o.monthPicker ? D(a(V)) : o.yearPicker ? _(a(V)) : p.value.enabled ? B(a(V)) : o.weekPicker ? Y(a(V)) : ne(a(V)), N = (V) => {
    if (i.isTextInputDate) return;
    const Z = U(V);
    t(a(Z)) ? (m.value = a(Z), de()) : (m.value = null, u.value = "");
  }, J = () => m.value ? p.value.enabled ? m.value.map((V) => g(V)).join("; ") : c.value.enabled ? x() : g(m.value) : "", de = () => {
    u.value = J();
  }, he = (V) => o.modelType ? Ab.includes(o.modelType) ? l(V) : o.modelType === "format" && typeof b.value.input == "string" ? ei(V, b.value.input, l(), { locale: o.locale }) : ei(V, o.modelType, l(), { locale: o.locale }) : l(V), ge = (V) => V ? o.modelType ? o.modelType === "timestamp" ? +V : o.modelType === "iso" ? V.toISOString() : o.modelType === "format" && typeof b.value.input == "string" ? g(V) : g(V, o.modelType) : V : null, $e = (V) => {
    r("update:model-value", V);
  }, we = (V) => Array.isArray(m.value) ? p.value.enabled ? m.value.map((Z) => V(Z)) : [V(m.value[0]), m.value[1] ? V(m.value[1]) : null] : V(a(m.value)), X = () => {
    if (Array.isArray(m.value)) {
      const V = h(m.value[0], o.weekStart), Z = m.value[1] ? h(m.value[1], o.weekStart) : [];
      return [V.map((me) => l(me)), Z.map((me) => l(me))];
    }
    return h(m.value, o.weekStart).map((V) => l(V));
  }, ve = (V) => $e(a(we(V))), Ce = () => r("update:model-value", X());
  return {
    checkBeforeEmit: () => m.value ? f.value.enabled ? f.value.partialRange ? m.value.length >= 1 : m.value.length === 2 : !!m.value : !1,
    parseExternalModelValue: N,
    formatInputValue: de,
    emitModelValue: () => (de(), o.monthPicker ? ve(C) : o.timePicker ? ve(S) : o.yearPicker ? ve(We) : o.weekPicker ? Ce() : $e(se()))
  };
}, qs = () => {
  const {
    defaults: { transitions: e }
  } = Ke(), n = T(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), t = T(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: n, showTransition: !!e.value, menuTransition: t };
}, js = (e) => {
  const {
    today: n,
    time: t,
    modelValue: a,
    defaults: { range: s }
  } = Ke(), { setTimeModelValue: l } = Dt();
  Le(
    s,
    (r, i) => {
      r.enabled !== i.enabled && l(t, a.value, n, s.value.enabled);
    },
    { deep: !0 }
  ), Le(
    a,
    (r, i) => {
      e && JSON.stringify(r ?? {}) !== JSON.stringify(i ?? {}) && e();
    },
    { deep: !0 }
  );
}, on = () => {
  const {
    defaults: { safeDates: e, range: n, multiDates: t, filters: a, timeConfig: s },
    rootProps: l,
    getDate: r
  } = Ke(), { getMapKeyType: i, getMapDate: o, errorMapper: u, convertType: c } = Dt(), { isDateBefore: f, isDateAfter: p, isDateEqual: d, resetDate: b, getDaysInBetween: m, setTimeValue: k, getTimeObj: y, setTime: h } = Ft(), g = (K) => e.value.disabledDates ? typeof e.value.disabledDates == "function" ? e.value.disabledDates(r(K)) : !!o(K, e.value.disabledDates) : !1, x = (K) => e.value.maxDate ? l.yearPicker ? We(K) > We(e.value.maxDate) : p(K, e.value.maxDate) : !1, S = (K) => e.value.minDate ? l.yearPicker ? We(K) < We(e.value.minDate) : f(K, e.value.minDate) : !1, C = (K) => {
    var L;
    if (!K) return !1;
    const oe = x(K), ye = S(K), A = g(K), z = a.value.months.map((fe) => +fe).includes(Ze(K)), $ = (L = a.value.weekDays) != null && L.length ? a.value.weekDays.some((fe) => +fe === $y(K)) : !1, F = B(K), P = We(K), Q = P < +l.yearRange[0] || P > +l.yearRange[1];
    return !(oe || ye || A || z || Q || $ || F);
  }, _ = (K, oe) => f(...Ce(e.value.minDate, K, oe)) || d(...Ce(e.value.minDate, K, oe)), O = (K, oe) => p(...Ce(e.value.maxDate, K, oe)) || d(...Ce(e.value.maxDate, K, oe)), I = (K, oe, ye) => {
    let A = !1;
    return e.value.maxDate && ye && O(K, oe) && (A = !0), e.value.minDate && !ye && _(K, oe) && (A = !0), A;
  }, D = (K, oe, ye, A) => {
    let z = !1;
    return A && (e.value.minDate || e.value.maxDate) ? e.value.minDate && e.value.maxDate ? z = I(K, oe, ye) : (e.value.minDate && _(K, oe) || e.value.maxDate && O(K, oe)) && (z = !0) : z = !0, z;
  }, B = (K) => Array.isArray(e.value.allowedDates) && !e.value.allowedDates.length ? !0 : e.value.allowedDates ? !o(
    K,
    e.value.allowedDates,
    i(l.monthPicker, l.yearPicker)
  ) : !1, Y = (K) => !C(K), ne = (K) => n.value.noDisabledRange ? !_i({ start: K[0], end: K[1] }).some((oe) => Y(oe)) : !0, W = (K) => {
    if (K) {
      const oe = We(K);
      return oe >= +l.yearRange[0] && oe <= l.yearRange[1];
    }
    return !0;
  }, ae = (K, oe) => !!(Array.isArray(K) && K[oe] && (n.value.maxRange || n.value.minRange) && W(K[oe])), G = (K, oe, ye = 0) => {
    if (ae(oe, ye) && W(K)) {
      const A = vd(K, oe[ye]), z = m(oe[ye], K), $ = z.length === 1 ? 0 : z.filter((P) => Y(P)).length, F = Math.abs(A) - (n.value.minMaxRawRange ? 0 : $);
      if (n.value.minRange && n.value.maxRange)
        return F >= +n.value.minRange && F <= +n.value.maxRange;
      if (n.value.minRange) return F >= +n.value.minRange;
      if (n.value.maxRange) return F <= +n.value.maxRange;
    }
    return !0;
  }, j = () => !s.value.enableTimePicker || l.monthPicker || l.yearPicker || s.value.ignoreTimeValidation, se = (K) => Array.isArray(K) ? [K[0] ? k(K[0]) : null, K[1] ? k(K[1]) : null] : k(K), U = (K, oe, ye) => oe ? K.find(
    (A) => +A.hours === An(oe) && A.minutes === "*" ? !0 : +A.minutes === Hn(oe) && +A.hours === An(oe)
  ) && ye : !1, N = (K, oe, ye) => {
    const [A, z] = K, [$, F] = oe;
    return !U(A, $, ye) && !U(z, F, ye) && ye;
  }, J = (K, oe) => {
    const ye = Array.isArray(oe) ? oe : [oe];
    return Array.isArray(l.disabledTimes) ? Array.isArray(l.disabledTimes[0]) ? N(l.disabledTimes, ye, K) : !ye.some((A) => U(l.disabledTimes, A, K)) : K;
  }, de = (K, oe) => {
    const ye = Array.isArray(oe) ? [y(oe[0]), oe[1] ? y(oe[1]) : void 0] : y(oe), A = !l.disabledTimes(ye);
    return K && A;
  }, he = (K, oe) => l.disabledTimes ? Array.isArray(l.disabledTimes) ? J(oe, K) : de(oe, K) : oe, ge = (K) => {
    let oe = !0;
    if (!K || j()) return !0;
    const ye = !e.value.minDate && !e.value.maxDate ? se(K) : K;
    return (l.maxTime || e.value.maxDate) && (oe = Z(
      l.maxTime,
      e.value.maxDate,
      "max",
      c(ye),
      oe
    )), (l.minTime || e.value.minDate) && (oe = Z(
      l.minTime,
      e.value.minDate,
      "min",
      c(ye),
      oe
    )), he(K, oe);
  }, $e = (K) => {
    if (!l.monthPicker) return !0;
    let oe = !0;
    const ye = r(b(K));
    if (e.value.minDate && e.value.maxDate) {
      const A = r(b(e.value.minDate)), z = r(b(e.value.maxDate));
      return p(ye, A) && f(ye, z) || d(ye, A) || d(ye, z);
    }
    if (e.value.minDate) {
      const A = r(b(e.value.minDate));
      oe = p(ye, A) || d(ye, A);
    }
    if (e.value.maxDate) {
      const A = r(b(e.value.maxDate));
      oe = f(ye, A) || d(ye, A);
    }
    return oe;
  }, we = T(() => (K) => !s.value.enableTimePicker || s.value.ignoreTimeValidation ? !0 : ge(K)), X = T(() => (K) => l.monthPicker ? Array.isArray(K) && (n.value.enabled || t.value.enabled) ? !K.filter((oe) => !$e(oe)).length : $e(K) : !0), ve = (K, oe, ye) => {
    if (!oe || ye && !e.value.maxDate || !ye && !e.value.minDate) return !1;
    const A = ye ? pn(K, 1) : ts(K, 1), z = [Ze(A), We(A)];
    return ye ? !O(...z) : !_(...z);
  }, Ce = (K, oe, ye) => [je(r(K), { date: 1 }), je(r(), { month: oe, year: ye, date: 1 })], V = (K, oe, ye, A) => {
    if (!K) return !0;
    if (A) {
      const z = ye === "max" ? Wn(K, oe) : Cn(K, oe), $ = { seconds: 0, milliseconds: 0 };
      return z || Wa(je(K, $), je(oe, $));
    }
    return ye === "max" ? K.getTime() <= oe.getTime() : K.getTime() >= oe.getTime();
  }, Z = (K, oe, ye, A, z) => {
    if (Array.isArray(A)) {
      const F = me(K, A[0], oe), P = me(K, A[1], oe);
      return V(A[0], F, ye, !!oe) && V(A[1], P, ye, !!oe) && z;
    }
    const $ = me(K, A, oe);
    return V(A, $, ye, !!oe) && z;
  }, me = (K, oe, ye) => K ? h(K, oe) : r(ye ?? oe);
  return {
    isDisabled: Y,
    validateDate: C,
    validateMonthYearInRange: D,
    isDateRangeAllowed: ne,
    checkMinMaxRange: G,
    isValidTime: ge,
    validateMonthYear: ve,
    validateMinDate: _,
    validateMaxDate: O,
    isValidDate: (K) => Array.isArray(K) ? Cs(K[0]) && (K[1] ? Cs(K[1]) : !0) : K ? Cs(K) : !1,
    checkPartialRangeValue: (K) => {
      if (K) return null;
      throw new Error(u.prop("partial-range"));
    },
    checkRangeEnabled: (K, oe) => {
      if (oe) return K();
      throw new Error(u.prop("range"));
    },
    checkMinMaxValue: (K, oe, ye) => {
      const A = ye != null, z = oe != null;
      if (!A && !z) return !1;
      const $ = +ye, F = +oe;
      return A && z ? +K > $ || +K < F : A ? +K > $ : z ? +K < F : !1;
    },
    isTimeValid: we,
    isMonthValid: X
  };
}, Fb = (e) => {
  const {
    rootEmit: n,
    rootProps: t,
    defaults: { timeConfig: a, flow: s }
  } = Ke(), l = ee(0), r = ka({
    [wa.timePicker]: !a.value.enableTimePicker || t.timePicker || t.monthPicker,
    [wa.calendar]: !1,
    [wa.header]: !1
  }), i = T(() => t.monthPicker || t.timePicker), o = (d) => {
    var b, m;
    if ((m = (b = s.value) == null ? void 0 : b.steps) != null && m.length) {
      if (!d && i.value) return p();
      r[d] = !0, Object.keys(r).filter((k) => !r[k]).length || p();
    }
  }, u = () => {
    var d, b, m, k;
    (b = (d = s.value) == null ? void 0 : d.steps) != null && b.length && l.value !== -1 && (l.value += 1, n("flow-step", l.value), p()), ((k = (m = s.value) == null ? void 0 : m.steps) == null ? void 0 : k.length) === l.value && Ge().then(() => c());
  }, c = () => {
    l.value = -1;
  }, f = (d, b, ...m) => {
    var k, y, h;
    ((k = s.value) == null ? void 0 : k.steps[l.value]) === d && e.value && ((h = (y = e.value)[b]) == null || h.call(y, ...m));
  }, p = (d = 0) => {
    var m;
    d && (l.value += d), f(Lt.month, "toggleMonthPicker", !0), f(Lt.year, "toggleYearPicker", !0), f(Lt.calendar, "toggleTimePicker", !1, !0), f(Lt.time, "toggleTimePicker", !0, !0);
    const b = (m = s.value) == null ? void 0 : m.steps[l.value];
    (b === Lt.hours || b === Lt.minutes || b === Lt.seconds) && f(b, "toggleTimePicker", !0, !0, b);
  };
  return { childMount: o, updateFlowStep: u, resetFlow: c, handleFlow: p, flowStep: l };
};
function kr(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
function ys(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (a === "formatting" && e.formattingValues) {
      const r = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : r;
      s = e.formattingValues[i] || e.formattingValues[r];
    } else {
      const r = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[i] || e.values[r];
    }
    const l = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[l];
  };
}
function bs(e) {
  return (n, t = {}) => {
    const a = t.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], l = n.match(s);
    if (!l)
      return null;
    const r = l[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(i) ? Lb(i, (f) => f.test(r)) : (
      // [TODO] -- I challenge you to fix the type
      Vb(i, (f) => f.test(r))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(r.length);
    return { value: u, rest: c };
  };
}
function Vb(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function Lb(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function Nb(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const s = a[0], l = n.match(e.parsePattern);
    if (!l) return null;
    let r = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    r = t.valueCallback ? t.valueCallback(r) : r;
    const i = n.slice(s.length);
    return { value: r, rest: i };
  };
}
const zb = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Bb = (e, n, t) => {
  let a;
  const s = zb[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
}, Wb = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Yb = (e, n, t, a) => Wb[e], Hb = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ub = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, qb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, jb = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Gb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Kb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Zb = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Xb = {
  ordinalNumber: Zb,
  era: ys({
    values: Hb,
    defaultWidth: "wide"
  }),
  quarter: ys({
    values: Ub,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ys({
    values: qb,
    defaultWidth: "wide"
  }),
  day: ys({
    values: jb,
    defaultWidth: "wide"
  }),
  dayPeriod: ys({
    values: Gb,
    defaultWidth: "wide",
    formattingValues: Kb,
    defaultFormattingWidth: "wide"
  })
}, Jb = /^(\d+)(th|st|nd|rd)?/i, Qb = /\d+/i, e0 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, t0 = {
  any: [/^b/i, /^(a|c)/i]
}, n0 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, a0 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, s0 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, l0 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, r0 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, i0 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, o0 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, u0 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, c0 = {
  ordinalNumber: Nb({
    matchPattern: Jb,
    parsePattern: Qb,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: bs({
    matchPatterns: e0,
    defaultMatchWidth: "wide",
    parsePatterns: t0,
    defaultParseWidth: "any"
  }),
  quarter: bs({
    matchPatterns: n0,
    defaultMatchWidth: "wide",
    parsePatterns: a0,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: bs({
    matchPatterns: s0,
    defaultMatchWidth: "wide",
    parsePatterns: l0,
    defaultParseWidth: "any"
  }),
  day: bs({
    matchPatterns: r0,
    defaultMatchWidth: "wide",
    parsePatterns: i0,
    defaultParseWidth: "any"
  }),
  dayPeriod: bs({
    matchPatterns: o0,
    defaultMatchWidth: "any",
    parsePatterns: u0,
    defaultParseWidth: "any"
  })
}, d0 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, f0 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, h0 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, m0 = {
  date: kr({
    formats: d0,
    defaultWidth: "full"
  }),
  time: kr({
    formats: f0,
    defaultWidth: "full"
  }),
  dateTime: kr({
    formats: h0,
    defaultWidth: "full"
  })
}, v0 = {
  code: "en-US",
  formatDistance: Bb,
  formatLong: m0,
  formatRelative: Yb,
  localize: Xb,
  match: c0,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, au = {
  noDisabledRange: !1,
  showLastInRange: !0,
  minMaxRawRange: !1,
  partialRange: !0,
  disableTimeRangeValidation: !1,
  maxRange: void 0,
  minRange: void 0,
  autoRange: void 0,
  fixedStart: !1,
  fixedEnd: !1,
  autoSwitchStartEnd: !0
}, p0 = {
  allowStopPropagation: !0,
  closeOnScroll: !1,
  modeHeight: 255,
  allowPreventDefault: !1,
  closeOnClearValue: !0,
  closeOnAutoApply: !0,
  noSwipe: !1,
  keepActionRow: !1,
  onClickOutside: void 0,
  tabOutClosesMenu: !0,
  arrowLeft: void 0,
  keepViewOnOffsetClick: !1,
  timeArrowHoldThreshold: 0,
  shadowDom: !1,
  mobileBreakpoint: 600,
  setDateOnMenuClose: !1,
  escClose: !0,
  spaceConfirm: !0,
  monthChangeOnArrows: !0,
  monthChangeOnScroll: !0
}, su = {
  enterSubmit: !0,
  tabSubmit: !0,
  openMenu: "open",
  selectOnFocus: !1,
  rangeSeparator: " - ",
  escClose: !0,
  format: void 0,
  maskFormat: void 0,
  applyOnBlur: !1,
  separators: void 0
}, g0 = {
  dates: [],
  years: [],
  months: [],
  quarters: [],
  weeks: [],
  weekdays: [],
  options: { highlightDisabled: !1 }
}, y0 = {
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  selectBtnLabel: "Select",
  cancelBtnLabel: "Cancel",
  nowBtnLabel: "Now",
  nowBtnRound: void 0
}, b0 = {
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
  yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
  timeOverlay: (e) => `${e} overlay`
}, lu = {
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down"
}, w0 = {
  weekDays: [],
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] }
}, k0 = {
  month: "LLL",
  year: "yyyy",
  weekDay: "EEEEEE",
  quarter: "MMMM",
  day: "d",
  input: void 0,
  preview: void 0
}, x0 = {
  enableTimePicker: !0,
  ignoreTimeValidation: !1,
  enableSeconds: !1,
  enableMinutes: !0,
  is24: !0,
  noHoursOverlay: !1,
  noMinutesOverlay: !1,
  noSecondsOverlay: !1,
  hoursGridIncrement: 1,
  minutesGridIncrement: 5,
  secondsGridIncrement: 5,
  hoursIncrement: 1,
  minutesIncrement: 1,
  secondsIncrement: 1,
  timePickerInline: !1,
  startTime: void 0
}, S0 = {
  flowStep: 0,
  menuWrapRef: null,
  collapse: !1
}, T0 = {
  weekStart: Vd.Monday,
  yearRange: () => [1900, 2100],
  ui: () => ({}),
  locale: () => v0,
  dark: !1,
  transitions: !0,
  hideNavigation: () => [],
  vertical: !1,
  hideMonthYearSelect: !1,
  disableYearSelect: !1,
  autoApply: !1,
  disabledDates: () => [],
  hideOffsetDates: !1,
  noToday: !1,
  markers: () => [],
  presetDates: () => [],
  preventMinMaxNavigation: !1,
  reverseYears: !1,
  weekPicker: !1,
  arrowNavigation: !1,
  monthPicker: !1,
  yearPicker: !1,
  quarterPicker: !1,
  timePicker: !1,
  modelAuto: !1,
  multiDates: !1,
  range: !1,
  inline: !1,
  sixWeeks: !1,
  focusStartDate: !1,
  yearFirst: !1,
  loading: !1,
  centered: !1
}, ru = {
  name: void 0,
  required: !1,
  autocomplete: "off",
  state: void 0,
  clearable: !0,
  alwaysClearable: !1,
  hideInputIcon: !1,
  id: void 0,
  inputmode: "none"
}, ol = {
  type: "local",
  hideOnOffsetDates: !1,
  label: "W"
}, $0 = (e) => {
  const { getMapKey: n, getMapKeyType: t, getTimeObjFromCurrent: a } = Dt();
  function s(j, se) {
    let U;
    return e.timezone ? U = new Ya(j ?? /* @__PURE__ */ new Date(), e.timezone) : U = j ? new Date(j) : /* @__PURE__ */ new Date(), se ? je(U, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }) : U;
  }
  const l = () => {
    const j = ne.value.enableSeconds ? ":ss" : "", se = ne.value.enableMinutes ? ":mm" : "";
    return ne.value.is24 ? `HH${se}${j}` : `hh${se}${j} aa`;
  }, r = () => {
    var j;
    return e.monthPicker ? "MM/yyyy" : e.timePicker ? l() : e.weekPicker ? `${((j = C.value) == null ? void 0 : j.type) === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : ne.value.enableTimePicker ? `MM/dd/yyyy, ${l()}` : "MM/dd/yyyy";
  }, i = (j) => a(s(), j, ne.value.enableSeconds), o = () => I.value.enabled ? ne.value.startTime && Array.isArray(ne.value.startTime) ? [i(ne.value.startTime[0]), i(ne.value.startTime[1])] : null : ne.value.startTime && !Array.isArray(ne.value.startTime) ? i(ne.value.startTime) : null, u = (j) => j ? typeof j == "boolean" ? j ? 2 : 0 : Math.max(+j, 2) : 0, c = (j) => {
    const se = t(e.monthPicker, e.yearPicker);
    return new Map(
      j.map((U) => {
        const N = s(U, f.value);
        return [n(N, se), N];
      })
    );
  }, f = T(() => e.monthPicker || e.yearPicker || e.quarterPicker), p = T(() => {
    const j = typeof e.multiCalendars == "object" && e.multiCalendars, se = {
      static: !0,
      solo: !1
    };
    if (!e.multiCalendars) return { ...se, count: u(!1) };
    const U = j ? e.multiCalendars : {}, N = j ? U.count ?? !0 : e.multiCalendars, J = u(N);
    return Object.assign(se, U, { count: J });
  }), d = T(() => o()), b = T(() => ({ ...b0, ...e.ariaLabels })), m = T(() => ({ ...w0, ...e.filters })), k = T(() => typeof e.transitions == "boolean" ? e.transitions ? lu : !1 : { ...lu, ...e.transitions }), y = T(() => ({ ...y0, ...e.actionRow })), h = T(() => typeof e.textInput == "object" ? {
    ...su,
    ...e.textInput,
    format: typeof e.textInput.format == "string" ? e.textInput.format : B.value.input,
    pattern: e.textInput.format ?? B.value.input,
    enabled: !0
  } : {
    ...su,
    format: B.value.input,
    pattern: B.value.input,
    enabled: e.textInput
  }), g = T(() => {
    const j = { input: !1 };
    return typeof e.inline == "object" ? { ...j, ...e.inline, enabled: !0 } : {
      enabled: e.inline,
      ...j
    };
  }), x = T(() => ({ ...p0, ...e.config })), S = T(() => typeof e.highlight == "function" ? e.highlight : {
    ...g0,
    ...e.highlight
  }), C = T(() => {
    var j, se;
    return typeof e.weekNumbers == "object" ? {
      type: ((j = e.weekNumbers) == null ? void 0 : j.type) ?? ol.type,
      hideOnOffsetDates: ((se = e.weekNumbers) == null ? void 0 : se.hideOnOffsetDates) ?? ol.hideOnOffsetDates,
      label: e.weekNumbers.label ?? ol.label
    } : e.weekNumbers ? ol : void 0;
  }), _ = T(() => {
    var j, se;
    return typeof e.multiDates == "boolean" ? { enabled: e.multiDates, dragSelect: !0, limit: null } : {
      enabled: !!e.multiDates,
      limit: (j = e.multiDates) != null && j.limit ? +e.multiDates.limit : null,
      dragSelect: ((se = e.multiDates) == null ? void 0 : se.dragSelect) ?? !0
    };
  }), O = T(() => {
    var j;
    return {
      minDate: e.minDate ? s(e.minDate) : null,
      maxDate: e.maxDate ? s(e.maxDate) : null,
      disabledDates: Array.isArray(e.disabledDates) ? c(e.disabledDates) : e.disabledDates,
      allowedDates: Array.isArray(e.allowedDates) ? c(e.allowedDates) : null,
      highlight: typeof S.value == "object" && Array.isArray(S.value.dates) ? c(S.value.dates) : S.value,
      markers: (j = e.markers) != null && j.length ? new Map(
        e.markers.map((se) => {
          const U = s(se.date);
          return [n(U, Ha.DATE), se];
        })
      ) : null
    };
  }), I = T(() => typeof e.range == "object" ? { enabled: !0, ...au, ...e.range } : {
    enabled: e.range,
    ...au
  }), D = T(() => ({
    ...Object.fromEntries(
      Object.keys(e.ui).map((j) => {
        const se = j, U = e.ui[se];
        if (se === "dayClass") return [se, e.ui[se]];
        const N = typeof e.ui[se] == "string" ? { [U]: !0 } : Object.fromEntries(U.map((J) => [J, !0]));
        return [j, N];
      })
    )
  })), B = T(() => {
    var j, se;
    return {
      ...k0,
      ...e.formats,
      input: ((j = e.formats) == null ? void 0 : j.input) ?? r(),
      preview: ((se = e.formats) == null ? void 0 : se.preview) ?? r()
    };
  }), Y = T(() => {
    if (e.teleport)
      return typeof e.teleport == "string" ? e.teleport : typeof e.teleport == "boolean" ? "body" : e.teleport;
  }), ne = T(() => ({ ...x0, ...e.timeConfig })), W = T(() => {
    if (e.flow)
      return { steps: [], partial: !1, ...e.flow };
  }), ae = T(() => {
    const j = h.value.enabled ? "text" : "none";
    return e.inputAttrs ? { ...ru, inputmode: j, ...e.inputAttrs } : { ...ru, inputmode: j };
  }), G = T(() => {
    var j, se, U, N, J, de;
    return {
      offset: ((j = e.floating) == null ? void 0 : j.offset) ?? 10,
      arrow: ((se = e.floating) == null ? void 0 : se.arrow) ?? !0,
      strategy: ((U = e.floating) == null ? void 0 : U.strategy) ?? void 0,
      placement: ((N = e.floating) == null ? void 0 : N.placement) ?? void 0,
      flip: ((J = e.floating) == null ? void 0 : J.flip) ?? !0,
      shift: ((de = e.floating) == null ? void 0 : de.shift) ?? !0
    };
  });
  return {
    transitions: k,
    multiCalendars: p,
    startTime: d,
    ariaLabels: b,
    filters: m,
    actionRow: y,
    textInput: h,
    inline: g,
    config: x,
    highlight: S,
    weekNumbers: C,
    range: I,
    safeDates: O,
    multiDates: _,
    ui: D,
    formats: B,
    teleport: Y,
    timeConfig: ne,
    flow: W,
    inputAttrs: ae,
    floatingConfig: G,
    getDate: s
  };
}, Dt = () => {
  const e = (h, g) => tn(h, g ?? Ha.DATE), n = (h, g) => h ? Ha.MONTH_AND_YEAR : g ? Ha.YEAR : Ha.DATE, t = (h, g, x) => g.get(e(h, x)), a = (h) => h, s = (h) => h === 0 ? h : !h || Number.isNaN(+h) ? null : +h, l = () => [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type='hidden'])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "[tabindex]:not([tabindex='-1'])",
    "[data-datepicker-instance]"
  ].join(", "), r = (h, g) => {
    let x = [...document.querySelectorAll(l())];
    x = x.filter((C) => !h.contains(C) || "datepicker-instance" in C.dataset);
    const S = x.indexOf(h);
    if (S >= 0 && (g ? S - 1 >= 0 : S + 1 <= x.length))
      return x[S + (g ? -1 : 1)];
  }, i = (h) => String(h).padStart(2, "0"), o = (h, g) => h == null ? void 0 : h.querySelector(`[data-dp-element="${g}"]`), u = (h, g, x = !1) => {
    h && g.allowStopPropagation && (x && h.stopImmediatePropagation(), h.stopPropagation());
  }, c = (h, g, x = !1, S) => {
    if (h.key === ct.enter || h.key === ct.space)
      return x && h.preventDefault(), g();
    if (S) return S(h);
  }, f = (h, g) => {
    g.allowStopPropagation && h.stopPropagation(), g.allowPreventDefault && h.preventDefault();
  }, p = (h) => {
    if (h)
      return [...h.querySelectorAll("input, button, select, textarea, a[href]")][0];
  }, d = () => "ontouchstart" in globalThis || navigator.maxTouchPoints > 0, b = (h) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][h], m = (h) => {
    const g = [], x = (S) => S.filter((C) => !!C);
    for (let S = 0; S < h.length; S += 3) {
      const C = [h[S], h[S + 1], h[S + 2]];
      g.push(x(C));
    }
    return g;
  }, k = {
    prop: (h) => `"${h}" prop must be enabled!`,
    dateArr: (h) => `You need to use array as "model-value" binding in order to support "${h}"`
  }, y = (h, g, x, S, C) => {
    const _ = {
      hours: An,
      minutes: Hn,
      seconds: la
    };
    if (!g) return S ? [_[h](x), _[h](x)] : _[h](x);
    if (Array.isArray(g) && S) {
      const O = g[0] ?? x, I = g[1];
      return [_[h](O), I ? _[h](I) : C[h][1] ?? _[h](x)];
    }
    return Array.isArray(g) && !S ? _[h](g[g.length - 1] ?? x) : _[h](g);
  };
  return {
    getMapKey: e,
    getMapKeyType: n,
    getMapDate: t,
    convertType: a,
    getNumVal: s,
    findNextFocusableElement: r,
    padZero: i,
    getElWithin: o,
    checkStopPropagation: u,
    checkKeyDown: c,
    handleEventPropagation: f,
    findFocusableEl: p,
    isTouchDevice: d,
    hoursToAmPmHours: b,
    getGroupedList: m,
    setTimeModelValue: (h, g, x, S) => {
      h.hours = y("hours", g, x, S, h), h.minutes = y("minutes", g, x, S, h), h.seconds = y("seconds", g, x, S, h);
    },
    getTimeObjFromCurrent: (h, g, x) => {
      const S = {
        hours: An(h),
        minutes: Hn(h),
        seconds: x ? la(h) : 0
      };
      return Object.assign(S, g);
    },
    errorMapper: k
  };
}, Ft = () => {
  const { getDate: e } = Ke(), { getMapDate: n, getGroupedList: t } = Dt(), a = (y, h) => {
    if (!y) return e();
    const g = e(y), x = je(g, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
    return h ? Ag(x) : x;
  }, s = (y, h) => {
    const g = e(h);
    return je(g, {
      hours: +(y.hours ?? An(g)),
      minutes: +(y.minutes ?? Hn(g)),
      seconds: +(y.seconds ?? la(g)),
      milliseconds: 0
    });
  }, l = (y, h) => {
    const g = rn(y, { weekStartsOn: +h }), x = Ei(y, { weekStartsOn: +h });
    return [g, x];
  }, r = (y, h) => !y || !h ? !1 : Wn(a(y), a(h)), i = (y, h) => !y || !h ? !1 : Wa(a(y), a(h)), o = (y, h) => !y || !h ? !1 : Cn(a(y), a(h)), u = (y, h, g) => y != null && y[0] && (y != null && y[1]) ? o(g, y[0]) && r(g, y[1]) : y != null && y[0] && h ? o(g, y[0]) && r(g, h) || r(g, y[0]) && o(g, h) : !1, c = (y, h) => {
    const g = o(y, h) ? h : y, x = o(h, y) ? h : y;
    return _i({ start: g, end: x });
  }, f = (y) => `dp-${tn(y, "yyyy-MM-dd")}`, p = (y) => a(je(e(y), { date: 1 })), d = (y, h) => {
    if (h) {
      const g = We(e(h));
      if (g > y) return 12;
      if (g === y) return Ze(e(h));
    }
  }, b = (y, h) => {
    if (h) {
      const g = We(e(h));
      return g < y ? -1 : g === y ? Ze(e(h)) : void 0;
    }
  }, m = (y) => {
    if (y) return We(e(y));
  }, k = (y) => ({
    hours: An(y),
    minutes: Hn(y),
    seconds: la(y)
  });
  return {
    resetDateTime: a,
    groupListAndMap: (y, h) => t(y).map((g) => g.map((x) => {
      const { active: S, disabled: C, isBetween: _, highlighted: O } = h(x);
      return {
        ...x,
        active: S,
        disabled: C,
        className: {
          dp__overlay_cell_active: S,
          dp__overlay_cell: !S,
          dp__overlay_cell_disabled: C,
          dp__overlay_cell_pad: !0,
          dp__overlay_cell_active_disabled: C && S,
          dp__cell_in_between: _,
          "dp--highlighted": O
        }
      };
    })),
    setTime: s,
    getWeekFromDate: l,
    isDateAfter: o,
    isDateBefore: r,
    isDateBetween: u,
    isDateEqual: i,
    getDaysInBetween: c,
    getCellId: f,
    resetDate: p,
    getMinMonth: d,
    getMaxMonth: b,
    getYearFromDate: m,
    getTimeObj: k,
    setTimeValue: (y) => je(e(), k(y)),
    sanitizeTime: (y, h, g) => h && (g || g === 0) ? Object.fromEntries(
      ["hours", "minutes", "seconds"].map((x) => x === h ? [x, g] : [x, Number.isNaN(+y[x]) ? void 0 : +y[x]])
    ) : {
      hours: Number.isNaN(+y.hours) ? void 0 : +y.hours,
      minutes: Number.isNaN(+y.minutes) ? void 0 : +y.minutes,
      seconds: Number.isNaN(+(y.seconds ?? "")) ? void 0 : +y.seconds
    },
    getBeforeAndAfterInRange: (y, h) => {
      const g = Cd(a(h), y), x = nn(a(h), y);
      return { before: g, after: x };
    },
    isModelAuto: (y) => Array.isArray(y) ? !!y[0] && !!y[1] : !1,
    matchDate: (y, h) => y ? h ? h instanceof Map ? !!n(y, h) : h(e(y)) : !1 : !0,
    checkHighlightMonth: (y, h, g) => typeof y == "function" ? y({ month: h, year: g }) : y.months.some((x) => x.month === h && x.year === g),
    checkHighlightYear: (y, h) => typeof y == "function" ? y(h) : y.years.includes(h)
  };
}, Hl = () => {
  const {
    defaults: { config: e }
  } = Ke(), n = ee(0);
  et(() => {
    t(), globalThis.addEventListener("resize", t, { passive: !0 });
  }), Xt(() => {
    globalThis.removeEventListener("resize", t);
  });
  const t = () => {
    n.value = globalThis.document.documentElement.clientWidth;
  };
  return {
    isMobile: T(() => n.value <= e.value.mobileBreakpoint ? !0 : void 0)
  };
}, ra = () => {
  const {
    getDate: e,
    state: n,
    modelValue: t,
    rootProps: a,
    defaults: { formats: s, textInput: l }
  } = Ke(), r = (b) => tn(mn(e(), b), s.value.year, { locale: a.locale }), i = (b) => tn(Dd(e(), b), s.value.month, { locale: a.locale }), o = (b) => tn(b, s.value.weekDay, { locale: a.locale }), u = (b) => tn(b, s.value.quarter, { locale: a.locale }), c = (b, m) => [b, m].map((k) => u(k)).join("-"), f = (b) => tn(b, s.value.day, { locale: a.locale }), p = (b, m, k) => {
    const y = k ? s.value.preview : s.value.input;
    if (!b) return "";
    if (typeof y == "function") return y(b);
    const h = m ?? y, g = { locale: a.locale };
    return Array.isArray(b) ? `${tn(b[0], h, g)}${a.modelAuto && !b[1] ? "" : l.value.rangeSeparator}${b[1] ? tn(b[1], h, g) : ""}` : tn(b, h, g);
  }, d = () => {
    const b = (m) => tn(m, l.value.format);
    return Array.isArray(t.value) ? `${b(t.value[0])} ${l.value.rangeSeparator} ${t.value[1] ? b(t.value[1]) : ""}` : "";
  };
  return {
    formatYear: r,
    formatMonth: i,
    formatWeekDay: o,
    formatQuarter: u,
    formatSelectedDate: p,
    formatForTextInput: () => n.isInputFocused && t.value ? Array.isArray(t.value) ? d() : tn(t.value, l.value.format) : p(t.value),
    formatPreview: (b) => p(b, void 0, !0),
    formatQuarterText: c,
    formatDay: f
  };
}, Ul = () => {
  const { rootProps: e } = Ke(), { formatYear: n, formatMonth: t } = ra();
  return {
    getMonths: () => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((a) => ({
      text: t(a),
      value: a
    })),
    getYears: () => {
      const a = [];
      for (let s = +e.yearRange[0]; s <= +e.yearRange[1]; s++)
        a.push({ value: +s, text: n(s) });
      return e.reverseYears ? a.reverse() : a;
    },
    isOutOfYearRange: (a) => a < +e.yearRange[0] || a > +e.yearRange[1]
  };
}, M0 = (e) => ({
  openMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.openMenu();
  },
  closeMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.closeMenu();
  },
  selectDate: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.selectDate();
  },
  clearValue: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.clearValue();
  },
  formatInputValue: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.formatInputValue();
  },
  updateInternalModelValue: (n) => {
    var t;
    return (t = e.value) == null ? void 0 : t.updateInternalModelValue(n);
  },
  setMonthYear: (n, t) => {
    var a;
    return (a = e.value) == null ? void 0 : a.setMonthYear(n, t);
  },
  parseModel: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.parseModel();
  },
  switchView: (n, t) => {
    var a;
    return (a = e.value) == null ? void 0 : a.switchView(n, t);
  },
  handleFlow: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.handleFlow();
  },
  toggleMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.toggleMenu();
  },
  dpMenuRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.dpMenuRef();
  },
  dpWrapMenuRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.dpWrapMenuRef();
  },
  inputRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.inputRef();
  }
}), is = () => ({
  boolHtmlAttribute: (e) => e ? !0 : void 0
}), C0 = () => {
  const {
    getDate: e,
    rootProps: n,
    defaults: { textInput: t, startTime: a, timeConfig: s }
  } = Ke(), { getTimeObjFromCurrent: l } = Dt(), r = ee(!1), i = T(
    () => Array.isArray(a.value) ? a.value[0] : a.value ?? l(e(), {}, s.value.enableSeconds)
  ), o = (c, f) => {
    var g, x;
    const p = /[^a-zA-Z]+/g, d = /\D+/g, b = f.split(d), m = c.split(p), k = c.match(p) || [], y = f.match(d) || [];
    let h = "";
    for (let S = 0; S < b.length && S < m.length; S++) {
      S > 0 && y[S - 1] && (h += k[S - 1] || y[S - 1]);
      const C = (g = b[S]) == null ? void 0 : g.length;
      h += (x = m[S]) == null ? void 0 : x.slice(0, C);
    }
    return h;
  }, u = (c, f, p) => {
    const d = ei(c, o(f, c), e(), {
      locale: n.locale
    });
    return Cs(d) && pd(d) ? p || r.value ? d : je(d, {
      hours: +i.value.hours,
      minutes: +i.value.minutes,
      seconds: +(i.value.seconds ?? 0),
      milliseconds: 0
    }) : null;
  };
  return {
    textPasted: r,
    parseFreeInput: (c, f) => {
      if (typeof t.value.pattern == "string")
        return u(c, t.value.pattern, f);
      if (Array.isArray(t.value.pattern)) {
        let p = null;
        for (const d of t.value.pattern)
          if (p = u(c, d, f), p)
            break;
        return p;
      }
      return typeof t.value.pattern == "function" ? t.value.pattern(c) : null;
    },
    applyMaxValues: (c, f) => {
      const p = {
        MM: 12,
        DD: 31,
        hh: 23,
        mm: 59,
        ss: 59
      };
      let d = "", b = 0;
      for (let m = 0; m < f.length; m++) {
        const k = f[m], y = k.length, h = c.slice(b, b + y);
        if (!h) break;
        if (h.length < y)
          d += h;
        else {
          let g = Number.parseInt(h, 10);
          p[k] && g > p[k] && (g = p[k]), d += g.toString().padStart(y, "0").slice(0, y);
        }
        b += y;
      }
      return d;
    },
    createMaskedValue: (c, f) => {
      const p = /(YYYY|MM|DD|hh|mm|ss)/g, d = [...f.matchAll(p)].map((h) => h[0]), b = f.replace(p, "|").split("|").filter(Boolean), m = d.map((h) => h.length);
      let k = "", y = 0;
      for (let h = 0; h < d.length; h++) {
        const g = m[h], x = c.slice(y, y + g);
        if (!x) break;
        k += x, x.length === g && b[h] && (k += b[h]), y += g;
      }
      return k;
    }
  };
};
var gn = /* @__PURE__ */ ((e) => (e.Input = "input", e.DatePicker = "date-picker", e.Calendar = "calendar", e.DatePickerHeader = "date-picker-header", e.Menu = "menu", e.ActionRow = "action-row", e.TimePicker = "time-picker", e.TimeInput = "time-input", e.PassTrough = "pass-trough", e.MonthPicker = "month-picker", e.YearMode = "year-mode", e.QuarterPicker = "quarter-picker", e.YearPicker = "year-picker", e))(gn || {});
const Va = [
  "time-input",
  "time-picker",
  "pass-trough"
  /* PassTrough */
], Ld = [
  { name: "trigger", use: [
    "input"
    /* Input */
  ] },
  { name: "input-icon", use: [
    "input"
    /* Input */
  ] },
  { name: "clear-icon", use: [
    "input"
    /* Input */
  ] },
  { name: "dp-input", use: [
    "input"
    /* Input */
  ] },
  { name: "clock-icon", use: [
    "time-picker",
    "time-input",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "arrow-left", use: [
    "date-picker-header",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  { name: "arrow-right", use: [
    "date-picker-header",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  {
    name: "arrow-up",
    use: [
      "time-picker",
      "time-input",
      "date-picker-header",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "arrow-down",
    use: [
      "time-picker",
      "time-input",
      "date-picker-header",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "calendar-icon",
    use: [
      "date-picker-header",
      "time-picker",
      "pass-trough",
      "year-mode"
      /* YearMode */
    ]
  },
  { name: "day", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "month-overlay-value",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker"
      /* MonthPicker */
    ]
  },
  {
    name: "year-overlay-value",
    use: [
      "date-picker-header",
      "pass-trough",
      "year-mode",
      "year-picker"
      /* YearPicker */
    ]
  },
  { name: "year-overlay", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month-overlay", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month-overlay-header", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "year-overlay-header", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "hours-overlay-value",
    use: Va
  },
  {
    name: "hours-overlay-header",
    use: Va
  },
  {
    name: "minutes-overlay-value",
    use: Va
  },
  {
    name: "minutes-overlay-header",
    use: Va
  },
  {
    name: "seconds-overlay-value",
    use: Va
  },
  {
    name: "seconds-overlay-header",
    use: Va
  },
  { name: "hours", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "minutes", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "seconds", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month", use: [
    "date-picker-header",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "year", use: [
    "date-picker-header",
    "time-picker",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  { name: "action-buttons", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "action-preview", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "calendar-header", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "marker-tooltip", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "action-extra", use: [
    "menu"
    /* Menu */
  ] },
  { name: "time-picker-overlay", use: [
    "time-picker",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "am-pm-button", use: [
    "time-picker",
    "time-input",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "left-sidebar", use: [
    "menu"
    /* Menu */
  ] },
  { name: "right-sidebar", use: [
    "menu"
    /* Menu */
  ] },
  {
    name: "month-year",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker",
      "year-picker"
      /* YearPicker */
    ]
  },
  { name: "time-picker", use: [
    "date-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "action-row", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "marker", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "quarter", use: [
    "quarter-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "top-extra",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker",
      "quarter-picker",
      "year-picker"
      /* YearPicker */
    ]
  },
  {
    name: "tp-inline-arrow-up",
    use: [
      "date-picker",
      "time-input",
      "time-picker",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "tp-inline-arrow-down",
    use: [
      "date-picker",
      "time-input",
      "time-picker",
      "pass-trough"
      /* PassTrough */
    ]
  },
  { name: "arrow", use: [
    "menu"
    /* Menu */
  ] },
  { name: "menu-header", use: [
    "menu"
    /* Menu */
  ] }
], _n = (e, n) => Ld.filter((t) => e[t.name] && t.use.includes(n)).map((t) => t.name), Nd = (e, n) => Ld.map((t) => t.name).concat((n == null ? void 0 : n.filter((t) => t.slot).map((t) => t.slot)) ?? []).filter((t) => !!e[t]), D0 = {
  key: 1,
  class: "dp__input_wrap"
}, O0 = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], _0 = {
  key: 1,
  class: "dp--clear-btn"
}, E0 = ["aria-label"], I0 = /* @__PURE__ */ ke({
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 }
  },
  emits: ["clear", "open", "set-input-date", "close", "select-date", "set-empty-date", "toggle", "focus", "blur", "real-blur"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: l,
      inputValue: r,
      rootProps: i,
      defaults: { textInput: o, ariaLabels: u, inline: c, config: f, range: p, multiDates: d, ui: b, inputAttrs: m }
    } = Ke(), { checkMinMaxRange: k, isValidDate: y } = on(), { parseFreeInput: h, textPasted: g, createMaskedValue: x, applyMaxValues: S } = C0(), { checkKeyDown: C, checkStopPropagation: _ } = Dt(), { boolHtmlAttribute: O } = is(), I = Xe("dp-input"), D = ee(null), B = ee(!1), Y = T(
      () => ({
        dp__pointer: !i.disabled && !i.readonly && !o.value.enabled,
        dp__disabled: i.disabled,
        dp__input_readonly: !o.value.enabled,
        dp__input: !0,
        dp__input_not_clearable: !m.value.clearable,
        dp__input_icon_pad: !m.value.hideInputIcon,
        dp__input_valid: typeof m.value.state == "boolean" ? m.value.state : !1,
        dp__input_invalid: typeof m.value.state == "boolean" ? !m.value.state : !1,
        dp__input_focus: B.value || s.isMenuOpen,
        dp__input_reg: !o.value.enabled,
        ...b.value.input
      })
    ), ne = () => {
      a("set-input-date", null), m && i.autoApply && (a("set-empty-date"), D.value = null);
    }, W = (V) => {
      var Z;
      if ((Z = o.value.separators) != null && Z.length) {
        const me = new RegExp(
          o.value.separators.map((K) => K.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")
        );
        return V.split(me);
      }
      return V.split(o.value.rangeSeparator);
    }, ae = (V) => {
      const [Z, me] = W(V);
      if (Z) {
        const K = h(Z.trim(), r.value), oe = me ? h(me.trim(), r.value) : void 0;
        if (Cn(K, oe)) return;
        const ye = K && oe ? [K, oe] : [K];
        k(oe, ye, 0) && (D.value = K ? ye : null);
      }
    }, G = () => {
      g.value = !0;
    }, j = (V) => {
      if (p.value.enabled)
        ae(V);
      else if (d.value.enabled) {
        const Z = V.split(";");
        D.value = Z.map((me) => h(me.trim())).filter((me) => !!me);
      } else
        D.value = h(V, r.value);
    }, se = (V) => {
      var oe, ye;
      const Z = typeof V == "string" ? V : (oe = V.target) == null ? void 0 : oe.value, me = (ye = o == null ? void 0 : o.value) == null ? void 0 : ye.maskFormat;
      let K = Z;
      if (typeof me == "string") {
        const A = /(YYYY|MM|DD|hh|mm|ss)/g, z = [...me.matchAll(A)].map((P) => P[0]), $ = Z.replace(/\D/g, ""), F = S($, z);
        K = x(F, me);
      }
      K === "" ? ne() : (o.value.openMenu && !s.isMenuOpen && a("open"), j(K), a("set-input-date", D.value)), g.value = !1, r.value = K, l("text-input", V, D.value);
    }, U = (V) => {
      o.value.enabled ? (j(V.target.value), o.value.enterSubmit && y(D.value) && r.value !== "" ? (a("set-input-date", D.value, !0), D.value = null) : o.value.enterSubmit && r.value === "" && (D.value = null, a("clear"))) : de(V);
    }, N = (V, Z) => {
      o.value.enabled && o.value.tabSubmit && !Z && j(V.target.value), o.value.tabSubmit && y(D.value) && r.value !== "" ? (a("set-input-date", D.value, !0, !0), D.value = null) : o.value.tabSubmit && r.value === "" && (D.value = null, a("clear"));
    }, J = () => {
      B.value = !0, a("focus"), Ge().then(() => {
        var V;
        o.value.enabled && o.value.selectOnFocus && ((V = I.value) == null || V.select());
      });
    }, de = (V) => {
      if (_(V, f.value, !0), o.value.enabled && o.value.openMenu && !c.value.input) {
        if (o.value.openMenu === "open" && !s.isMenuOpen) return a("open");
        if (o.value.openMenu === "toggle") return a("toggle");
      } else o.value.enabled || a("toggle");
    }, he = () => {
      a("real-blur"), B.value = !1, (!s.isMenuOpen || c.value.enabled && c.value.input) && a("blur"), (i.autoApply && o.value.enabled && D.value && !s.isMenuOpen || o.value.applyOnBlur) && (a("set-input-date", D.value), a("select-date"), D.value = null);
    }, ge = (V) => {
      _(V, f.value, !0), a("clear");
    }, $e = () => {
      a("close");
    }, we = (V) => {
      if (V.key === "Tab" && N(V), V.key === "Enter" && U(V), V.key === "Escape" && o.value.escClose && $e(), !o.value.enabled) {
        if (V.code === "Tab") return;
        V.preventDefault();
      }
    }, X = () => {
      var V;
      (V = I.value) == null || V.focus({ preventScroll: !0 });
    }, ve = (V) => {
      D.value = V;
    }, Ce = (V) => {
      V.key === ct.tab && N(V, !0);
    };
    return n({
      focusInput: X,
      setParsedDate: ve
    }), (V, Z) => {
      var me, K;
      return w(), M("div", { onClick: de }, [
        !V.$slots["dp-input"] && !v(c).enabled ? H(V.$slots, "trigger", { key: 0 }) : R("", !0),
        !V.$slots.trigger && (!v(c).enabled || v(c).input) ? (w(), M("div", D0, [
          !V.$slots.trigger && (!v(c).enabled || v(c).enabled && v(c).input) ? H(V.$slots, "dp-input", {
            key: 0,
            value: v(r),
            isMenuOpen: e.isMenuOpen,
            onInput: se,
            onEnter: U,
            onTab: N,
            onClear: ge,
            onBlur: he,
            onKeypress: we,
            onPaste: G,
            onFocus: J,
            openMenu: () => V.$emit("open"),
            closeMenu: () => V.$emit("close"),
            toggleMenu: () => V.$emit("toggle")
          }, () => [
            E("input", {
              id: v(m).id,
              ref: "dp-input",
              "data-test-id": "dp-input",
              name: v(m).name,
              class: q(Y.value),
              inputmode: v(m).inputmode,
              placeholder: v(i).placeholder,
              disabled: v(O)(v(i).disabled),
              readonly: v(O)(v(i).readonly),
              required: v(O)(v(m).required),
              value: v(r),
              autocomplete: v(m).autocomplete,
              "aria-label": v(u).input,
              "aria-disabled": v(i).disabled || void 0,
              "aria-invalid": v(m).state === !1 ? !0 : void 0,
              onInput: se,
              onBlur: he,
              onFocus: J,
              onKeypress: we,
              onKeydown: Z[0] || (Z[0] = (oe) => we(oe)),
              onPaste: G,
              onInvalid: Z[1] || (Z[1] = (oe) => v(l)("invalid", oe))
            }, null, 42, O0)
          ]) : R("", !0),
          E("div", {
            onClick: Z[4] || (Z[4] = (oe) => a("toggle"))
          }, [
            V.$slots["input-icon"] && !v(m).hideInputIcon ? (w(), M("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: Z[2] || (Z[2] = (oe) => a("toggle"))
            }, [
              H(V.$slots, "input-icon")
            ])) : R("", !0),
            !V.$slots["input-icon"] && !v(m).hideInputIcon && !V.$slots["dp-input"] ? (w(), ue(v(Us), {
              key: 1,
              "aria-label": (me = v(u)) == null ? void 0 : me.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: Z[3] || (Z[3] = (oe) => a("toggle"))
            }, null, 8, ["aria-label"])) : R("", !0)
          ]),
          V.$slots["clear-icon"] && (v(m).alwaysClearable || v(r) && v(m).clearable && !v(i).disabled && !v(i).readonly) ? (w(), M("span", _0, [
            H(V.$slots, "clear-icon", { clear: ge })
          ])) : R("", !0),
          !V.$slots["clear-icon"] && (v(m).alwaysClearable || v(m).clearable && v(r) && !v(i).disabled && !v(i).readonly) ? (w(), M("button", {
            key: 2,
            "aria-label": (K = v(u)) == null ? void 0 : K.clearInput,
            class: "dp--clear-btn",
            type: "button",
            "data-test-id": "clear-input-value-btn",
            onKeydown: Z[5] || (Z[5] = (oe) => v(C)(oe, () => ge(oe), !0, Ce)),
            onClick: Z[6] || (Z[6] = Ve((oe) => ge(oe), ["prevent"]))
          }, [
            ie(v(Eb), { class: "dp__input_icons" })
          ], 40, E0)) : R("", !0)
        ])) : R("", !0)
      ]);
    };
  }
}), A0 = {
  ref: "action-row",
  class: "dp__action_row"
}, P0 = ["title"], R0 = {
  ref: "action-buttons-container",
  class: "dp__action_buttons",
  "data-dp-element": "action-row"
}, F0 = ["disabled"], V0 = /* @__PURE__ */ ke({
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { default: 0 }
  },
  emits: ["close-picker", "select-date", "select-now"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      rootEmit: s,
      rootProps: l,
      modelValue: r,
      defaults: { actionRow: i, multiCalendars: o, inline: u, range: c, multiDates: f, formats: p }
    } = Ke(), { isTimeValid: d, isMonthValid: b } = on(), { formatPreview: m } = ra(), { checkKeyDown: k, convertType: y } = Dt(), { boolHtmlAttribute: h } = is(), g = Xe("action-buttons-container"), x = Xe("action-row"), S = ee(!1), C = ee({});
    et(() => {
      _(), globalThis.addEventListener("resize", _);
    }), Xt(() => {
      globalThis.removeEventListener("resize", _);
    });
    const _ = () => {
      S.value = !1, setTimeout(() => {
        var se, U;
        const G = (se = g.value) == null ? void 0 : se.getBoundingClientRect(), j = (U = x.value) == null ? void 0 : U.getBoundingClientRect();
        G && j && (C.value.maxWidth = `${j.width - G.width - 20}px`), S.value = !0;
      }, 0);
    }, O = T(() => c.value.enabled && !c.value.partialRange && r.value ? r.value.length === 2 : !0), I = T(
      () => !d.value(r.value) || !b.value(r.value) || !O.value
    ), D = () => {
      const G = p.value.preview;
      return l.timePicker || l.monthPicker, G(y(r.value));
    }, B = () => {
      const G = r.value;
      return o.value.count > 0 ? `${m(G[0])} - ${m(G[1])}` : [m(G[0]), m(G[1])];
    }, Y = T(() => !r.value || !a.menuMount ? "" : typeof p.value.preview == "string" ? Array.isArray(r.value) ? r.value.length === 2 && r.value[1] ? B() : f.value.enabled ? r.value.map((G) => `${m(G)}`) : l.modelAuto ? `${m(r.value[0])}` : `${m(r.value[0])} -` : m(r.value) : D()), ne = () => f.value.enabled ? "; " : " - ", W = T(
      () => Array.isArray(Y.value) ? Y.value.join(ne()) : Y.value
    ), ae = () => {
      d.value(r.value) && b.value(r.value) && O.value ? t("select-date") : s("invalid-select");
    };
    return (G, j) => (w(), M("div", A0, [
      G.$slots["action-row"] ? H(G.$slots, "action-row", Mt(lt({ key: 0 }, {
        modelValue: v(r),
        disabled: I.value,
        selectDate: () => G.$emit("select-date"),
        closePicker: () => G.$emit("close-picker")
      }))) : (w(), M(Te, { key: 1 }, [
        v(i).showPreview ? (w(), M("div", {
          key: 0,
          class: "dp__selection_preview",
          title: W.value || void 0,
          style: Fe(C.value)
        }, [
          G.$slots["action-preview"] && S.value ? H(G.$slots, "action-preview", {
            key: 0,
            value: v(r),
            formatValue: W.value
          }) : R("", !0),
          !G.$slots["action-preview"] && S.value ? (w(), M(Te, { key: 1 }, [
            He(re(W.value), 1)
          ], 64)) : R("", !0)
        ], 12, P0)) : R("", !0),
        E("div", R0, [
          G.$slots["action-buttons"] ? H(G.$slots, "action-buttons", {
            key: 0,
            value: v(r),
            selectDate: ae,
            selectionDisabled: I.value
          }) : R("", !0),
          G.$slots["action-buttons"] ? R("", !0) : (w(), M(Te, { key: 1 }, [
            !v(u).enabled && v(i).showCancel ? (w(), M("button", {
              key: 0,
              ref: "cancel-btn",
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_cancel",
              onClick: j[0] || (j[0] = (se) => G.$emit("close-picker")),
              onKeydown: j[1] || (j[1] = (se) => v(k)(se, () => G.$emit("close-picker")))
            }, re(v(i).cancelBtnLabel), 545)) : R("", !0),
            v(i).showNow ? (w(), M("button", {
              key: 1,
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_cancel",
              onClick: j[2] || (j[2] = (se) => G.$emit("select-now")),
              onKeydown: j[3] || (j[3] = (se) => v(k)(se, () => G.$emit("select-now")))
            }, re(v(i).nowBtnLabel), 33)) : R("", !0),
            v(i).showSelect ? (w(), M("button", {
              key: 2,
              ref: "select-btn",
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_select",
              disabled: v(h)(I.value),
              "data-test-id": "select-button",
              onKeydown: j[4] || (j[4] = (se) => v(k)(se, () => ae())),
              onClick: ae
            }, re(v(i).selectBtnLabel), 41, F0)) : R("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), ql = () => {
  const {
    rootProps: e,
    defaults: { multiCalendars: n }
  } = Ke(), t = T(() => (l) => {
    var r;
    return (r = e.hideNavigation) == null ? void 0 : r.includes(l);
  }), a = T(() => (l) => n.value.count ? n.value.solo ? !0 : l === 0 : !0), s = T(() => (l) => n.value.count ? n.value.solo ? !0 : l === n.value.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: a, showRightIcon: s };
}, L0 = ["role", "aria-label", "tabindex"], N0 = { class: "dp__selection_grid_header" }, z0 = ["aria-selected", "aria-disabled", "data-dp-action-element", "data-dp-element-active", "data-test-id", "onClick", "onKeydown", "onMouseover"], B0 = ["aria-label", "data-dp-action-element"], Gs = /* @__PURE__ */ ke({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    useRelative: { type: Boolean },
    height: {},
    overlayLabel: {},
    isLast: { type: Boolean },
    level: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      setState: s,
      defaults: { ariaLabels: l, config: r }
    } = Ke(), { hideNavigationButtons: i } = ql(), { handleEventPropagation: o, checkKeyDown: u } = Dt(), c = Xe("toggle-button"), f = Xe("overlay-container"), p = Xe("grid-wrap"), d = ee(!1), b = ee(null), m = ee(), k = ee(0);
    xf(() => {
      b.value = null;
    }), et(async () => {
      await Ge(), C(), s("arrowNavigationLevel", a.level ?? 1);
    }), Xt(() => {
      s("arrowNavigationLevel", (a.level ?? 1) - 1);
    });
    const y = T(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !a.useRelative,
        "dp--overlay-relative": a.useRelative
      })
    ), h = T(
      () => a.useRelative ? { height: `${a.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), g = T(() => ({
      dp__overlay_col: !0
    })), x = T(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: d.value,
        dp__button_bottom: a.isLast
      })
    ), S = T(() => {
      var ne, W;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((ne = a.items) == null ? void 0 : ne.length) <= 6,
        dp__container_block: ((W = a.items) == null ? void 0 : W.length) > 6
      };
    });
    Le(
      () => a.items,
      () => C(!1),
      { deep: !0 }
    );
    const C = (ne = !0) => {
      Ge().then(() => {
        const W = document.querySelector(`[data-dp-element-active="${a.level ?? 1}"]`), ae = Gt(p), G = Gt(c), j = Gt(f), se = G ? G.getBoundingClientRect().height : 0;
        ae && (ae.getBoundingClientRect().height ? k.value = ae.getBoundingClientRect().height - se : k.value = r.value.modeHeight - se), W && j && ne && (j.scrollTop = W.offsetTop - j.offsetTop - (k.value / 2 - W.getBoundingClientRect().height) - se);
      });
    }, _ = (ne) => {
      ne.disabled || t("selected", ne.value);
    }, O = () => {
      t("toggle"), t("reset-flow");
    }, I = (ne) => {
      r.value.escClose && (O(), o(ne, r.value));
    }, D = (ne) => {
      m.value = ne, t("hover-value", ne);
    }, B = (ne) => {
      if (ne.key === ct.esc) return I(ne);
    }, Y = (ne) => {
      if (ne.key === ct.enter) return O();
    };
    return (ne, W) => {
      var ae;
      return w(), M("div", {
        ref: "grid-wrap",
        class: q(y.value),
        style: Fe(h.value),
        role: e.useRelative ? void 0 : "dialog",
        "aria-label": e.overlayLabel,
        tabindex: e.useRelative ? void 0 : "0",
        onKeydown: B,
        onClick: W[0] || (W[0] = Ve(() => {
        }, ["prevent"]))
      }, [
        E("div", {
          ref: "overlay-container",
          class: q(S.value),
          style: Fe({ "--dp-overlay-height": `${k.value}px` }),
          role: "grid"
        }, [
          E("div", N0, [
            H(ne.$slots, "header")
          ]),
          H(ne.$slots, "overlay", {}, () => [
            (w(!0), M(Te, null, Ie(e.items, (G, j) => (w(), M("div", {
              key: j,
              class: q(["dp__overlay_row", { dp__flex_row: e.items.length >= 3 }]),
              role: "row"
            }, [
              (w(!0), M(Te, null, Ie(G, (se) => (w(), M("div", {
                key: se.value,
                role: "gridcell",
                class: q(g.value),
                "aria-selected": se.active || void 0,
                "aria-disabled": se.disabled || void 0,
                "data-dp-action-element": e.level ?? 1,
                "data-dp-element-active": se.active ? e.level ?? 1 : void 0,
                tabindex: "0",
                "data-test-id": se.text,
                onClick: Ve((U) => _(se), ["prevent"]),
                onKeydown: (U) => v(u)(U, () => _(se), !0),
                onMouseover: (U) => D(se.value)
              }, [
                E("div", {
                  class: q(se.className)
                }, [
                  H(ne.$slots, "item", { item: se }, () => [
                    He(re(se.text), 1)
                  ])
                ], 2)
              ], 42, z0))), 128))
            ], 2))), 128))
          ])
        ], 6),
        ne.$slots["button-icon"] ? an((w(), M("button", {
          key: 0,
          ref: "toggle-button",
          type: "button",
          "aria-label": (ae = v(l)) == null ? void 0 : ae.toggleOverlay,
          class: q(x.value),
          tabindex: "0",
          "data-dp-action-element": e.level ?? 1,
          onClick: O,
          onKeydown: Y
        }, [
          H(ne.$slots, "button-icon")
        ], 42, B0)), [
          [Bn, !v(i)(e.type)]
        ]) : R("", !0)
      ], 46, L0);
    };
  }
}), W0 = ["data-dp-mobile"], jl = /* @__PURE__ */ ke({
  __name: "InstanceWrap",
  props: {
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const {
      defaults: { multiCalendars: n }
    } = Ke(), { isMobile: t } = Hl(), a = T(
      () => n.value.count > 0 ? [...new Array(n.value.count).keys()] : [0]
    );
    return (s, l) => (w(), M("div", {
      class: q({
        dp__menu_inner: !e.stretch,
        "dp--menu--inner-stretched": e.stretch,
        dp__flex_display: v(n).count > 0,
        "dp--flex-display-collapsed": e.collapse
      }),
      "data-dp-mobile": v(t)
    }, [
      H(s.$slots, "default", {
        instances: a.value,
        wrapClass: { dp__instance_calendar: v(n).count > 0 }
      })
    ], 10, W0));
  }
}), Y0 = ["data-dp-element", "aria-label", "aria-disabled"], Ds = /* @__PURE__ */ ke({
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: n }) {
    const { checkKeyDown: t } = Dt(), a = n;
    return (s, l) => (w(), M("button", {
      ref: "arrow-btn",
      type: "button",
      "data-dp-element": e.elName,
      "data-dp-action-element": "0",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled || void 0,
      onClick: l[0] || (l[0] = (r) => a("activate")),
      onKeydown: l[1] || (l[1] = (r) => v(t)(r, () => a("activate"), !0))
    }, [
      E("span", {
        class: q(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        H(s.$slots, "default")
      ], 2)
    ], 40, Y0));
  }
}), H0 = ["aria-label", "data-test-id"], zd = /* @__PURE__ */ ke({
  __name: "YearModePicker",
  props: {
    items: {},
    instance: {},
    year: {},
    showYearPicker: { type: Boolean, default: !1 },
    isDisabled: {}
  },
  emits: ["handle-year", "year-select", "toggle-year-picker"],
  setup(e, { emit: n }) {
    const t = n, a = e, { showRightIcon: s, showLeftIcon: l } = ql(), {
      rootProps: r,
      defaults: { config: i, ariaLabels: o, ui: u }
    } = Ke(), { showTransition: c, transitionName: f } = qs(), { formatYear: p } = ra(), { boolHtmlAttribute: d } = is(), b = ee(!1), m = T(() => p(a.year)), k = (g = !1, x) => {
      b.value = !b.value, t("toggle-year-picker", { flow: g, show: x });
    }, y = (g) => {
      b.value = !1, t("year-select", g);
    }, h = (g = !1) => {
      t("handle-year", g);
    };
    return (g, x) => {
      var S, C, _, O, I;
      return w(), M(Te, null, [
        E("div", {
          class: q(["dp--year-mode-picker", { "dp--hidden-el": b.value }])
        }, [
          v(l)(e.instance) ? (w(), ue(Ds, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (S = v(o)) == null ? void 0 : S.prevYear,
            disabled: v(d)(e.isDisabled(!1)),
            class: q((C = v(u)) == null ? void 0 : C.navBtnPrev),
            onActivate: x[0] || (x[0] = (D) => h(!1))
          }, {
            default: ce(() => [
              g.$slots["arrow-left"] ? H(g.$slots, "arrow-left", { key: 0 }) : R("", !0),
              g.$slots["arrow-left"] ? R("", !0) : (w(), ue(v(Ed), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : R("", !0),
          E("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${e.year}-${(_ = v(o)) == null ? void 0 : _.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${e.instance}`,
            "data-dp-action-element": "0",
            onClick: x[1] || (x[1] = () => k(!1)),
            onKeydown: x[2] || (x[2] = Vt(Ve(() => k(!1), ["prevent"]), ["enter"]))
          }, [
            g.$slots.year ? H(g.$slots, "year", {
              key: 0,
              text: m.value,
              value: e.year
            }) : R("", !0),
            g.$slots.year ? R("", !0) : (w(), M(Te, { key: 1 }, [
              He(re(e.year), 1)
            ], 64))
          ], 40, H0),
          v(s)(e.instance) ? (w(), ue(Ds, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (O = v(o)) == null ? void 0 : O.nextYear,
            disabled: v(d)(e.isDisabled(!0)),
            class: q((I = v(u)) == null ? void 0 : I.navBtnNext),
            onActivate: x[3] || (x[3] = (D) => h(!0))
          }, {
            default: ce(() => [
              g.$slots["arrow-right"] ? H(g.$slots, "arrow-right", { key: 0 }) : R("", !0),
              g.$slots["arrow-right"] ? R("", !0) : (w(), ue(v(Id), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : R("", !0)
        ], 2),
        ie(ht, {
          name: v(f)(e.showYearPicker),
          css: v(c)
        }, {
          default: ce(() => {
            var D, B;
            return [
              e.showYearPicker ? (w(), ue(Gs, {
                key: 0,
                items: e.items,
                config: v(i),
                "is-last": v(r).autoApply && !v(i).keepActionRow,
                "overlay-label": (B = (D = v(o)) == null ? void 0 : D.yearPicker) == null ? void 0 : B.call(D, !0),
                type: "year",
                onToggle: k,
                onSelected: x[4] || (x[4] = (Y) => y(Y))
              }, dt({
                "button-icon": ce(() => [
                  g.$slots["calendar-icon"] ? H(g.$slots, "calendar-icon", { key: 0 }) : R("", !0),
                  g.$slots["calendar-icon"] ? R("", !0) : (w(), ue(v(Us), { key: 1 }))
                ]),
                _: 2
              }, [
                g.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: ce(({ item: Y }) => [
                    H(g.$slots, "year-overlay-value", {
                      text: Y.text,
                      value: Y.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "config", "is-last", "overlay-label"])) : R("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), Bd = (e) => {
  const {
    getDate: n,
    rootEmit: t,
    state: a,
    month: s,
    year: l,
    modelValue: r,
    calendars: i,
    rootProps: o,
    defaults: { multiCalendars: u, range: c, safeDates: f, filters: p, highlight: d }
  } = Ke(), { resetDate: b, getYearFromDate: m, checkHighlightYear: k, groupListAndMap: y } = Ft(), { getYears: h } = Ul(), { validateMonthYear: g, checkMinMaxValue: x } = on(), S = ee([!1]), C = T(() => h()), _ = T(() => (N, J) => {
    const de = je(b(n()), {
      month: s.value(N),
      year: l.value(N)
    }), he = J ? yd(de) : Ka(de);
    return g(he, o.preventMinMaxNavigation, J);
  }), O = () => Array.isArray(r.value) && u.value.solo && r.value[1], I = () => {
    for (let N = 0; N < u.value.count; N++)
      if (N === 0)
        i.value[N] = i.value[0];
      else if (N === u.value.count - 1 && O())
        i.value[N] = {
          month: Ze(r.value[1]),
          year: We(r.value[1])
        };
      else {
        const J = je(n(), i.value[N - 1]);
        i.value[N] = { month: Ze(J), year: We(Oi(J, 1)) };
      }
  }, D = (N) => {
    if (!N) return I();
    const J = je(n(), i.value[N]);
    return i.value[0].year = We(Od(J, u.value.count - 1)), I();
  }, B = (N, J) => {
    const de = Eg(J, N);
    return c.value.showLastInRange && de > 1 ? J : N;
  }, Y = (N) => o.focusStartDate || u.value.solo ? N[0] : N[1] ? B(N[0], N[1]) : N[0], ne = () => {
    if (r.value) {
      const N = Array.isArray(r.value) ? Y(r.value) : r.value;
      i.value[0] = { month: Ze(N), year: We(N) };
    }
  }, W = () => {
    ne(), u.value.count && I();
  };
  Le(r, (N, J) => {
    a.isTextInputDate && JSON.stringify(N ?? {}) !== JSON.stringify(J ?? {}) && W();
  }), et(() => {
    W();
  });
  const ae = (N, J) => {
    i.value[J].year = N, t("update-month-year", { instance: J, year: N, month: i.value[J].month }), u.value.count && !u.value.solo && D(J);
  }, G = T(() => (N) => y(C.value, (J) => {
    var $e;
    const de = l.value(N) === J.value, he = x(
      J.value,
      m(f.value.minDate),
      m(f.value.maxDate)
    ) || (($e = p.value.years) == null ? void 0 : $e.includes(l.value(N))), ge = k(d.value, J.value);
    return { active: de, disabled: he, highlighted: ge };
  })), j = (N, J) => {
    ae(N, J), U(J);
  }, se = (N, J = !1) => {
    if (!_.value(N, J)) {
      const de = J ? l.value(N) + 1 : l.value(N) - 1;
      ae(de, N);
    }
  }, U = (N, J = !1, de) => {
    J || e("reset-flow"), de === void 0 ? S.value[N] = !S.value[N] : S.value[N] = de, S.value[N] ? t("overlay-toggle", { open: !0, overlay: Lt.year }) : t("overlay-toggle", { open: !1, overlay: Lt.year });
  };
  return {
    isDisabled: _,
    groupedYears: G,
    showYearPicker: S,
    selectYear: ae,
    setStartDate: () => {
      o.startDate && (r.value && o.focusStartDate || !r.value) && ae(We(n(o.startDate)), 0);
    },
    toggleYearPicker: U,
    handleYearSelect: j,
    handleYear: se
  };
}, Gl = () => {
  const { isDateAfter: e, isDateBefore: n, isDateEqual: t } = Ft(), {
    getDate: a,
    rootEmit: s,
    rootProps: l,
    modelValue: r,
    defaults: { range: i }
  } = Ke();
  return {
    getRangeWithFixedDate: (o) => Array.isArray(r.value) && (r.value.length === 2 || r.value.length === 1 && i.value.partialRange) ? i.value.fixedStart && (e(o, r.value[0]) || t(o, r.value[0])) ? [r.value[0], o] : i.value.fixedEnd && (n(o, r.value[1]) || t(o, r.value[1])) ? [o, r.value[1]] : (s("invalid-fixed-range", o), r.value) : [],
    setPresetDate: (o) => {
      Array.isArray(o.value) && o.value.length <= 2 && i.value.enabled ? r.value = o.value.map((u) => a(u)) : Array.isArray(o.value) || (r.value = a(o.value));
    },
    checkRangeAutoApply: (o, u, c) => {
      i && (o[0] && o[1] && l.autoApply && u("auto-apply", c), o[0] && !o[1] && (l.modelAuto || i.value.partialRange) && l.autoApply && u("auto-apply", c));
    },
    setMonthOrYearRange: (o) => {
      let u = r.value ? r.value.slice() : [];
      return u.length === 2 && u[1] !== null && (u = []), u.length ? (n(o, u[0]) ? u.unshift(o) : u[1] = o, s("range-end", o)) : (u = [o], s("range-start", o)), u;
    },
    handleMultiDatesSelect: (o, u) => {
      if (r.value && Array.isArray(r.value))
        if (r.value.some((c) => t(o, c))) {
          const c = r.value.filter((f) => !t(f, o));
          r.value = c.length ? c : null;
        } else (u && +u > r.value.length || !u) && r.value.push(o);
      else
        r.value = [o];
    }
  };
}, U0 = (e, n) => {
  const {
    getDate: t,
    rootEmit: a,
    state: s,
    calendars: l,
    year: r,
    modelValue: i,
    rootProps: o,
    defaults: { range: u, highlight: c, safeDates: f, filters: p, multiDates: d }
  } = Ke();
  js(() => {
    s.isTextInputDate && j(We(t(o.startDate)), 0);
  });
  const { checkMinMaxRange: b, checkMinMaxValue: m } = on(), { isDateBetween: k, resetDateTime: y, resetDate: h, getMinMonth: g, getMaxMonth: x, checkHighlightMonth: S, groupListAndMap: C } = Ft(), { checkRangeAutoApply: _, getRangeWithFixedDate: O, handleMultiDatesSelect: I, setMonthOrYearRange: D, setPresetDate: B } = Gl(), { padZero: Y } = Dt(), { getMonths: ne, isOutOfYearRange: W } = Ul(), ae = T(() => ne()), G = ee(null), {
    selectYear: j,
    groupedYears: se,
    showYearPicker: U,
    toggleYearPicker: N,
    handleYearSelect: J,
    handleYear: de,
    isDisabled: he,
    setStartDate: ge
  } = Bd(n);
  et(() => {
    ge();
  });
  const $e = (L) => L ? { month: Ze(L), year: We(L) } : { month: null, year: null }, we = () => i.value ? Array.isArray(i.value) ? i.value.map((L) => $e(L)) : $e(i.value) : $e(), X = (L, fe) => {
    const Me = l.value[L], Re = we();
    return Array.isArray(Re) ? Re.some((_e) => _e.year === (Me == null ? void 0 : Me.year) && _e.month === fe) : (Me == null ? void 0 : Me.year) === Re.year && fe === Re.month;
  }, ve = (L, fe, Me) => {
    var _e, Ye;
    const Re = we();
    return Array.isArray(Re) ? r.value(fe) === ((_e = Re[Me]) == null ? void 0 : _e.year) && L === ((Ye = Re[Me]) == null ? void 0 : Ye.month) : !1;
  }, Ce = (L, fe) => {
    if (u.value.enabled) {
      const Me = we();
      if (Array.isArray(i.value) && Array.isArray(Me)) {
        const Re = ve(L, fe, 0) || ve(L, fe, 1), _e = je(h(t()), { month: L, year: r.value(fe) });
        return k(i.value, G.value, _e) && !Re;
      }
      return !1;
    }
    return !1;
  }, V = T(() => (L) => C(ae.value, (fe) => {
    var At;
    const Me = X(L, fe.value), Re = m(
      fe.value,
      g(r.value(L), f.value.minDate),
      x(r.value(L), f.value.maxDate)
    ) || P(f.value.disabledDates, r.value(L), fe.value) || ((At = p.value.months) == null ? void 0 : At.includes(fe.value)) || !Q(f.value.allowedDates, r.value(L), fe.value) || W(r.value(L)), _e = Ce(fe.value, L), Ye = S(c.value, fe.value, r.value(L));
    return { active: Me, disabled: Re, isBetween: _e, highlighted: Ye };
  })), Z = (L, fe) => je(h(t()), { month: L, year: r.value(fe) }), me = (L, fe) => {
    const Me = i.value ? i.value : h(t());
    i.value = je(Me, { month: L, year: r.value(fe) }), n("auto-apply"), n("update-flow-step");
  }, K = (L, fe) => {
    const Me = Z(L, fe);
    u.value.fixedEnd || u.value.fixedStart ? i.value = O(Me) : i.value ? b(Me, i.value) && (i.value = D(Z(L, fe))) : i.value = [Z(L, fe)], Ge().then(() => {
      _(i.value, n, i.value.length < 2);
    });
  }, oe = (L, fe) => {
    I(Z(L, fe), d.value.limit), n("auto-apply", !0);
  }, ye = (L, fe) => (l.value[fe].month = L, z(fe, l.value[fe].year, L), d.value.enabled ? oe(L, fe) : u.value.enabled ? K(L, fe) : me(L, fe)), A = (L, fe) => {
    j(L, fe), z(fe, L, null);
  }, z = (L, fe, Me) => {
    let Re = Me;
    if (!Re && Re !== 0) {
      const _e = we();
      Re = Array.isArray(_e) ? _e[L].month : _e.month;
    }
    a("update-month-year", { instance: L, year: fe, month: Re });
  }, $ = (L, fe) => {
    G.value = Z(L, fe);
  }, F = (L) => {
    B({
      value: L
    }), n("auto-apply");
  }, P = (L, fe, Me) => {
    if (L instanceof Map) {
      const Re = `${Y(Me + 1)}-${fe}`;
      return L.size ? L.has(Re) : !1;
    }
    return typeof L == "function" ? L(y(je(t(), { month: Me, year: fe }), !0)) : !1;
  }, Q = (L, fe, Me) => {
    if (L instanceof Map) {
      const Re = `${Y(Me + 1)}-${fe}`;
      return L.size ? L.has(Re) : !0;
    }
    return !0;
  };
  return {
    groupedMonths: V,
    groupedYears: se,
    year: r,
    isDisabled: he,
    showYearPicker: U,
    modelValue: i,
    toggleYearPicker: N,
    handleYearSelect: J,
    handleYear: de,
    presetDate: F,
    setHoverDate: $,
    selectMonth: ye,
    selectYear: A,
    getModelMonthYear: we
  };
}, q0 = /* @__PURE__ */ ke({
  __name: "MonthPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply", "update-flow-step", "mount"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, l = Ht(), {
      rootProps: r,
      defaults: { config: i }
    } = Ke(), o = _n(l, gn.YearMode);
    et(() => {
      a("mount");
    });
    const {
      groupedMonths: u,
      groupedYears: c,
      year: f,
      isDisabled: p,
      showYearPicker: d,
      modelValue: b,
      presetDate: m,
      setHoverDate: k,
      selectMonth: y,
      selectYear: h,
      toggleYearPicker: g,
      handleYearSelect: x,
      handleYear: S,
      getModelMonthYear: C
    } = U0(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: b,
      year: f,
      getModelMonthYear: C,
      selectMonth: y,
      selectYear: h,
      handleYear: S
    }), presetDate: m, toggleYearPicker: (_) => g(0, _) }), (_, O) => (w(), ue(jl, {
      collapse: e.collapse,
      stretch: ""
    }, {
      default: ce(({ instances: I, wrapClass: D }) => [
        (w(!0), M(Te, null, Ie(I, (B) => (w(), M("div", {
          key: B,
          class: q(D)
        }, [
          _.$slots["top-extra"] ? H(_.$slots, "top-extra", {
            key: 0,
            value: v(b)
          }) : R("", !0),
          H(_.$slots, "month-year", lt({ ref_for: !0 }, {
            year: v(f),
            months: v(u)(B),
            years: v(c)(B),
            selectMonth: v(y),
            selectYear: v(h),
            instance: B
          }), () => [
            ie(Gs, {
              items: v(u)(B),
              "is-last": v(r).autoApply && !v(i).keepActionRow,
              height: v(i).modeHeight,
              "no-overlay-focus": !!(e.noOverlayFocus || v(r).textInput),
              "use-relative": "",
              level: 0,
              type: "month",
              onSelected: (Y) => v(y)(Y, B),
              onHoverValue: (Y) => v(k)(Y, B)
            }, dt({
              header: ce(() => [
                ie(zd, {
                  items: v(c)(B),
                  instance: B,
                  "show-year-picker": v(d)[B],
                  year: v(f)(B),
                  "is-disabled": (Y) => v(p)(B, Y),
                  onHandleYear: (Y) => v(S)(B, Y),
                  onYearSelect: (Y) => v(x)(Y, B),
                  onToggleYearPicker: (Y) => v(g)(B, Y == null ? void 0 : Y.flow, Y == null ? void 0 : Y.show)
                }, dt({ _: 2 }, [
                  Ie(v(o), (Y, ne) => ({
                    name: Y,
                    fn: ce((W) => [
                      H(_.$slots, Y, lt({ ref_for: !0 }, W))
                    ])
                  }))
                ]), 1032, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
              ]),
              _: 2
            }, [
              _.$slots["month-overlay-value"] ? {
                name: "item",
                fn: ce(({ item: Y }) => [
                  H(_.$slots, "month-overlay-value", {
                    text: Y.text,
                    value: Y.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "height", "no-overlay-focus", "onSelected", "onHoverValue"])
          ])
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["collapse"]));
  }
}), j0 = (e, n) => {
  const {
    rootEmit: t,
    getDate: a,
    state: s,
    modelValue: l,
    rootProps: r,
    defaults: { highlight: i, multiDates: o, filters: u, range: c, safeDates: f }
  } = Ke(), { getYears: p } = Ul(), { isDateBetween: d, resetDate: b, resetDateTime: m, getYearFromDate: k, checkHighlightYear: y, groupListAndMap: h } = Ft(), { checkRangeAutoApply: g, setMonthOrYearRange: x } = Gl(), { checkMinMaxValue: S, checkMinMaxRange: C } = on();
  js(() => {
    s.isTextInputDate && (O.value = We(a(r.startDate)));
  });
  const _ = ee(null), O = ee();
  et(() => {
    r.startDate && (l.value && r.focusStartDate || !l.value) && (O.value = We(a(r.startDate)));
  });
  const I = (ae) => Array.isArray(l.value) ? l.value.some((G) => We(G) === ae) : l.value ? We(l.value) === ae : !1, D = (ae) => c.value.enabled && Array.isArray(l.value) ? d(l.value, _.value, W(ae)) : !1, B = (ae) => {
    var G;
    return (G = f.value.allowedDates) != null && G.size ? f.value.allowedDates.has(`${ae}`) : !0;
  }, Y = (ae) => f.value.disabledDates instanceof Map ? f.value.disabledDates.size ? f.value.disabledDates.has(`${ae}`) : !1 : typeof f.value.disabledDates == "function" ? f.value.disabledDates(mn(m(Ka(a())), ae)) : !0, ne = T(() => h(p(), (ae) => {
    const G = I(ae.value), j = S(
      ae.value,
      k(f.value.minDate),
      k(f.value.maxDate)
    ) || u.value.years.includes(ae.value) || !B(ae.value) || Y(ae.value), se = D(ae.value) && !G, U = y(i.value, ae.value);
    return { active: G, disabled: j, isBetween: se, highlighted: U };
  })), W = (ae) => mn(b(Ka(a())), ae);
  return {
    groupedYears: ne,
    focusYear: O,
    setHoverValue: (ae) => {
      _.value = mn(b(a()), ae);
    },
    selectYear: (ae) => {
      var G;
      if (t("update-month-year", { instance: 0, year: ae, month: Number.NaN }), o.value.enabled)
        return l.value ? Array.isArray(l.value) && (((G = l.value) == null ? void 0 : G.map((j) => We(j))).includes(ae) ? l.value = l.value.filter((j) => We(j) !== ae) : l.value.push(mn(m(a()), ae))) : l.value = [mn(m(Ka(a())), ae)], n("auto-apply", !0);
      c.value.enabled ? C(W(ae), l.value) && (l.value = x(W(ae)), Ge().then(() => {
        g(l.value, n, l.value.length < 2);
      })) : (l.value = W(ae), n("auto-apply"));
    }
  };
}, G0 = /* @__PURE__ */ ke({
  __name: "YearPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      modelValue: l,
      defaults: { config: r },
      rootProps: i
    } = Ke(), { groupedYears: o, focusYear: u, selectYear: c, setHoverValue: f } = j0(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: l,
      selectYear: c
    }) }), (p, d) => (w(), M("div", null, [
      p.$slots["top-extra"] ? H(p.$slots, "top-extra", {
        key: 0,
        value: v(l)
      }) : R("", !0),
      p.$slots["month-year"] ? H(p.$slots, "month-year", Mt(lt({ key: 1 }, {
        years: v(o),
        selectYear: v(c)
      }))) : (w(), ue(Gs, {
        key: 2,
        items: v(o),
        "is-last": v(i).autoApply && !v(r).keepActionRow,
        height: v(r).modeHeight,
        "no-overlay-focus": !!(e.noOverlayFocus || v(i).textInput),
        "focus-value": v(u),
        type: "year",
        "use-relative": "",
        onSelected: v(c),
        onHoverValue: v(f)
      }, dt({ _: 2 }, [
        p.$slots["year-overlay-value"] ? {
          name: "item",
          fn: ce(({ item: b }) => [
            H(p.$slots, "year-overlay-value", {
              text: b.text,
              value: b.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), K0 = {
  key: 0,
  class: "dp__time_input"
}, Z0 = ["data-compact", "data-collapsed"], X0 = ["data-test-id", "aria-label", "data-dp-action-element", "onKeydown", "onClick", "onMousedown"], J0 = ["aria-label", "disabled", "data-dp-action-element", "data-test-id", "onKeydown", "onClick"], Q0 = ["data-test-id", "aria-label", "data-dp-action-element", "onKeydown", "onClick", "onMousedown"], ew = { key: 0 }, tw = ["aria-label", "data-dp-action-element", "data-compact"], nw = /* @__PURE__ */ ke({
  __name: "TimeInput",
  props: {
    hours: {},
    minutes: {},
    seconds: {},
    order: {},
    closeTimePickerBtn: {},
    disabledTimesConfig: {},
    validateTime: {}
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "overlay-opened", "overlay-closed", "set-hours", "set-minutes", "reset-flow", "mounted"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      getDate: l,
      rootEmit: r,
      rootProps: i,
      defaults: { ariaLabels: o, filters: u, config: c, range: f, multiCalendars: p, timeConfig: d }
    } = Ke(), { checkKeyDown: b, hoursToAmPmHours: m } = Dt(), { boolHtmlAttribute: k } = is(), { sanitizeTime: y, groupListAndMap: h } = Ft(), { transitionName: g, showTransition: x } = qs(), S = ka({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), C = ee("AM"), _ = ee(null), O = ee(), I = ee(!1);
    et(() => {
      a("mounted");
    });
    const D = (P) => je(l(), {
      hours: P.hours,
      minutes: P.minutes,
      seconds: d.value.enableSeconds ? P.seconds : 0,
      milliseconds: 0
    }), B = T(() => i.timePicker || d.value.timePickerInline ? 0 : 1), Y = T(
      () => (P) => $e(P, s[P]) || W(P, s[P])
    ), ne = T(() => ({ hours: s.hours, minutes: s.minutes, seconds: s.seconds })), W = (P, Q) => f.value.enabled && !f.value.disableTimeRangeValidation ? !s.validateTime(P, Q) : !1, ae = (P, Q) => {
      if (f.value.enabled && !f.value.disableTimeRangeValidation) {
        const L = Q ? +d.value[`${P}Increment`] : -+d.value[`${P}Increment`], fe = s[P] + L;
        return !s.validateTime(P, fe);
      }
      return !1;
    }, G = T(() => (P) => !V(+s[P] + +d.value[`${P}Increment`], P) || ae(P, !0)), j = T(() => (P) => !V(+s[P] - +d.value[`${P}Increment`], P) || ae(P, !1)), se = (P, Q) => hd(je(l(), P), Q), U = (P, Q) => Cb(je(l(), P), Q), N = T(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !d.value.timePickerInline,
        dp__time_col_reg_block: !d.value.enableSeconds && d.value.is24 && !d.value.timePickerInline,
        dp__time_col_reg_inline: !d.value.enableSeconds && d.value.is24 && d.value.timePickerInline,
        dp__time_col_reg_with_button: !d.value.enableSeconds && !d.value.is24,
        dp__time_col_sec: d.value.enableSeconds && d.value.is24,
        dp__time_col_sec_with_button: d.value.enableSeconds && !d.value.is24
      })
    ), J = T(
      () => d.value.timePickerInline && f.value.enabled && !p.value.count
    ), de = T(() => {
      const P = [{ type: "hours" }];
      return d.value.enableMinutes && P.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), d.value.enableSeconds && P.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), P;
    }), he = T(() => de.value.filter((P) => !P.separator)), ge = T(() => (P) => {
      if (P === "hours") {
        const Q = A(+s.hours);
        return { text: Q < 10 ? `0${Q}` : `${Q}`, value: Q };
      }
      return { text: s[P] < 10 ? `0${s[P]}` : `${s[P]}`, value: s[P] };
    }), $e = (P, Q) => {
      var fe;
      if (!s.disabledTimesConfig) return !1;
      const L = s.disabledTimesConfig(s.order, P === "hours" ? Q : void 0);
      return L[P] ? !!((fe = L[P]) != null && fe.includes(Q)) : !0;
    }, we = (P, Q) => Q !== "hours" || C.value === "AM" ? P : P + 12, X = (P) => {
      const Q = d.value.is24 ? 24 : 12, L = P === "hours" ? Q : 60, fe = +d.value[`${P}GridIncrement`], Me = P === "hours" && !d.value.is24 ? fe : 0, Re = [];
      for (let _e = Me; _e < L; _e += fe)
        Re.push({
          value: d.value.is24 ? _e : we(_e, P),
          text: _e < 10 ? `0${_e}` : `${_e}`
        });
      return P === "hours" && !d.value.is24 && Re.unshift({ value: C.value === "PM" ? 12 : 0, text: "12" }), h(Re, (_e) => ({ active: !1, disabled: u.value.times[P].includes(_e.value) || !V(_e.value, P) || $e(P, _e.value) || W(P, _e.value) }));
    }, ve = (P) => P >= 0 ? P : 59, Ce = (P) => P >= 0 ? P : 23, V = (P, Q) => {
      const L = i.minTime ? D(y(i.minTime)) : null, fe = i.maxTime ? D(y(i.maxTime)) : null, Me = D(
        y(
          ne.value,
          Q,
          Q === "minutes" || Q === "seconds" ? ve(P) : Ce(P)
        )
      );
      return L && fe ? (Wn(Me, fe) || Wa(Me, fe)) && (Cn(Me, L) || Wa(Me, L)) : L ? Cn(Me, L) || Wa(Me, L) : fe ? Wn(Me, fe) || Wa(Me, fe) : !0;
    }, Z = (P) => d.value[`no${P[0].toUpperCase() + P.slice(1)}Overlay`], me = (P) => {
      Z(P) || (S[P] = !S[P], S[P] ? (I.value = !0, a("overlay-opened", P)) : (I.value = !1, a("overlay-closed", P)));
    }, K = (P) => P === "hours" ? An : P === "minutes" ? Hn : la, oe = () => {
      O.value && clearTimeout(O.value);
    }, ye = (P, Q = !0, L) => {
      const fe = Q ? se : U, Me = Q ? +d.value[`${P}Increment`] : -+d.value[`${P}Increment`];
      V(+s[P] + Me, P) && a(
        `update:${P}`,
        K(P)(
          fe({ [P]: +s[P] }, { [P]: +d.value[`${P}Increment`] })
        )
      ), !(L != null && L.keyboard) && c.value.timeArrowHoldThreshold && (O.value = setTimeout(() => {
        ye(P, Q);
      }, c.value.timeArrowHoldThreshold));
    }, A = (P) => d.value.is24 ? P : (P >= 12 ? C.value = "PM" : C.value = "AM", m(P)), z = () => {
      C.value === "PM" ? (C.value = "AM", a("update:hours", s.hours - 12)) : (C.value = "PM", a("update:hours", s.hours + 12)), r("am-pm-change", C.value);
    }, $ = (P) => {
      S[P] = !0;
    }, F = (P, Q) => (me(P), a(`update:${P}`, Q));
    return n({ openChildCmp: $ }), (P, Q) => v(i).disabled ? R("", !0) : (w(), M("div", K0, [
      (w(!0), M(Te, null, Ie(de.value, (L, fe) => {
        var Me, Re, _e;
        return w(), M("div", {
          key: fe,
          class: q(N.value),
          "data-compact": J.value && !v(d).enableSeconds,
          "data-collapsed": J.value && v(d).enableSeconds
        }, [
          L.separator ? (w(), M(Te, { key: 0 }, [
            I.value ? R("", !0) : (w(), M(Te, { key: 0 }, [
              He(":")
            ], 64))
          ], 64)) : (w(), M(Te, { key: 1 }, [
            E("button", {
              type: "button",
              class: q({
                dp__btn: !0,
                dp__inc_dec_button: !v(d).timePickerInline,
                dp__inc_dec_button_inline: v(d).timePickerInline,
                dp__tp_inline_btn_top: v(d).timePickerInline,
                dp__inc_dec_button_disabled: G.value(L.type),
                "dp--hidden-el": I.value
              }),
              "data-test-id": `${L.type}-time-inc-btn-${s.order}`,
              "aria-label": (Me = v(o)) == null ? void 0 : Me.incrementValue(L.type),
              tabindex: "0",
              "data-dp-action-element": B.value,
              onKeydown: (Ye) => v(b)(Ye, () => ye(L.type, !0, { keyboard: !0 }), !0),
              onClick: (Ye) => v(c).timeArrowHoldThreshold ? void 0 : ye(L.type, !0),
              onMousedown: (Ye) => v(c).timeArrowHoldThreshold ? ye(L.type, !0) : void 0,
              onMouseup: oe
            }, [
              v(d).timePickerInline ? H(P.$slots, "tp-inline-arrow-up", { key: 1 }, () => [
                Q[2] || (Q[2] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                Q[3] || (Q[3] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ]) : H(P.$slots, "arrow-up", { key: 0 }, () => [
                ie(v(Pd))
              ])
            ], 42, X0),
            E("button", {
              type: "button",
              "aria-label": `${ge.value(L.type).text}-${(Re = v(o)) == null ? void 0 : Re.openTpOverlay(L.type)}`,
              class: q({
                dp__time_display: !0,
                dp__time_display_block: !v(d).timePickerInline,
                dp__time_display_inline: v(d).timePickerInline,
                "dp--time-invalid": Y.value(L.type),
                "dp--time-overlay-btn": !Y.value(L.type),
                "dp--hidden-el": I.value
              }),
              disabled: v(k)(Z(L.type)),
              tabindex: "0",
              "data-dp-action-element": B.value,
              "data-test-id": `${L.type}-toggle-overlay-btn-${s.order}`,
              onKeydown: (Ye) => v(b)(Ye, () => me(L.type), !0),
              onClick: (Ye) => me(L.type)
            }, [
              H(P.$slots, L.type, {
                text: ge.value(L.type).text,
                value: ge.value(L.type).value
              }, () => [
                He(re(ge.value(L.type).text), 1)
              ])
            ], 42, J0),
            E("button", {
              type: "button",
              class: q({
                dp__btn: !0,
                dp__inc_dec_button: !v(d).timePickerInline,
                dp__inc_dec_button_inline: v(d).timePickerInline,
                dp__tp_inline_btn_bottom: v(d).timePickerInline,
                dp__inc_dec_button_disabled: j.value(L.type),
                "dp--hidden-el": I.value
              }),
              "data-test-id": `${L.type}-time-dec-btn-${s.order}`,
              "aria-label": (_e = v(o)) == null ? void 0 : _e.decrementValue(L.type),
              tabindex: "0",
              "data-dp-action-element": B.value,
              onKeydown: (Ye) => v(b)(Ye, () => ye(L.type, !1, { keyboard: !0 }), !0),
              onClick: (Ye) => v(c).timeArrowHoldThreshold ? void 0 : ye(L.type, !1),
              onMousedown: (Ye) => v(c).timeArrowHoldThreshold ? ye(L.type, !1) : void 0,
              onMouseup: oe
            }, [
              v(d).timePickerInline ? H(P.$slots, "tp-inline-arrow-down", { key: 1 }, () => [
                Q[4] || (Q[4] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                Q[5] || (Q[5] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ]) : H(P.$slots, "arrow-down", { key: 0 }, () => [
                ie(v(Rd))
              ])
            ], 42, Q0)
          ], 64))
        ], 10, Z0);
      }), 128)),
      v(d).is24 ? R("", !0) : (w(), M("div", ew, [
        H(P.$slots, "am-pm-button", {
          toggle: z,
          value: C.value
        }, () => {
          var L;
          return [
            E("button", {
              ref_key: "amPmButton",
              ref: _,
              type: "button",
              class: "dp__pm_am_button",
              role: "button",
              "aria-label": (L = v(o)) == null ? void 0 : L.amPmButton,
              tabindex: "0",
              "data-dp-action-element": B.value,
              "data-compact": J.value,
              onClick: z,
              onKeydown: Q[0] || (Q[0] = (fe) => v(b)(fe, () => z(), !0))
            }, re(C.value), 41, tw)
          ];
        })
      ])),
      (w(!0), M(Te, null, Ie(he.value, (L, fe) => (w(), ue(ht, {
        key: fe,
        name: v(g)(S[L.type]),
        css: v(x)
      }, {
        default: ce(() => {
          var Me, Re;
          return [
            S[L.type] ? (w(), ue(Gs, {
              key: 0,
              items: X(L.type),
              "is-last": v(i).autoApply && !v(c).keepActionRow,
              type: L.type,
              "aria-labels": v(o),
              level: v(d).timePickerInline || v(i).timePicker ? 1 : 2,
              "overlay-label": (Re = (Me = v(o)).timeOverlay) == null ? void 0 : Re.call(Me, L.type),
              onSelected: (_e) => F(L.type, _e),
              onToggle: (_e) => me(L.type),
              onResetFlow: Q[1] || (Q[1] = (_e) => P.$emit("reset-flow"))
            }, dt({
              "button-icon": ce(() => [
                H(P.$slots, "clock-icon", {}, () => [
                  P.$slots["clock-icon"] ? R("", !0) : (w(), ue(mt(v(d).timePickerInline ? v(Us) : v(Ad)), { key: 0 }))
                ])
              ]),
              _: 2
            }, [
              P.$slots[`${L.type}-overlay-value`] ? {
                name: "item",
                fn: ce(({ item: _e }) => [
                  H(P.$slots, `${L.type}-overlay-value`, {
                    text: _e.text,
                    value: _e.value
                  })
                ]),
                key: "0"
              } : void 0,
              P.$slots[`${L.type}-overlay-header`] ? {
                name: "header",
                fn: ce(() => [
                  H(P.$slots, `${L.type}-overlay-header`, {
                    toggle: () => me(L.type)
                  })
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["items", "is-last", "type", "aria-labels", "level", "overlay-label", "onSelected", "onToggle"])) : R("", !0)
          ];
        }),
        _: 2
      }, 1032, ["name", "css"]))), 128))
    ]));
  }
}), aw = ["data-dp-mobile"], sw = ["aria-label", "tabindex"], lw = ["role", "aria-label", "tabindex"], rw = ["aria-label"], Wd = /* @__PURE__ */ ke({
  __name: "TimePicker",
  props: {
    hours: {},
    minutes: {},
    seconds: {},
    disabledTimesConfig: { type: [Function, null] },
    noOverlayFocus: { type: Boolean },
    validateTime: { type: Function }
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "mount", "reset-flow"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: l,
      setState: r,
      modelValue: i,
      rootProps: o,
      defaults: { ariaLabels: u, textInput: c, config: f, range: p, timeConfig: d }
    } = Ke(), { isModelAuto: b } = Ft(), { checkKeyDown: m, findFocusableEl: k } = Dt(), { transitionName: y, showTransition: h } = qs(), { hideNavigationButtons: g } = ql(), { isMobile: x } = Hl(), S = Ht(), C = Xe("overlay"), _ = Xe("close-tp-btn"), O = Xe("tp-input"), I = ee(!1);
    et(() => {
      a("mount");
    });
    const D = T(() => p.value.enabled && o.modelAuto ? b(i.value) : !0), B = ee(!1), Y = (ge) => ({
      hours: Array.isArray(s.hours) ? s.hours[ge] : s.hours,
      minutes: Array.isArray(s.minutes) ? s.minutes[ge] : s.minutes,
      seconds: Array.isArray(s.seconds) ? s.seconds[ge] : s.seconds
    }), ne = T(() => {
      const ge = [];
      if (p.value.enabled)
        for (let $e = 0; $e < 2; $e++)
          ge.push(Y($e));
      else
        ge.push(Y(0));
      return ge;
    }), W = (ge, $e = !1, we = "") => {
      $e || a("reset-flow"), B.value = ge, r("arrowNavigationLevel", ge ? 1 : 0), l("overlay-toggle", { open: ge, overlay: Lt.time }), Ge(() => {
        var X;
        we !== "" && ((X = O.value) != null && X[0]) && O.value[0].openChildCmp(we);
      });
    }, ae = T(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: o.autoApply && !f.value.keepActionRow
    })), G = _n(S, gn.TimeInput), j = (ge, $e, we) => p.value.enabled ? $e === 0 ? [ge, ne.value[1][we]] : [ne.value[0][we], ge] : ge, se = (ge) => {
      a("update:hours", ge);
    }, U = (ge) => {
      a("update:minutes", ge);
    }, N = (ge) => {
      a("update:seconds", ge);
    }, J = () => {
      if (C.value && !c.value.enabled && !s.noOverlayFocus) {
        const ge = k(C.value);
        ge && ge.focus({ preventScroll: !0 });
      }
    }, de = (ge) => {
      I.value = !1, l("overlay-toggle", { open: !1, overlay: ge });
    }, he = (ge) => {
      I.value = !0, l("overlay-toggle", { open: !0, overlay: ge });
    };
    return n({ toggleTimePicker: W }), (ge, $e) => {
      var we;
      return w(), M("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": v(x)
      }, [
        !v(o).timePicker && !v(d).timePickerInline ? an((w(), M("button", {
          key: 0,
          ref: "open-tp-btn",
          type: "button",
          "data-dp-action-element": "0",
          class: q({ ...ae.value, "dp--hidden-el": B.value }),
          "aria-label": (we = v(u)) == null ? void 0 : we.openTimePicker,
          tabindex: e.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: $e[0] || ($e[0] = (X) => v(m)(X, () => W(!0))),
          onClick: $e[1] || ($e[1] = (X) => W(!0))
        }, [
          H(ge.$slots, "clock-icon", {}, () => [
            ie(v(Ad))
          ])
        ], 42, sw)), [
          [Bn, !v(g)("time")]
        ]) : R("", !0),
        ie(ht, {
          name: v(y)(B.value),
          css: v(h) && !v(d).timePickerInline
        }, {
          default: ce(() => {
            var X, ve;
            return [
              B.value || v(o).timePicker || v(d).timePickerInline ? (w(), M("div", {
                key: 0,
                ref: "overlay",
                role: v(d).timePickerInline ? void 0 : "dialog",
                class: q({
                  dp__overlay: !v(d).timePickerInline,
                  "dp--overlay-absolute": !v(o).timePicker && !v(d).timePickerInline,
                  "dp--overlay-relative": v(o).timePicker
                }),
                style: Fe(v(o).timePicker ? { height: `${v(f).modeHeight}px` } : void 0),
                "aria-label": (X = v(u)) == null ? void 0 : X.timePicker,
                tabindex: v(d).timePickerInline ? void 0 : 0
              }, [
                E("div", {
                  class: q(
                    v(d).timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  H(ge.$slots, "time-picker-overlay", {
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: se,
                    setMinutes: U,
                    setSeconds: N
                  }, () => [
                    E("div", {
                      class: q(v(d).timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                    }, [
                      (w(!0), M(Te, null, Ie(ne.value, (Ce, V) => an((w(), ue(nw, lt({ key: V }, { ref_for: !0 }, {
                        order: V,
                        hours: Ce.hours,
                        minutes: Ce.minutes,
                        seconds: Ce.seconds,
                        closeTimePickerBtn: _.value,
                        disabledTimesConfig: e.disabledTimesConfig,
                        disabled: V === 0 ? v(p).fixedStart : v(p).fixedEnd
                      }, {
                        ref_for: !0,
                        ref: "tp-input",
                        "validate-time": (Z, me) => e.validateTime(Z, j(me, V, Z)),
                        "onUpdate:hours": (Z) => se(j(Z, V, "hours")),
                        "onUpdate:minutes": (Z) => U(j(Z, V, "minutes")),
                        "onUpdate:seconds": (Z) => N(j(Z, V, "seconds")),
                        onMounted: J,
                        onOverlayClosed: de,
                        onOverlayOpened: he
                      }), dt({ _: 2 }, [
                        Ie(v(G), (Z, me) => ({
                          name: Z,
                          fn: ce((K) => [
                            H(ge.$slots, Z, lt({ ref_for: !0 }, K))
                          ])
                        }))
                      ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                        [Bn, V === 0 ? !0 : D.value]
                      ])), 128))
                    ], 2)
                  ]),
                  !v(o).timePicker && !v(d).timePickerInline ? an((w(), M("button", {
                    key: 0,
                    ref: "close-tp-btn",
                    "data-dp-action-element": "1",
                    type: "button",
                    class: q({ ...ae.value, "dp--hidden-el": I.value }),
                    "aria-label": (ve = v(u)) == null ? void 0 : ve.closeTimePicker,
                    tabindex: "0",
                    onKeydown: $e[2] || ($e[2] = (Ce) => v(m)(Ce, () => W(!1))),
                    onClick: $e[3] || ($e[3] = (Ce) => W(!1))
                  }, [
                    H(ge.$slots, "calendar-icon", {}, () => [
                      ie(v(Us))
                    ])
                  ], 42, rw)), [
                    [Bn, !v(g)("time")]
                  ]) : R("", !0)
                ], 2)
              ], 14, lw)) : R("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, aw);
    };
  }
}), Yd = (e) => {
  const {
    getDate: n,
    modelValue: t,
    time: a,
    rootProps: s,
    defaults: { range: l, timeConfig: r }
  } = Ke(), { isDateEqual: i, setTime: o } = Ft(), u = (_, O) => Array.isArray(a[_]) ? a[_][O] : a[_], c = (_) => r.value.enableSeconds ? Array.isArray(a.seconds) ? a.seconds[_] : a.seconds : 0, f = (_, O) => _ ? o(
    O !== void 0 ? { hours: u("hours", O), minutes: u("minutes", O), seconds: c(O) } : { hours: a.hours, minutes: a.minutes, seconds: c() },
    _
  ) : Mb(n(), c(O)), p = (_, O) => {
    a[_] = O;
  }, d = T(() => s.modelAuto && l.value.enabled ? Array.isArray(t.value) ? t.value.length > 1 : !1 : l.value.enabled), b = (_, O) => {
    const I = Object.fromEntries(
      Object.keys(a).map((D) => D === _ ? [D, O] : [D, a[D]].slice())
    );
    if (d.value && !l.value.disableTimeRangeValidation) {
      const D = (Y) => t.value ? o(
        {
          hours: I.hours[Y],
          minutes: I.minutes[Y],
          seconds: I.seconds[Y]
        },
        t.value[Y]
      ) : null, B = (Y) => $b(t.value[Y], 0);
      return !(i(D(0), D(1)) && (Cn(D(0), B(1)) || Wn(D(1), B(0))));
    }
    return !0;
  }, m = (_, O) => {
    b(_, O) && (p(_, O), e && e());
  }, k = (_) => {
    m("hours", _);
  }, y = (_) => {
    m("minutes", _);
  }, h = (_) => {
    m("seconds", _);
  }, g = (_, O) => {
    k(_.hours), y(_.minutes), h(_.seconds), t.value && O(t.value);
  }, x = (_) => {
    if (_) {
      const O = Array.isArray(_), I = O ? [+_[0].hours, +_[1].hours] : +_.hours, D = O ? [+_[0].minutes, +_[1].minutes] : +_.minutes, B = O ? [+(_[0].seconds ?? 0), +(_[1].seconds ?? 0)] : +(_.seconds ?? 0);
      p("hours", I), p("minutes", D), r.value.enableSeconds && p("seconds", B);
    }
  }, S = (_, O) => {
    const I = {
      hours: Array.isArray(a.hours) ? a.hours[_] : a.hours,
      disabledArr: []
    };
    return (O || O === 0) && (I.hours = O), Array.isArray(s.disabledTimes) && (I.disabledArr = l.value.enabled && Array.isArray(s.disabledTimes[_]) ? s.disabledTimes[_] : s.disabledTimes), I;
  }, C = T(() => (_, O) => {
    var I;
    if (Array.isArray(s.disabledTimes)) {
      const { disabledArr: D, hours: B } = S(_, O), Y = D.filter((ne) => +ne.hours === B);
      return ((I = Y[0]) == null ? void 0 : I.minutes) === "*" ? { hours: [B], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (Y == null ? void 0 : Y.map((ne) => +ne.minutes)) ?? [],
        seconds: (Y == null ? void 0 : Y.map((ne) => ne.seconds ? +ne.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    assignTime: p,
    updateHours: k,
    updateMinutes: y,
    updateSeconds: h,
    getSetDateTime: f,
    updateTimeValues: g,
    getSecondsValue: c,
    assignStartTime: x,
    validateTime: b,
    disabledTimesConfig: C
  };
}, iw = (e) => {
  const {
    getDate: n,
    time: t,
    modelValue: a,
    state: s,
    defaults: { startTime: l, range: r, timeConfig: i }
  } = Ke(), { getTimeObj: o } = Ft();
  js(() => {
    s.isTextInputDate && S();
  });
  const { updateTimeValues: u, getSetDateTime: c, assignTime: f, assignStartTime: p, disabledTimesConfig: d, validateTime: b } = Yd(m);
  function m() {
    e("update-flow-step");
  }
  const k = (_) => {
    const { hours: O, minutes: I, seconds: D } = _;
    return { hours: +O, minutes: +I, seconds: D ? +D : 0 };
  }, y = () => {
    if (i.value.startTime) {
      if (Array.isArray(i.value.startTime)) {
        const O = k(i.value.startTime[0]), I = k(i.value.startTime[1]);
        return [je(n(), O), je(n(), I)];
      }
      const _ = k(i.value.startTime);
      return je(n(), _);
    }
    return r.value.enabled ? [null, null] : null;
  }, h = () => {
    if (r.value.enabled) {
      const [_, O] = y();
      a.value = [c(_, 0), c(O, 1)];
    } else
      a.value = c(y());
  }, g = (_) => Array.isArray(_) ? [o(n(_[0])), o(n(_[1]))] : [o(_ ?? n())], x = (_, O, I) => {
    f("hours", _), f("minutes", O), f("seconds", i.value.enableSeconds ? I : 0);
  }, S = () => {
    const [_, O] = g(a.value);
    return r.value.enabled ? x(
      [_.hours, O.hours],
      [_.minutes, O.minutes],
      [_.seconds, O.seconds]
    ) : x(_.hours, _.minutes, _.seconds);
  };
  et(() => (p(l.value), a.value ? S() : h()));
  const C = () => {
    Array.isArray(a.value) ? a.value = a.value.map((_, O) => _ && c(_, O)) : a.value = c(a.value), e("time-update");
  };
  return {
    modelValue: a,
    time: t,
    disabledTimesConfig: d,
    validateTime: b,
    updateTime: (_) => {
      u(_, C);
    }
  };
}, ow = /* @__PURE__ */ ke({
  __name: "TimePickerSolo",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["time-update", "mount", "reset-flow", "update-flow-step"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = Ht(), l = _n(s, gn.TimePicker), r = Xe("time-input"), { time: i, modelValue: o, disabledTimesConfig: u, updateTime: c, validateTime: f } = iw(a);
    return et(() => {
      a("mount");
    }), n({ getSidebarProps: () => ({
      modelValue: o,
      time: i,
      updateTime: c
    }), toggleTimePicker: (p, d = !1, b = "") => {
      var m;
      (m = r.value) == null || m.toggleTimePicker(p, d, b);
    } }), (p, d) => (w(), ue(jl, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: ce(({ wrapClass: b }) => [
        E("div", {
          class: q(b)
        }, [
          ie(Wd, lt({ ref: "time-input" }, p.$props, {
            hours: v(i).hours,
            minutes: v(i).minutes,
            seconds: v(i).seconds,
            "disabled-times-config": v(u),
            "validate-time": v(f),
            "onUpdate:hours": d[0] || (d[0] = (m) => v(c)({ hours: m, minutes: v(i).minutes, seconds: v(i).seconds })),
            "onUpdate:minutes": d[1] || (d[1] = (m) => v(c)({ hours: v(i).hours, minutes: m, seconds: v(i).seconds })),
            "onUpdate:seconds": d[2] || (d[2] = (m) => v(c)({ hours: v(i).hours, minutes: v(i).minutes, seconds: m })),
            onResetFlow: d[3] || (d[3] = (m) => p.$emit("reset-flow"))
          }), dt({ _: 2 }, [
            Ie(v(l), (m, k) => ({
              name: m,
              fn: ce((y) => [
                H(p.$slots, m, Mt(Nt(y)))
              ])
            }))
          ]), 1040, ["hours", "minutes", "seconds", "disabled-times-config", "validate-time"])
        ], 2)
      ]),
      _: 3
    }));
  }
}), uw = (e, n) => {
  const {
    getDate: t,
    rootProps: a,
    defaults: { filters: s }
  } = Ke(), { validateMonthYearInRange: l, validateMonthYear: r } = on(), i = (p, d) => {
    let b = p;
    return s.value.months.includes(Ze(b)) ? (b = d ? pn(p, 1) : ts(p, 1), i(b, d)) : b;
  }, o = (p, d) => {
    let b = p;
    return s.value.years.includes(We(b)) ? (b = d ? Oi(p, 1) : Od(p, 1), o(b, d)) : b;
  }, u = (p, d = !1) => {
    const b = je(t(), { month: e.month, year: e.year });
    let m = p ? pn(b, 1) : ts(b, 1);
    a.disableYearSelect && (m = mn(m, e.year));
    let k = Ze(m), y = We(m);
    s.value.months.includes(k) && (m = i(m, p), k = Ze(m), y = We(m)), s.value.years.includes(y) && (m = o(m, p), y = We(m)), l(k, y, p, a.preventMinMaxNavigation) && c(k, y, d);
  }, c = (p, d, b = !1) => {
    n("update-month-year", { month: p, year: d, fromNav: b });
  }, f = T(() => (p) => r(
    je(t(), { month: e.month, year: e.year }),
    a.preventMinMaxNavigation,
    p
  ));
  return { handleMonthYearChange: u, isDisabled: f, updateMonthYear: c };
}, cw = { class: "dp--header-wrap" }, dw = {
  key: 0,
  class: "dp__month_year_wrap"
}, fw = { key: 0 }, hw = { class: "dp__month_year_wrap" }, mw = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], vw = /* @__PURE__ */ ke({
  __name: "DpHeader",
  props: {
    month: {},
    year: {},
    instance: {},
    years: {},
    months: {},
    menuWrapRef: {}
  },
  emits: ["mount", "reset-flow", "update-month-year"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: l,
      rootProps: r,
      modelValue: i,
      defaults: { ariaLabels: o, filters: u, config: c, highlight: f, safeDates: p, ui: d }
    } = Ke(), { transitionName: b, showTransition: m } = qs(), { showLeftIcon: k, showRightIcon: y } = ql(), { handleMonthYearChange: h, isDisabled: g, updateMonthYear: x } = uw(s, a), { getMaxMonth: S, getMinMonth: C, getYearFromDate: _, groupListAndMap: O, checkHighlightYear: I, checkHighlightMonth: D } = Ft(), { checkKeyDown: B } = Dt(), { formatYear: Y } = ra(), { checkMinMaxValue: ne } = on(), { boolHtmlAttribute: W } = is(), ae = ee(!1), G = ee(!1), j = ee(!1);
    et(() => {
      a("mount");
    });
    const se = (Z) => ({
      get: () => s[Z],
      set: (me) => {
        const K = Z === fn.month ? fn.year : fn.month;
        a("update-month-year", { [Z]: me, [K]: s[K] }), Z === fn.month ? we(!0) : X(!0);
      }
    }), U = T(se(fn.month)), N = T(se(fn.year)), J = T(() => (Z) => ({
      month: s.month,
      year: s.year,
      items: Z === fn.month ? s.months : s.years,
      instance: s.instance,
      updateMonthYear: x,
      toggle: Z === fn.month ? we : X
    })), de = T(() => s.months.find((me) => me.value === s.month) || { text: "", value: 0 }), he = T(() => O(s.months, (Z) => {
      const me = s.month === Z.value, K = ne(
        Z.value,
        C(s.year, p.value.minDate),
        S(s.year, p.value.maxDate)
      ) || u.value.months.includes(Z.value), oe = D(f.value, Z.value, s.year);
      return { active: me, disabled: K, highlighted: oe };
    })), ge = T(() => O(s.years, (Z) => {
      const me = s.year === Z.value, K = ne(
        Z.value,
        _(p.value.minDate),
        _(p.value.maxDate)
      ) || u.value.years.includes(Z.value), oe = I(f.value, Z.value);
      return { active: me, disabled: K, highlighted: oe };
    })), $e = (Z, me, K) => {
      K === void 0 ? Z.value = !Z.value : Z.value = K, Z.value ? (j.value = !0, l("overlay-toggle", { open: !0, overlay: me })) : (j.value = !1, l("overlay-toggle", { open: !1, overlay: me }));
    }, we = (Z = !1, me) => {
      ve(Z), $e(ae, Lt.month, me);
    }, X = (Z = !1, me) => {
      ve(Z), $e(G, Lt.year, me);
    }, ve = (Z) => {
      Z || a("reset-flow");
    }, Ce = T(() => {
      var Z, me, K, oe, ye, A;
      return [
        {
          type: fn.month,
          index: 1,
          toggle: we,
          modelValue: U.value,
          updateModelValue: (z) => U.value = z,
          text: de.value.text,
          showSelectionGrid: ae.value,
          items: he.value,
          ariaLabel: (Z = o.value) == null ? void 0 : Z.openMonthsOverlay,
          overlayLabel: ((K = (me = o.value).monthPicker) == null ? void 0 : K.call(me, !0)) ?? void 0
        },
        {
          type: fn.year,
          index: 2,
          toggle: X,
          modelValue: N.value,
          updateModelValue: (z) => N.value = z,
          text: Y(s.year),
          showSelectionGrid: G.value,
          items: ge.value,
          ariaLabel: (oe = o.value) == null ? void 0 : oe.openYearsOverlay,
          overlayLabel: ((A = (ye = o.value).yearPicker) == null ? void 0 : A.call(ye, !0)) ?? void 0
        }
      ];
    }), V = T(() => r.disableYearSelect ? [Ce.value[0]] : r.yearFirst ? [...Ce.value].reverse() : Ce.value);
    return n({
      toggleMonthPicker: we,
      toggleYearPicker: X,
      handleMonthYearChange: h
    }), (Z, me) => {
      var K, oe, ye, A, z, $;
      return w(), M("div", cw, [
        Z.$slots["month-year"] ? (w(), M("div", dw, [
          H(Z.$slots, "month-year", Mt(Nt({
            month: e.month,
            year: e.year,
            months: e.months,
            years: e.years,
            updateMonthYear: v(x),
            handleMonthYearChange: v(h),
            instance: e.instance,
            isDisabled: v(g)
          })))
        ])) : (w(), M(Te, { key: 1 }, [
          Z.$slots["top-extra"] ? (w(), M("div", fw, [
            H(Z.$slots, "top-extra", { value: v(i) })
          ])) : R("", !0),
          E("div", hw, [
            v(k)(e.instance) && !v(r).vertical ? (w(), ue(Ds, {
              key: 0,
              "aria-label": (K = v(o)) == null ? void 0 : K.prevMonth,
              disabled: v(W)(v(g)(!1)),
              class: q((oe = v(d)) == null ? void 0 : oe.navBtnPrev),
              "el-name": "action-prev",
              onActivate: me[0] || (me[0] = (F) => v(h)(!1, !0))
            }, {
              default: ce(() => [
                Z.$slots["arrow-left"] ? H(Z.$slots, "arrow-left", { key: 0 }) : R("", !0),
                Z.$slots["arrow-left"] ? R("", !0) : (w(), ue(v(Ed), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : R("", !0),
            E("div", {
              class: q(["dp__month_year_wrap", {
                dp__year_disable_select: v(r).disableYearSelect
              }])
            }, [
              (w(!0), M(Te, null, Ie(V.value, (F) => (w(), M(Te, {
                key: F.type
              }, [
                E("button", {
                  type: "button",
                  "data-dp-element": `overlay-${F.type}`,
                  class: q(["dp__btn dp__month_year_select", { "dp--hidden-el": j.value }]),
                  "aria-label": `${F.text}-${F.ariaLabel}`,
                  "data-test-id": `${F.type}-toggle-overlay-${e.instance}`,
                  tabindex: "0",
                  "data-dp-action-element": "0",
                  onClick: (P) => F.toggle(!1),
                  onKeydown: (P) => v(B)(P, () => F.toggle(), !0)
                }, [
                  Z.$slots[F.type] ? H(Z.$slots, F.type, {
                    key: 0,
                    text: F.text,
                    value: s[F.type]
                  }) : R("", !0),
                  Z.$slots[F.type] ? R("", !0) : (w(), M(Te, { key: 1 }, [
                    He(re(F.text), 1)
                  ], 64))
                ], 42, mw),
                ie(ht, {
                  name: v(b)(F.showSelectionGrid),
                  css: v(m)
                }, {
                  default: ce(() => [
                    F.showSelectionGrid ? (w(), ue(Gs, {
                      key: 0,
                      items: F.items,
                      "is-last": v(r).autoApply && !v(c).keepActionRow,
                      "skip-button-ref": !1,
                      type: F.type,
                      "header-refs": [],
                      "menu-wrap-ref": e.menuWrapRef,
                      "overlay-label": F.overlayLabel,
                      onSelected: F.updateModelValue,
                      onToggle: F.toggle
                    }, dt({
                      "button-icon": ce(() => [
                        Z.$slots["calendar-icon"] ? H(Z.$slots, "calendar-icon", { key: 0 }) : R("", !0),
                        Z.$slots["calendar-icon"] ? R("", !0) : (w(), ue(v(Us), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      Z.$slots[`${F.type}-overlay-value`] ? {
                        name: "item",
                        fn: ce(({ item: P }) => [
                          H(Z.$slots, `${F.type}-overlay-value`, {
                            text: P.text,
                            value: P.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      Z.$slots[`${F.type}-overlay`] ? {
                        name: "overlay",
                        fn: ce(() => [
                          H(Z.$slots, `${F.type}-overlay`, lt({ ref_for: !0 }, J.value(F.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      Z.$slots[`${F.type}-overlay-header`] ? {
                        name: "header",
                        fn: ce(() => [
                          H(Z.$slots, `${F.type}-overlay-header`, {
                            toggle: F.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "is-last", "type", "menu-wrap-ref", "overlay-label", "onSelected", "onToggle"])) : R("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            v(k)(e.instance) && v(r).vertical ? (w(), ue(Ds, {
              key: 1,
              "aria-label": (ye = v(o)) == null ? void 0 : ye.prevMonth,
              "el-name": "action-prev",
              disabled: v(W)(v(g)(!1)),
              class: q((A = v(d)) == null ? void 0 : A.navBtnPrev),
              onActivate: me[1] || (me[1] = (F) => v(h)(!1, !0))
            }, {
              default: ce(() => [
                Z.$slots["arrow-up"] ? H(Z.$slots, "arrow-up", { key: 0 }) : R("", !0),
                Z.$slots["arrow-up"] ? R("", !0) : (w(), ue(v(Pd), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : R("", !0),
            v(y)(e.instance) ? (w(), ue(Ds, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: v(W)(v(g)(!0)),
              "aria-label": (z = v(o)) == null ? void 0 : z.nextMonth,
              class: q(($ = v(d)) == null ? void 0 : $.navBtnNext),
              onActivate: me[2] || (me[2] = (F) => v(h)(!0, !0))
            }, {
              default: ce(() => [
                Z.$slots[v(r).vertical ? "arrow-down" : "arrow-right"] ? H(Z.$slots, v(r).vertical ? "arrow-down" : "arrow-right", { key: 0 }) : R("", !0),
                Z.$slots[v(r).vertical ? "arrow-down" : "arrow-right"] ? R("", !0) : (w(), ue(mt(v(r).vertical ? v(Rd) : v(Id)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : R("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), pw = {
  class: "dp__calendar_header",
  role: "row"
}, gw = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, yw = ["aria-label"], bw = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, ww = { class: "dp__cell_inner" }, kw = ["id", "aria-selected", "aria-disabled", "aria-label", "tabindex", "data-test-id", "data-dp-element-active", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], xw = /* @__PURE__ */ ke({
  __name: "DpCalendar",
  props: {
    instance: {},
    mappedDates: {},
    month: {},
    year: {}
  },
  emits: ["mount", "select-date", "set-hover-date", "handle-scroll", "handle-swipe"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      getDate: l,
      rootEmit: r,
      rootProps: i,
      defaults: { transitions: o, config: u, ariaLabels: c, multiCalendars: f, weekNumbers: p, multiDates: d, ui: b }
    } = Ke(), { isDateAfter: m, isDateEqual: k, resetDateTime: y, getCellId: h } = Ft(), { checkKeyDown: g, checkStopPropagation: x, isTouchDevice: S } = Dt(), { formatWeekDay: C } = ra(), _ = Xe("calendar-wrap"), O = Xe("active-tooltip"), I = ee([]), D = ee(null), B = ee(!0), Y = ee(!1), ne = ee(""), W = ee({
      bottom: "",
      left: "",
      transform: ""
    }), ae = ee({ left: "50%" });
    Sp(_, {
      onSwipeEnd: ($, F) => {
        u.value.noSwipe || (i.vertical ? (F === "up" || F === "down") && a("handle-swipe", F === "up" ? "left" : "right") : (F === "left" || F === "right") && a("handle-swipe", F === "right" ? "left" : "right"));
      }
    });
    const G = T(() => i.calendar ? i.calendar(s.mappedDates) : s.mappedDates), j = T(() => i.dayNames ? Array.isArray(i.dayNames) ? i.dayNames : i.dayNames() : z());
    et(() => {
      a("mount", { cmp: "calendar", dayRefs: I.value }), u.value.monthChangeOnScroll && _.value && _.value.addEventListener("wheel", Z, { passive: !1 });
    }), Xt(() => {
      u.value.monthChangeOnScroll && _.value && _.value.removeEventListener("wheel", Z);
    });
    const se = ($) => $ ? i.vertical ? "vNext" : "next" : i.vertical ? "vPrevious" : "previous", U = ($, F) => {
      if (i.transitions) {
        const P = y(je(l(), { month: s.month, year: s.year }));
        ne.value = m(y(je(l(), { month: $, year: F })), P) ? o.value[se(!0)] : o.value[se(!1)], B.value = !1, Ge(() => {
          B.value = !0;
        });
      }
    }, N = T(
      () => ({
        ...b.value.calendar
      })
    ), J = ($) => ({ type: "dot", ...$ }), de = T(() => ($) => {
      const F = J($);
      return {
        dp__marker_dot: F.type === "dot",
        dp__marker_line: F.type === "line"
      };
    }), he = T(() => ($) => k($, D.value)), ge = T(() => ({
      dp__calendar: !0,
      dp__calendar_next: f.value.count > 0 && s.instance !== 0
    })), $e = T(() => ($) => i.hideOffsetDates ? $.current : !0), we = async ($, F) => {
      var Me;
      const { width: P, height: Q } = $.getBoundingClientRect();
      D.value = F.value;
      let L = { left: `${P / 2}px` }, fe = -50;
      if (await Ge(), (Me = O.value) == null ? void 0 : Me[0]) {
        const { left: Re, width: _e } = O.value[0].getBoundingClientRect();
        Re < 0 && (L = { left: "0" }, fe = 0, ae.value.left = `${P / 2}px`), globalThis.innerWidth < Re + _e && (L = { right: "0" }, fe = 0, ae.value.left = `${_e - P / 2}px`);
      }
      W.value = {
        bottom: `${Q}px`,
        ...L,
        transform: `translateX(${fe}%)`
      };
    }, X = async ($, F, P) => {
      var L, fe, Me, Re, _e;
      const Q = Gt((fe = (L = I.value) == null ? void 0 : L[F]) == null ? void 0 : fe[P]);
      Q && ((Me = $.marker) != null && Me.customPosition && ((_e = (Re = $.marker) == null ? void 0 : Re.tooltip) != null && _e.length) ? W.value = $.marker.customPosition(Q) : await we(Q, $), r("tooltip-open", $.marker));
    }, ve = async ($, F, P) => {
      var Q, L;
      if (Y.value && d.value.enabled && d.value.dragSelect)
        return a("select-date", $);
      if (a("set-hover-date", $), (L = (Q = $.marker) == null ? void 0 : Q.tooltip) == null ? void 0 : L.length) {
        if (i.hideOffsetDates && !$.current) return;
        await X($, F, P);
      }
    }, Ce = ($) => {
      D.value && (D.value = null, W.value = structuredClone({ bottom: "", left: "", transform: "" }), r("tooltip-close", $.marker));
    }, V = ($, F, P) => {
      $ && (Array.isArray(I.value[F]) ? I.value[F][P] = $ : I.value[F] = [$]);
    }, Z = ($) => {
      u.value.monthChangeOnScroll && ($.preventDefault(), a("handle-scroll", $));
    }, me = ($) => p.value ? p.value.type === "local" ? Pi($.value, {
      weekStartsOn: +i.weekStart,
      locale: i.locale
    }) : p.value.type === "iso" ? Ii($.value) : typeof p.value.type == "function" ? p.value.type($.value) : "" : "", K = ($) => {
      var P;
      const F = $[0];
      return (P = p.value) != null && P.hideOnOffsetDates ? $.some((Q) => Q.current) ? me(F) : "" : me(F);
    }, oe = ($, F, P = !0) => {
      !P && S() || (!d.value.enabled || u.value.allowPreventDefault) && (x($, u.value), a("select-date", F));
    }, ye = ($) => {
      x($, u.value);
    }, A = ($) => {
      d.value.enabled && d.value.dragSelect ? (Y.value = !0, a("select-date", $)) : d.value.enabled && a("select-date", $);
    }, z = () => {
      const $ = l(), F = rn($, { locale: i.locale, weekStartsOn: +i.weekStart }), P = Ei($, { locale: i.locale, weekStartsOn: +i.weekStart });
      return _i({ start: F, end: P }).map((Q) => C(Q));
    };
    return n({ triggerTransition: U }), ($, F) => (w(), M("div", {
      class: q(ge.value)
    }, [
      E("div", {
        ref: "calendar-wrap",
        class: q(N.value),
        role: "grid"
      }, [
        E("div", pw, [
          v(p) ? (w(), M("div", gw, re(v(p).label), 1)) : R("", !0),
          (w(!0), M(Te, null, Ie(j.value, (P, Q) => {
            var L, fe;
            return w(), M("div", {
              key: Q,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (fe = (L = v(c)) == null ? void 0 : L.weekDay) == null ? void 0 : fe.call(L, Q)
            }, [
              H($.$slots, "calendar-header", {
                day: P,
                index: Q
              }, () => [
                He(re(P), 1)
              ])
            ], 8, yw);
          }), 128))
        ]),
        F[2] || (F[2] = E("div", { class: "dp__calendar_header_separator" }, null, -1)),
        ie(ht, {
          name: ne.value,
          css: !!v(o)
        }, {
          default: ce(() => [
            B.value ? (w(), M("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: F[1] || (F[1] = (P) => Y.value = !1)
            }, [
              (w(!0), M(Te, null, Ie(G.value, (P, Q) => (w(), M("div", {
                key: Q,
                class: "dp__calendar_row",
                role: "row"
              }, [
                v(p) ? (w(), M("div", bw, [
                  E("div", ww, re(K(P.days)), 1)
                ])) : R("", !0),
                (w(!0), M(Te, null, Ie(P.days, (L, fe) => {
                  var Me, Re, _e;
                  return w(), M("div", {
                    id: v(h)(L.value),
                    ref_for: !0,
                    ref: (Ye) => V(Ye, Q, fe),
                    key: fe + Q,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-selected": (L.classData.dp__active_date || L.classData.dp__range_start || L.classData.dp__range_end) ?? void 0,
                    "aria-disabled": L.classData.dp__cell_disabled || void 0,
                    "aria-label": (Re = (Me = v(c)) == null ? void 0 : Me.day) == null ? void 0 : Re.call(Me, L),
                    tabindex: !L.current && v(i).hideOffsetDates ? void 0 : 0,
                    "data-test-id": v(h)(L.value),
                    "data-dp-element-active": L.classData.dp__active_date ? 0 : void 0,
                    "data-dp-action-element": "0",
                    onClick: Ve((Ye) => oe(Ye, L), ["prevent"]),
                    onTouchend: (Ye) => oe(Ye, L, !1),
                    onKeydown: (Ye) => v(g)(Ye, () => $.$emit("select-date", L)),
                    onMouseenter: (Ye) => ve(L, Q, fe),
                    onMouseleave: (Ye) => Ce(L),
                    onMousedown: (Ye) => A(L),
                    onMouseup: F[0] || (F[0] = (Ye) => Y.value = !1)
                  }, [
                    E("div", {
                      class: q(["dp__cell_inner", L.classData])
                    }, [
                      $.$slots.day && $e.value(L) ? H($.$slots, "day", {
                        key: 0,
                        day: +L.text,
                        date: L.value
                      }) : R("", !0),
                      $.$slots.day ? R("", !0) : (w(), M(Te, { key: 1 }, [
                        He(re(L.text), 1)
                      ], 64)),
                      L.marker && $e.value(L) ? H($.$slots, "marker", {
                        key: 2,
                        marker: L.marker,
                        day: +L.text,
                        date: L.value
                      }, () => [
                        E("div", {
                          class: q(de.value(L.marker)),
                          style: Fe(L.marker.color ? { backgroundColor: L.marker.color } : {})
                        }, null, 6)
                      ]) : R("", !0),
                      he.value(L.value) ? (w(), M("div", {
                        key: 3,
                        ref_for: !0,
                        ref: "active-tooltip",
                        class: "dp__marker_tooltip",
                        style: Fe(W.value)
                      }, [
                        (_e = L.marker) != null && _e.tooltip ? (w(), M("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: ye
                        }, [
                          (w(!0), M(Te, null, Ie(L.marker.tooltip, (Ye, At) => (w(), M("div", {
                            key: At,
                            class: "dp__tooltip_text"
                          }, [
                            H($.$slots, "marker-tooltip", {
                              tooltip: Ye,
                              day: L.value
                            }, () => [
                              E("div", {
                                class: "dp__tooltip_mark",
                                style: Fe(Ye.color ? { backgroundColor: Ye.color } : {})
                              }, null, 4),
                              E("div", null, re(Ye.text), 1)
                            ])
                          ]))), 128)),
                          E("div", {
                            class: "dp__arrow_bottom_tp",
                            style: Fe(ae.value)
                          }, null, 4)
                        ])) : R("", !0)
                      ], 4)) : R("", !0)
                    ], 2)
                  ], 40, kw);
                }), 128))
              ]))), 128))
            ], 32)) : R("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), Sw = (e, n, t, a) => {
  const s = ee([]), l = ee(/* @__PURE__ */ new Date()), r = ee(), {
    getDate: i,
    rootEmit: o,
    calendars: u,
    month: c,
    year: f,
    time: p,
    modelValue: d,
    rootProps: b,
    today: m,
    state: k,
    defaults: { multiCalendars: y, startTime: h, range: g, config: x, safeDates: S, multiDates: C, timeConfig: _, flow: O }
  } = Ke(), { validateMonthYearInRange: I, isDisabled: D, isDateRangeAllowed: B, checkMinMaxRange: Y } = on(), { updateTimeValues: ne, getSetDateTime: W, assignTime: ae, assignStartTime: G, validateTime: j, disabledTimesConfig: se } = Yd(a), { formatDay: U } = ra(), { resetDateTime: N, setTime: J, isDateBefore: de, isDateEqual: he, getDaysInBetween: ge } = Ft(), { checkRangeAutoApply: $e, getRangeWithFixedDate: we, handleMultiDatesSelect: X, setPresetDate: ve } = Gl(), { getMapDate: Ce } = Dt();
  js(() => A(k.isTextInputDate));
  const V = (te) => !x.value.keepViewOnOffsetClick || te ? !0 : !r.value, Z = (te, pe, Ae, Ue = !1) => {
    var tt, Ut, qt;
    V(Ue) && ((tt = u.value)[te] ?? (tt[te] = u.value[te] = { month: 0, year: 0 }), u.value[te].month = pe ?? ((Ut = u.value[te]) == null ? void 0 : Ut.month), u.value[te].year = Ae ?? ((qt = u.value[te]) == null ? void 0 : qt.year));
  }, me = () => {
    b.autoApply && n("select-date");
  }, K = () => {
    h.value && G(h.value);
  };
  et(() => {
    d.value || (At(), K()), A(!0), b.focusStartDate && b.startDate && At();
  });
  const oe = T(() => {
    var te, pe, Ae;
    return (pe = (te = O.value) == null ? void 0 : te.steps) != null && pe.length && !((Ae = O.value) != null && Ae.partial) ? e.flowStep === O.value.steps.length : !0;
  }), ye = () => {
    var te, pe, Ae;
    b.autoApply && oe.value && n("auto-apply", (te = O.value) != null && te.partial ? e.flowStep !== ((Ae = (pe = O.value) == null ? void 0 : pe.steps) == null ? void 0 : Ae.length) : !1);
  }, A = (te = !1) => {
    if (d.value)
      return Array.isArray(d.value) ? (s.value = d.value, Me(te)) : P(d.value, te);
    if (y.value.count && te && !b.startDate)
      return F(i(), te);
  }, z = () => Array.isArray(d.value) && g.value.enabled ? Ze(d.value[0]) === Ze(d.value[1] ?? d.value[0]) : !1, $ = (te) => {
    const pe = pn(te, 1);
    return { month: Ze(pe), year: We(pe) };
  }, F = (te = i(), pe = !1) => {
    if ((!y.value.count || !y.value.static || pe) && Z(0, Ze(te), We(te)), y.value.count && (!d.value || z() || !y.value.solo) && (!y.value.solo || pe))
      for (let Ae = 1; Ae < y.value.count; Ae++) {
        const Ue = je(i(), { month: c.value(Ae - 1), year: f.value(Ae - 1) }), tt = hd(Ue, { months: 1 });
        u.value[Ae] = { month: Ze(tt), year: We(tt) };
      }
  }, P = (te, pe) => {
    F(te), ae("hours", An(te)), ae("minutes", Hn(te)), ae("seconds", la(te)), y.value.count && pe && Ye();
  }, Q = (te) => {
    if (y.value.count) {
      if (y.value.solo) return 0;
      const pe = Ze(te[0]), Ae = Ze(te[1]);
      return Math.abs(Ae - pe) < y.value.count ? 0 : 1;
    }
    return 1;
  }, L = (te, pe) => {
    te[1] && g.value.showLastInRange ? F(te[Q(te)], pe) : F(te[0], pe);
    const Ae = (Ue, tt) => [
      Ue(te[0]),
      te != null && te[1] ? Ue(te[1]) : p[tt][1]
    ];
    ae("hours", Ae(An, "hours")), ae("minutes", Ae(Hn, "minutes")), ae("seconds", Ae(la, "seconds"));
  }, fe = (te, pe) => {
    if ((g.value.enabled || b.weekPicker) && !C.value.enabled)
      return L(te, pe);
    if (C.value.enabled && pe) {
      const Ae = te[te.length - 1];
      return P(Ae, pe);
    }
  }, Me = (te) => {
    const pe = d.value;
    fe(pe, te), y.value.count && y.value.solo && Ye();
  }, Re = (te, pe) => {
    const Ae = je(i(), { month: c.value(pe), year: f.value(pe) }), Ue = te < 0 ? pn(Ae, 1) : ts(Ae, 1);
    I(Ze(Ue), We(Ue), te < 0, b.preventMinMaxNavigation) && (Z(pe, Ze(Ue), We(Ue)), o("update-month-year", { instance: pe, month: Ze(Ue), year: We(Ue) }), y.value.count && !y.value.solo && _e(pe), t());
  }, _e = (te) => {
    for (let pe = te - 1; pe >= 0; pe--) {
      const Ae = ts(je(i(), { month: c.value(pe + 1), year: f.value(pe + 1) }), 1);
      Z(pe, Ze(Ae), We(Ae));
    }
    for (let pe = te + 1; pe <= y.value.count - 1; pe++) {
      const Ae = pn(je(i(), { month: c.value(pe - 1), year: f.value(pe - 1) }), 1);
      Z(pe, Ze(Ae), We(Ae));
    }
  }, Ye = () => {
    if (Array.isArray(d.value) && d.value.length === 2) {
      const te = i(i(d.value[1] ?? pn(d.value[0], 1))), [pe, Ae] = [Ze(d.value[0]), We(d.value[0])], [Ue, tt] = [Ze(d.value[1]), We(d.value[1])];
      (pe !== Ue || pe === Ue && Ae !== tt) && y.value.solo && Z(1, Ze(te), We(te));
    } else d.value && !Array.isArray(d.value) && (Z(0, Ze(d.value), We(d.value)), F(i()));
  }, At = () => {
    b.startDate && (Z(0, Ze(i(b.startDate)), We(i(b.startDate))), y.value.count && _e(0));
  }, Fn = (te, pe) => {
    if (x.value.monthChangeOnScroll) {
      const Ae = Date.now() - l.value.getTime(), Ue = Math.abs(te.deltaY);
      let tt = 500;
      Ue > 1 && (tt = 100), Ue > 100 && (tt = 0), Ae > tt && (l.value = /* @__PURE__ */ new Date(), Re(
        x.value.monthChangeOnScroll === "inverse" ? te.deltaY : -te.deltaY,
        pe
      ));
    }
  }, xn = (te, pe, Ae = !1) => {
    x.value.monthChangeOnArrows && b.vertical === Ae && Jt(te, pe);
  }, Jt = (te, pe) => {
    Re(te === "right" ? -1 : 1, pe);
  }, Un = (te) => {
    if (S.value.markers)
      return Ce(te.value, S.value.markers);
  }, It = (te, pe) => {
    switch (b.sixWeeks === !0 ? "append" : b.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [te == 0, !0];
      case "fair":
        return [te == 0 || pe > te, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Bt = (te, pe, Ae, Ue) => {
    if (b.sixWeeks && te.length < 6) {
      const tt = 6 - te.length, Ut = (pe.getDay() + 7 - Ue) % 7, qt = 6 - (Ae.getDay() + 7 - Ue) % 7, [oa, Ea] = It(Ut, qt);
      for (let ua = 1; ua <= tt; ua++)
        if (Ea ? !!(ua % 2) == oa : oa) {
          const le = te[0].days[0], Se = un(nn(le.value, -7), Ze(pe));
          te.unshift({ days: Se });
        } else {
          const le = te[te.length - 1], Se = le.days[le.days.length - 1], qe = un(nn(Se.value, 1), Ze(pe));
          te.push({ days: qe });
        }
    }
    return te;
  }, un = (te, pe) => {
    const Ae = i(te), Ue = [];
    for (let tt = 0; tt < 7; tt++) {
      const Ut = nn(Ae, tt), qt = Ze(Ut) !== pe;
      Ue.push({
        text: b.hideOffsetDates && qt ? "" : U(Ut),
        value: Ut,
        current: !qt,
        classData: {}
      });
    }
    return Ue;
  }, Sn = (te, pe) => {
    const Ae = [], Ue = i(new Date(pe, te)), tt = i(new Date(pe, te + 1, 0)), Ut = b.weekStart, qt = rn(Ue, { weekStartsOn: Ut }), oa = (Ea) => {
      const ua = un(Ea, te);
      if (Ae.push({ days: ua }), !Ae[Ae.length - 1].days.some((le) => he(i(le.value), N(tt)))) {
        const le = nn(Ea, 7);
        oa(le);
      }
    };
    return oa(qt), Bt(Ae, Ue, tt, Ut);
  }, bt = (te) => {
    const pe = J(
      { hours: p.hours, minutes: p.minutes, seconds: _a() },
      i(te.value)
    );
    o("date-click", pe), C.value.enabled ? X(pe, C.value.limit) : d.value = pe, a(), Ge().then(() => {
      ye();
    });
  }, wt = (te) => g.value.noDisabledRange ? ge(s.value[0], te).some((pe) => D(pe)) : !1, De = () => {
    s.value = d.value ? d.value.slice().filter((te) => !!te) : [], s.value.length === 2 && !(g.value.fixedStart || g.value.fixedEnd) && (s.value = []);
  }, ut = (te, pe) => {
    const Ae = [i(te.value), nn(i(te.value), +g.value.autoRange)];
    B(Ae) ? (pe && Ct(te.value), s.value = Ae) : o("invalid-date", te.value);
  }, Ct = (te) => {
    const pe = Ze(i(te)), Ae = We(i(te));
    if (Z(0, pe, Ae), y.value.count > 0)
      for (let Ue = 1; Ue < y.value.count; Ue++) {
        const tt = $(
          je(i(te), { year: f.value(Ue - 1), month: c.value(Ue - 1) })
        );
        Z(Ue, tt.month, tt.year);
      }
  }, Tn = (te) => {
    if (wt(te.value) || !Y(te.value, d.value, g.value.fixedStart ? 0 : 1))
      return o("invalid-date", te.value);
    s.value = we(i(te.value));
  }, Vn = (te, pe) => {
    if (De(), g.value.autoRange) return ut(te, pe);
    if (g.value.fixedStart || g.value.fixedEnd) return Tn(te);
    s.value[0] ? Y(i(te.value), d.value) && !wt(te.value) ? de(i(te.value), i(s.value[0])) ? g.value.autoSwitchStartEnd ? (s.value.unshift(i(te.value)), o("range-end", s.value[0])) : (s.value[0] = i(te.value), o("range-start", s.value[0])) : (s.value[1] = i(te.value), o("range-end", s.value[1])) : o("invalid-date", te.value) : (s.value[0] = i(te.value), o("range-start", s.value[0]));
  }, _a = (te = !0) => _.value.enableSeconds ? Array.isArray(p.seconds) ? te ? p.seconds[0] : p.seconds[1] : p.seconds : 0, cs = (te) => {
    s.value[te] = J(
      {
        hours: p.hours[te],
        minutes: p.minutes[te],
        seconds: _a(te !== 1)
      },
      s.value[te]
    );
  }, er = () => {
    var te, pe;
    s.value[0] && s.value[1] && +((te = s.value) == null ? void 0 : te[0]) > +((pe = s.value) == null ? void 0 : pe[1]) && (s.value.reverse(), o("range-start", s.value[0]), o("range-end", s.value[1]));
  }, Xs = () => {
    var te, pe, Ae;
    s.value.length && (s.value[0] && !s.value[1] ? cs(0) : (cs(0), cs(1), a()), er(), d.value = s.value.slice(), $e(
      s.value,
      n,
      s.value.length < 2 || (te = O.value) != null && te.steps.length ? e.flowStep !== ((Ae = (pe = O.value) == null ? void 0 : pe.steps) == null ? void 0 : Ae.length) : !1
    ));
  }, tr = (te, pe = !1) => {
    if (D(te.value) || !te.current && b.hideOffsetDates)
      return o("invalid-date", te.value);
    if (r.value = structuredClone(te), !g.value.enabled) return bt(te);
    Array.isArray(p.hours) && Array.isArray(p.minutes) && !C.value.enabled && (Vn(te, pe), Xs());
  }, nr = (te, pe) => {
    var Ue, tt;
    Z(te, pe.month, pe.year, !0), y.value.count && !y.value.solo && _e(te), o("update-month-year", { instance: te, month: pe.month, year: pe.year }), t(y.value.solo ? te : void 0);
    const Ae = (tt = (Ue = O.value) == null ? void 0 : Ue.steps) != null && tt.length ? O.value.steps[e.flowStep] : void 0;
    !pe.fromNav && (Ae === Lt.month || Ae === Lt.year) && a();
  }, ar = (te) => {
    ve({
      value: te
    }), me(), b.multiCalendars && Ge().then(() => A(!0));
  }, Js = () => {
    var pe;
    let te = i();
    return (pe = b.actionRow) != null && pe.nowBtnRound && (te = Tb(te, {
      roundingMethod: b.actionRow.nowBtnRound.rounding ?? "ceil",
      nearestTo: b.actionRow.nowBtnRound.roundTo ?? 15
    })), te;
  }, qn = () => {
    const te = Js();
    !g.value.enabled && !C.value.enabled ? d.value = te : d.value && Array.isArray(d.value) && d.value[0] ? C.value.enabled ? d.value = [...d.value, te] : d.value = de(te, d.value[0]) ? [te, d.value[0]] : [d.value[0], te] : d.value = [te], me();
  }, Qs = () => {
    if (Array.isArray(d.value))
      if (C.value.enabled) {
        const te = Wi();
        d.value[d.value.length - 1] = W(te);
      } else
        d.value = d.value.map((te, pe) => te && W(te, pe));
    else
      d.value = W(d.value);
    n("time-update");
  }, Wi = () => Array.isArray(d.value) && d.value.length ? d.value[d.value.length - 1] : null, kt = (te) => {
    let pe = "";
    if (g.value.enabled && Array.isArray(d.value))
      for (const Ae of Object.keys(te)) {
        const Ue = te[Ae];
        Array.isArray(Ue) && (p[Ae][0] !== Ue[0] && (pe = "range-start"), p[Ae][1] !== Ue[1] && (pe = "range-start"));
      }
    return pe;
  };
  return {
    calendars: u,
    modelValue: d,
    month: c,
    year: f,
    time: p,
    disabledTimesConfig: se,
    today: m,
    validateTime: j,
    getCalendarDays: Sn,
    getMarker: Un,
    handleScroll: Fn,
    handleSwipe: Jt,
    handleArrow: xn,
    selectDate: tr,
    updateMonthYear: nr,
    presetDate: ar,
    selectCurrentDate: qn,
    updateTime: (te) => {
      const pe = kt(te);
      ne(te, Qs), pe && o(pe, d.value[pe === "range-start" ? 0 : 1]);
    },
    assignMonthAndYear: F,
    setStartTime: K
  };
}, Tw = () => {
  const {
    isModelAuto: e,
    matchDate: n,
    isDateAfter: t,
    isDateBefore: a,
    isDateBetween: s,
    isDateEqual: l,
    getWeekFromDate: r,
    getBeforeAndAfterInRange: i
  } = Ft(), {
    getDate: o,
    today: u,
    rootProps: c,
    defaults: { multiCalendars: f, multiDates: p, ui: d, highlight: b, safeDates: m, range: k },
    modelValue: y
  } = Ke(), { isDisabled: h } = on(), g = ee(null), x = ($) => {
    !$.current && c.hideOffsetDates || (g.value = $.value);
  }, S = () => {
    g.value = null;
  }, C = ($) => Array.isArray(y.value) && k.value.enabled && y.value[0] && g.value ? $ ? t(g.value, y.value[0]) : a(g.value, y.value[0]) : !0, _ = ($, F) => {
    const P = () => y.value ? F ? y.value[0] || null : y.value[1] : null, Q = y.value && Array.isArray(y.value) ? P() : null;
    return l(o($.value), Q);
  }, O = ($) => {
    const F = Array.isArray(y.value) ? y.value[0] : null;
    return $ ? !a(g.value, F) : !0;
  }, I = ($, F = !0) => (k.value.enabled || c.weekPicker) && Array.isArray(y.value) && y.value.length === 2 ? c.hideOffsetDates && !$.current ? !1 : l(o($.value), y.value[F ? 0 : 1]) : k.value.enabled ? _($, F) && O(F) || l($.value, Array.isArray(y.value) ? y.value[0] : null) && C(F) : !1, D = ($, F) => {
    if (Array.isArray(y.value) && y.value[0] && y.value.length === 1) {
      const P = l($.value, g.value);
      return F ? t(y.value[0], $.value) && P : a(y.value[0], $.value) && P;
    }
    return !1;
  }, B = ($) => !y.value || c.hideOffsetDates && !$.current ? !1 : k.value.enabled ? c.modelAuto && Array.isArray(y.value) ? l($.value, y.value[0] ?? u) : !1 : p.value.enabled && Array.isArray(y.value) ? y.value.some((F) => l(F, $.value)) : l($.value, y.value ? y.value : u), Y = ($) => {
    if (k.value.autoRange || c.weekPicker) {
      if (g.value) {
        if (c.hideOffsetDates && !$.current) return !1;
        const F = nn(g.value, +k.value.autoRange), P = r(o(g.value), c.weekStart);
        return c.weekPicker ? l(P[1], o($.value)) : l(F, o($.value));
      }
      return !1;
    }
    return !1;
  }, ne = ($) => {
    if (k.value.autoRange || c.weekPicker) {
      if (g.value) {
        const F = nn(g.value, +k.value.autoRange);
        if (c.hideOffsetDates && !$.current) return !1;
        const P = r(o(g.value), c.weekStart);
        return c.weekPicker ? t($.value, P[0]) && a($.value, P[1]) : t($.value, g.value) && a($.value, F);
      }
      return !1;
    }
    return !1;
  }, W = ($) => {
    if (k.value.autoRange || c.weekPicker) {
      if (g.value) {
        if (c.hideOffsetDates && !$.current) return !1;
        const F = r(o(g.value), c.weekStart);
        return c.weekPicker ? l(F[0], $.value) : l(g.value, $.value);
      }
      return !1;
    }
    return !1;
  }, ae = ($) => s(y.value, g.value, $.value), G = () => c.modelAuto && Array.isArray(y.value) ? !!y.value[0] : !1, j = () => c.modelAuto ? e(y.value) : !0, se = ($) => {
    if (c.weekPicker) return !1;
    const F = k.value.enabled ? !I($) && !I($, !1) : !0;
    return !h($.value) && !B($) && !(!$.current && c.hideOffsetDates) && F;
  }, U = ($) => k.value.enabled ? c.modelAuto ? G() && B($) : !1 : B($), N = ($) => b.value ? n($.value, m.value.highlight) : !1, J = ($) => {
    const F = h($.value);
    return F && (typeof b.value == "function" ? !b.value($.value, F) : !b.value.options.highlightDisabled);
  }, de = ($) => {
    var F;
    return typeof b.value == "function" ? b.value($.value) : (F = b.value.weekdays) == null ? void 0 : F.includes($.value.getDay());
  }, he = ($) => (k.value.enabled || c.weekPicker) && (!(f.value.count > 0) || $.current) && j() && !(!$.current && c.hideOffsetDates) && !B($) ? ae($) : !1, ge = ($) => {
    if (Array.isArray(y.value) && y.value.length === 1) {
      const { before: F, after: P } = i(+k.value.maxRange, y.value[0]);
      return Wn($.value, F) || Cn($.value, P);
    }
    return !1;
  }, $e = ($) => {
    if (Array.isArray(y.value) && y.value.length === 1) {
      const { before: F, after: P } = i(+k.value.minRange, y.value[0]);
      return s([F, P], y.value[0], $.value);
    }
    return !1;
  }, we = ($) => k.value.enabled && (k.value.maxRange || k.value.minRange) ? k.value.maxRange && k.value.minRange ? ge($) || $e($) : k.value.maxRange ? ge($) : $e($) : !1, X = ($) => {
    const { isRangeStart: F, isRangeEnd: P } = Z($), Q = k.value.enabled ? F || P : !1;
    return {
      dp__cell_offset: !$.current,
      dp__pointer: !c.disabled && !(!$.current && c.hideOffsetDates) && !h($.value) && !we($),
      dp__cell_disabled: h($.value) || we($),
      dp__cell_highlight: !J($) && (N($) || de($)) && !U($) && !Q && !W($) && !(he($) && c.weekPicker) && !P,
      dp__cell_highlight_active: !J($) && (N($) || de($)) && U($),
      dp__today: !c.noToday && l($.value, u) && $.current,
      "dp--past": a($.value, u),
      "dp--future": t($.value, u)
    };
  }, ve = ($) => ({
    dp__active_date: U($),
    dp__date_hover: se($)
  }), Ce = ($) => {
    if (y.value && !Array.isArray(y.value)) {
      const F = r(y.value, c.weekStart);
      return {
        ...A($),
        dp__range_start: l(F[0], $.value),
        dp__range_end: l(F[1], $.value),
        dp__range_between_week: t($.value, F[0]) && a($.value, F[1])
      };
    }
    return {
      ...A($)
    };
  }, V = ($) => {
    if (y.value && Array.isArray(y.value)) {
      const F = r(y.value[0], c.weekStart), P = y.value[1] ? r(y.value[1], c.weekStart) : [];
      return {
        ...A($),
        dp__range_start: l(F[0], $.value) || l(P[0], $.value),
        dp__range_end: l(F[1], $.value) || l(P[1], $.value),
        dp__range_between_week: t($.value, F[0]) && a($.value, F[1]) || t($.value, P[0]) && a($.value, P[1]),
        dp__range_between: t($.value, F[1]) && a($.value, P[0])
      };
    }
    return {
      ...A($)
    };
  }, Z = ($) => {
    const F = f.value.count > 0 ? $.current && I($) && j() : I($) && j(), P = f.value.count > 0 ? $.current && I($, !1) && j() : I($, !1) && j();
    return { isRangeStart: F, isRangeEnd: P };
  }, me = ($) => k.value.enabled && (k.value.fixedStart || k.value.fixedEnd) && Array.isArray(y.value) && y.value.length === 2, K = ($, F, P, Q) => !me(y.value) || !g.value ? !1 : F ? k.value.fixedEnd && l($.value, g.value) && Wn($.value, y.value[0]) && !P : k.value.fixedStart && l($.value, g.value) && Cn($.value, y.value[1]) && !Q, oe = ($, F) => !me(y.value) || !g.value ? !1 : F ? k.value.fixedEnd && Cn($.value, g.value) && Wn($.value, y.value[0]) : k.value.fixedStart && Wn($.value, g.value) && Cn($.value, y.value[1]), ye = ($) => {
    const { isRangeStart: F, isRangeEnd: P } = Z($);
    return {
      dp__range_start: F,
      dp__range_end: P,
      dp__range_between: he($),
      dp__date_hover: l($.value, g.value) && !F && !P && !c.weekPicker,
      dp__date_hover_start: D($, !0) || K($, !0, F, P),
      dp__date_hover_end: D($, !1) || K($, !1, F, P),
      "dp--extended-fixed-start": oe($, !0),
      "dp--extended-fixed-end": oe($, !1)
    };
  }, A = ($) => ({
    ...ye($),
    dp__cell_auto_range: ne($),
    dp__cell_auto_range_start: W($),
    dp__cell_auto_range_end: Y($)
  }), z = ($) => k.value.enabled ? k.value.autoRange ? A($) : c.modelAuto ? { ...ve($), ...ye($) } : c.weekPicker ? V($) : ye($) : c.weekPicker ? Ce($) : ve($);
  return {
    setHoverDate: x,
    clearHoverDate: S,
    getDayClassData: ($) => c.hideOffsetDates && !$.current ? {} : {
      ...X($),
      ...z($),
      [d.value.dayClass ? d.value.dayClass($.value, y.value) : ""]: !0,
      ...d.value.calendarCell
    }
  };
}, $w = { key: 0 }, Mw = /* @__PURE__ */ ke({
  __name: "DatePicker",
  props: /* @__PURE__ */ Eu({
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  }, S0),
  emits: ["mount", "update-flow-step", "reset-flow", "focus-menu", "select-date", "time-update", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      month: l,
      year: r,
      modelValue: i,
      time: o,
      disabledTimesConfig: u,
      today: c,
      validateTime: f,
      getCalendarDays: p,
      getMarker: d,
      handleArrow: b,
      handleScroll: m,
      handleSwipe: k,
      selectDate: y,
      updateMonthYear: h,
      presetDate: g,
      selectCurrentDate: x,
      updateTime: S,
      assignMonthAndYear: C,
      setStartTime: _
    } = Sw(s, a, ve, Ce), O = Ht(), { setHoverDate: I, getDayClassData: D, clearHoverDate: B } = Tw(), {
      getDate: Y,
      rootEmit: ne,
      rootProps: W,
      defaults: { multiCalendars: ae, timeConfig: G }
    } = Ke(), { getYears: j, getMonths: se } = Ul(), { getCellId: U } = Ft(), N = Xe("calendar-header"), J = Xe("calendar"), de = Xe("time-picker"), he = _n(O, gn.Calendar), ge = _n(O, gn.DatePickerHeader), $e = _n(O, gn.TimePicker), we = (z) => {
      a("mount", z);
    };
    Le(
      ae,
      (z, $) => {
        z.count - $.count > 0 && C();
      },
      { deep: !0 }
    );
    const X = T(() => (z) => p(l.value(z), r.value(z)).map(($) => ({
      ...$,
      days: $.days.map((F) => (F.marker = d(F), F.classData = D(F), F))
    })));
    function ve(z) {
      var $, F, P;
      z || z === 0 ? (F = ($ = J.value) == null ? void 0 : $[z]) == null || F.triggerTransition(l.value(z), r.value(z)) : (P = J.value) == null || P.forEach((Q, L) => Q == null ? void 0 : Q.triggerTransition(l.value(L), r.value(L)));
    }
    function Ce() {
      a("update-flow-step");
    }
    const V = (z, $, F = 0) => {
      var P, Q;
      (Q = (P = N.value) == null ? void 0 : P[F]) == null || Q.toggleMonthPicker(z, $);
    }, Z = (z, $, F = 0) => {
      var P, Q;
      (Q = (P = N.value) == null ? void 0 : P[F]) == null || Q.toggleYearPicker(z, $);
    }, me = (z, $, F) => {
      var P;
      (P = de.value) == null || P.toggleTimePicker(z, $, F);
    }, K = (z, $) => {
      var F;
      if (!W.range) {
        const P = i.value ? i.value : c, Q = $ ? Y($) : P, L = z ? rn(Q, { weekStartsOn: 1 }) : Ei(Q, { weekStartsOn: 1 });
        y({
          value: L,
          current: Ze(Q) === l.value(0),
          text: "",
          classData: {}
        }), (F = document.getElementById(U(L))) == null || F.focus();
      }
    }, oe = (z) => {
      var $, F;
      (F = ($ = N.value) == null ? void 0 : $[0]) == null || F.handleMonthYearChange(z, !0);
    }, ye = (z) => {
      h(0, { month: l.value(0), year: r.value(0) + (z ? 1 : -1), fromNav: !0 });
    }, A = (z) => {
      ne("overlay-toggle", { open: !1, overlay: z }), a("focus-menu");
    };
    return n({
      clearHoverDate: B,
      presetDate: g,
      selectCurrentDate: x,
      handleArrow: b,
      updateMonthYear: h,
      setStartTime: _,
      toggleMonthPicker: V,
      toggleYearPicker: Z,
      toggleTimePicker: me,
      getSidebarProps: () => ({
        modelValue: i,
        month: l,
        year: r,
        time: o,
        updateTime: S,
        updateMonthYear: h,
        selectDate: y,
        presetDate: g
      }),
      changeMonth: oe,
      changeYear: ye,
      selectWeekDate: K
    }), (z, $) => (w(), M(Te, null, [
      ie(jl, { collapse: e.collapse }, {
        default: ce(({ instances: F, wrapClass: P }) => [
          (w(!0), M(Te, null, Ie(F, (Q) => (w(), M("div", {
            key: Q,
            class: q(P)
          }, [
            v(W).hideMonthYearSelect ? R("", !0) : (w(), ue(vw, {
              key: 0,
              ref_for: !0,
              ref: "calendar-header",
              months: v(se)(),
              years: v(j)(),
              month: v(l)(Q),
              year: v(r)(Q),
              instance: Q,
              "menu-wrap-ref": e.menuWrapRef,
              onMount: $[0] || ($[0] = (L) => we(v(wa).header)),
              onResetFlow: $[1] || ($[1] = (L) => z.$emit("reset-flow")),
              onUpdateMonthYear: (L) => v(h)(Q, L),
              onOverlayClosed: A
            }, dt({ _: 2 }, [
              Ie(v(ge), (L, fe) => ({
                name: L,
                fn: ce((Me) => [
                  H(z.$slots, L, lt({ ref_for: !0 }, Me))
                ])
              }))
            ]), 1032, ["months", "years", "month", "year", "instance", "menu-wrap-ref", "onUpdateMonthYear"])),
            ie(xw, {
              ref_for: !0,
              ref: "calendar",
              "mapped-dates": X.value(Q),
              instance: Q,
              month: v(l)(Q),
              year: v(r)(Q),
              onSelectDate: (L) => v(y)(L, Q !== 1),
              onSetHoverDate: $[2] || ($[2] = (L) => v(I)(L)),
              onHandleScroll: (L) => v(m)(L, Q),
              onHandleSwipe: (L) => v(k)(L, Q),
              onMount: $[3] || ($[3] = (L) => we(v(wa).calendar))
            }, dt({ _: 2 }, [
              Ie(v(he), (L, fe) => ({
                name: L,
                fn: ce((Me) => [
                  H(z.$slots, L, lt({ ref_for: !0 }, Me))
                ])
              }))
            ]), 1032, ["mapped-dates", "instance", "month", "year", "onSelectDate", "onHandleScroll", "onHandleSwipe"])
          ], 2))), 128))
        ]),
        _: 3
      }, 8, ["collapse"]),
      v(G).enableTimePicker ? (w(), M("div", $w, [
        H(z.$slots, "time-picker", Mt(Nt({ time: v(o), updateTime: v(S) })), () => [
          ie(Wd, {
            ref: "time-picker",
            hours: v(o).hours,
            minutes: v(o).minutes,
            seconds: v(o).seconds,
            "disabled-times-config": v(u),
            "validate-time": v(f),
            "no-overlay-focus": e.noOverlayFocus,
            onMount: $[4] || ($[4] = (F) => we(v(wa).timePicker)),
            "onUpdate:hours": $[5] || ($[5] = (F) => v(S)({ hours: F, minutes: v(o).minutes, seconds: v(o).seconds })),
            "onUpdate:minutes": $[6] || ($[6] = (F) => v(S)({ hours: v(o).hours, minutes: F, seconds: v(o).seconds })),
            "onUpdate:seconds": $[7] || ($[7] = (F) => v(S)({ hours: v(o).hours, minutes: v(o).minutes, seconds: F })),
            onResetFlow: $[8] || ($[8] = (F) => z.$emit("reset-flow"))
          }, dt({ _: 2 }, [
            Ie(v($e), (F, P) => ({
              name: F,
              fn: ce((Q) => [
                H(z.$slots, F, Mt(Nt(Q)))
              ])
            }))
          ]), 1032, ["hours", "minutes", "seconds", "disabled-times-config", "validate-time", "no-overlay-focus"])
        ])
      ])) : R("", !0)
    ], 64));
  }
}), Cw = (e, n) => {
  const {
    getDate: t,
    modelValue: a,
    year: s,
    calendars: l,
    defaults: { highlight: r, range: i, multiDates: o }
  } = Ke(), { isDateBetween: u, isDateEqual: c } = Ft(), { checkRangeAutoApply: f, handleMultiDatesSelect: p, setMonthOrYearRange: d } = Gl();
  js();
  const { isDisabled: b } = on(), { formatQuarterText: m } = ra(), {
    selectYear: k,
    groupedYears: y,
    showYearPicker: h,
    isDisabled: g,
    toggleYearPicker: x,
    handleYearSelect: S,
    handleYear: C,
    setStartDate: _
  } = Bd(n), O = ee();
  et(() => {
    _();
  });
  const I = T(() => (j) => a.value ? Array.isArray(a.value) ? a.value.some((se) => eu(j, se)) : eu(a.value, j) : !1), D = (j) => {
    if (i.value.enabled) {
      if (Array.isArray(a.value)) {
        const se = c(j, a.value[0]) || c(j, a.value[1]);
        return u(a.value, O.value, j) && !se;
      }
      return !1;
    }
    return !1;
  }, B = (j, se) => j.quarter === Go(se) && j.year === We(se), Y = (j) => typeof r.value == "function" ? r.value({ quarter: Go(j), year: We(j) }) : r.value.quarters.some((se) => B(se, j)), ne = T(() => (j) => {
    const se = je(t(), { year: s.value(j) });
    return Ig({
      start: Ka(se),
      end: yd(se)
    }).map((U) => {
      const N = ga(U), J = Ko(U), de = b(U), he = D(N), ge = Y(N);
      return {
        text: m(N, J),
        value: N,
        active: I.value(N),
        highlighted: ge,
        disabled: de,
        isBetween: he
      };
    });
  }), W = (j) => {
    p(j, o.value.limit), n("auto-apply", !0);
  }, ae = (j) => {
    a.value = d(j), f(a.value, n, a.value.length < 2);
  }, G = (j) => {
    a.value = j, n("auto-apply");
  };
  return {
    groupedYears: y,
    year: s,
    isDisabled: g,
    quarters: ne,
    showYearPicker: h,
    modelValue: a,
    selectYear: k,
    toggleYearPicker: x,
    handleYearSelect: S,
    handleYear: C,
    setHoverDate: (j) => {
      O.value = j;
    },
    selectQuarter: (j, se, U) => {
      if (!U)
        return l.value[se].month = Ze(Ko(j)), o.value.enabled ? W(j) : i.value.enabled ? ae(j) : G(j);
    }
  };
}, Dw = { class: "dp--quarter-items" }, Ow = ["data-test-id", "disabled", "onClick", "onMouseover"], _w = /* @__PURE__ */ ke({
  __name: "QuarterPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      defaults: { config: l }
    } = Ke(), r = Ht(), { boolHtmlAttribute: i } = is(), o = _n(r, gn.YearMode), {
      groupedYears: u,
      year: c,
      isDisabled: f,
      quarters: p,
      modelValue: d,
      showYearPicker: b,
      setHoverDate: m,
      selectQuarter: k,
      toggleYearPicker: y,
      handleYearSelect: h,
      handleYear: g
    } = Cw(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: d,
      year: c,
      selectQuarter: k,
      handleYearSelect: h,
      handleYear: g
    }) }), (x, S) => (w(), ue(jl, {
      collapse: e.collapse,
      stretch: ""
    }, {
      default: ce(({ instances: C, wrapClass: _ }) => [
        (w(!0), M(Te, null, Ie(C, (O) => (w(), M("div", {
          key: O,
          class: q(_)
        }, [
          E("div", {
            class: "dp-quarter-picker-wrap",
            style: Fe({ minHeight: `${v(l).modeHeight}px` })
          }, [
            x.$slots["top-extra"] ? H(x.$slots, "top-extra", {
              key: 0,
              value: v(d)
            }) : R("", !0),
            E("div", null, [
              ie(zd, {
                items: v(u)(O),
                instance: O,
                "show-year-picker": v(b)[O],
                year: v(c)(O),
                "is-disabled": (I) => v(f)(O, I),
                onHandleYear: (I) => v(g)(O, I),
                onYearSelect: (I) => v(h)(I, O),
                onToggleYearPicker: (I) => v(y)(O, I == null ? void 0 : I.flow, I == null ? void 0 : I.show)
              }, dt({ _: 2 }, [
                Ie(v(o), (I, D) => ({
                  name: I,
                  fn: ce((B) => [
                    H(x.$slots, I, lt({ ref_for: !0 }, B))
                  ])
                }))
              ]), 1032, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
            ]),
            E("div", Dw, [
              (w(!0), M(Te, null, Ie(v(p)(O), (I, D) => (w(), M("div", { key: D }, [
                E("button", {
                  type: "button",
                  class: q(["dp--qr-btn", {
                    "dp--qr-btn-active": I.active,
                    "dp--qr-btn-between": I.isBetween,
                    "dp--qr-btn-disabled": I.disabled,
                    "dp--highlighted": I.highlighted
                  }]),
                  "data-dp-action-element": "0",
                  "data-test-id": I.value,
                  disabled: v(i)(I.disabled),
                  onClick: (B) => v(k)(I.value, O, I.disabled),
                  onMouseover: (B) => v(m)(I.value)
                }, [
                  H(x.$slots, "quarter", {
                    value: I.value,
                    text: I.text
                  }, () => [
                    He(re(I.text), 1)
                  ])
                ], 42, Ow)
              ]))), 128))
            ])
          ], 4)
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["collapse"]));
  }
}), Ew = ["id", "tabindex", "role", "aria-label"], Iw = {
  key: 0,
  class: "dp--menu-load-container"
}, Aw = {
  key: 1,
  class: "dp--menu-header"
}, Pw = ["data-dp-mobile"], Rw = {
  key: 0,
  class: "dp__sidebar_left"
}, Fw = ["data-dp-mobile"], Vw = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], Lw = { class: "dp__instance_calendar" }, Nw = {
  key: 2,
  class: "dp__sidebar_right"
}, zw = {
  key: 2,
  class: "dp__action_extra"
}, Bw = /* @__PURE__ */ ke({
  __name: "DatepickerMenu",
  props: {
    collapse: { type: Boolean },
    noOverlayFocus: { type: Boolean },
    getInputRect: { type: Function }
  },
  emits: ["close-picker", "select-date", "auto-apply", "time-update", "menu-blur"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = Ht(), {
      state: l,
      rootProps: r,
      defaults: { textInput: i, inline: o, config: u, ui: c, ariaLabels: f },
      setState: p
    } = Ke(), { isMobile: d } = Hl(), { handleEventPropagation: b, getElWithin: m, checkStopPropagation: k, checkKeyDown: y } = Dt();
    Pb();
    const h = Xe("inner-menu"), g = Xe("dp-menu"), x = Xe("dyn-cmp"), S = ee(0), C = ee(!1), _ = ee(!1), { flowStep: O, updateFlowStep: I, childMount: D, resetFlow: B, handleFlow: Y } = Fb(x), ne = (A) => {
      _.value = !0, u.value.allowPreventDefault && A.preventDefault(), k(A, u.value, !0);
    };
    et(() => {
      C.value = !0, W(), globalThis.addEventListener("resize", W);
      const A = Gt(g);
      A && !i.value.enabled && !o.value.enabled && p("menuFocused", !0), A && (A.addEventListener("pointerdown", ne), A.addEventListener("mousedown", ne)), document.addEventListener("mousedown", ye);
    }), Xt(() => {
      globalThis.removeEventListener("resize", W), document.removeEventListener("mousedown", ye);
      const A = Gt(g);
      A && (A.removeEventListener("pointerdown", ne), A.removeEventListener("mousedown", ne));
    });
    const W = () => {
      const A = Gt(h);
      A && (S.value = A.getBoundingClientRect().width);
    }, ae = T(() => r.monthPicker ? q0 : r.yearPicker ? G0 : r.timePicker ? ow : r.quarterPicker ? _w : Mw), G = () => {
      const A = Gt(g);
      A && A.focus({ preventScroll: !0 });
    }, j = T(() => {
      var A;
      return ((A = x.value) == null ? void 0 : A.getSidebarProps()) || {};
    }), se = _n(s, gn.ActionRow), U = _n(s, gn.PassTrough), N = T(() => ({
      dp__menu_disabled: r.disabled,
      dp__menu_readonly: r.readonly,
      "dp-menu-loading": r.loading
    })), J = T(
      () => ({
        dp__menu: !0,
        dp__menu_index: !o.value.enabled,
        dp__relative: o.value.enabled,
        ...c.value.menu
      })
    ), de = (A) => {
      k(A, u.value, !0);
    }, he = (A) => {
      u.value.escClose && (a("close-picker"), b(A, u.value));
    }, ge = (A) => {
      r.arrowNavigation || (A === hn.left || A === hn.up ? ve("handleArrow", hn.left, 0, A === hn.up) : ve("handleArrow", hn.right, 0, A === hn.down));
    }, $e = (A) => {
      p("shiftKeyInMenu", A.shiftKey), !r.hideMonthYearSelect && A.code === ct.tab && A.target.classList.contains("dp__menu") && l.shiftKeyInMenu && (A.preventDefault(), k(A, u.value, !0), a("close-picker"));
    }, we = (A) => {
      var z, $, F;
      (z = x.value) == null || z.toggleTimePicker(!1, !1), ($ = x.value) == null || $.toggleMonthPicker(!1, !1, A), (F = x.value) == null || F.toggleYearPicker(!1, !1, A);
    }, X = (A, z = 0) => {
      var $, F, P;
      return A === "month" ? ($ = x.value) == null ? void 0 : $.toggleMonthPicker(!1, !0, z) : A === "year" ? (F = x.value) == null ? void 0 : F.toggleYearPicker(!1, !0, z) : A === "time" ? (P = x.value) == null ? void 0 : P.toggleTimePicker(!0, !1) : we(z);
    }, ve = (A, ...z) => {
      var $, F;
      ($ = x.value) != null && $[A] && ((F = x.value) == null || F[A](...z));
    }, Ce = () => {
      ve("selectCurrentDate");
    }, V = (A) => {
      ve("presetDate", Qe(A));
    }, Z = () => {
      ve("clearHoverDate");
    }, me = (A, z) => {
      ve("updateMonthYear", A, z);
    }, K = (A, z) => {
      A.preventDefault(), ge(z);
    }, oe = (A) => {
      var z, $, F;
      if ($e(A), A.key === ct.home || A.key === ct.end)
        return ve(
          "selectWeekDate",
          A.key === ct.home,
          A.target.getAttribute("id")
        );
      switch ((A.key === ct.pageUp || A.key === ct.pageDown) && (A.shiftKey ? (ve("changeYear", A.key === ct.pageUp), (z = m(g.value, "overlay-year")) == null || z.focus()) : (ve("changeMonth", A.key === ct.pageUp), ($ = m(g.value, A.key === ct.pageUp ? "action-prev" : "action-next")) == null || $.focus()), A.target.getAttribute("id") && ((F = g.value) == null || F.focus({ preventScroll: !0 }))), A.key) {
        case ct.esc:
          return he(A);
        case ct.arrowLeft:
          return K(A, hn.left);
        case ct.arrowRight:
          return K(A, hn.right);
        case ct.arrowUp:
          return K(A, hn.up);
        case ct.arrowDown:
          return K(A, hn.down);
        default:
          return;
      }
    }, ye = (A) => {
      var z;
      o.value.enabled && !o.value.input && !((z = g.value) != null && z.contains(A.target)) && _.value && (_.value = !1, a("menu-blur"));
    };
    return n({
      updateMonthYear: me,
      switchView: X,
      onValueCleared: () => {
        var A, z;
        (z = (A = x.value) == null ? void 0 : A.setStartTime) == null || z.call(A);
      },
      handleFlow: Y
    }), (A, z) => {
      var $, F, P;
      return w(), M("div", {
        id: v(r).menuId,
        ref: "dp-menu",
        tabindex: v(o).enabled ? void 0 : "0",
        role: v(o).enabled ? void 0 : "dialog",
        "aria-label": ($ = v(f)) == null ? void 0 : $.menu,
        class: q(J.value),
        onMouseleave: Z,
        onClick: de,
        onKeydown: oe
      }, [
        (v(r).disabled || v(r).readonly) && v(o).enabled || v(r).loading ? (w(), M("div", {
          key: 0,
          class: q(N.value)
        }, [
          v(r).loading ? (w(), M("div", Iw, [...z[5] || (z[5] = [
            E("span", { class: "dp--menu-loader" }, null, -1)
          ])])) : R("", !0)
        ], 2)) : R("", !0),
        A.$slots["menu-header"] ? (w(), M("div", Aw, [
          H(A.$slots, "menu-header")
        ])) : R("", !0),
        H(A.$slots, "arrow"),
        E("div", {
          ref: "inner-menu",
          class: q({
            dp__menu_content_wrapper: ((F = v(r).presetDates) == null ? void 0 : F.length) || !!A.$slots["left-sidebar"] || !!A.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((P = v(r).presetDates) == null ? void 0 : P.length) || !!A.$slots["left-sidebar"] || !!A.$slots["right-sidebar"])
          }),
          "data-dp-mobile": v(d),
          style: Fe({ "--dp-menu-width": `${S.value}px` })
        }, [
          A.$slots["left-sidebar"] ? (w(), M("div", Rw, [
            H(A.$slots, "left-sidebar", Mt(Nt(j.value)))
          ])) : R("", !0),
          v(r).presetDates.length ? (w(), M("div", {
            key: 1,
            class: q({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": v(d)
          }, [
            (w(!0), M(Te, null, Ie(v(r).presetDates, (Q, L) => (w(), M(Te, { key: L }, [
              Q.slot ? H(A.$slots, Q.slot, {
                key: 0,
                presetDate: V,
                label: Q.label,
                value: Q.value
              }) : (w(), M("button", {
                key: 1,
                type: "button",
                style: Fe(Q.style || {}),
                class: q(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test-id": Q.testId ?? void 0,
                "data-dp-mobile": v(d),
                onClick: Ve((fe) => V(Q.value), ["prevent"]),
                onKeydown: (fe) => v(y)(fe, () => V(Q.value), !0)
              }, re(Q.label), 47, Vw))
            ], 64))), 128))
          ], 10, Fw)) : R("", !0),
          E("div", Lw, [
            (w(), ue(mt(ae.value), {
              ref: "dyn-cmp",
              "flow-step": v(O),
              collapse: e.collapse,
              "no-overlay-focus": e.noOverlayFocus,
              "menu-wrap-ref": g.value,
              onMount: v(D),
              onUpdateFlowStep: v(I),
              onResetFlow: v(B),
              onFocusMenu: G,
              onSelectDate: z[0] || (z[0] = (Q) => A.$emit("select-date")),
              onAutoApply: z[1] || (z[1] = (Q) => A.$emit("auto-apply", Q)),
              onTimeUpdate: z[2] || (z[2] = (Q) => A.$emit("time-update"))
            }, dt({ _: 2 }, [
              Ie(v(U), (Q, L) => ({
                name: Q,
                fn: ce((fe) => [
                  H(A.$slots, Q, Mt(Nt({ ...fe })))
                ])
              }))
            ]), 1064, ["flow-step", "collapse", "no-overlay-focus", "menu-wrap-ref", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ]),
          A.$slots["right-sidebar"] ? (w(), M("div", Nw, [
            H(A.$slots, "right-sidebar", Mt(Nt(j.value)))
          ])) : R("", !0)
        ], 14, Pw),
        A.$slots["action-extra"] ? (w(), M("div", zw, [
          A.$slots["action-extra"] ? H(A.$slots, "action-extra", {
            key: 0,
            selectCurrentDate: Ce
          }) : R("", !0)
        ])) : R("", !0),
        !v(r).autoApply || v(u).keepActionRow ? (w(), ue(V0, {
          key: 3,
          "menu-mount": C.value,
          "calendar-width": S.value,
          onClosePicker: z[3] || (z[3] = (Q) => A.$emit("close-picker")),
          onSelectDate: z[4] || (z[4] = (Q) => A.$emit("select-date")),
          onSelectNow: Ce
        }, dt({ _: 2 }, [
          Ie(v(se), (Q, L) => ({
            name: Q,
            fn: ce((fe) => [
              H(A.$slots, Q, Mt(Nt(fe)))
            ])
          }))
        ]), 1032, ["menu-mount", "calendar-width"])) : R("", !0)
      ], 42, Ew);
    };
  }
}), Ww = ["data-dp-mobile"], Yw = /* @__PURE__ */ ke({
  __name: "VueDatePicker",
  setup(e, { expose: n }) {
    const {
      rootEmit: t,
      setState: a,
      inputValue: s,
      modelValue: l,
      rootProps: r,
      defaults: { inline: i, config: o, textInput: u, range: c, multiDates: f, teleport: p, floatingConfig: d }
    } = Ke(), { validateDate: b, isValidTime: m } = on(), { menuTransition: k, showTransition: y } = qs(), { isMobile: h } = Hl(), { findNextFocusableElement: g, getNumVal: x } = Dt(), S = Ht(), C = ee(!1), _ = ee(i.value.enabled || r.centered), O = yl(r, "modelValue"), I = yl(r, "timezone"), D = Xe("dp-menu-wrap"), B = Xe("dp-menu"), Y = Xe("input-cmp"), ne = Xe("picker-wrapper"), W = Xe("menu-arrow"), ae = ee(!1), G = ee(!1), j = ee(!1), se = ee(!0), U = (De) => (d.value.arrow && De.push(
      wg({ element: d.value.arrow === !0 ? W : d.value.arrow })
    ), d.value.flip && De.push(pg(typeof d.value.flip == "object" ? d.value.flip : {})), d.value.shift && De.push(vg(typeof d.value.shift == "object" ? d.value.shift : {})), De), { floatingStyles: N, middlewareData: J, placement: de, y: he } = kg(
      Y,
      D,
      {
        strategy: d.value.strategy,
        placement: d.value.placement,
        middleware: U([mg(d.value.offset)]),
        whileElementsMounted: hg
      }
    );
    et(() => {
      we(r.modelValue), Ge().then(() => {
        i.value.enabled || globalThis.addEventListener("resize", ye);
      }), i.value.enabled && (C.value = !0), globalThis.addEventListener("keyup", A), globalThis.addEventListener("keydown", z);
    }), Xt(() => {
      i.value.enabled || globalThis.removeEventListener("resize", ye), globalThis.removeEventListener("keyup", A), globalThis.removeEventListener("keydown", z);
    });
    const ge = Nd(S, r.presetDates), $e = _n(S, gn.Input);
    Le(
      [O, I],
      () => {
        we(O.value);
      },
      { deep: !0 }
    ), Le([de, he], () => {
      !i.value.enabled && !r.centered && se.value && (_.value = !1, Ge().then(() => {
        se.value = !1, _.value = !0;
      }));
    });
    const { parseExternalModelValue: we, emitModelValue: X, formatInputValue: ve, checkBeforeEmit: Ce } = Rb(), V = T(
      () => ({
        dp__main: !0,
        dp__theme_dark: r.dark,
        dp__theme_light: !r.dark,
        dp__flex_display: i.value.enabled,
        "dp--flex-display-collapsed": j.value,
        dp__flex_display_with_input: i.value.input
      })
    ), Z = T(() => r.dark ? "dp__theme_dark" : "dp__theme_light"), me = T(() => i.value.enabled && (r.timePicker || r.monthPicker || r.yearPicker || r.quarterPicker)), K = () => {
      var De, ut;
      return ((ut = (De = Y.value) == null ? void 0 : De.$el) == null ? void 0 : ut.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, oe = () => {
      C.value && o.value.closeOnScroll && _e();
    }, ye = () => {
      var ut;
      const De = ((ut = B.value) == null ? void 0 : ut.$el.getBoundingClientRect().width) ?? 0;
      j.value = document.body.offsetWidth <= De;
    }, A = (De) => {
      De.key === "Tab" && !i.value.enabled && !r.teleport && o.value.tabOutClosesMenu && (ne.value.contains(document.activeElement) || _e()), G.value = De.shiftKey;
    }, z = (De) => {
      G.value = De.shiftKey;
    }, $ = () => {
      !r.disabled && !r.readonly && (se.value = !0, C.value = !0, C.value && t("open"), C.value || Re(), we(r.modelValue));
    }, F = () => {
      var De, ut;
      s.value = "", Re(), (De = B.value) == null || De.onValueCleared(), (ut = Y.value) == null || ut.setParsedDate(null), t("update:model-value", null), t("cleared"), o.value.closeOnClearValue && _e();
    }, P = () => {
      const De = l.value;
      return !De || !Array.isArray(De) && b(De) ? !0 : Array.isArray(De) ? f.value.enabled || De.length === 2 && b(De[0]) && b(De[1]) ? !0 : c.value.partialRange && !r.timePicker ? b(De[0]) : !1 : !1;
    }, Q = () => {
      Ce() && P() ? (X(), _e()) : t("invalid-select");
    }, L = (De) => {
      fe(), X(), o.value.closeOnAutoApply && !De && _e();
    }, fe = () => {
      Y.value && u.value.enabled && Y.value.setParsedDate(l.value);
    }, Me = (De = !1) => {
      r.autoApply && m(l.value) && P() && (c.value.enabled && Array.isArray(l.value) ? (c.value.partialRange || l.value.length === 2) && L(De) : L(De));
    }, Re = () => {
      u.value.enabled || (l.value = null);
    }, _e = (De = !1) => {
      se.value = !0, De && l.value && o.value.setDateOnMenuClose && Q(), i.value.enabled || (C.value && (C.value = !1, a("menuFocused", !1), a("shiftKeyInMenu", !1), t("closed"), s.value && we(O.value)), Re(), t("blur"));
    }, Ye = (De, ut, Ct = !1) => {
      if (!De) {
        l.value = null;
        return;
      }
      const Tn = Array.isArray(De) ? De.every((_a) => b(_a)) : b(De), Vn = m(De);
      Tn && Vn ? (a("isTextInputDate", !0), l.value = De, ut ? (ae.value = Ct, Q(), t("text-submit")) : r.autoApply && Me(!0), Ge().then(() => {
        a("isTextInputDate", !1);
      })) : t("invalid-date", De);
    }, At = () => {
      r.autoApply && m(l.value) && X(), fe();
    }, Fn = () => C.value ? _e() : $(), xn = (De) => {
      l.value = De;
    }, Jt = () => {
      u.value.enabled && (a("isInputFocused", !0), ve()), t("focus");
    }, Un = () => {
      var De;
      u.value.enabled && (a("isInputFocused", !1), we(r.modelValue), ae.value && ((De = g(ne.value, G.value)) == null || De.focus())), t("blur");
    }, It = (De, ut) => {
      B.value && B.value.updateMonthYear(ut ?? 0, {
        month: x(De.month),
        year: x(De.year)
      });
    }, Bt = (De) => {
      we(De ?? r.modelValue);
    }, un = (De, ut) => {
      var Ct;
      (Ct = B.value) == null || Ct.switchView(De, ut);
    }, Sn = (De, ut) => {
      if (C.value)
        return o.value.onClickOutside ? o.value.onClickOutside(De, ut) : _e(!0);
    }, bt = (De = 0) => {
      var ut;
      (ut = B.value) == null || ut.handleFlow(De);
    }, wt = () => D;
    return xp(D, (De) => Sn(P, De), {
      ignore: [Y]
    }), n({
      closeMenu: _e,
      selectDate: Q,
      clearValue: F,
      openMenu: $,
      onScroll: oe,
      formatInputValue: ve,
      // exposed for testing purposes
      updateInternalModelValue: xn,
      // modify internal modelValue
      setMonthYear: It,
      parseModel: Bt,
      switchView: un,
      toggleMenu: Fn,
      handleFlow: bt,
      getDpWrapMenuRef: wt,
      dpMenuRef: () => B,
      dpWrapMenuRef: () => D,
      inputRef: () => Y
    }), (De, ut) => (w(), M("div", {
      ref: "picker-wrapper",
      class: q(V.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": v(h)
    }, [
      ie(I0, {
        ref: "input-cmp",
        "is-menu-open": C.value,
        onClear: F,
        onOpen: $,
        onSetInputDate: Ye,
        onSetEmptyDate: v(X),
        onSelectDate: Q,
        onToggle: Fn,
        onClose: _e,
        onFocus: Jt,
        onBlur: Un,
        onRealBlur: ut[0] || (ut[0] = (Ct) => v(a)("isInputFocused", !1))
      }, dt({ _: 2 }, [
        Ie(v($e), (Ct, Tn) => ({
          name: Ct,
          fn: ce((Vn) => [
            H(De.$slots, Ct, Mt(Nt(Vn)))
          ])
        }))
      ]), 1032, ["is-menu-open", "onSetEmptyDate"]),
      ie(Pn, {
        to: v(p),
        disabled: !v(p)
      }, {
        default: ce(() => [
          E("div", {
            ref: "dp-menu-wrap",
            class: q({
              "dp--menu-wrapper": !v(i).enabled,
              dp__outer_menu_wrap: !0,
              "dp--centered": v(r).centered
            }),
            style: Fe(!v(i).enabled && !v(r).centered ? v(N) : void 0)
          }, [
            ie(ht, {
              name: v(k)(v(de).startsWith("top")),
              css: v(y) && !v(i).enabled && !v(r).centered && _.value
            }, {
              default: ce(() => [
                C.value && _.value ? (w(), ue(Bw, {
                  key: 0,
                  ref: "dp-menu",
                  class: q({ [Z.value]: !0 }),
                  "no-overlay-focus": me.value,
                  collapse: j.value,
                  "get-input-rect": K,
                  onClosePicker: _e,
                  onSelectDate: Q,
                  onAutoApply: Me,
                  onTimeUpdate: At,
                  onMenuBlur: ut[1] || (ut[1] = (Ct) => v(t)("blur"))
                }, dt({ _: 2 }, [
                  Ie(v(ge), (Ct, Tn) => ({
                    name: Ct,
                    fn: ce((Vn) => [
                      H(De.$slots, Ct, Mt(Nt({ ...Vn })))
                    ])
                  })),
                  !v(i).enabled && !v(r).centered && v(d).arrow === !0 ? {
                    name: "arrow",
                    fn: ce(() => {
                      var Ct, Tn;
                      return [
                        E("div", {
                          ref: "menu-arrow",
                          class: q({
                            dp__arrow_top: v(de) === "bottom",
                            dp__arrow_bottom: v(de) === "top"
                          }),
                          style: Fe({
                            left: ((Ct = v(J).arrow) == null ? void 0 : Ct.x) != null ? `${v(J).arrow.x}px` : "",
                            top: ((Tn = v(J).arrow) == null ? void 0 : Tn.y) != null ? `${v(J).arrow.y}px` : ""
                          })
                        }, null, 6)
                      ];
                    }),
                    key: "0"
                  } : void 0
                ]), 1032, ["class", "no-overlay-focus", "collapse"])) : R("", !0)
              ]),
              _: 3
            }, 8, ["name", "css"])
          ], 6)
        ]),
        _: 3
      }, 8, ["to", "disabled"])
    ], 10, Ww));
  }
}), Hw = /* @__PURE__ */ ke({
  __name: "VueDatePickerRoot",
  props: /* @__PURE__ */ Eu({
    multiCalendars: { type: [Boolean, Number, String, Object] },
    modelValue: {},
    modelType: {},
    dark: { type: Boolean },
    transitions: { type: [Boolean, Object] },
    ariaLabels: {},
    hideNavigation: {},
    timezone: {},
    vertical: { type: Boolean },
    hideMonthYearSelect: { type: Boolean },
    disableYearSelect: { type: Boolean },
    yearRange: {},
    autoApply: { type: Boolean },
    disabledDates: { type: [Array, Function] },
    startDate: {},
    hideOffsetDates: { type: Boolean },
    noToday: { type: Boolean },
    allowedDates: {},
    markers: {},
    presetDates: {},
    flow: {},
    preventMinMaxNavigation: { type: Boolean },
    reverseYears: { type: Boolean },
    weekPicker: { type: Boolean },
    filters: {},
    arrowNavigation: { type: Boolean },
    highlight: { type: [Function, Object] },
    teleport: { type: [String, Boolean] },
    centered: { type: Boolean },
    locale: {},
    weekStart: {},
    weekNumbers: { type: [Boolean, Object] },
    dayNames: { type: [Function, Array] },
    monthPicker: { type: Boolean },
    yearPicker: { type: Boolean },
    modelAuto: { type: Boolean },
    formats: {},
    multiDates: { type: [Boolean, Object] },
    minDate: {},
    maxDate: {},
    minTime: {},
    maxTime: {},
    inputAttrs: {},
    timeConfig: {},
    placeholder: {},
    timePicker: { type: Boolean },
    range: { type: [Boolean, Object] },
    menuId: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    inline: { type: [Boolean, Object] },
    textInput: { type: [Boolean, Object] },
    sixWeeks: { type: [Boolean, String] },
    actionRow: {},
    focusStartDate: { type: Boolean },
    disabledTimes: { type: [Function, Array] },
    calendar: { type: Function },
    config: {},
    quarterPicker: { type: Boolean },
    yearFirst: { type: Boolean },
    loading: { type: Boolean },
    ui: {},
    floating: {}
  }, T0),
  emits: ["update:model-value", "internal-model-change", "text-submit", "text-input", "open", "closed", "focus", "blur", "cleared", "flow-step", "update-month-year", "invalid-select", "invalid-fixed-range", "invalid-date", "tooltip-open", "tooltip-close", "am-pm-change", "range-start", "range-end", "date-click", "overlay-toggle", "invalid"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e;
    Ib(s, a);
    const l = Ht(), r = Nd(l, s.presetDates), i = Xe("date-picker");
    return n(M0(i)), (o, u) => (w(), ue(Yw, { ref: "date-picker" }, dt({ _: 2 }, [
      Ie(v(r), (c, f) => ({
        name: c,
        fn: ce((p) => [
          H(o.$slots, c, Mt(Nt(p)))
        ])
      }))
    ]), 1536));
  }
}), iu = "theme-mode", Uw = () => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", Hd = Df("theme", () => {
  const e = ee("light"), n = ee("light"), t = T(() => n.value === "dark"), a = T(() => n.value === "light"), s = (o) => {
    document.documentElement.setAttribute("data-theme", o);
  }, l = (o) => {
    e.value = o, n.value = o, s(o), localStorage.setItem(iu, o);
  };
  return {
    themeMode: e,
    resolvedTheme: n,
    isDark: t,
    isLight: a,
    setThemeMode: l,
    toggleTheme: () => {
      l(e.value === "dark" ? "light" : "dark");
    },
    initTheme: () => {
      const o = localStorage.getItem(iu);
      l(o === "light" || o === "dark" ? o : Uw());
    }
  };
}), qw = {
  key: 0,
  class: "v-datepicker-label"
}, jw = { class: "v-datepicker-icon-wrapper" }, Gw = { class: "v-datepicker-clear-wrapper" }, Kw = {
  key: 1,
  class: "v-datepicker-helper-text"
}, Zw = {
  key: 0,
  class: "form-error"
}, Xw = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "VDatepicker",
  props: /* @__PURE__ */ Yt({
    name: { default: "" },
    helperText: { default: "" },
    validation: { default: void 0 },
    size: { default: void 0 },
    icon: { default: "lucide:calendar" },
    autoApply: { type: Boolean, default: !0 },
    clearable: { type: Boolean, default: !1 },
    width: { default: "100%" },
    modern: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = Hd(), t = En(e, "modelValue"), a = Ht(), s = Il(), l = [
      "input-icon",
      "clear-icon",
      "arrow-left",
      "arrow-right",
      "arrow-up",
      "arrow-down",
      "clock-icon",
      "calendar-icon"
    ], r = e, i = T(() => r.size ?? "md"), o = ee(!1), u = T(() => {
      const b = s.disabled;
      return b !== void 0 && b !== !1 && b !== "false";
    }), c = T(() => {
      const b = t.value;
      return Array.isArray(b) ? b.some((m) => m != null && m !== "") : b != null && b !== "";
    }), f = T(() => {
      var b;
      return !!((b = r.validation) != null && b.$error);
    }), p = (b) => typeof b == "object" && b !== null && !Array.isArray(b), d = T(() => {
      const b = p(s.ui) ? s.ui : void 0;
      if (!r.modern) return b;
      const m = b == null ? void 0 : b.menu, k = Array.isArray(m) ? m : m ? [m] : [];
      return { ...b, menu: ["v-datepicker-menu--modern", ...k] };
    });
    return (b, m) => {
      var k, y, h, g;
      return w(), M("div", {
        class: q([[
          `v-datepicker--${i.value}`,
          {
            "v-datepicker-wrapper--modern": r.modern,
            "v-datepicker-wrapper--sized": r.modern && !!r.size,
            "v-datepicker-wrapper--open": o.value,
            "v-datepicker-wrapper--filled": c.value,
            "v-datepicker-wrapper--labelled": !!r.name,
            "v-datepicker-wrapper--disabled": u.value,
            "v-datepicker-wrapper--error": f.value
          }
        ], "v-datepicker-wrapper"]),
        style: Fe({ width: r.width })
      }, [
        r.name ? (w(), M("label", qw, re(r.name), 1)) : R("", !0),
        ie(v(Hw), lt({
          modelValue: t.value,
          "onUpdate:modelValue": m[0] || (m[0] = (x) => t.value = x),
          "auto-apply": r.autoApply,
          "calendar-class-name": "v-datepicker-calendar",
          class: [
            "v-datepicker",
            {
              "v-datepicker-error": (k = e.validation) == null ? void 0 : k.$error,
              "v-datepicker-no-clear": !r.clearable
            }
          ],
          dark: v(n).isDark,
          "input-class-name": [
            "v-datepicker-input",
            {
              "v-datepicker-input-error": (y = e.validation) == null ? void 0 : y.$error
            }
          ],
          timezone: "UTC",
          "week-start": 0
        }, b.$attrs, {
          ui: d.value,
          onClosed: m[1] || (m[1] = (x) => o.value = !1),
          onOpen: m[2] || (m[2] = (x) => o.value = !0)
        }), dt({ _: 2 }, [
          v(a)["input-icon"] ? {
            name: "input-icon",
            fn: ce(() => [
              H(b.$slots, "input-icon", {}, void 0, !0)
            ]),
            key: "0"
          } : {
            name: "input-icon",
            fn: ce(() => [
              E("div", jw, [
                ie(be, {
                  icon: e.icon,
                  class: "v-datepicker-icon"
                }, null, 8, ["icon"])
              ])
            ]),
            key: "1"
          },
          r.clearable ? r.clearable && v(a)["clear-icon"] ? {
            name: "clear-icon",
            fn: ce((x) => [
              H(b.$slots, "clear-icon", Mt(Nt(x)), void 0, !0)
            ]),
            key: "3"
          } : {
            name: "clear-icon",
            fn: ce(({ clear: x }) => [
              E("div", Gw, [
                ie(be, {
                  class: "v-datepicker-clear-icon",
                  icon: "lucide:x",
                  onClick: x
                }, null, 8, ["onClick"])
              ])
            ]),
            key: "4"
          } : {
            name: "clear-icon",
            fn: ce(() => []),
            key: "2"
          },
          v(a)["arrow-left"] ? {
            name: "arrow-left",
            fn: ce(() => [
              H(b.$slots, "arrow-left", {}, void 0, !0)
            ]),
            key: "5"
          } : {
            name: "arrow-left",
            fn: ce(() => [
              ie(be, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-left"
              })
            ]),
            key: "6"
          },
          v(a)["arrow-right"] ? {
            name: "arrow-right",
            fn: ce(() => [
              H(b.$slots, "arrow-right", {}, void 0, !0)
            ]),
            key: "7"
          } : {
            name: "arrow-right",
            fn: ce(() => [
              ie(be, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-right"
              })
            ]),
            key: "8"
          },
          v(a)["arrow-up"] ? {
            name: "arrow-up",
            fn: ce(() => [
              H(b.$slots, "arrow-up", {}, void 0, !0)
            ]),
            key: "9"
          } : {
            name: "arrow-up",
            fn: ce(() => [
              ie(be, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-up"
              })
            ]),
            key: "10"
          },
          v(a)["arrow-down"] ? {
            name: "arrow-down",
            fn: ce(() => [
              H(b.$slots, "arrow-down", {}, void 0, !0)
            ]),
            key: "11"
          } : {
            name: "arrow-down",
            fn: ce(() => [
              ie(be, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-down"
              })
            ]),
            key: "12"
          },
          v(a)["clock-icon"] ? {
            name: "clock-icon",
            fn: ce(() => [
              H(b.$slots, "clock-icon", {}, void 0, !0)
            ]),
            key: "13"
          } : {
            name: "clock-icon",
            fn: ce(() => [
              ie(be, {
                class: "v-datepicker-clock-icon",
                icon: "lucide:clock"
              })
            ]),
            key: "14"
          },
          v(a)["calendar-icon"] ? {
            name: "calendar-icon",
            fn: ce(() => [
              H(b.$slots, "calendar-icon", {}, void 0, !0)
            ]),
            key: "15"
          } : {
            name: "calendar-icon",
            fn: ce(() => [
              ie(be, {
                icon: e.icon,
                class: "v-datepicker-calendar-icon"
              }, null, 8, ["icon"])
            ]),
            key: "16"
          },
          Ie(v(a), (x, S) => ({
            name: S,
            fn: ce((C) => [
              l.includes(S) ? R("", !0) : H(b.$slots, S, Mt(lt({ key: 0 }, C)), void 0, !0)
            ])
          }))
        ]), 1040, ["modelValue", "auto-apply", "class", "dark", "input-class-name", "ui"]),
        E("fieldset", {
          class: q([{ "v-datepicker-fieldset--error": (h = e.validation) == null ? void 0 : h.$error }, "v-datepicker-fieldset"]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: q([{ "v-datepicker-legend--visible": !!r.name }, "v-datepicker-legend"])
          }, [
            E("span", null, re(r.name), 1)
          ], 2)
        ], 2),
        e.helperText && !((g = e.validation) != null && g.$error) ? (w(), M("p", Kw, re(e.helperText), 1)) : R("", !0),
        ie(ht, {
          mode: "out-in",
          name: "error-slide"
        }, {
          default: ce(() => {
            var x, S, C, _;
            return [
              (x = e.validation) != null && x.$error ? (w(), M("p", Zw, re((_ = (C = (S = e.validation) == null ? void 0 : S.$errors) == null ? void 0 : C[0]) == null ? void 0 : _.$message), 1)) : R("", !0)
            ];
          }),
          _: 1
        })
      ], 6);
    };
  }
}), iD = /* @__PURE__ */ ze(Xw, [["__scopeId", "data-v-751165b9"]]), Ks = (e) => e == null, Ud = (e, n) => e.length <= n ? e : `${e.slice(0, n)}...`, Os = (e, n = 2) => {
  if (e === 0) return "0 Bytes";
  const t = 1024, a = n < 0 ? 0 : n, s = [
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB"
  ], l = Math.floor(Math.log(e) / Math.log(t));
  return `${parseFloat((e / Math.pow(t, l)).toFixed(a))} ${s[l]}`;
}, qd = (e) => e.slice((e.lastIndexOf(".") - 1 >>> 0) + 2), oD = (e) => {
  const n = qd(e).toLowerCase();
  return [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "svg",
    "bmp"
  ].includes(n);
}, Jw = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  UAH: "₴",
  JPY: "¥",
  CNY: "¥"
}, _s = (e, n = "USD") => {
  if (Ks(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  let a, s, l;
  typeof n == "string" ? n === "compact" || n === "chart" || n === "default" ? (l = n, a = "USD") : a = n : (a = n.code ?? "USD", s = n.decimals, l = n.format);
  const r = Jw[a] || a, i = t < 0, o = Math.abs(t);
  if (l === "compact") {
    const c = new Intl.NumberFormat("en-US", {
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: s ?? 0,
      maximumFractionDigits: s ?? 1
    }).format(o);
    return i ? `-${r}${c}` : `${r}${c}`;
  }
  if (l === "chart") {
    const c = new Intl.NumberFormat("en-US", {
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: s ?? 1,
      maximumFractionDigits: s ?? 1
    }).format(o);
    return i ? `-${r}${c}` : `${r}${c}`;
  }
  const u = o.toLocaleString("en-US", {
    minimumFractionDigits: s ?? 0,
    maximumFractionDigits: s ?? 0
  });
  return i ? `-${r}${u}` : `${r}${u}`;
}, jd = (e, n) => {
  if (Ks(e)) return { text: "" };
  const t = !!e, a = (n == null ? void 0 : n.trueText) ?? "Yes", s = (n == null ? void 0 : n.falseText) ?? "No", l = (n == null ? void 0 : n.colored) ?? !0, r = t ? a : s;
  return l ? { text: r, class: t ? "text-success" : "text-negative" } : { text: r };
}, Vi = (e, n) => {
  if (Ks(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "object" ? n.decimals ?? 2 : 2;
  return `${((typeof n == "object" ? n.multiplier ?? !1 : !1) ? t * 100 : t).toLocaleString("en-US", {
    minimumFractionDigits: a,
    maximumFractionDigits: a
  })}%`;
}, aa = (e, n) => {
  if (Ks(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "string" ? n : (n == null ? void 0 : n.type) ?? "default", s = typeof n == "object" ? n.decimals : void 0, l = typeof n == "object" ? n.multiply : void 0, r = l !== void 0 ? t * l : t;
  switch (a) {
    case "compact":
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: s ?? 0,
        maximumFractionDigits: s ?? 1
      }).format(r);
    case "chart":
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: s ?? 1,
        maximumFractionDigits: s ?? 1
      }).format(r);
    case "percent":
      return `${r.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 2,
        maximumFractionDigits: s ?? 2
      })}%`;
    case "decimal":
      return r.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 2,
        maximumFractionDigits: s ?? 2
      });
    case "default":
    default:
      return r.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 0,
        maximumFractionDigits: s ?? 0
      });
  }
}, Gd = (e, n) => {
  if (!e) return "";
  let t;
  if (e instanceof Date)
    t = Ee.fromJSDate(e).toUTC();
  else if (typeof e == "string") {
    const s = Ee.fromISO(e, { zone: "utc" });
    if (s.isValid)
      t = s;
    else {
      const l = new Date(e);
      if (isNaN(l.getTime())) return String(e);
      t = Ee.fromJSDate(l).toUTC();
    }
  } else if (typeof e == "number")
    t = Ee.fromMillis(e).toUTC();
  else
    return String(e);
  const a = typeof n == "string" ? n : (n == null ? void 0 : n.format) ?? "short";
  switch (a) {
    case "short":
      return t.toFormat("MM/dd/yyyy");
    case "long":
      return t.toFormat("MMMM dd, yyyy");
    case "time":
      return t.toFormat("h:mm:ss a");
    case "datetime":
      return t.toFormat("MM/dd/yyyy h:mm:ss a");
    default:
      return t.toFormat(a);
  }
}, Kd = (e, n) => {
  if (Ks(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "object" ? n.decimals ?? 2 : 2;
  if (t === 0) return "0 Bytes";
  const s = 1024, l = [
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB"
  ], r = Math.floor(Math.log(t) / Math.log(s));
  return `${parseFloat((t / Math.pow(s, r)).toFixed(a))} ${l[r]}`;
}, uD = (e) => typeof e != "string" ? String(e || "") : e.replace(/[_-]/g, " ").replace(/\s+/g, " ").trim().toLowerCase().split(" ").map((n) => n.charAt(0).toUpperCase() + n.slice(1)).join(" "), Qw = {
  key: 0,
  class: "loader-message"
}, e1 = /* @__PURE__ */ ke({
  __name: "VLoader",
  props: {
    size: { default: "medium" },
    message: { default: "" },
    fullscreen: { type: Boolean, default: !1 },
    variant: { default: "primary" },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = T(() => `loader-${n.size}`), a = T(() => `loader-${n.variant}`), s = T(() => ({
      "loader-fullscreen": n.fullscreen
    }));
    return (l, r) => (w(), M("div", {
      class: q([[s.value, { "loader-container--modern": n.modern }], "loader-container"]),
      role: "status"
    }, [
      E("div", {
        class: q([[t.value, a.value], "loader"])
      }, [...r[0] || (r[0] = [
        E("div", { class: "loader-circle" }, null, -1),
        E("div", { class: "loader-circle" }, null, -1),
        E("div", { class: "loader-circle" }, null, -1)
      ])], 2),
      e.message ? (w(), M("span", Qw, re(e.message), 1)) : R("", !0),
      r[1] || (r[1] = E("span", { class: "sr-only" }, "Loading...", -1))
    ], 2));
  }
}), Kl = /* @__PURE__ */ ze(e1, [["__scopeId", "data-v-7cc51a38"]]), t1 = ["id", "accept", "disabled", "multiple"], n1 = {
  key: 0,
  class: "drag-n-drop__loading"
}, a1 = {
  key: 1,
  class: "drag-n-drop__content"
}, s1 = { class: "drag-n-drop__icon-wrapper" }, l1 = { class: "drag-n-drop__text" }, r1 = {
  key: 0,
  class: "drag-n-drop__title text-primary font-medium text-base"
}, i1 = { class: "drag-n-drop__hint text-secondaryText text-sm" }, o1 = { key: 0 }, u1 = { key: 1 }, c1 = { key: 2 }, d1 = {
  key: 2,
  class: "drag-n-drop__preview"
}, f1 = { class: "drag-n-drop__preview-header" }, h1 = { class: "drag-n-drop__title text-mainText font-medium" }, m1 = { class: "drag-n-drop__hint text-secondaryText text-xs mt-1" }, v1 = { class: "drag-n-drop__file-icon" }, p1 = { class: "drag-n-drop__file-info" }, g1 = ["title"], y1 = { class: "drag-n-drop__file-size" }, b1 = ["disabled", "onClick"], w1 = {
  key: 1,
  class: "drag-n-drop__actions"
}, k1 = /* @__PURE__ */ ke({
  __name: "DragNDrop",
  props: {
    loading: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    button: { type: Boolean, default: !1 },
    id: { default: void 0 },
    accept: { default: "" },
    maxSize: { default: 10 * 1024 * 1024 },
    maxFiles: { default: 10 },
    disabled: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["upload", "submit", "error"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = $a(), l = T(() => `fileInput-${t.id ?? s}`), r = ee(!1), i = ee([]), o = ee(null), u = T(() => i.value.length > 0), c = T(() => !t.multiple || i.value.length < t.maxFiles), f = (C) => {
      const _ = qd(C).toLowerCase();
      return {
        pdf: "mdi:file-pdf-box",
        doc: "mdi:file-word-box",
        docx: "mdi:file-word-box",
        xls: "mdi:file-excel-box",
        xlsx: "mdi:file-excel-box",
        ppt: "mdi:file-powerpoint-box",
        pptx: "mdi:file-powerpoint-box",
        zip: "mdi:folder-zip",
        rar: "mdi:folder-zip",
        jpg: "mdi:file-image",
        jpeg: "mdi:file-image",
        png: "mdi:file-image",
        gif: "mdi:file-image",
        svg: "mdi:file-image",
        txt: "mdi:file-document",
        csv: "mdi:file-delimited"
      }[_] || "mdi:file-document-outline";
    }, p = (C) => t.maxSize && C.size > t.maxSize ? `File "${C.name}" exceeds maximum size of ${Os(t.maxSize)}` : null, d = () => {
      i.value = [];
    }, b = (C) => {
      i.value.splice(C, 1), a("upload", i.value, () => {
      });
    }, m = (C) => {
      const _ = [];
      for (const O of C) {
        const I = p(O);
        if (I) {
          a("error", I);
          continue;
        }
        _.push(O);
      }
      if (_.length !== 0) {
        if (!t.multiple)
          i.value = [_[0]];
        else {
          const O = t.maxFiles - i.value.length, I = _.slice(0, O);
          _.length > O && a("error", `Maximum ${t.maxFiles} files allowed`), i.value = [...i.value, ...I];
        }
        a("upload", i.value, () => {
        });
      }
    }, k = (C) => {
      t.disabled || t.loading || (C.preventDefault(), r.value = !0);
    }, y = (C) => {
      C.preventDefault(), r.value = !1;
    }, h = (C) => {
      var O;
      if (C.preventDefault(), r.value = !1, t.disabled || t.loading || !c.value) return;
      const _ = Array.from(((O = C.dataTransfer) == null ? void 0 : O.files) || []);
      m(_);
    }, g = (C) => {
      const _ = C.target, O = Array.from(_.files || []);
      m(O), o.value && (o.value.value = "");
    }, x = () => {
      i.value.length !== 0 && a("submit", i.value, d);
    }, S = () => {
      var C;
      t.disabled || t.loading || !c.value || (C = o.value) == null || C.click();
    };
    return (C, _) => (w(), M("div", {
      class: q([{ "drag-n-drop--modern": t.modern }, "drag-n-drop"])
    }, [
      E("input", lt({
        id: l.value,
        ref_key: "fileRef",
        ref: o,
        accept: t.accept,
        disabled: t.disabled || t.loading,
        multiple: t.multiple,
        class: "drag-n-drop__input",
        name: "file",
        type: "file"
      }, C.$attrs, { onChange: g }), null, 16, t1),
      E("div", {
        class: q([{
          "drag-n-drop__dropzone--dragging": r.value,
          "drag-n-drop__dropzone--disabled": t.disabled || t.loading,
          "drag-n-drop__dropzone--has-files": u.value
        }, "drag-n-drop__dropzone"]),
        onClick: S,
        onDragleave: y,
        onDragover: k,
        onDrop: h
      }, [
        t.loading ? (w(), M("div", n1, [
          ie(Kl, { class: "w-8 h-8" }),
          _[0] || (_[0] = E("p", { class: "text-secondaryText text-sm mt-2" }, " Processing files... ", -1))
        ])) : u.value ? (w(), M("div", d1, [
          E("div", f1, [
            ie(be, {
              size: 24,
              class: "text-primary",
              icon: "mdi:file-multiple-outline"
            }),
            E("span", h1, re(i.value.length) + " file" + re(i.value.length > 1 ? "s" : "") + " selected ", 1)
          ]),
          E("p", m1, " Click to add " + re(t.multiple ? "more" : "another") + " file" + re(t.multiple ? "s" : ""), 1)
        ])) : (w(), M("div", a1, [
          E("div", s1, [
            ie(be, {
              icon: r.value ? "mdi:cloud-download" : "mdi:cloud-upload-outline",
              size: 48,
              class: "drag-n-drop__icon"
            }, null, 8, ["icon"])
          ]),
          E("div", l1, [
            r.value ? (w(), M("p", r1, " Release to drop files here ")) : (w(), M(Te, { key: 1 }, [
              H(C.$slots, "title", {}, () => [
                _[1] || (_[1] = E("p", { class: "drag-n-drop__title text-mainText font-medium text-base mb-1" }, " Drop files here or click to browse ", -1))
              ], !0),
              H(C.$slots, "subtitle", {}, () => [
                E("p", i1, [
                  t.accept ? (w(), M("span", o1, "Supported: " + re(t.accept), 1)) : R("", !0),
                  t.accept && t.maxSize ? (w(), M("span", u1, " • ")) : R("", !0),
                  t.maxSize ? (w(), M("span", c1, "Max: " + re(v(Os)(t.maxSize)), 1)) : R("", !0)
                ])
              ], !0)
            ], 64))
          ]),
          H(C.$slots, "action", {}, () => [
            ie(_t, {
              modern: t.modern,
              class: "mt-2",
              icon: "mdi:folder-open-outline",
              text: "Browse Files",
              variant: "primary",
              onClick: Ve(S, ["stop"])
            }, null, 8, ["modern"])
          ], !0)
        ]))
      ], 34),
      u.value && !t.loading ? (w(), ue(_r, {
        key: 0,
        class: "drag-n-drop__files",
        name: "file-list",
        tag: "div"
      }, {
        default: ce(() => [
          (w(!0), M(Te, null, Ie(i.value, (O, I) => (w(), M("div", {
            key: `${O.name}-${O.size}-${I}`,
            class: "drag-n-drop__file-item"
          }, [
            E("div", v1, [
              ie(be, {
                icon: f(O.name),
                size: 20,
                class: "text-primary"
              }, null, 8, ["icon"])
            ]),
            E("div", p1, [
              E("p", {
                title: O.name,
                class: "drag-n-drop__file-name"
              }, re(v(Ud)(O.name, 40)), 9, g1),
              E("p", y1, re(v(Os)(O.size)), 1)
            ]),
            E("button", {
              disabled: t.loading,
              class: "drag-n-drop__file-remove",
              type: "button",
              onClick: Ve((D) => b(I), ["stop"])
            }, [
              ie(be, {
                size: 20,
                icon: "mdi:close-circle"
              })
            ], 8, b1)
          ]))), 128))
        ]),
        _: 1
      })) : R("", !0),
      u.value && t.button && !t.loading ? (w(), M("div", w1, [
        ie(_t, {
          modern: t.modern,
          class: "w-full",
          icon: "mdi:check-circle-outline",
          text: "Submit Files",
          variant: "primary",
          onClick: x
        }, null, 8, ["modern"])
      ])) : R("", !0)
    ], 2));
  }
}), cD = /* @__PURE__ */ ze(k1, [["__scopeId", "data-v-864862db"]]), x1 = ["accept", "disabled", "multiple"], S1 = { class: "v-file-upload__icon-wrapper" }, T1 = { class: "v-file-upload__text-container" }, $1 = {
  key: 0,
  class: "v-file-upload__loading"
}, M1 = {
  key: 0,
  class: "v-file-upload__list"
}, C1 = { class: "v-file-upload__item-main flex items-center gap-3 overflow-hidden" }, D1 = { class: "v-file-upload__item-icon" }, O1 = { class: "flex flex-col min-w-0" }, _1 = ["title"], E1 = { class: "text-xs text-secondaryText" }, I1 = ["disabled", "onClick"], A1 = /* @__PURE__ */ ke({
  __name: "VFileUpload",
  props: {
    modelValue: { default: void 0 },
    accept: { default: "*" },
    multiple: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    maxSize: { default: void 0 },
    label: { default: "Click to upload or drag and drop" },
    subLabel: { default: "SVG, PNG, JPG" },
    showList: { type: Boolean, default: !0 },
    variant: { default: "default" },
    immediate: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "upload", "error", "file-select"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(!1), l = ee(null), r = ee(t.modelValue ?? []), i = T({
      get: () => t.modelValue ?? r.value,
      set: (b) => {
        r.value = b, a("update:modelValue", b);
      }
    }), o = () => {
      i.value = [], l.value && (l.value.value = "");
    }, u = (b) => {
      if (!(t.loading || t.disabled)) {
        if (t.maxSize !== void 0) {
          const { maxSize: m } = t;
          if (b.filter((y) => y.size > m).length) {
            a("error", `File size exceeds limit of ${Os(m)}`);
            return;
          }
        }
        if (t.immediate) {
          const m = b[0] || null;
          a("file-select", m), a("upload", b, o);
          return;
        }
        t.multiple ? i.value = [...i.value, ...b] : i.value = b.slice(0, 1), a("change", i.value), a("upload", i.value, o);
      }
    }, c = (b) => {
      var k;
      s.value = !1;
      const m = Array.from(((k = b.dataTransfer) == null ? void 0 : k.files) || []);
      m.length && u(m);
    }, f = (b) => {
      const m = b.target, k = Array.from(m.files || []);
      k.length && u(k);
    }, p = (b) => {
      if (t.loading || t.disabled) return;
      const m = [...i.value];
      m.splice(b, 1), i.value = m, a("change", m);
    }, d = () => {
      var b;
      !t.loading && !t.disabled && ((b = l.value) == null || b.click());
    };
    return (b, m) => (w(), M("div", {
      class: q([{ "v-file-upload--modern": e.modern }, "v-file-upload w-full"])
    }, [
      E("div", {
        class: q([{
          "v-file-upload__dropzone--dragging": s.value,
          "v-file-upload__dropzone--loading": e.loading,
          "v-file-upload__dropzone--disabled": e.disabled,
          "v-file-upload__dropzone--compact": e.variant === "compact"
        }, "v-file-upload__dropzone"]),
        onClick: d,
        onDragenter: m[0] || (m[0] = Ve((k) => s.value = !0, ["prevent"])),
        onDragleave: m[1] || (m[1] = Ve((k) => s.value = !1, ["prevent"])),
        onDragover: m[2] || (m[2] = Ve((k) => s.value = !0, ["prevent"])),
        onDrop: Ve(c, ["prevent"])
      }, [
        E("input", {
          ref_key: "inputRef",
          ref: l,
          accept: e.accept,
          disabled: e.disabled || e.loading,
          multiple: e.multiple,
          class: "hidden",
          type: "file",
          onChange: f
        }, null, 40, x1),
        E("div", {
          class: q([{ "v-file-upload__content--loading": e.loading }, "v-file-upload__content"])
        }, [
          E("div", S1, [
            H(b.$slots, "icon", {}, () => [
              ie(be, {
                size: e.variant === "compact" ? 20 : 28,
                class: "text-secondaryText",
                icon: "lucide:cloud-upload"
              }, null, 8, ["size"])
            ], !0)
          ]),
          E("div", T1, [
            m[3] || (m[3] = E("div", { class: "v-file-upload__text" }, [
              E("span", { class: "v-file-upload__action font-medium text-primary hover:text-primary-dark transition-colors" }, " Click to upload "),
              E("span", { class: "v-file-upload__hint text-secondaryText" }, " or drag and drop ")
            ], -1)),
            e.subLabel ? (w(), M("p", {
              key: 0,
              class: q([{ "mt-1": e.variant !== "compact" }, "text-xs text-secondaryText"])
            }, re(e.subLabel), 3)) : R("", !0)
          ])
        ], 2),
        e.loading ? (w(), M("div", $1, [
          ie(Kl, {
            size: e.variant === "compact" ? "small" : "medium",
            variant: "primary"
          }, null, 8, ["size"]),
          m[4] || (m[4] = E("p", { class: "v-file-upload__uploading text-secondaryText text-sm" }, " Uploading... ", -1))
        ])) : R("", !0)
      ], 34),
      e.showList && i.value.length > 0 && !e.immediate ? (w(), M("div", M1, [
        (w(!0), M(Te, null, Ie(i.value, (k, y) => (w(), M("div", {
          key: `${k.name}-${k.size}-${y}`,
          class: "v-file-upload__item"
        }, [
          E("div", C1, [
            E("div", D1, [
              ie(be, {
                size: e.modern ? 16 : void 0,
                class: "text-primary",
                icon: "lucide:file"
              }, null, 8, ["size"])
            ]),
            E("div", O1, [
              E("span", {
                title: k.name,
                class: "v-file-upload__item-name text-sm font-medium text-mainText truncate"
              }, re(v(Ud)(k.name, 30)), 9, _1),
              E("span", E1, re(v(Os)(k.size)), 1)
            ])
          ]),
          E("button", {
            disabled: e.loading || e.disabled,
            class: "v-file-upload__remove",
            type: "button",
            onClick: Ve((h) => p(y), ["stop"])
          }, [
            ie(be, {
              size: 20,
              icon: "lucide:trash-2"
            })
          ], 8, I1)
        ]))), 128))
      ])) : R("", !0)
    ], 2));
  }
}), dD = /* @__PURE__ */ ze(A1, [["__scopeId", "data-v-4a05eb51"]]), P1 = { class: "v-input-container" }, R1 = ["for"], F1 = ["id"], V1 = ["id"], L1 = /* @__PURE__ */ ke({
  __name: "VInput",
  props: /* @__PURE__ */ Yt({
    name: { default: "" },
    type: { default: "text" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    helperText: { default: "" },
    validation: {},
    error: { default: void 0 },
    icon: { default: "" },
    size: { default: void 0 },
    id: {},
    debounce: { type: [Boolean, Number], default: !1 },
    loading: { type: Boolean, default: !1 },
    textarea: { type: Boolean, default: !1 },
    rows: { default: 4 },
    showClearButton: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    modern: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Yt(["clear"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, a = T(() => !!t.name), s = T(() => {
      var W;
      return !!((W = t.validation) != null && W.$error || t.error);
    }), l = T(() => {
      var W, ae;
      return ((ae = (W = t.validation) == null ? void 0 : W.$errors[0]) == null ? void 0 : ae.$message) ?? t.error ?? "";
    }), r = En(e, "modelValue"), i = n, o = Ht(), u = $a(), c = ee(!1), f = ee(!1), p = ee(null), d = T(() => t.id || `v-input-${u}`), b = typeof t.debounce == "number" ? t.debounce : t.debounce ? 800 : 0, m = ee(r.value ?? "");
    Le(r, (W) => {
      W !== m.value && (m.value = W ?? "");
    });
    const k = Qh((W) => {
      r.value = W;
    }, b), y = (W) => {
      const ae = W.target.value;
      m.value = ae;
      let G = ae;
      if (t.type === "number" && ae !== "") {
        const j = Number(ae);
        isNaN(j) || (G = j);
      }
      k(G);
    }, h = () => {
      var W;
      m.value = "", r.value = t.type === "number" ? void 0 : "", i("clear"), (W = p.value) == null || W.focus();
    }, g = T(() => t.type === "password" ? c.value ? "text" : "password" : t.type), x = () => {
      c.value = !c.value;
    }, S = T(() => t.size ? {
      sm: "v-input-field--sm",
      md: "v-input-field--md",
      lg: "v-input-field--lg"
    }[t.size] : t.modern ? null : "v-input-field--md"), C = T(() => t.type === "search"), _ = T(() => t.icon || C.value || !!o["icon-left"] || t.loading), O = T(() => t.type === "password" || I.value || !!o["icon-right"]), I = T(
      () => t.type !== "password" && m.value !== "" && t.showClearButton
    ), D = T(() => t.icon ? t.icon : C.value ? "mdi:search" : ""), B = T(
      () => m.value !== "" && m.value !== null && m.value !== void 0
    ), Y = T(() => {
      if (s.value) return `${d.value}-error`;
      if (t.helperText) return `${d.value}-helper`;
    }), ne = T(() => t.name ? f.value ? t.placeholder : "" : t.placeholder);
    return (W, ae) => (w(), M("div", {
      class: q(["v-input-wrapper", { "v-input--modern": t.modern }])
    }, [
      E("div", P1, [
        a.value ? (w(), M("label", {
          key: 0,
          class: q([
            "v-label",
            {
              "v-label--active": f.value || B.value,
              "v-label--error": s.value,
              "v-label--with-icon": _.value && !(f.value || B.value),
              "v-label--textarea": e.textarea
            }
          ]),
          for: d.value
        }, re(t.name), 11, R1)) : R("", !0),
        _.value ? (w(), M("div", {
          key: 1,
          class: q([
            "v-input-icon v-input-icon-left",
            {
              "v-input-icon-textarea": e.textarea,
              // Legacy tints only a focused search field; modern tints any left icon on focus.
              "v-input-icon--active": f.value && (C.value || t.modern) || e.loading,
              "v-input-icon--error": s.value
            }
          ])
        }, [
          H(W.$slots, "icon-left", {}, () => [
            D.value || e.loading ? (w(), ue(be, {
              key: 0,
              icon: D.value,
              loading: e.loading,
              class: "v-input-icon-svg"
            }, null, 8, ["icon", "loading"])) : R("", !0)
          ], !0)
        ], 2)) : R("", !0),
        (w(), ue(mt(e.textarea ? "textarea" : "input"), lt({
          id: d.value,
          key: `${e.textarea ? "textarea" : "input"}-${d.value}`,
          ref_key: "inputRef",
          ref: p,
          class: [
            "v-input-field",
            S.value,
            {
              "v-input-field--textarea": e.textarea,
              "v-input-field--with-left-icon": _.value,
              "v-input-field--with-right-icon": O.value,
              "v-input-field--date": e.type === "date" && !e.textarea,
              "v-input-field--disabled": e.disabled
            }
          ],
          "aria-describedby": Y.value,
          "aria-invalid": s.value ? !0 : void 0,
          disabled: e.disabled,
          placeholder: ne.value,
          value: m.value
        }, {
          ...W.$attrs,
          type: e.textarea ? void 0 : g.value,
          rows: e.textarea ? e.rows : void 0
        }, {
          onBlur: ae[0] || (ae[0] = (G) => f.value = !1),
          onFocus: ae[1] || (ae[1] = (G) => f.value = !0),
          onInput: y
        }), null, 16, ["id", "class", "aria-describedby", "aria-invalid", "disabled", "placeholder", "value"])),
        O.value ? (w(), M("div", {
          key: 2,
          class: q([
            "v-input-icon v-input-icon-right",
            { "v-input-icon-textarea": e.textarea }
          ])
        }, [
          H(W.$slots, "icon-right", {}, () => [
            I.value ? (w(), M("button", {
              key: 0,
              "aria-label": "Clear input",
              class: "v-input-clear-btn",
              title: "Clear",
              type: "button",
              onClick: h
            }, [
              ie(be, {
                class: "v-input-icon-svg v-input-icon-svg--sm",
                icon: "lucide:x"
              })
            ])) : t.type === "password" ? (w(), M("div", {
              key: 1,
              class: "v-input-password-toggle",
              role: "button",
              tabindex: "0",
              onClick: x,
              onKeydown: Vt(x, ["enter", "space"])
            }, [
              ie(be, {
                icon: g.value === "text" ? "lucide:eye-off" : "lucide:eye",
                class: "v-input-icon-svg"
              }, null, 8, ["icon"])
            ], 32)) : R("", !0)
          ], !0)
        ], 2)) : R("", !0),
        E("fieldset", {
          class: q([
            "v-fieldset",
            {
              "v-fieldset--active": f.value,
              "v-fieldset--error": s.value,
              "v-fieldset--disabled": e.disabled,
              "v-fieldset--flat": !e.shadow
            }
          ]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: q(["v-legend", { "v-legend--visible": a.value && (B.value || f.value) }])
          }, [
            E("span", null, re(t.name), 1)
          ], 2)
        ], 2)
      ]),
      H(W.$slots, "helper-text", {}, () => [
        e.helperText && !s.value ? (w(), M("p", {
          key: 0,
          id: `${d.value}-helper`,
          class: "v-input-helper-text"
        }, re(e.helperText), 9, F1)) : R("", !0)
      ], !0),
      ie(ht, {
        mode: "out-in",
        name: "error-slide"
      }, {
        default: ce(() => [
          H(W.$slots, "error-message", {}, () => [
            s.value ? (w(), M("p", {
              key: 0,
              id: `${d.value}-error`,
              class: "v-input-error-message"
            }, re(l.value), 9, V1)) : R("", !0)
          ], !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), Ol = /* @__PURE__ */ ze(L1, [["__scopeId", "data-v-e1b966d0"]]), N1 = { class: "v-collapse__wrap" }, z1 = ["aria-hidden"], B1 = /* @__PURE__ */ ke({
  __name: "VCollapse",
  props: /* @__PURE__ */ Yt({
    duration: { default: 200 },
    unmount: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = En(e, "modelValue");
    return (t, a) => (w(), M("div", {
      class: q([{ "v-collapse--expanded": n.value }, "v-collapse"]),
      style: Fe({ "--v-collapse-duration": `${e.duration}ms` })
    }, [
      E("div", N1, [
        !e.unmount || n.value ? (w(), M("div", {
          key: 0,
          "aria-hidden": !n.value,
          class: "v-collapse__content"
        }, [
          H(t.$slots, "default", {}, void 0, !0)
        ], 8, z1)) : R("", !0)
      ])
    ], 6));
  }
}), W1 = /* @__PURE__ */ ze(B1, [["__scopeId", "data-v-d2e88ce5"]]), Y1 = { class: "v-composer__preview" }, H1 = {
  key: 1,
  class: "v-composer__meta"
}, U1 = {
  key: 0,
  class: "v-composer__edited"
}, q1 = { class: "v-composer__meta-actions" }, j1 = ["inert"], G1 = ["id", "aria-invalid", "aria-label", "placeholder", "rows"], K1 = {
  key: 0,
  class: "v-composer__message v-composer__message--error"
}, Z1 = {
  key: 1,
  class: "v-composer__message"
}, X1 = { class: "v-composer__footer" }, J1 = {
  key: 0,
  class: "v-composer__failed"
}, Q1 = {
  key: 1,
  class: "v-composer__hint"
}, ek = { class: "v-composer__footer-actions" }, tk = /* @__PURE__ */ ke({
  __name: "VComposer",
  props: /* @__PURE__ */ Yt({
    initialValue: { default: "" },
    preview: { default: "" },
    placeholder: { default: "" },
    openLabel: { default: "Write" },
    submitLabel: { default: "Send" },
    status: { default: "idle" },
    validation: {},
    error: {},
    helperText: { default: "" },
    copyable: { type: Boolean, default: !1 },
    rows: { default: 5 }
  }, {
    modelValue: { default: "" },
    modelModifiers: {},
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Yt(["submit", "expand"], ["update:modelValue", "update:open"]),
  setup(e, { emit: n }) {
    const t = n, { copy: a, copied: s, isSupported: l } = mi({ copiedDuring: 2e3 }), r = $a(), i = Xe("field"), o = Xe("root"), u = En(e, "modelValue"), c = En(e, "open");
    let f = !1;
    const p = T(() => {
      var O;
      return !!((O = e.validation) != null && O.$error || e.error);
    }), d = T(() => {
      var O, I;
      return ((I = (O = e.validation) == null ? void 0 : O.$errors[0]) == null ? void 0 : I.$message) ?? e.error ?? "";
    }), b = T(() => e.initialValue !== "" && u.value !== e.initialValue), m = T(() => e.status === "sending"), k = T(() => e.status === "sent"), y = T(() => e.status === "error" ? "Retry" : k.value ? "Send again" : e.submitLabel), h = () => {
      c.value || (c.value = !0, t("expand"));
    }, g = () => {
      var O;
      return ((O = o.value) == null ? void 0 : O.contains(document.activeElement)) ?? !1;
    }, x = ({ restoreFocus: O } = {}) => {
      const I = O ?? g();
      c.value = !1, I && Ge(() => {
        var D, B;
        (B = (D = o.value) == null ? void 0 : D.querySelector(".v-composer__row button")) == null || B.focus();
      });
    }, S = () => {
      var O;
      u.value = e.initialValue, (O = i.value) == null || O.focus();
    }, C = (O) => {
      if (!m.value) {
        if (f = !0, O) {
          O();
          return;
        }
        t("submit", u.value);
      }
    }, _ = (O) => {
      if (O.key === "Enter" && (O.metaKey || O.ctrlKey)) {
        O.preventDefault(), C();
        return;
      }
      O.key === "Escape" && (O.preventDefault(), O.stopPropagation(), x());
    };
    return Le(c, async (O) => {
      if (!O) return;
      await Ge();
      const I = i.value;
      I && (I.focus(), I.setSelectionRange(I.value.length, I.value.length));
    }), Le(() => e.status, (O, I) => {
      if (O !== "sent" || I !== "sending") return;
      const D = f || g();
      f = !1, x({ restoreFocus: D });
    }), (O, I) => (w(), M("div", {
      ref_key: "root",
      ref: o,
      class: q([{
        "v-composer--open": c.value,
        "v-composer--sent": k.value && !c.value,
        "v-composer--error": p.value,
        "v-composer--failed": e.status === "error" && !c.value
      }, "v-composer"])
    }, [
      c.value ? (w(), M("div", H1, [
        H(O.$slots, "meta", {}, void 0, !0),
        b.value ? (w(), M("span", U1, "edited")) : R("", !0),
        E("span", q1, [
          e.copyable && v(l) ? (w(), ue(_t, {
            key: 0,
            "aria-label": v(s) ? "Copied" : "Copy to clipboard",
            icon: v(s) ? "lucide:check" : "lucide:copy",
            modern: "",
            variant: "neutral",
            onClick: I[0] || (I[0] = (D) => v(a)(u.value))
          }, null, 8, ["aria-label", "icon"])) : R("", !0),
          ie(_t, {
            "aria-label": "Collapse",
            icon: "lucide:x",
            modern: "",
            variant: "neutral",
            onClick: I[1] || (I[1] = (D) => x())
          })
        ])
      ])) : (w(), M("div", {
        key: 0,
        class: "v-composer__row",
        onClick: h
      }, [
        ie(be, {
          icon: k.value ? "lucide:check" : "lucide:pen-line",
          size: 15,
          class: "v-composer__icon"
        }, null, 8, ["icon"]),
        E("span", Y1, [
          H(O.$slots, "preview", {}, () => [
            He(re(e.preview || e.placeholder), 1)
          ], !0)
        ]),
        ie(_t, {
          "aria-controls": v(r),
          icon: k.value ? void 0 : "lucide:send",
          text: k.value ? "View" : e.openLabel,
          variant: k.value ? "neutral" : "primary",
          "aria-expanded": "false",
          modern: "",
          onClick: Ve(h, ["stop"])
        }, null, 8, ["aria-controls", "icon", "text", "variant"])
      ])),
      ie(W1, { "model-value": c.value }, {
        default: ce(() => [
          E("div", {
            inert: !c.value,
            class: "v-composer__body"
          }, [
            an(E("textarea", {
              id: v(r),
              ref_key: "field",
              ref: i,
              "onUpdate:modelValue": I[2] || (I[2] = (D) => u.value = D),
              "aria-invalid": p.value,
              "aria-label": e.placeholder || e.submitLabel,
              placeholder: e.placeholder,
              rows: e.rows,
              class: "v-composer__field",
              onKeydown: _
            }, null, 40, G1), [
              [Iu, u.value]
            ]),
            p.value ? (w(), M("p", K1, re(d.value), 1)) : e.helperText ? (w(), M("p", Z1, re(e.helperText), 1)) : R("", !0),
            E("div", X1, [
              e.status === "error" ? (w(), M("span", J1, "Couldn't send — your text is kept")) : (w(), M("span", Q1, [
                H(O.$slots, "hint", {}, () => [
                  I[4] || (I[4] = E("kbd", null, "⌘/Ctrl", -1)),
                  I[5] || (I[5] = He()),
                  I[6] || (I[6] = E("kbd", null, "↵", -1)),
                  I[7] || (I[7] = He(" to send · ", -1)),
                  I[8] || (I[8] = E("kbd", null, "Esc", -1)),
                  I[9] || (I[9] = He(" to collapse ", -1))
                ], !0)
              ])),
              E("span", ek, [
                e.initialValue ? (w(), ue(_t, {
                  key: 0,
                  disabled: !b.value,
                  class: "v-composer__reset",
                  modern: "",
                  text: "Reset",
                  variant: "neutral",
                  onClick: S
                }, null, 8, ["disabled"])) : R("", !0),
                H(O.$slots, "actions", { submit: C }, () => [
                  ie(_t, {
                    loading: m.value,
                    text: y.value,
                    class: "v-composer__submit",
                    icon: "lucide:send",
                    modern: "",
                    variant: "primary",
                    onClick: I[3] || (I[3] = (D) => C())
                  }, null, 8, ["loading", "text"])
                ], !0)
              ])
            ])
          ], 8, j1)
        ]),
        _: 3
      }, 8, ["model-value"])
    ], 2));
  }
}), fD = /* @__PURE__ */ ze(tk, [["__scopeId", "data-v-670d3534"]]), nk = (e) => e.map((n) => n.text.trim()).filter((n) => n.length > 0), hD = (e) => e.map((n) => ({ text: n })), ak = ["aria-pressed", "disabled", "onClick"], sk = /* @__PURE__ */ ke({
  __name: "VToggleGroup",
  props: {
    modelValue: {},
    options: {},
    size: {},
    modern: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = {
      sm: "px-2 py-1 text-xs gap-1",
      md: "px-3 py-1.5 text-sm gap-1.5",
      lg: "px-4 py-2 text-base gap-2"
    }, s = {
      sm: "w-3 h-3",
      md: "w-4 h-4",
      lg: "w-5 h-5"
    }, l = T(() => e.modern && e.size ? `v-toggle-group--${e.size}` : ""), r = (i) => {
      i.disabled || t("update:modelValue", i.value);
    };
    return (i, o) => (w(), M("div", {
      class: q([[l.value, { "v-toggle-group--modern": e.modern }], "v-toggle-group inline-flex items-center gap-1 bg-base-200 rounded-lg p-1 shadow-md border border-base-400"])
    }, [
      (w(!0), M(Te, null, Ie(e.options, (u) => (w(), ue(xa, {
        key: String(u.value),
        "allow-html": !0,
        text: u.tooltip || "",
        class: "v-toggle-group__item flex items-center"
      }, {
        default: ce(() => [
          E("button", {
            class: q([[
              e.modern ? "transition-colors" : "transition-all",
              // Modern sizes items from CSS, and its active item is a neutral raised surface.
              e.modern ? "" : a[e.size ?? "md"],
              e.modelValue === u.value ? e.modern ? "v-toggle-group__button--active" : "bg-primary text-white shadow-sm" : "text-secondaryText hover:text-mainText hover:bg-base-300",
              u.disabled && "opacity-50 cursor-not-allowed"
            ], "flex items-center rounded-md font-medium whitespace-nowrap"]),
            "aria-pressed": e.modelValue === u.value,
            disabled: u.disabled,
            type: "button",
            onClick: (c) => r(u)
          }, [
            u.icon ? (w(), ue(be, {
              key: 0,
              class: q(s[e.size ?? "md"]),
              icon: u.icon
            }, null, 8, ["class", "icon"])) : R("", !0),
            E("span", null, re(u.label), 1)
          ], 10, ak)
        ]),
        _: 2
      }, 1032, ["text"]))), 128))
    ], 2));
  }
}), lk = /* @__PURE__ */ ze(sk, [["__scopeId", "data-v-1eb5a9e7"]]), rk = { class: "v-list-editor__header" }, ik = {
  key: 0,
  class: "v-list-editor__label"
}, ok = { class: "v-list-editor__tools" }, uk = ["disabled"], ck = {
  key: 0,
  class: "v-list-editor__manual"
}, dk = ["onClick"], fk = {
  key: 0,
  class: "v-list-editor__error"
}, hk = {
  key: 1,
  class: "v-list-editor__bulk"
}, mk = { class: "v-list-editor__hint" }, vk = { class: "v-list-editor__hint-detected" }, pk = { class: "v-list-editor__summary" }, gk = { class: "v-list-editor__count" }, yk = ["onClick"], bk = /* @__PURE__ */ ke({
  __name: "VListEditor",
  props: /* @__PURE__ */ Yt({
    label: { default: () => {
    } },
    itemLabel: { default: "Item" },
    itemLabelPlural: { default: () => {
    } },
    placeholder: { default: () => {
    } },
    markerClass: { default: () => {
    } },
    maxItems: { default: () => {
    } },
    maxLength: { default: () => {
    } },
    modes: { default: "both" },
    validation: { default: () => {
    } },
    itemError: { type: Function, default: void 0 },
    modern: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: n }) {
    const t = En(e, "modelValue"), a = Xe("inputs"), s = e.modes === "both", l = ee(e.modes === "bulk" ? "bulk" : "manual"), r = ee(""), i = [
      { value: "manual", label: "Manual", icon: "lucide:plus" },
      { value: "bulk", label: "Bulk", icon: "lucide:list" }
    ], o = /* @__PURE__ */ new WeakMap();
    let u = 0;
    const c = (U) => {
      const N = _u(U);
      let J = o.get(N);
      return J || (J = `item-${++u}`, o.set(N, J)), J;
    }, f = T(() => e.maxItems === void 0 || t.value.length < e.maxItems), p = T(() => `Add ${e.itemLabel.toLowerCase()}`), d = T(() => e.itemLabelPlural ?? `${e.itemLabel}s`), b = (U) => U === 0 ? e.placeholder ?? `${e.itemLabel} 1` : `${e.itemLabel} ${U + 1}`, m = T(() => {
      var U;
      return !!((U = e.validation) != null && U.$error);
    }), k = T(() => {
      var U, N, J;
      return String(((J = (N = (U = e.validation) == null ? void 0 : U.$errors) == null ? void 0 : N[0]) == null ? void 0 : J.$message) ?? "");
    }), y = () => {
      var U, N;
      (N = (U = e.validation) == null ? void 0 : U.$touch) == null || N.call(U);
    }, h = (U, N) => {
      var J;
      return ((J = e.itemError) == null ? void 0 : J.call(e, U, N)) ?? void 0;
    }, g = async (U) => {
      var J, de, he;
      await Ge();
      const N = (J = a.value) == null ? void 0 : J[U];
      (he = (de = N == null ? void 0 : N.$el) == null ? void 0 : de.querySelector("textarea, input")) == null || he.focus();
    }, x = (U) => {
      if (!f.value) return;
      const N = U === void 0 ? t.value.length : U + 1;
      t.value.splice(N, 0, { text: "" }), g(N);
    }, S = (U) => {
      t.value.length <= 1 || (t.value.splice(U, 1), y(), g(Math.max(0, U - 1)));
    }, C = (U) => {
      x(U);
    }, _ = (U, N) => {
      N.length > 0 || S(U);
    }, O = () => {
      x();
    }, I = [
      { char: `
`, label: "newline", regex: /\n/ },
      { char: ",", label: "comma", regex: /,/ },
      { char: ";", label: "semicolon", regex: /;/ },
      { char: "|", label: "pipe", regex: /\|/ },
      { char: "/", label: "slash", regex: /\// },
      { char: "	", label: "tab", regex: /\t/ }
    ], D = T(() => I.filter((U) => U.regex.test(r.value))), B = T(() => {
      const U = r.value.trim();
      if (!U) return [];
      const N = D.value.length ? new RegExp(D.value.map((de) => de.regex.source).join("|")) : /\s+/, J = [...new Set(U.split(N).map((de) => de.trim()).filter(Boolean))].map((de) => e.maxLength ? de.slice(0, e.maxLength) : de);
      return e.maxItems ? J.slice(0, e.maxItems) : J;
    }), Y = (U) => {
      const N = [...t.value];
      return U.map((J) => {
        const de = N.findIndex((he) => he.text === J);
        if (de !== -1) {
          const [he] = N.splice(de, 1);
          return he;
        }
        return { text: J };
      });
    }, ne = T(() => {
      if (!e.itemError) return {};
      const U = {};
      return B.value.forEach((N) => {
        const J = t.value.findIndex((de) => de.text === N);
        J !== -1 && (U[N] = e.itemError(t.value[J], J) ?? void 0);
      }), U;
    }), W = (U) => {
      r.value = U, t.value = Y(B.value);
    }, ae = (U) => {
      W(String(U ?? ""));
    }, G = () => {
      W("");
    }, j = (U) => {
      W(B.value.filter((N) => N !== U).join(`
`));
    }, se = (U) => {
      if (U !== l.value) {
        if (U === "bulk")
          r.value = nk(t.value).join(`
`);
        else {
          const N = Y(B.value);
          t.value = N.length ? N : [{ text: "" }], r.value = "";
        }
        l.value = U;
      }
    };
    return n({ focusRow: g }), (U, N) => (w(), M("div", {
      class: q([{ "v-list-editor--modern": e.modern }, "v-list-editor"])
    }, [
      E("div", rk, [
        e.label ? (w(), M("span", ik, re(e.label), 1)) : R("", !0),
        E("div", ok, [
          l.value === "manual" ? (w(), ue(xa, {
            key: 0,
            placement: "top",
            text: f.value ? "" : `Up to ${e.maxItems} ${d.value.toLowerCase()}`
          }, {
            default: ce(() => [
              E("button", {
                disabled: !f.value,
                class: "v-list-editor__add",
                type: "button",
                onClick: O
              }, [
                ie(be, {
                  icon: "lucide:plus",
                  size: "14"
                }),
                He(" " + re(p.value), 1)
              ], 8, uk)
            ]),
            _: 1
          }, 8, ["text"])) : R("", !0),
          s ? (w(), ue(lk, {
            key: 1,
            "model-value": l.value,
            modern: e.modern,
            options: i,
            size: "sm",
            "onUpdate:modelValue": se
          }, null, 8, ["model-value", "modern"])) : R("", !0)
        ])
      ]),
      l.value === "manual" ? (w(), M("div", ck, [
        E("div", {
          class: q([{ "v-list-editor__box--error": m.value }, "v-list-editor__box"])
        }, [
          ie(_r, {
            class: "v-list-editor__rows",
            name: "v-list-editor-row",
            tag: "div"
          }, {
            default: ce(() => [
              (w(!0), M(Te, null, Ie(t.value, (J, de) => (w(), M("div", {
                key: c(J),
                class: "v-list-editor__row"
              }, [
                e.markerClass ? (w(), M("span", {
                  key: 0,
                  class: q([e.markerClass, "v-list-editor__marker"])
                }, null, 2)) : R("", !0),
                ie(Ol, {
                  ref_for: !0,
                  ref: "inputs",
                  modelValue: J.text,
                  "onUpdate:modelValue": (he) => J.text = he,
                  error: h(J, de),
                  maxlength: e.maxLength,
                  modern: e.modern,
                  placeholder: b(de),
                  "show-clear-button": !1,
                  class: "flex-1 min-w-0",
                  name: "",
                  onBlur: y,
                  onKeydown: [
                    Vt(Ve((he) => C(de), ["exact", "prevent", "stop"]), ["enter"]),
                    Vt(Ve((he) => _(de, J.text), ["stop"]), ["backspace"])
                  ]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "maxlength", "modern", "placeholder", "onKeydown"]),
                t.value.length > 1 ? (w(), M("button", {
                  key: 1,
                  "aria-label": "Remove",
                  class: "v-list-editor__remove",
                  type: "button",
                  onClick: (he) => S(de)
                }, [
                  ie(be, {
                    icon: "lucide:x",
                    size: "14"
                  })
                ], 8, dk)) : R("", !0)
              ]))), 128))
            ]),
            _: 1
          })
        ], 2),
        m.value ? (w(), M("p", fk, re(k.value), 1)) : R("", !0)
      ])) : (w(), M("div", hk, [
        ie(Ol, {
          error: m.value ? k.value : void 0,
          "model-value": r.value,
          modern: e.modern,
          placeholder: `Enter ${d.value.toLowerCase()}, one per line or comma-separated`,
          rows: 4,
          textarea: !0,
          name: "",
          onBlur: y,
          "onUpdate:modelValue": ae
        }, null, 8, ["error", "model-value", "modern", "placeholder"]),
        E("p", mk, [
          N[1] || (N[1] = He(" Separate by: newline · , · ; · | · / · tab ", -1)),
          D.value.length ? (w(), M(Te, { key: 0 }, [
            N[0] || (N[0] = He(" · ", -1)),
            E("span", vk, " Detected: " + re(D.value.map((J) => J.label).join(", ")), 1)
          ], 64)) : R("", !0)
        ]),
        B.value.length > 0 ? (w(), M(Te, { key: 0 }, [
          E("div", pk, [
            E("span", gk, re(B.value.length) + " " + re(B.value.length === 1 ? "item" : "items") + " detected ", 1),
            E("button", {
              class: "v-list-editor__clear",
              type: "button",
              onClick: G
            }, " Clear all ")
          ]),
          ie(_r, {
            class: "v-list-editor__preview",
            name: "v-list-editor-chip",
            tag: "div"
          }, {
            default: ce(() => [
              (w(!0), M(Te, null, Ie(B.value, (J) => (w(), ue(xa, {
                key: J,
                placement: "top",
                text: ne.value[J] ?? ""
              }, {
                default: ce(() => [
                  ie(Zu, {
                    color: ne.value[J] ? "error" : "primary",
                    label: J,
                    class: "v-list-editor__chip",
                    size: "md",
                    variant: "outline"
                  }, {
                    "icon-right": ce(() => [
                      E("button", {
                        class: "v-list-editor__chip-remove",
                        type: "button",
                        onClick: (de) => j(J)
                      }, [
                        ie(be, {
                          class: "size-2.5",
                          icon: "lucide:x"
                        })
                      ], 8, yk)
                    ]),
                    _: 2
                  }, 1032, ["color", "label"])
                ]),
                _: 2
              }, 1032, ["text"]))), 128))
            ]),
            _: 1
          })
        ], 64)) : R("", !0)
      ]))
    ], 2));
  }
}), mD = /* @__PURE__ */ ze(bk, [["__scopeId", "data-v-f83df93a"]]), wk = ["aria-busy"], kk = ["aria-label", "aria-pressed", "title", "disabled", "onClick"], xk = { key: 1 }, Sk = {
  key: 0,
  "aria-hidden": "true",
  class: "absolute inset-0 flex items-center justify-center"
}, Tk = /* @__PURE__ */ ke({
  __name: "VSegmentedControl",
  props: {
    modelValue: {},
    options: {},
    size: {},
    fullWidth: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    deselectable: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = Xe("container"), s = Xe("pill");
    let l = null, r = 0, i = !1;
    const o = ee(!1), u = {
      primary: "bg-primary-100 text-primary-700",
      success: "bg-success-100 text-success-700",
      warning: "bg-warning-100 text-warning-700",
      error: "bg-error-100 text-error-700",
      info: "bg-info-100 text-info-700",
      neutral: "bg-base-300 text-secondaryText",
      violet: "bg-violet-100 text-violet-700"
    }, c = (h) => {
      if (e.modern) return "";
      const g = !!(h.icon && !h.label);
      switch (e.size) {
        case "none":
          return "";
        case "sm":
          return g ? "p-1" : "text-xs px-2 py-1";
        case "lg":
          return g ? "p-2.5" : "text-base px-4 py-2.5";
        default:
          return g ? "p-2" : "text-sm px-3 py-2";
      }
    }, f = T(() => e.modern && e.size ? `v-segmented-control--${e.size}` : ""), p = T(() => {
      switch (e.size) {
        // Modern text is 13px, so a 16px icon would tower over it in all but the tallest track.
        case "sm":
          return 14;
        case "lg":
          return 20;
        case void 0:
        case "md":
          return e.modern ? 14 : 16;
        default:
          return 16;
      }
    }), d = (h) => h.value === e.modelValue, b = (h) => e.loading && d(h), m = (h) => {
      o.value || i || h <= 0 || (i = !0, r = requestAnimationFrame(() => {
        r = requestAnimationFrame(() => {
          o.value = !0, i = !1;
        });
      }));
    }, k = () => {
      const h = a.value, g = s.value;
      if (!h || !g) return;
      const x = h.querySelectorAll("button"), S = e.options.findIndex((_) => _.value === e.modelValue), C = x[S];
      if (!C) {
        g.style.opacity = "0";
        return;
      }
      g.style.opacity = "1", g.style.transform = `translateX(${C.offsetLeft}px)`, g.style.width = `${C.offsetWidth}px`, m(C.offsetWidth);
    }, y = (h) => {
      if (!(h.disabled || e.disabled || e.loading)) {
        if (e.deselectable && d(h)) {
          t("update:modelValue", null);
          return;
        }
        t("update:modelValue", h.value);
      }
    };
    return et(() => {
      Ge(k);
      const h = a.value;
      !h || typeof ResizeObserver > "u" || (l = new ResizeObserver(() => k()), l.observe(h));
    }), Sf(k), Xt(() => {
      l == null || l.disconnect(), l = null, cancelAnimationFrame(r);
    }), (h, g) => (w(), M("div", {
      ref: "container",
      "aria-busy": e.loading,
      class: q([[f.value, {
        "v-segmented-control--modern": e.modern,
        "w-full": e.fullWidth,
        "opacity-50 pointer-events-none": e.disabled,
        // No dimming while loading: the spinner already says the control is busy, and fading the
        // whole track would hide the option the user just picked.
        "pointer-events-none": e.loading
      }], "v-segmented-control relative inline-flex items-center rounded-lg bg-base-200 p-1 border-[1px] border-base-400 shadow-md gap-1"])
    }, [
      E("span", {
        ref: "pill",
        class: q([{ "sliding-pill--ready": o.value }, "sliding-pill absolute left-0 top-1 rounded-md pointer-events-none bg-primary/15 ring-1 ring-inset ring-primary/40 shadow-sm"])
      }, null, 2),
      (w(!0), M(Te, null, Ie(e.options, (x) => (w(), M("button", {
        key: x.value,
        "aria-label": x.ariaLabel,
        "aria-pressed": d(x),
        title: x.ariaLabel,
        class: q([[
          c(x),
          e.fullWidth ? "flex-1" : "",
          d(x) ? "v-segment--active text-primary" : "text-secondaryText hover:text-mainText",
          x.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        ], "relative z-10 flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 focus-visible:ring-offset-base-200"]),
        disabled: x.disabled || e.disabled,
        type: "button",
        onClick: (S) => y(x)
      }, [
        H(h.$slots, `option-${x.value}`, {
          option: x,
          selected: d(x)
        }, () => [
          E("span", {
            class: q([{ "opacity-0": b(x) }, "flex items-center gap-1.5 transition-opacity duration-150"])
          }, [
            x.icon ? (w(), ue(be, {
              key: 0,
              icon: x.icon,
              size: p.value
            }, null, 8, ["icon", "size"])) : R("", !0),
            x.label ? (w(), M("span", xk, re(x.label), 1)) : R("", !0),
            x.badge !== void 0 ? (w(), M("span", {
              key: 2,
              class: q([u[x.badgeColor ?? "neutral"], "ml-0.5 rounded-full px-1.5 py-0.5 text-[11px] font-semibold leading-none"])
            }, re(x.badge), 3)) : R("", !0)
          ], 2),
          b(x) ? (w(), M("span", Sk, [
            ie(be, {
              size: p.value,
              icon: "lucide:loader-2",
              loading: ""
            }, null, 8, ["size"])
          ])) : R("", !0)
        ], !0)
      ], 10, kk))), 128))
    ], 10, wk));
  }
}), vD = /* @__PURE__ */ ze(Tk, [["__scopeId", "data-v-98aaebb0"]]);
function xr(e) {
  return e === 0 ? !1 : Array.isArray(e) && e.length === 0 ? !0 : !e;
}
function $k(e) {
  return (...n) => !e(...n);
}
function Mk(e, n) {
  return e === void 0 && (e = "undefined"), e === null && (e = "null"), e === !1 && (e = "false"), e.toString().toLowerCase().indexOf(n.trim()) !== -1;
}
function Ck(e) {
  return e.filter((n) => !n.$isLabel);
}
function Sr(e, n) {
  return (t) => t.reduce((a, s) => s[e] && s[e].length ? (a.push({
    $groupLabel: s[n],
    $isLabel: !0
  }), a.concat(s[e])) : a, []);
}
const ou = (...e) => (n) => e.reduce((t, a) => a(t), n);
var Dk = {
  data() {
    return {
      search: "",
      isOpen: !1,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: !0
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: !0
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(e, n) {
        return xr(e) ? "" : n ? e[n] : e;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: !1
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: !1
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: !1
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
     */
    preventAutofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows a custom function for sorting search/filtered results.
     * @default null
     * @type {Function}
     */
    filteringSortFunc: {
      type: Function,
      default: null
    }
  },
  mounted() {
    !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const e = this.search || "", n = e.toLowerCase().trim();
      let t = this.options.concat();
      return this.internalSearch ? t = this.groupValues ? this.filterAndFlat(t, n, this.label) : this.filterOptions(t, n, this.label, this.customLabel) : t = this.groupValues ? Sr(this.groupValues, this.groupLabel)(t) : t, t = this.hideSelected ? t.filter($k(this.isSelected)) : t, this.taggable && n.length && !this.isExistingOption(n) && (this.tagPosition === "bottom" ? t.push({ isTag: !0, label: e }) : t.unshift({ isTag: !0, label: e })), t.slice(0, this.optionsLimit);
    },
    valueKeys() {
      return this.trackBy ? this.internalValue.map((e) => e[this.trackBy]) : this.internalValue;
    },
    optionKeys() {
      return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map((n) => this.customLabel(n, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("update:modelValue", this.multiple ? [] : null));
      },
      deep: !0
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(e, n, t) {
      return ou(
        this.filterGroups(n, t, this.groupValues, this.groupLabel, this.customLabel),
        Sr(this.groupValues, this.groupLabel)
      )(e);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(e) {
      return ou(
        Sr(this.groupValues, this.groupLabel),
        Ck
      )(e);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(e) {
      this.search = e;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(e) {
      return this.options ? this.optionKeys.indexOf(e) > -1 : !1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(e) {
      const n = this.trackBy ? e[this.trackBy] : e;
      return this.valueKeys.indexOf(n) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(e) {
      return !!e.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(e) {
      if (xr(e)) return "";
      if (e.isTag) return e.label;
      if (e.$isLabel) return e.$groupLabel;
      const n = this.customLabel(e, this.label);
      return xr(n) ? "" : n;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(e, n) {
      if (e.$isLabel && this.groupSelect) {
        this.selectGroup(e);
        return;
      }
      if (!(this.blockKeys.indexOf(n) !== -1 || this.disabled || e.$isDisabled || e.$isLabel) && !(this.max && this.multiple && this.internalValue.length === this.max) && !(n === "Tab" && !this.pointerDirty)) {
        if (e.isTag)
          this.$emit("tag", e.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
        else {
          if (this.isSelected(e)) {
            n !== "Tab" && this.removeElement(e);
            return;
          }
          this.multiple ? this.$emit("update:modelValue", this.internalValue.concat([e])) : this.$emit("update:modelValue", e), this.$emit("select", e, this.id), this.clearOnSelect && (this.search = "");
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(e) {
      const n = this.options.find((t) => t[this.groupLabel] === e.$groupLabel);
      if (n) {
        if (this.wholeGroupSelected(n)) {
          this.$emit("remove", n[this.groupValues], this.id);
          const t = this.trackBy ? n[this.groupValues].map((s) => s[this.trackBy]) : n[this.groupValues], a = this.internalValue.filter(
            (s) => t.indexOf(this.trackBy ? s[this.trackBy] : s) === -1
          );
          this.$emit("update:modelValue", a);
        } else {
          const t = n[this.groupValues].filter(
            (a) => !(this.isOptionDisabled(a) || this.isSelected(a))
          );
          this.max && t.splice(this.max - this.internalValue.length), this.$emit("select", t, this.id), this.$emit(
            "update:modelValue",
            this.internalValue.concat(t)
          );
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(e) {
      return e[this.groupValues].every(
        (n) => this.isSelected(n) || this.isOptionDisabled(n)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(e) {
      return e[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(e, n = !0) {
      if (this.disabled || e.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const t = typeof e == "object" ? this.valueKeys.indexOf(e[this.trackBy]) : this.valueKeys.indexOf(e);
      if (this.multiple) {
        const a = this.internalValue.slice(0, t).concat(this.internalValue.slice(t + 1));
        this.$emit("update:modelValue", a);
      } else
        this.$emit("update:modelValue", null);
      this.$emit("remove", e, this.id), this.closeOnSelect && n && this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(() => this.$refs.search && this.$refs.search.focus())) : this.preventAutofocus || typeof this.$el < "u" && this.$el.focus(), this.$emit("open", this.id));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search !== null && typeof this.$refs.search < "u" && this.$refs.search.blur() : typeof this.$el < "u" && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window > "u") return;
      const e = this.$el.getBoundingClientRect().top, n = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      n > this.maxHeight || n > e || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(n - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(e - 40, this.maxHeight));
    },
    /**
     * Filters and sorts the options ready for selection
     * @param {Array} options
     * @param {String} search
     * @param {String} label
     * @param {Function} customLabel
     * @returns {Array}
     */
    filterOptions(e, n, t, a) {
      return n ? e.filter((s) => Mk(a(s, t), n)).sort((s, l) => typeof this.filteringSortFunc == "function" ? this.filteringSortFunc(s, l) : a(s, t).length - a(l, t).length) : e;
    },
    /**
     *
     * @param {String} search
     * @param {String} label
     * @param {String} values
     * @param {String} groupLabel
     * @param {function} customLabel
     * @returns {function(*): *}
     */
    filterGroups(e, n, t, a, s) {
      return (l) => l.map((r) => {
        if (!r[t])
          return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
        const i = this.filterOptions(r[t], e, n, s);
        return i.length ? {
          [a]: r[a],
          [t]: i
        } : [];
      });
    }
  }
}, Ok = {
  data() {
    return {
      pointer: 0,
      pointerDirty: !1
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: !0
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = !1;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(e, n) {
      return {
        "multiselect__option--highlight": e === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(n)
      };
    },
    groupHighlight(e, n) {
      if (!this.groupSelect)
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": n.$isLabel }
        ];
      const t = this.options.find((a) => a[this.groupLabel] === n.$groupLabel);
      return t && !this.wholeGroupDisabled(t) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": e === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(t) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key: e } = "Enter") {
      this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
    },
    pointerForward() {
      var e;
      this.pointer < this.filteredOptions.length - 1 && (this.pointer++, ((e = this.$refs.list) == null ? void 0 : e.scrollTop) <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
    },
    pointerBackward() {
      var e;
      this.pointer > 0 ? (this.pointer--, ((e = this.$refs.list) == null ? void 0 : e.scrollTop) >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
    },
    pointerAdjust() {
      this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
    },
    pointerSet(e) {
      this.pointer = e, this.pointerDirty = !0;
    }
  }
}, Zd = {
  name: "vue-multiselect",
  mixins: [Dk, Ok],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: !1
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (e) => `and ${e} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables search input's spellcheck if true.
     * @default false
     * @type {Boolean}
     */
    spellcheck: {
      type: Boolean,
      default: !1
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: !0
    },
    showNoResults: {
      type: Boolean,
      default: !0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Adds Required attribute to the input element when there is no value selected
     * @default false
     * @type {Boolean}
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Uses Vue Teleport's feature. Teleports the open dropdown to the bottom of the body element
     * @default false
     * @type {Boolean}
     */
    useTeleport: {
      type: Boolean,
      default: !1
    },
    /**
     * Classes to apply to the `multiselect__content-wrapper` element. This element is a teleport element (when enabled), so can be used to specifically target
     * the teleported element
     */
    contentWrapperClass: {
      type: [String, Array, Object],
      default: ""
    }
  },
  data() {
    return {
      dropdownStyles: {},
      ready: !1
    };
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      return this.searchable || this.multiple && this.modelValue && this.modelValue.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      return this.openDirection === "above" || this.openDirection === "top" ? !0 : this.openDirection === "below" || this.openDirection === "bottom" ? !1 : this.preferredOpenDirection === "above";
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : !0);
    },
    isRequired() {
      return this.required === !1 ? !1 : this.internalValue.length <= 0;
    }
  },
  watch: {
    isOpen(e) {
      e && (this.useTeleport ? (this.ready = !1, this.$nextTick(() => {
        const n = this.$el.getBoundingClientRect();
        this.dropdownStyles = {
          position: "absolute",
          top: `${n.bottom + window.scrollY}px`,
          left: `${n.left + window.scrollX}px`,
          width: `${n.width}px`,
          zIndex: 9999
        }, this.ready = !0;
      })) : this.ready = !0);
    }
  }
};
const _k = ["tabindex", "aria-expanded", "aria-owns", "aria-activedescendant"], Ek = {
  ref: "tags",
  class: "multiselect__tags"
}, Ik = { class: "multiselect__tags-wrap" }, Ak = ["textContent"], Pk = ["onKeydown", "onMousedown"], Rk = ["textContent"], Fk = { class: "multiselect__spinner" }, Vk = ["name", "id", "spellcheck", "placeholder", "required", "value", "disabled", "tabindex", "aria-label", "aria-controls"], Lk = ["id", "aria-multiselectable"], Nk = { key: 0 }, zk = { class: "multiselect__option" }, Bk = ["aria-selected", "id", "role"], Wk = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"], Yk = ["data-select", "data-deselect", "onMouseenter", "onMousedown"], Hk = { class: "multiselect__option" }, Uk = { class: "multiselect__option" };
function qk(e, n, t, a, s, l) {
  return w(), M("div", {
    tabindex: e.searchable ? -1 : t.tabindex,
    class: q([{ "multiselect--active": e.isOpen, "multiselect--disabled": t.disabled, "multiselect--above": l.isAbove, "multiselect--has-options-group": l.hasOptionGroup }, "multiselect"]),
    onFocus: n[14] || (n[14] = (r) => e.activate()),
    onBlur: n[15] || (n[15] = (r) => e.searchable ? !1 : e.deactivate()),
    onKeydown: [
      n[16] || (n[16] = Vt(Ve((r) => e.pointerForward(), ["self", "prevent"]), ["down"])),
      n[17] || (n[17] = Vt(Ve((r) => e.pointerBackward(), ["self", "prevent"]), ["up"])),
      n[18] || (n[18] = Vt(Ve((r) => e.addPointerElement(r), ["stop", "self"]), ["enter", "tab"]))
    ],
    onKeyup: n[19] || (n[19] = Vt((r) => e.deactivate(), ["esc"])),
    role: "combobox",
    "aria-expanded": e.isOpen,
    "aria-owns": "listbox-" + e.id,
    "aria-activedescendant": e.isOpen && e.pointer !== null ? e.id + "-" + e.pointer : null
  }, [
    H(e.$slots, "caret", { toggle: e.toggle }, () => [
      E(
        "div",
        {
          onMousedown: n[0] || (n[0] = Ve((r) => e.toggle(), ["prevent", "stop"])),
          class: "multiselect__select"
        },
        null,
        32
        /* NEED_HYDRATION */
      )
    ]),
    H(e.$slots, "clear", { search: e.search }),
    E(
      "div",
      Ek,
      [
        H(e.$slots, "selection", {
          search: e.search,
          remove: e.removeElement,
          values: l.visibleValues,
          isOpen: e.isOpen
        }, () => [
          an(E(
            "div",
            Ik,
            [
              (w(!0), M(
                Te,
                null,
                Ie(l.visibleValues, (r, i) => H(e.$slots, "tag", {
                  option: r,
                  search: e.search,
                  remove: e.removeElement
                }, () => [
                  (w(), M(
                    "span",
                    {
                      class: "multiselect__tag",
                      key: i,
                      onMousedown: n[1] || (n[1] = Ve(() => {
                      }, ["prevent"]))
                    },
                    [
                      E("span", {
                        textContent: re(e.getOptionLabel(r))
                      }, null, 8, Ak),
                      E("i", {
                        tabindex: "1",
                        onKeydown: Vt(Ve((o) => e.removeElement(r), ["prevent"]), ["enter"]),
                        onMousedown: Ve((o) => e.removeElement(r), ["prevent"]),
                        class: "multiselect__tag-icon"
                      }, null, 40, Pk)
                    ],
                    32
                    /* NEED_HYDRATION */
                  ))
                ])),
                256
                /* UNKEYED_FRAGMENT */
              ))
            ],
            512
            /* NEED_PATCH */
          ), [
            [Bn, l.visibleValues.length > 0]
          ]),
          e.internalValue && e.internalValue.length > t.limit ? H(e.$slots, "limit", { key: 0 }, () => [
            E("strong", {
              class: "multiselect__strong",
              textContent: re(t.limitText(e.internalValue.length - t.limit))
            }, null, 8, Rk)
          ]) : R("v-if", !0)
        ]),
        ie(ht, { name: "multiselect__loading" }, {
          default: ce(() => [
            H(e.$slots, "loading", {}, () => [
              an(E(
                "div",
                Fk,
                null,
                512
                /* NEED_PATCH */
              ), [
                [Bn, t.loading]
              ])
            ])
          ]),
          _: 3
          /* FORWARDED */
        }),
        e.searchable ? (w(), M("input", {
          key: 0,
          ref: "search",
          name: t.name,
          id: e.id,
          type: "text",
          autocomplete: "off",
          spellcheck: t.spellcheck,
          placeholder: e.placeholder,
          required: l.isRequired,
          style: Fe(l.inputStyle),
          value: e.search,
          disabled: t.disabled,
          tabindex: t.tabindex,
          "aria-label": t.name + "-searchbox",
          onInput: n[2] || (n[2] = (r) => e.updateSearch(r.target.value)),
          onFocus: n[3] || (n[3] = Ve((r) => e.activate(), ["prevent"])),
          onBlur: n[4] || (n[4] = Ve((r) => e.deactivate(), ["prevent"])),
          onKeyup: n[5] || (n[5] = Vt((r) => e.deactivate(), ["esc"])),
          onKeydown: [
            n[6] || (n[6] = Vt(Ve((r) => e.pointerForward(), ["prevent"]), ["down"])),
            n[7] || (n[7] = Vt(Ve((r) => e.pointerBackward(), ["prevent"]), ["up"])),
            n[8] || (n[8] = Vt(Ve((r) => e.addPointerElement(r), ["prevent", "stop", "self"]), ["enter"])),
            n[9] || (n[9] = Vt(Ve((r) => e.removeLastElement(), ["stop"]), ["delete"]))
          ],
          class: "multiselect__input",
          "aria-controls": "listbox-" + e.id
        }, null, 44, Vk)) : R("v-if", !0),
        l.isSingleLabelVisible ? (w(), M(
          "span",
          {
            key: 1,
            class: "multiselect__single",
            onMousedown: n[10] || (n[10] = Ve((...r) => e.toggle && e.toggle(...r), ["prevent"]))
          },
          [
            H(e.$slots, "singleLabel", { option: l.singleValue }, () => [
              He(
                re(e.currentOptionLabel),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : R("v-if", !0),
        l.isPlaceholderVisible ? (w(), M(
          "span",
          {
            key: 2,
            class: "multiselect__placeholder",
            onMousedown: n[11] || (n[11] = Ve((...r) => e.toggle && e.toggle(...r), ["prevent"]))
          },
          [
            H(e.$slots, "placeholder", {}, () => [
              He(
                re(e.placeholder),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : R("v-if", !0)
      ],
      512
      /* NEED_PATCH */
    ),
    (w(), ue(Pn, {
      to: "body",
      disabled: !t.useTeleport
    }, [
      ie(ht, { name: "multiselect" }, {
        default: ce(() => [
          e.isOpen && s.ready ? (w(), M(
            "div",
            {
              key: 0,
              class: q(["multiselect__content-wrapper", t.contentWrapperClass]),
              onFocus: n[12] || (n[12] = (...r) => e.activate && e.activate(...r)),
              tabindex: "-1",
              onMousedown: n[13] || (n[13] = Ve(() => {
              }, ["prevent"])),
              style: Fe([s.dropdownStyles, { maxHeight: e.optimizedHeight + "px" }]),
              ref: "list"
            },
            [
              E("ul", {
                class: "multiselect__content",
                style: Fe(l.contentStyle),
                role: "listbox",
                id: "listbox-" + e.id,
                "aria-multiselectable": e.multiple
              }, [
                H(e.$slots, "beforeList"),
                e.multiple && e.max === e.internalValue.length ? (w(), M("li", Nk, [
                  E("span", zk, [
                    H(e.$slots, "maxElements", {}, () => [
                      He(
                        "Maximum of " + re(e.max) + " options selected. First remove a selected option to select another.",
                        1
                        /* TEXT */
                      )
                    ])
                  ])
                ])) : R("v-if", !0),
                !e.max || e.internalValue.length < e.max ? (w(!0), M(
                  Te,
                  { key: 1 },
                  Ie(e.filteredOptions, (r, i) => (w(), M("li", {
                    class: "multiselect__element",
                    key: i,
                    "aria-selected": e.isSelected(r),
                    id: e.id + "-" + i,
                    role: r && (r.$isLabel || r.$isDisabled) ? null : "option"
                  }, [
                    r && (r.$isLabel || r.$isDisabled) ? R("v-if", !0) : (w(), M("span", {
                      key: 0,
                      class: q([e.optionHighlight(i, r), "multiselect__option"]),
                      onClick: Ve((o) => e.select(r), ["stop"]),
                      onMouseenter: Ve((o) => e.pointerSet(i), ["self"]),
                      "data-select": r && r.isTag ? e.tagPlaceholder : l.selectLabelText,
                      "data-selected": l.selectedLabelText,
                      "data-deselect": l.deselectLabelText
                    }, [
                      H(e.$slots, "option", {
                        option: r,
                        search: e.search,
                        index: i
                      }, () => [
                        E(
                          "span",
                          null,
                          re(e.getOptionLabel(r)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, Wk)),
                    r && (r.$isLabel || r.$isDisabled) ? (w(), M("span", {
                      key: 1,
                      "data-select": e.groupSelect && l.selectGroupLabelText,
                      "data-deselect": e.groupSelect && l.deselectGroupLabelText,
                      class: q([e.groupHighlight(i, r), "multiselect__option"]),
                      onMouseenter: Ve((o) => e.groupSelect && e.pointerSet(i), ["self"]),
                      onMousedown: Ve((o) => e.selectGroup(r), ["prevent"])
                    }, [
                      H(e.$slots, "option", {
                        option: r,
                        search: e.search,
                        index: i
                      }, () => [
                        E(
                          "span",
                          null,
                          re(e.getOptionLabel(r)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, Yk)) : R("v-if", !0)
                  ], 8, Bk))),
                  128
                  /* KEYED_FRAGMENT */
                )) : R("v-if", !0),
                an(E(
                  "li",
                  null,
                  [
                    E("span", Hk, [
                      H(e.$slots, "noResult", { search: e.search }, () => [
                        n[20] || (n[20] = He("No elements found. Consider changing the search query."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [Bn, t.showNoResults && e.filteredOptions.length === 0 && e.search && !t.loading]
                ]),
                an(E(
                  "li",
                  null,
                  [
                    E("span", Uk, [
                      H(e.$slots, "noOptions", {}, () => [
                        n[21] || (n[21] = He("List is empty."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [Bn, t.showNoOptions && (e.options.length === 0 || l.hasOptionGroup === !0 && e.filteredOptions.length === 0) && !e.search && !t.loading]
                ]),
                H(e.$slots, "afterList")
              ], 12, Lk)
            ],
            38
            /* CLASS, STYLE, NEED_HYDRATION */
          )) : R("v-if", !0)
        ]),
        _: 3
        /* FORWARDED */
      })
    ], 8, ["disabled"]))
  ], 42, _k);
}
Zd.render = qk;
const jk = { class: "v-select" }, Gk = { class: "multiselect__select" }, Kk = {
  key: 0,
  class: "v-select__helper-text"
}, Zk = {
  key: 0,
  class: "v-select__error-message"
}, Xk = /* @__PURE__ */ ke({
  __name: "VSelect",
  props: {
    modelValue: { default: null },
    options: { default: () => [] },
    placeholder: { default: "Select option" },
    disabled: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !0 },
    clearOnSelect: { type: Boolean, default: !0 },
    closeOnSelect: { type: Boolean, default: !0 },
    label: { default: "label" },
    trackBy: { default: "value" },
    loading: { type: Boolean, default: !1 },
    taggable: { type: Boolean, default: !1 },
    maxHeight: { default: 300 },
    optionsLimit: { default: 1e3 },
    teleportToBody: { type: Boolean, default: !0 },
    name: { default: "" },
    allowEmpty: { type: Boolean, default: !1 },
    noResultsText: { default: "No results found" },
    helperText: { default: "" },
    validation: { default: void 0 },
    error: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "select", "remove", "search-change", "open", "close"],
  setup(e, { emit: n }) {
    const t = e, a = ["noResult", "helper-text", "error-message"], s = (D) => !a.includes(D), l = T(() => {
      var D;
      return !!((D = t.validation) != null && D.$error || t.error);
    }), r = T(() => {
      var D, B;
      return ((B = (D = t.validation) == null ? void 0 : D.$errors[0]) == null ? void 0 : B.$message) ?? t.error ?? "";
    }), i = T(() => !!t.name), o = T(() => i.value ? u.value ? t.placeholder : "" : t.placeholder), u = ee(!1), c = T(() => Array.isArray(t.modelValue) ? t.modelValue.length > 0 : t.modelValue && typeof t.modelValue == "object" ? !0 : t.modelValue !== null && t.modelValue !== void 0), f = n, p = (D) => {
      f("update:modelValue", D);
    }, d = (D) => {
      f("select", D);
    }, b = (D) => {
      f("remove", D);
    }, m = (D) => {
      f("search-change", D);
    }, k = ee(null);
    let y = null, h = null, g = null;
    const x = () => {
      var G;
      if (!y || !k.value) return;
      const D = (G = k.value.$el) == null ? void 0 : G.querySelector(".multiselect__tags");
      if (!D) return;
      const B = D.getBoundingClientRect(), Y = window.innerHeight - B.bottom, ne = Math.min(y.scrollHeight, t.maxHeight), W = Y < ne && B.top > Y, ae = W ? Math.max(4, B.top - ne - 4) : Math.min(window.innerHeight - ne - 4, B.bottom + 4);
      Object.assign(y.style, {
        position: "fixed",
        top: `${ae}px`,
        left: `${B.left}px`,
        width: `${B.width}px`,
        maxHeight: `${t.maxHeight}px`,
        zIndex: "10000"
      }), y.classList.toggle("opened-above", W);
    }, S = () => requestAnimationFrame(x), C = () => {
      t.teleportToBody && Ge(() => {
        var D, B;
        y = (B = (D = k.value) == null ? void 0 : D.$el) == null ? void 0 : B.querySelector(".multiselect__content-wrapper"), y && (h || (g = y.parentElement, h = document.createComment("v-multiselect-anchor"), g == null || g.replaceChild(h, y), document.body.appendChild(y)), y.classList.add("v-ms-floating"), t.modern && y.classList.add("v-ms-modern"), x(), window.addEventListener("scroll", S, { passive: !0 }), window.addEventListener("resize", S, { passive: !0 }));
      });
    }, _ = () => {
      y && (window.removeEventListener("scroll", S), window.removeEventListener("resize", S), y.classList.remove("v-ms-floating", "v-ms-modern", "opened-above"), y.removeAttribute("style"), h && g && g.replaceChild(y, h), h = null, g = null, y = null);
    }, O = () => {
      C(), u.value = !0, f("open");
    }, I = () => {
      var D;
      _(), u.value = !1, (D = t.validation) == null || D.$touch(), f("close");
    };
    return Fs(() => _()), (D, B) => (w(), M("div", {
      class: q([{ "v-select--modern": t.modern }, "v-select-wrapper"])
    }, [
      E("div", jk, [
        i.value ? (w(), M("label", {
          key: 0,
          class: q([{
            "v-select__label--active": u.value || c.value,
            "v-select__label--error": l.value
          }, "v-select__label"])
        }, re(t.name), 3)) : R("", !0),
        ie(v(Zd), lt({
          ref_key: "msRef",
          ref: k,
          "allow-empty": t.allowEmpty,
          "clear-on-select": t.clearOnSelect,
          "close-on-select": t.closeOnSelect,
          disabled: t.disabled,
          label: t.label,
          loading: t.loading,
          "max-height": t.maxHeight,
          "model-value": t.modelValue,
          multiple: t.multiple,
          options: t.options,
          "options-limit": t.optionsLimit,
          placeholder: o.value,
          searchable: t.searchable,
          "show-labels": !1,
          taggable: t.taggable,
          "track-by": t.trackBy
        }, D.$attrs, {
          onClose: I,
          onOpen: O,
          onRemove: b,
          onSelect: d,
          "onUpdate:modelValue": p,
          onSearchChange: m
        }), dt({
          caret: ce(() => [
            E("div", Gk, [
              ie(be, {
                loading: t.loading,
                class: "v-select__caret-icon",
                icon: "mdi:chevron-down"
              }, null, 8, ["loading"])
            ])
          ]),
          noResult: ce(() => [
            H(D.$slots, "noResult", {}, () => [
              He(re(t.noResultsText || "No results found"), 1)
            ], !0)
          ]),
          _: 2
        }, [
          Ie(Object.keys(D.$slots).filter(s), (Y) => ({
            name: Y,
            fn: ce((ne) => [
              H(D.$slots, Y, Mt(Nt(ne ?? {})), void 0, !0)
            ])
          }))
        ]), 1040, ["allow-empty", "clear-on-select", "close-on-select", "disabled", "label", "loading", "max-height", "model-value", "multiple", "options", "options-limit", "placeholder", "searchable", "taggable", "track-by"]),
        E("fieldset", {
          class: q([{
            "v-select__fieldset--active": u.value,
            "v-select__fieldset--error": l.value
          }, "v-select__fieldset"]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: q([{ "v-select__legend--visible": i.value && (c.value || u.value) }, "v-select__legend"])
          }, [
            E("span", null, re(t.name), 1)
          ], 2)
        ], 2)
      ]),
      H(D.$slots, "helper-text", {}, () => [
        t.helperText && !l.value ? (w(), M("p", Kk, re(t.helperText), 1)) : R("", !0)
      ], !0),
      ie(ht, {
        mode: "out-in",
        name: "error-slide"
      }, {
        default: ce(() => [
          H(D.$slots, "error-message", {}, () => [
            l.value ? (w(), M("p", Zk, re(r.value), 1)) : R("", !0)
          ], !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), Jk = /* @__PURE__ */ ze(Xk, [["__scopeId", "data-v-caaac7fa"]]), Qk = ["for"], ex = { class: "v-switch__container" }, tx = ["id", "checked", "disabled"], nx = { class: "v-switch__label" }, ax = /* @__PURE__ */ ke({
  __name: "VSwitch",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    trueIcon: {},
    falseIcon: {},
    trueLabel: {},
    falseLabel: {},
    color: {},
    id: {},
    modern: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = Il(), l = $a(), r = T(() => t.id || `v-switch-${l}`), i = T({
      get: () => !!t.modelValue,
      set: (b) => a("update:modelValue", b)
    }), o = (b) => {
      b.target instanceof HTMLInputElement && (i.value = b.target.checked, b.target.checked = i.value);
    }, u = {
      positive: "success",
      negative: "error"
    }, c = (b) => /^#|^rgb|^hsl|^oklch|^color/.test(b) ? b : `rgb(var(--color-${u[b] ?? b}) / 1)`, f = T(() => t.modern ? 10 : 16), p = T(() => t.modern ? 10 : 12), d = T(() => {
      if (t.disabled && t.modern) return {};
      if (t.disabled)
        return {
          backgroundColor: "#d1d5db",
          borderColor: "#d1d5db"
        };
      if (t.color && i.value) {
        const b = c(t.color);
        return {
          backgroundColor: b,
          borderColor: b
        };
      }
      return {};
    });
    return (b, m) => (w(), M("label", {
      class: q([{
        "v-switch--modern": t.modern,
        "v-switch--disabled": t.disabled,
        "v-switch--loading": t.loading && !t.disabled
      }, "v-switch"]),
      for: r.value
    }, [
      E("span", ex, [
        E("input", lt({
          id: r.value,
          checked: i.value,
          disabled: t.disabled || t.loading,
          class: "v-switch__input",
          type: "checkbox"
        }, v(s), { onChange: o }), null, 16, tx),
        E("span", {
          class: q([
            "v-switch__track",
            { "v-switch__track--checked": i.value },
            { "v-switch__track--disabled": t.disabled },
            { "v-switch__track--custom-color": t.color && i.value }
          ]),
          style: Fe(d.value)
        }, [
          E("span", {
            class: q(["v-switch__thumb", { "v-switch__thumb--checked": i.value }])
          }, [
            t.loading ? (w(), ue(be, {
              key: 0,
              loading: !0,
              size: p.value,
              class: "v-switch__spinner",
              icon: "lucide:loading"
            }, null, 8, ["size"])) : b.$slots.icon ? H(b.$slots, "icon", { key: 1 }, () => [
              H(b.$slots, i.value ? "true-icon" : "false-icon", {}, void 0, !0)
            ], !0) : (w(), M(Te, { key: 2 }, [
              i.value && t.trueIcon ? (w(), ue(be, {
                key: 0,
                icon: t.trueIcon,
                size: f.value
              }, null, 8, ["icon", "size"])) : !i.value && t.falseIcon ? (w(), ue(be, {
                key: 1,
                icon: t.falseIcon,
                size: f.value
              }, null, 8, ["icon", "size"])) : R("", !0)
            ], 64))
          ], 2)
        ], 6)
      ]),
      E("span", nx, [
        H(b.$slots, "default", {}, () => [
          He(re(i.value ? t.trueLabel : t.falseLabel), 1)
        ], !0)
      ])
    ], 10, Qk));
  }
}), pD = /* @__PURE__ */ ze(ax, [["__scopeId", "data-v-2f6c82f7"]]), en = ee(/* @__PURE__ */ new Map());
let uu = 1e3;
const Xd = () => {
  const e = T(() => (f) => en.value.get(f)), n = T(() => (f) => {
    const p = en.value.get(f);
    return p ? p.isOpen : !1;
  }), t = T(() => (f) => {
    const p = en.value.get(f);
    return p ? p.zIndex : 1e3;
  }), a = T(() => Array.from(en.value.values()).filter((f) => f.isOpen)), s = T(() => a.value.length > 0), l = (f) => {
    en.value.has(f) || en.value.set(f, {
      id: f,
      isOpen: !1,
      zIndex: 1e3
    });
  }, r = (f) => {
    en.value.delete(f);
  }, i = (f) => {
    l(f);
    const p = en.value.get(f);
    p && (uu += 10, p.zIndex = uu, p.isOpen = !0);
  }, o = (f) => {
    const p = en.value.get(f);
    p && (p.isOpen = !1);
  };
  return {
    modals: en,
    getModal: e,
    isOpen: n,
    getZIndex: t,
    openModals: a,
    hasOpenModals: s,
    register: l,
    unregister: r,
    open: i,
    close: o,
    toggle: (f) => {
      const p = en.value.get(f);
      p && (p.isOpen ? o(f) : i(f));
    },
    closeAll: () => {
      en.value.forEach((f) => {
        f.isOpen = !1;
      });
    }
  };
}, Zl = (e, n = !0) => {
  const t = Xd();
  t.register(e);
  const a = T(() => t.isOpen.value(e)), s = T(() => t.getZIndex.value(e)), l = T(() => t.getModal.value(e)), r = () => t.open(e), i = () => t.close(e), o = () => t.toggle(e);
  return n && Fs(() => {
    t.unregister(e);
  }), {
    isOpen: a,
    zIndex: s,
    modal: l,
    open: r,
    close: i,
    toggle: o
  };
}, cu = { duration: 200, easing: "cubic-bezier(0, 0, 0.2, 1)" }, du = { duration: 160, easing: "cubic-bezier(0.4, 0, 1, 1)" }, ul = 0, Tr = () => {
  const { innerWidth: e, innerHeight: n } = window;
  return {
    top: n * ul,
    left: e * ul,
    width: e * (1 - 2 * ul),
    height: n * (1 - 2 * ul)
  };
}, fu = (e) => e instanceof HTMLElement ? e : void 0, sx = (e) => {
  var t;
  const n = fu(e);
  return n ? n.offsetHeight : ((t = fu(e == null ? void 0 : e.$el)) == null ? void 0 : t.offsetHeight) ?? 0;
}, ni = "v-table-fullscreen", ws = ee(!1);
let $r = null;
const hu = (e, n, t) => {
  const a = n.width / t.width, s = n.height / t.height, l = n.left - t.left, r = n.top - t.top;
  e.style.transformOrigin = "top left", e.style.transform = `translate(${l}px, ${r}px) scale(${a}, ${s})`;
}, lx = (e) => {
  const { wrapperRef: n, placeholderRef: t } = e, a = ee(!1), s = ee(null), l = ee(null), r = ee(0);
  let i = null, o = null, u = 0, c = !1;
  const { zIndex: f, open: p, close: d } = Zl(ni, !1), b = Xd(), m = () => {
    r.value = (e.chromeRefs ?? []).reduce((D, B) => D + sx(B.value), 0);
  }, k = async () => {
    const D = n.value;
    if (!D) return;
    const B = ++u, Y = D.getBoundingClientRect();
    s.value = Y, l.value = Tr(), m();
    const ne = window.scrollX, W = window.scrollY;
    if (a.value = !0, await Ge(), B !== u) return;
    (window.scrollX !== ne || window.scrollY !== W) && window.scrollTo({ left: ne, top: W, behavior: "instant" }), D.style.transition = "none";
    const ae = D.getBoundingClientRect();
    hu(D, Y, ae), D.offsetHeight, D.style.transition = `transform ${cu.duration}ms ${cu.easing}`, D.style.transform = "translate(0, 0) scale(1, 1)";
    const G = (j) => {
      j.target !== D || j.propertyName !== "transform" || (D.removeEventListener("transitionend", G), o = null, D.style.transform = "", D.style.transition = "", D.style.transformOrigin = "");
    };
    o = { el: D, handler: G }, D.addEventListener("transitionend", G);
  }, y = async () => {
    var j;
    const D = n.value;
    if (!D) return;
    const B = ++u, Y = window.scrollX, ne = window.scrollY;
    if (await Ge(), B !== u) return;
    (window.scrollX !== Y || window.scrollY !== ne) && window.scrollTo({ left: Y, top: ne, behavior: "instant" }), o && (o.el.removeEventListener("transitionend", o.handler), o = null), i && (i.el.removeEventListener("transitionend", i.handler), i = null);
    const W = D.getBoundingClientRect(), ae = ((j = t == null ? void 0 : t.value) == null ? void 0 : j.getBoundingClientRect()) ?? s.value ?? W;
    D.style.transition = `transform ${du.duration}ms ${du.easing}`, hu(D, ae, W);
    const G = (se) => {
      se.target !== D || se.propertyName !== "transform" || (D.removeEventListener("transitionend", G), i = null, a.value = !1, D.style.transform = "", D.style.transition = "", D.style.transformOrigin = "");
    };
    i = { el: D, handler: G }, D.addEventListener("transitionend", G);
  }, h = () => {
    a.value ? y() : k();
  }, g = () => {
    a.value && y();
  };
  Le(a, (D) => {
    D ? p() : c || d();
  });
  const x = (D) => {
    D.key !== "Escape" || !a.value || Math.max(
      0,
      ...b.openModals.value.filter((Y) => Y.id !== ni).map((Y) => Y.zIndex)
    ) > f.value || h();
  };
  Le(a, (D) => {
    D ? window.addEventListener("keydown", x) : window.removeEventListener("keydown", x);
  });
  const S = () => {
    a.value && (l.value = Tr(), m());
  };
  Le(a, (D) => {
    D ? window.addEventListener("resize", S) : window.removeEventListener("resize", S);
  }), Le(a, async (D) => {
    var B;
    await Ge(), await ((B = e.onToggle) == null ? void 0 : B.call(e, D));
  });
  const C = () => {
    m(), s.value = $r, l.value = Tr(), a.value = !0;
  };
  Au(() => {
    a.value && (c = !0, l.value = null, a.value = !1, u += 1, o && (o.el.removeEventListener("transitionend", o.handler), o = null), i && (i.el.removeEventListener("transitionend", i.handler), i = null), ws.value = !0, $r = s.value, Ge().then(() => {
      c = !1, ws.value && (ws.value = !1, $r = null, d());
    }));
  }), Pu(() => {
    ws.value && Qe(e.isEnabled) && (ws.value = !1, C());
  }), Xt(() => {
    a.value && d(), window.removeEventListener("keydown", x), window.removeEventListener("resize", S), i && (i.el.removeEventListener("transitionend", i.handler), i = null), o && (o.el.removeEventListener("transitionend", o.handler), o = null);
  });
  const _ = T(() => !a.value || !s.value ? null : {
    width: `${s.value.width}px`,
    height: `${s.value.height}px`
  }), O = T(() => {
    if (!a.value || !l.value) return null;
    const { top: D, left: B, width: Y, height: ne } = l.value;
    return {
      top: `${D}px`,
      left: `${B}px`,
      width: `${Y}px`,
      height: `${ne}px`
    };
  }), I = T(() => !a.value || !l.value ? 0 : l.value.height - r.value);
  return {
    isFullscreen: li(a),
    isEnabled: T(() => Qe(e.isEnabled)),
    zIndex: f,
    placeholderStyle: _,
    panelStyle: O,
    contentHeight: I,
    toggle: h,
    close: g
  };
}, rx = { class: "v-bulk-action-bar__count" }, ix = { class: "v-bulk-action-bar__badge" }, ox = /* @__PURE__ */ ke({
  __name: "VBulkActionBar",
  props: /* @__PURE__ */ Yt({
    items: {},
    clearOn: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Yt(["clear"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = En(e, "modelValue"), a = n, { isOpen: s, zIndex: l } = Zl(
      ni,
      !1
    ), r = T(() => t.value.length), i = T(() => r.value > 0), o = T(() => {
      var b;
      return ((b = e.items) == null ? void 0 : b.length) ?? null;
    }), u = T(
      () => o.value !== null && r.value < o.value
    ), c = T(() => s.value ? l.value + 2 : 50), f = T(() => JSON.stringify(e.clearOn ?? null)), p = () => {
      t.value = [], a("clear");
    }, d = () => {
      e.items && (t.value = [...e.items]);
    };
    return Le(f, () => {
      r.value && p();
    }), (b, m) => (w(), ue(Pn, { to: "body" }, [
      ie(ht, { name: "v-bulk-action-bar" }, {
        default: ce(() => [
          i.value ? (w(), M("div", {
            key: 0,
            style: Fe({ zIndex: c.value }),
            class: "v-bulk-action-bar"
          }, [
            E("div", rx, [
              E("span", ix, re(r.value), 1),
              m[0] || (m[0] = E("span", { class: "v-bulk-action-bar__label" }, "selected", -1))
            ]),
            u.value ? (w(), M("button", {
              key: 0,
              class: "v-bulk-action-bar__select-all",
              type: "button",
              onClick: d
            }, " Select all " + re(o.value), 1)) : R("", !0),
            m[1] || (m[1] = E("div", { class: "v-bulk-action-bar__divider" }, null, -1)),
            H(b.$slots, "actions", {}, void 0, !0),
            E("button", {
              "aria-label": "Clear selection",
              class: "v-bulk-action-bar__clear",
              type: "button",
              onClick: p
            }, [
              ie(be, {
                size: 16,
                icon: "lucide:x"
              })
            ])
          ], 4)) : R("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), gD = /* @__PURE__ */ ze(ox, [["__scopeId", "data-v-ecadfb85"]]), ux = ["data-overlay-open"], cx = {
  key: 0,
  class: "v-drawer__header"
}, dx = {
  key: 0,
  class: "v-drawer__title"
}, fx = {
  key: 1,
  fill: "none",
  height: "24",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, hx = { class: "v-drawer__content" }, mx = {
  key: 1,
  class: "v-drawer__footer"
}, vx = /* @__PURE__ */ ke({
  __name: "VDrawer",
  props: {
    id: {},
    title: { default: "" },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    position: { default: "right" },
    width: { default: "md" },
    backdropBlur: { default: "xs" },
    keepAlive: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["close", "open"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: s, close: l, zIndex: r } = Zl(t.id), i = T(() => `v-drawer__container--width-${t.width}`), o = T(() => `v-drawer__container--${t.position}`), u = T(() => t.backdropBlur === "none" ? "" : `v-drawer__backdrop--blur-${t.backdropBlur}`), c = () => {
      l(), a("close");
    }, f = () => {
      t.closeOnBackdrop && c();
    }, p = (d) => {
      t.closeOnEscape && d.key === "Escape" && c();
    };
    return (d, b) => (w(), ue(Pn, { to: "body" }, [
      ie(ht, {
        name: "v-drawer",
        onAfterEnter: b[1] || (b[1] = (m) => a("open"))
      }, {
        default: ce(() => [
          e.keepAlive || v(s) ? an((w(), M("div", {
            key: 0,
            class: q([[u.value, { "v-drawer--modern": e.modern }], "v-drawer__backdrop"]),
            "data-overlay-open": v(s) || void 0,
            style: Fe({ zIndex: v(r) }),
            onClick: f,
            onKeydown: p
          }, [
            E("div", {
              class: q([[i.value, o.value], "v-drawer__container"]),
              onClick: b[0] || (b[0] = Ve(() => {
              }, ["stop"]))
            }, [
              e.title || e.showCloseButton || d.$slots.header ? (w(), M("div", cx, [
                H(d.$slots, "header", {}, () => [
                  e.title ? (w(), M("h3", dx, re(e.title), 1)) : R("", !0)
                ], !0),
                e.showCloseButton ? (w(), M("button", {
                  key: 0,
                  "aria-label": "Close drawer",
                  class: "v-drawer__close-btn",
                  type: "button",
                  onClick: c
                }, [
                  e.modern ? (w(), ue(be, {
                    key: 0,
                    size: 16,
                    icon: "lucide:x"
                  })) : (w(), M("svg", fx, [...b[2] || (b[2] = [
                    E("line", {
                      x1: "18",
                      x2: "6",
                      y1: "6",
                      y2: "18"
                    }, null, -1),
                    E("line", {
                      x1: "6",
                      x2: "18",
                      y1: "6",
                      y2: "18"
                    }, null, -1)
                  ])]))
                ])) : R("", !0)
              ])) : R("", !0),
              E("div", hx, [
                H(d.$slots, "default", {}, void 0, !0)
              ]),
              d.$slots.footer ? (w(), M("div", mx, [
                H(d.$slots, "footer", {}, void 0, !0)
              ])) : R("", !0)
            ], 2)
          ], 46, ux)), [
            [Bn, e.keepAlive ? v(s) : !0]
          ]) : R("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), yD = /* @__PURE__ */ ze(vx, [["__scopeId", "data-v-5a5b6aa2"]]), px = { class: "v-floating" }, gx = ["disabled", "onClick"], yx = {
  key: 0,
  class: "v-floating-item-icon"
}, bx = { class: "v-floating-item-label" }, wx = 120, kx = /* @__PURE__ */ ke({
  __name: "VFloating",
  props: {
    placement: { default: "bottom-right" },
    teleport: { type: Boolean, default: !0 },
    closeOnClickOutside: { type: Boolean, default: !0 },
    offset: { default: 8 },
    openOnHover: { type: Boolean, default: !1 },
    hoverDelay: { default: 200 },
    items: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    closeOnSelect: { type: Boolean, default: !0 },
    unstyled: { type: Boolean, default: !1 },
    contentClass: { default: "" }
  },
  emits: ["select"],
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, l = ee(!1), r = ee(null), i = ee(null), o = ee({ top: 0, left: 0, right: 0 }), u = ee(!1);
    let c = !1, f = null;
    function p() {
      !l.value || !i.value || c || (c = !0, requestAnimationFrame(() => {
        c = !1, y();
      }));
    }
    const d = T(() => a.items.length > 0), b = T(() => a.disabled), m = T(() => {
      const we = a.placement, X = {
        "v-floating--bottom-left": we === "bottom-left",
        "v-floating--bottom-right": we === "bottom-right",
        "v-floating--top-left": we === "top-left",
        "v-floating--top-right": we === "top-right",
        "v-floating--teleported": a.teleport
      };
      return a.unstyled ? {
        ...X,
        "v-floating--unstyled": !0,
        [a.contentClass]: !!a.contentClass
      } : {
        ...X,
        "v-floating--dropdown": d.value,
        "v-floating--popover": !d.value,
        "v-floating--styled": !0,
        [a.contentClass]: !!a.contentClass
      };
    }), k = T(() => a.teleport ? u.value ? {
      position: "fixed",
      zIndex: "9999",
      top: `${o.value.top}px`,
      left: o.value.left !== void 0 ? `${o.value.left}px` : void 0,
      right: o.value.right !== void 0 ? `${o.value.right}px` : void 0
      // Prevent following scroll by using fixed positioning as-is
      // The dropdown will stay in place relative to viewport, not following the trigger
    } : {} : {}), y = () => {
      if (!(!r.value || !i.value)) {
        if (a.teleport) {
          const we = r.value.getBoundingClientRect(), X = i.value.offsetWidth, ve = i.value.offsetHeight, [Ce, V] = a.placement.split("-"), Z = a.offset;
          let me;
          Ce === "bottom" ? me = we.bottom + Z : me = we.top - ve - Z;
          let K;
          V === "left" ? K = we.left : K = we.right - X, o.value.top = me, o.value.left = K, o.value.right = void 0;
        } else
          o.value.top = 0, o.value.left = 0;
        u.value = !0;
      }
    }, h = () => {
      b.value || (l.value = !l.value, l.value ? (u.value = !1, Ge(() => {
        i.value && r.value && (y(), ge());
      })) : $e());
    }, g = () => {
      l.value && (l.value = !1, u.value = !1, $e());
    }, x = () => {
      b.value || l.value || (l.value = !0, u.value = !1, Ge(() => {
        i.value && r.value && (y(), ge());
      }));
    }, S = typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    let C = null, _ = null;
    const O = () => {
      C && (clearTimeout(C), C = null);
    }, I = () => {
      _ && (clearTimeout(_), _ = null);
    }, D = () => {
      O(), I();
    }, B = () => {
      I(), !l.value && (O(), C = setTimeout(() => {
        C = null, x();
      }, a.hoverDelay));
    }, Y = () => {
      D(), _ = setTimeout(() => {
        _ = null, g();
      }, wx);
    }, ne = () => {
      !a.openOnHover || !S || B();
    }, W = () => {
      !a.openOnHover || !S || Y();
    }, ae = () => {
      !a.openOnHover || !S || I();
    }, G = () => {
      !a.openOnHover || !S || Y();
    }, j = () => {
      a.openOnHover && (D(), x());
    }, se = () => {
      a.openOnHover && (D(), g());
    }, U = (we) => {
      we.disabled || we.loading || (s("select", we.value), a.closeOnSelect && !we.loading && g());
    }, N = (we) => {
      we.key === "Escape" && l.value && g();
    }, J = (we) => {
      if (!a.closeOnClickOutside || !l.value) return;
      const X = we.composedPath(), ve = r.value && X.includes(r.value), Ce = i.value && X.includes(i.value);
      !ve && !Ce && g();
    };
    et(() => {
      document.addEventListener("click", J, !0);
    }), Fs(() => {
      document.removeEventListener("click", J, !0), $e(), D();
    });
    const de = () => {
      !l.value || !a.teleport || p();
    }, he = () => {
      !l.value || !a.teleport || p();
    };
    function ge() {
      a.teleport && (window.addEventListener("scroll", de, {
        passive: !0,
        capture: !0
      }), window.addEventListener("resize", he, { passive: !0 }), r.value && (f = new ResizeObserver(() => p()), f.observe(r.value)), document.addEventListener("keydown", N));
    }
    function $e() {
      window.removeEventListener("scroll", de, { capture: !0 }), window.removeEventListener("resize", he), document.removeEventListener("keydown", N), f && (f.disconnect(), f = null);
    }
    return n({
      isOpen: l,
      open: x,
      close: g,
      toggle: h
    }), (we, X) => (w(), M("div", px, [
      E("div", {
        ref_key: "triggerRef",
        ref: r,
        class: q([{ "v-floating-trigger--disabled": b.value }, "v-floating-trigger"]),
        onClick: h,
        onFocusin: j,
        onFocusout: se,
        onMouseenter: ne,
        onMouseleave: W
      }, [
        H(we.$slots, "trigger", {
          isDisabled: b.value,
          isOpen: l.value
        }, void 0, !0)
      ], 34),
      (w(), ue(Pn, {
        disabled: !e.teleport,
        to: "body"
      }, [
        l.value ? (w(), M("div", {
          key: 0,
          ref_key: "floatingRef",
          ref: i,
          class: q([[
            m.value,
            { "v-floating--positioning": !u.value }
          ], "v-floating-content"]),
          style: Fe(k.value),
          onMouseenter: ae,
          onMouseleave: G
        }, [
          H(we.$slots, "content", { close: g }, () => [
            d.value ? (w(!0), M(Te, { key: 0 }, Ie(e.items, (ve) => (w(), M("button", {
              key: ve.value,
              class: q([{
                "v-floating-item--loading": ve.loading,
                "v-floating-item--active": ve.active,
                "v-floating-item--disabled": ve.disabled
              }, "v-floating-item"]),
              disabled: ve.disabled || ve.loading,
              onClick: (Ce) => U(ve)
            }, [
              H(we.$slots, "item-icon", { item: ve }, () => [
                ve.icon ? (w(), M("span", yx, [
                  ie(be, {
                    icon: ve.icon,
                    loading: ve.loading,
                    size: 16
                  }, null, 8, ["icon", "loading"])
                ])) : R("", !0)
              ], !0),
              E("span", bx, re(ve.label), 1)
            ], 10, gx))), 128)) : R("", !0)
          ], !0)
        ], 38)) : R("", !0)
      ], 8, ["disabled"]))
    ]));
  }
}), Rs = /* @__PURE__ */ ze(kx, [["__scopeId", "data-v-66563b51"]]), xx = ["data-overlay-open"], Sx = {
  key: 0,
  class: "modal-header"
}, Tx = {
  key: 0,
  class: "modal-heading"
}, $x = {
  key: 0,
  class: "modal-title"
}, Mx = {
  key: 0,
  class: "modal-description"
}, Cx = {
  key: 0,
  class: "modal-title"
}, Dx = {
  key: 1,
  fill: "none",
  height: "24",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, Ox = { class: "modal-content" }, _x = {
  key: 1,
  class: "modal-footer"
}, Ex = {
  key: 0,
  class: "modal-footer-actions"
}, Ix = /* @__PURE__ */ ke({
  __name: "VModal",
  props: {
    id: {},
    title: { default: "" },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    maxWidth: { default: "md" },
    footerActions: { type: [Boolean, Object], default: void 0 },
    loading: { type: Boolean },
    description: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["close", "open", "confirm"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: s, close: l, zIndex: r } = Zl(t.id), i = T(() => `modal-container--${t.maxWidth}`), o = {
      confirmText: "Confirm",
      cancelText: "Cancel",
      confirmVariant: "primary",
      cancelVariant: "default",
      showConfirm: !0,
      showCancel: !0
    }, u = T(() => t.footerActions ? t.footerActions === !0 ? o : { ...o, ...t.footerActions } : null), c = () => {
      l(), a("close");
    }, f = () => {
      t.closeOnBackdrop && c();
    }, p = (d) => {
      t.closeOnEscape && d.key === "Escape" && c();
    };
    return (d, b) => (w(), ue(Pn, { to: "body" }, [
      ie(ht, {
        name: e.modern ? "modal-modern" : "modal",
        onAfterEnter: b[2] || (b[2] = (m) => a("open"))
      }, {
        default: ce(() => [
          v(s) ? (w(), M("div", {
            key: 0,
            class: q([{ "modal-backdrop--modern": e.modern }, "modal-backdrop"]),
            "data-overlay-open": v(s) || void 0,
            style: Fe({ zIndex: v(r) }),
            onClick: f,
            onKeydown: p
          }, [
            E("div", {
              class: q([i.value, "modal-container"]),
              onClick: b[1] || (b[1] = Ve(() => {
              }, ["stop"]))
            }, [
              e.title || e.showCloseButton || d.$slots.header ? (w(), M("div", Sx, [
                e.modern ? (w(), M("div", Tx, [
                  H(d.$slots, "header", {}, () => [
                    e.title ? (w(), M("h3", $x, re(e.title), 1)) : R("", !0)
                  ], !0),
                  e.description ? (w(), M("p", Mx, re(e.description), 1)) : R("", !0)
                ])) : H(d.$slots, "header", { key: 1 }, () => [
                  e.title ? (w(), M("h3", Cx, re(e.title), 1)) : R("", !0)
                ], !0),
                e.showCloseButton ? (w(), M("button", {
                  key: 2,
                  "aria-label": "Close modal",
                  class: "modal-close-btn",
                  type: "button",
                  onClick: c
                }, [
                  e.modern ? (w(), ue(be, {
                    key: 0,
                    size: 16,
                    icon: "lucide:x"
                  })) : (w(), M("svg", Dx, [...b[3] || (b[3] = [
                    E("line", {
                      x1: "18",
                      x2: "6",
                      y1: "6",
                      y2: "18"
                    }, null, -1),
                    E("line", {
                      x1: "6",
                      x2: "18",
                      y1: "6",
                      y2: "18"
                    }, null, -1)
                  ])]))
                ])) : R("", !0)
              ])) : R("", !0),
              E("div", Ox, [
                H(d.$slots, "default", {}, void 0, !0)
              ]),
              d.$slots.footer || u.value ? (w(), M("div", _x, [
                H(d.$slots, "footer", {}, () => [
                  u.value ? (w(), M("div", Ex, [
                    u.value.showCancel ? (w(), ue(_t, {
                      key: 0,
                      disabled: t.loading,
                      modern: t.modern,
                      variant: u.value.cancelVariant,
                      type: "button",
                      onClick: c
                    }, {
                      default: ce(() => [
                        He(re(u.value.cancelText), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "modern", "variant"])) : R("", !0),
                    u.value.showConfirm ? (w(), ue(_t, {
                      key: 1,
                      loading: t.loading,
                      modern: t.modern,
                      variant: u.value.confirmVariant,
                      type: "button",
                      onClick: b[0] || (b[0] = (m) => a("confirm"))
                    }, {
                      default: ce(() => [
                        He(re(u.value.confirmText), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "modern", "variant"])) : R("", !0)
                  ])) : R("", !0)
                ], !0)
              ])) : R("", !0)
            ], 2)
          ], 46, xx)) : R("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), bD = /* @__PURE__ */ ze(Ix, [["__scopeId", "data-v-429bb3b1"]]), Ax = (e) => {
  const n = Vu(), t = ee(!0), a = ee(!1), s = ee(null), l = () => t.value && Qe((e == null ? void 0 : e.when) ?? !0);
  Cf((c) => c.meta.requiresAuth === !1 || !l() ? !0 : (a.value = !0, s.value = c, !1)), Le(
    [() => Qe((e == null ? void 0 : e.when) ?? !0), t],
    ([c, f]) => {
      (!c || !f) && a.value && i();
    }
  );
  const r = () => {
    if (!s.value) return;
    const c = s.value;
    t.value = !1, a.value = !1, s.value = null, n.push(c).finally(() => {
      t.value = !0;
    });
  }, i = () => {
    a.value = !1, s.value = null;
  };
  return { isPending: a, pendingTo: s, isEnabled: t, confirm: r, cancel: i, enable: () => {
    t.value = !0;
  }, disable: () => {
    t.value = !1;
  } };
}, Px = ["aria-label"], Rx = {
  key: 0,
  class: "unsaved-changes__card mx-4 flex w-full max-w-sm overflow-hidden rounded-xl"
}, Fx = { class: "flex flex-1 flex-col p-5" }, Vx = { class: "flex items-start gap-3" }, Lx = { class: "min-w-0 flex-1" }, Nx = { class: "mb-1 text-sm font-semibold leading-snug text-mainText" }, zx = { class: "text-xs leading-relaxed text-secondaryText" }, Bx = { class: "mt-4 flex items-center justify-end gap-2 border-t border-base-300 pt-4" }, Wx = /* @__PURE__ */ ke({
  __name: "VUnsavedChangesModal",
  props: {
    open: { type: Boolean, default: !1 },
    title: { default: "Unsaved changes" },
    description: { default: "Leaving now will discard your changes. This cannot be undone." },
    confirmLabel: { default: "Keep editing" },
    leaveLabel: { default: "Discard & leave" },
    zIndex: { default: 50 }
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: n }) {
    const t = n, a = Xe("dialog");
    return Le(() => e.open, (s) => {
      s && Ge(() => {
        var l;
        return (l = a.value) == null ? void 0 : l.focus();
      });
    }), (s, l) => (w(), ue(Pn, { to: "body" }, [
      ie(ht, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: ce(() => [
          e.open ? (w(), M("div", {
            key: 0,
            ref: "dialog",
            "aria-label": e.title,
            style: Fe({ "--_z-index": e.zIndex }),
            "aria-modal": "true",
            class: "unsaved-changes__backdrop fixed inset-0 flex items-center justify-center",
            role: "dialog",
            tabindex: "-1",
            onClick: l[3] || (l[3] = Ve((r) => t("cancel"), ["self"])),
            onKeydown: l[4] || (l[4] = Vt((r) => t("cancel"), ["esc"]))
          }, [
            ie(ht, {
              appear: "",
              "enter-active-class": "transition duration-200 ease-out",
              "enter-from-class": "opacity-0 scale-95 -translate-y-2",
              "enter-to-class": "opacity-100 scale-100 translate-y-0",
              "leave-active-class": "transition duration-150 ease-in",
              "leave-from-class": "opacity-100 scale-100 translate-y-0",
              "leave-to-class": "opacity-0 scale-95 -translate-y-2"
            }, {
              default: ce(() => [
                e.open ? (w(), M("div", Rx, [
                  l[7] || (l[7] = E("div", { class: "w-1 flex-shrink-0 bg-gradient-to-b from-warning via-warning/60 to-warning/10" }, null, -1)),
                  E("div", Fx, [
                    E("div", Vx, [
                      l[6] || (l[6] = E("div", { class: "mt-0.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border border-warning-200 bg-warning-50" }, [
                        E("svg", {
                          "aria-hidden": "true",
                          class: "h-4 w-4 text-warning",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2.2",
                          viewBox: "0 0 24 24"
                        }, [
                          E("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" }),
                          E("path", { d: "M12 9v4" }),
                          E("path", { d: "M12 17h.01" })
                        ])
                      ], -1)),
                      E("div", Lx, [
                        E("h2", Nx, re(e.title), 1),
                        E("div", zx, [
                          H(s.$slots, "description", {}, () => [
                            He(re(e.description), 1)
                          ], !0)
                        ])
                      ]),
                      E("button", {
                        "aria-label": "Cancel and keep editing",
                        class: "-mr-1 -mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md text-secondaryText transition-colors hover:bg-base-200",
                        type: "button",
                        onClick: l[0] || (l[0] = (r) => t("cancel"))
                      }, [...l[5] || (l[5] = [
                        E("svg", {
                          "aria-hidden": "true",
                          class: "h-3.5 w-3.5",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          viewBox: "0 0 24 24"
                        }, [
                          E("path", { d: "M18 6 6 18M6 6l12 12" })
                        ], -1)
                      ])])
                    ]),
                    E("div", Bx, [
                      E("button", {
                        class: "h-8 rounded-md border border-error/25 bg-transparent px-3 text-xs text-error transition-all hover:border-error/40 hover:bg-error/5 active:scale-95",
                        type: "button",
                        onClick: l[1] || (l[1] = (r) => t("confirm"))
                      }, re(e.leaveLabel), 1),
                      E("button", {
                        class: "h-8 rounded-md border-2 border-primary bg-primary px-4 text-xs text-white shadow-sm transition-all hover:border-primary-dark hover:bg-primary-dark active:scale-95",
                        type: "button",
                        onClick: l[2] || (l[2] = (r) => t("cancel"))
                      }, re(e.confirmLabel), 1)
                    ])
                  ])
                ])) : R("", !0)
              ]),
              _: 3
            })
          ], 44, Px)) : R("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Yx = /* @__PURE__ */ ze(Wx, [["__scopeId", "data-v-4050f9cd"]]), wD = /* @__PURE__ */ ke({
  __name: "NavigationGuardModal",
  props: {
    when: {},
    title: { default: "Unsaved changes" },
    description: { default: "Leaving now will discard your changes. This cannot be undone." },
    confirmLabel: { default: "Keep editing" },
    leaveLabel: { default: "Discard & leave" }
  },
  setup(e) {
    const { isPending: n, confirm: t, cancel: a } = Ax({ when: () => Qe(e.when) });
    return (s, l) => (w(), ue(Yx, {
      "confirm-label": e.confirmLabel,
      description: e.description,
      "leave-label": e.leaveLabel,
      open: v(n),
      title: e.title,
      onCancel: v(a),
      onConfirm: v(t)
    }, dt({ _: 2 }, [
      s.$slots.description ? {
        name: "description",
        fn: ce(() => [
          H(s.$slots, "description")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["confirm-label", "description", "leave-label", "open", "title", "onCancel", "onConfirm"]));
  }
}), Hx = { class: "v-meter" }, Ux = ["aria-valuemax", "aria-valuenow"], qx = /* @__PURE__ */ ke({
  __name: "VMeter",
  props: {
    value: {},
    max: {},
    goal: { default: "reach" },
    label: {},
    hint: {},
    pending: { type: Boolean, default: !1 },
    size: { default: "sm" }
  },
  setup(e) {
    const n = T(() => e.value !== null), t = T(() => e.value === null ? !1 : e.goal === "reach" ? e.value >= e.max : e.value <= e.max), a = T(() => e.value === null || e.max <= 0 ? 0 : Math.min(1, e.value / e.max)), s = T(() => e.value === null ? "Not measured" : `${e.value.toLocaleString("en-US")} / ${e.max.toLocaleString("en-US")}`), l = T(() => n.value ? t.value ? "lucide:circle-check" : "lucide:triangle-alert" : "lucide:circle-help");
    return (r, i) => (w(), M("div", Hx, [
      n.value || e.pending ? (w(), M("div", {
        key: 0,
        class: q([`v-meter__track--${e.size}`, "v-meter__track"])
      }, [
        E("div", {
          "aria-valuemax": e.max,
          "aria-valuenow": e.value ?? void 0,
          class: q([t.value ? "v-meter__fill--met" : "v-meter__fill--unmet", "v-meter__fill"]),
          style: Fe({ "--v-meter-fill": a.value }),
          "aria-valuemin": "0",
          role: "meter"
        }, null, 14, Ux)
      ], 2)) : R("", !0),
      ie(xa, {
        disabled: !e.hint,
        text: e.hint ?? ""
      }, {
        default: ce(() => [
          E("span", {
            class: q([{ "v-meter__value--pending": e.pending, "v-meter__value--help": !!e.hint }, "v-meter__value"])
          }, [
            e.pending ? (w(), ue(be, {
              key: 0,
              loading: !0,
              size: 14,
              icon: "lucide:loading"
            })) : (w(), ue(be, {
              key: 1,
              class: q(n.value ? t.value ? "v-meter__icon--met" : "v-meter__icon--unmet" : ""),
              icon: l.value,
              size: 14
            }, null, 8, ["class", "icon"])),
            H(r.$slots, "label", {}, () => [
              He(re(e.label ?? s.value), 1)
            ], !0)
          ], 2)
        ]),
        _: 3
      }, 8, ["disabled", "text"])
    ]));
  }
}), kD = /* @__PURE__ */ ze(qx, [["__scopeId", "data-v-f009ff9b"]]), jx = {
  key: 0,
  class: "v-progress-bar__header"
}, Gx = {
  key: 0,
  class: "v-progress-bar__step"
}, Kx = { key: 1 }, Zx = {
  key: 2,
  class: "v-progress-bar__percentage"
}, Xx = {
  key: 0,
  class: "v-progress-bar__shine"
}, Jx = /* @__PURE__ */ ke({
  __name: "VProgressBar",
  props: {
    percentage: {},
    step: { default: null },
    size: { default: "md" },
    showPercentage: { type: Boolean, default: !0 },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = T(() => Math.max(0, Math.min(100, n.percentage))), a = T(() => t.value >= 100), s = T(() => ({ sm: "4px", md: "6px", lg: "8px" })[n.size]);
    return (l, r) => (w(), M("div", {
      class: q([{ "v-progress-bar--modern": n.modern }, "v-progress-bar"])
    }, [
      e.step || e.showPercentage ? (w(), M("div", jx, [
        e.step ? (w(), M("span", Gx, re(e.step), 1)) : (w(), M("span", Kx)),
        e.showPercentage ? (w(), M("div", Zx, [
          E("span", {
            class: q({ "text-success": a.value })
          }, re(Math.round(t.value)) + "% ", 3),
          a.value ? (w(), ue(be, {
            key: 0,
            size: 14,
            class: "text-success ml-1",
            icon: "lucide:check-circle"
          })) : R("", !0)
        ])) : R("", !0)
      ])) : R("", !0),
      E("div", {
        style: Fe({ height: s.value }),
        class: "v-progress-bar__track"
      }, [
        E("div", {
          class: q([{ "v-progress-bar__fill--completed": a.value }, "v-progress-bar__fill"]),
          style: Fe({ width: `${t.value}%` })
        }, [
          a.value ? R("", !0) : (w(), M("div", Xx))
        ], 6)
      ], 4)
    ], 2));
  }
}), xD = /* @__PURE__ */ ze(Jx, [["__scopeId", "data-v-7cb5a7fb"]]), Qx = ["aria-checked", "aria-label", "title", "onClick"], eS = /* @__PURE__ */ ke({
  __name: "VThemeToggle",
  props: /* @__PURE__ */ Yt({
    compact: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = En(e, "modelValue"), t = [
      { value: "light", icon: "lucide:sun", label: "Light theme" },
      { value: "dark", icon: "lucide:moon", label: "Dark theme" }
    ], a = (s) => {
      n.value !== s && (n.value = s);
    };
    return (s, l) => (w(), M("div", {
      class: q([{ "theme-toggle--compact": e.compact, "theme-toggle--dark": n.value === "dark" }, "theme-toggle"]),
      "aria-label": "Theme",
      role: "radiogroup"
    }, [
      l[0] || (l[0] = E("span", {
        "aria-hidden": "true",
        class: "theme-toggle__thumb"
      }, null, -1)),
      (w(), M(Te, null, Ie(t, (r) => E("button", {
        key: r.value,
        "aria-checked": n.value === r.value,
        "aria-label": r.label,
        class: q([{ "theme-toggle__option--active": n.value === r.value }, "theme-toggle__option"]),
        title: r.label,
        role: "radio",
        type: "button",
        onClick: (i) => a(r.value)
      }, [
        ie(be, {
          icon: r.icon,
          size: 14
        }, null, 8, ["icon"])
      ], 10, Qx)), 64))
    ], 2));
  }
}), SD = /* @__PURE__ */ ze(eS, [["__scopeId", "data-v-7284576c"]]);
let ai = 1;
var tS = class {
  constructor() {
    xe(this, "subscribers");
    xe(this, "toasts");
    xe(this, "dismissedToasts");
    xe(this, "subscribe", (e) => (this.subscribers.push(e), () => {
      const n = this.subscribers.indexOf(e);
      this.subscribers.splice(n, 1);
    }));
    xe(this, "publish", (e) => {
      this.subscribers.forEach((n) => n(e));
    });
    xe(this, "addToast", (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    });
    xe(this, "create", (e) => {
      var r;
      const { message: n, ...t } = e, a = typeof e.id == "number" || e.id && ((r = e.id) == null ? void 0 : r.length) > 0 ? e.id : ai++, s = this.toasts.find((i) => i.id === a), l = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(a) && this.dismissedToasts.delete(a), s ? this.toasts = this.toasts.map((i) => i.id === a ? (this.publish({
        ...i,
        ...e,
        id: a,
        title: n
      }), {
        ...i,
        ...e,
        id: a,
        dismissible: l,
        title: n
      }) : i) : this.addToast({
        title: n,
        ...t,
        dismissible: l,
        id: a
      }), a;
    });
    xe(this, "dismiss", (e) => (e ? (this.dismissedToasts.add(e), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: e,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((t) => t({
        id: n.id,
        dismiss: !0
      }));
    }), e));
    xe(this, "message", (e, n) => this.create({
      ...n,
      message: e,
      type: "default"
    }));
    xe(this, "error", (e, n) => this.create({
      ...n,
      type: "error",
      message: e
    }));
    xe(this, "success", (e, n) => this.create({
      ...n,
      type: "success",
      message: e
    }));
    xe(this, "info", (e, n) => this.create({
      ...n,
      type: "info",
      message: e
    }));
    xe(this, "warning", (e, n) => this.create({
      ...n,
      type: "warning",
      message: e
    }));
    xe(this, "loading", (e, n) => this.create({
      ...n,
      type: "loading",
      message: e
    }));
    xe(this, "promise", (e, n) => {
      if (!n) return;
      let t;
      n.loading !== void 0 && (t = this.create({
        ...n,
        promise: e,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const a = Promise.resolve(e instanceof Function ? e() : e);
      let s = t !== void 0, l;
      const r = a.then(async (o) => {
        if (l = ["resolve", o], fs(o))
          s = !1, this.create({
            id: t,
            type: "default",
            message: o
          });
        else if (aS(o) && !o.ok) {
          s = !1;
          const c = typeof n.error == "function" ? await n.error(`HTTP error! status: ${o.status}`) : n.error, f = typeof n.description == "function" ? await n.description(`HTTP error! status: ${o.status}`) : n.description, d = typeof c == "object" && !fs(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: f,
            ...d
          });
        } else if (o instanceof Error) {
          s = !1;
          const c = typeof n.error == "function" ? await n.error(o) : n.error, f = typeof n.description == "function" ? await n.description(o) : n.description, d = typeof c == "object" && !fs(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: f,
            ...d
          });
        } else if (n.success !== void 0) {
          s = !1;
          const c = typeof n.success == "function" ? await n.success(o) : n.success, f = typeof n.description == "function" ? await n.description(o) : n.description, d = typeof c == "object" && !fs(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "success",
            description: f,
            ...d
          });
        }
      }).catch(async (o) => {
        if (l = ["reject", o], n.error !== void 0) {
          s = !1;
          const u = typeof n.error == "function" ? await n.error(o) : n.error, c = typeof n.description == "function" ? await n.description(o) : n.description, p = typeof u == "object" && !fs(u) ? u : {
            message: u || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: c,
            ...p
          });
        }
      }).finally(() => {
        var o;
        s && (this.dismiss(t), t = void 0), (o = n.finally) == null || o.call(n);
      }), i = () => new Promise((o, u) => r.then(() => l[0] === "reject" ? u(l[1]) : o(l[1])).catch(u));
      return typeof t != "string" && typeof t != "number" ? { unwrap: i } : Object.assign(t, { unwrap: i });
    });
    xe(this, "custom", (e, n) => {
      const t = (n == null ? void 0 : n.id) || ai++, a = this.toasts.find((l) => l.id === t), s = (n == null ? void 0 : n.dismissible) === void 0 ? !0 : n.dismissible;
      return this.dismissedToasts.has(t) && this.dismissedToasts.delete(t), a ? this.toasts = this.toasts.map((l) => l.id === t ? (this.publish({
        ...l,
        component: e,
        dismissible: s,
        id: t,
        ...n
      }), {
        ...l,
        component: e,
        dismissible: s,
        id: t,
        ...n
      }) : l) : this.addToast({
        component: e,
        dismissible: s,
        id: t,
        ...n
      }), t;
    });
    xe(this, "getActiveToasts", () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)));
    this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
};
const Wt = new tS();
function nS(e, n) {
  const t = (n == null ? void 0 : n.id) || ai++;
  return Wt.create({
    message: e,
    id: t,
    type: "default",
    ...n
  }), t;
}
const aS = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", sS = nS, lS = () => Wt.toasts, rS = () => Wt.getActiveToasts(), fa = Object.assign(sS, {
  success: Wt.success,
  info: Wt.info,
  warning: Wt.warning,
  error: Wt.error,
  custom: Wt.custom,
  message: Wt.message,
  promise: Wt.promise,
  dismiss: Wt.dismiss,
  loading: Wt.loading
}, {
  getHistory: lS,
  getToasts: rS
});
function cl(e) {
  return e.label !== void 0;
}
const iS = 3, Jd = "24px", Qd = "16px", mu = 4e3, oS = 356, uS = 14, cS = 45, ef = 200;
function dS() {
  const e = ee(!1);
  return jt(() => {
    const n = () => {
      e.value = document.hidden;
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }), { isDocumentHidden: e };
}
function Xn(...e) {
  return e.filter(Boolean).join(" ");
}
function fS(e) {
  const [n, t] = e.split("-"), a = [];
  return n && a.push(n), t && a.push(t), a;
}
function hS(e, n) {
  const t = {};
  return [e, n].forEach((a, s) => {
    const l = s === 1, r = l ? "--mobile-offset" : "--offset", i = l ? Qd : Jd;
    function o(u) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((c) => {
        t[`${r}-${c}`] = typeof u == "number" ? `${u}px` : u;
      });
    }
    typeof a == "number" || typeof a == "string" ? o(a) : typeof a == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((u) => {
      a[u] === void 0 ? t[`${r}-${u}`] = i : t[`${r}-${u}`] = typeof a[u] == "number" ? `${a[u]}px` : a[u];
    }) : o(i);
  }), t;
}
const mS = [
  "data-rich-colors",
  "data-styled",
  "data-mounted",
  "data-promise",
  "data-swiped",
  "data-removed",
  "data-visible",
  "data-y-position",
  "data-x-position",
  "data-index",
  "data-front",
  "data-swiping",
  "data-dismissible",
  "data-type",
  "data-invert",
  "data-swipe-out",
  "data-swipe-direction",
  "data-expanded",
  "data-testid"
], vS = [
  "aria-label",
  "data-disabled",
  "data-close-button-position"
];
var pS = /* @__PURE__ */ ke({
  __name: "Toast",
  props: {
    toast: {},
    toasts: {},
    index: {},
    swipeDirections: {},
    expanded: { type: Boolean },
    invert: { type: Boolean },
    heights: {},
    gap: {},
    position: {},
    closeButtonPosition: {},
    visibleToasts: {},
    expandByDefault: { type: Boolean },
    closeButton: { type: Boolean },
    interacting: { type: Boolean },
    style: {},
    cancelButtonStyle: {},
    actionButtonStyle: {},
    duration: {},
    class: {},
    unstyled: { type: Boolean },
    descriptionClass: {},
    loadingIcon: {},
    classes: {},
    icons: {},
    closeButtonAriaLabel: {},
    defaultRichColors: { type: Boolean }
  },
  emits: [
    "update:heights",
    "update:height",
    "removeToast"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(null), l = ee(null), r = ee(!1), i = ee(!1), o = ee(!1), u = ee(!1), c = ee(!1), f = ee(0), p = ee(0), d = ee(t.toast.duration || t.duration || mu), b = ee(null), m = ee(null), k = T(() => t.index === 0), y = T(() => t.index + 1 <= t.visibleToasts), h = T(() => t.toast.type), g = T(() => t.toast.dismissible !== !1), x = T(() => t.toast.class || ""), S = T(() => t.descriptionClass || ""), C = T(() => {
      const X = t.toast.position || t.position, Ce = t.heights.filter((V) => V.position === X).findIndex((V) => V.toastId === t.toast.id);
      return Ce >= 0 ? Ce : 0;
    }), _ = T(() => {
      const X = t.toast.position || t.position;
      return t.heights.filter((Ce) => Ce.position === X).reduce((Ce, V, Z) => Z >= C.value ? Ce : Ce + V.height, 0);
    }), O = T(() => C.value * t.gap + _.value || 0), I = T(() => t.toast.closeButton ?? t.closeButton), D = T(() => t.toast.duration || t.duration || mu), B = ee(0), Y = ee(0), ne = ee(null), W = T(() => t.position.split("-")), ae = T(() => W.value[0]), G = T(() => W.value[1]), j = T(() => typeof t.toast.title != "string"), se = T(() => typeof t.toast.description != "string"), { isDocumentHidden: U } = dS(), N = T(() => h.value && h.value === "loading");
    et(() => {
      r.value = !0, d.value = D.value;
    }), jt(async () => {
      if (!r.value || !m.value) return;
      await Ge();
      const X = m.value, ve = X.style.height;
      X.style.height = "auto";
      const Ce = X.getBoundingClientRect().height;
      X.style.height = ve, p.value = Ce, a("update:height", {
        toastId: t.toast.id,
        height: Ce,
        position: t.toast.position || t.position
      });
    });
    function J() {
      i.value = !0, f.value = O.value, setTimeout(() => {
        a("removeToast", t.toast);
      }, ef);
    }
    function de() {
      var X, ve;
      if (N.value || !g.value) return {};
      J(), (ve = (X = t.toast).onDismiss) == null || ve.call(X, t.toast);
    }
    function he(X) {
      X.button !== 2 && (N.value || !g.value || (b.value = /* @__PURE__ */ new Date(), f.value = O.value, X.target.setPointerCapture(X.pointerId), X.target.tagName !== "BUTTON" && (o.value = !0, ne.value = {
        x: X.clientX,
        y: X.clientY
      })));
    }
    function ge() {
      var me, K, oe, ye, A, z, $;
      if (u.value || !g.value) return;
      ne.value = null;
      const X = Number(((me = m.value) == null ? void 0 : me.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), ve = Number(((K = m.value) == null ? void 0 : K.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Ce = (/* @__PURE__ */ new Date()).getTime() - (((oe = b.value) == null ? void 0 : oe.getTime()) || 0), V = s.value === "x" ? X : ve, Z = Math.abs(V) / Ce;
      if (Math.abs(V) >= cS || Z > 0.11) {
        f.value = O.value, (A = (ye = t.toast).onDismiss) == null || A.call(ye, t.toast), s.value === "x" ? l.value = X > 0 ? "right" : "left" : l.value = ve > 0 ? "down" : "up", J(), u.value = !0;
        return;
      } else
        (z = m.value) == null || z.style.setProperty("--swipe-amount-x", "0px"), ($ = m.value) == null || $.style.setProperty("--swipe-amount-y", "0px");
      c.value = !1, o.value = !1, s.value = null;
    }
    function $e(X) {
      var oe, ye, A, z;
      if (!ne.value || !g.value || (((ye = (oe = window == null ? void 0 : window.getSelection()) == null ? void 0 : oe.toString()) == null ? void 0 : ye.length) ?? !1)) return;
      const Ce = X.clientY - ne.value.y, V = X.clientX - ne.value.x, Z = t.swipeDirections ?? fS(t.position);
      !s.value && (Math.abs(V) > 1 || Math.abs(Ce) > 1) && (s.value = Math.abs(V) > Math.abs(Ce) ? "x" : "y");
      let me = {
        x: 0,
        y: 0
      };
      const K = ($) => 1 / (1.5 + Math.abs($) / 20);
      if (s.value === "y") {
        if (Z.includes("top") || Z.includes("bottom")) if (Z.includes("top") && Ce < 0 || Z.includes("bottom") && Ce > 0) me.y = Ce;
        else {
          const $ = Ce * K(Ce);
          me.y = Math.abs($) < Math.abs(Ce) ? $ : Ce;
        }
      } else if (s.value === "x" && (Z.includes("left") || Z.includes("right")))
        if (Z.includes("left") && V < 0 || Z.includes("right") && V > 0) me.x = V;
        else {
          const $ = V * K(V);
          me.x = Math.abs($) < Math.abs(V) ? $ : V;
        }
      (Math.abs(me.x) > 0 || Math.abs(me.y) > 0) && (c.value = !0), (A = m.value) == null || A.style.setProperty("--swipe-amount-x", `${me.x}px`), (z = m.value) == null || z.style.setProperty("--swipe-amount-y", `${me.y}px`);
    }
    et(() => {
      if (r.value = !0, !m.value) return;
      const X = m.value.getBoundingClientRect().height;
      p.value = X;
      const ve = [{
        toastId: t.toast.id,
        height: X,
        position: t.toast.position
      }, ...t.heights];
      a("update:heights", ve);
    }), Fs(() => {
      m.value && a("removeToast", t.toast);
    }), jt((X) => {
      if (t.toast.promise && h.value === "loading" || t.toast.duration === 1 / 0 || t.toast.type === "loading") return;
      let ve;
      const Ce = () => {
        if (Y.value < B.value) {
          const Z = (/* @__PURE__ */ new Date()).getTime() - B.value;
          d.value = d.value - Z;
        }
        Y.value = (/* @__PURE__ */ new Date()).getTime();
      }, V = () => {
        d.value !== 1 / 0 && (B.value = (/* @__PURE__ */ new Date()).getTime(), ve = setTimeout(() => {
          var Z, me;
          (me = (Z = t.toast).onAutoClose) == null || me.call(Z, t.toast), J();
        }, d.value));
      };
      t.expanded || t.interacting || U.value ? Ce() : V(), X(() => {
        clearTimeout(ve);
      });
    }), Le(() => t.toast.delete, (X) => {
      var ve, Ce;
      X !== void 0 && X && (J(), (Ce = (ve = t.toast).onDismiss) == null || Ce.call(ve, t.toast));
    }, { deep: !0 });
    function we() {
      o.value = !1, s.value = null, ne.value = null;
    }
    return (X, ve) => {
      var Ce, V, Z, me, K, oe, ye, A, z, $, F, P, Q, L, fe, Me, Re, _e, Ye, At, Fn, xn, Jt, Un, It, Bt, un;
      return w(), M("li", {
        tabindex: "0",
        ref_key: "toastRef",
        ref: m,
        class: q(v(Xn)(t.class, x.value, (Ce = X.classes) == null ? void 0 : Ce.toast, (V = X.toast.classes) == null ? void 0 : V.toast, (Z = X.classes) == null ? void 0 : Z[h.value], (K = (me = X.toast) == null ? void 0 : me.classes) == null ? void 0 : K[h.value])),
        "data-sonner-toast": "",
        "data-rich-colors": X.toast.richColors ?? X.defaultRichColors,
        "data-styled": !(X.toast.component || (oe = X.toast) != null && oe.unstyled || X.unstyled),
        "data-mounted": r.value,
        "data-promise": !!X.toast.promise,
        "data-swiped": c.value,
        "data-removed": i.value,
        "data-visible": y.value,
        "data-y-position": ae.value,
        "data-x-position": G.value,
        "data-index": X.index,
        "data-front": k.value,
        "data-swiping": o.value,
        "data-dismissible": g.value,
        "data-type": h.value,
        "data-invert": X.toast.invert || X.invert,
        "data-swipe-out": u.value,
        "data-swipe-direction": l.value,
        "data-expanded": !!(X.expanded || X.expandByDefault && r.value),
        "data-testid": X.toast.testId,
        style: Fe({
          "--index": X.index,
          "--toasts-before": X.index,
          "--z-index": X.toasts.length - X.index,
          "--offset": `${i.value ? f.value : O.value}px`,
          "--initial-height": X.expandByDefault ? "auto" : `${p.value}px`,
          ...X.style,
          ...t.toast.style
        }),
        onDragend: we,
        onPointerdown: he,
        onPointerup: ge,
        onPointermove: $e
      }, [I.value && !X.toast.component && h.value !== "loading" ? (w(), M("button", {
        key: 0,
        "aria-label": X.closeButtonAriaLabel || "Close toast",
        "data-disabled": N.value,
        "data-close-button": "true",
        "data-close-button-position": X.closeButtonPosition,
        class: q(v(Xn)((ye = X.classes) == null ? void 0 : ye.closeButton, (z = (A = X.toast) == null ? void 0 : A.classes) == null ? void 0 : z.closeButton)),
        onClick: de
      }, [($ = X.icons) != null && $.close ? (w(), ue(mt((F = X.icons) == null ? void 0 : F.close), { key: 0 })) : H(X.$slots, "close-icon", { key: 1 })], 10, vS)) : R("v-if", !0), X.toast.component ? (w(), ue(mt(X.toast.component), lt({ key: 1 }, X.toast.componentProps, {
        onCloseToast: de,
        isPaused: X.$props.expanded || X.$props.interacting || v(U)
      }), null, 16, ["isPaused"])) : (w(), M(Te, { key: 2 }, [
        h.value !== "default" || X.toast.icon || X.toast.promise ? (w(), M("div", {
          key: 0,
          "data-icon": "",
          class: q(v(Xn)((P = X.classes) == null ? void 0 : P.icon, (L = (Q = X.toast) == null ? void 0 : Q.classes) == null ? void 0 : L.icon))
        }, [X.toast.icon ? (w(), ue(mt(X.toast.icon), { key: 0 })) : (w(), M(Te, { key: 1 }, [h.value === "loading" ? H(X.$slots, "loading-icon", { key: 0 }) : h.value === "success" ? H(X.$slots, "success-icon", { key: 1 }) : h.value === "error" ? H(X.$slots, "error-icon", { key: 2 }) : h.value === "warning" ? H(X.$slots, "warning-icon", { key: 3 }) : h.value === "info" ? H(X.$slots, "info-icon", { key: 4 }) : R("v-if", !0)], 64))], 2)) : R("v-if", !0),
        E("div", {
          "data-content": "",
          class: q(v(Xn)((fe = X.classes) == null ? void 0 : fe.content, (Re = (Me = X.toast) == null ? void 0 : Me.classes) == null ? void 0 : Re.content))
        }, [E("div", {
          "data-title": "",
          class: q(v(Xn)((_e = X.classes) == null ? void 0 : _e.title, (Ye = X.toast.classes) == null ? void 0 : Ye.title))
        }, [j.value ? (w(), ue(mt(X.toast.title), Mt(lt({ key: 0 }, X.toast.componentProps)), null, 16)) : (w(), M(Te, { key: 1 }, [He(re(X.toast.title), 1)], 64))], 2), X.toast.description ? (w(), M("div", {
          key: 0,
          "data-description": "",
          class: q(v(Xn)(X.descriptionClass, S.value, (At = X.classes) == null ? void 0 : At.description, (Fn = X.toast.classes) == null ? void 0 : Fn.description))
        }, [se.value ? (w(), ue(mt(X.toast.description), Mt(lt({ key: 0 }, X.toast.componentProps)), null, 16)) : (w(), M(Te, { key: 1 }, [He(re(X.toast.description), 1)], 64))], 2)) : R("v-if", !0)], 2),
        X.toast.cancel ? (w(), M("button", {
          key: 1,
          style: Fe(X.toast.cancelButtonStyle || X.cancelButtonStyle),
          class: q(v(Xn)((xn = X.classes) == null ? void 0 : xn.cancelButton, (Jt = X.toast.classes) == null ? void 0 : Jt.cancelButton)),
          "data-button": "",
          "data-cancel": "",
          onClick: ve[0] || (ve[0] = (Sn) => {
            var bt, wt;
            v(cl)(X.toast.cancel) && g.value && ((wt = (bt = X.toast.cancel).onClick) == null || wt.call(bt, Sn), J());
          })
        }, re(v(cl)(X.toast.cancel) ? (Un = X.toast.cancel) == null ? void 0 : Un.label : X.toast.cancel), 7)) : R("v-if", !0),
        X.toast.action ? (w(), M("button", {
          key: 2,
          style: Fe(X.toast.actionButtonStyle || X.actionButtonStyle),
          class: q(v(Xn)((It = X.classes) == null ? void 0 : It.actionButton, (Bt = X.toast.classes) == null ? void 0 : Bt.actionButton)),
          "data-button": "",
          "data-action": "",
          onClick: ve[1] || (ve[1] = (Sn) => {
            var bt, wt;
            v(cl)(X.toast.action) && ((wt = (bt = X.toast.action).onClick) == null || wt.call(bt, Sn), !Sn.defaultPrevented && J());
          })
        }, re(v(cl)(X.toast.action) ? (un = X.toast.action) == null ? void 0 : un.label : X.toast.action), 7)) : R("v-if", !0)
      ], 64))], 46, mS);
    };
  }
}), gS = pS, Zs = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, s] of n) t[a] = s;
  return t;
};
const yS = {}, bS = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stoke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function wS(e, n) {
  return w(), M("svg", bS, n[0] || (n[0] = [E("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }, null, -1), E("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }, null, -1)]));
}
var kS = /* @__PURE__ */ Zs(yS, [["render", wS]]);
const xS = ["data-visible"], SS = { class: "sonner-spinner" };
var TS = /* @__PURE__ */ ke({
  __name: "Loader",
  props: { visible: { type: Boolean } },
  setup(e) {
    const n = Array(12).fill(0);
    return (t, a) => (w(), M("div", {
      class: "sonner-loading-wrapper",
      "data-visible": t.visible
    }, [E("div", SS, [(w(!0), M(Te, null, Ie(v(n), (s) => (w(), M("div", {
      key: `spinner-bar-${s}`,
      class: "sonner-loading-bar"
    }))), 128))])], 8, xS));
  }
}), $S = TS;
const MS = {}, CS = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function DS(e, n) {
  return w(), M("svg", CS, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var OS = /* @__PURE__ */ Zs(MS, [["render", DS]]);
const _S = {}, ES = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function IS(e, n) {
  return w(), M("svg", ES, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var AS = /* @__PURE__ */ Zs(_S, [["render", IS]]);
const PS = {}, RS = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function FS(e, n) {
  return w(), M("svg", RS, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var VS = /* @__PURE__ */ Zs(PS, [["render", FS]]);
const LS = {}, NS = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function zS(e, n) {
  return w(), M("svg", NS, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var BS = /* @__PURE__ */ Zs(LS, [["render", zS]]);
const WS = ["aria-label"], YS = [
  "data-sonner-theme",
  "dir",
  "data-theme",
  "data-rich-colors",
  "data-y-position",
  "data-x-position"
], HS = typeof window < "u" && typeof document < "u";
function US() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
var qS = /* @__PURE__ */ ke({
  name: "Toaster",
  inheritAttrs: !1,
  __name: "Toaster",
  props: {
    id: {},
    invert: {
      type: Boolean,
      default: !1
    },
    theme: { default: "light" },
    position: { default: "bottom-right" },
    closeButtonPosition: { default: "top-left" },
    hotkey: { default: () => ["altKey", "KeyT"] },
    richColors: {
      type: Boolean,
      default: !1
    },
    expand: {
      type: Boolean,
      default: !1
    },
    duration: {},
    gap: { default: uS },
    visibleToasts: { default: iS },
    closeButton: {
      type: Boolean,
      default: !1
    },
    toastOptions: { default: () => ({}) },
    class: { default: "" },
    style: {},
    offset: { default: Jd },
    mobileOffset: { default: Qd },
    dir: { default: "auto" },
    swipeDirections: {},
    icons: {},
    containerAriaLabel: { default: "Notifications" }
  },
  setup(e) {
    const n = e, t = Il(), a = ee([]), s = T(() => n.id ? a.value.filter((D) => D.toasterId === n.id) : a.value.filter((D) => !D.toasterId));
    function l(D, B) {
      return s.value.filter((Y) => !Y.position && B === 0 || Y.position === D);
    }
    const r = T(() => {
      const D = s.value.filter((B) => B.position).map((B) => B.position);
      return D.length > 0 ? Array.from(new Set([n.position].concat(D))) : [n.position];
    }), i = T(() => {
      const D = {};
      return r.value.forEach((B) => {
        D[B] = a.value.filter((Y) => Y.position === B);
      }), D;
    }), o = ee([]), u = ee({}), c = ee(!1);
    jt(() => {
      r.value.forEach((D) => {
        D in u.value || (u.value[D] = !1);
      });
    });
    const f = ee(n.theme !== "system" ? n.theme : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), p = ee(null), d = ee(null), b = ee(!1), m = n.hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    function k(D) {
      var B;
      (B = a.value.find((Y) => Y.id === D.id)) != null && B.delete || Wt.dismiss(D.id), a.value = a.value.filter(({ id: Y }) => Y !== D.id), setTimeout(() => {
        a.value.find((Y) => Y.id === D.id) || (o.value = o.value.filter((Y) => Y.toastId !== D.id));
      }, ef + 50);
    }
    function y(D) {
      var B, Y;
      b.value && !((Y = (B = D.currentTarget) == null ? void 0 : B.contains) != null && Y.call(B, D.relatedTarget)) && (b.value = !1, d.value && (d.value.focus({ preventScroll: !0 }), d.value = null));
    }
    function h(D) {
      D.target instanceof HTMLElement && D.target.dataset.dismissible === "false" || b.value || (b.value = !0, d.value = D.relatedTarget);
    }
    function g(D) {
      D.target && D.target instanceof HTMLElement && D.target.dataset.dismissible === "false" || (c.value = !0);
    }
    jt((D) => {
      const B = Wt.subscribe((Y) => {
        if (Y.dismiss) {
          requestAnimationFrame(() => {
            a.value = a.value.map((ne) => ne.id === Y.id ? {
              ...ne,
              delete: !0
            } : ne);
          });
          return;
        }
        Ge(() => {
          const ne = a.value.findIndex((W) => W.id === Y.id);
          ne !== -1 ? a.value = [
            ...a.value.slice(0, ne),
            {
              ...a.value[ne],
              ...Y
            },
            ...a.value.slice(ne + 1)
          ] : a.value = [Y, ...a.value];
        });
      });
      D(B);
    }), jt((D) => {
      if (typeof window > "u") return;
      if (n.theme !== "system") {
        f.value = n.theme;
        return;
      }
      const B = window.matchMedia("(prefers-color-scheme: dark)"), Y = (W) => {
        f.value = W ? "dark" : "light";
      };
      Y(B.matches);
      const ne = (W) => {
        Y(W.matches);
      };
      try {
        B.addEventListener("change", ne);
      } catch {
        B.addListener(ne);
      }
      D(() => {
        try {
          B.removeEventListener("change", ne);
        } catch {
          B.removeListener(ne);
        }
      });
    }), jt(() => {
      p.value && d.value && (d.value.focus({ preventScroll: !0 }), d.value = null, b.value = !1);
    }), jt(() => {
      a.value.length <= 1 && Object.keys(u.value).forEach((D) => {
        u.value[D] = !1;
      });
    }), jt((D) => {
      function B(Y) {
        const ne = n.hotkey.every((G) => Y[G] || Y.code === G), W = Array.isArray(p.value) ? p.value[0] : p.value;
        ne && (r.value.forEach((G) => {
          u.value[G] = !0;
        }), W == null || W.focus());
        const ae = document.activeElement === p.value || (W == null ? void 0 : W.contains(document.activeElement));
        Y.code === "Escape" && ae && r.value.forEach((G) => {
          u.value[G] = !1;
        });
      }
      HS && (document.addEventListener("keydown", B), D(() => {
        document.removeEventListener("keydown", B);
      }));
    });
    function x(D) {
      const B = D.currentTarget, Y = B.getAttribute("data-y-position") + "-" + B.getAttribute("data-x-position");
      u.value[Y] = !0;
    }
    function S(D) {
      if (!c.value) {
        const B = D.currentTarget, Y = B.getAttribute("data-y-position") + "-" + B.getAttribute("data-x-position");
        u.value[Y] = !1;
      }
    }
    function C() {
      Object.keys(u.value).forEach((D) => {
        u.value[D] = !1;
      });
    }
    function _() {
      c.value = !1;
    }
    function O(D) {
      o.value = D;
    }
    function I(D) {
      const B = o.value.findIndex((Y) => Y.toastId === D.toastId);
      if (B !== -1) o.value[B] = D;
      else {
        const Y = o.value.findIndex((ne) => ne.position === D.position);
        Y !== -1 ? o.value.splice(Y, 0, D) : o.value.unshift(D);
      }
    }
    return (D, B) => (w(), M(Te, null, [R(" Remove item from normal navigation flow, only available via hotkey "), E("section", {
      "aria-label": `${D.containerAriaLabel} ${v(m)}`,
      tabIndex: -1,
      "aria-live": "polite",
      "aria-relevant": "additions text",
      "aria-atomic": "false"
    }, [(w(!0), M(Te, null, Ie(r.value, (Y, ne) => {
      var W;
      return w(), M("ol", lt({
        key: Y,
        ref_for: !0,
        ref_key: "listRef",
        ref: p,
        "data-sonner-toaster": "",
        "data-sonner-theme": f.value,
        class: n.class,
        dir: D.dir === "auto" ? US() : D.dir,
        tabIndex: -1,
        "data-theme": D.theme,
        "data-rich-colors": D.richColors,
        "data-y-position": Y.split("-")[0],
        "data-x-position": Y.split("-")[1],
        style: {
          "--front-toast-height": `${((W = o.value[0]) == null ? void 0 : W.height) || 0}px`,
          "--width": `${v(oS)}px`,
          "--gap": `${D.gap}px`,
          ...D.style,
          ...v(t).style,
          ...v(hS)(D.offset, D.mobileOffset)
        }
      }, { ref_for: !0 }, D.$attrs, {
        onBlur: y,
        onFocus: h,
        onMouseenter: x,
        onMousemove: x,
        onMouseleave: S,
        onDragend: C,
        onPointerdown: g,
        onPointerup: _
      }), [(w(!0), M(Te, null, Ie(l(Y, ne), (ae, G) => {
        var j, se, U, N, J, de, he, ge, $e, we, X;
        return w(), ue(gS, {
          key: ae.id,
          heights: o.value,
          icons: D.icons,
          index: G,
          toast: ae,
          defaultRichColors: D.richColors,
          duration: ((j = D.toastOptions) == null ? void 0 : j.duration) ?? D.duration,
          class: q(((se = D.toastOptions) == null ? void 0 : se.class) ?? ""),
          descriptionClass: (U = D.toastOptions) == null ? void 0 : U.descriptionClass,
          invert: D.invert,
          visibleToasts: D.visibleToasts,
          closeButton: ((N = D.toastOptions) == null ? void 0 : N.closeButton) ?? D.closeButton,
          interacting: c.value,
          position: Y,
          closeButtonPosition: ((J = D.toastOptions) == null ? void 0 : J.closeButtonPosition) ?? D.closeButtonPosition,
          style: Fe((de = D.toastOptions) == null ? void 0 : de.style),
          unstyled: (he = D.toastOptions) == null ? void 0 : he.unstyled,
          classes: (ge = D.toastOptions) == null ? void 0 : ge.classes,
          cancelButtonStyle: ($e = D.toastOptions) == null ? void 0 : $e.cancelButtonStyle,
          actionButtonStyle: (we = D.toastOptions) == null ? void 0 : we.actionButtonStyle,
          "close-button-aria-label": (X = D.toastOptions) == null ? void 0 : X.closeButtonAriaLabel,
          toasts: i.value[Y],
          expandByDefault: D.expand,
          gap: D.gap,
          expanded: u.value[Y] || !1,
          swipeDirections: n.swipeDirections,
          "onUpdate:heights": O,
          "onUpdate:height": I,
          onRemoveToast: k
        }, {
          "close-icon": ce(() => [H(D.$slots, "close-icon", {}, () => [ie(kS)])]),
          "loading-icon": ce(() => [H(D.$slots, "loading-icon", {}, () => [ie($S, { visible: ae.type === "loading" }, null, 8, ["visible"])])]),
          "success-icon": ce(() => [H(D.$slots, "success-icon", {}, () => [ie(OS)])]),
          "error-icon": ce(() => [H(D.$slots, "error-icon", {}, () => [ie(BS)])]),
          "warning-icon": ce(() => [H(D.$slots, "warning-icon", {}, () => [ie(VS)])]),
          "info-icon": ce(() => [H(D.$slots, "info-icon", {}, () => [ie(AS)])]),
          _: 2
        }, 1032, [
          "heights",
          "icons",
          "index",
          "toast",
          "defaultRichColors",
          "duration",
          "class",
          "descriptionClass",
          "invert",
          "visibleToasts",
          "closeButton",
          "interacting",
          "position",
          "closeButtonPosition",
          "style",
          "unstyled",
          "classes",
          "cancelButtonStyle",
          "actionButtonStyle",
          "close-button-aria-label",
          "toasts",
          "expandByDefault",
          "gap",
          "expanded",
          "swipeDirections"
        ]);
      }), 128))], 16, YS);
    }), 128))], 8, WS)], 2112));
  }
}), jS = qS;
const GS = /* @__PURE__ */ ke({
  __name: "VToaster",
  setup(e) {
    const n = Hd(), t = T(() => n.resolvedTheme);
    return (a, s) => (w(), ue(v(jS), {
      duration: 4e3,
      theme: t.value,
      "toast-options": {
        unstyled: !0,
        classes: {
          toast: "toast-custom",
          title: "toast-title",
          description: "toast-description",
          actionButton: "toast-action",
          cancelButton: "toast-cancel",
          closeButton: "toast-close",
          error: "toast-error",
          success: "toast-success",
          warning: "toast-warning",
          info: "toast-info"
        }
      },
      "close-button": "",
      position: "top-right"
    }, null, 8, ["theme"]));
  }
}), TD = /* @__PURE__ */ ze(GS, [["__scopeId", "data-v-9305e752"]]), KS = ["id"], ZS = ["id", "aria-controls", "aria-expanded", "disabled", "onClick"], XS = { class: "v-expansion-panel-header__content" }, JS = { class: "v-expansion-panel-title" }, QS = {
  key: 0,
  class: "v-expansion-panel-subtitle"
}, eT = { class: "v-expansion-panel-header__icon-wrapper" }, tT = ["id", "aria-hidden", "aria-labelledby"], nT = { class: "v-expansion-panel-content__wrap" }, aT = { class: "v-expansion-panel-content__inner" }, sT = { class: "v-expansion-panel-text" }, lT = /* @__PURE__ */ ke({
  __name: "VAccordion",
  props: /* @__PURE__ */ Yt({
    items: { default: () => [] },
    multiple: { type: Boolean, default: !1 },
    variant: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    flat: { type: Boolean, default: !1 },
    accordion: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: () => [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Yt(["change"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, a = n, s = $a(), l = En(e, "modelValue"), r = (u) => l.value.includes(u), i = (u) => {
      l.value = u, a("change", u);
    }, o = (u, c) => {
      if (t.disabled || c) return;
      const f = r(u);
      if (t.accordion || !t.multiple) {
        i(f ? [] : [u]);
        return;
      }
      i(
        f ? l.value.filter((p) => p !== u) : [...l.value, u]
      );
    };
    return et(() => {
      if (l.value.length) return;
      const u = t.items.filter((c) => c.defaultOpen).map((c) => c.id);
      u.length && (l.value = t.accordion || !t.multiple ? [u[0]] : u);
    }), (u, c) => (w(), M("div", {
      id: v(s),
      class: q([[
        `v-expansion-panels--${e.variant}`,
        {
          "v-expansion-panels--flat": e.flat,
          "v-expansion-panels--disabled": e.disabled,
          "v-expansion-panels--modern": e.modern
        }
      ], "v-expansion-panels"])
    }, [
      (w(!0), M(Te, null, Ie(e.items, (f, p) => (w(), M("div", {
        key: f.id,
        class: q([{
          "v-expansion-panel--active": r(f.id),
          "v-expansion-panel--disabled": f.disabled || e.disabled
        }, "v-expansion-panel"])
      }, [
        E("button", {
          id: `${v(s)}-header-${f.id}`,
          "aria-controls": `${v(s)}-content-${f.id}`,
          "aria-expanded": r(f.id),
          disabled: f.disabled || e.disabled,
          class: "v-expansion-panel-header",
          type: "button",
          onClick: (d) => o(f.id, f.disabled)
        }, [
          H(u.$slots, `header-${f.id}`, {
            index: p,
            isOpen: r(f.id),
            item: f
          }, () => [
            H(u.$slots, "header", {
              index: p,
              isOpen: r(f.id),
              item: f
            }, () => [
              f.icon ? (w(), ue(be, {
                key: 0,
                icon: f.icon,
                size: e.modern ? 16 : void 0,
                class: "v-expansion-panel-header__icon"
              }, null, 8, ["icon", "size"])) : R("", !0),
              E("div", XS, [
                E("div", JS, re(f.title), 1),
                f.subtitle ? (w(), M("div", QS, re(f.subtitle), 1)) : R("", !0)
              ]),
              E("div", eT, [
                ie(be, {
                  class: q(
                    r(f.id) ? "v-expansion-panel-header__expand-icon v-expansion-panel-header__expand-icon--active" : "v-expansion-panel-header__expand-icon"
                  ),
                  icon: e.modern ? "lucide:chevron-down" : "mdi:chevron-down",
                  size: e.modern ? 16 : void 0
                }, null, 8, ["class", "icon", "size"])
              ])
            ], !0)
          ], !0)
        ], 8, ZS),
        E("div", {
          id: `${v(s)}-content-${f.id}`,
          "aria-hidden": !r(f.id),
          "aria-labelledby": `${v(s)}-header-${f.id}`,
          class: "v-expansion-panel-content",
          role: "region"
        }, [
          E("div", nT, [
            E("div", aT, [
              H(u.$slots, `content-${f.id}`, {
                index: p,
                item: f
              }, () => [
                H(u.$slots, "content", {
                  index: p,
                  item: f
                }, () => [
                  E("div", sT, re(f.content), 1)
                ], !0)
              ], !0)
            ])
          ])
        ], 8, tT)
      ], 2))), 128))
    ], 10, KS));
  }
}), $D = /* @__PURE__ */ ze(lT, [["__scopeId", "data-v-79e6a45e"]]), MD = /* @__PURE__ */ ke({
  __name: "VAnimatedBackground",
  props: {
    count: { default: 15 },
    minRadius: { default: 100 },
    maxRadius: { default: 300 },
    speed: { default: 1 },
    colors: { default: () => [
      "rgba(37, 99, 235, 0.3)",
      // primary
      "rgba(251, 191, 36, 0.3)",
      // accent
      "rgba(14, 165, 233, 0.3)",
      // info
      "rgba(34, 197, 94, 0.3)"
      // success
    ] }
  },
  setup(e) {
    const n = e, t = ee(null);
    let a, s = null;
    const l = [], r = (o) => {
      l.length = 0;
      const { colors: u } = n;
      if (u.length !== 0)
        for (let c = 0; c < n.count; c++)
          l.push({
            x: Math.random() * o.width,
            y: Math.random() * o.height,
            radius: Math.random() * (n.maxRadius - n.minRadius) + n.minRadius,
            vx: (Math.random() - 0.5) * n.speed,
            vy: (Math.random() - 0.5) * n.speed,
            color: u[c % u.length]
          });
    }, i = (o, u) => {
      u.clearRect(0, 0, o.width, o.height), l.forEach((c) => {
        c.x += c.vx, c.y += c.vy, (c.x < -c.radius || c.x > o.width + c.radius) && (c.vx *= -1), (c.y < -c.radius || c.y > o.height + c.radius) && (c.vy *= -1);
        const f = u.createRadialGradient(
          c.x,
          c.y,
          0,
          c.x,
          c.y,
          c.radius * 0.7
        ), p = c.color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (p) {
          const [, d, b, m] = p;
          f.addColorStop(0, `rgba(${d}, ${b}, ${m}, 0.5)`), f.addColorStop(0.5, `rgba(${d}, ${b}, ${m}, 0.25)`), f.addColorStop(1, `rgba(${d}, ${b}, ${m}, 0)`);
        }
        u.fillStyle = f, u.beginPath(), u.arc(c.x, c.y, c.radius, 0, Math.PI * 2), u.fill();
      }), a = requestAnimationFrame(() => i(o, u));
    };
    return et(() => {
      const o = t.value;
      if (!o) return;
      const u = o.getContext("2d");
      if (!u) return;
      const c = () => {
        o && (o.width = window.innerWidth, o.height = window.innerHeight, l.length === 0 && r(o));
      };
      s = c, c(), window.addEventListener("resize", c), i(o, u);
    }), Xt(() => {
      s && window.removeEventListener("resize", s), a && cancelAnimationFrame(a), l.length = 0;
    }), (o, u) => (w(), M(Te, null, [
      E("canvas", {
        ref_key: "canvasRef",
        ref: t,
        class: "fixed inset-0 z-10 pointer-events-none"
      }, null, 512),
      u[0] || (u[0] = E("div", { class: "fixed inset-0 z-10 bg-gradient-to-br from-primary/5 via-accent/5 to-info/5" }, null, -1))
    ], 64));
  }
}), rT = {
  key: 0,
  class: "v-card__loading"
}, iT = {
  key: 0,
  class: "v-card__header"
}, oT = { class: "v-card__header-content" }, uT = {
  key: 1,
  class: "v-card__header-text"
}, cT = {
  key: 0,
  class: "v-card__title"
}, dT = {
  key: 1,
  class: "v-card__subtitle"
}, fT = {
  key: 0,
  class: "v-card__description"
}, hT = {
  key: 1,
  class: "v-card__content"
}, mT = {
  key: 2,
  class: "v-card__footer"
}, vT = /* @__PURE__ */ ke({
  __name: "VCard",
  props: {
    title: { default: "" },
    subtitle: { default: "" },
    description: { default: "" },
    variant: { default: "default" },
    size: { default: "full" },
    radius: { default: "xl" },
    padding: { default: "sm" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    clickable: { type: Boolean },
    icon: { default: "" },
    as: { default: "div" },
    href: { default: "" },
    target: { default: "_self" },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = T(() => t.title || t.subtitle || t.icon || !!c.header), l = T(() => !!c.footer), r = T(() => t.clickable || t.href || t.as === "button"), i = T(() => t.href ? "a" : t.as), o = T(() => {
      const p = ["v-card"];
      return p.push(`v-card--${t.variant}`), p.push(`v-card--${t.size}`), p.push(`v-card--radius-${t.radius}`), t.padding && p.push(`v-card--padding-${t.padding}`), t.disabled && p.push("v-card--disabled"), t.loading && p.push("v-card--loading"), r.value && p.push("v-card--interactive"), t.modern && p.push("v-card--modern"), p;
    }), u = T(() => t.href ? {
      href: t.href,
      target: t.target,
      rel: t.target === "_blank" ? "noopener noreferrer" : void 0
    } : {}), c = Ht(), f = (p) => {
      if (t.disabled || t.loading) {
        p.preventDefault();
        return;
      }
      a("click", p);
    };
    return (p, d) => (w(), ue(mt(i.value), lt({ class: o.value }, u.value, { onClick: f }), {
      default: ce(() => [
        e.loading ? (w(), M("div", rT, [
          H(p.$slots, "loading", {}, () => [
            ie(Kl)
          ], !0)
        ])) : (w(), M(Te, { key: 1 }, [
          s.value ? (w(), M("header", iT, [
            H(p.$slots, "header", {}, () => [
              E("div", oT, [
                t.icon ? (w(), ue(be, {
                  key: 0,
                  icon: t.icon,
                  class: "v-card__icon"
                }, null, 8, ["icon"])) : R("", !0),
                e.title || e.subtitle ? (w(), M("div", uT, [
                  e.title ? (w(), M("h3", cT, re(e.title), 1)) : R("", !0),
                  e.subtitle ? (w(), M("p", dT, re(e.subtitle), 1)) : R("", !0)
                ])) : R("", !0)
              ]),
              e.description ? (w(), M("p", fT, re(e.description), 1)) : R("", !0)
            ], !0)
          ])) : R("", !0),
          !e.modern || c.default ? (w(), M("div", hT, [
            H(p.$slots, "default", {}, void 0, !0)
          ])) : R("", !0),
          l.value ? (w(), M("footer", mT, [
            H(p.$slots, "footer", {}, void 0, !0)
          ])) : R("", !0)
        ], 64))
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), pT = /* @__PURE__ */ ze(vT, [["__scopeId", "data-v-d4d6de05"]]), gT = {
  key: 0,
  class: "space-y-4"
}, yT = {
  key: 0,
  class: "v-info-notice__head flex gap-3 items-start"
}, bT = { class: "flex-1" }, wT = {
  key: 0,
  class: "v-info-notice__title font-semibold text-mainText"
}, kT = {
  key: 1,
  class: "v-info-notice__subtitle text-sm text-secondaryText mt-0.5"
}, xT = { class: "v-info-notice__features grid grid-cols-2 md:grid-cols-4 gap-3" }, ST = { class: "min-w-0" }, TT = { class: "v-info-notice__feature-title font-medium text-sm text-mainText truncate" }, $T = {
  key: 0,
  class: "v-info-notice__feature-description text-xs text-secondaryText truncate"
}, MT = {
  key: 1,
  class: "v-info-notice__hint flex items-center gap-2 text-sm text-secondaryText pt-2 border-t border-base-400/30"
}, CT = {
  key: 1,
  class: "v-info-notice__head flex gap-3 items-start"
}, DT = { class: "v-info-notice__body flex-1 text-sm leading-relaxed" }, OT = {
  key: 0,
  class: "v-info-notice__title font-semibold mb-1 text-mainText"
}, _T = {
  key: 1,
  class: "v-info-notice__subtitle text-secondaryText"
}, ET = {
  key: 2,
  class: "text-secondaryText"
}, IT = {
  key: 0,
  class: "flex-shrink-0"
}, AT = /* @__PURE__ */ ke({
  __name: "VInfoNotice",
  props: {
    icon: { default: "lucide:info" },
    iconColor: { default: "primary" },
    title: { default: void 0 },
    subtitle: { default: void 0 },
    card: { type: Boolean, default: !0 },
    size: { default: void 0 },
    features: { default: void 0 },
    hint: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = T(() => n.size ?? (n.modern ? 20 : "50px")), a = T(() => [
      { "p-4": !n.card && !n.modern },
      n.modern ? ["v-info-notice--modern", `v-info-notice--tone-${n.iconColor}`] : []
    ]), s = (u) => `v-info-notice--tone-${u || "primary"}`, l = T(() => {
      const u = {
        primary: "text-primary",
        success: "text-success",
        warning: "text-warning",
        error: "text-error",
        info: "text-info",
        muted: "text-secondaryText"
      };
      return u[n.iconColor] || u.primary;
    }), r = (u) => ({
      primary: "bg-primary/10",
      success: "bg-success/10",
      warning: "bg-warning/10",
      error: "bg-error/10",
      info: "bg-info/10",
      muted: "bg-muted/10"
    })[u || "primary"], i = (u) => ({
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
      info: "text-info",
      muted: "text-secondaryText"
    })[u || "primary"], o = T(() => n.features && n.features.length > 0);
    return (u, c) => (w(), ue(mt(e.card ? pT : "div"), {
      class: q(a.value)
    }, {
      default: ce(() => [
        o.value ? (w(), M("div", gT, [
          e.title || e.subtitle || u.$slots.title || u.$slots.subtitle ? (w(), M("div", yT, [
            H(u.$slots, "icon", {}, () => [
              ie(be, {
                class: q(`${l.value} v-info-notice__icon`),
                icon: e.icon,
                size: e.modern ? 20 : 24
              }, null, 8, ["class", "icon", "size"])
            ], !0),
            E("div", bT, [
              e.title || u.$slots.title ? (w(), M("p", wT, [
                H(u.$slots, "title", {}, () => [
                  He(re(e.title), 1)
                ], !0)
              ])) : R("", !0),
              e.subtitle || u.$slots.subtitle ? (w(), M("p", kT, [
                H(u.$slots, "subtitle", {}, () => [
                  He(re(e.subtitle), 1)
                ], !0)
              ])) : R("", !0)
            ])
          ])) : R("", !0),
          E("div", xT, [
            (w(!0), M(Te, null, Ie(e.features, (f, p) => (w(), M("div", {
              key: p,
              class: "v-info-notice__feature flex items-center gap-3 p-3 rounded-lg bg-cardBg/50 border border-base-400/50"
            }, [
              E("div", {
                class: q([[r(f.color), s(f.color)], "v-info-notice__feature-icon w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"])
              }, [
                ie(be, {
                  class: q(i(f.color)),
                  icon: f.icon,
                  size: e.modern ? 16 : 20
                }, null, 8, ["class", "icon", "size"])
              ], 2),
              E("div", ST, [
                E("p", TT, re(f.title), 1),
                f.description ? (w(), M("p", $T, re(f.description), 1)) : R("", !0)
              ])
            ]))), 128))
          ]),
          e.hint || u.$slots.hint ? (w(), M("div", MT, [
            ie(be, {
              size: e.modern ? 14 : 16,
              class: "text-secondaryText flex-shrink-0",
              icon: "lucide:info"
            }, null, 8, ["size"]),
            E("span", null, [
              H(u.$slots, "hint", {}, () => [
                He(re(e.hint), 1)
              ], !0)
            ])
          ])) : R("", !0)
        ])) : (w(), M("div", CT, [
          H(u.$slots, "icon", {}, () => [
            ie(be, {
              class: q([l.value, "v-info-notice__icon"]),
              icon: e.icon,
              size: t.value
            }, null, 8, ["class", "icon", "size"])
          ], !0),
          E("div", DT, [
            e.title || u.$slots.title ? (w(), M("p", OT, [
              H(u.$slots, "title", {}, () => [
                He(re(e.title), 1)
              ], !0)
            ])) : R("", !0),
            e.subtitle || u.$slots.subtitle ? (w(), M("p", _T, [
              H(u.$slots, "subtitle", {}, () => [
                He(re(e.subtitle), 1)
              ], !0)
            ])) : R("", !0),
            u.$slots.default ? (w(), M("div", ET, [
              H(u.$slots, "default", {}, void 0, !0)
            ])) : R("", !0)
          ]),
          u.$slots.actions ? (w(), M("div", IT, [
            H(u.$slots, "actions", {}, void 0, !0)
          ])) : R("", !0)
        ]))
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), CD = /* @__PURE__ */ ze(AT, [["__scopeId", "data-v-7575fa6d"]]), PT = {
  key: 0,
  class: "scroll-panel__copy"
}, RT = ["aria-label"], FT = { class: "scroll-panel__copy-glyph" }, VT = { class: "scroll-panel__copy-glyph scroll-panel__copy-glyph--check" }, LT = /* @__PURE__ */ ke({
  __name: "VScrollPanel",
  props: {
    copyText: {},
    copyLabel: { default: "Copy to clipboard" },
    maxHeight: { default: () => {
    } },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const { copy: n, copied: t, isSupported: a } = mi({ copiedDuring: 2e3 });
    return (s, l) => (w(), M("div", {
      class: q([{
        "scroll-panel--modern": e.modern,
        "scroll-panel--capped": e.maxHeight
      }, "scroll-panel overflow-y-auto p-2.5"]),
      style: Fe(e.maxHeight ? { "--v-scroll-panel-max-height": e.maxHeight } : void 0)
    }, [
      e.copyText !== void 0 && v(a) ? (w(), M("div", PT, [
        E("button", {
          "aria-label": v(t) ? "Copied" : e.copyLabel,
          class: q([{ "scroll-panel__copy-btn--copied": v(t) }, "scroll-panel__copy-btn"]),
          type: "button",
          onClick: l[0] || (l[0] = (r) => v(n)(e.copyText))
        }, [
          E("span", FT, [
            ie(be, {
              size: 14,
              icon: "lucide:copy"
            })
          ]),
          E("span", VT, [
            ie(be, {
              size: 14,
              icon: "lucide:check"
            })
          ])
        ], 10, RT)
      ])) : R("", !0),
      H(s.$slots, "default", {}, void 0, !0)
    ], 6));
  }
}), DD = /* @__PURE__ */ ze(LT, [["__scopeId", "data-v-abddb997"]]), NT = {
  key: 0,
  class: "v-tabs__header"
}, zT = {
  key: 0,
  "aria-busy": "true",
  class: "v-tabs__skeleton"
}, BT = { class: "v-tabs__list" }, WT = ["id", "aria-controls", "aria-disabled", "aria-selected", "data-tab-id", "tabindex", "onClick", "onFocus"], YT = { class: "v-tabs__tab-label" }, HT = {
  key: 2,
  class: "v-tabs__tab-count"
}, UT = {
  key: 0,
  class: "v-tabs__more"
}, qT = {
  key: 1,
  class: "v-tabs__actions"
}, jT = ["id"], GT = ["id", "aria-labelledby"], KT = { class: "v-tabs__panel" }, ZT = 70, XT = /* @__PURE__ */ ke({
  __name: "VTabs",
  props: {
    tabs: {},
    loading: { type: Boolean },
    reset: { type: Boolean },
    useHash: { type: Boolean, default: !0 },
    tabSelectionMode: { default: "auto" },
    actionsTargetId: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["tabSelected"],
  setup(e, { expose: n, emit: t }) {
    const a = Vu(), s = ii(), l = $a(), r = e, i = t, o = T(
      () => r.tabs.length > 0 && r.tabs.every((W) => W.to)
    );
    Le(() => r.tabs, (W) => {
    }, { immediate: !0 });
    const c = ee((() => {
      var ae;
      if (!o.value && r.useHash && (s != null && s.hash)) {
        const G = s.hash.replace("#tab-", ""), j = r.tabs.find((se) => String(se.id) === G);
        if (j)
          return j.id;
      }
      const W = r.tabs.find((G) => G.activeByDefault);
      return (W == null ? void 0 : W.id) ?? ((ae = r.tabs[0]) == null ? void 0 : ae.id);
    })()), f = T(() => {
      var se, U;
      if (!o.value) return null;
      const W = r.tabs.flatMap(
        (N) => N.to ? [{ id: N.id, resolved: a.resolve(N.to) }] : []
      ), ae = W.find(({ resolved: N }) => s.name != null && N.name != null ? N.name === s.name : N.path === s.path);
      if (ae) return ae.id;
      const G = (N) => s.path.startsWith(N.endsWith("/") ? N : `${N}/`);
      return ((se = W.filter(({ resolved: N }) => G(N.path)).sort((N, J) => J.resolved.path.length - N.resolved.path.length)[0]) == null ? void 0 : se.id) ?? ((U = r.tabs[0]) == null ? void 0 : U.id) ?? null;
    }), p = T(() => f.value ?? c.value), d = T(() => r.tabs.find((W) => W.id === p.value)), b = (W, ae = !0) => {
      const G = r.tabs.find((se) => se.id === W);
      if (!G || G.disabled) return;
      if (o.value) {
        if (G.id === p.value) return;
        const se = () => {
          G.to && a.push(G.to);
        };
        r.tabSelectionMode === "controlled" ? i("tabSelected", { tabId: W, callback: se, tab: G }) : (se(), i("tabSelected", { tabId: W, callback: () => {
        }, tab: G }));
        return;
      }
      const j = () => {
        c.value = W, r.useHash && ae && s && a && s.hash !== `#tab-${W}` && a.push({
          hash: `#tab-${W}`,
          query: s.query
        });
      };
      r.tabSelectionMode === "controlled" ? i("tabSelected", {
        tabId: W,
        callback: j,
        tab: G
      }) : (j(), i("tabSelected", {
        tabId: W,
        callback: () => {
        },
        // Already switched, callback is no-op
        tab: G
      }));
    };
    Le(
      () => r.reset,
      (W) => {
        W && r.tabs.length > 0 && b(r.tabs[0].id);
      }
    ), et(() => {
      const W = () => {
        !o.value && r.useHash && s && a && s.hash !== `#tab-${c.value}` && a.replace({
          hash: `#tab-${c.value}`,
          query: s.query
        });
      }, ae = r.tabs.find((G) => G.id === p.value);
      W(), i("tabSelected", {
        tabId: p.value,
        callback: () => {
        },
        // Already initialized, callback is no-op
        tab: ae
      });
    });
    const m = (W) => p.value === W, k = (W) => m(W) && !o.value ? `${l}-tabpanel-${W}` : void 0, y = Xe("nav"), h = ee(null), g = T(() => {
      const W = C.value.filter((G) => !G.disabled), ae = W.find((G) => G.id === h.value) ?? W.find((G) => G.id === p.value) ?? W[0];
      return (ae == null ? void 0 : ae.id) ?? null;
    }), x = (W) => {
      var U;
      if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(W.key) || !y.value) return;
      const G = Array.from(y.value.querySelectorAll("[role=tab]")).filter((N) => N.getAttribute("aria-disabled") !== "true");
      if (G.length === 0) return;
      const j = G.indexOf(document.activeElement);
      let se = j;
      W.key === "ArrowRight" ? se = (j + 1) % G.length : W.key === "ArrowLeft" ? se = (j - 1 + G.length) % G.length : W.key === "Home" ? se = 0 : se = G.length - 1, W.preventDefault(), (U = G[se]) == null || U.focus();
    }, S = ee(null), C = ee([...r.tabs]), _ = ee([]), O = ee(/* @__PURE__ */ new Map()), I = () => {
      if (!S.value || r.tabs.length === 0) return;
      const W = S.value, ae = W.offsetWidth;
      if (ae === 0) return;
      W.querySelectorAll(".v-tabs__tab").forEach((de) => {
        const he = de.getAttribute("data-tab-id");
        if (!he) return;
        const ge = r.tabs.find(($e) => String($e.id) === he);
        ge && de && O.value.set(ge.id, de.offsetWidth);
      });
      let j = 0;
      const se = [];
      for (const de of r.tabs) {
        const he = O.value.get(de.id) || 150;
        se.push(he), j += he;
      }
      if (j <= ae) {
        C.value = [...r.tabs], _.value = [];
        return;
      }
      const U = ae - ZT;
      let N = 0, J = 0;
      for (let de = 0; de < r.tabs.length; de++) {
        const he = se[de];
        if (N + he <= U)
          N += he, J = de + 1;
        else
          break;
      }
      C.value = r.tabs.slice(0, J), _.value = r.tabs.slice(J);
    }, D = T(() => _.value.map((W) => ({
      label: W.count !== void 0 ? `${W.label} (${aa(W.count)})` : W.label,
      value: W.id,
      icon: W.icon,
      disabled: W.disabled,
      active: W.id === p.value
    }))), B = (W) => {
      b(W);
    };
    let Y = null, ne = null;
    return et(async () => {
      await Ge(), await Ge(), S.value && (I(), Y = new ResizeObserver(() => {
        ne && clearTimeout(ne), ne = setTimeout(() => {
          I();
        }, 100);
      }), Y.observe(S.value));
    }), Fs(() => {
      ne && clearTimeout(ne), Y && S.value && (Y.unobserve(S.value), Y.disconnect());
    }), Le(() => r.tabs, async () => {
      await Ge(), I();
    }, { deep: !0 }), n({
      currentTabId: c,
      activeTabId: p,
      selectTab: b
    }), (W, ae) => (w(), M("div", {
      class: q(["v-tabs", { "v-tabs--modern": r.modern }])
    }, [
      r.tabs.length > 0 ? (w(), M("div", NT, [
        r.loading ? (w(), M("section", zT, [
          (w(!0), M(Te, null, Ie(r.tabs.length, (G) => (w(), M("div", {
            key: G,
            class: "v-tabs__skeleton-item"
          }))), 128))
        ])) : R("", !0),
        E("div", BT, [
          E("div", {
            ref_key: "tabsContainerRef",
            ref: S,
            class: "v-tabs__scroll"
          }, [
            E("nav", {
              ref: "nav",
              "aria-label": "Tabs navigation",
              class: "v-tabs__nav",
              role: "tablist",
              onKeydown: x
            }, [
              (w(!0), M(Te, null, Ie(C.value, (G) => (w(), M("button", {
                id: `${v(l)}-tab-${G.id}`,
                key: G.id,
                "aria-controls": k(G.id),
                "aria-disabled": G.disabled,
                "aria-selected": m(G.id),
                class: q([
                  "v-tabs__tab",
                  {
                    "v-tabs__tab--active": m(G.id),
                    "v-tabs__tab--disabled": G.disabled
                  },
                  G.styles
                ]),
                "data-tab-id": G.id,
                tabindex: G.id === g.value ? 0 : -1,
                role: "tab",
                type: "button",
                onClick: (j) => b(G.id),
                onFocus: (j) => h.value = G.id
              }, [
                G.icon ? (w(), ue(be, {
                  key: 1,
                  icon: G.icon,
                  class: "v-tabs__tab-icon"
                }, null, 8, ["icon"])) : H(W.$slots, `tab-icon-${G.id}`, { key: 0 }, void 0, !0),
                E("span", YT, re(G.label), 1),
                G.count !== void 0 ? (w(), M("span", HT, re(v(aa)(G.count)), 1)) : R("", !0)
              ], 42, WT))), 128))
            ], 544)
          ], 512),
          _.value.length > 0 ? (w(), M("div", UT, [
            ie(Rs, {
              items: D.value,
              placement: "bottom-right",
              onSelect: B
            }, {
              trigger: ce(() => [
                ie(_t, { icon: "mdi:dots-horizontal" })
              ]),
              _: 1
            }, 8, ["items"])
          ])) : R("", !0)
        ]),
        W.$slots["tabs-right"] || e.actionsTargetId ? (w(), M("div", qT, [
          H(W.$slots, "tabs-right", { currentTabId: p.value }, void 0, !0),
          e.actionsTargetId ? (w(), M("div", {
            key: 0,
            id: e.actionsTargetId,
            class: "v-tabs__actions-target"
          }, null, 8, jT)) : R("", !0)
        ])) : R("", !0)
      ])) : R("", !0),
      !r.loading && !o.value ? (w(), M("div", {
        key: 1,
        id: `${v(l)}-tabpanel-${p.value}`,
        "aria-labelledby": `${v(l)}-tab-${p.value}`,
        class: "v-tabs__content",
        role: "tabpanel"
      }, [
        E("div", KT, [
          H(W.$slots, `${p.value}`, {}, () => {
            var G;
            return [
              (G = d.value) != null && G.component ? (w(), ue(mt(d.value.component), { key: 0 })) : R("", !0)
            ];
          }, !0)
        ])
      ], 8, GT)) : R("", !0)
    ], 2));
  }
}), OD = /* @__PURE__ */ ze(XT, [["__scopeId", "data-v-b967eba7"]]), tf = Symbol("tableModern"), Oa = () => yn(tf, T(() => !1)), JT = ["title"], vu = /* @__PURE__ */ ke({
  __name: "TableCell",
  props: {
    value: {},
    align: { default: "left" },
    depth: { default: 0 },
    isFirstColumn: { type: Boolean, default: !1 },
    row: {},
    column: {},
    colIndex: {},
    rowIndex: {},
    interactive: { type: Boolean, default: !1 },
    isExpanded: { type: Boolean, default: !1 }
  },
  emits: ["toggle-expand"],
  setup(e, { emit: n }) {
    const t = n, a = Ht(), s = Oa(), l = yn("tableCellMetadata", void 0), r = T(() => !e.row || !e.column || e.colIndex === void 0 || e.rowIndex === void 0 || !l ? null : l(e.row, e.column, e.colIndex, e.rowIndex)), i = T(() => {
      if (e.isFirstColumn && e.depth > 0)
        return `${e.depth * 24 + 16}px`;
    }), o = T(
      () => r.value ? r.value.formattedValue : e.value
    ), u = () => {
      if (!(e.interactive || a.default))
        return String(o.value);
    }, c = T(() => {
      var m;
      return !!((m = r.value) != null && m.isExpandable);
    }), f = T(() => !!e.row && !!e.column), p = T(() => {
      var m;
      return [
        {
          "v-table-cell--left": e.align === "left",
          "v-table-cell--center": e.align === "center",
          "v-table-cell--right": e.align === "right",
          "v-table-cell--indented": e.isFirstColumn && e.depth > 0,
          // Styling hook for `modern` (control-sized vertical padding). The legacy rule on this
          // class only touches .v-table-cell-text overflow, which interactive cells already leave visible.
          "v-table-cell--interactive": e.interactive
        },
        (m = r.value) == null ? void 0 : m.cssClass
      ];
    }), d = T(() => {
      var k, y;
      const m = (k = r.value) == null ? void 0 : k.indentStyle;
      return {
        paddingLeft: i.value,
        ...m ? { "--cell-indent": m.paddingLeft } : {},
        ...(y = r.value) == null ? void 0 : y.customStyle
      };
    }), b = () => {
      t("toggle-expand");
    };
    return (m, k) => (w(), M("div", {
      class: q([p.value, "v-table-cell"]),
      style: Fe(d.value)
    }, [
      f.value ? (w(), M(Te, { key: 0 }, [
        H(m.$slots, "pin"),
        c.value ? (w(), M("button", {
          key: 0,
          class: "v-table-cell-expand-btn",
          onClick: Ve(b, ["stop"])
        }, [
          ie(v(be), {
            icon: e.isExpanded ? "lucide:chevron-down" : "lucide:chevron-right",
            size: v(s) ? 14 : 18
          }, null, 8, ["icon", "size"])
        ])) : R("", !0),
        E("span", {
          title: u(),
          class: q([{ "v-table-cell-text--truncate": !e.interactive }, "v-table-cell-text"])
        }, [
          H(m.$slots, "default", {}, () => [
            He(re(o.value), 1)
          ])
        ], 10, JT)
      ], 64)) : H(m.$slots, "default", { key: 1 })
    ], 6));
  }
}), QT = ["title"], e$ = /* @__PURE__ */ ke({
  __name: "TableCellValue",
  props: {
    value: {},
    interactive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = T(() => e.interactive ? void 0 : String(e.value));
    return (t, a) => (w(), M("span", { title: n.value }, re(e.value), 9, QT));
  }
}), t$ = /* @__PURE__ */ ke({
  __name: "TableCheckboxCell",
  props: {
    checked: { type: Boolean },
    indeterminate: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = () => {
      t("toggle");
    };
    return (s, l) => (w(), M("div", {
      class: "v-table-checkbox-cell",
      onClick: l[0] || (l[0] = Ve(() => {
      }, ["stop"]))
    }, [
      ie(v(ed), {
        disabled: e.disabled,
        indeterminate: e.indeterminate,
        "model-value": e.checked,
        "onUpdate:modelValue": a
      }, null, 8, ["disabled", "indeterminate", "model-value"])
    ]));
  }
}), n$ = /* @__PURE__ */ ze(t$, [["__scopeId", "data-v-499acbc1"]]), a$ = [
  { key: "text", label: "Text", icon: "lucide:align-left", color: "secondaryText" },
  { key: "multi-text", label: "Multi-text", icon: "lucide:align-justify", color: "secondaryText" },
  { key: "number", label: "Number", icon: "lucide:hash", color: "primary" },
  { key: "decimal", label: "Decimal", icon: "lucide:percent", color: "primary" },
  { key: "boolean", label: "Boolean", icon: "lucide:toggle-right", color: "success" },
  { key: "date", label: "Date", icon: "lucide:calendar", color: "warning" },
  { key: "datetime", label: "Datetime", icon: "lucide:calendar-clock", color: "warning" },
  { key: "select", label: "Select", icon: "lucide:list", color: "primary" },
  { key: "multi-select", label: "Multi-select", icon: "lucide:list-checks", color: "primary" },
  { key: "color", label: "Color", icon: "lucide:palette", color: "error" },
  { key: "json", label: "JSON", icon: "lucide:braces", color: "error" },
  { key: "url", label: "URL", icon: "lucide:link", color: "secondaryText" },
  { key: "link", label: "Link", icon: "lucide:external-link", color: "secondaryText" },
  { key: "asset", label: "Asset", icon: "lucide:image", color: "info" },
  { key: "multi-asset", label: "Multi-asset", icon: "lucide:images", color: "info" },
  { key: "sys", label: "File", icon: "lucide:file", color: "info" }
], _D = (e) => e;
function os(e) {
  return new Promise((n, t) => {
    e.oncomplete = e.onsuccess = () => n(e.result), e.onabort = e.onerror = () => t(e.error);
  });
}
function nf(e, n) {
  let t;
  const a = () => {
    if (t)
      return t;
    const s = indexedDB.open(e);
    return s.onupgradeneeded = () => s.result.createObjectStore(n), t = os(s), t.then((l) => {
      l.onclose = () => t = void 0;
    }, () => {
    }), t;
  };
  return (s, l) => a().then((r) => l(r.transaction(n, s).objectStore(n)));
}
let Mr;
function Xl() {
  return Mr || (Mr = nf("keyval-store", "keyval")), Mr;
}
function pu(e, n = Xl()) {
  return n("readonly", (t) => os(t.get(e)));
}
function s$(e, n, t = Xl()) {
  return t("readwrite", (a) => (a.put(n, e), os(a.transaction)));
}
function gu(e, n = Xl()) {
  return n("readwrite", (t) => (t.delete(e), os(t.transaction)));
}
function l$(e, n) {
  return e.openCursor().onsuccess = function() {
    this.result && (n(this.result), this.result.continue());
  }, os(e.transaction);
}
function yu(e = Xl()) {
  return e("readonly", (n) => {
    if (n.getAllKeys)
      return os(n.getAllKeys());
    const t = [];
    return l$(n, (a) => t.push(a.key)).then(() => t);
  });
}
const r$ = {
  deserialize: JSON.parse,
  dialect: "redis",
  serialize: JSON.stringify,
  dbName: "keyv",
  storeName: "keyv"
};
class i$ {
  constructor(n) {
    this.ttlSupport = !1, this.namespace = "", this.opts = Object.assign({}, r$, n), this.store = nf(this.opts.dbName, this.opts.storeName);
  }
  _getKey(n) {
    return this.namespace ? `${this.namespace}${n}` : n;
  }
  _innerKeyToKey(n) {
    return this.namespace && n.startsWith(this.namespace) ? n.slice(this.namespace.length) : n;
  }
  on(n, t) {
    return this;
  }
  async get(n) {
    try {
      const t = await pu(this._getKey(n), this.store);
      return t ?? void 0;
    } catch {
    }
  }
  async getMany(n) {
    return Promise.all(n.map((t) => this.get(t)));
  }
  /**
   * Note: `await kv.set()` will wait <options.writeDelay> millseconds to save to disk, it would be slow. Please remove `await` if you find performance issues.
   * @param key
   * @param value
   * @param ttl
   * @returns
   */
  async set(n, t, a) {
    return s$(this._getKey(n), t, this.store);
  }
  async delete(n) {
    let t = await this.has(n);
    return await gu(this._getKey(n), this.store), t;
  }
  async deleteMany(n) {
    return (await Promise.all(n.map((a) => this.delete(a)))).every((a) => a);
  }
  async clear() {
    let n = await yu(this.store), t = [];
    for (let a = 0; a < n.length; a++) {
      const s = n[a];
      typeof s == "string" && s.startsWith(this.namespace) && t.push(gu(s, this.store));
    }
    await Promise.all(t);
  }
  async has(n) {
    return await this.get(n) !== void 0;
  }
  disconnect() {
    return Promise.resolve();
  }
  async *iterator(n = this.namespace) {
    let t = await yu(this.store);
    for (let a = 0; a < t.length; a++) {
      let s = t[a];
      typeof s == "string" && (!n || s.startsWith(n)) && (yield [s, await pu(s, this.store)]);
    }
  }
}
class o$ {
  constructor(n = "table-configs") {
    xe(this, "keyv");
    this.keyv = new i$({
      dbName: n,
      storeName: "keyv",
      namespace: n
    });
  }
  async get(n) {
    try {
      return await this.keyv.get(n) ?? null;
    } catch (t) {
      return console.error("IndexedDB get error:", t), null;
    }
  }
  async set(n, t) {
    try {
      await this.keyv.set(n, t);
    } catch (a) {
      throw console.error("IndexedDB set error:", a), a;
    }
  }
  async delete(n) {
    try {
      await this.keyv.delete(n);
    } catch (t) {
      throw console.error("IndexedDB delete error:", t), t;
    }
  }
  async clear() {
    try {
      await this.keyv.clear();
    } catch (n) {
      throw console.error("IndexedDB clear error:", n), n;
    }
  }
}
class bu {
  constructor(n = "localStorage") {
    xe(this, "storage");
    this.storage = n === "sessionStorage" ? sessionStorage : localStorage;
  }
  get(n) {
    try {
      const t = this.storage.getItem(n);
      return Promise.resolve(t ? JSON.parse(t) : null);
    } catch (t) {
      return console.error("WebStorage get error:", t), Promise.resolve(null);
    }
  }
  set(n, t) {
    try {
      return this.storage.setItem(n, JSON.stringify(t)), Promise.resolve();
    } catch (a) {
      return console.error("WebStorage set error:", a), a instanceof DOMException && a.name === "QuotaExceededError" && console.warn("Storage quota exceeded, consider using IndexedDB"), Promise.reject(a);
    }
  }
  delete(n) {
    try {
      return this.storage.removeItem(n), Promise.resolve();
    } catch (t) {
      return console.error("WebStorage delete error:", t), Promise.reject(t);
    }
  }
  clear() {
    try {
      return this.storage.clear(), Promise.resolve();
    } catch (n) {
      return console.error("WebStorage clear error:", n), Promise.reject(n);
    }
  }
}
function wu(e = "indexedDB", n) {
  switch (e) {
    case "indexedDB":
      return new o$(n);
    case "localStorage":
      return new bu("localStorage");
    case "sessionStorage":
      return new bu("sessionStorage");
    default:
      throw new Error(`Unknown storage type: ${e}`);
  }
}
const va = class va {
  constructor() {
    xe(this, "adapter");
    xe(this, "storageType");
    this.storageType = "indexedDB", this.adapter = wu(this.storageType, "table-configs");
  }
  static getInstance() {
    return va.instance || (va.instance = new va()), va.instance;
  }
  /**
     * Change storage type globally
     * Useful for testing or fallback scenarios
     */
  setStorageType(n, t) {
    this.storageType = n, this.adapter = wu(n, t);
  }
  getStorageType() {
    return this.storageType;
  }
  getAdapter() {
    return this.adapter;
  }
  /**
     * Get table configuration
     */
  getTableConfig(n) {
    return this.adapter.get(n);
  }
  /**
     * Save table configuration
     */
  async setTableConfig(n, t) {
    await this.adapter.set(n, t);
  }
  /**
     * Delete table configuration
     */
  async deleteTableConfig(n) {
    await this.adapter.delete(n);
  }
  /**
     * Clear all table configurations
     */
  async clearAllConfigs() {
    await this.adapter.clear();
  }
};
xe(va, "instance");
let si = va;
const ns = si.getInstance(), _l = (e, n) => (n && ns.setStorageType(n), ns.getTableConfig(e)), af = async (e, n, t) => {
  t && ns.setStorageType(t), await ns.setTableConfig(e, n);
}, u$ = { class: "column-picker" }, c$ = { class: "column-picker-header" }, d$ = { class: "column-picker-header-title" }, f$ = { class: "column-picker-body" }, h$ = { class: "column-picker-panel column-picker-panel--left" }, m$ = { class: "column-picker-panel-header" }, v$ = { class: "column-picker-panel-count" }, p$ = { class: "cp-toolbar" }, g$ = { class: "cp-search" }, y$ = { class: "cp-sort-group" }, b$ = { class: "column-picker-panel-list" }, w$ = ["onClick"], k$ = ["onClick"], x$ = {
  key: 0,
  class: "cp-type-group-header"
}, S$ = { class: "cp-type-group-label" }, T$ = ["onClick"], $$ = {
  key: 0,
  class: "cp-type-icon"
}, M$ = { class: "cp-available-item-label" }, C$ = {
  class: "cp-available-item-toggle",
  "aria-hidden": "true"
}, D$ = ["onClick"], O$ = {
  key: 0,
  class: "column-picker-empty"
}, _$ = { class: "column-picker-panel column-picker-panel--right" }, E$ = { class: "column-picker-panel-header" }, I$ = { class: "column-picker-panel-search" }, A$ = { class: "column-picker-panel-list" }, P$ = ["draggable", "onDragover", "onDragstart", "onDrop"], R$ = { class: "cp-selected-item-drag" }, F$ = {
  key: 0,
  class: "cp-type-icon"
}, V$ = { class: "cp-selected-item-label" }, L$ = ["title", "onClick"], N$ = ["onClick"], z$ = {
  key: 0,
  class: "column-picker-empty"
}, B$ = { class: "column-picker-footer" }, W$ = {
  key: 0,
  class: "column-picker-footer-hint column-picker-footer-hint--limit"
}, Y$ = {
  key: 1,
  class: "column-picker-footer-hint"
}, Cr = 6, Dr = 40, H$ = /* @__PURE__ */ ke({
  __name: "TableColumnPicker",
  props: {
    groups: {},
    columns: {},
    originalColumns: {},
    loading: { type: Boolean, default: !1 },
    storageKey: {},
    storageType: {},
    types: {}
  },
  emits: ["update:visible-columns", "close"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = ee(""), l = ee("alpha"), r = ee(/* @__PURE__ */ new Set()), i = ee(/* @__PURE__ */ new Set());
    Le(l, () => {
      i.value = /* @__PURE__ */ new Set();
    });
    const o = (A) => {
      if (r.value.has(A)) {
        r.value.delete(A);
        const z = new Set(i.value);
        z.delete(A), i.value = z;
      } else
        r.value.add(A);
      r.value = new Set(r.value);
    }, u = T(() => {
      const A = s.value.trim().toLowerCase();
      return A ? t.groups.map((z) => ({
        ...z,
        items: z.items.filter(($) => $.label.toLowerCase().includes(A))
      })).filter((z) => z.items.length > 0) : t.groups;
    });
    Le(s, (A) => {
      A.trim() ? r.value = new Set(u.value.map((z) => z.key)) : r.value = /* @__PURE__ */ new Set();
    });
    const c = T(() => {
      const A = a$.map((z) => ({ ...z }));
      for (const z of t.types ?? []) {
        const $ = A.findIndex((F) => F.key === z.key);
        $ === -1 ? A.push(z) : A[$] = z;
      }
      return A;
    }), f = T(
      () => new Map(c.value.map((A) => [A.key, A]))
    ), p = T(
      () => new Map(c.value.map((A, z) => [A.key, z]))
    ), d = (A) => {
      const z = A.replace(/[-_]/g, " ").trim();
      return z.charAt(0).toUpperCase() + z.slice(1);
    }, b = (A) => {
      var z;
      return ((z = f.value.get(A)) == null ? void 0 : z.label) ?? d(A);
    }, m = (A) => {
      const z = A ? f.value.get(A) : void 0;
      return (z == null ? void 0 : z.icon) ?? "lucide:help-circle";
    }, k = (A) => {
      const z = A ? f.value.get(A) : void 0;
      return (z == null ? void 0 : z.color) ?? "secondaryText";
    };
    function y(A) {
      const z = new Set(i.value);
      z.add(A), i.value = z;
    }
    function h(A) {
      const z = [...A.items];
      return l.value === "alpha" ? z.sort(($, F) => {
        const P = $.label.toLowerCase().trim(), Q = F.label.toLowerCase().trim();
        return P < Q ? -1 : P > Q ? 1 : 0;
      }) : z.sort(($, F) => {
        const P = p.value.get($.icon ?? "") ?? Number.MAX_SAFE_INTEGER, Q = p.value.get(F.icon ?? "") ?? Number.MAX_SAFE_INTEGER;
        if (P !== Q) return P - Q;
        if (P === Number.MAX_SAFE_INTEGER) {
          const Me = $.icon ?? "", Re = F.icon ?? "";
          if (Me !== Re) return Me < Re ? -1 : 1;
        }
        const L = $.label.toLowerCase().trim(), fe = F.label.toLowerCase().trim();
        return L < fe ? -1 : L > fe ? 1 : 0;
      });
    }
    function g(A) {
      return !s.value.trim() && !i.value.has(A.key) && h(A).length > Cr;
    }
    const x = (A) => {
      if (!(s.value.trim() || i.value.has(A.key)))
        return Cr;
    }, S = (A) => {
      const z = h(A), $ = x(A);
      if (l.value !== "by-type")
        return ($ !== void 0 ? z.slice(0, $) : z).map((fe) => ({ isHeader: !1, key: fe.key, item: fe }));
      const F = /* @__PURE__ */ new Map();
      for (const L of z) {
        const fe = L.icon ?? "", Me = F.get(fe);
        Me ? Me.push(L) : F.set(fe, [L]);
      }
      const P = [];
      let Q = 0;
      for (const [L, fe] of F) {
        if ($ !== void 0 && Q >= $) break;
        P.push({ isHeader: !0, key: `hdr-${L}`, typeKey: L });
        for (const Me of fe) {
          if ($ !== void 0 && Q >= $) break;
          P.push({ isHeader: !1, key: Me.key, item: Me }), Q += 1;
        }
      }
      return P;
    }, C = ee([]), _ = ee([]), O = (A, z = !1) => {
      if (A) {
        const $ = /* @__PURE__ */ new Map();
        t.groups.forEach((P) => P.items.forEach((Q) => $.set(Q.key, Q)));
        const F = A.order.filter((P) => A.visible.includes(P)).map((P) => {
          var _e, Ye;
          const Q = t.columns.find((At) => At.key === P), L = $.get(P), fe = (Q == null ? void 0 : Q.label) ?? (L == null ? void 0 : L.label) ?? ((_e = A.labels) == null ? void 0 : _e[P]) ?? P, Me = (L == null ? void 0 : L.icon) ?? (Q == null ? void 0 : Q.icon), Re = (Ye = A.fixed) == null ? void 0 : Ye[P];
          return { key: P, label: fe, icon: Me, fixed: Re };
        }).filter((P) => P !== null);
        C.value = F;
      } else {
        const $ = z ? t.originalColumns ?? t.columns : t.columns;
        C.value = $.map((F) => ({
          key: F.key,
          label: F.label,
          icon: F.icon,
          fixed: F.fixed
        }));
      }
      _.value = JSON.parse(JSON.stringify(C.value));
    };
    et(async () => {
      if (t.storageKey)
        try {
          const A = await _l(t.storageKey, t.storageType);
          O(A);
          return;
        } catch (A) {
          console.error("[TableColumnPicker] Failed to load from storage:", A);
        }
      O();
    });
    const I = ee(""), D = T(() => {
      const A = I.value.trim().toLowerCase();
      return A ? C.value.filter((z) => z.label.toLowerCase().includes(A)) : C.value;
    }), B = T(() => new Set(C.value.map((A) => A.key))), Y = T(() => C.value.length >= Dr), ne = T(
      () => t.groups.reduce((A, z) => A + z.items.length, 0)
    );
    function W(A) {
      return A.items.filter((z) => B.value.has(z.key)).length;
    }
    function ae(A) {
      return A.items.length > 0 && A.items.every((z) => B.value.has(z.key));
    }
    function G(A) {
      if (ae(A)) {
        const z = new Set(A.items.map(($) => $.key));
        C.value = C.value.filter(($) => z.has($.key) ? !!$.fixed : !0);
      } else {
        const z = A.items.filter((F) => !B.value.has(F.key)), $ = Dr - C.value.length;
        C.value = [
          ...C.value,
          ...z.slice(0, $).map((F) => ({ key: F.key, label: F.label, icon: F.icon }))
        ];
      }
    }
    const j = (A) => {
      !B.value.has(A.key) && !Y.value && (C.value = [...C.value, { key: A.key, label: A.label, icon: A.icon }]);
    }, se = (A) => {
      const z = C.value.find(($) => $.key === A);
      z != null && z.fixed || (C.value = C.value.filter(($) => $.key !== A));
    }, U = (A) => {
      B.value.has(A.key) ? se(A.key) : j(A);
    }, N = async () => {
      if (t.storageKey)
        try {
          await ns.deleteTableConfig(t.storageKey);
        } catch (P) {
          console.error("[TableColumnPicker] Failed to clear storage:", P);
        }
      O(null, !0);
      const A = t.originalColumns ?? t.columns, z = new Map(A.map((P) => [P.key, P])), $ = /* @__PURE__ */ new Map();
      t.groups.forEach((P) => P.items.forEach((Q) => $.set(Q.key, Q)));
      const F = C.value.map((P) => {
        const Q = z.get(P.key);
        if (Q) return { ...Q, fixed: P.fixed };
        const L = $.get(P.key);
        return {
          key: P.key,
          label: P.label,
          fixed: P.fixed,
          sortable: L == null ? void 0 : L.sortable,
          format: L == null ? void 0 : L.format
        };
      });
      a("update:visible-columns", F), a("close");
    }, J = (A) => A === 0 || A === 1, de = (A) => A.fixed === "left", he = (A) => {
      !J(A) || !C.value[A] || (C.value = C.value.map(
        ($, F) => F === A ? { ...$, fixed: $.fixed === "left" ? void 0 : "left" } : $
      ));
    }, ge = () => {
      C.value = C.value.map(
        (A, z) => A.fixed === "left" && !J(z) ? { ...A, fixed: void 0 } : A
      );
    }, $e = ee(null), we = ee(null), X = (A, z) => {
      I.value.trim() || ($e.value = A, z.dataTransfer && (z.dataTransfer.effectAllowed = "move", z.dataTransfer.setData("text/html", "")));
    }, ve = (A, z) => {
      z.preventDefault(), z.dataTransfer && (z.dataTransfer.dropEffect = "move"), we.value = A;
    }, Ce = (A, z) => {
      if (z.preventDefault(), $e.value === null || $e.value === A) {
        $e.value = null, we.value = null;
        return;
      }
      const $ = [...C.value], [F] = $.splice($e.value, 1);
      $.splice(A, 0, F), C.value = $, ge(), $e.value = null, we.value = null;
    }, V = () => {
      $e.value = null, we.value = null;
    }, Z = async (A) => {
      if (!t.storageKey) return;
      const z = {}, $ = {};
      A.forEach((P) => {
        P.fixed && (z[P.key] = P.fixed), $[P.key] = P.label;
      });
      const F = {
        visible: A.map((P) => P.key),
        order: A.map((P) => P.key),
        fixed: Object.keys(z).length > 0 ? z : void 0,
        labels: $
      };
      try {
        await af(t.storageKey, F, t.storageType);
      } catch (P) {
        console.error("[TableColumnPicker] Failed to save to storage:", P);
      }
    }, me = T(
      () => JSON.stringify(C.value) !== JSON.stringify(_.value)
    ), K = async () => {
      const A = new Map(t.columns.map((F) => [F.key, F])), z = /* @__PURE__ */ new Map();
      t.groups.forEach((F) => F.items.forEach((P) => z.set(P.key, P)));
      const $ = C.value.map((F) => {
        const P = A.get(F.key);
        if (P) return { ...P, fixed: F.fixed };
        const Q = z.get(F.key);
        return {
          key: F.key,
          label: F.label,
          fixed: F.fixed,
          sortable: Q == null ? void 0 : Q.sortable,
          format: Q == null ? void 0 : Q.format
        };
      });
      await Z(C.value), a("update:visible-columns", $), _.value = JSON.parse(JSON.stringify(C.value)), a("close");
    }, oe = () => {
      C.value = JSON.parse(JSON.stringify(_.value)), a("close");
    };
    function ye(A) {
      return A ? { "--cp-type-color-raw": `var(--color-${k(A)})` } : {};
    }
    return (A, z) => (w(), M("div", u$, [
      E("div", c$, [
        E("div", d$, [
          ie(v(be), {
            size: 24,
            icon: "lucide:columns",
            variant: "link"
          }),
          z[5] || (z[5] = E("span", null, "Edit columns", -1))
        ]),
        E("button", {
          class: "column-picker-close-btn",
          title: "Close",
          onClick: oe
        }, [
          ie(v(be), {
            size: 16,
            icon: "lucide:x"
          })
        ])
      ]),
      E("div", f$, [
        E("div", h$, [
          E("div", m$, [
            E("span", v$, re(ne.value) + " columns available ", 1)
          ]),
          E("div", p$, [
            E("div", g$, [
              ie(v(be), {
                size: 11,
                icon: "lucide:search"
              }),
              an(E("input", {
                "onUpdate:modelValue": z[0] || (z[0] = ($) => s.value = $),
                placeholder: "Search…"
              }, null, 512), [
                [Iu, s.value]
              ])
            ]),
            E("div", y$, [
              E("button", {
                class: q([{ "cp-sort-btn--active": l.value === "by-type" }, "cp-sort-btn"]),
                title: "Group by type",
                type: "button",
                onClick: z[1] || (z[1] = ($) => l.value = "by-type")
              }, [
                ie(v(be), {
                  size: 10,
                  icon: "lucide:group"
                })
              ], 2),
              z[6] || (z[6] = E("div", { class: "cp-sort-divider" }, null, -1)),
              E("button", {
                class: q([{ "cp-sort-btn--active": l.value === "alpha" }, "cp-sort-btn"]),
                title: "Sort alphabetically",
                type: "button",
                onClick: z[2] || (z[2] = ($) => l.value = "alpha")
              }, " A→Z ", 2)
            ])
          ]),
          E("div", b$, [
            e.loading ? (w(), M(Te, { key: 0 }, Ie(6, ($) => E("div", {
              key: $,
              class: "column-picker-skeleton"
            })), 64)) : (w(), M(Te, { key: 1 }, [
              (w(!0), M(Te, null, Ie(u.value, ($) => (w(), M("div", {
                key: $.key
              }, [
                E("div", {
                  class: "cp-group-header",
                  onClick: (F) => o($.key)
                }, [
                  E("span", {
                    class: q([{ "cp-group-label--has-selection": W($) > 0 }, "cp-group-label"])
                  }, re($.label), 3),
                  E("button", {
                    class: "cp-group-select-btn",
                    type: "button",
                    onClick: Ve((F) => G($), ["stop"])
                  }, re(ae($) ? "Deselect all" : "Select all"), 9, k$),
                  E("span", {
                    class: q([W($) > 0 ? "cp-group-badge--selected" : "cp-group-badge--empty", "cp-group-badge"])
                  }, re(W($)) + "/" + re($.items.length), 3),
                  ie(v(be), {
                    class: q([{ "cp-group-chevron--open": r.value.has($.key) }, "cp-group-chevron"]),
                    size: 10,
                    icon: "lucide:chevron-right"
                  }, null, 8, ["class"])
                ], 8, w$),
                r.value.has($.key) ? (w(), M(Te, { key: 0 }, [
                  (w(!0), M(Te, null, Ie(S($), (F) => (w(), M(Te, {
                    key: F.key
                  }, [
                    F.isHeader && F.typeKey ? (w(), M("div", x$, [
                      E("div", {
                        style: Fe({ background: `rgb(var(--color-${k(F.typeKey)}))` }),
                        class: "cp-type-group-dot"
                      }, null, 4),
                      E("span", S$, re(b(F.typeKey)), 1)
                    ])) : F.item ? (w(), M("div", {
                      key: 1,
                      class: q([{ "cp-available-item--selected": B.value.has(F.item.key) }, "cp-available-item"]),
                      style: Fe(ye(F.item.icon)),
                      onClick: (P) => U(F.item)
                    }, [
                      F.item.icon ? (w(), M("div", $$, [
                        ie(v(be), {
                          icon: m(F.item.icon),
                          size: 9
                        }, null, 8, ["icon"])
                      ])) : R("", !0),
                      E("span", M$, re(F.item.label), 1),
                      E("span", C$, [
                        ie(v(be), {
                          icon: B.value.has(F.item.key) ? "lucide:check" : "lucide:plus",
                          size: B.value.has(F.item.key) ? 10 : 9
                        }, null, 8, ["icon", "size"])
                      ])
                    ], 14, T$)) : R("", !0)
                  ], 64))), 128)),
                  g($) ? (w(), M("button", {
                    key: 0,
                    class: "cp-show-more-btn",
                    type: "button",
                    onClick: Ve((F) => y($.key), ["stop"])
                  }, " Show " + re(h($).length - Cr) + " more ", 9, D$)) : R("", !0)
                ], 64)) : R("", !0)
              ]))), 128)),
              u.value.length === 0 ? (w(), M("div", O$, " No columns match your search ")) : R("", !0)
            ], 64))
          ])
        ]),
        z[8] || (z[8] = E("div", { class: "column-picker-divider" }, null, -1)),
        E("div", _$, [
          E("div", E$, [
            E("span", {
              class: q([{ "column-picker-panel-count--limit": Y.value }, "column-picker-panel-count"])
            }, re(C.value.length) + " selected ", 3),
            E("button", {
              class: "column-picker-text-btn",
              onClick: N
            }, [
              ie(v(be), {
                size: 12,
                icon: "lucide:rotate-ccw"
              }),
              z[7] || (z[7] = He(" Reset to default ", -1))
            ])
          ]),
          E("div", I$, [
            ie(v(Ol), {
              modelValue: I.value,
              "onUpdate:modelValue": z[3] || (z[3] = ($) => I.value = $),
              name: "Search",
              placeholder: "Search by column name",
              type: "search"
            }, null, 8, ["modelValue"])
          ]),
          E("div", A$, [
            (w(!0), M(Te, null, Ie(D.value, ($, F) => (w(), M("div", {
              key: $.key,
              class: q([{
                "cp-selected-item--dragging": $e.value === F,
                "cp-selected-item--drag-over": we.value === F,
                "cp-selected-item--locked": !!$.fixed
              }, "cp-selected-item"]),
              draggable: !$.fixed && !I.value,
              style: Fe(ye($.icon)),
              onDragend: V,
              onDragleave: z[4] || (z[4] = (P) => we.value = null),
              onDragover: (P) => ve(F, P),
              onDragstart: (P) => X(F, P),
              onDrop: (P) => Ce(F, P)
            }, [
              E("div", R$, [
                ie(v(be), {
                  size: 14,
                  icon: $.fixed ? "lucide:lock" : "lucide:grip-vertical"
                }, null, 8, ["icon"])
              ]),
              $.icon ? (w(), M("div", F$, [
                ie(v(be), {
                  icon: m($.icon),
                  size: 9
                }, null, 8, ["icon"])
              ])) : R("", !0),
              E("span", V$, re($.label), 1),
              J(F) && !I.value ? (w(), M("button", {
                key: 1,
                class: q([{ "cp-selected-item-pin--active": de($) }, "cp-selected-item-pin"]),
                title: de($) ? "Unpin column" : "Pin column to left",
                onClick: Ve((P) => he(F), ["stop"])
              }, [
                ie(v(be), {
                  icon: de($) ? "lucide:pin" : "lucide:pin-off",
                  size: 12
                }, null, 8, ["icon"])
              ], 10, L$)) : R("", !0),
              $.fixed ? R("", !0) : (w(), M("button", {
                key: 2,
                class: "cp-selected-item-remove",
                title: "Remove column",
                onClick: (P) => se($.key)
              }, [
                ie(v(be), {
                  size: 12,
                  icon: "lucide:x"
                })
              ], 8, N$))
            ], 46, P$))), 128)),
            C.value.length === 0 ? (w(), M("div", z$, " No columns selected. Use the left panel to add columns. ")) : R("", !0)
          ])
        ])
      ]),
      E("div", B$, [
        Y.value ? (w(), M("span", W$, [
          ie(v(be), {
            size: 24,
            icon: "lucide:alert-circle"
          }),
          He(" Max " + re(Dr) + " columns reached ")
        ])) : (w(), M("span", Y$, [
          ie(v(be), {
            size: 24,
            icon: "lucide:info"
          }),
          z[9] || (z[9] = He(" Drag to reorder · Pin first 2 columns ", -1))
        ])),
        ie(v(_t), {
          disabled: !me.value,
          class: "h-[30px]",
          text: "Apply",
          variant: "primary",
          onClick: K
        }, null, 8, ["disabled"])
      ])
    ]));
  }
}), U$ = { class: "column-setup" }, q$ = {
  key: 0,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, j$ = {
  key: 1,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, G$ = {
  key: 2,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, K$ = { class: "column-setup-toggle-count" }, Z$ = ["draggable", "onDragover", "onDragstart", "onDrop"], X$ = {
  key: 0,
  class: "column-setup-item-drag"
}, J$ = ["title", "onClick"], Q$ = {
  key: 0,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, eM = {
  key: 1,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, tM = ["title", "onClick"], nM = {
  key: 2,
  class: "column-setup-item-badge column-setup-item-badge--warning",
  title: "Fixed will be removed — move to top 2 positions"
}, aM = { class: "column-setup-footer" }, sM = {
  key: 0,
  class: "column-setup-hint"
}, ku = "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24", lM = /* @__PURE__ */ ke({
  __name: "TableColumnSetup",
  props: {
    columns: {},
    config: { default: () => ({}) }
  },
  emits: ["update:visible-columns", "close"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = async () => {
      var U;
      if (!((U = t.config) != null && U.key)) return null;
      try {
        return await _l(t.config.key, t.config.type);
      } catch (N) {
        return console.error("Failed to load column setup from storage:", N), null;
      }
    }, l = async (U) => {
      var N;
      if ((N = t.config) != null && N.key)
        try {
          const J = {};
          U.forEach((he) => {
            he.fixed && (J[he.key] = he.fixed);
          });
          const de = {
            visible: U.filter((he) => he.visible).map((he) => he.key),
            order: U.map((he) => he.key),
            fixed: Object.keys(J).length > 0 ? J : void 0
            // Only save if there are fixed columns
          };
          await af(t.config.key, de, t.config.type);
        } catch (J) {
          console.error("Failed to save column setup to storage:", J);
        }
    }, r = (U) => U.reduce((N, J) => J.children && J.children.length > 0 ? [...N, ...r(J.children)] : [...N, J], []), i = (U) => {
      var de;
      const N = r(t.columns);
      if (U) {
        const { visible: he, order: ge, fixed: $e } = U, we = new Map(N.map((ve) => [ve.key, ve])), X = [];
        return ge.forEach((ve, Ce) => {
          const V = we.get(ve);
          V && (X.push({
            key: V.key,
            label: V.label,
            visible: he.includes(ve),
            order: Ce,
            fixed: ($e == null ? void 0 : $e[ve]) || V.fixed
            // Use saved fixed state, fallback to column's fixed
          }), we.delete(ve));
        }), we.forEach((ve) => {
          X.push({
            key: ve.key,
            label: ve.label,
            visible: !0,
            order: X.length,
            fixed: ve.fixed
          });
        }), X;
      }
      const J = (de = t.config) == null ? void 0 : de.initialVisible;
      return N.map((he, ge) => ({
        key: he.key,
        label: he.label,
        // If initialVisible is provided, check if column is in the list
        // If not provided, all columns are visible by default
        visible: J ? J.includes(he.key) : !0,
        order: ge,
        fixed: he.fixed
      }));
    }, o = ee(i()), u = ee(JSON.parse(JSON.stringify(i())));
    s().then((U) => {
      if (U) {
        const N = i(U);
        o.value = N, u.value = JSON.parse(JSON.stringify(N));
      }
    });
    const c = T(() => JSON.stringify(o.value) !== JSON.stringify(u.value)), f = () => {
      const U = r(t.columns), J = o.value.filter((de) => de.visible).sort((de, he) => de.order - he.order).map((de) => {
        const he = U.find((ge) => ge.key === de.key);
        return he ? {
          ...he,
          fixed: de.fixed
        } : null;
      }).filter(Boolean);
      a("update:visible-columns", J);
    };
    Le(
      o,
      () => {
      },
      { deep: !0 }
    );
    const p = () => {
      l(o.value), f(), u.value = JSON.parse(JSON.stringify(o.value)), a("close");
    }, d = T(() => o.value.every((U) => U.visible)), b = T(() => o.value.every((U) => !U.visible)), m = T(() => !d.value && !b.value), k = T(() => o.value.filter((U) => U.visible).length), y = ee(null), h = ee(null), g = ee(null), x = ee(null), S = (U) => {
      if (!g.value) return;
      const N = g.value.getBoundingClientRect(), J = U.clientY, de = 50, he = 10;
      J < N.top + de && J > N.top ? x.value || (x.value = window.setInterval(() => {
        g.value && g.value.scrollTop > 0 && (g.value.scrollTop -= he);
      }, 16)) : J > N.bottom - de && J < N.bottom ? x.value || (x.value = window.setInterval(() => {
        if (g.value) {
          const ge = g.value.scrollHeight - g.value.clientHeight;
          g.value.scrollTop < ge && (g.value.scrollTop += he);
        }
      }, 16)) : C();
    }, C = () => {
      x.value && (clearInterval(x.value), x.value = null);
    }, _ = (U, N) => {
      var J;
      ((J = t.config) == null ? void 0 : J.allowReorder) !== !1 && (y.value = U, N.dataTransfer && (N.dataTransfer.effectAllowed = "move", N.dataTransfer.setData("text/html", "")));
    }, O = (U, N) => {
      var J;
      ((J = t.config) == null ? void 0 : J.allowReorder) !== !1 && (N.preventDefault(), N.dataTransfer && (N.dataTransfer.dropEffect = "move"), h.value = U, S(N));
    }, I = () => {
      h.value = null;
    }, D = (U, N) => {
      var he;
      if (((he = t.config) == null ? void 0 : he.allowReorder) === !1) return;
      if (N.preventDefault(), C(), y.value === null || y.value === U) {
        y.value = null, h.value = null;
        return;
      }
      const J = [...o.value], [de] = J.splice(y.value, 1);
      J.splice(U, 0, de), J.forEach((ge, $e) => {
        ge.order = $e;
      }), o.value = J, j(), y.value = null, h.value = null;
    }, B = () => {
      y.value = null, h.value = null, C();
    }, Y = (U) => {
      const N = o.value.find((J) => J.key === U);
      N && (N.visible = !N.visible);
    }, ne = () => {
      const U = !d.value;
      o.value.forEach((N) => {
        N.visible = U;
      });
    }, W = (U) => U === 0 || U === 1, ae = (U) => U.fixed === "left", G = (U) => {
      if (!W(U)) return;
      const N = o.value[U];
      N && (N.fixed === "left" ? N.fixed = void 0 : N.fixed = "left");
    }, j = () => {
      o.value.forEach((U, N) => {
        U.fixed === "left" && !W(N) && (U.fixed = void 0);
      });
    }, se = async () => {
      var U;
      if ((U = t.config) != null && U.key)
        try {
          await ns.deleteTableConfig(t.config.key);
        } catch (N) {
          console.error("Failed to clear storage:", N);
        }
      o.value = i(), f(), u.value = JSON.parse(JSON.stringify(o.value)), a("close");
    };
    return (U, N) => {
      var J;
      return w(), M("div", U$, [
        E("div", { class: "column-setup-header" }, [
          N[1] || (N[1] = E("span", { class: "column-setup-title" }, "Column Settings", -1)),
          E("button", {
            class: "column-setup-reset-btn",
            title: "Reset to default",
            onClick: se
          }, [...N[0] || (N[0] = [
            E("svg", {
              fill: "none",
              height: "13",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2.3",
              viewBox: "0 0 24 24",
              width: "13"
            }, [
              E("polyline", { points: "1 4 1 10 7 10" }),
              E("path", { d: "M3.51 15a9 9 0 1 0 .49-4.5" })
            ], -1)
          ])])
        ]),
        E("div", {
          class: "column-setup-toggle-all",
          onClick: ne
        }, [
          E("div", {
            class: q([{
              "column-setup-toggle-eye--none": b.value
            }, "column-setup-toggle-eye"])
          }, [
            d.value ? (w(), M("svg", q$, [...N[2] || (N[2] = [
              E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              E("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              }, null, -1)
            ])])) : m.value ? (w(), M("svg", j$, [...N[3] || (N[3] = [
              E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              E("line", {
                x1: "9",
                x2: "15",
                y1: "12",
                y2: "12"
              }, null, -1)
            ])])) : (w(), M("svg", G$, [
              E("path", { d: ku }),
              N[4] || (N[4] = E("line", {
                x1: "1",
                x2: "23",
                y1: "1",
                y2: "23"
              }, null, -1))
            ]))
          ], 2),
          N[5] || (N[5] = E("span", { class: "column-setup-toggle-label" }, "Show all columns", -1)),
          E("span", K$, re(k.value) + " / " + re(o.value.length), 1)
        ]),
        E("div", {
          ref_key: "listRef",
          ref: g,
          class: "column-setup-list"
        }, [
          (w(!0), M(Te, null, Ie(o.value, (de, he) => {
            var ge, $e, we;
            return w(), M("div", {
              key: de.key,
              class: q([{
                "column-setup-item--dragging": y.value === he,
                "column-setup-item--drag-over": h.value === he,
                "column-setup-item--no-reorder": ((ge = e.config) == null ? void 0 : ge.allowReorder) === !1
              }, "column-setup-item"]),
              draggable: (($e = e.config) == null ? void 0 : $e.allowReorder) !== !1,
              onDragend: B,
              onDragleave: I,
              onDragover: (X) => O(he, X),
              onDragstart: (X) => _(he, X),
              onDrop: (X) => D(he, X)
            }, [
              ((we = e.config) == null ? void 0 : we.allowReorder) !== !1 ? (w(), M("div", X$, [
                ie(v(be), {
                  size: 16,
                  icon: "lucide:grip-vertical"
                })
              ])) : R("", !0),
              E("button", {
                class: q([de.visible ? "column-setup-item-eye--visible" : "column-setup-item-eye--hidden", "column-setup-item-eye"]),
                title: de.visible ? "Hide column" : "Show column",
                onClick: Ve((X) => Y(de.key), ["stop"])
              }, [
                de.visible ? (w(), M("svg", Q$, [...N[6] || (N[6] = [
                  E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                  E("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3"
                  }, null, -1)
                ])])) : (w(), M("svg", eM, [
                  E("path", { d: ku }),
                  N[7] || (N[7] = E("line", {
                    x1: "1",
                    x2: "23",
                    y1: "1",
                    y2: "23"
                  }, null, -1))
                ]))
              ], 10, J$),
              E("div", {
                class: q([{ "column-setup-item-label--hidden": !de.visible }, "column-setup-item-label"])
              }, re(de.label), 3),
              W(he) ? (w(), M("button", {
                key: 1,
                class: q([{ "column-setup-item-fixed-btn--active": ae(de) }, "column-setup-item-fixed-btn"]),
                title: ae(de) ? "Unpin column" : "Pin column to left",
                onClick: Ve((X) => G(he), ["stop"])
              }, [
                ie(v(be), {
                  icon: ae(de) ? "lucide:pin" : "lucide:pin-off",
                  size: 16
                }, null, 8, ["icon"])
              ], 10, tM)) : R("", !0),
              de.fixed && !W(he) ? (w(), M("div", nM, [
                ie(v(be), {
                  size: 16,
                  icon: "lucide:triangle-alert"
                })
              ])) : R("", !0)
            ], 42, Z$);
          }), 128))
        ], 512),
        E("div", aM, [
          ((J = e.config) == null ? void 0 : J.allowReorder) !== !1 ? (w(), M("span", sM, [
            ie(v(be), {
              size: 11,
              icon: "lucide:grip-vertical"
            }),
            N[8] || (N[8] = He(" Drag to reorder ", -1))
          ])) : R("", !0),
          ie(v(_t), {
            disabled: !c.value,
            text: "Apply",
            variant: "primary",
            class: "h-[30px]",
            onClick: p
          }, null, 8, ["disabled"])
        ])
      ]);
    };
  }
}), rM = /* @__PURE__ */ ze(lM, [["__scopeId", "data-v-72a05d03"]]), iM = { class: "v-table-empty-state-content" }, oM = {
  key: 0,
  class: "v-table-empty-state-icon"
}, uM = {
  key: 1,
  class: "v-table-empty-state-title"
}, cM = {
  key: 2,
  class: "v-table-empty-state-description"
}, dM = /* @__PURE__ */ ke({
  __name: "TableEmptyState",
  props: {
    title: {},
    description: {},
    icon: {}
  },
  setup(e) {
    const n = Oa(), t = yn("tableSlots", {}), a = (s, { slots: l }) => H({ default: t.emptyState }, "default", {}, l.default);
    return (s, l) => (w(), M("div", {
      class: q([{ "v-table-empty-state--modern": v(n) }, "v-table-empty-state"])
    }, [
      E("div", iM, [
        ie(a, null, {
          default: ce(() => [
            e.icon ? (w(), M("div", oM, [
              ie(v(be), {
                icon: e.icon,
                size: v(n) ? 40 : 48
              }, null, 8, ["icon", "size"])
            ])) : R("", !0),
            e.title ? (w(), M("h3", uM, re(e.title), 1)) : R("", !0),
            e.description ? (w(), M("p", cM, re(e.description), 1)) : R("", !0)
          ]),
          _: 1
        })
      ])
    ], 2));
  }
}), fM = /* @__PURE__ */ ze(dM, [["__scopeId", "data-v-57210eab"]]), hM = ["aria-label", "title"], mM = /* @__PURE__ */ ke({
  __name: "TableFullscreenToggle",
  props: {
    isFullscreen: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = T(() => e.isFullscreen ? "Collapse table" : "Expand table"), s = T(() => e.isFullscreen ? "lucide:minimize-2" : "lucide:maximize-2");
    return (l, r) => (w(), M("button", {
      "aria-label": a.value,
      class: q([{ "v-table-fullscreen-toggle--active": e.isFullscreen }, "v-table-fullscreen-toggle"]),
      title: a.value,
      type: "button",
      onClick: r[0] || (r[0] = (i) => t("toggle"))
    }, [
      ie(v(be), {
        icon: s.value,
        size: 15
      }, null, 8, ["icon"])
    ], 10, hM));
  }
}), vM = /* @__PURE__ */ ke({
  __name: "TableHeaderCheckbox",
  props: {
    state: {},
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = () => {
      t.disabled || a("toggle");
    };
    return (l, r) => (w(), M("div", {
      class: "v-table-header-checkbox-cell",
      onClick: r[0] || (r[0] = Ve(() => {
      }, ["stop"]))
    }, [
      ie(v(ed), {
        disabled: e.disabled,
        indeterminate: e.state === "indeterminate",
        "model-value": e.state === "checked",
        "onUpdate:modelValue": s
      }, null, 8, ["disabled", "indeterminate", "model-value"])
    ]));
  }
}), pM = /* @__PURE__ */ ze(vM, [["__scopeId", "data-v-b48644bb"]]), gM = ["aria-label", "aria-pressed"], sf = /* @__PURE__ */ ke({
  __name: "TablePinButton",
  props: {
    pinned: { type: Boolean },
    label: {}
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = T(() => e.pinned ? `Unpin ${e.label}` : `Pin ${e.label}`), s = (l) => {
      l.stopPropagation(), t("toggle");
    };
    return (l, r) => (w(), M("button", {
      "aria-label": a.value,
      "aria-pressed": e.pinned,
      class: q([{ "v-table-pin-button--active": e.pinned }, "v-table-pin-button"]),
      type: "button",
      onClick: s,
      onMousedown: r[0] || (r[0] = Ve(() => {
      }, ["stop"]))
    }, [
      ie(v(be), {
        icon: e.pinned ? "lucide:x" : "lucide:pin",
        size: 13
      }, null, 8, ["icon"])
    ], 42, gM));
  }
}), yM = { class: "v-table-header-content" }, bM = ["title"], wM = { class: "items-center justify-center flex p-0 w-[16px]" }, kM = ["title"], xM = ["aria-label"], SM = /* @__PURE__ */ ke({
  __name: "TableHeader",
  props: {
    column: {},
    label: {},
    align: { default: "left" },
    columnKey: {},
    resizable: { type: Boolean, default: !0 },
    isSorted: { type: Boolean, default: !1 },
    sortOrder: { default: null },
    sortIndex: { default: -1 }
  },
  emits: ["sort-click", "resize-start", "resize-dblclick"],
  setup(e, { emit: n }) {
    const t = yn("tableSlots", {}), a = Oa(), s = yn("tableHighlight", null), l = e, r = n, i = T(() => !l.isSorted || !l.sortOrder ? "lucide:arrow-up-down" : l.sortOrder === "asc" ? "lucide:arrow-up" : "lucide:arrow-down"), o = T(() => l.isSorted ? "v-sort-icon v-sort-icon--active" : "v-sort-icon"), u = (b) => {
      l.column.sortable && (b.stopPropagation(), r("sort-click"));
    }, c = (b) => {
      l.column.onHeaderClick && (b.stopPropagation(), l.column.onHeaderClick({
        column: l.column,
        columnKey: l.columnKey,
        event: b
      }));
    }, f = (b) => {
      r("resize-start", l.columnKey, b);
    }, p = () => {
      r("resize-dblclick", l.columnKey);
    }, d = (b) => {
      l.column.sortable && (b.key === "Enter" || b.key === " ") && (b.preventDefault(), r("sort-click"));
    };
    return (b, m) => {
      var k;
      return w(), M("div", {
        class: q([{
          "v-table-header-cell--left": e.align === "left",
          "v-table-header-cell--center": e.align === "center",
          "v-table-header-cell--right": e.align === "right",
          "v-table-header-cell--sortable": e.column.sortable,
          "v-table-header-cell--clickable": e.column.onHeaderClick
        }, "v-table-header-cell"])
      }, [
        E("div", yM, [
          E("div", {
            class: q([{ "v-table-header-label-wrapper--clickable": e.column.onHeaderClick }, "v-table-header-label-wrapper"]),
            onClick: c
          }, [
            H(b.$slots, "default", {
              column: e.column,
              isSorted: e.isSorted,
              sortOrder: e.sortOrder
            }, () => [
              E("span", {
                title: e.label,
                class: "v-table-header-label"
              }, re(e.label), 9, bM)
            ], !0),
            H(b.$slots, "icon", { column: e.column }, void 0, !0),
            e.column.tooltip ? (w(), ue(v(xa), {
              key: 0,
              text: e.column.tooltip,
              placement: "top",
              "tooltip-class": "bg-cardBg opacity-1 w-[300px]"
            }, {
              default: ce(() => [
                E("div", wM, [
                  ie(v(be), {
                    size: v(a) ? 12 : 14,
                    class: "v-table-header-info-icon",
                    icon: "lucide:info"
                  }, null, 8, ["size"])
                ])
              ]),
              _: 1
            }, 8, ["text"])) : R("", !0),
            e.column.onHeaderClick ? (w(), M("div", {
              key: 1,
              title: `Click to interact with ${e.label}`,
              class: "v-table-header-click-indicator"
            }, [
              ie(v(be), {
                size: v(a) ? 12 : 14,
                class: "click-indicator-icon",
                icon: "lucide:mouse-pointer-click"
              }, null, 8, ["size"])
            ], 8, kM)) : R("", !0)
          ], 2),
          e.column.sortable ? (w(), M("div", {
            key: 0,
            "aria-label": `Sort by ${e.label}`,
            tabindex: 0,
            class: "v-table-header-sort",
            role: "button",
            onClick: u,
            onKeydown: d
          }, [
            ie(v(be), {
              class: q(o.value),
              icon: i.value,
              size: v(a) ? 14 : 16
            }, null, 8, ["class", "icon", "size"])
          ], 40, xM)) : R("", !0),
          v(t).headerCellCustomAction ? (w(), ue(mt(v(t).headerCellCustomAction), {
            key: 1,
            column: e.column
          }, null, 8, ["column"])) : R("", !0),
          (k = v(s)) != null && k.columnEnabled.value ? (w(), ue(sf, {
            key: 2,
            label: e.label,
            pinned: v(s).isColumnPinned(e.columnKey),
            onToggle: m[0] || (m[0] = (y) => v(s).toggleColumn(e.columnKey))
          }, null, 8, ["label", "pinned"])) : R("", !0)
        ]),
        e.resizable ? (w(), M("div", {
          key: 0,
          class: "v-table-resize-handle",
          onMousedown: Ve(f, ["stop"]),
          onDblclick: Ve(p, ["stop"])
        }, [...m[1] || (m[1] = [
          E("div", { class: "v-table-resize-indicator" }, [
            E("div", { class: "v-table-resize-line" }),
            E("div", { class: "v-table-resize-line" })
          ], -1),
          E("div", { class: "v-table-resize-divider" }, null, -1)
        ])], 32)) : R("", !0)
      ], 2);
    };
  }
}), lf = /* @__PURE__ */ ze(SM, [["__scopeId", "data-v-f522bebd"]]), TM = { class: "v-table-header-group-label" }, $M = /* @__PURE__ */ ke({
  __name: "TableHeaderGroup",
  props: {
    cell: {},
    groupWidth: {}
  },
  setup(e) {
    return (n, t) => (w(), M("div", {
      class: q([{
        "v-table-header-group--left": e.cell.column.align === "left",
        "v-table-header-group--center": e.cell.column.align === "center",
        "v-table-header-group--right": e.cell.column.align === "right"
      }, "v-table-header-group"])
    }, [
      E("span", TM, re(e.cell.label), 1)
    ], 2));
  }
}), MM = /* @__PURE__ */ ke({
  __name: "TableHeaderGrouped",
  props: {
    columns: {},
    getColumnClasses: { type: Function },
    getFixedStyles: { type: Function },
    getGroupWidth: { type: Function },
    getGroupFixedStyles: { type: Function },
    getSortState: { type: Function },
    isColumnResizable: { type: Function }
  },
  emits: ["resize-start", "resize-dblclick", "sort-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (i, o) => {
      a("resize-start", i, o);
    }, l = (i) => {
      a("resize-dblclick", i);
    }, r = (i) => {
      a("sort-click", i);
    };
    return (i, o) => (w(!0), M(Te, null, Ie(e.columns, (u, c) => (w(), M("div", {
      key: `header-level-${c}`,
      class: q([`v-table-header-row-level-${c}`, "v-table-header-row"])
    }, [
      c === 0 ? H(i.$slots, "checkbox-header", { key: 0 }) : R("", !0),
      (w(!0), M(Te, null, Ie(u, (f) => (w(), M(Te, {
        key: f.key
      }, [
        f.isGroup ? (w(), ue($M, {
          key: 0,
          cell: f,
          class: q(e.getColumnClasses(f.column)),
          "group-width": e.getGroupWidth(f.column),
          style: Fe({
            gridColumn: `span ${f.colspan}`,
            gridRow: f.rowspan > 1 ? `span ${f.rowspan}` : void 0,
            ...e.getGroupFixedStyles(f.column)
          })
        }, null, 8, ["cell", "class", "group-width", "style"])) : (w(), ue(lf, {
          key: 1,
          align: f.column.align,
          class: q([
            e.getColumnClasses(f.column),
            {
              "v-table-header-cell--grouped": c > 0,
              "v-table-header-cell--rowspan": f.rowspan > 1
            }
          ]),
          column: f.column,
          "column-key": f.column.key,
          "is-sorted": e.getSortState(f.column.key).isSorted,
          label: f.label,
          resizable: t.isColumnResizable(f.column),
          "sort-index": e.getSortState(f.column.key).index,
          "sort-order": e.getSortState(f.column.key).order,
          style: Fe({
            gridRow: f.rowspan > 1 ? `span ${f.rowspan}` : void 0,
            ...e.getFixedStyles(f.column)
          }),
          onSortClick: (p) => r(f.column),
          onResizeStart: s,
          onResizeDblclick: l
        }, dt({ _: 2 }, [
          i.$slots[`header-icon-${f.column.key}`] ? {
            name: "icon",
            fn: ce((p) => [
              H(i.$slots, `header-icon-${f.column.key}`, lt({ ref_for: !0 }, p))
            ]),
            key: "0"
          } : void 0,
          i.$slots[`header-${f.column.key}`] ? {
            name: "default",
            fn: ce((p) => [
              H(i.$slots, `header-${f.column.key}`, lt({ ref_for: !0 }, p))
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["align", "class", "column", "column-key", "is-sorted", "label", "resizable", "sort-index", "sort-order", "style", "onSortClick"]))
      ], 64))), 128))
    ], 2))), 128));
  }
}), CM = { class: "v-table-header-row" }, DM = /* @__PURE__ */ ke({
  __name: "TableHeaderSimple",
  props: {
    columns: {},
    getColumnClasses: { type: Function },
    getFixedStyles: { type: Function },
    getSortState: { type: Function },
    isColumnResizable: { type: Function }
  },
  emits: ["resize-start", "resize-dblclick", "sort-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (i, o) => {
      a("resize-start", i, o);
    }, l = (i) => {
      a("resize-dblclick", i);
    }, r = (i) => {
      a("sort-click", i);
    };
    return (i, o) => (w(), M("div", CM, [
      H(i.$slots, "checkbox-header"),
      (w(!0), M(Te, null, Ie(e.columns, (u) => (w(), ue(lf, {
        key: u.key,
        align: u.align,
        class: q(e.getColumnClasses(u)),
        column: u,
        "column-key": u.key,
        "is-sorted": e.getSortState(u.key).isSorted,
        label: u.label,
        resizable: t.isColumnResizable(u),
        "sort-index": e.getSortState(u.key).index,
        "sort-order": e.getSortState(u.key).order,
        style: Fe(e.getFixedStyles(u)),
        onSortClick: (c) => r(u),
        onResizeStart: s,
        onResizeDblclick: l
      }, dt({ _: 2 }, [
        i.$slots[`header-icon-${u.key}`] ? {
          name: "icon",
          fn: ce((c) => [
            H(i.$slots, `header-icon-${u.key}`, lt({ ref_for: !0 }, c))
          ]),
          key: "0"
        } : void 0,
        i.$slots[`header-${u.key}`] ? {
          name: "default",
          fn: ce((c) => [
            H(i.$slots, `header-${u.key}`, lt({ ref_for: !0 }, c))
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["align", "class", "column", "column-key", "is-sorted", "label", "resizable", "sort-index", "sort-order", "style", "onSortClick"]))), 128))
    ]));
  }
}), OM = {
  key: 0,
  class: "v-table-loading-overlay"
}, _M = { class: "v-table-loading-spinner" }, EM = /* @__PURE__ */ ke({
  __name: "TableLoadingOverlay",
  props: {
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (w(), ue(ht, { name: "fade" }, {
      default: ce(() => [
        e.loading ? (w(), M("div", OM, [
          t[0] || (t[0] = E("div", { class: "v-table-loading-backdrop" }, null, -1)),
          E("div", _M, [
            ie(v(Kl), {
              size: "large",
              variant: "primary"
            })
          ])
        ])) : R("", !0)
      ]),
      _: 1
    }));
  }
}), IM = { class: "v-table-pagination" }, AM = { class: "v-table-pagination-info" }, PM = { class: "v-table-pagination-info-highlight" }, RM = { class: "v-table-pagination-info-highlight" }, FM = { class: "v-table-pagination-controls" }, VM = ["disabled"], LM = ["disabled", "onClick"], NM = {
  key: 1,
  class: "v-table-pagination-ellipsis"
}, zM = ["disabled"], BM = {
  key: 0,
  class: "v-table-pagination-size"
}, WM = ["disabled", "value"], YM = ["value"], HM = /* @__PURE__ */ ke({
  __name: "TablePagination",
  props: {
    page: {},
    pageSize: {},
    total: {},
    pageSizeOptions: { default: () => [10, 25, 50, 100] },
    showSizeChanger: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = Oa(), l = T(() => Math.ceil(t.total / t.pageSize)), r = T(() => t.total === 0 ? 0 : aa((t.page - 1) * t.pageSize + 1)), i = T(() => {
      const m = t.page * t.pageSize;
      return aa(Math.min(m, t.total));
    }), o = T(() => {
      const m = [], k = l.value, y = t.page;
      if (k <= 7) {
        for (let h = 1; h <= k; h++)
          m.push(h);
        return m;
      }
      return m.push(1), y <= 3 ? (m.push(2, 3, 4), m.push("ellipsis"), m.push(k)) : y >= k - 2 ? (m.push("ellipsis"), m.push(k - 3, k - 2, k - 1, k)) : (m.push("ellipsis"), m.push(y - 1, y, y + 1), m.push("ellipsis"), m.push(k)), m;
    }), u = (m) => {
      t.loading || m !== t.page && (m < 1 || m > l.value || a("page-change", { page: m, pageSize: t.pageSize }));
    }, c = () => {
      t.page > 1 && u(t.page - 1);
    }, f = () => {
      t.page < l.value && u(t.page + 1);
    }, p = (m) => {
      t.loading || m !== t.pageSize && a("page-change", { page: 1, pageSize: m });
    }, d = T(() => t.loading || t.page <= 1), b = T(() => t.loading || t.page >= l.value);
    return (m, k) => (w(), M("div", IM, [
      E("div", AM, [
        k[1] || (k[1] = He(" Showing ", -1)),
        E("span", PM, re(r.value) + "–" + re(i.value), 1),
        k[2] || (k[2] = He(" of ", -1)),
        E("span", RM, re(v(aa)(e.total)), 1)
      ]),
      E("div", FM, [
        E("button", {
          disabled: d.value,
          "aria-label": "Previous page",
          class: "v-table-pagination-btn",
          onClick: c
        }, [
          ie(v(be), {
            size: v(s) ? 15 : 18,
            icon: "lucide:chevron-left"
          }, null, 8, ["size"])
        ], 8, VM),
        (w(!0), M(Te, null, Ie(o.value, (y, h) => (w(), M(Te, { key: h }, [
          y !== "ellipsis" ? (w(), M("button", {
            key: 0,
            class: q([{ "v-table-pagination-btn--active": y === e.page }, "v-table-pagination-btn"]),
            disabled: e.loading,
            onClick: (g) => u(y)
          }, re(y), 11, LM)) : (w(), M("span", NM, " ... "))
        ], 64))), 128)),
        E("button", {
          disabled: b.value,
          "aria-label": "Next page",
          class: "v-table-pagination-btn",
          onClick: f
        }, [
          ie(v(be), {
            size: v(s) ? 15 : 18,
            icon: "lucide:chevron-right"
          }, null, 8, ["size"])
        ], 8, zM)
      ]),
      e.showSizeChanger ? (w(), M("div", BM, [
        k[3] || (k[3] = E("label", { for: "pagination-size" }, "Rows:", -1)),
        E("select", {
          id: "pagination-size",
          disabled: e.loading,
          value: e.pageSize,
          onChange: k[0] || (k[0] = (y) => p(Number(y.target.value)))
        }, [
          (w(!0), M(Te, null, Ie(e.pageSizeOptions, (y) => (w(), M("option", {
            key: y,
            value: y
          }, re(y), 9, YM))), 128))
        ], 40, WM)
      ])) : R("", !0)
    ]));
  }
}), UM = /* @__PURE__ */ ze(HM, [["__scopeId", "data-v-b2d204b5"]]), qM = { class: "v-toolbar v-toolbar--split" }, jM = { class: "v-toolbar-split-left" }, GM = { key: 0 }, KM = { class: "v-toolbar-title" }, ZM = {
  key: 0,
  class: "v-toolbar-subtitle"
}, XM = {
  key: 0,
  class: "v-toolbar-search-split flex h-full items-center"
}, JM = { class: "v-toolbar-split-right" }, QM = /* @__PURE__ */ ke({
  __name: "TableToolbar",
  props: {
    config: { default: void 0 },
    search: { default: "" }
  },
  emits: ["update:search", "refresh", "reset-sort", "export"],
  setup(e, { emit: n }) {
    const t = Oa(), a = yn("tableSlots", {}), s = e, l = n, r = T({
      get: () => s.search,
      set: (g) => l("update:search", g)
    }), i = T(() => {
      var g;
      return (g = s.config) != null && g.search ? typeof s.config.search == "boolean" ? { placeholder: "Search..." } : s.config.search : null;
    }), o = T(() => {
      var x, S;
      const g = (S = (x = s.config) == null ? void 0 : x.actions) == null ? void 0 : S.refresh;
      return g ? typeof g == "object" ? { loading: g.loading ?? !1 } : { loading: !1 } : null;
    }), u = T(() => {
      var x, S;
      const g = (S = (x = s.config) == null ? void 0 : x.actions) == null ? void 0 : S.export;
      return !g || !g ? null : typeof g == "object" ? {
        mode: g.mode,
        formats: g.formats || [],
        selectedOnly: g.selectedOnly ?? !1,
        loading: g.loading ?? !1
      } : {
        mode: g,
        formats: [],
        selectedOnly: !1,
        loading: !1
      };
    }), c = T(() => u.value !== null), f = T(() => {
      var g;
      return ((g = u.value) == null ? void 0 : g.loading) || !1;
    }), p = T(() => {
      var g;
      return ((g = u.value) == null ? void 0 : g.formats) || [];
    }), d = T(() => p.value.some((g) => g.loading)), b = T(() => {
      var g;
      return (g = u.value) == null ? void 0 : g.mode;
    }), m = () => {
      l("refresh");
    }, k = () => {
      l("reset-sort");
    }, y = (g) => {
      var x;
      l("export", String(g), (x = u.value) == null ? void 0 : x.selectedOnly);
    }, h = () => {
      var g;
      l("export", "csv", (g = u.value) == null ? void 0 : g.selectedOnly);
    };
    return (g, x) => {
      var S, C, _, O, I, D;
      return w(), M("div", qM, [
        E("div", jM, [
          v(a).toolbarTitle ? (w(), ue(mt(v(a).toolbarTitle), { key: 0 })) : H(g.$slots, "title", { key: 1 }, () => {
            var B;
            return [
              (B = e.config) != null && B.title ? (w(), M("div", GM, [
                E("h3", KM, re(e.config.title), 1),
                e.config.subtitle ? (w(), M("p", ZM, re(e.config.subtitle), 1)) : R("", !0)
              ])) : R("", !0)
            ];
          }),
          v(a).toolbarSearch ? (w(), ue(mt(v(a).toolbarSearch), { key: 2 })) : H(g.$slots, "search", { key: 3 }, () => [
            i.value ? (w(), M("div", XM, [
              x[1] || (x[1] = E("span", { class: "w-px h-5 bg-base-300 ml-[1px] mr-4" }, null, -1)),
              ie(v(Ol), {
                modelValue: r.value,
                "onUpdate:modelValue": x[0] || (x[0] = (B) => r.value = B),
                modern: v(t),
                name: i.value.placeholder,
                placeholder: i.value.placeholder,
                class: "max-w-[280px]",
                debounce: "",
                type: "search"
              }, null, 8, ["modelValue", "modern", "name", "placeholder"])
            ])) : R("", !0)
          ]),
          v(a).toolbarFilters ? (w(), ue(mt(v(a).toolbarFilters), { key: 4 })) : H(g.$slots, "filters", { key: 5 })
        ]),
        E("div", JM, [
          v(a).toolbarActions ? (w(), ue(mt(v(a).toolbarActions), { key: 0 })) : H(g.$slots, "actions", { key: 1 }),
          o.value ? (w(), ue(v(_t), {
            key: 2,
            loading: o.value.loading,
            modern: v(t),
            icon: "lucide:refresh-cw",
            variant: "default",
            onClick: m
          }, null, 8, ["loading", "modern"])) : R("", !0),
          (C = (S = e.config) == null ? void 0 : S.actions) != null && C.resetSort ? (w(), ue(v(_t), {
            key: 3,
            modern: v(t),
            icon: "lucide:arrow-up-down",
            text: "Reset Sort",
            variant: "default",
            onClick: k
          }, null, 8, ["modern"])) : R("", !0),
          c.value && b.value === "single" ? (w(), ue(v(_t), {
            key: 4,
            disabled: f.value,
            loading: f.value,
            modern: v(t),
            icon: "lucide:file-down",
            text: "Export",
            variant: "primary",
            onClick: h
          }, null, 8, ["disabled", "loading", "modern"])) : R("", !0),
          c.value && b.value === "multi" ? (w(), ue(v(Rs), {
            key: 5,
            items: p.value,
            placement: "bottom-right",
            onSelect: y
          }, {
            trigger: ce(() => [
              ie(v(_t), {
                loading: d.value,
                modern: v(t),
                icon: "lucide:file-down",
                text: "Export",
                variant: "primary"
              }, null, 8, ["loading", "modern"])
            ]),
            _: 1
          }, 8, ["items"])) : R("", !0),
          v(a).toolbarColumnActions ? (w(), ue(mt(v(a).toolbarColumnActions), { key: 6 })) : R("", !0),
          (O = (_ = e.config) == null ? void 0 : _.actions) != null && O.columnSetup || (D = (I = e.config) == null ? void 0 : I.actions) != null && D.columnPicker ? H(g.$slots, "column-setup", { key: 7 }) : R("", !0)
        ])
      ]);
    };
  }
}), rt = {
  SM: 640,
  // Tailwind sm
  MD: 768,
  // Tailwind md
  LG: 1024,
  // Tailwind lg
  XL: 1280,
  // Tailwind xl
  "2XL": 1536,
  // Tailwind 2xl
  "3XL": 1920,
  // custom 3xl
  ULTRA: 2560,
  // custom ultra
  "4K": 3440
  // custom 4k
}, Li = typeof window < "u" ? window.innerWidth : 1920;
function rf(e = Li) {
  return e < rt.SM || e < rt.MD ? "sm" : e < rt.LG ? "md" : e < rt.XL ? "lg" : e < rt["2XL"] ? "xl" : e < rt["3XL"] ? "2xl" : e < rt.ULTRA ? "3xl" : e < rt["4K"] ? "ultra" : "4k";
}
function Or(e, n = Li) {
  const t = rf(n), a = ["4k", "ultra", "3xl", "2xl", "xl", "lg", "md", "sm"], s = a.indexOf(t);
  for (let l = s; l < a.length; l++) {
    const r = e[a[l]];
    if (r !== void 0) return r;
  }
  return e.default;
}
function ED(e, n = 1920, t, a, s = Li) {
  const l = s / n;
  let r = Math.round(e * l);
  return t !== void 0 && (r = Math.max(r, t)), a !== void 0 && (r = Math.min(r, a)), r;
}
const ia = rf(), Ni = ia === "sm", zi = ia === "md", of = ia === "lg", uf = ia === "xl", cf = ia === "2xl", Bi = ia === "3xl", Jl = ia === "ultra", Ql = ia === "4k", eC = Ni || zi, ID = Ni || zi || of, tC = uf || cf || Bi || Jl || Ql, nC = Bi || Jl || Ql, aC = Jl || Ql, AD = {
  sm: Ni,
  md: zi,
  lg: of,
  xl: uf,
  "2xl": cf,
  "3xl": Bi,
  ultra: Jl,
  "4k": Ql,
  // Grouped checks
  isMobileOrTablet: eC,
  isDesktopOrLarger: tC,
  isLargeOrBigger: nC,
  isUltraOrBigger: aC
}, PD = {
  sm: `(max-width: ${rt.SM - 1}px)`,
  md: `(min-width: ${rt.SM}px) and (max-width: ${rt.MD - 1}px)`,
  lg: `(min-width: ${rt.MD}px) and (max-width: ${rt.LG - 1}px)`,
  xl: `(min-width: ${rt.LG}px) and (max-width: ${rt.XL - 1}px)`,
  "2xl": `(min-width: ${rt.XL}px) and (max-width: ${rt["2XL"] - 1}px)`,
  "3xl": `(min-width: ${rt["2XL"]}px) and (max-width: ${rt["3XL"] - 1}px)`,
  ultra: `(min-width: ${rt["3XL"]}px) and (max-width: ${rt.ULTRA - 1}px)`,
  "4k": `(min-width: ${rt.ULTRA}px)`,
  // Range queries (min-width)
  minMd: `(min-width: ${rt.SM}px)`,
  minLg: `(min-width: ${rt.MD}px)`,
  minXl: `(min-width: ${rt.LG}px)`,
  min2Xl: `(min-width: ${rt.XL}px)`,
  min3Xl: `(min-width: ${rt["2XL"]}px)`,
  minUltra: `(min-width: ${rt["3XL"]}px)`,
  min4K: `(min-width: ${rt.ULTRA}px)`
}, df = {
  MIN_COLUMN_WIDTH: Or({
    sm: 60,
    md: 80,
    lg: 90,
    xl: 100,
    "3xl": 110,
    ultra: 120,
    default: 100
  }),
  DEFAULT_MIN_WIDTH: Or({
    sm: 60,
    md: 80,
    lg: 90,
    xl: 100,
    "3xl": 120,
    ultra: 190,
    default: 100
  }),
  DEFAULT_COLUMN_WIDTH: Or({
    sm: 100,
    md: 120,
    lg: 140,
    xl: 150,
    "3xl": 180,
    ultra: 270,
    default: 150
  })
}, {
  MIN_COLUMN_WIDTH: sC,
  DEFAULT_MIN_WIDTH: xu,
  DEFAULT_COLUMN_WIDTH: ks
} = df;
function lC(e) {
  const n = ee(/* @__PURE__ */ new Map()), t = ee({
    isResizing: !1,
    columnKey: null,
    startX: 0,
    startWidth: 0
  });
  let a = null, s = null, l = 0;
  const r = (y) => y.width !== "flex", i = (y) => {
    const h = n.value.get(y.key);
    return h !== void 0 ? `${h}px` : y.width === "flex" ? `minmax(${xu}px, 1fr)` : y.width ? y.width : `${ks}px`;
  }, o = T(() => e.value.map((y) => i(y)).join(" ")), u = (y = 50) => `${y}px ${o.value}`, c = (y, h) => {
    h.preventDefault(), h.stopPropagation();
    const g = e.value.find((C) => C.key === y);
    if (!g || !r(g))
      return;
    let x;
    const S = n.value.get(y);
    if (S !== void 0)
      x = S;
    else if (g.width && g.width !== "flex" && g.width.endsWith("px"))
      x = parseInt(g.width, 10);
    else if (!g.width)
      x = ks;
    else {
      const C = h.target.closest('[role="columnheader"]');
      x = C ? C.offsetWidth : ks;
    }
    t.value = {
      isResizing: !0,
      columnKey: y,
      startX: h.clientX,
      startWidth: x
    }, document.addEventListener("mousemove", p), document.addEventListener("mouseup", d), document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
  }, f = () => {
    if (a = null, s === null) return;
    const y = new Map(n.value);
    y.set(s, l), n.value = y;
  }, p = (y) => {
    if (!t.value.isResizing || !t.value.columnKey)
      return;
    const h = y.clientX - t.value.startX, g = Math.max(
      sC,
      t.value.startWidth + h
    );
    s = t.value.columnKey, l = g, a === null && (a = requestAnimationFrame(f));
  }, d = () => {
    a !== null && (cancelAnimationFrame(a), a = null), f(), s = null, t.value = {
      isResizing: !1,
      columnKey: null,
      startX: 0,
      startWidth: 0
    }, document.removeEventListener("mousemove", p), document.removeEventListener("mouseup", d), document.body.style.cursor = "", document.body.style.userSelect = "";
  }, b = (y) => {
    const h = new Map(n.value);
    h.delete(y), n.value = h;
  }, m = () => {
    n.value = /* @__PURE__ */ new Map();
  }, k = (y) => {
    const h = n.value.get(y);
    if (h !== void 0)
      return h;
    const g = e.value.find((x) => x.key === y);
    return g ? g.width === "flex" ? `minmax(${xu}px, 1fr)` : g.width ? g.width : ks : ks;
  };
  return {
    gridTemplateColumns: o,
    getGridTemplateWithCheckbox: u,
    resizedWidths: n,
    isResizing: T(() => t.value.isResizing),
    isColumnResizable: r,
    startResize: c,
    autoFitColumn: b,
    getColumnWidth: k,
    resetWidths: m
  };
}
function rC(e) {
  const n = ee(/* @__PURE__ */ new Set());
  return {
    flattenedData: T(() => {
      const i = [], o = (u, c = 0, f) => {
        u.forEach((p) => {
          var m, k;
          const d = !!((m = p.children) != null && m.length || p.expandable && p.expandedContent), b = n.value.has(p.id);
          i.push({
            ...p,
            depth: c,
            parentId: f,
            hasChildren: d,
            isExpanded: b
          }), b && ((k = p.children) != null && k.length) && o(p.children, c + 1, p.id);
        });
      };
      return o(e.value), i;
    }),
    // For passing to virtualizer
    expandedRows: n,
    // For UI indicators
    toggleRow: (i) => {
      n.value.has(i) ? n.value.delete(i) : n.value.add(i), n.value = new Set(n.value);
    },
    // For click handlers
    expandAll: () => {
      const i = (o) => {
        const u = [];
        return o.forEach((c) => {
          var f;
          ((f = c.children) != null && f.length || c.expandable) && (u.push(c.id), c.children && u.push(...i(c.children)));
        }), u;
      };
      n.value = new Set(i(e.value));
    },
    collapseAll: () => {
      n.value.clear(), n.value = /* @__PURE__ */ new Set();
    },
    isExpandable: (i) => {
      var o;
      return !!((o = i.children) != null && o.length || i.expandable);
    }
  };
}
const { DEFAULT_COLUMN_WIDTH: La } = df;
function iC(e, n) {
  const t = T(
    () => e.value.filter((m) => m.fixed === "left")
  ), a = T(
    () => e.value.filter((m) => m.fixed === "right")
  ), s = T(
    () => e.value.filter((m) => !m.fixed)
  ), l = T(() => {
    const m = n == null ? void 0 : n.value, k = /* @__PURE__ */ new Map();
    let y = 0;
    for (const h of e.value)
      if (h.fixed === "left") {
        k.set(h.key, y);
        let g = La;
        if (m) {
          const x = m.get(h.key);
          x !== void 0 ? g = x : g = dl(h.width) || La;
        } else
          g = dl(h.width) || La;
        y += g;
      }
    return k;
  }), r = T(() => {
    const m = n == null ? void 0 : n.value, k = /* @__PURE__ */ new Map(), y = e.value.filter((g) => g.fixed === "right");
    let h = 0;
    for (let g = y.length - 1; g >= 0; g--) {
      const x = y[g];
      k.set(x.key, h);
      let S = La;
      if (m) {
        const C = m.get(x.key);
        C !== void 0 ? S = C : S = dl(x.width) || La;
      } else
        S = dl(x.width) || La;
      h += S;
    }
    return k;
  }), i = (m, k) => {
    if (k.fixed === "left") {
      const h = e.value.findIndex((x) => x.key === m);
      let g = 0;
      for (let x = 0; x < h; x++)
        e.value[x].fixed === "left" && g++;
      return 50 + (t.value.length - g);
    }
    if (k.fixed === "right") {
      const h = e.value.findIndex((x) => x.key === m);
      let g = 0;
      for (let x = h + 1; x < e.value.length; x++)
        e.value[x].fixed === "right" && g++;
      return 50 + g + 1;
    }
    return 1;
  }, o = T(() => {
    const m = /* @__PURE__ */ new Map();
    return e.value.forEach((k) => {
      if (!k.fixed) {
        m.set(k.key, {});
        return;
      }
      const y = {
        // position: sticky added through CSS classes!
        // zIndex also controlled through CSS for proper hierarchy
      };
      if (k.fixed === "left") {
        const h = l.value.get(k.key) || 0;
        y.left = `${h}px`;
      } else if (k.fixed === "right") {
        const h = r.value.get(k.key) || 0;
        y.right = `${h}px`;
      }
      m.set(k.key, y);
    }), m;
  }), u = (m) => o.value.get(m.key) || {}, c = (m) => !!m.fixed, f = T(() => {
    let m = null;
    for (const k of e.value)
      k.fixed === "left" && (m = k.key);
    return m;
  }), p = T(() => {
    for (const m of e.value)
      if (m.fixed === "right")
        return m.key;
    return null;
  });
  return {
    leftFixedColumns: t,
    rightFixedColumns: a,
    normalColumns: s,
    getFixedStyles: u,
    isFixed: c,
    isLastLeftFixed: (m) => f.value === m,
    isFirstRightFixed: (m) => p.value === m,
    getZIndex: i
  };
}
function dl(e) {
  return e && e.endsWith("px") ? Number.parseInt(e, 10) : null;
}
function oC(e, n) {
  const a = T(() => ((b) => b.some((m) => !!(m.children && m.children.length > 0)))(e.value)), s = (d, b = 1) => {
    let m = b;
    return d.forEach((k) => {
      if (k.children && k.children.length > 0) {
        const y = s(k.children, b + 1);
        m = Math.max(m, y);
      }
    }), m;
  }, l = T(() => {
    const d = [], b = (m) => {
      m.forEach((k) => {
        k.children && k.children.length > 0 ? b(k.children) : d.push(k);
      });
    };
    return b(e.value), d;
  }), r = (d) => !d.children || d.children.length === 0 ? 1 : d.children.reduce((b, m) => b + r(m), 0), i = (d) => d && d.endsWith("px") ? parseInt(d, 10) : 150, o = (d) => {
    const b = n.value.get(d.key);
    return b !== void 0 ? b : i(d.width);
  }, u = (d) => !d.children || d.children.length === 0 ? o(d) : d.children.reduce((b, m) => b + u(m), 0), c = (d, b, m = 0, k = 1) => {
    const y = [];
    return d.forEach((h) => {
      if (!!(h.children && h.children.length > 0))
        m === b && y.push({
          key: h.key,
          label: h.label,
          column: h,
          colspan: r(h),
          rowspan: 1,
          isGroup: !0,
          level: m
        }), m < b && y.push(...c(h.children, b, m + 1, k));
      else if (m === b) {
        const x = m === 0;
        y.push({
          key: h.key,
          label: h.label,
          column: h,
          colspan: 1,
          rowspan: x ? k : 1,
          // Root level spans all, others just 1
          isGroup: !1,
          level: m
        });
      }
    }), y;
  }, f = T(() => {
    if (!a.value)
      return [
        e.value.map((m) => ({
          key: m.key,
          label: m.label,
          column: m,
          colspan: 1,
          rowspan: 1,
          isGroup: !1,
          level: 0
        }))
      ];
    const d = s(e.value), b = [];
    for (let m = 0; m < d; m++)
      b.push(c(e.value, m, 0, d));
    return b;
  });
  return {
    hasGroups: a,
    // Boolean - do we have grouped headers?
    flatColumns: l,
    // Flat list of leaf columns for data rows
    headerLevels: f,
    // Array of header rows (one per level)
    getGroupWidth: u,
    // Calculate width of group dynamically
    getColspan: r,
    // Get colspan for any column
    isGroupFixed: (d) => {
      if (!d.children || d.children.length === 0)
        return d.fixed || null;
      const b = (h) => !h.children || h.children.length === 0 ? [h.fixed] : h.children.flatMap((g) => b(g)), m = b(d), k = m.every((h) => h === "left"), y = m.every((h) => h === "right");
      return k ? "left" : y ? "right" : null;
    }
    // Check if group should be sticky
  };
}
const uC = (e, n, t) => {
  if (!n.format)
    return e;
  const a = n.format;
  if (a.formatter)
    return a.formatter(e, t);
  if (a.currency !== void 0 && a.currency !== !1) {
    const s = a.currency === !0 ? "USD" : a.currency;
    return _s(e, s);
  }
  return a.percentage !== void 0 ? Vi(e, a.percentage) : a.number ? aa(e, a.number) : a.date ? Gd(e, a.date) : a.boolean ? jd(e, a.boolean) : a.fileSize !== void 0 ? Kd(e, a.fileSize) : e;
}, cC = () => ({
  formatCellValue: uC,
  // Export individual formatters for custom use
  formatCurrency: _s,
  formatPercentage: Vi,
  formatNumber: aa,
  formatDate: Gd,
  formatBoolean: jd,
  formatFileSize: Kd
}), dC = (e) => {
  const { isExpandable: n, isRowExpandable: t } = e, { formatCellValue: a } = cC(), s = (o, u, c) => {
    if (!u.format)
      return o;
    const f = a(o, u, c);
    return f && typeof f == "object" && !Array.isArray(f) && "text" in f && typeof f.text < "u" ? f.text : f;
  }, l = (o, u, c) => {
    if (!u.format)
      return;
    const f = a(o, u, c);
    if (f && typeof f == "object" && !Array.isArray(f) && "class" in f && typeof f.class == "string")
      return f.class;
  }, r = /* @__PURE__ */ new WeakMap();
  return { getCellValue: s, getCellClass: l, getCellMetadata: (o, u, c, f) => {
    let p = r.get(o);
    p || (p = /* @__PURE__ */ new WeakMap(), r.set(o, p));
    const d = p.get(u);
    if (d) return d;
    const b = u.format ? a(o[u.key], u, o) : o[u.key];
    let m = b, k;
    if (b && typeof b == "object" && !Array.isArray(b) && "text" in b && (m = b.text, k = b.class), u.cellClass) {
      const C = u.cellClass({ value: o[u.key], row: o, rowIndex: f });
      C && (k = k ? `${k} ${C}` : C);
    }
    const y = u.cellStyle ? u.cellStyle({ value: o[u.key], row: o, rowIndex: f }) : void 0, h = o.depth || 0, g = c === 0 && h ? { paddingLeft: `${h * 24 + 16}px` } : null, x = c === 0 && Qe(n) ? t(o) : !1, S = {
      formattedValue: m,
      cssClass: k,
      indentStyle: g,
      customStyle: y,
      isExpandable: x
    };
    return p.set(u, S), S;
  } };
}, fC = (e) => {
  const n = T(() => Qe(e.columns)), t = T(() => {
    const k = Qe(e.columnSetup);
    return typeof k == "string" || typeof k == "object";
  }), a = T(() => {
    const k = Qe(e.columnSetup);
    return typeof k == "string" ? {
      key: k,
      type: "indexedDB",
      allowReorder: !0
    } : typeof k == "object" ? {
      ...k,
      type: k.type || "indexedDB"
      // Default to indexedDB
    } : {};
  }), s = (k, y, h) => {
    const g = (O) => O.flatMap((I) => I.children && I.children.length ? g(I.children) : [I]), x = new Map(g(n.value).map((O) => [O.key, O])), S = [], C = k.fixed, _ = (O) => {
      var Y;
      if (!k.visible.includes(O)) return;
      const I = x.get(O);
      if (I) {
        S.push({ ...I, fixed: (C == null ? void 0 : C[O]) || I.fixed });
        return;
      }
      const D = y == null ? void 0 : y.get(O);
      if (D) {
        S.push({
          key: D.key,
          label: D.label,
          fixed: C == null ? void 0 : C[O],
          sortable: D.sortable ?? h
        });
        return;
      }
      const B = (Y = k.labels) == null ? void 0 : Y[O];
      B && S.push({
        key: O,
        label: B,
        fixed: C == null ? void 0 : C[O],
        sortable: h
      });
    };
    return k.order.forEach(_), !S.length && k.visible.length && k.visible.forEach(_), S.length ? S : null;
  }, l = async () => {
    const k = t.value, y = Qe(e.columnPicker), h = !!y && typeof y == "object";
    if (!k && !h) return null;
    if (k) {
      const g = a.value;
      if (g.key)
        try {
          const S = await _l(g.key, g.type);
          if (S) return s(S);
        } catch (S) {
          console.warn("[VTable] Failed to load stored column setup", S);
        }
      const x = Array.isArray(g.initialVisible) ? g.initialVisible : null;
      if (x) {
        const S = n.value.filter((C) => x.includes(C.key));
        return x.length === 0 ? [] : S.length ? S : null;
      }
    }
    if (h && typeof y == "object") {
      const g = y.key, x = y.type;
      if (g)
        try {
          const S = await _l(g, x);
          if (S) {
            const C = /* @__PURE__ */ new Map();
            return y.groups.forEach((_) => _.items.forEach((O) => C.set(O.key, O))), s(S, C, y.defaultSortable);
          }
        } catch (S) {
          console.warn("[VTable] Failed to load stored column picker state", S);
        }
    }
    return null;
  }, r = ee(null), i = ee(null), o = ee(null);
  l().then((k) => {
    k !== null && (r.value = k);
  });
  const u = (k) => {
    r.value = [...k];
  }, c = () => {
    var k;
    (k = i.value) == null || k.close();
  }, f = () => {
    var k;
    (k = o.value) == null || k.close();
  }, p = T(() => {
    const k = Qe(e.columnPicker);
    return !!k && typeof k == "object";
  }), d = T(() => {
    const k = Qe(e.columnPicker);
    return !k || typeof k != "object" ? null : k;
  }), b = (k) => {
    const y = k.filter((x) => x.fixed === "left"), h = k.filter((x) => !x.fixed), g = k.filter((x) => x.fixed === "right");
    return !y.length && !g.length ? k : [...y, ...h, ...g];
  }, m = T(() => !t.value && !p.value ? b(n.value) : b(r.value ?? n.value));
  return {
    columnSetupEnabledBasic: t,
    columnSetupConfig: a,
    columnSetupPopoverRef: i,
    columnPickerPopoverRef: o,
    handleVisibleColumnsUpdate: u,
    handleColumnSetupClose: c,
    handleColumnPickerClose: f,
    columnPickerEnabled: p,
    columnPickerConfig: d,
    effectiveColumns: m
  };
}, hC = (e) => e ? e === !0 ? { enabled: !0, row: !0, column: !0 } : {
  enabled: !0,
  row: e.row ?? !0,
  column: e.column ?? !0
} : { enabled: !1, row: !1, column: !1 }, mC = (e) => {
  const n = ee(null), t = ee(null), a = () => Qe(e.config), s = T(() => n.value !== null || t.value !== null), l = (m) => n.value === null ? !1 : m !== void 0 && n.value === m, r = (m) => t.value === null ? !1 : t.value === m, i = () => {
    var m;
    (m = e.onChange) == null || m.call(e, {
      rowId: n.value,
      columnKey: t.value
    });
  };
  return {
    pinnedRowId: n,
    pinnedColumnKey: t,
    hasPin: s,
    isRowPinned: l,
    isColumnPinned: r,
    toggleRow: (m) => {
      const { enabled: k, row: y } = a();
      !k || !y || (n.value = n.value === m ? null : m, i());
    },
    toggleColumn: (m) => {
      const { enabled: k, column: y } = a();
      !k || !y || (t.value = t.value === m ? null : m, i());
    },
    unpinRow: () => {
      n.value !== null && (n.value = null, i());
    },
    unpinColumn: () => {
      t.value !== null && (t.value = null, i());
    },
    clear: () => {
      s.value && (n.value = null, t.value = null, i());
    },
    applyRemote: (m) => {
      const { enabled: k, row: y, column: h } = a();
      k && (n.value = y ? m.rowId : null, t.value = h ? m.columnKey : null);
    },
    setPin: (m) => {
      const { enabled: k, row: y, column: h } = a();
      k && (n.value = y ? m.rowId : null, t.value = h ? m.columnKey : null, i());
    }
  };
}, ff = Symbol("tablePageKey");
function RD(e = []) {
  const n = ee(1);
  return e.length && Le(e, () => {
    n.value === 1 ? Er(n) : n.value = 1;
  }, { flush: "pre", deep: !0 }), ea(ff, n), n;
}
function vC(e) {
  const { config: n, flattenedData: t, selectedRows: a, onSelectionChange: s } = e, l = ee(/* @__PURE__ */ new Set()), r = (S) => S.id;
  Le(
    a,
    (S) => {
      l.value = new Set(S.map((C) => r(C)));
    },
    { immediate: !0 }
  );
  const i = T(() => {
    var S;
    return ((S = n.value) == null ? void 0 : S.enabled) ?? !1;
  }), o = T(
    () => {
      var S;
      return ((S = n.value) == null ? void 0 : S.selectionMode) === "dependent";
    }
  ), u = (S) => l.value.has(S), c = (S) => {
    var C;
    return (C = n.value) != null && C.isRowSelectable ? n.value.isRowSelectable(S) : !0;
  }, f = (S) => {
    if (!S.children || S.children.length === 0) return [];
    const C = [], _ = (O) => {
      O.forEach((I) => {
        C.push(r(I)), I.children && _(I.children);
      });
    };
    return _(S.children), C;
  }, p = (S) => {
    if (!S.children || S.children.length === 0) return [];
    const C = [], _ = t.value.filter((D) => D.isExpanded), O = new Set(_.map((D) => r(D))), I = (D, B) => {
      D.forEach((Y) => {
        if (B) {
          C.push(r(Y));
          const ne = O.has(r(Y));
          Y.children && I(Y.children, ne);
        }
      });
    };
    return I(S.children, !0), C;
  }, d = (S) => t.value.find(
    (C) => {
      var _;
      return (_ = C.children) == null ? void 0 : _.some((O) => O.id === S);
    }
  ), b = (S) => {
    var O;
    if (!S.children || S.children.length === 0)
      return u(r(S)) ? "checked" : "unchecked";
    const C = (O = n.value) != null && O.selectOnlyVisible ? p(S) : f(S);
    if (C.length === 0)
      return u(r(S)) ? "checked" : "unchecked";
    const _ = C.filter(
      (I) => l.value.has(I)
    ).length;
    return _ === 0 && !u(r(S)) ? "unchecked" : _ === C.length && u(r(S)) ? "checked" : "indeterminate";
  }, m = (S) => {
    var I, D, B, Y, ne, W;
    if (!i.value || !c(S)) return;
    const C = r(S), _ = u(C), O = new Set(l.value);
    if (_ ? (O.delete(C), o.value && ((I = n.value) != null && I.selectChildren) && ((D = n.value) != null && D.selectOnlyVisible ? p(S) : f(S)).forEach((G) => O.delete(G))) : (O.add(C), o.value && ((B = n.value) != null && B.selectChildren) && ((Y = n.value) != null && Y.selectOnlyVisible ? p(S) : f(S)).forEach((G) => O.add(G))), o.value && ((ne = n.value) != null && ne.selectParent)) {
      const ae = d(C);
      ae && ((((W = ae.children) == null ? void 0 : W.map((se) => r(se))) || []).every(
        (se) => O.has(se)
      ) ? O.add(r(ae)) : O.delete(r(ae)));
    }
    l.value = O, h();
  }, k = () => {
    const S = t.value.filter(
      (_) => c(_)
    );
    if (S.length === 0) return "unchecked";
    const C = S.filter(
      (_) => u(r(_))
    ).length;
    return C === 0 ? "unchecked" : C === S.length ? "checked" : "indeterminate";
  }, y = () => {
    if (!i.value) return;
    const S = k(), C = new Set(l.value), _ = t.value.filter(
      (I) => c(I)
    ), O = (I) => {
      var D;
      return !o.value || !((D = n.value) != null && D.selectChildren) ? [] : n.value.selectOnlyVisible ? p(I) : f(I);
    };
    S === "checked" ? _.forEach((I) => {
      C.delete(r(I)), O(I).forEach((D) => C.delete(D));
    }) : _.forEach((I) => {
      C.add(r(I)), O(I).forEach((D) => C.add(D));
    }), l.value = C, h();
  }, h = () => {
    const S = (O, I) => {
      for (const D of I) {
        if (D.id === O) return D;
        if (D.children) {
          const B = S(O, D.children);
          if (B) return B;
        }
      }
    }, C = t.value.map((O) => {
      const { depth: I, parentId: D, hasChildren: B, isExpanded: Y, ...ne } = O;
      return ne;
    }), _ = Array.from(l.value).map((O) => S(O, C)).filter((O) => O !== void 0);
    s(_);
  };
  return {
    // State
    isEnabled: i,
    isDependentMode: o,
    selectedIds: l,
    // Methods
    isRowSelected: u,
    isRowSelectable: c,
    toggleRow: m,
    toggleAllRows: y,
    getParentCheckboxState: b,
    getHeaderCheckboxState: k,
    clearSelection: () => {
      l.value = /* @__PURE__ */ new Set(), h();
    },
    selectRows: (S) => {
      l.value = new Set(S), h();
    }
  };
}
const pC = (e) => {
  const {
    sort: n = {},
    sortState: t,
    columns: a,
    page: s,
    pageSize: l,
    data: r,
    onRequest: i,
    onSort: o,
    onUpdateSortState: u
  } = e, c = T(() => ({
    type: n.type || "server",
    multiple: n.multiple !== void 0 ? n.multiple : !0
  })), f = ee((t == null ? void 0 : t.value) || []);
  t && Le(t, (S) => {
    f.value = S || [];
  });
  const p = (S, C) => {
    const _ = a.value.find((D) => D.key === C);
    if (_ != null && _.sortValue)
      return _.sortValue(S, C);
    const O = C.split(".");
    let I = S;
    for (const D of O) {
      if (I == null) return null;
      I = I[D];
    }
    return I;
  }, d = (S, C, _) => {
    if (S == null && C == null) return 0;
    if (S == null) return 1;
    if (C == null) return -1;
    const O = typeof S == "string" ? parseFloat(S) : S, I = typeof C == "string" ? parseFloat(C) : C;
    if (typeof O == "number" && typeof I == "number" && !Number.isNaN(O) && !Number.isNaN(I))
      return _ === "asc" ? O - I : I - O;
    const D = String(S).toLowerCase(), B = String(C).toLowerCase();
    return _ === "asc" ? D.localeCompare(B, void 0, { numeric: !0 }) : B.localeCompare(D, void 0, { numeric: !0 });
  }, b = (S, C) => C.length === 0 ? [...S] : [...S].sort((_, O) => {
    for (const I of C) {
      const D = p(_, I.field), B = p(O, I.field), Y = d(D, B, I.order);
      if (Y !== 0)
        return Y;
    }
    return 0;
  }), m = T(() => c.value.type !== "front" || !r ? (r == null ? void 0 : r.value) || [] : b(r.value, f.value)), k = (S) => {
    const C = f.value.find((_) => _.field === S);
    return {
      isSorted: !!C,
      order: (C == null ? void 0 : C.order) || null,
      index: C ? f.value.indexOf(C) : -1
      // For multi-sort indicator
    };
  }, y = (S) => S ? S === "asc" ? "desc" : null : "asc", h = (S) => {
    if (!S.sortable) return;
    const C = S.key, _ = k(C), O = y(_.order);
    let I;
    if (c.value.multiple ? O === null ? I = f.value.filter((D) => D.field !== C) : _.isSorted ? I = f.value.map(
      (D) => D.field === C ? { field: C, order: O } : D
    ) : I = [...f.value, { field: C, order: O }] : O === null ? I = [] : I = [{ field: C, order: O }], f.value = I, u == null || u(I), c.value.type === "front") {
      if (I.length > 0) {
        const D = I.find((B) => B.field === C);
        D && (o == null || o({
          field: C,
          order: D.order,
          sortState: I
        }));
      }
    } else {
      const D = {
        // page: page?.value ?? 1,
        page: 1,
        pageSize: (l == null ? void 0 : l.value) ?? 10,
        sort: I
      };
      i == null || i(D);
    }
  }, g = T(() => f.value.length > 0);
  return {
    sortState: f,
    sortConfig: c,
    getSortState: k,
    handleSortClick: h,
    hasSortedColumns: g,
    resetSort: () => {
      if (f.value = [], u == null || u([]), c.value.type === "server") {
        const S = {
          page: (s == null ? void 0 : s.value) ?? 1,
          pageSize: (l == null ? void 0 : l.value) ?? 10,
          sort: []
        };
        i == null || i(S);
      }
    },
    // Frontend sorting
    sortedData: m
    // Reactive sorted data for frontend sorting
  };
};
function Na(e, n, t) {
  let a = t.initialDeps ?? [], s, l = !0;
  function r() {
    var i, o, u;
    let c;
    t.key && ((i = t.debug) != null && i.call(t)) && (c = Date.now());
    const f = e();
    if (!(f.length !== a.length || f.some((b, m) => a[m] !== b)))
      return s;
    a = f;
    let d;
    if (t.key && ((o = t.debug) != null && o.call(t)) && (d = Date.now()), s = n(...f), t.key && ((u = t.debug) != null && u.call(t))) {
      const b = Math.round((Date.now() - c) * 100) / 100, m = Math.round((Date.now() - d) * 100) / 100, k = m / 16, y = (h, g) => {
        for (h = String(h); h.length < g; )
          h = " " + h;
        return h;
      };
      console.info(
        `%c⏱ ${y(m, 5)} /${y(b, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * k, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return t != null && t.onChange && !(l && t.skipInitialOnChange) && t.onChange(s), l = !1, s;
  }
  return r.updateDeps = (i) => {
    a = i;
  }, r;
}
function Su(e, n) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const gC = (e, n) => Math.abs(e - n) < 1.01, yC = (e, n, t) => {
  let a;
  return function(...s) {
    e.clearTimeout(a), a = e.setTimeout(() => n.apply(this, s), t);
  };
}, Tu = (e) => {
  const { offsetWidth: n, offsetHeight: t } = e;
  return { width: n, height: t };
}, bC = (e) => e, wC = (e) => {
  const n = Math.max(e.startIndex - e.overscan, 0), t = Math.min(e.endIndex + e.overscan, e.count - 1), a = [];
  for (let s = n; s <= t; s++)
    a.push(s);
  return a;
}, kC = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  const s = (r) => {
    const { width: i, height: o } = r;
    n({ width: Math.round(i), height: Math.round(o) });
  };
  if (s(Tu(t)), !a.ResizeObserver)
    return () => {
    };
  const l = new a.ResizeObserver((r) => {
    const i = () => {
      const o = r[0];
      if (o != null && o.borderBoxSize) {
        const u = o.borderBoxSize[0];
        if (u) {
          s({ width: u.inlineSize, height: u.blockSize });
          return;
        }
      }
      s(Tu(t));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(i) : i();
  });
  return l.observe(t, { box: "border-box" }), () => {
    l.unobserve(t);
  };
}, $u = {
  passive: !0
}, Mu = typeof window > "u" ? !0 : "onscrollend" in window, xC = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  let s = 0;
  const l = e.options.useScrollendEvent && Mu ? () => {
  } : yC(
    a,
    () => {
      n(s, !1);
    },
    e.options.isScrollingResetDelay
  ), r = (c) => () => {
    const { horizontal: f, isRtl: p } = e.options;
    s = f ? t.scrollLeft * (p && -1 || 1) : t.scrollTop, l(), n(s, c);
  }, i = r(!0), o = r(!1);
  t.addEventListener("scroll", i, $u);
  const u = e.options.useScrollendEvent && Mu;
  return u && t.addEventListener("scrollend", o, $u), () => {
    t.removeEventListener("scroll", i), u && t.removeEventListener("scrollend", o);
  };
}, SC = (e, n, t) => {
  if (n != null && n.borderBoxSize) {
    const a = n.borderBoxSize[0];
    if (a)
      return Math.round(
        a[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[t.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, TC = (e, {
  adjustments: n = 0,
  behavior: t
}, a) => {
  var s, l;
  const r = e + n;
  (l = (s = a.scrollElement) == null ? void 0 : s.scrollTo) == null || l.call(s, {
    [a.options.horizontal ? "left" : "top"]: r,
    behavior: t
  });
};
class $C {
  constructor(n) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.currentScrollToIndex = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const a = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((l) => {
          const r = () => {
            this._measureElement(l.target, l);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(r) : r();
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = a()) == null || s.disconnect(), t = null;
        },
        observe: (s) => {
          var l;
          return (l = a()) == null ? void 0 : l.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var l;
          return (l = a()) == null ? void 0 : l.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([a, s]) => {
        typeof s > "u" && delete t[a];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: bC,
        rangeExtractor: wC,
        onChange: () => {
        },
        measureElement: SC,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...t
      };
    }, this.notify = (t) => {
      var a, s;
      (s = (a = this.options).onChange) == null || s.call(a, this, t);
    }, this.maybeNotify = Na(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var t;
      const a = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== a) {
        if (this.cleanup(), !a) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = a, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((t = this.scrollElement) == null ? void 0 : t.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, l) => {
            this.scrollAdjustments = 0, this.scrollDirection = l ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = l, this.maybeNotify();
          })
        ), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (t, a) => {
      const s = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map();
      for (let r = a - 1; r >= 0; r--) {
        const i = t[r];
        if (s.has(i.lane))
          continue;
        const o = l.get(
          i.lane
        );
        if (o == null || i.end > o.end ? l.set(i.lane, i) : i.end < o.end && s.set(i.lane, !0), s.size === this.options.lanes)
          break;
      }
      return l.size === this.options.lanes ? Array.from(l.values()).sort((r, i) => r.end === i.end ? r.index - i.index : r.end - i.end)[0] : void 0;
    }, this.getMeasurementOptions = Na(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes
      ],
      (t, a, s, l, r, i) => (this.prevLanes !== void 0 && this.prevLanes !== i && (this.lanesChangedFlag = !0), this.prevLanes = i, this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: a,
        scrollMargin: s,
        getItemKey: l,
        enabled: r,
        lanes: i
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Na(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: a, scrollMargin: s, getItemKey: l, enabled: r, lanes: i }, o) => {
        if (!r)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > t)
          for (const p of this.laneAssignments.keys())
            p >= t && this.laneAssignments.delete(p);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMeasuredCacheIndexes = []), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((p) => {
          this.itemSizeCache.set(p.key, p.size);
        }));
        const u = this.lanesSettling ? 0 : this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [], this.lanesSettling && this.measurementsCache.length === t && (this.lanesSettling = !1);
        const c = this.measurementsCache.slice(0, u), f = new Array(i).fill(
          void 0
        );
        for (let p = 0; p < u; p++) {
          const d = c[p];
          d && (f[d.lane] = p);
        }
        for (let p = u; p < t; p++) {
          const d = l(p), b = this.laneAssignments.get(p);
          let m, k;
          if (b !== void 0 && this.options.lanes > 1) {
            m = b;
            const x = f[m], S = x !== void 0 ? c[x] : void 0;
            k = S ? S.end + this.options.gap : a + s;
          } else {
            const x = this.options.lanes === 1 ? c[p - 1] : this.getFurthestMeasurement(c, p);
            k = x ? x.end + this.options.gap : a + s, m = x ? x.lane : p % this.options.lanes, this.options.lanes > 1 && this.laneAssignments.set(p, m);
          }
          const y = o.get(d), h = typeof y == "number" ? y : this.options.estimateSize(p), g = k + h;
          c[p] = {
            index: p,
            start: k,
            size: h,
            end: g,
            key: d,
            lane: m
          }, f[m] = p;
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Na(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (t, a, s, l) => this.range = t.length > 0 && a > 0 ? MC({
        measurements: t,
        outerSize: a,
        scrollOffset: s,
        lanes: l
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = Na(
      () => {
        let t = null, a = null;
        const s = this.calculateRange();
        return s && (t = s.startIndex, a = s.endIndex), this.maybeNotify.updateDeps([this.isScrolling, t, a]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          t,
          a
        ];
      },
      (t, a, s, l, r) => l === null || r === null ? [] : t({
        startIndex: l,
        endIndex: r,
        overscan: a,
        count: s
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const a = this.options.indexAttribute, s = t.getAttribute(a);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${a}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, a) => {
      const s = this.indexFromElement(t), l = this.measurementsCache[s];
      if (!l)
        return;
      const r = l.key, i = this.elementsCache.get(r);
      i !== t && (i && this.observer.unobserve(i), this.observer.observe(t), this.elementsCache.set(r, t)), t.isConnected && this.resizeItem(s, this.options.measureElement(t, a, this));
    }, this.resizeItem = (t, a) => {
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const l = this.itemSizeCache.get(s.key) ?? s.size, r = a - l;
      r !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, r, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", r), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += r,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, a)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((a, s) => {
          a.isConnected || (this.observer.unobserve(a), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = Na(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (t, a) => {
        const s = [];
        for (let l = 0, r = t.length; l < r; l++) {
          const i = t[l], o = a[i];
          s.push(o);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const a = this.getMeasurements();
      if (a.length !== 0)
        return Su(
          a[hf(
            0,
            a.length - 1,
            (s) => Su(a[s]).start,
            t
          )]
        );
    }, this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement)
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      {
        const t = this.scrollElement.document.documentElement;
        return this.options.horizontal ? t.scrollWidth - this.scrollElement.innerWidth : t.scrollHeight - this.scrollElement.innerHeight;
      }
    }, this.getOffsetForAlignment = (t, a, s = 0) => {
      if (!this.scrollElement) return 0;
      const l = this.getSize(), r = this.getScrollOffset();
      a === "auto" && (a = t >= r + l ? "end" : "start"), a === "center" ? t += (s - l) / 2 : a === "end" && (t -= l);
      const i = this.getMaxScrollOffset();
      return Math.max(Math.min(i, t), 0);
    }, this.getOffsetForIndex = (t, a = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const l = this.getSize(), r = this.getScrollOffset();
      if (a === "auto")
        if (s.end >= r + l - this.options.scrollPaddingEnd)
          a = "end";
        else if (s.start <= r + this.options.scrollPaddingStart)
          a = "start";
        else
          return [r, a];
      if (a === "end" && t === this.options.count - 1)
        return [this.getMaxScrollOffset(), a];
      const i = a === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(i, a, s.size),
        a
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.scrollToOffset = (t, { align: a = "start", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, a), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (t, { align: a = "auto", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), t = Math.max(0, Math.min(t, this.options.count - 1)), this.currentScrollToIndex = t;
      let l = 0;
      const r = 10, i = (u) => {
        if (!this.targetWindow) return;
        const c = this.getOffsetForIndex(t, u);
        if (!c) {
          console.warn("Failed to get offset for index:", t);
          return;
        }
        const [f, p] = c;
        this._scrollToOffset(f, { adjustments: void 0, behavior: s }), this.targetWindow.requestAnimationFrame(() => {
          const d = () => {
            if (this.currentScrollToIndex !== t) return;
            const b = this.getScrollOffset(), m = this.getOffsetForIndex(t, p);
            if (!m) {
              console.warn("Failed to get offset for index:", t);
              return;
            }
            gC(m[0], b) || o(p);
          };
          this.isDynamicMode() ? this.targetWindow.requestAnimationFrame(d) : d();
        });
      }, o = (u) => {
        this.targetWindow && this.currentScrollToIndex === t && (l++, l < r ? (process.env.NODE_ENV !== "production" && this.options.debug && console.info("Schedule retry", l, r), this.targetWindow.requestAnimationFrame(() => i(u))) : console.warn(
          `Failed to scroll to index ${t} after ${r} attempts.`
        ));
      };
      i(a);
    }, this.scrollBy = (t, { behavior: a } = {}) => {
      a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: a
      });
    }, this.getTotalSize = () => {
      var t;
      const a = this.getMeasurements();
      let s;
      if (a.length === 0)
        s = this.options.paddingStart;
      else if (this.options.lanes === 1)
        s = ((t = a[a.length - 1]) == null ? void 0 : t.end) ?? 0;
      else {
        const l = Array(this.options.lanes).fill(null);
        let r = a.length - 1;
        for (; r >= 0 && l.some((i) => i === null); ) {
          const i = a[r];
          l[i.lane] === null && (l[i.lane] = i.end), r--;
        }
        s = Math.max(...l.filter((i) => i !== null));
      }
      return Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: a,
      behavior: s
    }) => {
      this.options.scrollToFn(t, { behavior: s, adjustments: a }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(n);
  }
}
const hf = (e, n, t, a) => {
  for (; e <= n; ) {
    const s = (e + n) / 2 | 0, l = t(s);
    if (l < a)
      e = s + 1;
    else if (l > a)
      n = s - 1;
    else
      return s;
  }
  return e > 0 ? e - 1 : 0;
};
function MC({
  measurements: e,
  outerSize: n,
  scrollOffset: t,
  lanes: a
}) {
  const s = e.length - 1, l = (o) => e[o].start;
  if (e.length <= a)
    return {
      startIndex: 0,
      endIndex: s
    };
  let r = hf(
    0,
    s,
    l,
    t
  ), i = r;
  if (a === 1)
    for (; i < s && e[i].end < t + n; )
      i++;
  else if (a > 1) {
    const o = Array(a).fill(0);
    for (; i < s && o.some((c) => c < t + n); ) {
      const c = e[i];
      o[c.lane] = c.end, i++;
    }
    const u = Array(a).fill(t + n);
    for (; r >= 0 && u.some((c) => c >= t); ) {
      const c = e[r];
      u[c.lane] = c.start, r--;
    }
    r = Math.max(0, r - r % a), i = Math.min(s, i + (a - 1 - i % a));
  }
  return { startIndex: r, endIndex: i };
}
function CC(e) {
  const n = new $C(v(e)), t = Et(n), a = n._didMount();
  return Le(
    () => v(e).getScrollElement(),
    (s) => {
      s && n._willUpdate();
    },
    {
      immediate: !0
    }
  ), Le(
    () => v(e),
    (s) => {
      n.setOptions({
        ...s,
        onChange: (l, r) => {
          var i;
          Er(t), (i = s.onChange) == null || i.call(s, l, r);
        }
      }), n._willUpdate(), Er(t);
    },
    {
      immediate: !0
    }
  ), El(a), t;
}
function DC(e) {
  return CC(
    T(() => ({
      observeElementRect: kC,
      observeElementOffset: xC,
      scrollToFn: TC,
      ...v(e)
    }))
  );
}
function OC(e, n, t = {}) {
  const {
    estimateSize: a = 50,
    overscan: s = 3,
    measureElement: l = !1
  } = t, r = Et(!1);
  let i = null, o = !1;
  const u = {
    get count() {
      return n.value.length;
    },
    getScrollElement: () => e.value,
    estimateSize: () => a,
    overscan: s,
    scrollingDelay: 150
  };
  l && (u.measureElement = (h) => !h || r.value ? a : h.getBoundingClientRect().height || a);
  const c = DC(u), f = T(() => c.value.getVirtualItems()), p = T(() => c.value.getTotalSize()), d = () => {
    r.value = !0, i && clearTimeout(i), i = setTimeout(() => {
      r.value = !1;
    }, 150);
  }, b = () => {
    const h = e.value;
    !h || !c.value || (c.value.measure(), h.dispatchEvent(new Event("scroll", { bubbles: !0 })));
  }, m = () => {
    const h = e.value;
    h && !o && (h.addEventListener("scroll", d, { passive: !0 }), o = !0);
  }, k = () => {
    const h = e.value;
    h && o && (h.removeEventListener("scroll", d), o = !1);
  }, y = () => {
    i && (clearTimeout(i), i = null);
  };
  return et(() => {
    requestAnimationFrame(() => {
      m();
    });
  }), Pu(() => {
    requestAnimationFrame(() => {
      b(), m();
    });
  }), Au(() => {
    y();
  }), Xt(() => {
    k(), y();
  }), {
    virtualizer: c,
    virtualItems: f,
    totalSize: p,
    remeasure: b
  };
}
const _C = {
  key: 1,
  ref: "toolbarSlot",
  class: "v-table-toolbar-slot"
}, EC = { class: "v-table-container-wrapper" }, IC = {
  key: 1,
  class: "v-table-header-checkbox-cell v-table-header-checkbox-cell--empty"
}, AC = ["onClick"], PC = {
  key: 0,
  class: "v-table-total-cell v-table-checkbox-cell"
}, RC = { class: "v-table-total-content" }, FC = {
  key: 0,
  class: "v-table-total-spacer"
}, VC = 36, LC = 40, FD = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "VTable",
  props: /* @__PURE__ */ Yt({
    columns: {},
    data: {},
    loading: { type: Boolean, default: !1 },
    virtualized: { type: Boolean, default: !0 },
    rowHeight: { default: void 0 },
    modern: { type: Boolean, default: !1 },
    height: {},
    totalRow: {},
    selectedRows: {},
    multiSelect: {},
    expandMode: { default: "auto" },
    sort: { default: () => ({ type: "server", multiple: !0 }) },
    sortState: {},
    pagination: {},
    page: {},
    pageSize: {},
    toolbar: { default: void 0 },
    search: { default: "" },
    rowClassName: {},
    scrollSync: {},
    highlight: { type: [Boolean, Object] },
    highlightState: {},
    highlightSync: {}
  }, {
    search: {},
    searchModifiers: {}
  }),
  emits: /* @__PURE__ */ Yt(["row-click", "update:selected-rows", "expand-click", "update:sort-state", "update:highlight-state", "update:page", "update:pageSize", "request", "sort", "update:search", "toolbar:refresh", "toolbar:reset-sort", "toolbar:export"], ["update:search"]),
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, l = T(() => a.rowHeight ?? (a.modern ? 40 : 50));
    ea(tf, T(() => a.modern));
    const r = Ht(), i = Il(), o = Xe("wrapper"), u = Xe("fullscreenPlaceholder"), c = Xe("toolbarSlot"), f = Xe("pagination");
    ea("tableSlots", {
      headerCellCustomAction: r["header-cell-custom-action"],
      toolbarTitle: r["toolbar-title"],
      toolbarSearch: r["toolbar-search"],
      toolbarFilters: r["toolbar-filters"],
      toolbarActions: r["toolbar-actions"],
      toolbarColumnActions: r["toolbar-column-actions"],
      emptyState: r["empty-state"]
    });
    const p = En(e, "search"), d = T(() => {
      var le;
      return ((le = a.toolbar) == null ? void 0 : le.enabled) || r.toolbar;
    }), b = T(() => {
      var le, Se;
      return !!d.value && ((Se = (le = a.toolbar) == null ? void 0 : le.actions) == null ? void 0 : Se.fullscreen) !== !1;
    }), {
      isFullscreen: m,
      zIndex: k,
      placeholderStyle: y,
      panelStyle: h,
      contentHeight: g,
      toggle: x
    } = lx({
      wrapperRef: o,
      placeholderRef: u,
      // The toolbar/pagination chrome is already rendered and is the same size in
      // both fullscreen and normal mode — the composable measures it before the
      // fullscreen flag flips (see useTableFullScreen's enter()) so
      // fullscreenContentHeight is a final px value on the very first fullscreen
      // render (see scrollContainerStyle below).
      chromeRefs: [c, f],
      isEnabled: b,
      // The scroll container's own height changed the instant the fullscreen class
      // applied — the virtualizer's cached scroll element rect is now stale. We
      // don't preserve scroll position across the toggle, so reset to top and
      // force a remeasure (delegated to useVirtualTable's own remeasure()) instead
      // of waiting for the user's next real scroll to reveal any rows.
      onToggle: () => {
        const le = wt.value;
        le && (le.scrollTop = 0, le.scrollLeft = 0), Ct();
      }
    }), S = T(() => i.class), C = T(() => {
      const le = i.style, Se = typeof le == "object" && le !== null ? le : {};
      if (y.value)
        return { ...Se, ...y.value };
    }), _ = () => {
      var qe, Pe;
      s("toolbar:refresh");
      const le = (Pe = (qe = a.toolbar) == null ? void 0 : qe.actions) == null ? void 0 : Pe.refresh;
      (typeof le == "object" ? le.mode ?? "default" : le) !== "custom" && (Q.value = [], fe.value = 1, It.collapseAll(), kt.clear(), s("request", {
        page: fe.value,
        pageSize: Re.value,
        sort: []
      }));
    }, O = () => {
      var Se, qe;
      s("toolbar:reset-sort"), ((qe = (Se = a.toolbar) == null ? void 0 : Se.actions) == null ? void 0 : qe.resetSort) !== "custom" && (Q.value = [], fe.value = 1, It.collapseAll(), kt.clear(), s("request", {
        page: fe.value,
        pageSize: Re.value,
        sort: []
      }));
    }, I = (le, Se) => {
      s("toolbar:export", le, Se);
    }, {
      columnSetupEnabledBasic: D,
      columnSetupConfig: B,
      columnSetupPopoverRef: Y,
      columnPickerPopoverRef: ne,
      handleVisibleColumnsUpdate: W,
      handleColumnSetupClose: ae,
      handleColumnPickerClose: G,
      columnPickerEnabled: j,
      columnPickerConfig: se,
      effectiveColumns: U
    } = fC({
      columns: () => a.columns,
      columnSetup: () => {
        var le, Se;
        return (Se = (le = a.toolbar) == null ? void 0 : le.actions) == null ? void 0 : Se.columnSetup;
      },
      columnPicker: () => {
        var le, Se;
        return (Se = (le = a.toolbar) == null ? void 0 : le.actions) == null ? void 0 : Se.columnPicker;
      }
    }), N = T(() => a.totalRow !== void 0), J = ee(/* @__PURE__ */ new Map()), {
      hasGroups: de,
      flatColumns: he,
      headerLevels: ge,
      getGroupWidth: $e,
      isGroupFixed: we
    } = oC(U, J), X = T(() => D.value ? de.value ? (console.warn("Column Setup is not supported with grouped headers yet"), !1) : !0 : !1), ve = T(() => de.value ? he.value : U.value), {
      gridTemplateColumns: Ce,
      getGridTemplateWithCheckbox: V,
      startResize: Z,
      autoFitColumn: me,
      isResizing: K,
      resizedWidths: oe,
      isColumnResizable: ye
    } = lC(ve);
    Le(oe, () => {
      const le = /* @__PURE__ */ new Map();
      ve.value.forEach((Se) => {
        var Pe;
        const qe = oe.value.get(Se.key);
        qe !== void 0 ? le.set(Se.key, qe) : (Pe = Se.width) != null && Pe.endsWith("px") && le.set(Se.key, parseInt(Se.width, 10));
      }), J.value = le;
    }, { immediate: !0 });
    const {
      getFixedStyles: A,
      isLastLeftFixed: z,
      isFirstRightFixed: $
    } = iC(ve, J), F = T(() => a.height ? typeof a.height == "number" ? `${a.height}px` : a.height : "600px"), P = T(() => m.value ? {
      height: `${g.value}px`,
      overscrollBehavior: "contain"
    } : { height: F.value, overscrollBehavior: "contain" }), Q = T({
      get: () => a.sortState || [],
      set: (le) => s("update:sort-state", le)
    }), L = yn(ff, null), fe = T({
      get: () => {
        var le;
        return a.page ?? (L == null ? void 0 : L.value) ?? ((le = a.pagination) == null ? void 0 : le.page) ?? 1;
      },
      set: (le) => {
        a.page !== void 0 ? s("update:page", le) : L && (L.value = le);
      }
    }), Me = T(() => {
      var le, Se;
      return ((le = a.pagination) == null ? void 0 : le.showSizeChanger) ?? ((Se = a.pagination) == null ? void 0 : Se.pageSizeOptions) !== void 0;
    }), Re = T({
      get: () => {
        var le;
        return a.pageSize ?? ((le = a.pagination) == null ? void 0 : le.pageSize) ?? 10;
      },
      set: (le) => {
        a.pageSize !== void 0 && s("update:pageSize", le);
      }
    }), {
      getSortState: _e,
      handleSortClick: Ye,
      sortedData: At
    } = pC({
      sort: a.sort,
      sortState: Q,
      columns: U,
      page: T(() => {
        var le;
        return (le = a.pagination) == null ? void 0 : le.page;
      }),
      pageSize: T(() => {
        var le;
        return (le = a.pagination) == null ? void 0 : le.pageSize;
      }),
      data: T(() => a.data),
      // Pass data for frontend sorting
      onRequest: (le) => {
        fe.value = le.page, It.collapseAll(), kt.clear(), s("request", le);
      },
      onSort: (le) => s("sort", le),
      onUpdateSortState: (le) => s("update:sort-state", le)
    }), Fn = (le) => {
      Ye(le);
    }, xn = T(() => {
      var qe;
      const le = ((qe = a.sort) == null ? void 0 : qe.type) === "front" ? At.value : a.data, Se = (Pe, ft = "") => Pe.map((Ot, Ln) => {
        var el;
        const ds = Ot.id ?? `${ft}row-${Ln}`, jn = (el = Ot.children) != null && el.length ? Se(Ot.children, `${ds}-`) : Ot.children;
        return Ot.id !== void 0 && jn === Ot.children ? Ot : { ...Ot, id: ds, children: jn };
      });
      return Se(le);
    }), Jt = T(
      () => xn.value.some((le) => le.children && le.children.length > 0)
    ), Un = T(() => xn.value), It = rC(Un), Bt = T(() => Jt.value ? It.flattenedData.value : xn.value), un = T(() => a.multiSelect), Sn = T({
      get: () => a.selectedRows || [],
      set: (le) => s("update:selected-rows", le)
    }), bt = vC({
      config: un,
      flattenedData: Bt,
      selectedRows: Sn,
      onSelectionChange: (le) => {
        s("update:selected-rows", le);
      }
    }), wt = ee(null), {
      virtualItems: De,
      totalSize: ut,
      remeasure: Ct
    } = OC(
      wt,
      Bt,
      {
        // Read once: `rowHeight` and `modern` are fixed for the life of a table, so the virtualiser
        // never needs to re-estimate.
        estimateSize: l.value,
        overscan: 2,
        // Reduced from 5 for better performance
        // PERFORMANCE: Disable measureElement to prevent memory leaks
        // Using fixed height improves performance dramatically for large datasets
        // Trade-off: scroll bar may be slightly inaccurate with expanded rows
        measureElement: !1
      }
    ), Tn = T(() => {
      const le = bt.isEnabled.value ? V(a.modern ? LC : 50) : Ce.value;
      return {
        // Sizing plumbing for the SCSS. The header is 48px legacy, 36px modern — never the row height.
        // Legacy cells keep their literal 50px min-height and ignore --v-table-row-h.
        "--v-table-row-h": `${l.value}px`,
        "--v-table-header-h": a.modern ? `${VC}px` : "48px",
        display: "grid",
        gridTemplateColumns: le,
        gridAutoRows: "auto"
        // All rows auto-sized (headers get height from CSS)
      };
    }), Vn = (le) => {
      s("row-click", le);
    }, _a = ({ page: le, pageSize: Se }) => {
      !a.pagination || a.loading || (wt.value && wt.value.scrollTop > 0 && wt.value.scrollTo({
        top: 0,
        behavior: "smooth"
      }), fe.value = le, Re.value = Se, It.collapseAll(), kt.clear(), s("request", {
        page: le,
        pageSize: Se,
        sort: Q.value
      }));
    }, cs = (le) => {
      const Se = le.target;
      a.scrollSync && a.scrollSync.onScroll(Se.scrollLeft, Se.scrollTop);
    }, er = (le, Se, qe) => {
      Jt.value && (a.expandMode === "controlled" ? s("expand-click", {
        row: Se,
        column: qe,
        callback: () => It.toggleRow(le),
        expanded: Xs(Se)
      }) : (It.toggleRow(le), s("expand-click", {
        row: Se,
        column: qe,
        callback: () => {
        },
        // Already toggled, callback is no-op
        expanded: !Xs(Se)
        // New state after toggle
      })));
    }, Xs = (le) => le.isExpanded || !1, tr = (le) => le.hasChildren || !1, { getCellValue: nr, getCellClass: ar, getCellMetadata: Js } = dC({
      isExpandable: Jt,
      isRowExpandable: (le) => It.isExpandable(le)
    });
    ea("tableCellMetadata", Js);
    const qn = T(() => hC(a.highlight)), Qs = () => {
      const le = kt.pinnedRowId.value, Se = kt.pinnedColumnKey.value;
      if (le === null && Se === null) return null;
      const qe = le === null ? -1 : Bt.value.findIndex((jn) => jn.id === le), Pe = qe >= 0 ? Bt.value[qe] : void 0, ft = Se === null ? void 0 : ve.value.find((jn) => jn.key === Se), Ot = Pe && le !== null ? { rowId: le, rowIndex: qe, row: Pe } : null, Ln = ft && Se !== null ? { columnKey: Se, column: ft } : null;
      let ds = null;
      if (Ot && Ln) {
        const jn = ve.value.indexOf(Ln.column), el = Js(Ot.row, Ln.column, jn, Ot.rowIndex);
        ds = {
          value: Ot.row[Ln.columnKey],
          formattedValue: String(el.formattedValue ?? "")
        };
      }
      return { row: Ot, column: Ln, cell: ds };
    }, kt = mC({
      config: qn,
      onChange: (le) => {
        var Se;
        s("update:highlight-state", Qs()), (Se = a.highlightSync) == null || Se.broadcast(le);
      }
    }), te = (le) => {
      kt.applyRemote(le), s("update:highlight-state", Qs());
    }, pe = (le) => kt.isRowPinned(le);
    ea("tableHighlight", {
      columnEnabled: T(() => qn.value.column),
      isColumnPinned: kt.isColumnPinned,
      toggleColumn: kt.toggleColumn
    });
    const Ae = (le, Se) => a.rowClassName ? typeof a.rowClassName == "string" ? a.rowClassName : typeof a.rowClassName == "function" ? a.rowClassName(le, Se) : "" : "", Ue = T(() => a.virtualized ? wt.value ? De.value.length === 0 ? [] : De.value.map((le) => {
      const Se = Bt.value[le.index], qe = Se ? Ae(Se, le.index) : "";
      return {
        row: Se,
        index: le.index,
        // CRITICAL: Use row.id as key, not index! Index causes memory leaks
        // because Vue reuses components for different data at same index
        key: (Se == null ? void 0 : Se.id) || `row-${le.index}`,
        isVirtual: !0,
        virtualRow: le,
        rowClass: qe,
        isCustomRow: !!qe
      };
    }) : [] : Bt.value.map((le, Se) => {
      const qe = Ae(le, Se);
      return {
        row: le,
        index: Se,
        key: le.id || Se,
        isVirtual: !1,
        rowClass: qe,
        isCustomRow: !!qe
      };
    })), tt = (le) => {
      const Se = [], qe = le.fixed || (de.value ? we(le) : null);
      return qe && (Se.push("v-table-fixed-column"), qe === "left" ? Se.push("v-table-fixed-left") : qe === "right" && Se.push("v-table-fixed-right"), z(le.key) && Se.push("v-table-fixed-left-last"), $(le.key) && Se.push("v-table-fixed-right-first")), kt.isColumnPinned(le.key) && Se.push("v-table-cell--pinned-col"), Se;
    }, Ut = T(() => {
      const le = /* @__PURE__ */ new Map();
      return ve.value.forEach((Se) => {
        le.set(Se.key, tt(Se));
      }), de.value && ge.value.forEach((Se) => {
        Se.forEach((qe) => {
          le.has(qe.column.key) || le.set(qe.column.key, tt(qe.column));
        });
      }), le;
    }), qt = (le) => Ut.value.get(le.key) ?? [], oa = (le) => we(le) ? A(le) : {}, Ea = T(() => de.value ? MM : DM), ua = T(() => de.value ? ge.value : ve.value);
    return Xt(() => {
      var le, Se;
      It && It.collapseAll(), wt.value = null, (le = a.scrollSync) == null || le.unregister(), (Se = a.highlightSync) == null || Se.unregister();
    }), et(() => {
      var le;
      (le = a.highlightSync) == null || le.register(te), a.scrollSync && wt.value && a.scrollSync.register(wt.value);
    }), qn.value.enabled && (Le(() => a.highlightState, (le) => {
      var Pe, ft;
      const Se = ((Pe = le == null ? void 0 : le.row) == null ? void 0 : Pe.rowId) ?? null, qe = ((ft = le == null ? void 0 : le.column) == null ? void 0 : ft.columnKey) ?? null;
      Se === kt.pinnedRowId.value && qe === kt.pinnedColumnKey.value || kt.setPin({ rowId: Se, columnKey: qe });
    }), Le(qn, (le) => {
      if (!le.enabled) {
        kt.clear();
        return;
      }
      le.row || kt.unpinRow(), le.column || kt.unpinColumn();
    })), n({ visibleColumns: U }), (le, Se) => {
      var qe;
      return w(), M(Te, null, [
        (w(), ue(Pn, {
          disabled: !v(m),
          to: "body"
        }, [
          E("div", lt({
            ref: "wrapper",
            class: [{
              "v-table-wrapper--modern": e.modern,
              "v-table-wrapper--virtualized": e.virtualized,
              "v-table-wrapper--with-toolbar": d.value,
              "v-table-wrapper--fullscreen": v(m)
            }, "v-table-wrapper"],
            style: v(m) ? { ...v(h), zIndex: v(k) + 1 } : void 0
          }, v(i)), [
            b.value ? (w(), ue(mM, {
              key: 0,
              "is-fullscreen": v(m),
              onToggle: v(x)
            }, null, 8, ["is-fullscreen", "onToggle"])) : R("", !0),
            d.value ? (w(), M("div", _C, [
              v(r).toolbar ? H(le.$slots, "toolbar", { key: 0 }) : (qe = e.toolbar) != null && qe.enabled ? (w(), ue(QM, {
                key: 1,
                search: p.value,
                "onUpdate:search": Se[0] || (Se[0] = (Pe) => p.value = Pe),
                config: e.toolbar,
                onExport: I,
                onRefresh: _,
                onResetSort: O
              }, dt({ _: 2 }, [
                X.value || v(j) ? {
                  name: "column-setup",
                  fn: ce(() => [
                    v(j) ? (w(), ue(v(Rs), {
                      key: 0,
                      ref_key: "columnPickerPopoverRef",
                      ref: ne,
                      offset: 8,
                      "content-class": "rounded-lg",
                      placement: "bottom-right",
                      unstyled: ""
                    }, {
                      trigger: ce(() => [
                        ie(v(_t), {
                          modern: e.modern,
                          icon: "lucide:columns",
                          variant: "default"
                        }, null, 8, ["modern"])
                      ]),
                      content: ce(() => [
                        ie(H$, {
                          columns: v(U),
                          groups: v(se).groups,
                          loading: v(se).loading,
                          "original-columns": a.columns,
                          "storage-key": v(se).key,
                          "storage-type": v(se).type,
                          types: v(se).types,
                          onClose: v(G),
                          "onUpdate:visibleColumns": v(W)
                        }, null, 8, ["columns", "groups", "loading", "original-columns", "storage-key", "storage-type", "types", "onClose", "onUpdate:visibleColumns"])
                      ]),
                      _: 1
                    }, 512)) : R("", !0),
                    X.value ? (w(), ue(v(Rs), {
                      key: 1,
                      ref_key: "columnSetupPopoverRef",
                      ref: Y,
                      offset: 8,
                      "content-class": "rounded-lg",
                      placement: "bottom-right",
                      unstyled: ""
                    }, {
                      trigger: ce(() => [
                        ie(v(_t), {
                          modern: e.modern,
                          icon: "lucide:table-2",
                          variant: "default"
                        }, null, 8, ["modern"])
                      ]),
                      content: ce(() => [
                        ie(rM, {
                          columns: e.columns,
                          config: v(B),
                          onClose: v(ae),
                          "onUpdate:visibleColumns": v(W)
                        }, null, 8, ["columns", "config", "onClose", "onUpdate:visibleColumns"])
                      ]),
                      _: 1
                    }, 512)) : R("", !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["search", "config"])) : R("", !0)
            ], 512)) : R("", !0),
            E("div", EC, [
              Bt.value.length === 0 ? (w(), ue(fM, {
                key: 0,
                description: "Try adjusting your filters or search criteria",
                icon: "lucide:inbox",
                title: "No data to display"
              })) : R("", !0),
              ie(EM, { loading: e.loading }, null, 8, ["loading"]),
              E("div", {
                ref_key: "scrollContainerRef",
                ref: wt,
                class: q([{ "v-table-scroll-container--loading": e.loading }, "v-table-scroll-container v-table-scrollbar-styled"]),
                style: Fe(P.value),
                onScrollPassive: cs
              }, [
                E("div", {
                  class: q([{
                    "v-is-resizing": v(K),
                    "v-table-grid--highlight": v(kt).hasPin.value
                  }, "v-table-grid"]),
                  style: Fe(Tn.value)
                }, [
                  (w(), ue(mt(Ea.value), {
                    columns: ua.value,
                    "get-column-classes": qt,
                    "get-fixed-styles": v(A),
                    "get-group-fixed-styles": oa,
                    "get-group-width": v($e),
                    "get-sort-state": v(_e),
                    "is-column-resizable": v(ye),
                    onResizeStart: v(Z),
                    onResizeDblclick: v(me),
                    onSortClick: Fn
                  }, dt({ _: 2 }, [
                    v(bt).isEnabled.value ? {
                      name: "checkbox-header",
                      fn: ce(() => {
                        var Pe;
                        return [
                          ((Pe = un.value) == null ? void 0 : Pe.showHeaderCheckbox) !== !1 ? (w(), ue(pM, {
                            key: 0,
                            state: v(bt).getHeaderCheckboxState(),
                            onToggle: v(bt).toggleAllRows
                          }, null, 8, ["state", "onToggle"])) : (w(), M("div", IC))
                        ];
                      }),
                      key: "0"
                    } : void 0,
                    Ie(ve.value, (Pe) => ({
                      name: `header-icon-${Pe.key}`,
                      fn: ce((ft) => [
                        H(le.$slots, `header-icon-${Pe.key}`, Mt(Nt(ft)))
                      ])
                    })),
                    Ie(ve.value, (Pe) => ({
                      name: `header-${Pe.key}`,
                      fn: ce((ft) => [
                        H(le.$slots, `header-${Pe.key}`, Mt(Nt(ft)))
                      ])
                    }))
                  ]), 1064, ["columns", "get-fixed-styles", "get-group-width", "get-sort-state", "is-column-resizable", "onResizeStart", "onResizeDblclick"])),
                  a.virtualized && v(De).length > 0 && v(De)[0] ? (w(), M("div", {
                    key: 0,
                    style: Fe({ height: `${v(De)[0].start}px` }),
                    class: "v-table-virtual-spacer"
                  }, null, 4)) : R("", !0),
                  (w(!0), M(Te, null, Ie(Ue.value, (Pe) => (w(), M("div", {
                    key: Pe.key,
                    class: q([{ "v-table-row-wrapper--pinned": pe(Pe.row.id) }, "v-table-row-wrapper"]),
                    onClick: (ft) => Vn(Pe.row)
                  }, [
                    v(bt).isEnabled.value ? (w(), ue(n$, {
                      key: 0,
                      checked: v(bt).isRowSelected(Pe.row.id),
                      class: q(Pe.rowClass),
                      "data-custom-row": Pe.isCustomRow ? "true" : void 0,
                      disabled: !v(bt).isRowSelectable(Pe.row),
                      indeterminate: v(bt).isDependentMode.value && tr(Pe.row) && v(bt).getParentCheckboxState(Pe.row) === "indeterminate",
                      onToggle: (ft) => v(bt).toggleRow(Pe.row)
                    }, null, 8, ["checked", "class", "data-custom-row", "disabled", "indeterminate", "onToggle"])) : R("", !0),
                    (w(!0), M(Te, null, Ie(ve.value, (ft, Ot) => (w(), ue(vu, {
                      key: ft.key,
                      align: ft.align,
                      class: q([
                        qt(ft),
                        Pe.rowClass,
                        { "v-table-cell--pin-host": qn.value.row && Ot === 0 }
                      ]),
                      "col-index": Ot,
                      column: ft,
                      "data-custom-row": Pe.isCustomRow ? "true" : void 0,
                      interactive: ft.interactive,
                      "is-expanded": !!Pe.row.isExpanded,
                      row: Pe.row,
                      "row-index": Pe.index,
                      style: Fe(v(A)(ft)),
                      onToggleExpand: (Ln) => er(Pe.row.id, Pe.row, ft)
                    }, dt({ _: 2 }, [
                      qn.value.row && Ot === 0 ? {
                        name: "pin",
                        fn: ce(() => [
                          ie(sf, {
                            pinned: pe(Pe.row.id),
                            label: "row",
                            onToggle: (Ln) => v(kt).toggleRow(Pe.row.id)
                          }, null, 8, ["pinned", "onToggle"])
                        ]),
                        key: "0"
                      } : void 0,
                      v(r)[`cell-${ft.key}`] ? {
                        name: "default",
                        fn: ce(() => [
                          H(le.$slots, `cell-${ft.key}`, {
                            column: ft,
                            depth: Pe.row.depth || 0,
                            index: Pe.index,
                            row: Pe.row,
                            value: Pe.row[ft.key]
                          })
                        ]),
                        key: "1"
                      } : void 0
                    ]), 1032, ["align", "class", "col-index", "column", "data-custom-row", "interactive", "is-expanded", "row", "row-index", "style", "onToggleExpand"]))), 128))
                  ], 10, AC))), 128)),
                  a.virtualized && v(De).length > 0 && v(De)[v(De).length - 1] ? (w(), M("div", {
                    key: 1,
                    style: Fe({
                      height: `${v(ut) - v(De)[v(De).length - 1].end}px`
                    }),
                    class: "v-table-virtual-spacer"
                  }, null, 4)) : R("", !0),
                  N.value && e.totalRow ? (w(), M(Te, { key: 2 }, [
                    v(bt).isEnabled.value ? (w(), M("div", PC)) : R("", !0),
                    (w(!0), M(Te, null, Ie(ve.value, (Pe, ft) => (w(), ue(vu, {
                      key: Pe.key,
                      align: Pe.align,
                      class: q([qt(Pe), "v-table-total-cell"]),
                      style: Fe(v(A)(Pe))
                    }, {
                      default: ce(() => [
                        E("div", RC, [
                          ft === 0 && Jt.value ? (w(), M("div", FC)) : R("", !0),
                          E("div", {
                            class: q([{ "v-table-total-text--truncate": !Pe.interactive }, "v-table-total-text"])
                          }, [
                            H(le.$slots, `total-cell-${Pe.key}`, {
                              column: Pe,
                              row: e.totalRow,
                              value: e.totalRow[Pe.key]
                            }, () => [
                              ie(e$, {
                                class: q(v(ar)(e.totalRow[Pe.key], Pe, e.totalRow)),
                                interactive: Pe.interactive,
                                value: v(nr)(e.totalRow[Pe.key], Pe, e.totalRow)
                              }, null, 8, ["class", "interactive", "value"])
                            ])
                          ], 2)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["align", "class", "style"]))), 128))
                  ], 64)) : R("", !0)
                ], 6)
              ], 38)
            ]),
            e.pagination ? (w(), ue(UM, {
              key: 2,
              ref: "pagination",
              loading: e.loading,
              page: fe.value,
              "page-size": Re.value,
              "page-size-options": e.pagination.pageSizeOptions || [10, 25, 50, 100],
              "show-size-changer": Me.value,
              total: e.pagination.total,
              onPageChange: _a
            }, null, 8, ["loading", "page", "page-size", "page-size-options", "show-size-changer", "total"])) : R("", !0)
          ], 16)
        ], 8, ["disabled"])),
        v(y) ? (w(), M("div", {
          key: 0,
          ref: "fullscreenPlaceholder",
          class: q(S.value),
          style: Fe(C.value),
          "aria-hidden": "true"
        }, null, 6)) : R("", !0)
      ], 64);
    };
  }
}), NC = /* @__PURE__ */ ke({
  __name: "DeltaValue",
  props: {
    value: { default: void 0 },
    delta: { default: void 0 },
    format: { default: void 0 },
    deltaFormat: { default: void 0 },
    deltaAsPercentage: { type: Boolean, default: !0 },
    reverse: { type: Boolean, default: !1 },
    size: { default: "default" },
    showZeroDelta: { type: Boolean, default: !0 },
    modern: { type: Boolean, default: void 0 }
  },
  setup(e) {
    const n = e, t = Oa(), a = T(() => n.modern ?? t.value), s = T(() => n.delta === null || n.delta === void 0 ? null : n.reverse ? n.delta < 0 : n.delta > 0), l = T(() => n.delta === null || n.delta === void 0 ? null : n.reverse ? n.delta > 0 : n.delta < 0), r = T(() => n.delta === 0), i = T(() => n.delta === null || n.delta === void 0 ? !1 : n.showZeroDelta || n.delta !== 0), o = T(() => {
      var d;
      if (n.delta === null || n.delta === void 0) return "";
      const f = Math.abs(n.delta);
      if (n.deltaFormat) {
        const { type: b = "number", decimals: m = 0, currencyCode: k = "USD" } = n.deltaFormat;
        switch (b) {
          case "currency":
            return new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: k,
              minimumFractionDigits: m,
              maximumFractionDigits: m
            }).format(f);
          case "percentage":
            return `${new Intl.NumberFormat("en-US", {
              minimumFractionDigits: m,
              maximumFractionDigits: m
            }).format(f)}%`;
          default:
            return new Intl.NumberFormat("en-US", {
              minimumFractionDigits: m,
              maximumFractionDigits: m
            }).format(f);
        }
      }
      const p = f.toFixed(((d = n.format) == null ? void 0 : d.decimals) ?? 0);
      return n.deltaAsPercentage ? `${p}%` : p;
    }), u = T(() => {
      if (n.value === null || n.value === void 0) return null;
      if (typeof n.value == "string") return n.value;
      const { type: f = "number", decimals: p = 0, currencyCode: d = "USD" } = n.format || {};
      switch (f) {
        case "currency":
          return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: d,
            minimumFractionDigits: p,
            maximumFractionDigits: p
          }).format(n.value);
        case "percentage":
          return `${new Intl.NumberFormat("en-US", {
            minimumFractionDigits: p,
            maximumFractionDigits: p
          }).format(n.value)}%`;
        default:
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: p,
            maximumFractionDigits: p
          }).format(n.value);
      }
    }), c = T(() => {
      if (a.value)
        switch (n.size) {
          case "sm":
            return { value: "delta-value__value--sm", delta: "delta-value__delta--sm", icon: 11 };
          case "lg":
            return { value: "delta-value__value--lg", delta: "delta-value__delta--lg", icon: 14 };
          default:
            return { value: "", delta: "", icon: 12 };
        }
      switch (n.size) {
        case "sm":
          return {
            value: "text-sm",
            delta: "text-xs",
            icon: 14
          };
        case "lg":
          return {
            value: "text-lg font-semibold",
            delta: "text-sm",
            icon: 20
          };
        default:
          return {
            value: "text-base",
            delta: "text-sm",
            icon: 16
          };
      }
    });
    return (f, p) => (w(), M("div", {
      class: q(["delta-value flex flex-col", { "delta-value--modern": a.value }])
    }, [
      u.value !== null ? (w(), M("span", {
        key: 0,
        class: q([c.value.value, "text-mainText"])
      }, re(u.value), 3)) : R("", !0),
      i.value ? (w(), M("div", {
        key: 1,
        class: q([c.value.delta, "flex items-center gap-0.5"])
      }, [
        s.value ? (w(), ue(v(be), {
          key: 0,
          size: c.value.icon,
          color: "text-success",
          icon: "lucide:arrow-up"
        }, null, 8, ["size"])) : l.value ? (w(), ue(v(be), {
          key: 1,
          size: c.value.icon,
          color: "text-negative",
          icon: "lucide:arrow-down"
        }, null, 8, ["size"])) : r.value ? (w(), ue(v(be), {
          key: 2,
          size: c.value.icon,
          color: "text-secondaryText",
          icon: "lucide:minus"
        }, null, 8, ["size"])) : R("", !0),
        E("span", {
          class: q({
            "text-success": s.value,
            "text-negative": l.value,
            "text-secondaryText": r.value
          })
        }, re(o.value), 3)
      ], 2)) : R("", !0)
    ], 2));
  }
}), VD = /* @__PURE__ */ ze(NC, [["__scopeId", "data-v-8b50e3f4"]]), LD = /* @__PURE__ */ ke({
  __name: "DeltaIndicator",
  props: {
    value: { default: 0 },
    format: { default: () => {
    } },
    reverse: { type: Boolean, default: !1 },
    size: { default: "default" },
    showIcon: { type: Boolean, default: !0 },
    showZero: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = T(
      () => e.value !== null && e.value !== void 0
    ), t = T(
      () => n.value && (e.showZero || e.value !== 0)
    ), a = T(() => n.value ? e.reverse ? e.value < 0 : e.value > 0 : null), s = T(() => n.value ? e.reverse ? e.value > 0 : e.value < 0 : null), l = T(() => e.value === 0), r = T(() => {
      if (!n.value) return "";
      const o = e.format;
      if (!o) return String(e.value);
      if (o.currency !== void 0) {
        if (typeof o.currency == "object") {
          const { code: u, decimals: c } = o.currency;
          return _s(e.value, { code: u, decimals: c });
        }
        return typeof o.currency == "string" ? _s(e.value, o.currency) : _s(e.value);
      }
      return o.percentage !== void 0 ? Vi(e.value, o.percentage === !0 ? void 0 : o.percentage) : o.number !== void 0 ? aa(e.value, o.number) : String(e.value);
    }), i = T(() => {
      switch (e.size) {
        case "sm":
          return { text: "text-xs", icon: 12 };
        case "lg":
          return { text: "text-sm font-semibold", icon: 18 };
        default:
          return { text: "text-sm", icon: 14 };
      }
    });
    return (o, u) => t.value ? (w(), M("div", {
      key: 0,
      class: q([i.value.text, "flex items-center gap-0.5"])
    }, [
      e.showIcon ? (w(), M(Te, { key: 0 }, [
        a.value ? (w(), ue(v(be), {
          key: 0,
          size: i.value.icon,
          color: "text-success",
          icon: "lucide:arrow-up"
        }, null, 8, ["size"])) : s.value ? (w(), ue(v(be), {
          key: 1,
          size: i.value.icon,
          color: "text-negative",
          icon: "lucide:arrow-down"
        }, null, 8, ["size"])) : l.value ? (w(), ue(v(be), {
          key: 2,
          size: i.value.icon,
          color: "text-secondaryText",
          icon: "lucide:minus"
        }, null, 8, ["size"])) : R("", !0)
      ], 64)) : R("", !0),
      E("span", {
        class: q({
          "text-success": a.value,
          "text-negative": s.value,
          "text-secondaryText": l.value
        })
      }, re(r.value), 3)
    ], 2)) : R("", !0);
  }
}), zC = { class: "v-table-title-block" }, BC = { class: "v-table-title-block__title-section" }, WC = {
  key: 1,
  class: "v-table-title-block__title"
}, YC = {
  key: 2,
  class: "v-table-title-block__separator"
}, HC = {
  key: 0,
  class: "v-table-title-block__actions"
}, UC = /* @__PURE__ */ ke({
  __name: "TableTitleBlock",
  props: {
    title: { default: "" },
    icon: { default: "" }
  },
  setup(e) {
    return (n, t) => (w(), M("div", zC, [
      E("div", BC, [
        e.icon ? (w(), ue(v(be), {
          key: 0,
          icon: e.icon,
          size: 20,
          class: "v-table-title-block__icon"
        }, null, 8, ["icon"])) : R("", !0),
        e.title ? (w(), M("h3", WC, re(e.title), 1)) : R("", !0),
        e.title && n.$slots.default ? (w(), M("span", YC)) : R("", !0)
      ]),
      n.$slots.default ? (w(), M("div", HC, [
        H(n.$slots, "default", {}, void 0, !0)
      ])) : R("", !0)
    ]));
  }
}), ND = /* @__PURE__ */ ze(UC, [["__scopeId", "data-v-c3a3c2e6"]]);
function qC(e) {
  const {
    granularity: n,
    dateRange: t,
    includeSummary: a = !1,
    onPeriodChange: s
  } = e, l = ee(null), r = ee(!0), i = T(() => {
    const m = n.value, k = [], y = m === "MONTH" ? "All Months" : m === "WEEK" ? "All Weeks" : "All Days";
    return k.push({ label: y, value: "all" }), a && k.push({ label: "Summary", value: "summary" }), m === "MONTH" ? k.push(...u()) : m === "WEEK" ? k.push(...c()) : m === "DAY" && k.push(...f()), k;
  }), o = T(() => i.value[0]);
  function u() {
    const { since: m, until: k } = t.value, y = Ee.fromISO(m, { zone: "utc" }), h = Ee.fromISO(k, { zone: "utc" }), g = [];
    let x = y.startOf("month");
    for (; x <= h; )
      g.push({
        label: x.toFormat("MMMM yyyy"),
        value: x.toISODate()
      }), x = x.plus({ months: 1 });
    return g.sort(
      (S, C) => Ee.fromISO(C.value).toMillis() - Ee.fromISO(S.value).toMillis()
    );
  }
  function c() {
    const { since: m, until: k } = t.value, y = Ee.fromISO(m, { zone: "utc" }), h = Ee.fromISO(k, { zone: "utc" }), g = Ee.utc().startOf("day"), x = [];
    let S = y.startOf("week").plus({ days: 6 });
    for (; S <= h && S < g; )
      x.push({
        label: S.toFormat("MM/dd/yyyy"),
        value: S.toISODate()
      }), S = S.plus({ weeks: 1 });
    return x.sort(
      (C, _) => Ee.fromISO(_.value).toMillis() - Ee.fromISO(C.value).toMillis()
    );
  }
  function f() {
    const { since: m, until: k } = t.value, y = Ee.fromISO(m, { zone: "utc" }), h = Ee.fromISO(k, { zone: "utc" }), g = Ee.utc().startOf("day"), x = [];
    let S = y;
    for (; S <= h && S < g; )
      x.push({
        label: S.toFormat("MM/dd/yyyy"),
        value: S.toISODate()
      }), S = S.plus({ days: 1 });
    return x.sort(
      (C, _) => Ee.fromISO(_.value).toMillis() - Ee.fromISO(C.value).toMillis()
    );
  }
  const p = T(() => {
    var y;
    const m = (y = l.value) == null ? void 0 : y.value;
    if (!m || m === "all" || m === "summary")
      return {};
    const k = n.value;
    if (k === "MONTH") {
      const g = Ee.fromISO(m, { zone: "utc" }).endOf("month");
      return {
        period: {
          since: m,
          until: g.toISODate()
        }
      };
    }
    if (k === "WEEK") {
      const h = Ee.fromISO(m, { zone: "utc" });
      return {
        period: {
          since: m,
          until: h.plus({ days: 6 }).toISODate()
        }
      };
    }
    return k === "DAY" ? {
      period: {
        since: m,
        until: m
      }
    } : {};
  }), d = (m) => {
    l.value = m, r.value = m.value !== "summary", s && s(p.value, r.value);
  }, b = async () => {
    l.value = o.value, r.value = !0, s && s(p.value, r.value);
  };
  return Le(
    () => [n.value, t.value],
    () => {
      b();
    },
    { flush: "pre", deep: !0 }
  ), l.value || (l.value = o.value), {
    /** Currently selected period */
    selectedPeriod: l,
    /** Available period options for dropdown */
    periodOptions: i,
    /** Default period option */
    defaultPeriod: o,
    /** Request params to spread into API call */
    periodRequestParams: p,
    /** Whether to group by date (false when "Summary" is selected) */
    isGroupByDate: r,
    /** Handle period selection change */
    handlePeriodChange: d,
    /** Reset to default period */
    resetPeriod: b
  };
}
const jC = { class: "w-[160px]" }, zD = /* @__PURE__ */ ke({
  __name: "TablePeriodSelect",
  props: {
    granularity: {},
    dateRange: {},
    includeSummary: { type: Boolean, default: !1 },
    widthClass: { default: "w-40" },
    placeholder: { default: "Select period" },
    modern: { type: Boolean, default: void 0 }
  },
  emits: ["change"],
  setup(e, { expose: n, emit: t }) {
    const a = e, s = Oa(), l = T(() => a.modern ?? s.value), r = t, {
      selectedPeriod: i,
      periodOptions: o,
      periodRequestParams: u,
      isGroupByDate: c,
      handlePeriodChange: f
    } = qC({
      granularity: yl(a, "granularity"),
      dateRange: yl(a, "dateRange"),
      includeSummary: a.includeSummary,
      onPeriodChange: () => {
        p();
      }
    }), p = () => {
      r("change", {
        selected: i.value,
        requestParams: u.value,
        isGroupByDate: c.value
      });
    }, d = (b) => {
      f(b);
    };
    return n({
      selectedPeriod: i,
      periodRequestParams: u,
      isGroupByDate: c
    }), (b, m) => (w(), M("div", jC, [
      ie(v(Jk), lt({
        modelValue: v(i),
        "onUpdate:modelValue": m[0] || (m[0] = (k) => Ru(i) ? i.value = k : null),
        class: e.widthClass,
        "close-on-select": !0,
        modern: l.value,
        options: v(o),
        placeholder: e.placeholder,
        searchable: !1
      }, b.$attrs, { onSelect: d }), null, 16, ["modelValue", "class", "modern", "options", "placeholder"])
    ]));
  }
}), GC = /* @__PURE__ */ ke({
  __name: "TableExpandAdditionalHeadersButton",
  props: {
    isExpanded: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, s) => (w(), M("button", {
      class: q([{ "is-expanded": e.isExpanded }, "expand-button"]),
      type: "button",
      onClick: s[0] || (s[0] = Ve((l) => t("click"), ["stop"]))
    }, [
      ie(v(be), {
        size: 16,
        class: "expand-icon",
        icon: "lucide:chevron-right"
      })
    ], 2));
  }
}), BD = /* @__PURE__ */ ze(GC, [["__scopeId", "data-v-41dc3668"]]), ha = /* @__PURE__ */ new Map(), WD = (e, n, t) => {
  const a = (t == null ? void 0 : t.paginationMode) === "sync" ? t.totalPages : void 0, s = (t == null ? void 0 : t.paginationMode) ?? "independent", l = (t == null ? void 0 : t.initialPage) ?? 1, r = t == null ? void 0 : t.namespace, i = r ? `${r}:${e}` : e, o = n.filter((h) => h !== e), u = ee(l), c = ee(null), f = {
    scrollEl: null,
    scrollPosition: c,
    isReceivingScroll: !1,
    pendingScrollX: 0,
    pendingScrollY: 0,
    scrollRafId: null,
    page: u,
    paginationMode: s,
    totalPages: a,
    receiveHighlight: null,
    isReceivingHighlight: !1
  };
  ha.set(i, f);
  const p = (h) => r ? `${r}:${h}` : h, d = {
    register: (h) => {
      f.scrollEl = h;
      for (const g of o) {
        const x = ha.get(p(g));
        if (x != null && x.scrollEl) {
          h.scrollLeft = x.scrollEl.scrollLeft, h.scrollTop = x.scrollEl.scrollTop;
          break;
        }
      }
    },
    unregister: () => {
      f.scrollEl = null;
    },
    onScroll: (h, g) => {
      f.isReceivingScroll || o.forEach((x) => {
        const S = ha.get(p(x));
        !S || !S.scrollEl || S.scrollEl.scrollLeft === h && S.scrollEl.scrollTop === g || (S.pendingScrollX = h, S.pendingScrollY = g, S.scrollRafId === null && (S.scrollRafId = requestAnimationFrame(() => {
          S.scrollRafId = null, S.scrollEl && (S.isReceivingScroll = !0, S.scrollEl.scrollLeft = S.pendingScrollX, S.scrollEl.scrollTop = S.pendingScrollY, requestAnimationFrame(() => {
            S.isReceivingScroll = !1;
          }));
        })));
      });
    },
    scrollPosition: c
  }, b = {
    register: (h) => {
      f.receiveHighlight = h;
    },
    unregister: () => {
      f.receiveHighlight = null;
    },
    // No rAF throttling here, unlike onScroll: this fires once per click.
    broadcast: (h) => {
      f.isReceivingHighlight || o.forEach((g) => {
        const x = ha.get(p(g));
        x != null && x.receiveHighlight && (x.isReceivingHighlight = !0, x.receiveHighlight(h), x.isReceivingHighlight = !1);
      });
    }
  }, m = (h) => {
    u.value = h, o.forEach((g) => {
      const x = ha.get(p(g));
      if (!(!x || x.paginationMode === "independent")) {
        if (x.paginationMode === "reset") {
          x.page.value = 1;
          return;
        }
        x.totalPages && (x.page.value = Math.min(h, x.totalPages.value));
      }
    });
  }, k = (h = 1) => {
    var g;
    f.page.value = h, f.scrollPosition.value = null, (g = f.receiveHighlight) == null || g.call(f, { rowId: null, columnKey: null }), f.scrollEl && (f.scrollEl.scrollLeft = 0, f.scrollEl.scrollTop = 0), o.forEach((x) => {
      var C;
      const S = ha.get(p(x));
      S && (S.page.value = h, S.scrollPosition.value = null, (C = S.receiveHighlight) == null || C.call(S, { rowId: null, columnKey: null }), S.scrollEl && (S.scrollEl.scrollLeft = 0, S.scrollEl.scrollTop = 0));
    });
  }, y = t == null ? void 0 : t.resetOn;
  return y !== void 0 && Le(() => Qe(y), () => k()), El(() => {
    ha.delete(i);
  }), {
    // markRaw prevents reactive() from deep-wrapping the controllers
    link: ka({
      scrollSync: Yi(d),
      highlightSync: Yi(b),
      page: u,
      "onUpdate:page": m
    }),
    resetState: k
  };
};
function YD(e, n = 100, t = !1) {
  const a = Math.max(0, Math.min(1, e / n)), s = Math.round(t ? 255 * a : 255 * (1 - a)), l = Math.round(t ? 255 * (1 - a) : 255 * a);
  return `rgba(${s}, ${l}, 0, 0.4)`;
}
function HD(e) {
  const n = Math.max(0, Math.min(100, e)), t = Math.round(255 * (100 - n) / 100), a = Math.round(255 * n / 100);
  return `bg-[rgb(${t},${a},0)]`;
}
const UD = () => ({
  success: (i, o) => {
    fa.success(i, {
      description: o,
      duration: 4e3
    });
  },
  error: (i, o) => {
    fa.error(i, {
      description: o,
      duration: 5e3
    });
  },
  warning: (i, o) => {
    fa.warning(i, {
      description: o,
      duration: 4e3
    });
  },
  info: (i, o) => {
    fa.info(i, {
      description: o,
      duration: 4e3
    });
  },
  promise: (i, o) => fa.promise(i, o),
  custom: (i, o) => fa(i, o),
  dismiss: (i) => {
    fa.dismiss(i);
  }
}), mf = Symbol("SidebarState");
function KC(e) {
  const n = T(
    () => Ru(e.items) ? e.items.value : e.items
  ), t = () => {
    e.isCollapsed.value = !e.isCollapsed.value;
  }, a = (u) => {
    const c = e.expandedItems.value;
    c.has(u) ? c.delete(u) : c.add(u), e.expandedItems.value = new Set(c);
  }, s = (u) => {
    if (!u.length) return;
    const c = new Set(e.expandedItems.value);
    u.forEach((f) => c.add(f)), e.expandedItems.value = c;
  }, l = (u) => e.expandedItems.value.has(u), r = () => {
    e.isMobileOpen.value = !0;
  }, i = () => {
    e.isMobileOpen.value = !1;
  }, o = () => {
    e.isMobileOpen.value = !e.isMobileOpen.value;
  };
  return {
    isCollapsed: e.isCollapsed,
    isMobileOpen: e.isMobileOpen,
    expandedItems: e.expandedItems,
    resolvedItems: n,
    options: e.options,
    toggleCollapse: t,
    toggleExpanded: a,
    expandMany: s,
    isExpanded: l,
    openMobile: r,
    closeMobile: i,
    toggleMobile: o
  };
}
function us() {
  const e = yn(mf);
  if (!e)
    throw new Error(
      '[NavigationSidebar] useSidebarState() called outside of <NavigationSidebar>. Make sure the component is wrapped in <NavigationSidebar :sidebar="...">.'
    );
  return e;
}
function vf(e, n = []) {
  const t = ii();
  return { resolvedTo: T(() => {
    const s = e.to;
    if (!s) return;
    if (!n.length) return s;
    const l = {};
    for (const r of n) {
      const i = t.query[r];
      i != null && (l[r] = Array.isArray(i) ? i[0] ?? "" : i);
    }
    return Object.keys(l).length ? typeof s == "string" ? { path: s, query: l } : {
      ...s,
      query: {
        ...l,
        ...s.query ?? {}
      }
    } : s;
  }) };
}
const ZC = { class: "sidebar-flyout__item-label" }, XC = {
  key: 1,
  class: "sidebar-flyout__item-badge"
}, JC = /* @__PURE__ */ ke({
  __name: "SidebarMenuFlyoutItem",
  props: {
    item: {}
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n, { isActive: a, onPrefetch: s, options: l } = us(), { resolvedTo: r } = vf(e.item, l.persistentQueryParams), i = T(() => a(e.item.id)), o = T(() => ({
      "sidebar-flyout__item--active": i.value,
      "sidebar-flyout__item--disabled": e.item.disabled
    })), u = () => {
      e.item.disabled || !r.value || s(r.value);
    }, c = () => {
      e.item.disabled || t("click", e.item);
    };
    return (f, p) => {
      const d = Fu("router-link");
      return e.item.to ? (w(), ue(d, {
        key: 0,
        "aria-current": i.value ? "page" : void 0,
        class: q([o.value, "sidebar-flyout__item"]),
        style: Fe(`--depth: ${e.item.level}`),
        to: v(r),
        onClick: c,
        onMouseenter: u
      }, {
        default: ce(() => [
          e.item.icon ? (w(), ue(be, {
            key: 0,
            icon: e.item.icon,
            size: 15,
            class: "sidebar-flyout__item-icon"
          }, null, 8, ["icon"])) : R("", !0),
          E("span", ZC, re(e.item.label), 1),
          e.item.badge ? (w(), M("span", XC, re(e.item.badge), 1)) : R("", !0)
        ]),
        _: 1
      }, 8, ["aria-current", "class", "style", "to"])) : R("", !0);
    };
  }
}), QC = { class: "sidebar-flyout__item-label" }, e2 = {
  key: 1,
  class: "sidebar-flyout__item-badge"
}, t2 = /* @__PURE__ */ ke({
  __name: "SidebarMenuFlyoutParent",
  props: {
    item: {}
  },
  setup(e) {
    return (n, t) => (w(), M("div", {
      style: Fe(`--depth: ${e.item.level}`),
      class: "sidebar-flyout__item sidebar-flyout__item--parent"
    }, [
      e.item.icon ? (w(), ue(be, {
        key: 0,
        icon: e.item.icon,
        size: 15,
        class: "sidebar-flyout__item-icon"
      }, null, 8, ["icon"])) : R("", !0),
      E("span", QC, re(e.item.label), 1),
      e.item.badge ? (w(), M("span", e2, re(e.item.badge), 1)) : R("", !0)
    ], 4));
  }
}), n2 = { class: "sidebar-flyout" }, a2 = { class: "sidebar-flyout__title" }, s2 = { class: "sidebar-flyout__list" }, Cu = 16, l2 = /* @__PURE__ */ ke({
  __name: "SidebarMenuFlyout",
  props: {
    item: {}
  },
  setup(e) {
    const { closeMobile: n } = us(), t = ee(!1), a = ee(null), s = ee(null), l = ee({ top: 0, left: 0, right: 0 }), r = ee(!1), { width: i, height: o } = im(), u = () => {
      if (!a.value || !s.value) return;
      const h = a.value.getBoundingClientRect(), g = s.value.getBoundingClientRect(), x = h.right + 8, S = s.value.offsetHeight, C = Math.max(
        Cu,
        Math.min(h.top, o.value - Cu - S)
      );
      x + g.width > i.value - 20 ? (r.value = !0, l.value = {
        top: C,
        right: i.value - h.left + 8,
        left: 0
      }) : (r.value = !1, l.value = { top: C, left: x, right: 0 });
    };
    Le([i, o], () => {
      t.value && u();
    });
    const { start: c, stop: f } = Fr(async () => {
      t.value = !0, await Ge(), requestAnimationFrame(u);
    }, 150, { immediate: !1 }), { start: p, stop: d } = Fr(() => {
      t.value = !1;
    }, 100, { immediate: !1 }), b = () => {
      if (d(), !t.value) {
        if (a.value) {
          const h = a.value.getBoundingClientRect();
          l.value = { top: h.top, left: h.right + 8, right: 0 };
        }
        c();
      }
    }, m = () => {
      f(), p();
    }, k = T(() => {
      const h = (g, x = 0) => {
        var C;
        const S = [];
        for (const _ of g)
          S.push({ ..._, level: x }), (C = _.children) != null && C.length && S.push(...h(_.children, x + 1));
        return S;
      };
      return e.item.children ? h(e.item.children) : [];
    }), y = (h) => {
      h.disabled || (n(), t.value = !1);
    };
    return (h, g) => (w(), M("div", {
      ref_key: "buttonRef",
      ref: a,
      class: "sidebar-flyout-trigger",
      onMouseenter: b,
      onMouseleave: m
    }, [
      H(h.$slots, "default", {}, void 0, !0),
      (w(), ue(Pn, { to: "body" }, [
        ie(ht, {
          "enter-active-class": "sidebar-flyout-enter-active",
          "enter-from-class": "sidebar-flyout-enter-from",
          "enter-to-class": "sidebar-flyout-enter-to",
          "leave-active-class": "sidebar-flyout-leave-active",
          "leave-from-class": "sidebar-flyout-leave-from",
          "leave-to-class": "sidebar-flyout-leave-to"
        }, {
          default: ce(() => {
            var x;
            return [
              t.value && ((x = e.item.children) != null && x.length) ? (w(), M("div", {
                key: 0,
                style: Fe({
                  top: `${l.value.top}px`,
                  ...r.value ? { right: `${l.value.right - 8}px` } : { left: `${l.value.left - 8}px` }
                }),
                class: q([{ "sidebar-flyout-portal--left": r.value }, "sidebar-flyout-portal"]),
                onMouseenter: b,
                onMouseleave: m
              }, [
                E("div", {
                  class: q([r.value ? "sidebar-flyout-bridge--left" : "sidebar-flyout-bridge--right", "sidebar-flyout-bridge"])
                }, null, 2),
                E("div", {
                  ref_key: "flyoutRef",
                  ref: s,
                  class: "sidebar-flyout-content"
                }, [
                  E("div", n2, [
                    E("div", a2, re(e.item.label), 1),
                    E("div", s2, [
                      (w(!0), M(Te, null, Ie(k.value, (S) => (w(), M(Te, {
                        key: S.id
                      }, [
                        S.to ? (w(), ue(JC, {
                          key: 0,
                          item: S,
                          onClick: y
                        }, null, 8, ["item"])) : (w(), ue(t2, {
                          key: 1,
                          item: S
                        }, null, 8, ["item"]))
                      ], 64))), 128))
                    ])
                  ])
                ], 512)
              ], 38)) : R("", !0)
            ];
          }),
          _: 1
        })
      ]))
    ], 544));
  }
}), r2 = /* @__PURE__ */ ze(l2, [["__scopeId", "data-v-224b195a"]]), i2 = ["aria-label"], o2 = ["title"], u2 = {
  key: 1,
  class: "sidebar-item__badge"
}, c2 = { class: "sidebar-item-children__inner" }, d2 = /* @__PURE__ */ ke({
  __name: "SidebarNavItem",
  props: {
    item: {},
    level: { default: 0 }
  },
  setup(e) {
    const {
      isCollapsed: n,
      isExpanded: t,
      toggleExpanded: a,
      closeMobile: s,
      isActive: l,
      isOnActivePath: r,
      onPrefetch: i,
      options: o
    } = us(), { resolvedTo: u } = vf(e.item, o.persistentQueryParams), c = Xe("label"), f = ee(!1), p = T(() => {
      var S;
      return !!((S = e.item.children) != null && S.length);
    }), d = T(() => p.value && t(e.item.id)), b = T(() => l(e.item.id)), m = T(
      () => !b.value && p.value && r(e.item.id)
    ), k = () => {
      p.value || e.item.disabled || !u.value || i(u.value);
    }, y = () => {
      const S = c.value;
      S && (f.value = S.scrollWidth > S.clientWidth);
    }, h = () => {
      if (!e.item.disabled) {
        if (e.item.onClick) {
          e.item.onClick(), s();
          return;
        }
        p.value ? a(e.item.id) : s();
      }
    }, g = T(() => e.item.icon ?? null), x = T(() => ({
      "sidebar-item--active": b.value,
      "sidebar-item--has-active-child": m.value,
      "sidebar-item--disabled": e.item.disabled,
      "sidebar-item--collapsed": n.value,
      "sidebar-item--nested": e.level > 0,
      "sidebar-item--no-icon": !g.value
    }));
    return (S, C) => {
      const _ = Fu("SidebarNavItem", !0);
      return w(), M("div", {
        style: Fe(`--depth: ${e.level}`),
        class: "sidebar-item-wrapper"
      }, [
        v(n) && p.value && !e.item.disabled ? (w(), ue(r2, {
          key: 0,
          item: e.item
        }, {
          default: ce(() => [
            E("button", {
              "aria-label": e.item.label,
              class: q([{
                "sidebar-item--active": b.value,
                "sidebar-item--has-active-child": m.value
              }, "sidebar-item sidebar-item--collapsed"]),
              type: "button",
              onClick: h
            }, [
              e.item.icon ? (w(), ue(be, {
                key: 0,
                icon: e.item.icon,
                size: 15,
                class: "sidebar-item__icon"
              }, null, 8, ["icon"])) : R("", !0)
            ], 10, i2)
          ]),
          _: 1
        }, 8, ["item"])) : v(n) && !e.item.disabled ? (w(), ue(xa, {
          key: 1,
          delay: 200,
          text: e.item.label,
          placement: "right"
        }, {
          default: ce(() => [
            (w(), ue(mt(e.item.to ? "router-link" : "button"), {
              "aria-label": e.item.label,
              class: q([{ "sidebar-item--active": b.value }, "sidebar-item sidebar-item--collapsed"]),
              disabled: e.item.disabled || void 0,
              to: e.item.to ? v(u) : void 0,
              type: e.item.to ? void 0 : "button",
              onClick: h,
              onMouseenter: k
            }, {
              default: ce(() => [
                e.item.icon ? (w(), ue(be, {
                  key: 0,
                  icon: e.item.icon,
                  size: 15,
                  class: "sidebar-item__icon"
                }, null, 8, ["icon"])) : R("", !0)
              ]),
              _: 1
            }, 40, ["aria-label", "class", "disabled", "to", "type"]))
          ]),
          _: 1
        }, 8, ["text"])) : (w(), ue(mt(p.value || !e.item.to ? "button" : "router-link"), {
          key: 2,
          "aria-current": b.value ? "page" : void 0,
          "aria-expanded": p.value ? d.value : void 0,
          "aria-label": e.item.label,
          class: q([x.value, "sidebar-item"]),
          disabled: e.item.disabled || void 0,
          to: !p.value && e.item.to ? v(u) : void 0,
          type: p.value || !e.item.to ? "button" : void 0,
          onClick: h,
          onMouseenter: k
        }, {
          default: ce(() => [
            g.value ? (w(), ue(be, {
              key: 0,
              icon: g.value,
              size: 15,
              class: "sidebar-item__icon"
            }, null, 8, ["icon"])) : R("", !0),
            ie(ht, {
              "enter-active-class": "sidebar-label-enter-active",
              "enter-from-class": "sidebar-label-enter-from",
              "enter-to-class": "sidebar-label-enter-to",
              "leave-active-class": "sidebar-label-leave-active",
              "leave-from-class": "sidebar-label-leave-from",
              "leave-to-class": "sidebar-label-leave-to"
            }, {
              default: ce(() => [
                v(n) ? R("", !0) : (w(), M("span", {
                  key: 0,
                  ref: "label",
                  title: f.value ? e.item.label : void 0,
                  class: "sidebar-item__label",
                  onMouseenter: y
                }, re(e.item.label), 41, o2))
              ]),
              _: 1
            }),
            e.item.badge && !v(n) ? (w(), M("span", u2, re(e.item.badge), 1)) : R("", !0),
            p.value && !v(n) ? (w(), ue(be, {
              key: 2,
              class: q([{ "sidebar-item__chevron--expanded": d.value }, "sidebar-item__chevron"]),
              size: 14,
              icon: "lucide:chevron-right"
            }, null, 8, ["class"])) : R("", !0)
          ]),
          _: 1
        }, 40, ["aria-current", "aria-expanded", "aria-label", "class", "disabled", "to", "type"])),
        p.value && !v(n) ? (w(), M("div", {
          key: 3,
          class: q([{ "sidebar-item-children--expanded": d.value }, "sidebar-item-children"])
        }, [
          E("div", c2, [
            (w(!0), M(Te, null, Ie(e.item.children, (O) => (w(), ue(_, {
              key: O.id,
              item: O,
              level: e.level + 1
            }, null, 8, ["item", "level"]))), 128))
          ])
        ], 2)) : R("", !0)
      ], 4);
    };
  }
}), pf = /* @__PURE__ */ ze(d2, [["__scopeId", "data-v-0acaee3e"]]), f2 = {
  key: 0,
  class: "v-sidebar-footer__slot"
}, h2 = {
  key: 1,
  class: "v-sidebar-footer__nav"
}, m2 = {
  key: 2,
  class: "v-sidebar-footer__slot"
}, v2 = /* @__PURE__ */ ke({
  __name: "SidebarFooter",
  props: {
    items: { default: () => [] }
  },
  setup(e) {
    const { isCollapsed: n } = us();
    return (t, a) => (w(), M("div", {
      class: q([{ "v-sidebar-footer--collapsed": v(n) }, "v-sidebar-footer"])
    }, [
      t.$slots.start ? (w(), M("div", f2, [
        H(t.$slots, "start")
      ])) : R("", !0),
      e.items.length ? (w(), M("nav", h2, [
        (w(!0), M(Te, null, Ie(e.items, (s) => (w(), ue(pf, {
          key: s.id,
          item: s,
          level: 0
        }, null, 8, ["item"]))), 128))
      ])) : R("", !0),
      t.$slots.end ? (w(), M("div", m2, [
        H(t.$slots, "end")
      ])) : R("", !0)
    ], 2));
  }
}), p2 = {
  key: 0,
  class: "sidebar-header__brand"
}, g2 = {
  key: 0,
  class: "sidebar-header__logo"
}, y2 = ["alt", "src"], b2 = {
  key: 1,
  "aria-hidden": "true",
  class: "sidebar-header__mark"
}, w2 = { class: "sidebar-header__name" }, k2 = { class: "sidebar-header__controls" }, x2 = ["aria-label"], S2 = { class: "sidebar-header__toggle-icons" }, T2 = /* @__PURE__ */ ke({
  __name: "SidebarHeader",
  setup(e) {
    var l;
    const { isCollapsed: n, toggleCollapse: t, options: a } = us(), s = ((l = a.brandName) == null ? void 0 : l.trim().charAt(0).toUpperCase()) ?? "";
    return (r, i) => (w(), M("div", {
      class: q([{ "sidebar-header--collapsed": v(n) }, "sidebar-header"])
    }, [
      ie(ht, {
        "enter-active-class": "sidebar-label-enter-active",
        "enter-from-class": "sidebar-label-enter-from",
        "enter-to-class": "sidebar-label-enter-to",
        "leave-active-class": "sidebar-label-leave-active",
        "leave-from-class": "sidebar-label-leave-from",
        "leave-to-class": "sidebar-label-leave-to"
      }, {
        default: ce(() => [
          v(n) ? R("", !0) : (w(), M("div", p2, [
            H(r.$slots, "start", {}, () => [
              v(a).logoUrl ? (w(), M("div", g2, [
                E("img", {
                  alt: v(a).brandName,
                  src: v(a).logoUrl
                }, null, 8, y2)
              ])) : v(s) ? (w(), M("span", b2, re(v(s)), 1)) : R("", !0),
              E("span", w2, re(v(a).brandName), 1)
            ], !0)
          ]))
        ]),
        _: 3
      }),
      E("div", k2, [
        H(r.$slots, "end", {}, void 0, !0),
        E("button", {
          "aria-label": v(n) ? "Expand sidebar" : "Collapse sidebar",
          class: q([{ "sidebar-header__toggle--collapsed": v(n) }, "sidebar-header__toggle"]),
          type: "button",
          onClick: i[0] || (i[0] = //@ts-ignore
          (...o) => v(t) && v(t)(...o))
        }, [
          E("span", S2, [
            ie(be, {
              size: 15,
              class: "sidebar-header__toggle-icon sidebar-header__toggle-icon--close",
              icon: "lucide:panel-left-close"
            }),
            ie(be, {
              size: 15,
              class: "sidebar-header__toggle-icon sidebar-header__toggle-icon--open",
              icon: "lucide:panel-left-open"
            })
          ])
        ], 10, x2)
      ])
    ], 2));
  }
}), $2 = /* @__PURE__ */ ze(T2, [["__scopeId", "data-v-14b770dc"]]), M2 = { class: "sidebar-nav__list" }, C2 = /* @__PURE__ */ ke({
  __name: "SidebarNav",
  setup(e) {
    const {
      resolvedItems: n,
      isCollapsed: t,
      expandedItems: a,
      activeItemId: s
    } = us();
    return (l, r) => (w(), M("nav", {
      class: q([{ "sidebar-nav--collapsed": v(t) }, "sidebar-nav"])
    }, [
      E("div", M2, [
        (w(!0), M(Te, null, Ie(v(n), (i, o, u, c) => {
          const f = [v(s), v(a), v(t), i.id];
          if (c && c.key === i.id && Tf(c, f)) return c;
          const p = (w(), ue(pf, {
            key: i.id,
            item: i,
            level: 0
          }, null, 8, ["item"]));
          return p.memo = f, p;
        }, r, 0), 128))
      ])
    ], 2));
  }
});
function gf(e, n = []) {
  var a;
  const t = [];
  for (const s of e) {
    const l = [...n, s.id];
    if (s.to) {
      const r = {
        itemId: s.id,
        ancestorIds: l,
        matchNested: s.matchNested,
        activeOn: s.activeOn
      };
      typeof s.to == "string" ? r.path = s.to : typeof s.to == "object" && "name" in s.to && s.to.name ? r.routeName = s.to.name : typeof s.to == "object" && "path" in s.to && s.to.path && (r.path = s.to.path), t.push(r);
    }
    (a = s.children) != null && a.length && t.push(...gf(s.children, l));
  }
  return t;
}
function D2(e) {
  const n = ii(), t = T(() => gf(e.value)), a = Et(null), s = Et(/* @__PURE__ */ new Set());
  Le(
    () => ({ path: n.path, name: n.name, matchedNames: n.matched.map((u) => u.name) }),
    ({ path: u, name: c, matchedNames: f }) => {
      let p;
      for (const d of t.value) {
        if (d.path && d.path === u) {
          p = d;
          break;
        }
        if (d.routeName && d.routeName === c) {
          p = d;
          break;
        }
      }
      p ?? (p = t.value.find((d) => d.matchNested && d.routeName !== void 0 && f.includes(d.routeName))), p ?? (p = t.value.find((d) => {
        var b;
        return (b = d.activeOn) == null ? void 0 : b.some((m) => f.includes(m));
      })), p ? (a.value = p.itemId, s.value = new Set(p.ancestorIds)) : (a.value = null, s.value = /* @__PURE__ */ new Set());
    },
    { immediate: !0 }
  );
  const l = T(() => a.value), r = T(() => s.value);
  return { activeItemId: l, activePathIds: r, isActive: (u) => a.value === u, isOnActivePath: (u) => s.value.has(u) };
}
const qD = /* @__PURE__ */ ke({
  __name: "NavigationSidebar",
  props: {
    sidebar: {}
  },
  emits: ["prefetch", "collapse", "item-click"],
  setup(e, { emit: n }) {
    const t = n, a = $f(
      () => import("./NavigationSidebarMobile-C1R4bVyK.js")
    ), s = KC(e.sidebar), { activeItemId: l, activePathIds: r, isActive: i, isOnActivePath: o } = D2(
      s.resolvedItems
    );
    ea(mf, {
      ...s,
      activeItemId: l,
      activePathIds: r,
      isActive: i,
      isOnActivePath: o,
      onPrefetch: (c) => t("prefetch", c)
    });
    const u = T(() => e.sidebar.isCollapsed.value);
    return Le(
      r,
      (c) => {
        s.expandMany([...c]);
      },
      { immediate: !0 }
    ), (c, f) => (w(), M("div", null, [
      E("aside", {
        class: q([{ "sidebar--collapsed": u.value }, "sidebar sidebar--flat"]),
        "aria-label": "Main navigation"
      }, [
        ie($2, null, dt({ _: 2 }, [
          c.$slots["header-title"] ? {
            name: "start",
            fn: ce(() => [
              H(c.$slots, "header-title")
            ]),
            key: "0"
          } : void 0,
          c.$slots["header-end"] ? {
            name: "end",
            fn: ce(() => [
              H(c.$slots, "header-end")
            ]),
            key: "1"
          } : void 0
        ]), 1024),
        H(c.$slots, "subtitle-block"),
        ie(C2),
        ie(v2, null, dt({ _: 2 }, [
          c.$slots["footer-start"] ? {
            name: "start",
            fn: ce(() => [
              H(c.$slots, "footer-start")
            ]),
            key: "0"
          } : void 0,
          c.$slots["footer-end"] ? {
            name: "end",
            fn: ce(() => [
              H(c.$slots, "footer-end")
            ]),
            key: "1"
          } : void 0
        ]), 1024)
      ], 2),
      ie(v(a), null, dt({ _: 2 }, [
        c.$slots["footer-start"] ? {
          name: "start",
          fn: ce(() => [
            H(c.$slots, "footer-start")
          ]),
          key: "0"
        } : void 0,
        c.$slots["footer-end"] ? {
          name: "end",
          fn: ce(() => [
            H(c.$slots, "footer-end")
          ]),
          key: "1"
        } : void 0
      ]), 1024)
    ]));
  }
}), O2 = "ui-sidebar";
function _2(e) {
  try {
    return localStorage.getItem(`${e}:collapsed`) === "true";
  } catch {
    return !1;
  }
}
function E2(e, n) {
  try {
    localStorage.setItem(`${e}:collapsed`, String(n));
  } catch {
  }
}
function I2(e) {
  try {
    const n = localStorage.getItem(`${e}:expanded`);
    if (!n) return /* @__PURE__ */ new Set();
    const t = JSON.parse(n);
    return Array.isArray(t) ? new Set(t) : /* @__PURE__ */ new Set();
  } catch {
    return /* @__PURE__ */ new Set();
  }
}
function A2(e, n) {
  try {
    localStorage.setItem(`${e}:expanded`, JSON.stringify([...n]));
  } catch {
  }
}
function jD(e) {
  const n = {
    brandName: e.brandName ?? "",
    logoUrl: e.logoUrl ?? "",
    storageKey: e.storageKey ?? O2,
    persistCollapse: e.persistCollapse ?? !0,
    persistentQueryParams: e.persistentQueryParams ?? []
  }, t = ee(!1), a = ee(!1), s = ee(/* @__PURE__ */ new Set());
  return n.persistCollapse && typeof window < "u" && (t.value = _2(n.storageKey), s.value = I2(n.storageKey), jt(() => {
    E2(n.storageKey, t.value);
  }), jt(() => {
    A2(n.storageKey, s.value);
  })), {
    items: e.items,
    isCollapsed: t,
    isMobileOpen: a,
    expandedItems: s,
    options: n,
    toggleCollapse: () => {
      t.value = !t.value;
    },
    toggleMobile: () => {
      a.value = !a.value;
    }
  };
}
function P2(e, n, t, a, s) {
  let l = e.find((r) => r.id === n);
  return l || (l = { id: n, label: t, icon: a, order: s ?? 999, children: [] }, e.push(l)), l;
}
function R2(e, n, t) {
  if (!t.menuGroup) {
    e.push(n);
    return;
  }
  const a = t.menuGroup.split("/");
  let s = e;
  a.forEach((l, r) => {
    var c;
    const i = `group:${a.slice(0, r + 1).join("/")}`, o = (c = t.menuGroupMeta) == null ? void 0 : c[l];
    s = P2(
      s,
      i,
      l,
      (o == null ? void 0 : o.icon) ?? (r === 0 ? t.menuGroupIcon : void 0),
      (o == null ? void 0 : o.order) ?? (r === 0 ? t.menuGroupOrder : void 0)
    ).children;
  }), s.push(n);
}
function yf(e) {
  return e.sort((n, t) => (n.order ?? 999) - (t.order ?? 999)).map((n) => {
    var t;
    return {
      ...n,
      children: (t = n.children) != null && t.length ? yf(n.children) : void 0
    };
  });
}
function GD(e) {
  const n = [];
  for (const { item: t, meta: a } of e)
    R2(n, t, a);
  return yf(n);
}
const F2 = ["aria-expanded", "title"], V2 = {
  key: 0,
  class: "workspace-trigger__text"
}, L2 = { class: "workspace-trigger__label" }, N2 = {
  key: 0,
  class: "workspace-trigger__user"
}, z2 = { class: "workspace-menu__text" }, B2 = { class: "workspace-menu__title" }, W2 = { class: "workspace-menu__caption" }, Y2 = { class: "workspace-menu__heading" }, H2 = ["aria-current", "disabled", "onClick"], U2 = { class: "workspace-menu__label" }, q2 = { class: "workspace-menu__section" }, j2 = ["onClick"], G2 = { class: "workspace-menu__text" }, K2 = { class: "workspace-menu__title" }, Z2 = {
  key: 0,
  class: "workspace-menu__caption"
}, X2 = ["onClick"], J2 = /* @__PURE__ */ ke({
  __name: "VWorkspaceContext",
  props: {
    items: { default: () => {
    } },
    activeId: { default: null },
    activeLabel: { default: () => {
    } },
    caption: {},
    switchHeading: { default: "" },
    sections: { default: () => {
    } },
    canAccess: { type: Function, default: void 0 },
    user: {},
    collapsed: { type: Boolean, default: !1 },
    placement: { default: "bottom-left" },
    switching: { type: Boolean, default: !1 },
    headClickable: { type: Boolean, default: !1 }
  },
  emits: ["switch", "select", "profile", "head-click", "logout"],
  setup(e, { emit: n }) {
    const t = [
      "from-primary-600 to-primary",
      "from-success-600 to-success",
      "from-warning-600 to-warning"
    ], a = n, s = T(() => e.sections !== void 0), l = (y) => {
      var h;
      return y === void 0 || ((h = e.canAccess) == null ? void 0 : h.call(e, y)) === !0;
    }, r = T(() => {
      if (e.sections === void 0) {
        const g = e.items ?? [];
        return g.length < 2 ? [] : [{
          id: "",
          heading: e.switchHeading,
          variant: "switch",
          caption: void 0,
          primary: !0,
          entries: g.map((x, S) => ({
            id: x.id,
            label: x.label,
            tile: S,
            active: x.id === e.activeId
          }))
        }];
      }
      let y = 0;
      const h = [];
      for (const g of e.sections) {
        if (!l(g.permission)) continue;
        const x = g.items.filter((C) => l(C.permission));
        if (x.length === 0) continue;
        const S = g.activeId !== void 0 ? g.activeId : e.activeId;
        h.push({
          id: g.id,
          heading: g.heading,
          variant: g.variant,
          caption: g.caption,
          primary: g.primary === !0,
          entries: x.map((C) => ({
            id: C.id,
            label: C.label,
            tile: y++,
            active: C.id === S
          }))
        });
      }
      return h;
    }), i = T(() => {
      var x;
      if (e.sections === void 0) {
        const S = e.items ?? [], C = S.findIndex((O) => O.id === e.activeId), _ = C >= 0 ? C : 0;
        return { label: ((x = S[_]) == null ? void 0 : x.label) ?? "", tile: _, caption: e.caption };
      }
      const y = e.activeId === null ? void 0 : r.value.map((S) => ({ group: S, entry: S.entries.find((C) => C.id === e.activeId) })).find((S) => S.entry !== void 0);
      if (y != null && y.entry)
        return {
          label: y.entry.label,
          tile: y.entry.tile,
          caption: y.group.caption ?? e.caption
        };
      const h = r.value.find((S) => S.primary) ?? r.value[0], g = h == null ? void 0 : h.entries.find((S) => S.active);
      return {
        label: (g == null ? void 0 : g.label) ?? "",
        tile: (g == null ? void 0 : g.tile) ?? 0,
        caption: (h == null ? void 0 : h.caption) ?? e.caption
      };
    }), o = T(() => e.activeLabel ?? i.value.label), u = T(() => {
      if (!e.user) return "";
      const y = e.user.displayName ?? e.user.name;
      return e.user.role ? `${y} · ${e.user.role}` : y;
    }), c = T(() => e.placement.startsWith("top")), f = T(() => e.placement.endsWith("right")), p = (y) => t[y % t.length], d = (y) => y.split(" ").filter(Boolean).slice(0, 2).map((h) => h[0]).join("").toUpperCase(), b = T(
      () => {
        var y, h;
        return d(o.value) || d(((y = e.user) == null ? void 0 : y.displayName) ?? ((h = e.user) == null ? void 0 : h.name) ?? "") || "?";
      }
    ), m = (y, h) => {
      s.value ? a("select", y.id, h.id) : a("switch", h.id);
    }, k = (y, h) => {
      y(), h();
    };
    return Le(
      [() => e.sections, () => e.items, r],
      () => {
      },
      { immediate: !0 }
    ), (y, h) => (w(), M("div", {
      class: q([{ "workspace-context--collapsed": e.collapsed }, "workspace-context"])
    }, [
      ie(Rs, {
        class: q([{ "workspace-floating--collapsed": e.collapsed }, "workspace-floating"]),
        placement: e.placement,
        unstyled: ""
      }, {
        trigger: ce(({ isOpen: g }) => [
          E("button", {
            "aria-expanded": g,
            class: q([{
              "workspace-trigger--open": g,
              "workspace-trigger--collapsed": e.collapsed
            }, "workspace-trigger"]),
            title: e.collapsed ? o.value : void 0,
            "aria-haspopup": "menu",
            type: "button"
          }, [
            E("span", {
              class: q([p(i.value.tile), "workspace-tile text-white"])
            }, re(b.value), 3),
            ie(ht, { name: "context-info-fade" }, {
              default: ce(() => [
                e.collapsed ? R("", !0) : (w(), M("span", V2, [
                  E("span", L2, re(o.value), 1),
                  e.user ? (w(), M("span", N2, re(u.value), 1)) : R("", !0)
                ]))
              ]),
              _: 1
            }),
            ie(ht, { name: "context-info-fade" }, {
              default: ce(() => [
                !e.collapsed && e.user ? (w(), ue(Hi, {
                  key: 0,
                  avatar: e.user.avatar ?? void 0,
                  "custom-size": 24,
                  name: e.user.name,
                  modern: "",
                  shape: "square"
                }, null, 8, ["avatar", "name"])) : R("", !0)
              ]),
              _: 1
            }),
            ie(ht, { name: "context-info-fade" }, {
              default: ce(() => [
                e.collapsed ? R("", !0) : (w(), ue(be, {
                  key: 0,
                  loading: e.switching,
                  size: 14,
                  class: "workspace-trigger__chevron",
                  icon: "lucide:chevron-down"
                }, null, 8, ["loading"]))
              ]),
              _: 1
            })
          ], 10, F2)
        ]),
        content: ce(({ close: g }) => [
          E("div", {
            class: q([{ "workspace-menu--up": c.value, "workspace-menu--right": f.value }, "workspace-menu"])
          }, [
            (w(), ue(mt(e.headClickable ? "button" : "div"), {
              class: q([{ "workspace-menu__head--button": e.headClickable }, "workspace-menu__head"]),
              type: e.headClickable ? "button" : void 0,
              onClick: (x) => e.headClickable && k(g, () => a("head-click"))
            }, {
              default: ce(() => [
                E("span", {
                  class: q([p(i.value.tile), "workspace-tile workspace-tile--lg text-white"])
                }, re(b.value), 3),
                E("span", z2, [
                  E("span", B2, re(o.value), 1),
                  E("span", W2, re(i.value.caption), 1)
                ]),
                e.headClickable ? (w(), ue(be, {
                  key: 0,
                  size: 14,
                  class: "workspace-menu__arrow",
                  icon: "lucide:chevron-right"
                })) : R("", !0)
              ]),
              _: 1
            }, 8, ["class", "type", "onClick"])),
            (w(!0), M(Te, null, Ie(r.value, (x) => (w(), M("div", {
              key: x.id,
              class: "workspace-menu__section"
            }, [
              E("p", Y2, re(x.heading), 1),
              (w(!0), M(Te, null, Ie(x.entries, (S) => (w(), M("button", {
                key: S.id,
                "aria-current": S.active ? "true" : void 0,
                disabled: x.variant === "switch" && S.active || e.switching,
                class: "workspace-menu__item",
                type: "button",
                onClick: (C) => k(g, () => m(x, S))
              }, [
                E("span", {
                  class: q([p(S.tile), "workspace-tile workspace-tile--sm text-white"])
                }, re(d(S.label) || "?"), 3),
                E("span", U2, re(S.label), 1),
                x.variant === "switch" && S.active ? (w(), ue(be, {
                  key: 0,
                  size: 15,
                  class: "workspace-menu__check",
                  icon: "lucide:check"
                })) : x.variant === "link" ? (w(), ue(be, {
                  key: 1,
                  size: 14,
                  class: "workspace-menu__arrow",
                  icon: "lucide:chevron-right"
                })) : R("", !0)
              ], 8, H2))), 128))
            ]))), 128)),
            E("div", q2, [
              e.user ? (w(), M("button", {
                key: 0,
                class: "workspace-menu__item workspace-menu__item--user",
                type: "button",
                onClick: (x) => k(g, () => a("profile"))
              }, [
                ie(Hi, {
                  avatar: e.user.avatar ?? void 0,
                  "custom-size": 32,
                  name: e.user.name,
                  modern: "",
                  shape: "square"
                }, null, 8, ["avatar", "name"]),
                E("span", G2, [
                  E("span", K2, re(e.user.name), 1),
                  e.user.email ? (w(), M("span", Z2, re(e.user.email), 1)) : R("", !0)
                ]),
                ie(be, {
                  size: 14,
                  class: "workspace-menu__arrow",
                  icon: "lucide:chevron-right"
                })
              ], 8, j2)) : R("", !0),
              E("button", {
                class: "workspace-menu__item workspace-menu__item--danger",
                type: "button",
                onClick: (x) => k(g, () => a("logout"))
              }, [
                ie(be, {
                  size: 15,
                  icon: "lucide:log-out"
                }),
                h[0] || (h[0] = E("span", { class: "workspace-menu__label" }, "Log out", -1))
              ], 8, X2)
            ]),
            H(y.$slots, "menu-footer", {}, void 0, !0)
          ], 2)
        ]),
        _: 3
      }, 8, ["class", "placement"])
    ], 2));
  }
}), KD = /* @__PURE__ */ ze(J2, [["__scopeId", "data-v-e80d0a61"]]);
export {
  lk as $,
  dD as A,
  rt as B,
  a$ as C,
  VD as D,
  Rs as E,
  CD as F,
  Ol as G,
  mD as H,
  Kl as I,
  kD as J,
  bD as K,
  xD as L,
  PD as M,
  DD as N,
  vD as O,
  Jk as P,
  pD as Q,
  df as R,
  FD as S,
  fM as T,
  UM as U,
  be as V,
  OD as W,
  Zu as X,
  SD as Y,
  TD as Z,
  ze as _,
  vf as a,
  xa as a0,
  Yx as a1,
  KD as a2,
  GD as a3,
  jD as a4,
  ia as a5,
  _D as a6,
  jd as a7,
  Os as a8,
  uC as a9,
  AD as aA,
  uf as aB,
  nk as aC,
  ns as aD,
  hD as aE,
  Ud as aF,
  WD as aG,
  Zl as aH,
  D2 as aI,
  Ax as aJ,
  cC as aK,
  RD as aL,
  qC as aM,
  Hd as aN,
  UD as aO,
  Li as aP,
  _s as aa,
  Gd as ab,
  Kd as ac,
  uD as ad,
  aa as ae,
  Vi as af,
  rf as ag,
  qd as ah,
  YD as ai,
  HD as aj,
  Or as ak,
  ED as al,
  cf as am,
  Bi as an,
  Ql as ao,
  tC as ap,
  oD as aq,
  ID as ar,
  nC as as,
  of as at,
  zi as au,
  eC as av,
  Ks as aw,
  Ni as ax,
  Jl as ay,
  aC as az,
  Is as b,
  Jw as c,
  LD as d,
  cD as e,
  wD as f,
  qD as g,
  BD as h,
  zD as i,
  ND as j,
  $D as k,
  MD as l,
  Hi as m,
  gD as n,
  _t as o,
  aD as p,
  pT as q,
  ed as r,
  sD as s,
  W1 as t,
  us as u,
  fD as v,
  lD as w,
  rD as x,
  iD as y,
  yD as z
};
//# sourceMappingURL=index-DlDAB9bn.js.map
